import {
  Unit_instanceat14thlj150z as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString30pk9tzaqopn as toString,
  hashCodeq5arwsb9dgti as hashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  toList3jhuyej2anx2q as toList,
  VOID7hggqo3abtya as VOID,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString_0,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  createThis2j2avj17cvnv2 as createThis,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  ArrayList3it5z8td81qkl as ArrayList,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  isInterface3d6p8outrmvmk as isInterface,
  lazy2hsh8ze7j6ikd as lazy,
  isIntArrayeijsubfngq38 as isIntArray,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  KProperty1ca4yb4wlo496 as KProperty1,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  fill2542d4m9l93pn as fill,
  toByte4i43936u611k as toByte,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  SequenceScope1coiso86pqzq2 as SequenceScope,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  RuntimeException1r3t0zl97011n as RuntimeException,
  StringBuildermazzzhj6kkai as StringBuilder,
  iterator3f5i676wpaa3g as iterator,
  Iterable1y3qizuf89iou as Iterable,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  coerceAtMost322komnqp70ag as coerceAtMost,
  round2mrvepag8eey0 as round,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  isFloatArrayjjscnqphw92j as isFloatArray,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  to2cs3ny02qtbcb as to,
  mapOf1xd03cq9cnmy8 as mapOf,
  removePrefix279df90bhrqqg as removePrefix,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  split2bvyvnrlcifjv as split,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  startsWith26w8qjqapeeq6 as startsWith,
  setOf45ia9pnfhe90 as setOf,
  toInt5qdj874w69jh as toInt,
  printStackTrace18lnx7a39cni as printStackTrace,
  contains3u8qpdzrl9an as contains,
  Collection1k04j3hzsbod0 as Collection,
  KtList3hktaavzmj137 as KtList,
  roundToInt1ue8x8yshtznx as roundToInt,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  compareTo3ankvs086tmwq as compareTo,
  Comparable198qfk8pnblz0 as Comparable,
  numberToDouble210hrknaofnhf as numberToDouble,
  protoOf180f3jzyo7rfj as protoOf,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  HashMap1a0ld5kgwhmhv as HashMap,
  startsWith1bgirhbedtv2y as startsWith_0,
  firstOrNullf6vlo6vdgu1e as firstOrNull,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  first28gmhyvs4kf06 as first,
  toMap1vec9topfei08 as toMap,
  lines3g90sq0zeq43v as lines,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  split3d3yeauc4rm2n as split_0,
  listOf1jh22dvmctj1r as listOf,
  plus310ted5e4i90h as plus,
  numberToChar93r9buh19yek as numberToChar,
  toString14fd7g605f91p as toString_1,
  toInt2q8uldh7sc951 as toInt_0,
  toDouble1kn912gjoizjp as toDouble,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
  TimedValuew9j01dao9jci as TimedValue,
  listOfvhqybd2zx248 as listOf_0,
  println2shhhgwwt4c61 as println,
  emptyList1g2z5xcrvp2zy as emptyList,
  until1jbpn0z3f8lbg as until,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  first58ocm7j58k3q as first_0,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  firstOrNull1982767dljvdy as firstOrNull_0,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  toList2z3tifmtru5ra as toList_0,
  emptyMapr06gerzljqtm as emptyMap,
  last1vo29oleiqj36 as last,
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  getProgressionLastElement2w30kdy2w5nkt as getProgressionLastElement,
  isNumberiramasdbon0i as isNumber,
  toShort36kaw0zjdq3ex as toShort,
  Char__plus_impl_qi7pgjkmqmcttgys79 as Char__plus_impl_qi7pgj,
  Default_getInstancegttbt9h1yt0q as Default_getInstance,
  step18s9qzr5xwxat as step,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toList383f556t1dixk as toList_1,
  boxApply1qmzdb3dh90hg as boxApply,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  Long2qws0ah9gnpki as Long,
  copyOfRange1v9olvyjr7c0r as copyOfRange_0,
  repeat2w4c6j8zoq09o as repeat,
  getOrNull1d60i0672n7ns as getOrNull,
  joinToString1cxrrlmo0chqs as joinToString,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  primitiveArrayConcatwxgknw08pmlb as primitiveArrayConcat,
  toIntArray27j90pvfixv10 as toIntArray,
  first34dru09vyikub as first_1,
  getOrNullef5jbxih7r4f as getOrNull_0,
  lastOrNullxgbdyo3mdsps as lastOrNull,
  toLongw1zpgk99d84b as toLong,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  addAll1k27qatfgp3k5 as addAll,
  distinct10qe1scfdvu5k as distinct,
  sortedWith2csnbbb21k0lg as sortedWith,
  first1vi3grnpj1175 as first_2,
  toSet2orjxp16sotqu as toSet,
  Exceptiondt2hlxn7j7vw as Exception,
  minus27abgkurcn6u0 as minus,
  CancellationException3b36o9qz53rgr as CancellationException,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  setOf1u3mizs95ngxo as setOf_0,
  plus1nh85pok677ot as plus_0,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__toString_impl_8d916b13ohvvi8wucz4 as Duration__toString_impl_8d916b,
  toMapcf6xfku344cz as toMap_0,
  toIntArray2d4xwvtjb01mq as toIntArray_0,
  abs1kdzbjes1idip as abs,
  endsWith3cq61xxngobwh as endsWith,
  Char19o2r8palgjof as Char,
  Duration__hashCode_impl_u4exz629330ogi7dvp as Duration__hashCode_impl_u4exz6,
  toMutableMapr5f3w62lv8sk as toMutableMap,
  getOrNull1go7ef9ldk0df as getOrNull_1,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  KtMap140uvy3s5zad8 as KtMap,
  filterNotNull3qfgcwmxhwfxe as filterNotNull,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  Duration__div_impl_dknbf41b3wgg5p924df as Duration__div_impl_dknbf4,
  fill34ox8qmmmh3u3 as fill_0,
  coerceIn10f36k81le1mm as coerceIn,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  KProperty02ce7r476m8633 as KProperty0,
  Paire9pteg33gng7 as Pair,
  substringBefore3n7kj60w69hju as substringBefore,
  substringAfter1hku067gwr5ve as substringAfter,
  Char__hashCode_impl_otmys1ewos5t0dm35g as Char__hashCode_impl_otmys,
  ValueTimeMark__minus_impl_f87sko6qoir9myg4l1 as ValueTimeMark__minus_impl_f87sko,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  intercepted2ogpsikxxj4u0 as intercepted,
  copyToArray2j022khrow2yi as copyToArray,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_instanceeeaudfwfrq87 as Companion_instance_0,
  RectSlicec5msorw5q4el as RectSlice,
  ImageDoNotFitException2gm4q4wt4lh58 as ImageDoNotFitException,
  _SliceOrientation___get_flipX__impl__lgb7bx2vjjbyotgryi3 as _SliceOrientation___get_flipX__impl__lgb7bx,
  _SliceOrientation___get_rotation__impl__m65r0o2xos42p9chv89 as _SliceOrientation___get_rotation__impl__m65r0o,
  Companion_getInstance2kfoysd3on6as as Companion_getInstance_0,
  _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq2n27zigfr3r41 as _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  applyTransform1vhqlmleb4dce as applyTransform,
  getCurves2yjahbp68cxj3 as getCurves,
  toBezier1cphbqwqpx0d3 as toBezier,
  plus1r33v70e4ipd7 as plus_1,
  get_immutablepxpdoj6e54ll as get_immutable,
  arc$default4sjbw0e0mkug as arc$default,
  VectorBuilder2g8a28qau4ty9 as VectorBuilder,
  SliceOrientation5szkqzxt7oev as SliceOrientation,
  cubic3uw6rftl1cilc as cubic,
  get_EASE_CLAMP_START3mw7sc31t8amo as get_EASE_CLAMP_START,
  get_EASE_CLAMP_END2i469hpc6wipw as get_EASE_CLAMP_END,
  interpolate2729pk90l3f88 as interpolate,
  Winding_EVEN_ODD_getInstancemyc10vdu2m52 as Winding_EVEN_ODD_getInstance,
  StrokeToFill127v8ehrppf9e as StrokeToFill,
  strokeToFill2j5wye7yyxd99 as strokeToFill,
  Companion_getInstance154uzbkgf0e3s as Companion_getInstance_1,
  LineScaleMode_NORMAL_getInstance1wxue9rdh6hry as LineScaleMode_NORMAL_getInstance,
  LineCap_BUTT_getInstancetv7srcehoz43 as LineCap_BUTT_getInstance,
  LineJoin_MITER_getInstance35lw9h64apo2h as LineJoin_MITER_getInstance,
  Winding_NON_ZERO_getInstance38kh1ikwl48ly as Winding_NON_ZERO_getInstance,
  line3u2mk0n2uhnlh as line,
  arcTo1g4ivunekrrtg as arcTo,
  isEmpty3b7xkdp0by4c8 as isEmpty,
  rect1tyihxx4629c2 as rect,
  rect31bppuugx2wch as rect_0,
  rect3nqbmqh4a4l2a as rect_1,
  roundRect2sqmspzw5002d as roundRect,
  roundRect3456nlcytya47 as roundRect_0,
  arc1vjl2w7wqv39k as arc,
  circle1t8rrxfrm1ku9 as circle,
  ellipse2rxvxxfaddo1k as ellipse,
  lineToHqj5ppmwlqa9l as lineToH,
  lineToV2af0qnj7t3mk2 as lineToV,
  rLineToH2txnr065wfrbz as rLineToH,
  rLineToV3iwt0xj4dbrft as rLineToV,
  rMoveTo38ittbd8h3wn5 as rMoveTo,
  rLineTo1671hm1vy9pme as rLineTo,
  transformed2t6vo3srmaaf9 as transformed,
  toCurvesList2ibv2opnrpohn as toCurvesList,
  ProjectedPoint37gr1oedqap6n as ProjectedPoint,
  Companion_getInstance3d17rumlj92i7 as Companion_getInstance_2,
  write11msa0gyjblqp as write,
  get_isConvex3nm4n5empqw0n as get_isConvex,
  strokeToFill34bvxzbc34djp as strokeToFill_0,
  get_mutableqzgwrema46rx as get_mutable,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
  Companion_instance1b5ldp3f3peqe as Companion_instance_1,
  Companion_instance2kecexmga2w0q as Companion_instance_2,
  get_cachedPoints16ehjcv6uuio1 as get_cachedPoints,
  RastScale3rcmuinujik1d as RastScale,
  PolygonScanline1ccjpk6mqxyxd as PolygonScanline,
  IntSegmentSet3br6yjcm9q2bd as IntSegmentSet,
} from './korlibs-math-root-korlibs-math.mjs';
import {
  MarginInt3jiec8xsxkfd as MarginInt,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  SizeInte6w85oa6mz6v as SizeInt,
  Companion_instanceu31qrc8c1r0r as Companion_instance_3,
  Companion_getInstancenbeyvbsm21qs as Companion_getInstance_3,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_4,
  Vector2D378fe5rov8fgw as Vector2D,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_5,
  Line2D2pf35pcx71ncp as Line2D,
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_6,
  Companion_getInstance2yu48324co92b as Companion_getInstance_7,
  _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i as _BoundsBuilder___get_bounds__impl__s1l1gx,
  BoundsBuilder__plus_impl_cz7f7xqnc8b6uzo82y as BoundsBuilder__plus_impl_cz7f7x,
  Rectangle3q03woyn9k8x1 as Rectangle,
  BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm as BoundsBuilder__plus_impl_cz7f7x_0,
  Scale2cm697xlulcp5 as Scale,
  toFloat3b315y36g90cd as toFloat,
  Matrix1p940sdz227jj as Matrix,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_8,
  Angle_between72970e1vlen9 as Angle_between,
  Angle__unaryMinus_impl_7901fruk5m76f5kg06 as Angle__unaryMinus_impl_7901fr,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__div_impl_ut2btd19ndx9mxcgcss as Angle__div_impl_ut2btd,
  Angle2itorpob18n08 as Angle,
  Angle__hashCode_impl_szcndtx0rhatnvuhb1 as Angle__hashCode_impl_szcndt,
  get_degrees1wvulgxbo1fy6 as get_degrees_0,
  get_radians87y5j8tewvub as get_radians,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  BoundsBuilder__xminOr_impl_k3l1m233j5xey4uzzri as BoundsBuilder__xminOr_impl_k3l1m2,
  BoundsBuilder__toString_impl_fmvxh7qh65bafrb2p as BoundsBuilder__toString_impl_fmvxh7,
  BoundsBuilder__hashCode_impl_649zbo2cbmgnd4y2see as BoundsBuilder__hashCode_impl_649zbo,
  BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3 as BoundsBuilder__plus_impl_cz7f7x_1,
  get_radians391vbqqjsolq6 as get_radians_0,
  _Angle___get_degrees__impl__qg56vw2n539uvc01e1n as _Angle___get_degrees__impl__qg56vw,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  _Angle___init__impl__g23q1m36yxttgnpy5tv as _Angle___init__impl__g23q1m,
  _Angle___get_ratio__impl__ap3on435dv91f5cbp85 as _Angle___get_ratio__impl__ap3on4,
  BoundsBuilder__boundsOrNull_impl_se9lyg1z0iqowyff423 as BoundsBuilder__boundsOrNull_impl_se9lyg,
  scaled2eehd42i2trq9 as scaled,
  MatrixType_IDENTITY_getInstance26n3n49ggvwm4 as MatrixType_IDENTITY_getInstance,
  _Angle___get_radians__impl__n00yt518seywpfbf9fr as _Angle___get_radians__impl__n00yt5,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  setExtra314k0z6q35eku as setExtra,
  hasExtra1969mplo13qgb as hasExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  Property1m5vulkepgwzd as Property,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  toIntFloor3t307m2tavlm8 as toIntFloor,
  toIntCeiltm5lvaa6k4k9 as toIntCeil,
  toRatiolga1a9coidva as toRatio,
  clamp31lhm66c28ic8 as clamp,
  ilog23dbvpk38jf7rc as ilog2,
  extract2vhru1ihy4ogl as extract,
  insertm9bp9ll4cml3 as insert,
  clamp011ml7wx1d2b7sp as clamp01,
  min2wcdwdef93gdl as min,
  maxfuu7ju0dv4mx as max,
  convertRange378kqy75r4gq5 as convertRange,
  clampdicp8njiht45 as clamp_0,
  toIntFloor2i5mxseifeud5 as toIntFloor_0,
  toIntRoundjnzmk86x1qp5 as toIntRound,
  divCeil2r4o5lbvnv4lh as divCeil,
  Ratio__toFloat_impl_1ftup533krasllqk7v1 as Ratio__toFloat_impl_1ftup5,
  clampUByte16elok6pzd6c5 as clampUByte,
  get_niceStr1tlwtz2l2j4my as get_niceStr,
  interpolatexm8yaf0iv9q9 as interpolate_0,
  clamp012a0sd8pj80ati as clamp01_0,
  toIntCeil3h286vm49zgwd as toIntCeil_0,
  niceStr1mw27wr6fq0ek as niceStr,
  get_niceStr3crhxydmlnaoj as get_niceStr_0,
  extractSignedx6cuhlj55jv4 as extractSigned,
  insert163hf9bvod0wg0m as insert16,
  toIntRound1mv0y8x9hh1p4 as toIntRound_0,
  _Ratio___init__impl__9mwvn2mn8x7j48jyfs as _Ratio___init__impl__9mwvn2,
  clamp1qclpmpfxm7xb as clamp_1,
  Ratio__toDouble_impl_o7epze2ppsc3gplivz8 as Ratio__toDouble_impl_o7epze,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_9,
  Easing3266vfl8a4o75 as Easing,
  invoke3idfsdzzpzmqq as invoke,
  invoke1y68e7g1lbvl5 as invoke_0,
  Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_10,
  Ratio__toString_impl_mfgt3e2iqv27qr9i5ak as Ratio__toString_impl_mfgt3e,
  Ratio__hashCode_impl_quhc2v2f99yx2uv51mf as Ratio__hashCode_impl_quhc2v,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  convertRange139vj18oahy2c as convertRange_0,
  Ratio136tf4z2t0p2d as Ratio,
  _Ratio___init__impl__9mwvn2xyj9fjgana63 as _Ratio___init__impl__9mwvn2_0,
  toRatio1hooqit5gulhr as toRatio_0,
  interpolate2g7wzskc23f1q as interpolate_1,
  interpolate35pbs3ac913y4 as interpolate_2,
  Ratio__times_impl_ucdh7y2x1w5kf040xma as Ratio__times_impl_ucdh7y,
  _Ratio___init__impl__9mwvn224skkn3fz6cfs as _Ratio___init__impl__9mwvn2_1,
  umodgae5ifx362au as umod,
  insert8f3zk23r8x9da as insert8,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  IntArray23680o40e0fgt8 as IntArray2,
  Companion_instancelqpzd9anuk16 as Companion_instance_4,
  Companion_instance3ldriv9x4zcjm as Companion_instance_5,
  FloatArray2beehiaucxmzd as FloatArray2,
  GenericSubList2rec7qqyf06nw as GenericSubList,
  GenericListIterator397gjg9p2xwl5 as GenericListIterator,
  toIntMapp1jij98esrcm as toIntMap,
  associateByInt3vmv30txx5avl as associateByInt,
  IntMap2d9g6f5pyaoc2 as IntMap,
  IntArrayList3liuagbdnwmna as IntArrayList,
  reverse22fe0u1pwl2c6 as reverse,
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  IntIntMap3mvg5iqgd5t3z as IntIntMap,
  getCyclic28wvgqye98jqx as getCyclic,
  toIntArrayList3jlt4o6tyleu as toIntArrayList,
  reader2h6ma9ht1vbo2 as reader,
  expect28ynvao96agxo as expect,
  ListReader37jxep6q6wbzq as ListReader,
  doubleArrayListOfkj3z9zq4pobs as doubleArrayListOf,
  DoubleVectorArrayListq54dfthnqi2t as DoubleVectorArrayList,
  intArrayListOf18h0hna7wb0zr as intArrayListOf,
  _TGenStack___init__impl__yynjgt2kqnbzr6sil9y as _TGenStack___init__impl__yynjgt,
  TGenStack__push_impl_9yh33t21dxxdiycat5m as TGenStack__push_impl_9yh33t,
  TGenStack__pop_impl_qisxa01c9hqlgdxaps5 as TGenStack__pop_impl_qisxa0,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  invalidOp1stebxh2m3n07 as invalidOp,
  NativeImageRefqizti6jm75 as NativeImageRef,
  reserved38luap2kxmc9d as reserved,
  get_unreachable2fi7msfg0vgzd as get_unreachable,
  get_reserved2d9gxjta2y60d as get_reserved,
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  Endian_BIG_ENDIAN_getInstance3qe1a0k2pp7jd as Endian_BIG_ENDIAN_getInstance,
  Endian_LITTLE_ENDIAN_getInstance29hybk19wzxil as Endian_LITTLE_ENDIAN_getInstance,
  FileNotFoundException2tz8ve019qipn as FileNotFoundException,
  ByteArrayBuilderyrflhqjz64ju as ByteArrayBuilder,
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_11,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  arraycopy14jict0dth60o as arraycopy,
  UByteArrayInt__get_impl_px6q8a2tesw5a6a7pt2 as UByteArrayInt__get_impl_px6q8a,
  UByteArrayInt__set_impl_gn45323mc9aqt29pp9p as UByteArrayInt__set_impl_gn4532,
  arraycopy3czrd9re36wzt as arraycopy_0,
  _UByteArrayInt___init__impl__xif7bu3la1vncefaitd as _UByteArrayInt___init__impl__xif7bu,
  getU83agrw8yj0shar as getU8,
  _UShortArrayInt___init__impl__kdofb8124zcs6bgqfxc as _UShortArrayInt___init__impl__kdofb8,
  UShortArrayInt__set_impl_38wgvc2wqa90g1ifa1l as UShortArrayInt__set_impl_38wgvc,
  UShortArrayInt__get_impl_ciz20k3q1wtux9fkamc as UShortArrayInt__get_impl_ciz20k,
  getU16LE2cizldw8qp53x as getU16LE,
  getU16BE2rszf3doox5o as getU16BE,
  getU24LEi3x1z5ajbdbv as getU24LE,
  getU24BE36pml41y2814b as getU24BE,
  getS32LE1pxm9wohin3g8 as getS32LE,
  getS32BE5aphh7sm8f2q as getS32BE,
  getU1616fejrhhqwfv2 as getU16,
  getS3225c4j90s7n16a as getS32,
  _UByteArrayInt___init__impl__xif7bu3qwnn3s49fymk as _UByteArrayInt___init__impl__xif7bu_0,
  asByteArray1mw554k0vpuh5 as asByteArray,
  UByteArrayInt__getOrElse_impl_f0pf7216mblxgilcglu as UByteArrayInt__getOrElse_impl_f0pf72,
  _UByteArrayInt___get_size__impl__bcjnte1riayqw17gpkp as _UByteArrayInt___get_size__impl__bcjnte,
  UByteArrayInt247ue4nx0pkns as UByteArrayInt,
  asInt32Arrayf0ml2lp92o3m as asInt32Array,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  substr2jonrcqd8qwvx as substr,
  substr1q77u5lo4evr6 as substr_0,
  unquote1kjyk5vajgaow as unquote,
  get_UTF82geyfhi1l22xl as get_UTF8,
  get_UTF16_BE3rxrt7v8707y4 as get_UTF16_BE,
  Companion_getInstance6aal8l6ipt6u as Companion_getInstance_12,
  Charsets_instance2e55bmt8joybi as Charsets_instance,
  ASCII_getInstancey3nspn0nzsaa as ASCII_getInstance,
  toString2x583ovdqfjci as toString_2,
  Companion_instancem01nsetwb8p0 as Companion_instance_6,
  skipWhile2q7z6jpi2pkj6 as skipWhile,
  WStringReader2bukzqxb5clbi as WStringReader,
  _WChar___get_codePoint__impl__c8brwu2vjc0ffpg6ich as _WChar___get_codePoint__impl__c8brwu,
  WStringambx64bqrrmq as WString,
  get_isNumeric3g36pzg3a1w7z as get_isNumeric,
  get_eofrk1bzx8ckgtd as get_eof,
  skipSpaces25iogcdi8m3q2 as skipSpaces,
  skipExpect1tagjz9aj6y5q as skipExpect,
  isLetterOrDigit1ja5dr081kl50 as isLetterOrDigit,
  isDigit1w4owst7y9rdz as isDigit,
  isWhitespaceFast2iszcfvpi3biz as isWhitespaceFast,
} from './korlibs-string-root-korlibs-string.mjs';
import {
  appendHexByte1xtb46j7ij290 as appendHexByte,
  fromBase6434uveajlhn2ar as fromBase64,
  get_hex32p4ssq0y1xxx as get_hex,
  get_hex3lw8e6gsph9rg as get_hex_0,
} from './korlibs-encoding-root-korlibs-encoding.mjs';
import {
  Xmlepssdknidwxh as Xml,
  get12f8xnsftqcwn as get,
  Companion_getInstance345a0ojzj45ct as Companion_getInstance_13,
} from './korlibs-serialization-root-korlibs-serialization.mjs';
import {
  get_dynw5edstkdie96 as get_dyn,
  Dyn__get_impl_6l2p802ap79h85reiiq as Dyn__get_impl_6l2p80,
  Dyn__toDoubleDefault_impl_fspogf1rn8v9q6wbx2 as Dyn__toDoubleDefault_impl_fspogf,
  Dyn__toStringOrNull_impl_7e6cgy1b2jkpzd6lmvg as Dyn__toStringOrNull_impl_7e6cgy,
  Dyn__toList_impl_pxssgreuo7vfsc7aqn as Dyn__toList_impl_pxssgr,
  Dyn__toString_impl_9l0v3s3bs6vkriyagvh as Dyn__toString_impl_9l0v3s,
  _Dyn___get_int__impl__sh8lhmx5zxcvkgp62x as _Dyn___get_int__impl__sh8lhm,
} from './korlibs-dyn-root-korlibs-dyn.mjs';
import {
  Companion_getInstance3mocpl8hga9iq as Companion_getInstance_14,
  uncompress3ofkd276wd0zn as uncompress,
} from './korlibs-compression-root-korlibs-compression.mjs';
import {
  openFastStream2r4uuohoj0wpo as openFastStream,
  toSyncStream3g0dpktigjx33 as toSyncStream,
  FastByteArrayInputStream1jjm4ufd0tkh5 as FastByteArrayInputStream,
  sliceHere162e6oimkowhf as sliceHere,
  readString3h14fm47a2tde as readString,
  readU162q6ft3yjssyvs as readU16,
  readS325wl7ebgpu38s as readS32,
  readBytesExact305h8zdeltghk as readBytesExact,
  sliceStart186j1d4dpd1wx as sliceStart,
  readStringzzxx8hll1ncys as readStringz,
  skipToAlignusebk6ndjvs1 as skipToAlign,
  openSync2m3qn99fqytu0 as openSync,
  sliceStart237tx6t7cytus as sliceStart_0,
  readString3106ot9qwcir2 as readString_0,
  readBytes3l26albs0coyl as readBytes,
  readAll1pkrq4jwoqns4 as readAll,
  readS32BE1vkzsiuy9pof1 as readS32BE,
  get_eofaukbsoaf5jcj as get_eof_0,
  readStringz3jxaogr49n5ys as readStringz_0,
  readStream3s64ivrsklqly as readStream,
  readU82o15i0epsnmc5 as readU8,
  readAll3m5rixujsbctr as readAll_0,
  openAsync37anb1e84urmo as openAsync,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import {
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_15,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  get_baseName2yf63efofm8te as get_baseName,
  readAsSyncStream2ficq0l6vek7d as readAsSyncStream,
  getUnderlyingUnscapedFilej1r5tpfxb7a7 as getUnderlyingUnscapedFile,
  UrlVfs292f1sja450ff as UrlVfs,
  LocalVfs18bzski76hhpp as LocalVfs,
} from './korlibs-io-vfs-root-korlibs-io-vfs.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from './kotlinx-atomicfu.mjs';
import {
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
  runBlockingNoSuspensions25hsuevf2mle as runBlockingNoSuspensions,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  toDuration15w5sljvx2ut2 as toDuration_0,
  get_fast37cu8s8qwnuyi as get_fast,
  get_milliseconds20vru1dkca6bq as get_milliseconds,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  Companion_instance3mhfp4g0i6mgz as Companion_instance_7,
  decodeBytes3q5q9i2zh0cy6 as decodeBytes,
} from './korlibs-image-core-root-korlibs-image-core.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from './kotlinx-coroutines-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
var log2 = Math.log2;
//endregion
//region block: pre-declaration
class GrowMethod extends Enum {}
class Entry {
  constructor(slice, data) {
    this.v3u_1 = slice;
    this.w3u_1 = data;
  }
  toString() {
    return 'Entry(slice=' + this.v3u_1.toString() + ', data=' + toString(this.w3u_1) + ')';
  }
  hashCode() {
    var result = this.v3u_1.hashCode();
    result = imul(result, 31) + (this.w3u_1 == null ? 0 : hashCode(this.w3u_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!this.v3u_1.equals(tmp0_other_with_cast.v3u_1))
      return false;
    if (!equals(this.w3u_1, tmp0_other_with_cast.w3u_1))
      return false;
    return true;
  }
}
class MutableAtlas {
  static a3w(binPacker, border, premultiplied, allowToGrow, growMethod) {
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    var $this = createThis(this);
    $this.x3u_1 = binPacker;
    $this.y3u_1 = border;
    $this.z3u_1 = premultiplied;
    $this.a3v_1 = allowToGrow;
    $this.b3v_1 = growMethod;
    $this.c3v_1 = MarginInt.j29($this.y3u_1);
    $this.d3v_1 = Bitmap32.y3v($this.w2i(), $this.x2i(), VOID, $this.z3u_1);
    $this.e3v_1 = arrayListOf([$this.d3v_1]);
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.f3v_1 = ArrayList.i1();
    $this.g3v_1 = LinkedHashMap.ac();
    $this.h3v_1 = null;
    return $this;
  }
  static b3w(width, height, border, premultiplied, allowToGrow, growMethod) {
    width = width === VOID ? 2048 : width;
    height = height === VOID ? width : height;
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    return this.a3w(Companion_instance_0.w3e(width, height), border, premultiplied, allowToGrow, growMethod);
  }
  w2i() {
    return numberToInt(this.x3u_1.w2i());
  }
  x2i() {
    return numberToInt(this.x3u_1.x2i());
  }
  d1() {
    return this.f3v_1.d1();
  }
  c3w(bmp, data, name) {
    return this.z3v(slice(bmp, VOID, name), data, name);
  }
  d3w(bmp, data, name, $super) {
    name = name === VOID ? 'Slice' + this.d1() : name;
    return $super === VOID ? this.c3w(bmp, data, name) : $super.c3w.call(this, bmp, data, name);
  }
  z3v(bmp, data, name) {
    var tmp = get_bmp(bmp);
    if (!(tmp instanceof Bitmap32)) {
      return this.c3w(extract_0(bmp).r3w(), data, name);
    }
    if (!(bmp instanceof RectSlice))
      THROW_CCE();
    try {
      var rname = name == null ? 'Slice' + this.d1() : name;
      var isEmpty = isFullyTransparent(bmp);
      var entry = null;
      if (isEmpty && !(this.h3v_1 == null)) {
        var bigEmptySlice = ensureNotNull(this.h3v_1).v3u_1;
        if (bigEmptySlice.s3g_1 >= bmp.s3g_1 && bigEmptySlice.t3g_1 >= bmp.t3g_1) {
          entry = new Entry(bigEmptySlice.c3i(RectangleInt.k2f(0, 0, bmp.s3g_1, bmp.t3g_1)), data);
        }
      }
      if (entry == null) {
        var rect = this.x3u_1.i2r(bmp.s3g_1 + imul(this.y3u_1, 2), bmp.t3g_1 + imul(this.y3u_1, 2));
        var slice = sliceWithSize(this.d3v_1, numberToInt(rect.t26() + this.y3u_1), numberToInt(rect.v26() + this.y3u_1), bmp.s3g_1, bmp.t3g_1, rname);
        var dstX = slice.t26();
        var dstY = slice.v26();
        var boundsWithBorder = get_bounds_0(slice).l2f(this.c3v_1);
        // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
        var this_0 = this.d3v_1;
        if (true) {
          this_0.s3w();
        }
        var result;
        try {
          // Inline function 'korlibs.image.atlas.MutableAtlas.add.<anonymous>' call
          this.d3v_1.t3w(bmp, dstX, dstY);
          expandBorder(this.d3v_1, slice.k3g_1, this.y3u_1);
        }finally {
          result = true ? this_0.u3w(boundsWithBorder) : 0;
        }
        entry = new Entry(slice, data);
        if (this.h3v_1 == null || bmp.y2f() > ensureNotNull(this.h3v_1).v3u_1.y2f()) {
          this.h3v_1 = entry;
        }
      }
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = this.f3v_1;
      var element = entry;
      this_1.h(element);
      // Inline function 'kotlin.collections.set' call
      var this_2 = this.g3v_1;
      var value = entry;
      this_2.f3(rname, value);
      return entry;
    } catch ($p) {
      if ($p instanceof ImageDoNotFitException) {
        var e = $p;
        if (!this.a3v_1)
          throw e;
        growAtlas(this, bmp);
        return this.z3v(bmp, data, name);
      } else {
        throw $p;
      }
    }
  }
  v3w(bmp, data, name, $super) {
    name = name === VOID ? bmp.n3g_1 : name;
    return $super === VOID ? this.z3v(bmp, data, name) : $super.z3v.call(this, bmp, data, name);
  }
}
class Bitmap {
  static w3w(width, height, bpp, premultiplied, backingArray) {
    var $this = createThis(this);
    $this.e3w_1 = new Mixin();
    $this.f3w_1 = width;
    $this.g3w_1 = height;
    $this.h3w_1 = bpp;
    $this.i3w_1 = backingArray;
    $this.j3w_1 = RectangleInt.k2f(0, 0, $this.f3w_1, $this.g3w_1);
    $this.k3w_1 = null;
    $this.l3w_1 = premultiplied;
    $this.m3w_1 = false;
    var tmp = $this;
    tmp.n3w_1 = lazy(Bitmap$tempInts$delegate$lambda($this));
    $this.o3w_1 = 0;
    $this.p3w_1 = null;
    $this.q3w_1 = false;
    return $this;
  }
  y1i(_set____db54di) {
    this.e3w_1.y1i(_set____db54di);
  }
  z1i() {
    return this.e3w_1.z1i();
  }
  d1() {
    return SizeInt.d2h(this.f3w_1, this.g3w_1);
  }
  x3w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n3w_1;
    tempInts$factory();
    return this_0.o1();
  }
  y3w() {
    return _RgbaArray___init__impl__oib4y4(this.x3w());
  }
  z3w() {
    return imul(this.f3w_1, this.h3w_1) / 8 | 0;
  }
  y2f() {
    return imul(this.f3w_1, this.g3w_1);
  }
  a3x(x, y) {
    return imul(y, this.f3w_1) + x | 0;
  }
  b3x() {
    if (!(this.p3w_1 == null)) {
      this.p3w_1 = null;
    }
  }
  s3w() {
    return Unit_instance;
  }
  u3w(rect) {
    if (this.p3w_1 == null)
      this.p3w_1 = rect;
    else
      this.p3w_1 = Companion_instance_3.r2f(ensureNotNull(this.p3w_1), rect);
    this.o3w_1 = this.o3w_1 + 1 | 0;
    return this.o3w_1;
  }
  c3x(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            out[_unary__edvuaz] = _RGBA___get_value__impl__hhco8v(this.d3x(x0 + x | 0, y0 + y | 0));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  e3x(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp = x0 + x | 0;
            var tmp_0 = y0 + y | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            this.f3x(tmp, tmp_0, _RGBA___init__impl__lqpay5(out[_unary__edvuaz]));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  g3x(x, y, width, height, out, offset, $super) {
    offset = offset === VOID ? 0 : offset;
    var tmp;
    if ($super === VOID) {
      this.e3x(x, y, width, height, out, offset);
      tmp = Unit_instance;
    } else {
      tmp = $super.e3x.call(this, x, y, width, height, out, offset);
    }
    return tmp;
  }
  h3x(x, y, v) {
    if (this.l3w_1) {
      this.f3x(x, y, asNonPremultiplied(_RGBA___get_premultiplied__impl__3bulqc(v)));
    } else {
      this.f3x(x, y, v);
    }
  }
  i3x(x, y) {
    var tmp;
    if (this.l3w_1) {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = asPremultiplied(this.d3x(x, y));
      tmp = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
    } else {
      tmp = this.d3x(x, y);
    }
    return tmp;
  }
  j3x(x, y, color) {
    this.f3x(x, y, _RGBA___init__impl__lqpay5(color));
  }
  k3x(x, y) {
    return _RGBA___get_value__impl__hhco8v(this.d3x(x, y));
  }
  l3x(x, y) {
    var x0 = toIntFloor(x);
    var y0 = toIntFloor(y);
    if (x0 < 0 || y0 < 0 || x0 >= this.f3w_1 || y0 >= this.g3w_1)
      return Colors_getInstance().r3x_1;
    var x1 = toIntCeil(x);
    var y1 = toIntCeil(y);
    var x1Inside = x1 < (this.f3w_1 - 1 | 0);
    var y1Inside = y1 < (this.g3w_1 - 1 | 0);
    // Inline function 'korlibs.math.fract' call
    var xratio = x - toIntFloor(x);
    // Inline function 'korlibs.math.fract' call
    var yratio = y - toIntFloor(y);
    var c00 = this.d3x(x0, y0);
    var c10 = x1Inside ? this.d3x(x1, y0) : c00;
    var c01 = y1Inside ? this.d3x(x0, y1) : c00;
    var c11 = x1Inside && y1Inside ? this.d3x(x1, y1) : c01;
    return Companion_getInstance_23().j43(c00, c10, c01, c11, toRatio(xratio), toRatio(yratio));
  }
  k43(srcX, srcY, dst, dstX, dstY, width, height) {
    var src = this;
    var srcX0 = src.l43(srcX);
    var srcX1 = src.l43(srcX + width | 0);
    var srcY0 = src.m43(srcY);
    var srcY1 = src.m43(srcY + height | 0);
    var dstX0 = dst.l43(dstX);
    var dstX1 = dst.l43(dstX + width | 0);
    var dstY0 = dst.m43(dstY);
    var dstY1 = dst.m43(dstY + height | 0);
    var srcX_0 = srcX0;
    var srcY_0 = srcY0;
    var dstX_0 = dstX0;
    var dstY_0 = dstY0;
    // Inline function 'kotlin.math.min' call
    var a = srcX1 - srcX0 | 0;
    var b = dstX1 - dstX0 | 0;
    var width_0 = Math.min(a, b);
    // Inline function 'kotlin.math.min' call
    var a_0 = srcY1 - srcY0 | 0;
    var b_0 = dstY1 - dstY0 | 0;
    var height_0 = Math.min(a_0, b_0);
    this.n43(srcX_0, srcY_0, dst, dstX_0, dstY_0, width_0, height_0);
  }
  n43(srcX, srcY, dst, dstX, dstY, width, height) {
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.c3x(srcX, srcY + y | 0, width, 1, this.x3w(), 0);
        dst.e3x(dstX, dstY + y | 0, width, 1, this.x3w(), 0);
      }
       while (inductionVariable < height);
  }
  o43(x) {
    return x >= 0 && x < this.f3w_1;
  }
  p43(y) {
    return y >= 0 && y < this.g3w_1;
  }
  q43(x, y) {
    return this.o43(x) && this.p43(y);
  }
  r43(x) {
    return clamp(x, 0, this.f3w_1 - 1 | 0);
  }
  s43(y) {
    return clamp(y, 0, this.g3w_1 - 1 | 0);
  }
  l43(x) {
    return clamp(x, 0, this.f3w_1);
  }
  m43(y) {
    return clamp(y, 0, this.g3w_1);
  }
  t43() {
    var inductionVariable = 0;
    var last = this.g3w_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.u43(y, (this.g3w_1 - y | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  v43() {
    var inductionVariable = 0;
    var last = this.f3w_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.w43(x, (this.f3w_1 - x | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  x43(rotation) {
    var tmp;
    switch (rotation.k3_1) {
      case 0:
        tmp = this.u1i();
        break;
      case 1:
        tmp = this.y43().v43();
        break;
      case 2:
        tmp = this.y43().v43().y43().v43();
        break;
      case 3:
        tmp = this.y43().t43();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  z43(orientation) {
    var out = this.u1i();
    if (_SliceOrientation___get_flipX__impl__lgb7bx(orientation)) {
      out.v43();
    }
    return out.x43(_SliceOrientation___get_rotation__impl__m65r0o(orientation));
  }
  y43() {
    var temp = new IntArray2(this.f3w_1, this.g3w_1, readPixelsUnsafe(this, 0, 0, this.f3w_1, this.g3w_1));
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = this.g3w_1;
    var height = this.f3w_1;
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 0;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var out = new IntArray2(width, height, isIntArray(tmp_2) ? tmp_2 : THROW_CCE());
    var inductionVariable = 0;
    var last = this.g3w_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.f3w_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.c2j(y, x, temp.n28(x, y));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = this.a44(this.g3w_1, this.f3w_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.transposed.<anonymous>' call
    this_0.g3x(0, 0, this.g3w_1, this.f3w_1, out.v2i_1);
    return this_0;
  }
  u43(y0, y1) {
    var inductionVariable = 0;
    var last = this.f3w_1;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.k3x(x, y0);
        var c1 = this.k3x(x, y1);
        this.j3x(x, y0, c1);
        this.j3x(x, y1, c0);
      }
       while (inductionVariable < last);
  }
  w43(x0, x1) {
    var inductionVariable = 0;
    var last = this.g3w_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.k3x(x0, y);
        var c1 = this.k3x(x1, y);
        this.j3x(x0, y, c1);
        this.j3x(x1, y, c0);
      }
       while (inductionVariable < last);
  }
  b44(antialiasing) {
    throw UnsupportedOperationException.x9('Not implemented context2d on Bitmap, please use NativeImage or Bitmap32 instead');
  }
  a44(width, height) {
    invalidOp('Unsupported createWithThisFormat (' + toString_0(this) + ')');
  }
  r3w() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.y3v(this.f3w_1, this.g3w_1, VOID, this.l3w_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.toBMP32.<anonymous>' call
    this.c3x(0, 0, this.f3w_1, this.g3w_1, this_0.v3v_1, 0);
    return this_0;
  }
  c44() {
    var tmp;
    if (this instanceof Bitmap32) {
      tmp = this;
    } else {
      tmp = this.r3w();
    }
    return tmp;
  }
  u1i() {
    var out = this.a44(this.f3w_1, this.g3w_1);
    this.n43(0, 0, out, 0, 0, this.f3w_1, this.g3w_1);
    return out;
  }
}
class Companion {
  constructor() {
    Companion_instance_8 = this;
    this.m44_1 = Bitmap32.y3v(0, 0, VOID, true);
  }
  n44(width, height, value) {
    // Inline function 'kotlin.apply' call
    var this_0 = Bitmap32.y3v(width, height, VOID, true);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Companion.invoke.<anonymous>' call
    fill(this_0.v3v_1, _RGBAPremultiplied___get_value__impl__bqfhud(value));
    return this_0;
  }
  o44(width, height, premultiplied) {
    return Bitmap32.y3v(width, height, new Int32Array(imul(width, height)), premultiplied);
  }
  p44(src, srcChannel, dst, dstChannel) {
    var srcShift = srcChannel.t44_1;
    var dstShift = dstChannel.t44_1;
    var dstClear = dstChannel.v44_1;
    var dstData = dst.v3v_1;
    var srcData = src.v3v_1;
    var inductionVariable = 0;
    var last = dst.y2f();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = (srcData[n] >>> srcShift | 0) & 255;
        dstData[n] = dstData[n] & dstClear | c << dstShift;
      }
       while (inductionVariable < last);
  }
  w44(src, dst, dstChannel) {
    var destShift = imul(dstChannel.s44_1, 8);
    var destClear = ~(255 << destShift);
    var inductionVariable = 0;
    var last = dst.y2f();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = src.r45()[n] & 255;
        dst.v3v_1[n] = dst.v3v_1[n] & destClear | c << destShift;
      }
       while (inductionVariable < last);
  }
  s45(src, srcChannel, dst) {
    var shift = srcChannel.t44_1;
    var inductionVariable = 0;
    var last = src.y2f();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        dst.r45()[n] = toByte((src.v3v_1[n] >>> shift | 0) & 255);
      }
       while (inductionVariable < last);
  }
}
class Bitmap32$iterator$slambda {
  constructor(this$0) {
    this.k44_1 = this$0;
  }
  t45($this$iterator, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$iterator), $completion);
  }
  pd(p1, $completion) {
    return this.t45(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  }
}
class Bitmap32 extends Bitmap {
  static y3v(width, height, ints, premultiplied) {
    Companion_getInstance_16();
    ints = ints === VOID ? new Int32Array(imul(width, height)) : ints;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    var $this = this.w3w(width, height, 32, premultiplied, ints);
    $this.v3v_1 = ints;
    if ($this.v3v_1.length < imul(width, height))
      throw RuntimeException.ia('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.v3v_1.length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.w3v_1 = new Int32Array(tmp$ret$0);
    $this.x3v_1 = RectangleInt.k2f(0, 0, width, height);
    return $this;
  }
  a44(width, height) {
    return Bitmap32.y3v(width, height, VOID, this.l3w_1);
  }
  n43(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap32))
      return super.n43(srcX, srcY, dst, dstX, dstY, width, height);
    var src = this;
    var srcArray = src.v3v_1;
    var dstArray = dst.v3v_1;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        arraycopy(srcArray, src.a3x(srcX, srcY + y | 0), dstArray, dst.a3x(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  u45(x, y, color) {
    this.h3x(x, y, color);
  }
  v45(x, y) {
    return this.i3x(x, y);
  }
  j3x(x, y, color) {
    this.v3v_1[this.a3x(x, y)] = color;
  }
  k3x(x, y) {
    return this.v3v_1[this.a3x(x, y)];
  }
  d3x(x, y) {
    return _RGBA___init__impl__lqpay5(this.k3x(x, y));
  }
  f3x(x, y, v) {
    return this.j3x(x, y, _RGBA___get_value__impl__hhco8v(v));
  }
  w45(n, color) {
    this.v3v_1[n] = this.l3w_1 ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(color)) : _RGBA___get_value__impl__hhco8v(color);
  }
  x45(n, color) {
    var tmp;
    if (this.l3w_1) {
      tmp = _RGBAPremultiplied___get_value__impl__bqfhud(color);
    } else {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(color);
      tmp = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
    }
    this.v3v_1[n] = tmp;
  }
  l44(n) {
    var tmp;
    if (this.l3w_1) {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.v3v_1[n]);
      tmp = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
    } else {
      tmp = _RGBA___init__impl__lqpay5(this.v3v_1[n]);
    }
    return tmp;
  }
  y45(n) {
    return this.l3w_1 ? _RGBAPremultiplied___init__impl__uos02x(this.v3v_1[n]) : _RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.v3v_1[n]));
  }
  z45(src, dx, dy, sleft, stop, sright, sbottom, mix_0) {
    var dst = this;
    var width = sright - sleft | 0;
    var height = sbottom - stop | 0;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dstOffset = dst.a3x(dx, dy + y | 0);
        var srcOffset = src.a3x(sleft, stop + y | 0);
        if (mix_0) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < width)
            do {
              var x = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              dst.x45(dstOffset + x | 0, mix(dst.y45(dstOffset + x | 0), src.y45(srcOffset + x | 0)));
            }
             while (inductionVariable_0 < width);
        } else {
          if (dst.l3w_1 === src.l3w_1) {
            arraycopy(src.v3v_1, srcOffset, dst.v3v_1, dstOffset, width);
          } else if (!dst.l3w_1) {
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < width)
              do {
                var x_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                dst.w45(dstOffset + x_0 | 0, src.l44(srcOffset + x_0 | 0));
              }
               while (inductionVariable_1 < width);
          } else {
            var inductionVariable_2 = 0;
            if (inductionVariable_2 < width)
              do {
                var x_1 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                dst.x45(dstOffset + x_1 | 0, src.y45(srcOffset + x_1 | 0));
              }
               while (inductionVariable_2 < width);
          }
        }
      }
       while (inductionVariable < height);
  }
  a46(src, dx, dy, sleft, stop, sright, sbottom, mix) {
    var sleft_0 = sleft;
    var stop_0 = stop;
    var dx_0 = dx;
    var dy_0 = dy;
    if (dx_0 < 0) {
      sleft_0 = sleft_0 - dx_0 | 0;
      dx_0 = 0;
    }
    if (dy_0 < 0) {
      stop_0 = stop_0 - dy_0 | 0;
      dy_0 = 0;
    }
    var availableWidth = this.f3w_1 - dx_0 | 0;
    var availableHeight = this.g3w_1 - dy_0 | 0;
    // Inline function 'kotlin.math.min' call
    var b = sright - sleft_0 | 0;
    var awidth = Math.min(availableWidth, b);
    // Inline function 'kotlin.math.min' call
    var b_0 = sbottom - stop_0 | 0;
    var aheight = Math.min(availableHeight, b_0);
    this.z45(src, dx_0, dy_0, sleft_0, stop_0, sleft_0 + awidth | 0, stop_0 + aheight | 0, mix);
  }
  b46(mix, other, _dx, _dy) {
    this.a46(other, _dx, _dy, 0, 0, other.f3w_1, other.g3w_1, mix);
  }
  c46(color, x, y, width, height) {
    var x1 = this.r43(x);
    var x2 = this.r43((x + width | 0) - 1 | 0);
    var y1 = this.s43(y);
    var y2 = this.s43((y + height | 0) - 1 | 0);
    var colorInt = RGBA__premultipliedValue_impl_oja55q(color, this.l3w_1);
    var inductionVariable = y1;
    if (inductionVariable <= y2)
      do {
        var cy = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        fill(this.v3v_1, colorInt, this.a3x(x1, cy), this.a3x(x2, cy) + 1 | 0);
      }
       while (!(cy === y2));
  }
  d46(color, x, y, width, height, $super) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? this.f3w_1 - x | 0 : width;
    height = height === VOID ? this.g3w_1 - y | 0 : height;
    var tmp;
    if ($super === VOID) {
      this.c46(color, x, y, width, height);
      tmp = Unit_instance;
    } else {
      tmp = $super.c46.call(this, new RGBA(color), x, y, width, height);
    }
    return tmp;
  }
  e46(src, dx, dy, mix) {
    var b = get_bounds_0(src);
    this.a46(get_bmp(src), dx, dy, b.t26(), b.v26(), b.u26(), b.w26(), mix);
  }
  f46(src, dx, dy) {
    return this.b46(false, src, dx, dy);
  }
  g46(src, dx, dy) {
    return this.b46(true, src, dx, dy);
  }
  t3w(src, dx, dy) {
    return this.e46(src, dx, dy, true);
  }
  h46(destination, input, source) {
    return Companion_getInstance_16().p44(input, source, this, destination);
  }
  i46(destination, input) {
    return Companion_getInstance_16().w44(input, this, destination);
  }
  j46(channel, out) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.extractChannel.<anonymous>' call
    Companion_getInstance_16().s45(this, channel, out);
    return out;
  }
  k46(channel, out, $super) {
    out = out === VOID ? Bitmap8.f47(this.f3w_1, this.g3w_1) : out;
    return $super === VOID ? this.j46(channel, out) : $super.j46.call(this, channel, out);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.toString.<anonymous>' call
    this_0.nb('Bitmap32(');
    this_0.qg(this.f3w_1);
    this_0.nb(', ');
    this_0.qg(this.g3w_1);
    if (!(this.k3w_1 == null)) {
      this_0.nb(', name=');
      this_0.nb(this.k3w_1);
    }
    this_0.nb(')');
    return this_0.toString();
  }
  u43(y0, y1) {
    var s0 = this.a3x(0, y0);
    var s1 = this.a3x(0, y1);
    arraycopy(this.v3v_1, s0, this.w3v_1, 0, this.f3w_1);
    arraycopy(this.v3v_1, s1, this.v3v_1, s0, this.f3w_1);
    arraycopy(this.w3v_1, 0, this.v3v_1, s1, this.f3w_1);
  }
  u1i() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.v3v_1.slice();
    return Bitmap32.y3v(this.f3w_1, this.g3w_1, tmp$ret$1, this.l3w_1);
  }
  b44(antialiasing) {
    return new Context2d(new Bitmap32Context2d(this, antialiasing));
  }
  g47() {
    return this.l3w_1 ? this : this.copyPremultiplied();
  }
  h47() {
    return !this.l3w_1 ? this : this.i47();
  }
  copyPremultiplied() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.u1i();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.premultiplied.<anonymous>' call
    this_0.j47();
    return this_0;
  }
  i47() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.u1i();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.depremultiplied.<anonymous>' call
    this_0.k47();
    return this_0;
  }
  j47() {
    if (this.l3w_1)
      return Unit_instance;
    this.l3w_1 = true;
    var inductionVariable = 0;
    var last = this.y2f();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.v3v_1[n] = _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.v3v_1[n])));
      }
       while (inductionVariable < last);
  }
  k47() {
    if (!this.l3w_1)
      return Unit_instance;
    this.l3w_1 = false;
    var inductionVariable = 0;
    var last = this.y2f();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
        var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.v3v_1[n]);
        var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
        this.v3v_1[n] = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
      }
       while (inductionVariable < last);
  }
  a1() {
    return iterator(Bitmap32$iterator$slambda_0(this));
  }
  l47(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy(_RgbaArray___get_ints__impl__u2kps1(data), 0, this.v3v_1, this.a3x(x, y), width);
    } else {
      var m = this.a3x(x, y);
      var inductionVariable = 0;
      if (inductionVariable < width)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.v3v_1[m] = _RgbaArray___get_ints__impl__u2kps1(data)[n];
          m = m + increment | 0;
        }
         while (inductionVariable < width);
    }
  }
  r3w() {
    return this;
  }
}
class Companion_0 {
  m47(src, srcX, srcY, dst, dstX, dstY, width, height) {
    return src.k43(srcX, srcY, dst, dstX, dstY, width, height);
  }
}
class BitmapIndexed extends Bitmap {
  static o47(bpp, width, height, bytes, palette) {
    bytes = bytes === VOID ? new Int8Array(imul(width, height) / (8 / bpp | 0) | 0) : bytes;
    palette = palette === VOID ? Companion_instance_14.n47(1 << bpp) : palette;
    var $this = this.w3w(width, height, bpp, false, bytes);
    $this.k45_1 = bytes;
    $this.l45_1 = palette;
    if ($this.k45_1.length < (imul(width, height) / (8 / bpp | 0) | 0))
      throw RuntimeException.ia('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.r45().length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.m45_1 = new Int8Array(tmp$ret$0);
    $this.n45_1 = _UByteArrayInt___init__impl__xif7bu($this.r45());
    $this.o45_1 = 8 / bpp | 0;
    $this.p45_1 = ilog2($this.o45_1);
    $this.q45_1 = $this.o45_1 - 1 | 0;
    return $this;
  }
  r45() {
    return this.k45_1;
  }
  toString() {
    return 'BitmapIndexed(bpp=' + this.h3w_1 + ', width=' + this.f3w_1 + ', height=' + this.g3w_1 + ', clut=' + _RgbaArray___get_size__impl__imxef8(this.l45_1) + ')';
  }
  k3x(x, y) {
    return this.q47(this.a3x(x, y));
  }
  j3x(x, y, color) {
    return this.p47(this.a3x(x, y), color);
  }
  q47(n) {
    var iD = this.s47(n);
    var iM = this.t47(n);
    return extract(UByteArrayInt__get_impl_px6q8a(this.n45_1, iD), imul(this.h3w_1, iM), this.h3w_1);
  }
  p47(n, color) {
    var iD = this.s47(n);
    var iM = this.t47(n);
    UByteArrayInt__set_impl_gn4532(this.n45_1, iD, insert(UByteArrayInt__get_impl_px6q8a(this.n45_1, iD), color, imul(this.h3w_1, iM), this.h3w_1));
  }
  d3x(x, y) {
    var tmp = this.l45_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.k3x(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  f3x(x, y, v) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Not yet implemented';
    throw NotImplementedError.nd('An operation is not implemented: ' + reason);
  }
  r47(x, y) {
    return this.s47(this.a3x(x, y));
  }
  s47(n) {
    return n >>> this.p45_1 | 0;
  }
  t47(n) {
    return n & this.q45_1;
  }
  u43(y0, y1) {
    var s0 = this.r47(0, y0);
    var s1 = this.r47(0, y1);
    arraycopy_0(this.r45(), s0, this.m45_1, 0, this.z3w());
    arraycopy_0(this.r45(), s1, this.r45(), s0, this.z3w());
    arraycopy_0(this.m45_1, 0, this.r45(), s1, this.z3w());
  }
  u47(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy_0(data, 0, this.r45(), this.a3x(x, y), width / this.o45_1 | 0);
    } else {
      var m = this.a3x(x, y);
      var inductionVariable = 0;
      var last = width / this.o45_1 | 0;
      if (inductionVariable < last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.r45()[m] = data[n];
          m = m + increment | 0;
        }
         while (inductionVariable < last);
    }
  }
  r3w() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.y3v(this.f3w_1, this.g3w_1, VOID, this.l3w_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.toBMP32.<anonymous>' call
    var out = this_0.v3v_1;
    var pal = _RgbaArray___get_ints__impl__u2kps1(this.l45_1);
    var inductionVariable = 0;
    var last = this.y2f();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out[n] = pal[this.q47(n)];
      }
       while (inductionVariable < last);
    return this_0;
  }
}
class Bitmap8 extends BitmapIndexed {
  static f47(width, height, data, palette) {
    data = data === VOID ? new Int8Array(imul(width, height)) : data;
    palette = palette === VOID ? Companion_instance_14.n47(256) : palette;
    return this.o47(8, width, height, data, palette);
  }
  a44(width, height) {
    return Bitmap8.f47(width, height, VOID, this.l45_1);
  }
  j3x(x, y, color) {
    return this.p47(this.a3x(x, y), color);
  }
  k3x(x, y) {
    return UByteArrayInt__get_impl_px6q8a(this.n45_1, this.a3x(x, y));
  }
  d3x(x, y) {
    var tmp = this.l45_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.k3x(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  q47(n) {
    return UByteArrayInt__get_impl_px6q8a(this.n45_1, n);
  }
  p47(n, color) {
    UByteArrayInt__set_impl_gn4532(this.n45_1, n, color);
  }
  n43(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap8))
      return super.n43(srcX, srcY, dst, dstX, dstY, width, height);
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.r45();
        var tmp_0 = this.a3x(srcX, srcY + y | 0);
        arraycopy_0(tmp, tmp_0, (dst instanceof Bitmap8 ? dst : THROW_CCE()).r45(), dst.a3x(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  u1i() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = this.r45().slice();
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = _RgbaArray___get_ints__impl__u2kps1(this.l45_1).slice();
    return Bitmap8.f47(this.f3w_1, this.g3w_1, tmp, _RgbaArray___init__impl__oib4y4(tmp$ret$3));
  }
  toString() {
    return 'Bitmap8(' + this.f3w_1 + ', ' + this.g3w_1 + ', palette=' + _RgbaArray___get_size__impl__imxef8(this.l45_1) + ')';
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_10 = this;
    this.v47_1 = values();
  }
  f1(index) {
    return this.v47_1[index];
  }
}
class BitmapChannel extends Enum {
  constructor(name, ordinal, index) {
    super(name, ordinal);
    this.s44_1 = index;
    this.t44_1 = imul(this.s44_1, 8);
    this.u44_1 = 255 << this.t44_1;
    this.v44_1 = ~this.u44_1;
  }
}
class Bitmaps {}
class Companion_2 {
  constructor() {
    this.w47_1 = 1.0;
    this.x47_1 = 1.4142135;
  }
}
class DistanceBitmap {
  constructor(width, height, d, px, py) {
    d = d === VOID ? new Float32Array(imul(width, height)) : d;
    px = px === VOID ? new Int32Array(imul(width, height)) : px;
    py = py === VOID ? new Int32Array(imul(width, height)) : py;
    this.y47_1 = width;
    this.z47_1 = height;
    this.a48_1 = d;
    this.b48_1 = px;
    this.c48_1 = py;
    this.d48_1 = imul(this.y47_1, this.z47_1);
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.a48_1.length >= this.d48_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.s4(toString_0(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.b48_1.length >= this.d48_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_0 = 'Check failed.';
      throw IllegalStateException.s4(toString_0(message_0));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.c48_1.length >= this.d48_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_1 = 'Check failed.';
      throw IllegalStateException.s4(toString_0(message_1));
    }
  }
  o43(x) {
    return x >= 0 && x < this.y47_1;
  }
  p43(y) {
    return y >= 0 && y < this.z47_1;
  }
  q43(x, y) {
    return this.o43(x) && this.p43(y);
  }
  a3x(x, y) {
    return imul(y, this.y47_1) + x | 0;
  }
  i48(x, y) {
    return this.q43(x, y) ? this.a48_1[this.a3x(x, y)] : Infinity;
  }
  f48(x, y) {
    return this.q43(x, y) ? this.b48_1[this.a3x(x, y)] : -1;
  }
  g48(x, y) {
    return this.q43(x, y) ? this.c48_1[this.a3x(x, y)] : -1;
  }
  h48(x, y, d) {
    if (!this.q43(x, y))
      return Unit_instance;
    this.a48_1[this.a3x(x, y)] = d;
  }
  j48(x, y, px, py) {
    if (!this.q43(x, y))
      return Unit_instance;
    var index = this.a3x(x, y);
    this.b48_1[index] = px;
    this.c48_1[index] = py;
  }
  e48(x, y, px, py) {
    return this.j48(x, y, this.f48(px, py), this.g48(px, py));
  }
  k48(bmp, thresold) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.y47_1 === bmp.f3w_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.s4(toString_0(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.z47_1 === bmp.g3w_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_0 = 'Check failed.';
      throw IllegalStateException.s4(toString_0(message_0));
    }
    var thresoldInt = numberToInt(clamp01(thresold) * 255);
    var inductionVariable = 0;
    var last = this.z47_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.y47_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this.h48(x, y, Infinity);
            this.j48(x, y, -1, -1);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    var inductionVariable_1 = 0;
    var last_1 = this.z47_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = this.y47_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var cur = setFromBitmap$getAlpha(bmp, x_0, y_0, thresoldInt);
            var left = setFromBitmap$getAlpha(bmp, x_0 - 1 | 0, y_0, thresoldInt);
            var right = setFromBitmap$getAlpha(bmp, x_0 + 1 | 0, y_0, thresoldInt);
            var up = setFromBitmap$getAlpha(bmp, x_0, y_0 - 1 | 0, thresoldInt);
            var down = setFromBitmap$getAlpha(bmp, x_0, y_0 + 1 | 0, thresoldInt);
            if (!(left === cur) || !(right === cur) || !(up === cur) || !(down === cur)) {
              this.h48(x_0, y_0, 0.0);
              this.j48(x_0, y_0, x_0, y_0);
            }
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    var inductionVariable_3 = 0;
    var last_3 = this.z47_1;
    if (inductionVariable_3 < last_3)
      do {
        var y_1 = inductionVariable_3;
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        var inductionVariable_4 = 0;
        var last_4 = this.y47_1;
        if (inductionVariable_4 < last_4)
          do {
            var x_1 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            setFromBitmap$pass(this, x_1, y_1, -1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, 0, -1, 1.0);
            setFromBitmap$pass(this, x_1, y_1, 1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, -1, 0, 1.0);
          }
           while (inductionVariable_4 < last_4);
      }
       while (inductionVariable_3 < last_3);
    var inductionVariable_5 = this.z47_1 - 1 | 0;
    if (0 <= inductionVariable_5)
      do {
        var y_2 = inductionVariable_5;
        inductionVariable_5 = inductionVariable_5 + -1 | 0;
        var inductionVariable_6 = this.y47_1 - 1 | 0;
        if (0 <= inductionVariable_6)
          do {
            var x_2 = inductionVariable_6;
            inductionVariable_6 = inductionVariable_6 + -1 | 0;
            setFromBitmap$pass(this, x_2, y_2, 1, 0, 1.0);
            setFromBitmap$pass(this, x_2, y_2, -1, 1, 1.4142135);
            setFromBitmap$pass(this, x_2, y_2, 0, 1, 1.0);
            setFromBitmap$pass(this, x_2, y_2, 1, 1, 1.4142135);
          }
           while (0 <= inductionVariable_6);
      }
       while (0 <= inductionVariable_5);
    var inductionVariable_7 = this.z47_1 - 1 | 0;
    if (0 <= inductionVariable_7)
      do {
        var y_3 = inductionVariable_7;
        inductionVariable_7 = inductionVariable_7 + -1 | 0;
        var inductionVariable_8 = this.y47_1 - 1 | 0;
        if (0 <= inductionVariable_8)
          do {
            var x_3 = inductionVariable_8;
            inductionVariable_8 = inductionVariable_8 + -1 | 0;
            if (setFromBitmap$getAlpha(bmp, x_3, y_3, thresoldInt)) {
              this.h48(x_3, y_3, -this.i48(x_3, y_3));
            }
          }
           while (0 <= inductionVariable_8);
      }
       while (0 <= inductionVariable_7);
  }
}
class FloatBitmap32 extends Bitmap {
  static z48(width, height, data, premultiplied) {
    data = data === VOID ? new Float32Array(imul(imul(width, height), 4)) : data;
    premultiplied = premultiplied === VOID ? false : premultiplied;
    var $this = this.w3w(width, height, 32, premultiplied, data);
    $this.y48_1 = data;
    return $this;
  }
  f3x(x, y, v) {
    var rindex = index4(this, x, y);
    this.y48_1[rindex + 0 | 0] = _RGBA___get_rf__impl__kvz75k(v);
    this.y48_1[rindex + 1 | 0] = _RGBA___get_gf__impl__5gcu1f(v);
    this.y48_1[rindex + 2 | 0] = _RGBA___get_bf__impl__1xz5yg(v);
    this.y48_1[rindex + 3 | 0] = _RGBA___get_af__impl__vu36qv(v);
  }
  d3x(x, y) {
    var rindex = index4(this, x, y);
    return Companion_getInstance_23().a49(this.y48_1[rindex + 0 | 0], this.y48_1[rindex + 1 | 0], this.y48_1[rindex + 2 | 0], this.y48_1[rindex + 3 | 0]);
  }
  b49(x, y) {
    return this.y48_1[index4(this, x, y) + 0 | 0];
  }
  c49(x, y) {
    return this.y48_1[index4(this, x, y) + 1 | 0];
  }
  d49(x, y) {
    return this.y48_1[index4(this, x, y) + 2 | 0];
  }
  e49(x, y) {
    return this.y48_1[index4(this, x, y) + 3 | 0];
  }
  f49(x, y, r, g, b, a) {
    var rindex = index4(this, x, y);
    this.y48_1[rindex + 0 | 0] = r;
    this.y48_1[rindex + 1 | 0] = g;
    this.y48_1[rindex + 2 | 0] = b;
    this.y48_1[rindex + 3 | 0] = a;
  }
  g49(x, y, out) {
    var rindex = index4(this, x, y);
    _RGBAf___set_r__impl__pz5j5e(out, this.y48_1[rindex + 0 | 0]);
    _RGBAf___set_g__impl__c4jj21(out, this.y48_1[rindex + 1 | 0]);
    _RGBAf___set_b__impl__a2n9pa(out, this.y48_1[rindex + 2 | 0]);
    _RGBAf___set_a__impl__iqz7cx(out, this.y48_1[rindex + 3 | 0]);
    return out;
  }
  h49(out) {
    var min_0 = Infinity;
    var max_0 = -Infinity;
    var temp = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.f3w_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.g3w_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.a3x(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.getMinMax.<anonymous>' call
            n = n + 1 | 0;
            var c = this.g49(x, y, temp);
            min_0 = min(min_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
            max_0 = max(max_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    out[0] = min_0;
    out[1] = max_0;
    return out;
  }
  i49(out, $super) {
    out = out === VOID ? new Float32Array(2) : out;
    return $super === VOID ? this.h49(out) : $super.h49.call(this, out);
  }
  j49(minSrc, maxSrc, minDst, maxDst) {
    var out = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.f3w_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.g3w_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.a3x(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.convertRange.<anonymous>' call
            n = n + 1 | 0;
            var rgbaf = this.g49(x, y, out);
            this.f49(x, y, convertRange(_RGBAf___get_r__impl__jfq8gq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_g__impl__dhoraz(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_b__impl__fjl0nq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_a__impl__qnwk97(rgbaf), minSrc, maxSrc, minDst, maxDst));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  k49(minSrc, maxSrc, minDst, maxDst, $super) {
    minDst = minDst === VOID ? 0.0 : minDst;
    maxDst = maxDst === VOID ? 1.0 : maxDst;
    var tmp;
    if ($super === VOID) {
      this.j49(minSrc, maxSrc, minDst, maxDst);
      tmp = Unit_instance;
    } else {
      tmp = $super.j49.call(this, minSrc, maxSrc, minDst, maxDst);
    }
    return tmp;
  }
  l49() {
    var _destruct__k2r9zo = this.i49();
    // Inline function 'kotlin.collections.component1' call
    var min = _destruct__k2r9zo[0];
    // Inline function 'kotlin.collections.component2' call
    var max = _destruct__k2r9zo[1];
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.absoluteValue' call
    var a = Math.abs(min);
    // Inline function 'kotlin.math.absoluteValue' call
    var b = Math.abs(max);
    var range = Math.max(a, b);
    this.k49(-range, +range);
  }
  m49(scale) {
    return this.n49(scale, scale, scale, scale);
  }
  n49(scaleRed, scaleGreen, scaleBlue, scaleAlpha) {
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.f3w_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.g3w_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.a3x(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.scale.<anonymous>' call
            n = n + 1 | 0;
            this.f49(x, y, this.b49(x, y) * scaleRed, this.c49(x, y) * scaleGreen, this.d49(x, y) * scaleBlue, this.e49(x, y) * scaleAlpha);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  o49(min, max) {
    // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.f3w_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.g3w_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.a3x(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
            n = n + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value = this.b49(x, y);
            var tmp = clamp_0(value, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_0 = this.c49(x, y);
            var tmp_0 = clamp_0(value_0, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_1 = this.d49(x, y);
            var tmp_1 = clamp_0(value_1, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_2 = this.e49(x, y);
            var tmp$ret$3 = clamp_0(value_2, min, max);
            this.f49(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
}
class MultiBitmap extends Bitmap {}
class NativeImage extends Bitmap {
  static d4a(width, height, data, premultiplied) {
    var $this = this.w3w(width, height, 32, premultiplied, null);
    $this.c4a_1 = data;
    return $this;
  }
  r3w() {
    // Inline function 'kotlin.also' call
    var this_0 = Companion_getInstance_16().o44(this.f3w_1, this.g3w_1, this.l3w_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.NativeImage.toBMP32.<anonymous>' call
    this.c3x(0, 0, this.f3w_1, this.g3w_1, this_0.v3v_1, 0);
    return this_0;
  }
  f3x(x, y, v) {
    RgbaArray__set_impl_epw2wg(this.y3w(), 0, v);
    this.e3x(x, y, 1, 1, this.x3w(), 0);
  }
  d3x(x, y) {
    this.c3x(x, y, 1, 1, this.x3w(), 0);
    return RgbaArray__get_impl_nzyo1o(this.y3w(), 0);
  }
  j3x(x, y, color) {
    return this.f3x(x, y, _RGBA___init__impl__lqpay5(color));
  }
  k3x(x, y) {
    return _RGBA___get_value__impl__hhco8v(this.d3x(x, y));
  }
  t43() {
    var tmp = this.r3w().t43();
    this.g3x(0, 0, this.f3w_1, this.g3w_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).v3v_1);
    return this;
  }
  v43() {
    var tmp = this.r3w().v43();
    this.g3x(0, 0, this.f3w_1, this.g3w_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).v3v_1);
    return this;
  }
  u43(y0, y1) {
    this.c3x(0, y0, this.f3w_1, 1, this.x3w(), 0);
    this.c3x(0, y1, this.f3w_1, 1, this.x3w(), this.f3w_1);
    this.e3x(0, y1, this.f3w_1, 1, this.x3w(), 0);
    this.e3x(0, y0, this.f3w_1, 1, this.x3w(), this.f3w_1);
  }
  w43(x0, x1) {
    this.c3x(x0, 0, 1, this.g3w_1, this.x3w(), 0);
    this.c3x(x1, 0, 1, this.g3w_1, this.x3w(), this.f3w_1);
    this.e3x(x1, 0, 1, this.g3w_1, this.x3w(), 0);
    this.e3x(x0, 0, 1, this.g3w_1, this.x3w(), this.f3w_1);
  }
  a44(width, height) {
    return NativeImage_0(width, height);
  }
  toString() {
    return this.l3() + '(' + this.f3w_1 + ', ' + this.g3w_1 + ')';
  }
}
class ForcedTexId {}
function get_forcedTexTarget() {
  return 3553;
}
class NullBitmap extends Bitmap {
  static i4b(width, height, premultiplied) {
    Companion_getInstance_20();
    premultiplied = premultiplied === VOID ? true : premultiplied;
    return this.w3w(width, height, 32, premultiplied, null);
  }
  f3x(x, y, v) {
    return Unit_instance;
  }
  d3x(x, y) {
    return _RGBA___init__impl__lqpay5(0);
  }
}
class Companion_3 extends NullBitmap {
  static u4a() {
    Companion_instance_12 = null;
    var $this = this.i4b(1, 1);
    Companion_instance_12 = $this;
    return $this;
  }
}
class Palette {
  constructor(colors, names, changeStart, changeEnd) {
    names = names === VOID ? null : names;
    changeStart = changeStart === VOID ? 0 : changeStart;
    changeEnd = changeEnd === VOID ? 0 : changeEnd;
    this.j4b_1 = colors;
    this.k4b_1 = names;
    this.l4b_1 = changeStart;
    this.m4b_1 = changeEnd;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Palette.toString.<anonymous>' call
    this_0.nb('Palette(');
    var inductionVariable = 0;
    var last = _RgbaArray___get_size__impl__imxef8(this.j4b_1);
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var color = RgbaArray__get_impl_nzyo1o(this.j4b_1, n);
        var tmp22_safe_receiver = this.k4b_1;
        var name = tmp22_safe_receiver == null ? null : tmp22_safe_receiver[n];
        if (n > 0) {
          this_0.nb(', ');
        }
        if (!(name == null)) {
          this_0.nb(name);
          this_0.nb(': ');
        }
        this_0.nb(RGBA__toString_impl_4lw6dp(color));
      }
       while (inductionVariable < last);
    this_0.nb(')');
    return this_0.toString();
  }
}
class Result {
  constructor(bmp, buffer, radius, cutoff) {
    this.x4b_1 = bmp;
    this.y4b_1 = buffer;
    this.z4b_1 = radius;
    this.a4c_1 = cutoff;
  }
  toString() {
    return 'Result(bmp=' + this.x4b_1.toString() + ', buffer=' + this.y4b_1 + ', radius=' + this.z4b_1 + ', cutoff=' + this.a4c_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.x4b_1);
    result = imul(result, 31) + this.y4b_1 | 0;
    result = imul(result, 31) + this.z4b_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.a4c_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.x4b_1, tmp0_other_with_cast.x4b_1))
      return false;
    if (!(this.y4b_1 === tmp0_other_with_cast.y4b_1))
      return false;
    if (!(this.z4b_1 === tmp0_other_with_cast.z4b_1))
      return false;
    if (!equals(this.a4c_1, tmp0_other_with_cast.a4c_1))
      return false;
    return true;
  }
}
class NewSDF {
  constructor() {
    this.b4c_1 = 1.0E10;
  }
  c4c(bmp, maxSide, buffer, radius, cutoff) {
    var size = maxSide + imul(buffer, 4) | 0;
    var out = Bitmap32.y3v(bmp.f3w_1 + imul(buffer, 2) | 0, bmp.g3w_1 + imul(buffer, 2) | 0);
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = out.f3w_1;
    var height = out.g3w_1;
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Float32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 1.0E10;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var gridOuter = new FloatArray2(width, height, isFloatArray(tmp_2) ? tmp_2 : THROW_CCE());
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width_0 = out.f3w_1;
    var height_0 = out.g3w_1;
    var tmp_3 = 0;
    var tmp_4 = imul(width_0, height_0);
    var tmp_5 = new Float32Array(tmp_4);
    while (tmp_3 < tmp_4) {
      tmp_5[tmp_3] = 0.0;
      tmp_3 = tmp_3 + 1 | 0;
    }
    var tmp_6 = tmp_5;
    var gridInner = new FloatArray2(width_0, height_0, isFloatArray(tmp_6) ? tmp_6 : THROW_CCE());
    var f = new Float32Array(size);
    var z = new Float32Array(size + 1 | 0);
    var v = _UShortArrayInt___init__impl__kdofb8(size);
    var inductionVariable = 0;
    var last = bmp.g3w_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = bmp.f3w_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var a = _RGBA___get_af__impl__vu36qv(bmp.v45(x, y));
            var x0 = x + buffer | 0;
            var y0 = y + buffer | 0;
            switch (a) {
              case 0.0:
                gridOuter.j2j(x0, y0, 1.0E10);
                gridInner.j2j(x0, y0, 0.0);
                break;
              case 1.0:
                gridOuter.j2j(x0, y0, 0.0);
                gridInner.j2j(x0, y0, 1.0E10);
                break;
              default:
                var d = 0.5 - a;
                gridOuter.j2j(x0, y0, d > 0.0 ? d * d : 0.0);
                gridInner.j2j(x0, y0, d < 0.0 ? d * d : 0.0);
                break;
            }
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    this.d4c(gridOuter.h2j_1, 0, 0, out.f3w_1, out.g3w_1, gridOuter.w2i(), f, v, z);
    this.d4c(gridInner.h2j_1, buffer, buffer, bmp.f3w_1, bmp.g3w_1, gridInner.w2i(), f, v, z);
    var inductionVariable_1 = 0;
    var last_1 = out.g3w_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = out.f3w_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var gout = gridOuter.n28(x_0, y_0);
            var gin = gridInner.n28(x_0, y_0);
            // Inline function 'kotlin.math.sqrt' call
            var tmp_7 = Math.sqrt(gout);
            // Inline function 'kotlin.math.sqrt' call
            var d_0 = tmp_7 - Math.sqrt(gin);
            var a_0 = toIntRound(255 - 255 * (d_0 / radius + cutoff));
            out.u45(x_0, y_0, Companion_getInstance_23().w4b(255, 255, 255, clamp(a_0, 0, 255)));
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    return new Result(out, buffer, radius, cutoff);
  }
  e4c(bmp, maxSide, buffer, radius, cutoff, $super) {
    var tmp;
    if (maxSide === VOID) {
      // Inline function 'kotlin.math.max' call
      var a = bmp.f3w_1;
      var b = bmp.g3w_1;
      tmp = Math.max(a, b);
    } else {
      tmp = maxSide;
    }
    maxSide = tmp;
    buffer = buffer === VOID ? divCeil(maxSide, 8) : buffer;
    radius = radius === VOID ? divCeil(maxSide, 3) : radius;
    cutoff = cutoff === VOID ? 0.5 : cutoff;
    return $super === VOID ? this.c4c(bmp, maxSide, buffer, radius, cutoff) : $super.c4c.call(this, bmp, maxSide, buffer, radius, cutoff);
  }
  d4c(data, x0, y0, width, height, gridSize, f, v, z) {
    var inductionVariable = x0;
    var last = x0 + width | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.f4c(data, imul(y0, gridSize) + x | 0, gridSize, height, f, v, z);
      }
       while (inductionVariable < last);
    var inductionVariable_0 = y0;
    var last_0 = y0 + height | 0;
    if (inductionVariable_0 < last_0)
      do {
        var y = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.f4c(data, imul(y, gridSize) + x0 | 0, 1, width, f, v, z);
      }
       while (inductionVariable_0 < last_0);
  }
  f4c(grid, offset, stride, length, f, v, z) {
    UShortArrayInt__set_impl_38wgvc(v, 0, 0);
    z[0] = -1.0E10;
    z[1] = 1.0E10;
    f[0] = grid[offset];
    var k = 0;
    var s = 0.0;
    var inductionVariable = 1;
    if (inductionVariable < length)
      do {
        var q = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        f[q] = grid[offset + imul(q, stride) | 0];
        var q2 = imul(q, q);
        $l$1: do {
          $l$0: do {
            var r = UShortArrayInt__get_impl_ciz20k(v, k);
            s = (f[q] - f[r] + q2 - imul(r, r)) / (q - r | 0) / 2.0;
          }
           while (false);
          var tmp;
          if (s <= z[k]) {
            k = k - 1 | 0;
            tmp = k > -1;
          } else {
            tmp = false;
          }
        }
         while (tmp);
        k = k + 1 | 0;
        UShortArrayInt__set_impl_38wgvc(v, k, q);
        z[k] = s;
        z[k + 1 | 0] = 1.0E10;
      }
       while (inductionVariable < length);
    k = 0;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < length)
      do {
        var q_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        while (z[k + 1 | 0] < q_0) {
          k = k + 1 | 0;
        }
        var r_0 = UShortArrayInt__get_impl_ciz20k(v, k);
        var qr = q_0 - r_0 | 0;
        grid[offset + imul(q_0, stride) | 0] = f[r_0] + imul(qr, qr);
      }
       while (inductionVariable_0 < length);
  }
}
class ColorFormat32 {
  constructor() {
    this.l4c_1 = 32;
  }
  g4c() {
    return this.l4c_1;
  }
}
class ColorFormat24 {
  constructor() {
    this.m4c_1 = 24;
  }
  g4c() {
    return this.m4c_1;
  }
}
class ColorTransformMul {
  constructor(_r, _g, _b, _a) {
    _r = _r === VOID ? 1.0 : _r;
    _g = _g === VOID ? 1.0 : _g;
    _b = _b === VOID ? 1.0 : _b;
    _a = _a === VOID ? 1.0 : _a;
    this.n4c_1 = _r;
    this.o4c_1 = _g;
    this.p4c_1 = _b;
    this.q4c_1 = _a;
    this.r4c_1 = true;
    this.s4c_1 = Colors_getInstance().m3x_1;
  }
  t4c() {
    return this.n4c_1;
  }
  u4c() {
    return this.o4c_1;
  }
  v4c() {
    return this.p4c_1;
  }
  w4c(value) {
    this.q4c_1 = value;
    this.r4c_1 = true;
  }
  x4c() {
    return this.q4c_1;
  }
  y4c(v) {
    this.z4c(_RGBA___get_rf__impl__kvz75k(v), _RGBA___get_gf__impl__5gcu1f(v), _RGBA___get_bf__impl__1xz5yg(v), _RGBA___get_af__impl__vu36qv(v));
    this.s4c_1 = v;
    this.r4c_1 = false;
  }
  a4d() {
    if (this.r4c_1) {
      this.r4c_1 = false;
      this.s4c_1 = Companion_getInstance_23().a49(this.n4c_1, this.o4c_1, this.p4c_1, this.q4c_1);
    }
    return this.s4c_1;
  }
  z4c(r, g, b, a) {
    this.n4c_1 = r;
    this.o4c_1 = g;
    this.p4c_1 = b;
    this.q4c_1 = a;
    this.r4c_1 = true;
  }
  b4d(other) {
    return this.z4c(other.n4c_1, other.o4c_1, other.p4c_1, other.q4c_1);
  }
  c4d(a, b) {
    return this.z4c(a.t4c() * b.t4c(), a.u4c() * b.u4c(), a.v4c() * b.v4c(), a.x4c() * b.x4c());
  }
  toString() {
    return 'ColorTransformMul(_r=' + this.n4c_1 + ', _g=' + this.o4c_1 + ', _b=' + this.p4c_1 + ', _a=' + this.q4c_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.n4c_1);
    result = imul(result, 31) + getNumberHashCode(this.o4c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p4c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q4c_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorTransformMul))
      return false;
    var tmp0_other_with_cast = other instanceof ColorTransformMul ? other : THROW_CCE();
    if (!equals(this.n4c_1, tmp0_other_with_cast.n4c_1))
      return false;
    if (!equals(this.o4c_1, tmp0_other_with_cast.o4c_1))
      return false;
    if (!equals(this.p4c_1, tmp0_other_with_cast.p4c_1))
      return false;
    if (!equals(this.q4c_1, tmp0_other_with_cast.q4c_1))
      return false;
    return true;
  }
}
class WithDefault {
  constructor(defaultColor) {
    this.d4d_1 = defaultColor;
  }
  e4d(str) {
    return Colors_getInstance().f4d(str, this.d4d_1);
  }
}
class Colors {
  constructor() {
    Colors_instance = this;
    this.m3x_1 = Companion_getInstance_23().w4b(255, 255, 255, 255);
    this.n3x_1 = Companion_getInstance_23().w4b(0, 0, 0, 255);
    this.o3x_1 = Companion_getInstance_23().w4b(255, 0, 0, 255);
    this.p3x_1 = Companion_getInstance_23().w4b(0, 255, 0, 255);
    this.q3x_1 = Companion_getInstance_23().w4b(0, 0, 255, 255);
    this.r3x_1 = Companion_getInstance_23().w4b(0, 0, 0, 0);
    this.s3x_1 = Companion_getInstance_23().w4b(255, 255, 255, 0);
    this.t3x_1 = Companion_getInstance_23().g4d(240, 248, 255);
    this.u3x_1 = Companion_getInstance_23().g4d(250, 235, 215);
    this.v3x_1 = Companion_getInstance_23().g4d(0, 255, 255);
    this.w3x_1 = Companion_getInstance_23().g4d(127, 255, 212);
    this.x3x_1 = Companion_getInstance_23().g4d(240, 255, 255);
    this.y3x_1 = Companion_getInstance_23().g4d(245, 245, 220);
    this.z3x_1 = Companion_getInstance_23().g4d(255, 228, 196);
    this.a3y_1 = Companion_getInstance_23().g4d(255, 235, 205);
    this.b3y_1 = Companion_getInstance_23().g4d(138, 43, 226);
    this.c3y_1 = Companion_getInstance_23().g4d(165, 42, 42);
    this.d3y_1 = Companion_getInstance_23().g4d(222, 184, 135);
    this.e3y_1 = Companion_getInstance_23().g4d(95, 158, 160);
    this.f3y_1 = Companion_getInstance_23().g4d(127, 255, 0);
    this.g3y_1 = Companion_getInstance_23().g4d(210, 105, 30);
    this.h3y_1 = Companion_getInstance_23().g4d(255, 127, 80);
    this.i3y_1 = Companion_getInstance_23().g4d(100, 149, 237);
    this.j3y_1 = Companion_getInstance_23().g4d(255, 248, 220);
    this.k3y_1 = Companion_getInstance_23().g4d(220, 20, 60);
    this.l3y_1 = Companion_getInstance_23().g4d(0, 0, 139);
    this.m3y_1 = Companion_getInstance_23().g4d(0, 255, 255);
    this.n3y_1 = Companion_getInstance_23().g4d(0, 139, 139);
    this.o3y_1 = Companion_getInstance_23().g4d(184, 134, 11);
    this.p3y_1 = Companion_getInstance_23().g4d(169, 169, 169);
    this.q3y_1 = Companion_getInstance_23().g4d(0, 100, 0);
    this.r3y_1 = Companion_getInstance_23().g4d(169, 169, 169);
    this.s3y_1 = Companion_getInstance_23().g4d(189, 183, 107);
    this.t3y_1 = Companion_getInstance_23().g4d(255, 0, 255);
    this.u3y_1 = Companion_getInstance_23().g4d(139, 0, 139);
    this.v3y_1 = Companion_getInstance_23().g4d(85, 107, 47);
    this.w3y_1 = Companion_getInstance_23().g4d(255, 140, 0);
    this.x3y_1 = Companion_getInstance_23().g4d(153, 50, 204);
    this.y3y_1 = Companion_getInstance_23().g4d(139, 0, 0);
    this.z3y_1 = Companion_getInstance_23().g4d(233, 150, 122);
    this.a3z_1 = Companion_getInstance_23().g4d(143, 188, 143);
    this.b3z_1 = Companion_getInstance_23().g4d(72, 61, 139);
    this.c3z_1 = Companion_getInstance_23().g4d(47, 79, 79);
    this.d3z_1 = Companion_getInstance_23().g4d(47, 79, 79);
    this.e3z_1 = Companion_getInstance_23().g4d(0, 206, 209);
    this.f3z_1 = Companion_getInstance_23().g4d(148, 0, 211);
    this.g3z_1 = Companion_getInstance_23().g4d(255, 20, 147);
    this.h3z_1 = Companion_getInstance_23().g4d(0, 191, 255);
    this.i3z_1 = Companion_getInstance_23().g4d(105, 105, 105);
    this.j3z_1 = Companion_getInstance_23().g4d(105, 105, 105);
    this.k3z_1 = Companion_getInstance_23().g4d(30, 144, 255);
    this.l3z_1 = Companion_getInstance_23().g4d(178, 34, 34);
    this.m3z_1 = Companion_getInstance_23().g4d(255, 250, 240);
    this.n3z_1 = Companion_getInstance_23().g4d(34, 139, 34);
    this.o3z_1 = Companion_getInstance_23().g4d(255, 0, 255);
    this.p3z_1 = Companion_getInstance_23().g4d(220, 220, 220);
    this.q3z_1 = Companion_getInstance_23().g4d(248, 248, 255);
    this.r3z_1 = Companion_getInstance_23().g4d(255, 215, 0);
    this.s3z_1 = Companion_getInstance_23().g4d(218, 165, 32);
    this.t3z_1 = Companion_getInstance_23().g4d(173, 255, 47);
    this.u3z_1 = Companion_getInstance_23().g4d(240, 255, 240);
    this.v3z_1 = Companion_getInstance_23().g4d(255, 105, 180);
    this.w3z_1 = Companion_getInstance_23().g4d(205, 92, 92);
    this.x3z_1 = Companion_getInstance_23().g4d(75, 0, 130);
    this.y3z_1 = Companion_getInstance_23().g4d(255, 255, 240);
    this.z3z_1 = Companion_getInstance_23().g4d(240, 230, 140);
    this.a40_1 = Companion_getInstance_23().g4d(230, 230, 250);
    this.b40_1 = Companion_getInstance_23().g4d(255, 240, 245);
    this.c40_1 = Companion_getInstance_23().g4d(124, 252, 0);
    this.d40_1 = Companion_getInstance_23().g4d(255, 250, 205);
    this.e40_1 = Companion_getInstance_23().g4d(173, 216, 230);
    this.f40_1 = Companion_getInstance_23().g4d(240, 128, 128);
    this.g40_1 = Companion_getInstance_23().g4d(224, 255, 255);
    this.h40_1 = Companion_getInstance_23().g4d(250, 250, 210);
    this.i40_1 = Companion_getInstance_23().g4d(211, 211, 211);
    this.j40_1 = Companion_getInstance_23().g4d(144, 238, 144);
    this.k40_1 = Companion_getInstance_23().g4d(211, 211, 211);
    this.l40_1 = Companion_getInstance_23().g4d(255, 182, 193);
    this.m40_1 = Companion_getInstance_23().g4d(255, 160, 122);
    this.n40_1 = Companion_getInstance_23().g4d(32, 178, 170);
    this.o40_1 = Companion_getInstance_23().g4d(135, 206, 250);
    this.p40_1 = Companion_getInstance_23().g4d(119, 136, 153);
    this.q40_1 = Companion_getInstance_23().g4d(119, 136, 153);
    this.r40_1 = Companion_getInstance_23().g4d(176, 196, 222);
    this.s40_1 = Companion_getInstance_23().g4d(255, 255, 224);
    this.t40_1 = Companion_getInstance_23().g4d(0, 255, 0);
    this.u40_1 = Companion_getInstance_23().g4d(50, 205, 50);
    this.v40_1 = Companion_getInstance_23().g4d(250, 240, 230);
    this.w40_1 = Companion_getInstance_23().g4d(128, 0, 0);
    this.x40_1 = Companion_getInstance_23().g4d(102, 205, 170);
    this.y40_1 = Companion_getInstance_23().g4d(0, 0, 205);
    this.z40_1 = Companion_getInstance_23().g4d(186, 85, 211);
    this.a41_1 = Companion_getInstance_23().g4d(147, 112, 219);
    this.b41_1 = Companion_getInstance_23().g4d(60, 179, 113);
    this.c41_1 = Companion_getInstance_23().g4d(123, 104, 238);
    this.d41_1 = Companion_getInstance_23().g4d(0, 250, 154);
    this.e41_1 = Companion_getInstance_23().g4d(72, 209, 204);
    this.f41_1 = Companion_getInstance_23().g4d(199, 21, 133);
    this.g41_1 = Companion_getInstance_23().g4d(25, 25, 112);
    this.h41_1 = Companion_getInstance_23().g4d(245, 255, 250);
    this.i41_1 = Companion_getInstance_23().g4d(255, 228, 225);
    this.j41_1 = Companion_getInstance_23().g4d(255, 228, 181);
    this.k41_1 = Companion_getInstance_23().g4d(255, 222, 173);
    this.l41_1 = Companion_getInstance_23().g4d(0, 0, 128);
    this.m41_1 = Companion_getInstance_23().g4d(253, 245, 230);
    this.n41_1 = Companion_getInstance_23().g4d(128, 128, 0);
    this.o41_1 = Companion_getInstance_23().g4d(107, 142, 35);
    this.p41_1 = Companion_getInstance_23().g4d(255, 165, 0);
    this.q41_1 = Companion_getInstance_23().g4d(255, 69, 0);
    this.r41_1 = Companion_getInstance_23().g4d(218, 112, 214);
    this.s41_1 = Companion_getInstance_23().g4d(238, 232, 170);
    this.t41_1 = Companion_getInstance_23().g4d(152, 251, 152);
    this.u41_1 = Companion_getInstance_23().g4d(175, 238, 238);
    this.v41_1 = Companion_getInstance_23().g4d(219, 112, 147);
    this.w41_1 = Companion_getInstance_23().g4d(255, 239, 213);
    this.x41_1 = Companion_getInstance_23().g4d(255, 218, 185);
    this.y41_1 = Companion_getInstance_23().g4d(205, 133, 63);
    this.z41_1 = Companion_getInstance_23().g4d(255, 192, 203);
    this.a42_1 = Companion_getInstance_23().g4d(221, 160, 221);
    this.b42_1 = Companion_getInstance_23().g4d(176, 224, 230);
    this.c42_1 = Companion_getInstance_23().g4d(128, 0, 128);
    this.d42_1 = Companion_getInstance_23().g4d(188, 143, 143);
    this.e42_1 = Companion_getInstance_23().g4d(65, 105, 225);
    this.f42_1 = Companion_getInstance_23().g4d(139, 69, 19);
    this.g42_1 = Companion_getInstance_23().g4d(250, 128, 114);
    this.h42_1 = Companion_getInstance_23().g4d(244, 164, 96);
    this.i42_1 = Companion_getInstance_23().g4d(46, 139, 87);
    this.j42_1 = Companion_getInstance_23().g4d(255, 245, 238);
    this.k42_1 = Companion_getInstance_23().g4d(160, 82, 45);
    this.l42_1 = Companion_getInstance_23().g4d(192, 192, 192);
    this.m42_1 = Companion_getInstance_23().g4d(135, 206, 235);
    this.n42_1 = Companion_getInstance_23().g4d(106, 90, 205);
    this.o42_1 = Companion_getInstance_23().g4d(112, 128, 144);
    this.p42_1 = Companion_getInstance_23().g4d(112, 128, 144);
    this.q42_1 = Companion_getInstance_23().g4d(255, 250, 250);
    this.r42_1 = Companion_getInstance_23().g4d(0, 255, 127);
    this.s42_1 = Companion_getInstance_23().g4d(70, 130, 180);
    this.t42_1 = Companion_getInstance_23().g4d(210, 180, 140);
    this.u42_1 = Companion_getInstance_23().g4d(0, 128, 128);
    this.v42_1 = Companion_getInstance_23().g4d(216, 191, 216);
    this.w42_1 = Companion_getInstance_23().g4d(255, 99, 71);
    this.x42_1 = Companion_getInstance_23().g4d(64, 224, 208);
    this.y42_1 = Companion_getInstance_23().g4d(238, 130, 238);
    this.z42_1 = Companion_getInstance_23().g4d(245, 222, 179);
    this.a43_1 = Companion_getInstance_23().g4d(245, 245, 245);
    this.b43_1 = Companion_getInstance_23().g4d(154, 205, 50);
    this.c43_1 = Companion_getInstance_23().g4d(255, 255, 0);
    this.d43_1 = mapOf([to('black', new RGBA(this.n3x_1)), to('white', new RGBA(this.m3x_1)), to('red', new RGBA(this.o3x_1)), to('green', new RGBA(this.p3x_1)), to('blue', new RGBA(this.q3x_1)), to('aliceblue', new RGBA(this.t3x_1)), to('antiquewhite', new RGBA(this.u3x_1)), to('aqua', new RGBA(this.v3x_1)), to('aquamarine', new RGBA(this.w3x_1)), to('azure', new RGBA(this.x3x_1)), to('beige', new RGBA(this.y3x_1)), to('bisque', new RGBA(this.z3x_1)), to('blanchedalmond', new RGBA(this.a3y_1)), to('blueviolet', new RGBA(this.b3y_1)), to('brown', new RGBA(this.c3y_1)), to('burlywood', new RGBA(this.d3y_1)), to('cadetblue', new RGBA(this.e3y_1)), to('chartreuse', new RGBA(this.f3y_1)), to('chocolate', new RGBA(this.g3y_1)), to('coral', new RGBA(this.h3y_1)), to('cornflowerblue', new RGBA(this.i3y_1)), to('cornsilk', new RGBA(this.j3y_1)), to('crimson', new RGBA(this.k3y_1)), to('cyan', new RGBA(this.m3y_1)), to('darkblue', new RGBA(this.l3y_1)), to('darkcyan', new RGBA(this.n3y_1)), to('darkgoldenrod', new RGBA(this.o3y_1)), to('darkgray', new RGBA(this.p3y_1)), to('darkgreen', new RGBA(this.q3y_1)), to('darkgrey', new RGBA(this.r3y_1)), to('darkkhaki', new RGBA(this.s3y_1)), to('darkmagenta', new RGBA(this.u3y_1)), to('darkolivegreen', new RGBA(this.v3y_1)), to('darkorange', new RGBA(this.w3y_1)), to('darkorchid', new RGBA(this.x3y_1)), to('darkred', new RGBA(this.y3y_1)), to('darksalmon', new RGBA(this.z3y_1)), to('darkseagreen', new RGBA(this.a3z_1)), to('darkslateblue', new RGBA(this.b3z_1)), to('darkslategray', new RGBA(this.c3z_1)), to('darkslategrey', new RGBA(this.d3z_1)), to('darkturquoise', new RGBA(this.e3z_1)), to('darkviolet', new RGBA(this.f3z_1)), to('deeppink', new RGBA(this.g3z_1)), to('deepskyblue', new RGBA(this.h3z_1)), to('dimgray', new RGBA(this.i3z_1)), to('dimgrey', new RGBA(this.j3z_1)), to('dodgerblue', new RGBA(this.k3z_1)), to('firebrick', new RGBA(this.l3z_1)), to('floralwhite', new RGBA(this.m3z_1)), to('forestgreen', new RGBA(this.n3z_1)), to('fuchsia', new RGBA(this.o3z_1)), to('gainsboro', new RGBA(this.p3z_1)), to('ghostwhite', new RGBA(this.q3z_1)), to('gold', new RGBA(this.r3z_1)), to('goldenrod', new RGBA(this.s3z_1)), to('greenyellow', new RGBA(this.t3z_1)), to('honeydew', new RGBA(this.u3z_1)), to('hotpink', new RGBA(this.v3z_1)), to('indianred', new RGBA(this.w3z_1)), to('indigo', new RGBA(this.x3z_1)), to('ivory', new RGBA(this.y3z_1)), to('khaki', new RGBA(this.z3z_1)), to('lavender', new RGBA(this.a40_1)), to('lavenderblush', new RGBA(this.b40_1)), to('lawngreen', new RGBA(this.c40_1)), to('lemonchiffon', new RGBA(this.d40_1)), to('lightblue', new RGBA(this.e40_1)), to('lightcoral', new RGBA(this.f40_1)), to('lightcyan', new RGBA(this.g40_1)), to('lightgoldenrodyellow', new RGBA(this.h40_1)), to('lightgray', new RGBA(this.i40_1)), to('lightgreen', new RGBA(this.j40_1)), to('lightgrey', new RGBA(this.k40_1)), to('lightpink', new RGBA(this.l40_1)), to('lightsalmon', new RGBA(this.m40_1)), to('lightseagreen', new RGBA(this.n40_1)), to('lightskyblue', new RGBA(this.o40_1)), to('lightslategray', new RGBA(this.p40_1)), to('lightslategrey', new RGBA(this.q40_1)), to('lightsteelblue', new RGBA(this.r40_1)), to('lightyellow', new RGBA(this.s40_1)), to('lime', new RGBA(this.t40_1)), to('limegreen', new RGBA(this.u40_1)), to('linen', new RGBA(this.v40_1)), to('magenta', new RGBA(this.t3y_1)), to('maroon', new RGBA(this.w40_1)), to('mediumaquamarine', new RGBA(this.x40_1)), to('mediumblue', new RGBA(this.y40_1)), to('mediumorchid', new RGBA(this.z40_1)), to('mediumpurple', new RGBA(this.a41_1)), to('mediumseagreen', new RGBA(this.b41_1)), to('mediumslateblue', new RGBA(this.c41_1)), to('mediumspringgreen', new RGBA(this.d41_1)), to('mediumturquoise', new RGBA(this.e41_1)), to('mediumvioletred', new RGBA(this.f41_1)), to('midnightblue', new RGBA(this.g41_1)), to('mintcream', new RGBA(this.h41_1)), to('mistyrose', new RGBA(this.i41_1)), to('moccasin', new RGBA(this.j41_1)), to('navajowhite', new RGBA(this.k41_1)), to('navy', new RGBA(this.l41_1)), to('oldlace', new RGBA(this.m41_1)), to('olive', new RGBA(this.n41_1)), to('olivedrab', new RGBA(this.o41_1)), to('orange', new RGBA(this.p41_1)), to('orangered', new RGBA(this.q41_1)), to('orchid', new RGBA(this.r41_1)), to('palegoldenrod', new RGBA(this.s41_1)), to('palegreen', new RGBA(this.t41_1)), to('paleturquoise', new RGBA(this.u41_1)), to('palevioletred', new RGBA(this.v41_1)), to('papayawhip', new RGBA(this.w41_1)), to('peachpuff', new RGBA(this.x41_1)), to('peru', new RGBA(this.y41_1)), to('pink', new RGBA(this.z41_1)), to('plum', new RGBA(this.a42_1)), to('powderblue', new RGBA(this.b42_1)), to('purple', new RGBA(this.c42_1)), to('rosybrown', new RGBA(this.d42_1)), to('royalblue', new RGBA(this.e42_1)), to('saddlebrown', new RGBA(this.f42_1)), to('salmon', new RGBA(this.g42_1)), to('sandybrown', new RGBA(this.h42_1)), to('seagreen', new RGBA(this.i42_1)), to('seashell', new RGBA(this.j42_1)), to('sienna', new RGBA(this.k42_1)), to('silver', new RGBA(this.l42_1)), to('skyblue', new RGBA(this.m42_1)), to('slateblue', new RGBA(this.n42_1)), to('slategray', new RGBA(this.o42_1)), to('slategrey', new RGBA(this.p42_1)), to('snow', new RGBA(this.q42_1)), to('springgreen', new RGBA(this.r42_1)), to('steelblue', new RGBA(this.s42_1)), to('tan', new RGBA(this.t42_1)), to('teal', new RGBA(this.u42_1)), to('thistle', new RGBA(this.v42_1)), to('tomato', new RGBA(this.w42_1)), to('turquoise', new RGBA(this.x42_1)), to('violet', new RGBA(this.y42_1)), to('wheat', new RGBA(this.z42_1)), to('whitesmoke', new RGBA(this.a43_1)), to('yellowgreen', new RGBA(this.b43_1)), to('yellow', new RGBA(this.c43_1))]);
  }
  e4d(str) {
    return this.h4d(str, this.r3x_1, true);
  }
  h4d(str, default_0, errorOnDefault) {
    try {
      if (startsWith(str, '#')) {
        var hex = substr(str, 1);
        if (!setOf([3, 4, 6, 8]).k1(hex.length))
          return this.n3x_1;
        var chars = hex.length < 6 ? 1 : 2;
        var scale = hex.length < 6 ? 255.0 / 15.0 : 1.0;
        var hasAlpha = (hex.length / chars | 0) >= 4;
        var r = numberToInt(toInt(substr_0(hex, imul(0, chars), chars), 16) * scale);
        var g = numberToInt(toInt(substr_0(hex, imul(1, chars), chars), 16) * scale);
        var b = numberToInt(toInt(substr_0(hex, imul(2, chars), chars), 16) * scale);
        var a = hasAlpha ? numberToInt(toInt(substr_0(hex, imul(3, chars), chars), 16) * scale) : 255;
        return Companion_getInstance_23().w4b(r, g, b, a);
      } else if (startsWith(str, 'RGBA(', true)) {
        // Inline function 'kotlin.text.toUpperCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = str.toUpperCase();
        var parts = split(removeSuffix(removePrefix(tmp$ret$1, 'RGBA('), ')'), [',']);
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        if (0 <= 0 ? 0 < parts.d1() : false) {
          tmp = parts.f1(0);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp = '0';
        }
        var tmp$ret$3 = tmp;
        var tmp0_elvis_lhs = toIntOrNull(tmp$ret$3);
        var r_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0;
        if (0 <= 1 ? 1 < parts.d1() : false) {
          tmp_0 = parts.f1(1);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_0 = '0';
        }
        var tmp$ret$5 = tmp_0;
        var tmp1_elvis_lhs = toIntOrNull(tmp$ret$5);
        var g_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_1;
        if (0 <= 2 ? 2 < parts.d1() : false) {
          tmp_1 = parts.f1(2);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_1 = '0';
        }
        var tmp$ret$7 = tmp_1;
        var tmp2_elvis_lhs = toIntOrNull(tmp$ret$7);
        var b_0 = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_2;
        if (0 <= 3 ? 3 < parts.d1() : false) {
          tmp_2 = parts.f1(3);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_2 = '1.0';
        }
        var tmp$ret$9 = tmp_2;
        var tmp3_elvis_lhs = toDoubleOrNull(tmp$ret$9);
        var af = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
        return Companion_getInstance_23().w4b(r_0, g_0, b_0, numberToInt(af * 255));
      } else {
        // Inline function 'kotlin.text.toLowerCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$11 = str.toLowerCase();
        var tmp_3 = this.d43_1.d3(tmp$ret$11);
        var col = tmp_3 == null ? null : tmp_3.i4d_1;
        var tmp_4;
        var tmp_5 = col;
        if ((tmp_5 == null ? null : new RGBA(tmp_5)) == null) {
          tmp_4 = errorOnDefault;
        } else {
          tmp_4 = false;
        }
        if (tmp_4)
          return this.f4d('#' + str, default_0);
        var tmp_6;
        var tmp_7 = col;
        if ((tmp_7 == null ? null : new RGBA(tmp_7)) == null) {
          tmp_6 = default_0;
        } else {
          tmp_6 = col;
        }
        return tmp_6;
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        return Colors_getInstance().o3x_1;
      } else {
        throw $p;
      }
    }
  }
  f4d(str, default_0, errorOnDefault, $super) {
    errorOnDefault = errorOnDefault === VOID ? false : errorOnDefault;
    return $super === VOID ? this.h4d(str, default_0, errorOnDefault) : $super.h4d.call(this, str, new RGBA(default_0), errorOnDefault).i4d_1;
  }
}
class RGB extends ColorFormat24 {
  constructor(rOffset, gOffset, bOffset) {
    Companion_getInstance_21();
    super();
    this.k4d_1 = rOffset;
    this.l4d_1 = gOffset;
    this.m4d_1 = bOffset;
  }
  h4c(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.k4d_1 | 0) & 255;
  }
  i4c(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.l4d_1 | 0) & 255;
  }
  j4c(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.m4d_1 | 0) & 255;
  }
  k4c(v) {
    return 255;
  }
}
class Companion_4 extends RGB {
  constructor() {
    Companion_instance_13 = null;
    super(0, 8, 16);
    Companion_instance_13 = this;
  }
}
class Companion_5 {
  n47(size) {
    return _RgbaArray___init__impl__oib4y4(new Int32Array(size));
  }
}
class RgbaArray {
  constructor(ints) {
    this.n4d_1 = ints;
  }
  w2(fromIndex, toIndex) {
    return RgbaArray__subList_impl_rbyi98(this.n4d_1, fromIndex, toIndex);
  }
  o4d(element) {
    return RgbaArray__contains_impl_ofn00n(this.n4d_1, element);
  }
  k1(element) {
    return RgbaArray__contains_impl_ofn00n_0(this, element);
  }
  p4d(elements) {
    return RgbaArray__containsAll_impl_l6gz5c(this.n4d_1, elements);
  }
  t2(elements) {
    return RgbaArray__containsAll_impl_l6gz5c_0(this, elements);
  }
  g1() {
    return RgbaArray__isEmpty_impl_nch3ip(this.n4d_1);
  }
  a1() {
    return RgbaArray__iterator_impl_5wfwsm(this.n4d_1);
  }
  u2() {
    return RgbaArray__listIterator_impl_m4kjt0(this.n4d_1);
  }
  v2(index) {
    return RgbaArray__listIterator_impl_m4kjt0_0(this.n4d_1, index);
  }
  d1() {
    return _RgbaArray___get_size__impl__imxef8(this.n4d_1);
  }
  q4d(index) {
    return RgbaArray__get_impl_nzyo1o(this.n4d_1, index);
  }
  f1(index) {
    return RgbaArray__get_impl_nzyo1o_0(this, index);
  }
  toString() {
    return RgbaArray__toString_impl_vgvk04(this.n4d_1);
  }
  hashCode() {
    return RgbaArray__hashCode_impl_ht2l65(this.n4d_1);
  }
  equals(other) {
    return RgbaArray__equals_impl_6qvuf(this.n4d_1, other);
  }
}
class Companion_6 extends ColorFormat32 {
  constructor() {
    Companion_instance_15 = null;
    super();
    Companion_instance_15 = this;
    this.f43_1 = 0;
    this.g43_1 = 8;
    this.h43_1 = 16;
    this.i43_1 = 24;
  }
  a49(r, g, b, a) {
    return this.r4d(f2i(r), f2i(g), f2i(b), f2i(a));
  }
  r4d(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntUnchecked(r, g, b, a));
  }
  w4b(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, a));
  }
  g4d(r, g, b) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, 255));
  }
  s4d(rgb, a) {
    return _RGBA___init__impl__lqpay5(rgb & 16777215 | a << 24);
  }
  t4d(rgba) {
    return rgba;
  }
  h4c(v) {
    return _RGBA___get_r__impl__duz7mo(_RGBA___init__impl__lqpay5(v));
  }
  i4c(v) {
    return _RGBA___get_g__impl__o8pukr(_RGBA___init__impl__lqpay5(v));
  }
  j4c(v) {
    return _RGBA___get_b__impl__m6tl80(_RGBA___init__impl__lqpay5(v));
  }
  k4c(v) {
    return _RGBA___get_a__impl__6msvu7(_RGBA___init__impl__lqpay5(v));
  }
  u4d(c1, c2, factor256) {
    return _RGBA___init__impl__lqpay5(this.v4d(_RGBA___get_value__impl__hhco8v(c1), _RGBA___get_value__impl__hhco8v(c2), factor256));
  }
  v4d(c1, c2, factor256) {
    var ifactor256 = 256 - factor256 | 0;
    return ((imul(c1 & 16711935, ifactor256) + imul(c2 & 16711935, factor256) | 0) & -16711936 | (imul(c1 & 65280, ifactor256) + imul(c2 & 65280, factor256) | 0) & 16711680) >>> 8 | 0;
  }
  w4d(c1, c2, factor) {
    // Inline function 'kotlin.math.roundToInt' call
    var this_0 = Ratio__toFloat_impl_1ftup5(factor) * 256;
    var tmp$ret$0 = roundToInt(this_0);
    return this.u4d(c1, c2, tmp$ret$0);
  }
  x4d(c1, c2, factor) {
    return Companion_getInstance_23().s4d(_RGBA___get_rgb__impl__tijaqt(this.w4d(c1, c2, factor)), blendComponent(this, _RGBA___get_a__impl__6msvu7(c1), _RGBA___get_a__impl__6msvu7(c2), factor));
  }
  j43(c00, c10, c01, c11, factorX, factorY) {
    var c1 = this.x4d(c00, c10, factorX);
    var c2 = this.x4d(c01, c11, factorX);
    return this.x4d(c1, c2, factorY);
  }
  v4b(dst, src) {
    var srcA = _RGBA___get_a__impl__6msvu7(src);
    var iSrcA = 255 - srcA | 0;
    switch (srcA) {
      case 0:
        return dst;
      case 255:
        return src;
      default:
        return Companion_getInstance_23().s4d(_RGBA___get_rgb__impl__tijaqt(this.u4d(dst, src, srcA + 1 | 0)), clampUByte(srcA + (imul(_RGBA___get_a__impl__6msvu7(dst), iSrcA) / 255 | 0) | 0));
    }
  }
  y4d(src, dst, ratio) {
    return Companion_getInstance_23().w4b(interpolate_0(ratio, _RGBA___get_r__impl__duz7mo(src), _RGBA___get_r__impl__duz7mo(dst)), interpolate_0(ratio, _RGBA___get_g__impl__o8pukr(src), _RGBA___get_g__impl__o8pukr(dst)), interpolate_0(ratio, _RGBA___get_b__impl__m6tl80(src), _RGBA___get_b__impl__m6tl80(dst)), interpolate_0(ratio, _RGBA___get_a__impl__6msvu7(src), _RGBA___get_a__impl__6msvu7(dst)));
  }
}
class RGBA {
  constructor(value) {
    Companion_getInstance_23();
    this.i4d_1 = value;
  }
  u1i() {
    return RGBA__clone_impl_w007z0(this.i4d_1);
  }
  toString() {
    return RGBA__toString_impl_4lw6dp(this.i4d_1);
  }
  z4d(other) {
    return RGBA__compareTo_impl_lrfjc1(this.i4d_1, other);
  }
  d(other) {
    return RGBA__compareTo_impl_lrfjc1_0(this, other);
  }
  hashCode() {
    return RGBA__hashCode_impl_h59qf6(this.i4d_1);
  }
  equals(other) {
    return RGBA__equals_impl_4vjmca(this.i4d_1, other);
  }
}
class Companion_7 {
  constructor() {
    this.a4e_1 = 16711935;
    this.b4e_1 = -16711936;
  }
  c4e(dst, src) {
    return _RGBAPremultiplied___init__impl__uos02x(sumPacked4MulR(_RGBAPremultiplied___get_value__impl__bqfhud(src), _RGBAPremultiplied___get_value__impl__bqfhud(dst), 256 - _RGBAPremultiplied___get_a__impl__f0hnd1(src) | 0));
  }
}
class Companion_8 {
  d4e(size) {
    return _RgbaPremultipliedArray___init__impl__lx83hy(new Int32Array(size));
  }
}
class RgbaPremultipliedArray {
  constructor(ints) {
    this.e4e_1 = ints;
  }
  toString() {
    return RgbaPremultipliedArray__toString_impl_seal6e(this.e4e_1);
  }
  hashCode() {
    return RgbaPremultipliedArray__hashCode_impl_kvnjzv(this.e4e_1);
  }
  equals(other) {
    return RgbaPremultipliedArray__equals_impl_vav5d5(this.e4e_1, other);
  }
}
class Companion_9 {
  f4e(f, s) {
    return insert(insert(0, f, 0, 16), s, 16, 16);
  }
}
class Companion_10 {}
class Kerning {
  constructor(first, second, amount) {
    this.o4e_1 = first;
    this.p4e_1 = second;
    this.q4e_1 = amount;
  }
}
class Glyph {
  constructor(fontSize, id, texture, xoffset, yoffset, xadvance) {
    this.g4e_1 = fontSize;
    this.h4e_1 = id;
    this.i4e_1 = texture;
    this.j4e_1 = xoffset;
    this.k4e_1 = yoffset;
    this.l4e_1 = xadvance;
    var tmp = this;
    tmp.m4e_1 = lazy(BitmapFont$Glyph$bmp$delegate$lambda(this));
    this.n4e_1 = new GlyphMetrics(this.g4e_1, true, -1, Companion_getInstance_4().m2e(this.j4e_1, this.k4e_1, this.i4e_1.s3g_1, this.i4e_1.t3g_1), this.l4e_1);
  }
  r4e() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m4e_1;
    bmp$factory();
    return this_0.o1();
  }
  toString() {
    return 'Glyph(fontSize=' + this.g4e_1 + ', id=' + this.h4e_1 + ', texture=' + this.i4e_1.toString() + ', xoffset=' + this.j4e_1 + ', yoffset=' + this.k4e_1 + ', xadvance=' + this.l4e_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.g4e_1);
    result = imul(result, 31) + this.h4e_1 | 0;
    result = imul(result, 31) + this.i4e_1.hashCode() | 0;
    result = imul(result, 31) + this.j4e_1 | 0;
    result = imul(result, 31) + this.k4e_1 | 0;
    result = imul(result, 31) + this.l4e_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Glyph))
      return false;
    var tmp0_other_with_cast = other instanceof Glyph ? other : THROW_CCE();
    if (!equals(this.g4e_1, tmp0_other_with_cast.g4e_1))
      return false;
    if (!(this.h4e_1 === tmp0_other_with_cast.h4e_1))
      return false;
    if (!this.i4e_1.equals(tmp0_other_with_cast.i4e_1))
      return false;
    if (!(this.j4e_1 === tmp0_other_with_cast.j4e_1))
      return false;
    if (!(this.k4e_1 === tmp0_other_with_cast.k4e_1))
      return false;
    if (!(this.l4e_1 === tmp0_other_with_cast.l4e_1))
      return false;
    return true;
  }
}
class Font {}
function getOrNull_2() {
  return this;
}
function getFontMetrics$default(size, metrics, $super) {
  metrics = metrics === VOID ? new FontMetrics() : metrics;
  return $super === VOID ? this.b4f(size, metrics) : $super.b4f.call(this, size, metrics);
}
function getGlyphMetrics$default(size, codePoint, metrics, reader, $super) {
  metrics = metrics === VOID ? new GlyphMetrics() : metrics;
  reader = reader === VOID ? null : reader;
  return $super === VOID ? this.n4f(size, codePoint, metrics, reader) : $super.n4f.call(this, size, codePoint, metrics, reader);
}
function renderGlyph$default(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw, $super) {
  reader = reader === VOID ? null : reader;
  beforeDraw = beforeDraw === VOID ? null : beforeDraw;
  return $super === VOID ? this.y4f(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) : $super.y4f.call(this, ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw);
}
class BitmapFont {}
function get_baseBmp() {
  return get_bmp(this.y4e().i4e_1);
}
function getFontMetrics(size, metrics) {
  return metrics.l4f(this.z4e(), size);
}
function getGlyphMetrics(size, codePoint, metrics, reader) {
  var tmp38_safe_receiver = this.o4f(codePoint);
  var tmp0_elvis_lhs = tmp38_safe_receiver == null ? null : tmp38_safe_receiver.n4e_1;
  return metrics.u4f(tmp0_elvis_lhs == null ? this.a4f() : tmp0_elvis_lhs, size, codePoint);
}
function getTextScale(size) {
  return size / this.s4e();
}
function get_0(charCode) {
  var tmp0_elvis_lhs = this.o4f(charCode);
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.o4f(32) : tmp0_elvis_lhs;
  return tmp1_elvis_lhs == null ? this.y4e() : tmp1_elvis_lhs;
}
function renderGlyph(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
  var scale = this.x4f(size);
  var tmp0_elvis_lhs = this.v4e().f1(codePoint);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var g = tmp;
  // Inline function 'kotlin.takeIf' call
  var this_0 = this.n4f(size, codePoint, metrics, reader);
  // Inline function 'kotlin.contracts.contract' call
  var tmp_0;
  // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
  if (this_0.q4f_1) {
    tmp_0 = this_0;
  } else {
    tmp_0 = null;
  }
  if (tmp_0 == null)
    return false;
  if (metrics.w2i() === 0.0 && metrics.x2i() === 0.0)
    return false;
  var texX = pos.c26_1 + metrics.t26();
  var texY = pos.d26_1 + metrics.v26();
  var swidth = metrics.w2i();
  var sheight = metrics.x2i();
  var tmp_1;
  if (equals(ctx.v4g(), new RGBA(get_DefaultPaint()))) {
    tmp_1 = g.r4e();
  } else {
    // Inline function 'korlibs.image.bitmap.context2d' call
    var this_1 = Bitmap32.y3v(g.r4e().f3w_1, g.r4e().g3w_1, VOID, true);
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_1.j3w_1;
    if (true) {
      this_1.s3w();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx_0 = this_1.b44(true);
      try {
        // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
        // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
        var t = ctx_0.g44_1.z4f_1;
        try {
          // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>.<anonymous>' call
          ctx_0.u4g(1.0 / scale);
          ctx_0.w4g(ctx.v4g());
          // Inline function 'korlibs.image.vector.Context2d.fillRect' call
          var width = ctx_0.w2i() * scale;
          var height = ctx_0.x2i() * scale;
          ctx_0.x4g(numberToDouble(0), numberToDouble(0), numberToDouble(width), numberToDouble(height));
        }finally {
          ctx_0.g44_1.z4f_1 = t;
        }
      }finally {
        ctx_0.ov();
      }
    }finally {
      result = true ? this_1.u3w(rect) : 0;
    }
    var bmpFill = this_1;
    bmpFill.h46(BitmapChannel_ALPHA_getInstance(), g.r4e(), BitmapChannel_ALPHA_getInstance());
    tmp_1 = bmpFill;
  }
  var bmp = tmp_1;
  if (beforeDraw == null)
    null;
  else
    beforeDraw();
  ctx.y4g(bmp, Vector2D.l28(texX, texY - metrics.w26()), Size2D.s2e(swidth, sheight));
  return true;
}
function getKerning(size, leftCodePoint, rightCodePoint) {
  var tmp = this.x4f(size);
  var tmp40_safe_receiver = this.w4f(leftCodePoint, rightCodePoint);
  var tmp41_safe_receiver = tmp40_safe_receiver == null ? null : tmp40_safe_receiver.q4e_1;
  var tmp0_elvis_lhs = tmp41_safe_receiver == null ? null : tmp41_safe_receiver;
  return tmp * (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
}
class BitmapFontImpl {
  constructor(fontSize, lineHeight, base, glyphs, kernings, name, distanceField) {
    name = name === VOID ? 'BitmapFont' : name;
    distanceField = distanceField === VOID ? null : distanceField;
    this.b4h_1 = new Mixin();
    this.c4h_1 = fontSize;
    this.d4h_1 = lineHeight;
    this.e4h_1 = base;
    this.f4h_1 = glyphs;
    this.g4h_1 = kernings;
    this.h4h_1 = name;
    this.i4h_1 = distanceField;
    this.j4h_1 = this.d4h_1 - this.e4h_1;
    var tmp = this;
    tmp.k4h_1 = lazy(BitmapFontImpl$naturalFontMetrics$delegate$lambda(this));
    this.l4h_1 = new GlyphMetrics(this.c4h_1, false, 0, Companion_getInstance_4().q29(), 0.0);
    var tmp_0 = this;
    tmp_0.m4h_1 = lazy(BitmapFontImpl$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.n4h_1 = lazy(BitmapFontImpl$invalidGlyph$delegate$lambda(this));
  }
  y1i(_set____db54di) {
    this.b4h_1.y1i(_set____db54di);
  }
  z1i() {
    return this.b4h_1.z1i();
  }
  s4e() {
    return this.c4h_1;
  }
  t4e() {
    return this.d4h_1;
  }
  s3h() {
    return this.e4h_1;
  }
  v4e() {
    return this.f4h_1;
  }
  w4e() {
    return this.g4h_1;
  }
  l3() {
    return this.h4h_1;
  }
  u4e() {
    return this.i4h_1;
  }
  c1k() {
    return this;
  }
  z4e() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.k4h_1;
    naturalFontMetrics$factory();
    return this_0.o1();
  }
  a4f() {
    return this.l4h_1;
  }
  w4f(first, second) {
    return this.g4h_1.f1(Companion_instance_18.f4e(first, second));
  }
  o4f(codePoint) {
    return this.f4h_1.f1(codePoint);
  }
  y4e() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m4h_1;
    anyGlyph$factory();
    return this_0.o1();
  }
  o4h() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n4h_1;
    invalidGlyph$factory();
    return this_0.o1();
  }
}
class TextToBitmapResult {
  constructor(bmp, fmetrics, metrics, glyphs, glyphsPerLine, shape) {
    shape = shape === VOID ? null : shape;
    this.e4k_1 = bmp;
    this.f4k_1 = fmetrics;
    this.g4k_1 = metrics;
    this.h4k_1 = glyphs;
    this.i4k_1 = glyphsPerLine;
    this.j4k_1 = shape;
  }
  toString() {
    return 'TextToBitmapResult(bmp=' + toString_0(this.e4k_1) + ', fmetrics=' + this.f4k_1.toString() + ', metrics=' + this.g4k_1.toString() + ', glyphs=' + toString_0(this.h4k_1) + ', glyphsPerLine=' + toString_0(this.i4k_1) + ', shape=' + toString(this.j4k_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.e4k_1);
    result = imul(result, 31) + this.f4k_1.hashCode() | 0;
    result = imul(result, 31) + this.g4k_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.h4k_1) | 0;
    result = imul(result, 31) + hashCode(this.i4k_1) | 0;
    result = imul(result, 31) + (this.j4k_1 == null ? 0 : hashCode(this.j4k_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextToBitmapResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextToBitmapResult ? other : THROW_CCE();
    if (!equals(this.e4k_1, tmp0_other_with_cast.e4k_1))
      return false;
    if (!this.f4k_1.equals(tmp0_other_with_cast.f4k_1))
      return false;
    if (!this.g4k_1.equals(tmp0_other_with_cast.g4k_1))
      return false;
    if (!equals(this.h4k_1, tmp0_other_with_cast.h4k_1))
      return false;
    if (!equals(this.i4k_1, tmp0_other_with_cast.i4k_1))
      return false;
    if (!equals(this.j4k_1, tmp0_other_with_cast.j4k_1))
      return false;
    return true;
  }
}
class PlacedGlyphMetrics {
  constructor(codePoint, pos, metrics, fontMetrics, transform, index, nline) {
    this.v4k_1 = codePoint;
    this.w4k_1 = pos;
    this.x4k_1 = metrics;
    this.y4k_1 = fontMetrics;
    this.z4k_1 = transform;
    this.a4l_1 = index;
    this.b4l_1 = nline;
    var tmp = this;
    tmp.c4l_1 = lazy(PlacedGlyphMetrics$boundsPath$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.d4l_1 = lazy(PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.e4l_1 = lazy(PlacedGlyphMetrics$caretStart$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.f4l_1 = lazy(PlacedGlyphMetrics$caretEnd$delegate$lambda(this));
  }
  g4l() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c4l_1;
    boundsPath$factory();
    return this_0.o1();
  }
  h4l() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d4l_1;
    boundsPathCurves$factory();
    return this_0.o1();
  }
  toString() {
    return 'PlacedGlyphMetrics(codePoint=' + this.v4k_1 + ', pos=' + this.w4k_1.toString() + ', metrics=' + this.x4k_1.toString() + ', fontMetrics=' + this.y4k_1.toString() + ', transform=' + this.z4k_1.toString() + ', index=' + this.a4l_1 + ', nline=' + this.b4l_1 + ')';
  }
  hashCode() {
    var result = this.v4k_1;
    result = imul(result, 31) + this.w4k_1.hashCode() | 0;
    result = imul(result, 31) + this.x4k_1.hashCode() | 0;
    result = imul(result, 31) + this.y4k_1.hashCode() | 0;
    result = imul(result, 31) + this.z4k_1.hashCode() | 0;
    result = imul(result, 31) + this.a4l_1 | 0;
    result = imul(result, 31) + this.b4l_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlacedGlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof PlacedGlyphMetrics ? other : THROW_CCE();
    if (!(this.v4k_1 === tmp0_other_with_cast.v4k_1))
      return false;
    if (!this.w4k_1.equals(tmp0_other_with_cast.w4k_1))
      return false;
    if (!this.x4k_1.equals(tmp0_other_with_cast.x4k_1))
      return false;
    if (!this.y4k_1.equals(tmp0_other_with_cast.y4k_1))
      return false;
    if (!this.z4k_1.equals(tmp0_other_with_cast.z4k_1))
      return false;
    if (!(this.a4l_1 === tmp0_other_with_cast.a4l_1))
      return false;
    if (!(this.b4l_1 === tmp0_other_with_cast.b4l_1))
      return false;
    return true;
  }
}
class TextMetricsResult {
  constructor(fmetrics, metrics, glyphs, glyphsPerLine) {
    fmetrics = fmetrics === VOID ? new FontMetrics() : fmetrics;
    metrics = metrics === VOID ? new TextMetrics() : metrics;
    glyphs = glyphs === VOID ? emptyList() : glyphs;
    glyphsPerLine = glyphsPerLine === VOID ? emptyList() : glyphsPerLine;
    this.i4l_1 = fmetrics;
    this.j4l_1 = metrics;
    this.k4l_1 = glyphs;
    this.l4l_1 = glyphsPerLine;
  }
  toString() {
    return 'TextMetricsResult(fmetrics=' + this.i4l_1.toString() + ', metrics=' + this.j4l_1.toString() + ', glyphs=' + toString_0(this.k4l_1) + ', glyphsPerLine=' + toString_0(this.l4l_1) + ')';
  }
  hashCode() {
    var result = this.i4l_1.hashCode();
    result = imul(result, 31) + this.j4l_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.k4l_1) | 0;
    result = imul(result, 31) + hashCode(this.l4l_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetricsResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetricsResult ? other : THROW_CCE();
    if (!this.i4l_1.equals(tmp0_other_with_cast.i4l_1))
      return false;
    if (!this.j4l_1.equals(tmp0_other_with_cast.j4l_1))
      return false;
    if (!equals(this.k4l_1, tmp0_other_with_cast.k4l_1))
      return false;
    if (!equals(this.l4l_1, tmp0_other_with_cast.l4l_1))
      return false;
    return true;
  }
}
class MultiplePlacedGlyphMetrics {
  constructor() {
    this.n4m_1 = FastArrayList.r1j();
    this.o4m_1 = FastArrayList.r1j();
  }
  d1() {
    return this.n4m_1.d1();
  }
  t4n(glyph) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.n4m_1.h(glyph);
    while (this.o4m_1.d1() <= glyph.b4l_1) {
      this.o4m_1.h(FastArrayList.r1j());
    }
    this.o4m_1.f1(glyph.b4l_1).h(glyph);
  }
}
class ITextRendererActions {}
function reset() {
  this.d4q(Companion_getInstance_6().e26_1);
}
function advance(x) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.t1h();
  var that = Vector2D.l28(x, 0.0);
  var tmp$ret$0 = Vector2D.l28(this_0.c26_1 + that.c26_1, this_0.d26_1 + that.d26_1);
  this.d4q(tmp$ret$0);
}
function newLine(y, end) {
  this.d4q(Vector2D.l28(0.0, this.t1h().d26_1 + y));
  var _unary__edvuaz = this.v4p();
  this.b4q(_unary__edvuaz + 1 | 0);
}
class TextRendererActions {
  constructor($box) {
    boxApply(this, $box);
    this.l4p_1 = new GlyphPath();
    this.m4p_1 = new GlyphMetrics();
    this.n4p_1 = new FontMetrics();
    this.o4p_1 = 0;
    this.q4p_1 = 0.0;
    this.r4p_1 = Companion_getInstance_6().e26_1;
    this.s4p_1 = Companion_getInstance_5().n29_1;
    this.t4p_1 = null;
    this.u4p_1 = Colors_getInstance().m3x_1;
  }
  t4e() {
    return this.n4p_1.t4e();
  }
  b4q(_set____db54di) {
    this.o4p_1 = _set____db54di;
  }
  v4p() {
    return this.o4p_1;
  }
  a4q() {
    var tmp = this.p4p_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('font');
    }
  }
  c4q(font, size) {
    this.p4p_1 = font;
    this.q4p_1 = size;
    font.b4f(size, this.n4p_1);
  }
  d4q(_set____db54di) {
    this.r4p_1 = _set____db54di;
  }
  t1h() {
    return this.r4p_1;
  }
  e4q(reader, codePoint) {
    return this.a4q().n4f(this.q4p_1, codePoint, this.m4p_1, reader);
  }
  f4q(_set____db54di) {
    this.s4p_1 = _set____db54di;
  }
  y4p() {
    return this.s4p_1;
  }
  w4f(leftCodePoint, rightCodePoint) {
    return this.a4q().a4h(this.q4p_1, leftCodePoint, rightCodePoint);
  }
}
class drawText$actions$1 extends TextRendererActions {
  constructor($renderer, $text, $size, $fnt, $align, $pos, $ctx, $paint, $textRangeStart, $textRangeEnd, $doRender, $glyphs, $placed, $box) {
    if ($box === VOID)
      $box = {};
    $box.a4p_1 = $size;
    $box.b4p_1 = $align;
    $box.c4p_1 = $pos;
    $box.d4p_1 = $ctx;
    $box.e4p_1 = $paint;
    $box.f4p_1 = $textRangeStart;
    $box.g4p_1 = $textRangeEnd;
    $box.h4p_1 = $doRender;
    $box.i4p_1 = $glyphs;
    $box.j4p_1 = $placed;
    super($box);
    this.y4o_1 = measure($renderer, $text, $size, $fnt);
    this.z4o_1 = 0;
  }
  k4p(reader, codePoint) {
    var nline = this.v4p();
    var dx = this.y4o_1.w4p(this.b4p_1.k4n_1, nline);
    var dy = this.y4o_1.n4n(this.b4p_1.l4n_1, this.n4p_1);
    var px = this.t1h().c26_1 + this.c4p_1.c26_1 - dx;
    var py = this.t1h().d26_1 + this.c4p_1.d26_1 + dy;
    var tmp71_safe_receiver = this.d4p_1;
    if (tmp71_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
      var t = tmp71_safe_receiver.g44_1.z4f_1;
      try {
        // Inline function 'korlibs.image.font.<no name provided>.put.<anonymous>' call
        this.d4p_1.x4p(px, py);
        this.d4p_1.z4p(get_immutable(this.y4p()));
        var tmp0_elvis_lhs = this.t4p_1;
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.e4p_1 : tmp0_elvis_lhs;
        this.d4p_1.w4g(tmp1_elvis_lhs == null ? NonePaint_instance : tmp1_elvis_lhs);
        var containsLower = this.f4p_1;
        var containsUpper = this.g4p_1;
        var containsArg = this.z4o_1;
        if (containsLower <= containsArg ? containsArg < containsUpper : false) {
          this.a4q().y4f(this.d4p_1, this.a4p_1, codePoint, Companion_getInstance_6().e26_1, null, this.m4p_1, reader, this.h4p_1);
        }
        this.z4o_1 = this.z4o_1 + 1 | 0;
      }finally {
        tmp71_safe_receiver.g44_1.z4f_1 = t;
      }
    }
    if (!(this.i4p_1 == null)) {
      var glyph = new PlacedGlyphMetrics(codePoint, Vector2D.l28(px, py), this.m4p_1.u1i(), this.n4p_1.u1i(), this.y4p(), this.i4p_1.d1(), nline);
      this.i4p_1.t4n(glyph);
    }
    var tmp72_safe_receiver = this.j4p_1;
    if (tmp72_safe_receiver == null)
      null;
    else
      tmp72_safe_receiver(this, codePoint, Vector2D.l28(px, py), this.a4p_1, this.m4p_1, this.n4p_1, this.y4p());
    return this.m4p_1;
  }
}
class GlyphPath {
  constructor(path, colorShape, bitmap, bitmapOffset, bitmapScale, transform, scale) {
    path = path === VOID ? new VectorPath() : path;
    colorShape = colorShape === VOID ? null : colorShape;
    bitmap = bitmap === VOID ? null : bitmap;
    bitmapOffset = bitmapOffset === VOID ? Vector2D.y28(0, 0) : bitmapOffset;
    bitmapScale = bitmapScale === VOID ? Scale.i2g(1, 1) : bitmapScale;
    transform = transform === VOID ? Companion_getInstance_5().q29() : transform;
    scale = scale === VOID ? 1.0 : scale;
    this.i4q_1 = path;
    this.j4q_1 = colorShape;
    this.k4q_1 = bitmap;
    this.l4q_1 = bitmapOffset;
    this.m4q_1 = bitmapScale;
    this.n4q_1 = transform;
    this.o4q_1 = scale;
  }
  p4q() {
    return this.k4q_1 == null && this.j4q_1 == null;
  }
  q4q(c) {
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = c.g44_1.z4f_1;
    try {
      // Inline function 'korlibs.image.font.GlyphPath.draw.<anonymous>' call
      c.z4p(this.n4q_1);
      if (!(this.k4q_1 == null)) {
        c.y4g(ensureNotNull(this.k4q_1), this.l4q_1, toFloat(ensureNotNull(this.k4q_1).d1()).w2g(this.m4q_1));
      } else if (!(this.j4q_1 == null)) {
        c.r4q(ensureNotNull(this.j4q_1));
        c.m4m();
      } else {
        draw_1(c, this.i4q_1);
      }
    }finally {
      c.g44_1.z4f_1 = t;
    }
  }
  toString() {
    return 'GlyphPath(path=' + this.i4q_1.toString() + ', colorShape=' + toString(this.j4q_1) + ', bitmap=' + toString(this.k4q_1) + ', bitmapOffset=' + this.l4q_1.toString() + ', bitmapScale=' + this.m4q_1.toString() + ', transform=' + this.n4q_1.toString() + ', scale=' + this.o4q_1 + ')';
  }
  hashCode() {
    var result = this.i4q_1.hashCode();
    result = imul(result, 31) + (this.j4q_1 == null ? 0 : hashCode(this.j4q_1)) | 0;
    result = imul(result, 31) + (this.k4q_1 == null ? 0 : hashCode(this.k4q_1)) | 0;
    result = imul(result, 31) + this.l4q_1.hashCode() | 0;
    result = imul(result, 31) + this.m4q_1.hashCode() | 0;
    result = imul(result, 31) + this.n4q_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.o4q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath ? other : THROW_CCE();
    if (!this.i4q_1.equals(tmp0_other_with_cast.i4q_1))
      return false;
    if (!equals(this.j4q_1, tmp0_other_with_cast.j4q_1))
      return false;
    if (!equals(this.k4q_1, tmp0_other_with_cast.k4q_1))
      return false;
    if (!this.l4q_1.equals(tmp0_other_with_cast.l4q_1))
      return false;
    if (!this.m4q_1.equals(tmp0_other_with_cast.m4q_1))
      return false;
    if (!this.n4q_1.equals(tmp0_other_with_cast.n4q_1))
      return false;
    if (!equals(this.o4q_1, tmp0_other_with_cast.o4q_1))
      return false;
    return true;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_20 = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(32);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    tmp.s4q_1 = new Int32Array([tmp$ret$0]);
  }
}
class LazyBitmapFont {
  constructor(font, fontSize, distanceField) {
    Companion_getInstance_28();
    distanceField = distanceField === VOID ? null : distanceField;
    this.t4q_1 = new Mixin();
    this.u4q_1 = font;
    this.v4q_1 = fontSize;
    this.w4q_1 = distanceField;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = MutableAtlas.b3w(1024, 1024, 2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.LazyBitmapFont.atlas.<anonymous>' call
    if (!(this.w4q_1 == null))
      this_0.d3v_1;
    else
      mipmaps(this_0.d3v_1);
    tmp.x4q_1 = this_0;
    this.y4q_1 = this.u4q_1.m4f(this.v4q_1);
    this.z4q_1 = this.y4q_1.t4e();
    this.a4r_1 = this.y4q_1.f4f_1;
    this.b4r_1 = IntMap.f2o();
    this.c4r_1 = IntMap.f2o();
    var tmp_0 = this;
    tmp_0.d4r_1 = lazy(LazyBitmapFont$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.e4r_1 = lazy(LazyBitmapFont$invalidGlyph$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.f4r_1 = lazy(LazyBitmapFont$naturalFontMetrics$delegate$lambda(this));
    this.g4r_1 = new GlyphMetrics(this.v4q_1, false, 0, Companion_getInstance_4().q29(), 0.0);
  }
  y1i(_set____db54di) {
    this.t4q_1.y1i(_set____db54di);
  }
  z1i() {
    return this.t4q_1.z1i();
  }
  s4e() {
    return this.v4q_1;
  }
  u4e() {
    return this.w4q_1;
  }
  t4e() {
    return this.z4q_1;
  }
  s3h() {
    return this.a4r_1;
  }
  v4e() {
    return this.b4r_1;
  }
  w4e() {
    return this.c4r_1;
  }
  y4e() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d4r_1;
    anyGlyph$factory_0();
    return this_0.o1();
  }
  o4h() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.e4r_1;
    invalidGlyph$factory_0();
    return this_0.o1();
  }
  l3() {
    return this.u4q_1.l3();
  }
  z4e() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f4r_1;
    naturalFontMetrics$factory_0();
    return this_0.o1();
  }
  a4f() {
    return this.g4r_1;
  }
  w4f(first, second) {
    var kerning = this.u4q_1.a4h(this.v4q_1, first, second);
    var tmp;
    if (kerning === 0.0) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var this_0 = this.c4r_1;
      var key = Companion_instance_18.f4e(first, second);
      var res = this_0.f1(key);
      if (res == null) {
        // Inline function 'korlibs.image.font.LazyBitmapFont.getKerning.<anonymous>' call
        var tmp$ret$0 = new Kerning(first, second, numberToInt(kerning));
        this_0.z2n(key, tmp$ret$0);
      }
      tmp = ensureNotNull(this_0.f1(key));
    }
    return tmp;
  }
  o4f(codePoint) {
    if (this.b4r_1.f1(codePoint) == null) {
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(97);
      var tmp = Char__toInt_impl_vasixd(this_0);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(122);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      this.h4r(codePoint, numberRangeToNumber(tmp, tmp$ret$1));
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(65);
      var tmp_0 = Char__toInt_impl_vasixd(this_2);
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(90);
      var tmp$ret$3 = Char__toInt_impl_vasixd(this_3);
      this.h4r(codePoint, numberRangeToNumber(tmp_0, tmp$ret$3));
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(48);
      var tmp_1 = Char__toInt_impl_vasixd(this_4);
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(57);
      var tmp$ret$5 = Char__toInt_impl_vasixd(this_5);
      this.h4r(codePoint, numberRangeToNumber(tmp_1, tmp$ret$5));
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$6 = new Int32Array([codePoint]);
      this.i4r(tmp$ret$6);
    }
    return this.b4r_1.f1(codePoint);
  }
  h4r(codePoint, range) {
    var containsLower = range.y1_1;
    if (codePoint <= range.z1_1 ? containsLower <= codePoint : false) {
      // Inline function 'korlibs.datastructure.toIntList' call
      // Inline function 'kotlin.also' call
      var this_0 = IntArrayList.x2j(coerceAtLeast(range.b2() - range.c2() | 0, 0));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.toIntList.<anonymous>' call
      var inductionVariable = range.c2();
      var last = range.b2();
      if (inductionVariable <= last)
        do {
          var v = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.d2k(v);
        }
         while (!(v === last));
      this.i4r(this_0.o2k());
    }
  }
  i4r(codePoints) {
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var this_0 = this.x4q_1.d3v_1;
    var rect = this_0.j3w_1;
    if (true) {
      this_0.s3w();
    }
    var result;
    try {
      // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>' call
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < codePoints.length) {
        // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var codePoint = codePoints[_unary__edvuaz];
        // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
        var this_1 = this.b4r_1;
        var res = this_1.f1(codePoint);
        if (res == null) {
          // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>.<anonymous>' call
          var tmp;
          if (!(this.w4q_1 == null)) {
            // Inline function 'kotlin.math.max' call
            var b = toIntCeil_0(this.v4q_1 / 8.0);
            tmp = Math.max(4, b);
          } else {
            tmp = 1;
          }
          var border = tmp;
          var tmp83_$receiver = this.u4q_1;
          var tmp84_size = this.v4q_1;
          var tmp85_paint = Colors_getInstance().m3x_1;
          var result_0 = renderGlyphToBitmap(tmp83_$receiver, tmp84_size, codePoint, new RGBA(tmp85_paint), true, null, border);
          var bmp = result_0.e4k_1.r3w();
          var rbmp;
          switch (this.w4q_1) {
            case 'msdf':
              rbmp = msdfBmp(ensureNotNull(result_0.j4k_1).j4r(), bmp.f3w_1, bmp.g3w_1);
              break;
            case 'sdf':
              rbmp = sdfBmp(ensureNotNull(result_0.j4k_1).j4r(), bmp.f3w_1, bmp.g3w_1);
              break;
            default:
              rbmp = bmp;
              break;
          }
          var entry = this.x4q_1.d3w(rbmp, Unit_instance);
          var slice = entry.v3u_1.y3h(border, border, entry.v3u_1.s3g_1 - border | 0, entry.v3u_1.t3g_1 - border | 0);
          var g = first_0(result_0.h4k_1);
          var m = g.x4k_1;
          var xadvance = m.t4f_1;
          var tmp$ret$1 = new Glyph(this.v4q_1, codePoint, slice, -toIntRound(g.w4k_1.c26_1) | 0, -toIntRound(g.w4k_1.d26_1) | 0, toIntRound(xadvance));
          this_1.z2n(codePoint, tmp$ret$1);
        }
        ensureNotNull(this_1.f1(codePoint));
      }
    }finally {
      result = true ? this_0.u3w(rect) : 0;
    }
  }
}
class FontMetrics {
  constructor(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    size = size === VOID ? 0.0 : size;
    top = top === VOID ? 0.0 : top;
    ascent = ascent === VOID ? 0.0 : ascent;
    baseline = baseline === VOID ? 0.0 : baseline;
    descent = descent === VOID ? 0.0 : descent;
    bottom = bottom === VOID ? 0.0 : bottom;
    lineGap = lineGap === VOID ? 0.0 : lineGap;
    maxWidth = maxWidth === VOID ? 0.0 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? 0.0 : unitsPerEm;
    this.c4f_1 = size;
    this.d4f_1 = top;
    this.e4f_1 = ascent;
    this.f4f_1 = baseline;
    this.g4f_1 = descent;
    this.h4f_1 = bottom;
    this.i4f_1 = lineGap;
    this.j4f_1 = maxWidth;
    this.k4f_1 = unitsPerEm;
  }
  k4r() {
    // Inline function 'kotlin.math.max' call
    var a = this.e4f_1;
    var b = this.d4f_1;
    return Math.max(a, b);
  }
  l4r() {
    // Inline function 'kotlin.math.min' call
    var a = this.g4f_1;
    var b = this.h4f_1;
    return Math.min(a, b);
  }
  m4r() {
    return this.k4r() - this.l4r();
  }
  t4e() {
    return this.m4r() + this.i4f_1;
  }
  t4m(other) {
    return this.n4r(other, 1.0);
  }
  l4f(other, size) {
    return this.n4r(other, size / other.c4f_1);
  }
  n4r(other, scale) {
    this.c4f_1 = other.c4f_1 * scale;
    this.d4f_1 = other.d4f_1 * scale;
    this.e4f_1 = other.e4f_1 * scale;
    this.f4f_1 = other.f4f_1 * scale;
    this.g4f_1 = other.g4f_1 * scale;
    this.h4f_1 = other.h4f_1 * scale;
    this.i4f_1 = other.i4f_1 * scale;
    this.k4f_1 = other.k4f_1 * scale;
    this.j4f_1 = other.j4f_1 * scale;
    return this;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.FontMetrics.toString.<anonymous>' call
    this_0.nb('FontMetrics(');
    this_0.nb('size=' + niceStr(this.c4f_1, 1) + ', ');
    this_0.nb('top=' + niceStr(this.d4f_1, 1) + ', ');
    this_0.nb('ascent=' + niceStr(this.e4f_1, 1) + ', ');
    this_0.nb('baseline=' + niceStr(this.f4f_1, 1) + ', ');
    this_0.nb('descent=' + niceStr(this.g4f_1, 1) + ', ');
    this_0.nb('bottom=' + niceStr(this.h4f_1, 1) + ', ');
    this_0.nb('lineGap=' + niceStr(this.i4f_1, 1) + ', ');
    this_0.nb('unitsPerEm=' + niceStr(this.k4f_1, 1) + ', ');
    this_0.nb('maxWidth=' + niceStr(this.j4f_1, 1) + ', ');
    this_0.nb('lineHeight=' + niceStr(this.t4e(), 1));
    this_0.nb(')');
    return this_0.toString();
  }
  u1i() {
    return this.o4r();
  }
  p4r(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    return new FontMetrics(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  }
  o4r(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm, $super) {
    size = size === VOID ? this.c4f_1 : size;
    top = top === VOID ? this.d4f_1 : top;
    ascent = ascent === VOID ? this.e4f_1 : ascent;
    baseline = baseline === VOID ? this.f4f_1 : baseline;
    descent = descent === VOID ? this.g4f_1 : descent;
    bottom = bottom === VOID ? this.h4f_1 : bottom;
    lineGap = lineGap === VOID ? this.i4f_1 : lineGap;
    maxWidth = maxWidth === VOID ? this.j4f_1 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? this.k4f_1 : unitsPerEm;
    return $super === VOID ? this.p4r(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) : $super.p4r.call(this, size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  }
  hashCode() {
    var result = getNumberHashCode(this.c4f_1);
    result = imul(result, 31) + getNumberHashCode(this.d4f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e4f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.f4f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.g4f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.h4f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i4f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j4f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k4f_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FontMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof FontMetrics ? other : THROW_CCE();
    if (!equals(this.c4f_1, tmp0_other_with_cast.c4f_1))
      return false;
    if (!equals(this.d4f_1, tmp0_other_with_cast.d4f_1))
      return false;
    if (!equals(this.e4f_1, tmp0_other_with_cast.e4f_1))
      return false;
    if (!equals(this.f4f_1, tmp0_other_with_cast.f4f_1))
      return false;
    if (!equals(this.g4f_1, tmp0_other_with_cast.g4f_1))
      return false;
    if (!equals(this.h4f_1, tmp0_other_with_cast.h4f_1))
      return false;
    if (!equals(this.i4f_1, tmp0_other_with_cast.i4f_1))
      return false;
    if (!equals(this.j4f_1, tmp0_other_with_cast.j4f_1))
      return false;
    if (!equals(this.k4f_1, tmp0_other_with_cast.k4f_1))
      return false;
    return true;
  }
}
class GlyphMetrics {
  constructor(size, existing, codePoint, bounds, xadvance) {
    size = size === VOID ? 0.0 : size;
    existing = existing === VOID ? false : existing;
    codePoint = codePoint === VOID ? 0 : codePoint;
    bounds = bounds === VOID ? Companion_getInstance_4().q29() : bounds;
    xadvance = xadvance === VOID ? 0.0 : xadvance;
    this.p4f_1 = size;
    this.q4f_1 = existing;
    this.r4f_1 = codePoint;
    this.s4f_1 = bounds;
    this.t4f_1 = xadvance;
  }
  w26() {
    return this.s4f_1.w26();
  }
  t26() {
    return this.s4f_1.t26();
  }
  v26() {
    return this.s4f_1.v26();
  }
  w2i() {
    return this.s4f_1.o26_1;
  }
  x2i() {
    return this.s4f_1.p26_1;
  }
  u1i() {
    return this.q4r(VOID, VOID, VOID, this.s4f_1.u1i());
  }
  u4f(other, size, codePoint) {
    return this.r4r(other, size / other.p4f_1, codePoint);
  }
  r4r(other, scale, codePoint) {
    this.p4f_1 = other.p4f_1;
    this.q4f_1 = other.q4f_1;
    this.r4f_1 = codePoint;
    this.s4f_1 = other.s4f_1.v2e(scale);
    this.t4f_1 = other.t4f_1 * scale;
    return this;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.GlyphMetrics.toString.<anonymous>' call
    this_0.nb('GlyphMetrics(');
    this_0.nb('codePoint=' + this.r4f_1 + " ('" + toString_1(numberToChar(this.r4f_1)) + "'), ");
    this_0.nb('existing=' + this.q4f_1 + ', ');
    this_0.nb('xadvance=' + roundToInt(this.t4f_1) + ', ');
    this_0.nb('bounds=' + this.s4f_1.f2().toString());
    this_0.nb(')');
    return this_0.toString();
  }
  s4r(size, existing, codePoint, bounds, xadvance) {
    return new GlyphMetrics(size, existing, codePoint, bounds, xadvance);
  }
  q4r(size, existing, codePoint, bounds, xadvance, $super) {
    size = size === VOID ? this.p4f_1 : size;
    existing = existing === VOID ? this.q4f_1 : existing;
    codePoint = codePoint === VOID ? this.r4f_1 : codePoint;
    bounds = bounds === VOID ? this.s4f_1 : bounds;
    xadvance = xadvance === VOID ? this.t4f_1 : xadvance;
    return $super === VOID ? this.s4r(size, existing, codePoint, bounds, xadvance) : $super.s4r.call(this, size, existing, codePoint, bounds, xadvance);
  }
  hashCode() {
    var result = getNumberHashCode(this.p4f_1);
    result = imul(result, 31) + getBooleanHashCode(this.q4f_1) | 0;
    result = imul(result, 31) + this.r4f_1 | 0;
    result = imul(result, 31) + this.s4f_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.t4f_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphMetrics ? other : THROW_CCE();
    if (!equals(this.p4f_1, tmp0_other_with_cast.p4f_1))
      return false;
    if (!(this.q4f_1 === tmp0_other_with_cast.q4f_1))
      return false;
    if (!(this.r4f_1 === tmp0_other_with_cast.r4f_1))
      return false;
    if (!this.s4f_1.equals(tmp0_other_with_cast.s4f_1))
      return false;
    if (!equals(this.t4f_1, tmp0_other_with_cast.t4f_1))
      return false;
    return true;
  }
}
class TextMetrics {
  constructor(bounds, lineBounds, fontMetrics, nlines) {
    bounds = bounds === VOID ? Companion_getInstance_4().q29() : bounds;
    lineBounds = lineBounds === VOID ? emptyList() : lineBounds;
    fontMetrics = fontMetrics === VOID ? new FontMetrics() : fontMetrics;
    nlines = nlines === VOID ? 0 : nlines;
    this.p4m_1 = bounds;
    this.q4m_1 = lineBounds;
    this.r4m_1 = fontMetrics;
    this.s4m_1 = nlines;
  }
  t4r() {
    var tmp0_elvis_lhs = firstOrNull_0(this.q4m_1);
    return tmp0_elvis_lhs == null ? Companion_getInstance_4().y26_1 : tmp0_elvis_lhs;
  }
  t26() {
    return this.p4m_1.t26();
  }
  v26() {
    return this.p4m_1.v26();
  }
  w2i() {
    return this.p4m_1.o26_1;
  }
  x2i() {
    return this.p4m_1.p26_1;
  }
  u4r() {
    return -this.t26();
  }
  v4r() {
    return this.t4r().p26_1 + this.t4r().v26();
  }
  s4n() {
    return this.r4m_1.e4f_1;
  }
  toString() {
    return 'TextMetrics[' + get_niceStr_0(this.t26()) + ', ' + get_niceStr_0(this.v26()) + ', ' + get_niceStr_0(this.w2i()) + ', ' + get_niceStr_0(this.x2i()) + '][' + get_niceStr_0(this.u4r()) + ', ' + get_niceStr_0(this.v4r()) + ']';
  }
  hashCode() {
    var result = this.p4m_1.hashCode();
    result = imul(result, 31) + hashCode(this.q4m_1) | 0;
    result = imul(result, 31) + this.r4m_1.hashCode() | 0;
    result = imul(result, 31) + this.s4m_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetrics ? other : THROW_CCE();
    if (!this.p4m_1.equals(tmp0_other_with_cast.p4m_1))
      return false;
    if (!equals(this.q4m_1, tmp0_other_with_cast.q4m_1))
      return false;
    if (!this.r4m_1.equals(tmp0_other_with_cast.r4m_1))
      return false;
    if (!(this.s4m_1 === tmp0_other_with_cast.s4m_1))
      return false;
    return true;
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_21 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_0();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.bc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.VALUES_BY_ID.<anonymous>' call
      var tmp$ret$0 = element.y4r_1;
      destination.f3(tmp$ret$0, element);
    }
    tmp.z4r_1 = toIntMap(destination);
  }
  f1(id) {
    return this.z4r_1.f1(id);
  }
}
class GlyphPath_0 {
  constructor(path, advanceWidth) {
    this.a4s_1 = path;
    this.b4s_1 = advanceWidth;
  }
  toString() {
    return 'GlyphPath(path=' + this.a4s_1.toString() + ', advanceWidth=' + this.b4s_1 + ')';
  }
  hashCode() {
    var result = this.a4s_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.b4s_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath_0))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath_0 ? other : THROW_CCE();
    if (!this.a4s_1.equals(tmp0_other_with_cast.a4s_1))
      return false;
    if (!equals(this.b4s_1, tmp0_other_with_cast.b4s_1))
      return false;
    return true;
  }
}
class CFFResult {
  constructor(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict) {
    this.c4s_1 = charstringsIndex;
    this.d4s_1 = globalSubrIndex;
    this.e4s_1 = localSubrsIndex;
    this.f4s_1 = privateDict;
    var tmp = this;
    var tmp90_safe_receiver = this.f4s_1.d3(Op_defaultWidthX_getInstance());
    var tmp91_safe_receiver = tmp90_safe_receiver == null ? null : firstOrNull_0(tmp90_safe_receiver);
    var tmp0_elvis_lhs = tmp91_safe_receiver == null ? null : numberToDouble(tmp91_safe_receiver);
    tmp.g4s_1 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    var tmp_0 = this;
    var tmp92_safe_receiver = this.f4s_1.d3(Op_nominalWidthX_getInstance());
    var tmp93_safe_receiver = tmp92_safe_receiver == null ? null : firstOrNull_0(tmp92_safe_receiver);
    var tmp0_elvis_lhs_0 = tmp93_safe_receiver == null ? null : numberToDouble(tmp93_safe_receiver);
    tmp_0.h4s_1 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
  }
  i4s(index, flipY) {
    var evalCtx = new EvalContext(this.d4s_1, this.e4s_1, this.g4s_1, this.h4s_1, index);
    var vp = new VectorPath();
    var bytes = this.c4s_1.f1(index);
    CharStringType2_instance.l4s(vp, openFastStream(bytes), evalCtx);
    if (flipY) {
      vp.q3o(1.0, -1.0);
    }
    return new GlyphPath_0(vp, evalCtx.v4s_1);
  }
  x4s(index, flipY, $super) {
    flipY = flipY === VOID ? true : flipY;
    return $super === VOID ? this.i4s(index, flipY) : $super.i4s.call(this, index, flipY);
  }
}
class DataIndex {
  static y4s(offsets, bytes) {
    var $this = createThis(this);
    $this.j4s_1 = offsets;
    $this.k4s_1 = bytes;
    return $this;
  }
  static z4s() {
    // Inline function 'kotlin.intArrayOf' call
    var tmp = new Int32Array([0]);
    // Inline function 'kotlin.byteArrayOf' call
    var tmp$ret$1 = new Int8Array([]);
    return this.y4s(tmp, tmp$ret$1);
  }
  d1() {
    return this.j4s_1.length - 1 | 0;
  }
  a4t(index) {
    return this.j4s_1[index + 1 | 0] - this.j4s_1[index] | 0;
  }
  f1(index) {
    return copyOfRange(this.k4s_1, this.j4s_1[index], this.j4s_1[index + 1 | 0]);
  }
  b4t() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.d1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.y1_1;
    var last = this_0.z1_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.DataIndex.toList.<anonymous>' call
        var it = item;
        var tmp$ret$0 = this.f1(it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return destination;
  }
  a1() {
    return this.b4t().a1();
  }
  toString() {
    var tmp = this.d1();
    var tmp_0 = toString_0(toList_0(this.j4s_1));
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.d1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.y1_1;
    var last = this_0.z1_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.DataIndex.toString.<anonymous>' call
        var it = item;
        var tmp$ret$0 = this.a4t(it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return 'DataIndex[' + tmp + '](' + tmp_0 + ')(' + toString_0(destination) + ')';
  }
}
class Op extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.y4r_1 = id;
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_22 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_1();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.bc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.MAP.<anonymous>' call
      var tmp$ret$0 = element.e4t_1;
      destination.f3(tmp$ret$0, element);
    }
    tmp.f4t_1 = toIntMap(destination);
  }
  f1(id) {
    var tmp0_elvis_lhs = this.f4t_1.f1(id);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'Unknown CFF CS2 operator ' + id;
      throw IllegalStateException.s4(toString_0(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
}
class EvalContext {
  constructor(globalSubrIndex, localSubrsIndex, defaultWidthX, nominalWidthX, index, heap) {
    globalSubrIndex = globalSubrIndex === VOID ? DataIndex.z4s() : globalSubrIndex;
    localSubrsIndex = localSubrsIndex === VOID ? DataIndex.z4s() : localSubrsIndex;
    defaultWidthX = defaultWidthX === VOID ? 0.0 : defaultWidthX;
    nominalWidthX = nominalWidthX === VOID ? 0.0 : nominalWidthX;
    index = index === VOID ? -1 : index;
    heap = heap === VOID ? new Float64Array(32) : heap;
    this.m4s_1 = globalSubrIndex;
    this.n4s_1 = localSubrsIndex;
    this.o4s_1 = defaultWidthX;
    this.p4s_1 = nominalWidthX;
    this.q4s_1 = index;
    this.r4s_1 = heap;
    this.s4s_1 = computeSubrBias(CharStringType2_instance, this.m4s_1.d1());
    this.t4s_1 = computeSubrBias(CharStringType2_instance, this.n4s_1.d1());
    this.u4s_1 = 0;
    this.v4s_1 = this.o4s_1;
    this.w4s_1 = false;
  }
}
class Op_0 extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.e4t_1 = id;
  }
}
class CFF {
  g4t(_this__u8e3s4) {
    this.h4t(_this__u8e3s4);
    var nameIndex = this.i4t(_this__u8e3s4);
    var topDictIndex = this.i4t(_this__u8e3s4);
    var topDictByte = topDictIndex.f1(0)[1];
    var topDict = this.j4t(openFastStream(topDictIndex.f1(0)));
    var stringIndex = this.i4t(_this__u8e3s4);
    var globalSubrIndex = this.i4t(_this__u8e3s4);
    var privateSizeOffset = topDict.d3(Op_Private_getInstance());
    var localSubrsIndex = DataIndex.z4s();
    var privateDict = emptyMap();
    if (!(privateSizeOffset == null)) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(privateSizeOffset, 10));
      var tmp0_iterator = privateSizeOffset.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.image.font.CFF.readCFF.<anonymous>' call
        var tmp$ret$0 = numberToInt(item);
        destination.h(tmp$ret$0);
      }
      // Inline function 'kotlin.collections.component1' call
      var privateSize = destination.f1(0);
      // Inline function 'kotlin.collections.component2' call
      var privateOffset = destination.f1(1);
      privateDict = this.j4t(_this__u8e3s4.w1q(privateOffset, privateSize));
      var localSubrs = privateDict.d3(Op_Subrs_getInstance());
      if (!(localSubrs == null)) {
        var subrsOffset = privateOffset + numberToInt(last(localSubrs)) | 0;
        localSubrsIndex = this.i4t(_this__u8e3s4.x1q(subrsOffset));
      }
    }
    var charstringsOffsets = topDict.d3(Op_CharStrings_getInstance());
    var charstringsOffset = numberToInt(first_0(ensureNotNull(charstringsOffsets)));
    var charstringsIndex = this.i4t(_this__u8e3s4.x1q(charstringsOffset));
    return new CFFResult(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict);
  }
  h4t(_this__u8e3s4) {
    var versionMajor = _this__u8e3s4.c1r();
    var versionMinor = _this__u8e3s4.c1r();
    var headerSize = _this__u8e3s4.c1r();
    var offsetSize = _this__u8e3s4.c1r();
    if (versionMajor > 1) {
      // Inline function 'kotlin.error' call
      var message = 'Only supported CFF version 1';
      throw IllegalStateException.s4(toString_0(message));
    }
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = TtfCIDFont_getInstance().k4t_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.k2t(level)) {
      // Inline function 'korlibs.image.font.CFF.readHeader.<anonymous>' call
      var tmp$ret$0 = 'CFF.versionMajor/Minor: ' + versionMajor + '.' + versionMinor + ' : headerSize=' + headerSize + ', offsetSize=' + offsetSize;
      this_0.l2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
  l4t(_this__u8e3s4) {
    return _this__u8e3s4.c1r();
  }
  m4t(_this__u8e3s4, offSize) {
    var roffSize = offSize < 0 ? this.l4t(_this__u8e3s4) : offSize;
    var tmp;
    switch (roffSize) {
      case 1:
        tmp = _this__u8e3s4.c1r();
        break;
      case 2:
        tmp = _this__u8e3s4.e1r();
        break;
      case 3:
        tmp = _this__u8e3s4.f1r();
        break;
      case 4:
        tmp = _this__u8e3s4.g1r();
        break;
      default:
        reserved('' + roffSize);
        break;
    }
    return tmp;
  }
  i4t(_this__u8e3s4) {
    var count = _this__u8e3s4.e1r();
    if (count === 0)
      return DataIndex.z4s();
    var offSize = this.l4t(_this__u8e3s4);
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_0 = until(0, count + 1 | 0);
    // Inline function 'kotlin.also' call
    var this_1 = IntArrayList.x2j((coerceAtLeast(this_0.b2() - this_0.c2() | 0, 0) / this_0.a2_1 | 0) + 1 | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var nestedFirst = this_0.c2();
    var nestedLast = this_0.b2();
    var stepArg = this_0.a2_1;
    if (stepArg <= 0)
      THROW_IAE('Step must be positive, was: ' + stepArg + '.');
    var inductionVariable = nestedFirst;
    var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
    if (inductionVariable <= last)
      do {
        var v = inductionVariable;
        inductionVariable = inductionVariable + stepArg | 0;
        // Inline function 'korlibs.image.font.CFF.readIndex.<anonymous>' call
        var tmp$ret$0 = CFF_instance.m4t(_this__u8e3s4, offSize) - 1 | 0;
        this_1.d2k(tmp$ret$0);
      }
       while (!(v === last));
    var offsets = this_1;
    var bytes = _this__u8e3s4.a1r(offsets.k2k());
    return DataIndex.y4s(offsets.o2k(), bytes);
  }
  j4t(_this__u8e3s4) {
    var map = LinkedHashMap.ac();
    // Inline function 'kotlin.collections.arrayListOf' call
    var values = ArrayList.i1();
    while (_this__u8e3s4.s1g()) {
      var item = this.n4t(_this__u8e3s4);
      if (item instanceof Op) {
        // Inline function 'kotlin.collections.set' call
        var value = toList(values);
        map.f3(item, value);
        values.y2();
      } else {
        if (isNumber(item)) {
          values.h(item);
        }
      }
    }
    return map;
  }
  n4t(_this__u8e3s4) {
    var b0 = _this__u8e3s4.c1r();
    var tmp;
    if (0 <= b0 ? b0 <= 21 : false) {
      var tmp_0 = Companion_getInstance_29();
      tmp = tmp_0.f1(b0 === 12 ? b0 << 8 | _this__u8e3s4.c1r() : b0);
    } else if (22 <= b0 ? b0 <= 27 : false) {
      get_reserved();
    } else if (b0 === 28) {
      tmp = toShort(_this__u8e3s4.c1r() << 8 | _this__u8e3s4.c1r());
    } else if (b0 === 29) {
      tmp = _this__u8e3s4.c1r() << 24 | _this__u8e3s4.c1r() << 16 | _this__u8e3s4.c1r() << 8 | _this__u8e3s4.c1r();
    } else if (b0 === 30) {
      tmp = this.o4t(_this__u8e3s4, false);
    } else if (b0 === 31) {
      get_reserved();
    } else if (32 <= b0 ? b0 <= 246 : false) {
      tmp = b0 - 139 | 0;
    } else if (247 <= b0 ? b0 <= 250 : false) {
      tmp = (imul(b0 - 247 | 0, 256) + _this__u8e3s4.c1r() | 0) + 108 | 0;
    } else if (251 <= b0 ? b0 <= 254 : false) {
      tmp = ((-imul(b0 - 251 | 0, 256) | 0) - _this__u8e3s4.c1r() | 0) - 108 | 0;
    } else if (b0 === 255) {
      get_reserved();
    } else {
      get_unreachable();
    }
    return tmp;
  }
  p4t(_this__u8e3s4, readHeader) {
    if (readHeader) {
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(_this__u8e3s4.c1r() === 30)) {
        // Inline function 'kotlin.check.<anonymous>' call
        var message = 'Check failed.';
        throw IllegalStateException.s4(toString_0(message));
      }
    }
    var str = StringBuilder.f();
    end: while (true) {
      var byte = _this__u8e3s4.c1r();
      var inductionVariable = 0;
      if (inductionVariable <= 1)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var nibble = (byte >>> imul(1 - n | 0, 4) | 0) & 15;
          if (nibble === 15)
            break end;
          switch (nibble) {
            case 15:
              break end;
            case 12:
              str.nb('E-');
              break;
            default:
              str.ob((0 <= nibble ? nibble <= 9 : false) ? Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(48), nibble) : nibble === 10 ? _Char___init__impl__6a9atx(46) : nibble === 11 ? _Char___init__impl__6a9atx(69) : nibble === 14 ? _Char___init__impl__6a9atx(45) : _Char___init__impl__6a9atx(48));
              break;
          }
        }
         while (inductionVariable <= 1);
    }
    return str.toString();
  }
  o4t(_this__u8e3s4, readHeader) {
    return toDouble(this.p4t(_this__u8e3s4, readHeader));
  }
}
class CharStringType2 {
  q4t(_this__u8e3s4, value) {
    _this__u8e3s4.d2l(_this__u8e3s4.d1() - 1 | 0, value);
  }
  r4t(_this__u8e3s4) {
    return _this__u8e3s4.f1(_this__u8e3s4.d1() - 1 | 0);
  }
  s4t(_this__u8e3s4) {
    return _this__u8e3s4.a3(_this__u8e3s4.d1() - 1 | 0);
  }
  t4t(_this__u8e3s4, value) {
    _this__u8e3s4.t1k(value);
  }
  u4t(_this__u8e3s4, value) {
    _this__u8e3s4.t1k(value);
  }
  v4t(_this__u8e3s4) {
    var lastPoint = _this__u8e3s4.c3e();
    _this__u8e3s4.y5();
    _this__u8e3s4.b3e(lastPoint);
  }
  w4t(_this__u8e3s4, x, y) {
    _this__u8e3s4.z3n(Vector2D.l28(x, y));
  }
  x4t(_this__u8e3s4, x, y) {
    _this__u8e3s4.a3o(Vector2D.l28(x, y));
  }
  y4t(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay) {
    _this__u8e3s4.g3e(Vector2D.l28(fcx1, fcy1), Vector2D.l28(fcx2, fcy2), Vector2D.l28(fax, fay));
  }
  z4t(_this__u8e3s4, cx1, cy1, cx2, cy2, ax, ay) {
    var fcx1 = _this__u8e3s4.c3e().c26_1 + cx1;
    var fcy1 = _this__u8e3s4.c3e().d26_1 + cy1;
    var fcx2 = fcx1 + cx2;
    var fcy2 = fcy1 + cy2;
    var fax = fcx2 + ax;
    var fay = fcy2 + ay;
    this.y4t(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay);
  }
  a4u(_this__u8e3s4, v, horizontal) {
    return this.w4t(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  }
  b4u(_this__u8e3s4, v, horizontal) {
    return this.x4t(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  }
  c4u(_this__u8e3s4) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CharStringType2.u8.<anonymous>' call
    return _this__u8e3s4.c1r();
  }
  d4u(ctx, s, evalCtx, stack, stackLevel) {
    while (s.s1g()) {
      var v0 = this.c4u(s);
      if ((0 <= v0 ? v0 <= 27 : false) || (29 <= v0 ? v0 <= 31 : false)) {
        var tmp = Companion_getInstance_30();
        var op = tmp.f1(v0 === 12 ? v0 << 8 | this.c4u(s) : v0);
        switch (op.k3_1) {
          case 13:
            return Unit_instance;
          case 16:
            var tmp_0;
            // Inline function 'kotlin.collections.isNotEmpty' call

            if (!stack.g1()) {
              tmp_0 = !evalCtx.w4s_1;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              evalCtx.v4s_1 = stack.f1(0) + evalCtx.p4s_1;
              evalCtx.w4s_1 = true;
            }

            if (!(ctx.m3n() === 0)) {
              this.v4t(ctx);
            }

            return Unit_instance;
          case 11:
          case 40:
            var global = op.equals(Op_callgsubr_getInstance());
            var funcOffset = numberToInt(this.s4t(stack));
            var bytes = global ? evalCtx.m4s_1.f1(evalCtx.s4s_1 + funcOffset | 0) : evalCtx.n4s_1.f1(evalCtx.t4s_1 + funcOffset | 0);
            this.d4u(ctx, openFastStream(bytes), evalCtx, stack, stackLevel + 1 | 0);
            break;
          case 22:
            this.s4t(stack);
            break;
          case 38:
            // Inline function 'kotlin.also' call

            var this_0 = this.s4t(stack);
            // Inline function 'kotlin.contracts.contract' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            stack.w2k(this_0, this_0);
            break;
          case 39:
            stack.m2k(stack.d1() - 2 | 0, stack.d1() - 1 | 0);
            break;
          case 43:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.nd();
          case 41:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.nd();
          case 25:
            var index = this.s4t(stack);
            var value = this.s4t(stack);
            evalCtx.r4s_1[numberToInt(index)] = value;
            break;
          case 27:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var it = this.r4t(stack);
            var tmp$ret$3 = evalCtx.r4s_1[numberToInt(it)];
            this.q4t(stack, tmp$ret$3);
            break;
          case 2:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r = this.s4t(stack);
            var l = this.s4t(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$5 = !(l === 0.0) && !(r === 0.0) ? 1 : 0;
            this.t4t(stack, tmp$ret$5);
            break;
          case 4:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_0 = this.s4t(stack);
            var l_0 = this.s4t(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$7 = !(l_0 === 0.0) || !(r_0 === 0.0) ? 1 : 0;
            this.t4t(stack, tmp$ret$7);
            break;
          case 6:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$9 = this.r4t(stack) === 0.0 ? 1 : 0;
            this.q4t(stack, tmp$ret$9);
            break;
          case 19:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_1 = this.s4t(stack);
            var l_1 = this.s4t(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$11 = l_1 === r_1 ? 1 : 0;
            this.t4t(stack, tmp$ret$11);
            break;
          case 29:
            var v2 = this.s4t(stack);
            var v1 = this.s4t(stack);
            var s2 = this.s4t(stack);
            var s1 = this.s4t(stack);
            this.t4t(stack, v1 <= v2 ? s1 : s2);
            break;
          case 31:
            stack.t1k(Default_getInstance().mo());
            break;
          case 36:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'kotlin.math.sqrt' call

            var x = this.r4t(stack);
            var tmp$ret$13 = Math.sqrt(x);
            this.q4t(stack, tmp$ret$13);
            break;
          case 10:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'kotlin.math.abs' call

            var x_0 = this.r4t(stack);
            var tmp$ret$15 = Math.abs(x_0);
            this.q4t(stack, tmp$ret$15);
            break;
          case 17:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$16 = -this.r4t(stack);
            this.q4t(stack, tmp$ret$16);
            break;
          case 12:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_2 = this.s4t(stack);
            var l_2 = this.s4t(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$17 = l_2 + r_2;
            this.t4t(stack, tmp$ret$17);
            break;
          case 14:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_3 = this.s4t(stack);
            var l_3 = this.s4t(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$18 = l_3 - r_3;
            this.t4t(stack, tmp$ret$18);
            break;
          case 15:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_4 = this.s4t(stack);
            var l_4 = this.s4t(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$19 = l_4 / r_4;
            this.t4t(stack, tmp$ret$19);
            break;
          case 33:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_5 = this.s4t(stack);
            var l_5 = this.s4t(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$20 = l_5 * r_5;
            this.t4t(stack, tmp$ret$20);
            break;
          case 26:
            if (stack.d1() > 2) {
              evalCtx.v4s_1 = stack.f1(0) + evalCtx.p4s_1;
              evalCtx.w4s_1 = true;
            }

            if (!(ctx.m3n() === 0)) {
              this.v4t(ctx);
            }

            this.w4t(ctx, stack.f1(stack.d1() - 2 | 0), stack.f1(stack.d1() - 1 | 0));
            stack.y2();
            break;
          case 3:
          case 28:
            if (stack.d1() > 1) {
              evalCtx.v4s_1 = stack.f1(0) + evalCtx.p4s_1;
              evalCtx.w4s_1 = true;
            }

            this.a4u(ctx, this.s4t(stack), op.equals(Op_hmoveto_getInstance()));
            stack.y2();
            break;
          case 5:
            var progression = step(until(0, stack.d1()), 2);
            var inductionVariable = progression.y1_1;
            var last = progression.z1_1;
            var step_0 = progression.a2_1;
            if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
              do {
                var n = inductionVariable;
                inductionVariable = inductionVariable + step_0 | 0;
                this.x4t(ctx, stack.f1(n), stack.f1(n + 1 | 0));
              }
               while (!(n === last));
            stack.y2();
            break;
          case 7:
          case 8:
            var toggle = op.equals(Op_hlineto_getInstance());
            var inductionVariable_0 = 0;
            var last_0 = stack.d1();
            if (inductionVariable_0 < last_0)
              do {
                var n_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                this.b4u(ctx, stack.f1(n_0), toggle);
                toggle = !toggle;
              }
               while (inductionVariable_0 < last_0);
            stack.y2();
            break;
          case 9:
          case 32:
          case 34:
            var n_1 = 0;
            if (op.equals(Op_rlinecurve_getInstance())) {
              while ((stack.d1() - n_1 | 0) < 6) {
                var _unary__edvuaz = n_1;
                n_1 = _unary__edvuaz + 1 | 0;
                var tmp_1 = stack.f1(_unary__edvuaz);
                var _unary__edvuaz_0 = n_1;
                n_1 = _unary__edvuaz_0 + 1 | 0;
                this.x4t(ctx, tmp_1, stack.f1(_unary__edvuaz_0));
              }
            }

            while ((stack.d1() - n_1 | 0) >= 6) {
              var _unary__edvuaz_1 = n_1;
              n_1 = _unary__edvuaz_1 + 1 | 0;
              var tmp_2 = stack.f1(_unary__edvuaz_1);
              var _unary__edvuaz_2 = n_1;
              n_1 = _unary__edvuaz_2 + 1 | 0;
              var tmp_3 = stack.f1(_unary__edvuaz_2);
              var _unary__edvuaz_3 = n_1;
              n_1 = _unary__edvuaz_3 + 1 | 0;
              var tmp_4 = stack.f1(_unary__edvuaz_3);
              var _unary__edvuaz_4 = n_1;
              n_1 = _unary__edvuaz_4 + 1 | 0;
              var tmp_5 = stack.f1(_unary__edvuaz_4);
              var _unary__edvuaz_5 = n_1;
              n_1 = _unary__edvuaz_5 + 1 | 0;
              var tmp_6 = stack.f1(_unary__edvuaz_5);
              var _unary__edvuaz_6 = n_1;
              n_1 = _unary__edvuaz_6 + 1 | 0;
              this.z4t(ctx, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, stack.f1(_unary__edvuaz_6));
            }

            if (op.equals(Op_rcurveline_getInstance())) {
              while (n_1 < stack.d1()) {
                var _unary__edvuaz_7 = n_1;
                n_1 = _unary__edvuaz_7 + 1 | 0;
                var tmp_7 = stack.f1(_unary__edvuaz_7);
                var _unary__edvuaz_8 = n_1;
                n_1 = _unary__edvuaz_8 + 1 | 0;
                this.x4t(ctx, tmp_7, stack.f1(_unary__edvuaz_8));
              }
            }

            stack.y2();
            break;
          case 35:
          case 37:
            var horizontal = op.equals(Op_hhcurveto_getInstance());
            var n_2 = 0;
            var tmp_8;
            if ((stack.d1() % 2 | 0) === 1) {
              var _unary__edvuaz_9 = n_2;
              n_2 = _unary__edvuaz_9 + 1 | 0;
              tmp_8 = stack.f1(_unary__edvuaz_9);
            } else {
              tmp_8 = 0.0;
            }

            var v = tmp_8;
            var initialY = horizontal ? v : 0.0;
            var initialX = horizontal ? 0.0 : v;
            if (!(((stack.d1() - n_2 | 0) % 4 | 0) === 0)) {
              // Inline function 'kotlin.error' call
              var message = 'Invalid number of operands';
              throw IllegalStateException.s4(toString_0(message));
            }

            while (n_2 < stack.d1()) {
              var _unary__edvuaz_10 = n_2;
              n_2 = _unary__edvuaz_10 + 1 | 0;
              var vv = stack.f1(_unary__edvuaz_10);
              var x1 = initialX + (horizontal ? vv : 0.0);
              var y1 = initialY + (horizontal ? 0.0 : vv);
              var _unary__edvuaz_11 = n_2;
              n_2 = _unary__edvuaz_11 + 1 | 0;
              var x2 = stack.f1(_unary__edvuaz_11);
              var _unary__edvuaz_12 = n_2;
              n_2 = _unary__edvuaz_12 + 1 | 0;
              var y2 = stack.f1(_unary__edvuaz_12);
              var _unary__edvuaz_13 = n_2;
              n_2 = _unary__edvuaz_13 + 1 | 0;
              var v1_0 = stack.f1(_unary__edvuaz_13);
              var lastX = horizontal ? v1_0 : 0.0;
              var lastY = horizontal ? 0.0 : v1_0;
              this.z4t(ctx, x1, y1, x2, y2, lastX, lastY);
              initialX = 0.0;
              initialY = 0.0;
            }

            stack.y2();
            break;
          case 42:
          case 44:
            reverse(stack);
            var toggle_0 = op.equals(Op_hvcurveto_getInstance());
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!stack.g1()) {
                break $l$loop;
              }
              var vv_0 = this.s4t(stack);
              var x1_0 = toggle_0 ? vv_0 : 0.0;
              var y1_0 = toggle_0 ? 0.0 : vv_0;
              var x2_0 = this.s4t(stack);
              var y2_0 = this.s4t(stack);
              var v1_1 = this.s4t(stack);
              var v2_0 = stack.d1() === 1 ? this.s4t(stack) : 0.0;
              var ax = toggle_0 ? v2_0 : v1_1;
              var ay = toggle_0 ? v1_1 : v2_0;
              this.z4t(ctx, x1_0, y1_0, x2_0, y2_0, ax, ay);
              toggle_0 = !toggle_0;
            }

            stack.y2();
            break;
          case 45:
          case 46:
          case 47:
          case 48:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.nd();
          case 0:
          case 1:
          case 21:
          case 30:
          case 23:
          case 24:
            if (!((stack.d1() % 2 | 0) === 0) && !evalCtx.w4s_1) {
              var value_0 = stack.f1(0);
              evalCtx.v4s_1 = value_0 + evalCtx.p4s_1;
            }

            evalCtx.u4s_1 = evalCtx.u4s_1 + (stack.d1() >>> 1 | 0) | 0;
            evalCtx.w4s_1 = true;
            stack.y2();
            if (op.equals(Op_hintmask_getInstance()) || op.equals(Op_cntrmask_getInstance())) {
              var skipCount = (evalCtx.u4s_1 + 7 | 0) >>> 3 | 0;
              s.x1g(skipCount);
            }

            break;
          case 18:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.nd();
          case 20:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.nd();
          default:
            noWhenBranchMatchedException();
            break;
        }
      } else if (v0 === 255) {
        var integerPart = this.c4u(s) << 8 | this.c4u(s);
        var fractionPart = this.c4u(s) << 8 | this.c4u(s);
        var value_1 = integerPart + fractionPart / 65536.0;
        this.t4t(stack, value_1);
      } else {
        var tmp_9;
        if (v0 === 28) {
          tmp_9 = toShort(this.c4u(s) << 8 | this.c4u(s));
        } else if (32 <= v0 ? v0 <= 246 : false) {
          tmp_9 = v0 - 139 | 0;
        } else if (247 <= v0 ? v0 <= 250 : false) {
          tmp_9 = (imul(v0 - 247 | 0, 256) + this.c4u(s) | 0) + 108 | 0;
        } else if (251 <= v0 ? v0 <= 254 : false) {
          tmp_9 = ((-imul(v0 - 251 | 0, 256) | 0) - this.c4u(s) | 0) - 108 | 0;
        } else {
          get_unreachable();
        }
        var value_2 = tmp_9;
        this.u4t(stack, value_2);
      }
    }
  }
  l4s(ctx, s, evalCtx, stack, stackLevel, $super) {
    stack = stack === VOID ? DoubleArrayList.r2k(32) : stack;
    stackLevel = stackLevel === VOID ? 0 : stackLevel;
    var tmp;
    if ($super === VOID) {
      this.d4u(ctx, s, evalCtx, stack, stackLevel);
      tmp = Unit_instance;
    } else {
      tmp = $super.d4u.call(this, ctx, s, evalCtx, stack, stackLevel);
    }
    return tmp;
  }
}
class TtfCIDFont {
  constructor() {
    TtfCIDFont_instance = this;
    this.k4t_1 = Companion_getInstance_15().c1h('TtfCIDFont');
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_23 = this;
    this.e4u_1 = Companion_getInstance_15().c1h('TTF');
  }
}
class VectorFont {}
function getGlyphPath$default(size, codePoint, path, reader, $super) {
  path = path === VOID ? new GlyphPath() : path;
  reader = reader === VOID ? null : reader;
  return $super === VOID ? this.u4w(size, codePoint, path, reader) : $super.u4w.call(this, size, codePoint, path, reader);
}
function renderGlyph_0(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
  $l$block: {
    // Inline function 'korlibs.io.lang.keep' call
    var tmp0_elvis_lhs = reader == null ? null : reader.l1g_1;
    var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    try {
      // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
      this.n4f(size, codePoint, metrics, reader);
      break $l$block;
    }finally {
      if (reader == null)
        null;
      else {
        reader.l1g_1 = old;
      }
    }
  }
  var g = this.v4w(size, codePoint, VOID, reader);
  if (!(g == null)) {
    if (!(fill == null)) {
      ctx.m4m();
    }
    if (!g.p4q()) {
      if (beforeDraw == null)
        null;
      else
        beforeDraw();
    }
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = ctx.g44_1.z4f_1;
    try {
      // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
      // Inline function 'korlibs.image.vector.Context2d.translate' call
      ctx.x4p(pos.c26_1, pos.d26_1);
      g.q4q(ctx);
    }finally {
      ctx.g44_1.z4f_1 = t;
    }
    switch (fill) {
      case true:
        ctx.v4n();
        break;
      case false:
        ctx.u4n();
        break;
      case null:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return !g.p4q();
  }
  return false;
}
class BaseTtfFont {
  static q56(s, extName, onlyReadMetadata, enableLigatures) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var $this = createThis(this);
    $this.f4u_1 = new Mixin();
    $this.g4u_1 = s;
    $this.h4u_1 = extName;
    $this.i4u_1 = onlyReadMetadata;
    $this.j4u_1 = enableLigatures;
    $this.k4u_1 = new NamesInfo();
    var tmp = $this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(3), null);
    while (tmp_0 < 3) {
      tmp_1[tmp_0] = new Contour();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.l4u_1 = tmp_1;
    $this.m4u_1 = 0;
    $this.n4u_1 = 0;
    $this.o4u_1 = 0;
    $this.p4u_1 = 0;
    $this.q4u_1 = 0;
    $this.r4u_1 = 0;
    $this.s4u_1 = 0;
    $this.t4u_1 = 0;
    $this.u4u_1 = 0;
    $this.v4u_1 = 0;
    $this.w4u_1 = 0;
    $this.x4u_1 = 0;
    $this.y4u_1 = 0;
    $this.z4u_1 = 0;
    $this.a4v_1 = Companion_instance_27.r56(0, 0);
    $this.b4v_1 = 0;
    $this.c4v_1 = 0;
    $this.d4v_1 = 0;
    $this.e4v_1 = 0;
    $this.f4v_1 = 0;
    $this.g4v_1 = 0;
    $this.h4v_1 = 0;
    $this.i4v_1 = 0;
    $this.j4v_1 = 0;
    $this.k4v_1 = 0;
    $this.l4v_1 = 0;
    $this.m4v_1 = 0;
    $this.n4v_1 = new Int32Array(0);
    $this.o4v_1 = Companion_instance_27.r56(0, 0);
    $this.p4v_1 = 128;
    $this.q4v_1 = 0;
    $this.r4v_1 = 0;
    $this.s4v_1 = 0;
    $this.t4v_1 = 0;
    $this.u4v_1 = 0;
    $this.v4v_1 = 0;
    $this.w4v_1 = 0;
    $this.x4v_1 = 0;
    $this.y4v_1 = 0;
    var tmp_2 = $this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_2.z4v_1 = emptyList();
    $this.a4w_1 = LinkedHashMap.ac();
    $this.b4w_1 = LinkedHashMap.ac();
    $this.c4w_1 = IntMap.f2o(512);
    $this.d4w_1 = LinkedHashMap.ac();
    var tmp_3 = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_3.e4w_1 = [];
    $this.f4w_1 = IntMap.f2o();
    var tmp_4 = $this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_4.g4w_1 = emptyList();
    $this.h4w_1 = new COLRv1();
    $this.i4w_1 = false;
    $this.j4w_1 = IntIntMap.x2o();
    $this.k4w_1 = IntMap.f2o();
    $this.m4w_1 = new GlyphMetrics(1.0, false, 0, Companion_getInstance_4().q29(), 0.0);
    $this.n4w_1 = false;
    $this.o4w_1 = null;
    return $this;
  }
  y1i(_set____db54di) {
    this.f4u_1.y1i(_set____db54di);
  }
  z1i() {
    return this.f4u_1.z1i();
  }
  static p4w(d, extName, onlyReadMetadata, enableLigatures) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    return this.q56(openFastStream(d), extName, onlyReadMetadata, enableLigatures);
  }
  b4f(size, metrics) {
    return metrics.l4f(this.z4w(), size);
  }
  n4f(size, codePoint, metrics, reader) {
    var tmp104_safe_receiver = this.k4y(reader, codePoint);
    var tmp0_elvis_lhs = tmp104_safe_receiver == null ? null : tmp104_safe_receiver.w53_1;
    return metrics.u4f(tmp0_elvis_lhs == null ? this.m4w_1 : tmp0_elvis_lhs, size, codePoint);
  }
  a4h(size, leftCodePoint, rightCodePoint) {
    return 0.0;
  }
  u4w(size, codePoint, path, reader) {
    var spos = reader == null ? null : reader.l1g_1;
    var codePointPeek = reader == null ? null : reader.t1g(0);
    var tmp0_elvis_lhs = this.j4y(reader, codePoint, true);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var g = tmp;
    var scale = this.x4f(size);
    path.i4q_1 = g.m22().z53_1;
    var tmp_0 = path;
    var tmp107_safe_receiver = g.j54();
    tmp_0.j4q_1 = tmp107_safe_receiver == null ? null : tmp107_safe_receiver.b54();
    var bitmapEntry = g.l54();
    var bitmap = bitmapEntry == null ? null : bitmapEntry.l51();
    path.k4q_1 = bitmap;
    if (!(bitmapEntry == null)) {
      var scaleX = this.p4v_1 / bitmapEntry.u50_1.a50_1;
      var scaleY = this.p4v_1 / bitmapEntry.u50_1.b50_1;
      path.l4q_1 = Vector2D.l28(0.0, ((-bitmapEntry.v50_1 | 0) - bitmapEntry.f51() | 0) * scaleY);
      path.m4q_1 = Scale.z2d(scaleX, scaleY);
    }
    path.n4q_1 = Companion_getInstance_5().n29_1.p2a(scale, scale);
    path.o4q_1 = scale;
    return path;
  }
  x4f(size) {
    return size / this.p4v_1;
  }
  w4w(key) {
    return this.a4w_1.d3(key);
  }
  x4w(codePoint, glyphID) {
    // Inline function 'kotlin.collections.set' call
    this.a4w_1.f3(codePoint, glyphID);
    // Inline function 'kotlin.collections.set' call
    this.b4w_1.f3(glyphID, codePoint);
  }
  y4w(codePoint, glyphID) {
  }
  z4w() {
    var tmp = this.l4w_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fontMetrics1px');
    }
  }
  a4x() {
    return this.k4u_1.a4x();
  }
  l3() {
    var tmp0_elvis_lhs = this.h4u_1;
    return tmp0_elvis_lhs == null ? this.a4x() : tmp0_elvis_lhs;
  }
  q4w() {
    this.r4w();
    this.g4x();
    this.h4x();
    this.i4x();
    this.e4x();
    if (!this.i4u_1) {
      if (!(this.t4w('CFF ') == null) && this.t4w('glyf') == null) {
        // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
        var tmp111_safe_receiver = this.d4x('CFF ');
        if (tmp111_safe_receiver == null)
          null;
        else {
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
          // Inline function 'kotlin.apply' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>.<anonymous>' call
          this.o4w_1 = CFF_instance.g4t(tmp111_safe_receiver);
        }
      }
      this.f4x();
      this.g4y();
      this.j4x();
      this.k4x();
      this.f4y();
      this.e4y();
      this.m4x();
      this.n4x();
      this.o4x();
    }
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new FontMetrics();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
    var scale = this.x4f(1.0);
    this_0.c4f_1 = 1.0;
    this_0.d4f_1 = this.t4v_1 * scale;
    this_0.e4f_1 = this.b4v_1 * scale;
    this_0.f4f_1 = 0.0 * scale;
    this_0.g4f_1 = this.c4v_1 * scale;
    this_0.h4f_1 = this.r4v_1 * scale;
    this_0.i4f_1 = this.d4v_1 * scale;
    this_0.j4f_1 = this.e4v_1 * scale;
    this_0.k4f_1 = this.p4v_1 * scale;
    tmp.l4w_1 = this_0;
  }
  toString() {
    return 'TtfFont(name=' + this.l3() + ')';
  }
  b4x(_this__u8e3s4) {
    return _FWord___init__impl__2rjyqf(_this__u8e3s4.e1r());
  }
  c4x(_this__u8e3s4) {
    return Companion_instance_27.r56(_this__u8e3s4.d1r(), _this__u8e3s4.d1r());
  }
  d4x(name) {
    var tmp109_safe_receiver = this.t4w(name);
    return tmp109_safe_receiver == null ? null : tmp109_safe_receiver.o4z();
  }
  e4x() {
    var tmp111_safe_receiver = this.d4x('name');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readNames.<anonymous>' call
      Companion_instance_26.r4z(tmp111_safe_receiver, this.k4u_1);
    }
    return Unit_instance;
  }
  f4x() {
    var tmp111_safe_receiver = this.d4x('loca');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>' call
      var tmp;
      switch (this.x4v_1) {
        case 0:
          tmp = 2;
          break;
        case 1:
          tmp = 4;
          break;
        default:
          get_invalidOp();
          break;
      }
      var bytesPerEntry = tmp;
      var data = tmp111_safe_receiver.a1r(imul(bytesPerEntry, this.m4u_1 + 1 | 0));
      var tmp_0 = this;
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>' call
      var $this$run = new FastByteArrayInputStream(data);
      var tmp_1;
      switch (this.x4v_1) {
        case 0:
          // Inline function 'korlibs.datastructure.mapInt' call

          var this_0 = $this$run.k1r(this.m4u_1 + 1 | 0);
          // Inline function 'kotlin.also' call

          var this_1 = new Int32Array(this_0.length);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

          var inductionVariable = 0;
          var last = this_0.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>.<anonymous>' call
              // Inline function 'kotlin.code' call
              var this_2 = this_0[n];
              var tmp$ret$0 = Char__toInt_impl_vasixd(this_2);
              this_1[n] = imul(tmp$ret$0, 2);
            }
             while (inductionVariable < last);
          tmp_1 = this_1;
          break;
        case 1:
          tmp_1 = $this$run.m1r(this.m4u_1 + 1 | 0);
          break;
        default:
          get_invalidOp();
          break;
      }
      tmp_0.n4v_1 = tmp_1;
    }
    return Unit_instance;
  }
  g4x() {
    var tmp111_safe_receiver = this.d4x('head');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp111_safe_receiver.e1r() === 1)) {
        invalidOp('Invalid TTF');
      }
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp111_safe_receiver.e1r() === 0)) {
        invalidOp('Invalid TTF');
      }
      this.o4v_1 = this.c4x(tmp111_safe_receiver);
      var checkSumAdjustment = tmp111_safe_receiver.g1r();
      // Inline function 'kotlin.apply' call
      var this_0 = tmp111_safe_receiver.g1r();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(this_0 === 1594834165)) {
        invalidOp('Invalid magic ' + get_hex(this_0));
      }
      var flags = tmp111_safe_receiver.e1r();
      this.p4v_1 = tmp111_safe_receiver.e1r();
      var created = tmp111_safe_receiver.h1r().s3(new Long(1000, 0));
      var modified = tmp111_safe_receiver.h1r().s3(new Long(1000, 0));
      this.q4v_1 = tmp111_safe_receiver.d1r();
      this.r4v_1 = tmp111_safe_receiver.d1r();
      this.s4v_1 = tmp111_safe_receiver.d1r();
      this.t4v_1 = tmp111_safe_receiver.d1r();
      this.u4v_1 = tmp111_safe_receiver.e1r();
      this.v4v_1 = tmp111_safe_receiver.e1r();
      this.w4v_1 = tmp111_safe_receiver.d1r();
      this.x4v_1 = tmp111_safe_receiver.d1r();
      this.y4v_1 = tmp111_safe_receiver.d1r();
    }
    return Unit_instance;
  }
  h4x() {
    var tmp111_safe_receiver = this.d4x('maxp');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readMaxp.<anonymous>' call
      var version = this.c4x(tmp111_safe_receiver);
      this.m4u_1 = tmp111_safe_receiver.e1r();
      this.n4u_1 = tmp111_safe_receiver.e1r();
      this.o4u_1 = tmp111_safe_receiver.e1r();
      this.p4u_1 = tmp111_safe_receiver.e1r();
      this.q4u_1 = tmp111_safe_receiver.e1r();
      this.r4u_1 = tmp111_safe_receiver.e1r();
      this.s4u_1 = tmp111_safe_receiver.e1r();
      this.t4u_1 = tmp111_safe_receiver.e1r();
      this.u4u_1 = tmp111_safe_receiver.e1r();
      this.v4u_1 = tmp111_safe_receiver.e1r();
      this.w4u_1 = tmp111_safe_receiver.e1r();
      this.x4u_1 = tmp111_safe_receiver.e1r();
      this.y4u_1 = tmp111_safe_receiver.e1r();
      this.z4u_1 = tmp111_safe_receiver.e1r();
    }
    return Unit_instance;
  }
  i4x() {
    var tmp111_safe_receiver = this.d4x('hhea');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHhea.<anonymous>' call
      this.a4v_1 = this.c4x(tmp111_safe_receiver);
      this.b4v_1 = tmp111_safe_receiver.d1r();
      this.c4v_1 = tmp111_safe_receiver.d1r();
      this.d4v_1 = tmp111_safe_receiver.d1r();
      this.e4v_1 = tmp111_safe_receiver.e1r();
      this.f4v_1 = tmp111_safe_receiver.d1r();
      this.g4v_1 = tmp111_safe_receiver.d1r();
      this.h4v_1 = tmp111_safe_receiver.d1r();
      this.i4v_1 = tmp111_safe_receiver.d1r();
      this.j4v_1 = tmp111_safe_receiver.d1r();
      this.k4v_1 = tmp111_safe_receiver.d1r();
      tmp111_safe_receiver.d1r();
      tmp111_safe_receiver.d1r();
      tmp111_safe_receiver.d1r();
      tmp111_safe_receiver.d1r();
      this.l4v_1 = tmp111_safe_receiver.d1r();
      this.m4v_1 = tmp111_safe_receiver.e1r();
    }
    return Unit_instance;
  }
  j4x() {
    var tmp111_safe_receiver = this.d4x('hmtx');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, this.m4v_1);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var inductionVariable = this_0.y1_1;
      var last_0 = this_0.z1_1;
      if (inductionVariable <= last_0)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
          var tmp$ret$0 = new HorMetric(tmp111_safe_receiver.e1r(), tmp111_safe_receiver.d1r());
          destination.h(tmp$ret$0);
        }
         while (!(item === last_0));
      var firstMetrics = destination;
      var lastAdvanceWidth = last(firstMetrics).p4z_1;
      // Inline function 'kotlin.collections.map' call
      var this_1 = until(0, this.m4u_1 - this.m4v_1 | 0);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var inductionVariable_0 = this_1.y1_1;
      var last_1 = this_1.z1_1;
      if (inductionVariable_0 <= last_1)
        do {
          var item_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
          var tmp$ret$3 = new HorMetric(lastAdvanceWidth, tmp111_safe_receiver.d1r());
          destination_0.h(tmp$ret$3);
        }
         while (!(item_0 === last_1));
      var compressedMetrics = destination_0;
      this.z4v_1 = plus(firstMetrics, compressedMetrics);
    }
    return Unit_instance;
  }
  k4x() {
    var tmp111_safe_receiver = this.d4x('CPAL');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>' call
      var version = tmp111_safe_receiver.e1r();
      switch (version) {
        case 0:
        case 1:
          var numPaletteEntries = tmp111_safe_receiver.e1r();
          var numPalettes = tmp111_safe_receiver.e1r();
          var numColorRecords = tmp111_safe_receiver.e1r();
          var colorRecordsArrayOffset = tmp111_safe_receiver.g1r();
          var colorRecordIndices = tmp111_safe_receiver.j1r(numPalettes);
          var paletteTypesArrayOffset = version === 1 ? tmp111_safe_receiver.g1r() : -1;
          var paletteLabelsArrayOffset = version === 1 ? tmp111_safe_receiver.g1r() : -1;
          var paletteEntryLabelsArrayOffset = version === 1 ? tmp111_safe_receiver.g1r() : -1;
          tmp111_safe_receiver.s1q(colorRecordsArrayOffset);
          var colorInts = tmp111_safe_receiver.l1r(numColorRecords);
          var inductionVariable = 0;
          var last = colorInts.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var c = _RGBA___init__impl__lqpay5(colorInts[n]);
              colorInts[n] = _RGBA___get_value__impl__hhco8v(Companion_getInstance_23().w4b(_RGBA___get_b__impl__m6tl80(c), _RGBA___get_g__impl__o8pukr(c), _RGBA___get_r__impl__duz7mo(c), _RGBA___get_a__impl__6msvu7(c)));
            }
             while (inductionVariable < last);
          var tmp = this;
          // Inline function 'kotlin.collections.map' call

          // Inline function 'kotlin.collections.mapTo' call

          var destination = ArrayList.w(colorRecordIndices.length);
          var inductionVariable_0 = 0;
          var last_0 = colorRecordIndices.length;
          while (inductionVariable_0 < last_0) {
            var item = colorRecordIndices[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>.<anonymous>' call
            var tmp$ret$0 = new Palette(_RgbaArray___init__impl__oib4y4(copyOfRange_0(colorInts, item, item + numPaletteEntries | 0)));
            destination.h(tmp$ret$0);
          }

          tmp.g4w_1 = destination;
          break;
        default:
          println('TTF WARNING CPAL version != 0,1');
          break;
      }
    }
    return Unit_instance;
  }
  l4x(_this__u8e3s4) {
    return new SbitLineMetrics(_this__u8e3s4.b1r(), _this__u8e3s4.b1r(), _this__u8e3s4.c1r(), _this__u8e3s4.b1r(), _this__u8e3s4.b1r(), _this__u8e3s4.b1r(), _this__u8e3s4.b1r(), _this__u8e3s4.b1r(), _this__u8e3s4.b1r(), _this__u8e3s4.b1r(), _this__u8e3s4.b1r(), _this__u8e3s4.b1r());
  }
  m4x() {
    var tmp111_safe_receiver = this.d4x('CBLC');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCblc.<anonymous>' call
      var majorVersion = tmp111_safe_receiver.e1r();
      var minorVersion = tmp111_safe_receiver.e1r();
      if (majorVersion === 3) {
        var numSizes = tmp111_safe_receiver.g1r();
        var tmp = 0;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_0 = fillArrayVal(Array(numSizes), null);
        while (tmp < numSizes) {
          tmp_0[tmp] = new ColorBitmapInfo(tmp111_safe_receiver.g1r(), tmp111_safe_receiver.g1r(), tmp111_safe_receiver.g1r(), tmp111_safe_receiver.g1r(), this.l4x(tmp111_safe_receiver), this.l4x(tmp111_safe_receiver), tmp111_safe_receiver.e1r(), tmp111_safe_receiver.e1r(), tmp111_safe_receiver.c1r(), tmp111_safe_receiver.c1r(), tmp111_safe_receiver.c1r(), tmp111_safe_receiver.b1r());
          tmp = tmp + 1 | 0;
        }
        var colorBitmapInfos = toList_1(tmp_0);
        var _iterator__ex2g4s = colorBitmapInfos.a1();
        while (_iterator__ex2g4s.b1()) {
          var cbi = _iterator__ex2g4s.c1();
          var glyphCount = cbi.z4z_1 - cbi.y4z_1 | 0;
          tmp111_safe_receiver.s1q(cbi.s4z_1);
          var tmp_1 = 0;
          var tmp_2 = cbi.u4z_1;
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_3 = fillArrayVal(Array(tmp_2), null);
          while (tmp_1 < tmp_2) {
            tmp_3[tmp_1] = new BaseTtfFont$readCblc$Subtable(tmp111_safe_receiver.e1r(), tmp111_safe_receiver.e1r(), tmp111_safe_receiver.g1r());
            tmp_1 = tmp_1 + 1 | 0;
          }
          var subtables = tmp_3;
          var inductionVariable = 0;
          var last = subtables.length;
          while (inductionVariable < last) {
            var subtable = subtables[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            tmp111_safe_receiver.s1q(cbi.s4z_1 + subtable.d56_1 | 0);
            var indexFormat = tmp111_safe_receiver.e1r();
            var imageFormat = tmp111_safe_receiver.e1r();
            var imageDataOffset = tmp111_safe_receiver.g1r();
            var tmp_4;
            if (indexFormat === 1) {
              var tmp_5 = 0;
              var tmp_6 = subtable.e56() + 1 | 0;
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_7 = fillArrayVal(Array(tmp_6), null);
              while (tmp_5 < tmp_6) {
                tmp_7[tmp_5] = imageDataOffset + tmp111_safe_receiver.g1r() | 0;
                tmp_5 = tmp_5 + 1 | 0;
              }
              tmp_4 = tmp_7;
            } else {
              // Inline function 'kotlin.emptyArray' call
              tmp_4 = [];
            }
            var offsets = tmp_4;
            var inductionVariable_0 = 0;
            var last_0 = offsets.length - 1 | 0;
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var offset = offsets[n];
                var size = offsets[n + 1 | 0] - offset | 0;
                var glyphID = (subtable.b56_1 + n | 0) - 1 | 0;
                // Inline function 'kotlin.collections.set' call
                var this_0 = this.d4w_1;
                var value = new BitmapGlyphInfo(glyphID, imageFormat, offset, size, cbi);
                this_0.f3(glyphID, value);
              }
               while (inductionVariable_0 < last_0);
          }
        }
      } else {
        println('Unsupported CBLC ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  }
  n4x() {
    var tmp111_safe_receiver = this.d4x('CBDT');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCbdt.<anonymous>' call
      var majorVersion = tmp111_safe_receiver.e1r();
      var minorVersion = tmp111_safe_receiver.e1r();
      if (majorVersion === 3) {
        var _iterator__ex2g4s = this.d4w_1.i3().a1();
        while (_iterator__ex2g4s.b1()) {
          var i = _iterator__ex2g4s.c1();
          var format = i.r50_1;
          if (format === 17 || format === 18) {
            i.v50_1 = tmp111_safe_receiver.c1r();
            i.w50_1 = tmp111_safe_receiver.c1r();
            i.x50_1 = tmp111_safe_receiver.b1r();
            i.y50_1 = tmp111_safe_receiver.b1r();
            i.z50_1 = tmp111_safe_receiver.c1r();
            i.a51_1 = format === 18 ? tmp111_safe_receiver.b1r() : i.x50_1;
            i.b51_1 = format === 18 ? tmp111_safe_receiver.b1r() : i.y50_1;
            i.c51_1 = format === 18 ? tmp111_safe_receiver.b1r() : i.z50_1;
          }
          var dataLen = tmp111_safe_receiver.g1r();
          i.d51_1 = tmp111_safe_receiver.v1q(dataLen);
        }
      } else {
        println('Unsupported CBDT ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  }
  o4x() {
    var tmp111_safe_receiver = this.d4x('sbix');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>' call
      var version = tmp111_safe_receiver.e1r();
      var flags = tmp111_safe_receiver.e1r();
      var numStrikes = tmp111_safe_receiver.g1r();
      var strikeOffsets = tmp111_safe_receiver.m1r(numStrikes);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(strikeOffsets.length);
      var inductionVariable = 0;
      var last = strikeOffsets.length;
      while (inductionVariable < last) {
        var item = strikeOffsets[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        tmp111_safe_receiver.s1q(item);
        var tmp$ret$0 = new BaseTtfFont$readSbix$StrikeInfo(tmp111_safe_receiver.e1r(), tmp111_safe_receiver.e1r(), item, toIntArrayList(tmp111_safe_receiver.m1r(this.m4u_1 + 1 | 0)));
        destination.h(tmp$ret$0);
      }
      var strikes = destination;
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.maxByOrNull' call
        var iterator = strikes.a1();
        if (!iterator.b1()) {
          tmp$ret$3 = null;
          break $l$block_0;
        }
        var maxElem = iterator.c1();
        if (!iterator.b1()) {
          tmp$ret$3 = maxElem;
          break $l$block_0;
        }
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        var maxValue = maxElem.f56_1;
        do {
          var e = iterator.c1();
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          var v = e.f56_1;
          if (compareTo(maxValue, v) < 0) {
            maxElem = e;
            maxValue = v;
          }
        }
         while (iterator.b1());
        tmp$ret$3 = maxElem;
      }
      var strike = ensureNotNull(tmp$ret$3);
      var inductionVariable_0 = 0;
      var last_0 = this.m4u_1;
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var glyphID = n;
          var offset = strike.i56_1.f1(n);
          var len = strike.i56_1.f1(n + 1 | 0) - offset | 0;
          var start = strike.h56_1 + offset | 0;
          var end = start + len | 0;
          tmp111_safe_receiver.s1q(start);
          var originOffsetX = tmp111_safe_receiver.d1r();
          var originOffsetY = tmp111_safe_receiver.d1r();
          var graphicType = tmp111_safe_receiver.p1r(4);
          var bytes = tmp111_safe_receiver.v1q(len - 8 | 0);
          // Inline function 'kotlin.collections.set' call
          var this_0 = this.d4w_1;
          // Inline function 'kotlin.also' call
          var this_1 = new BitmapGlyphInfo(glyphID, VOID, VOID, VOID, new ColorBitmapInfo(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, strike.f56_1, strike.f56_1));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          this_1.d51_1 = bytes;
          this_0.f3(glyphID, this_1);
        }
         while (inductionVariable_0 < last_0);
    }
    return Unit_instance;
  }
  p4x(_this__u8e3s4) {
    return _this__u8e3s4.g1r();
  }
  q4x(_this__u8e3s4) {
    return _this__u8e3s4.e1r();
  }
  r4x(_this__u8e3s4) {
    return _this__u8e3s4.d1r();
  }
  s4x(_this__u8e3s4) {
    return _this__u8e3s4.e1r();
  }
  t4x(_this__u8e3s4) {
    return _this__u8e3s4.f1r();
  }
  u4x(_this__u8e3s4) {
    return _this__u8e3s4.g1r();
  }
  v4x(_this__u8e3s4, isVar) {
    var xx = this.q4y(_this__u8e3s4);
    var yx = this.q4y(_this__u8e3s4);
    var xy = this.q4y(_this__u8e3s4);
    var yy = this.q4y(_this__u8e3s4);
    var dx = this.q4y(_this__u8e3s4);
    var dy = this.q4y(_this__u8e3s4);
    return new Matrix(xx, yx, xy, yy, dx, -dy);
  }
  w4x(_this__u8e3s4, out) {
    out.p51_1 = this.p4y(_this__u8e3s4);
    out.q51_1 = _this__u8e3s4.e1r();
    out.r51_1 = this.p4y(_this__u8e3s4);
    return out;
  }
  x4x(_this__u8e3s4, out, $super) {
    out = out === VOID ? new ColorStop(0.0, 0, 0.0) : out;
    return $super === VOID ? this.w4x(_this__u8e3s4, out) : $super.w4x.call(this, _this__u8e3s4, out);
  }
  y4x(_this__u8e3s4, doVar) {
    var format = _this__u8e3s4.c1r();
    var xMin = this.r4x(_this__u8e3s4);
    var yMin = this.r4x(_this__u8e3s4);
    var xMax = this.r4x(_this__u8e3s4);
    var yMax = this.r4x(_this__u8e3s4);
    if (format === 2) {
      var varIndexBase = this.p4x(_this__u8e3s4);
    }
    return Companion_getInstance_4().q2e(xMin, yMin, xMax, yMax);
  }
  z4x(_this__u8e3s4, doVar, $super) {
    doVar = doVar === VOID ? false : doVar;
    return $super === VOID ? this.y4x(_this__u8e3s4, doVar) : $super.y4x.call(this, _this__u8e3s4, doVar);
  }
  a4y(_this__u8e3s4) {
    var cycle;
    switch (_this__u8e3s4.c1r()) {
      case 0:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
      case 1:
        cycle = CycleMethod_REPEAT_getInstance();
        break;
      case 2:
        cycle = CycleMethod_REFLECT_getInstance();
        break;
      default:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
    }
    // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf16' call
    var tmp = 0;
    var tmp_0 = _this__u8e3s4.e1r();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      // Inline function 'korlibs.image.font.BaseTtfFont.readColorLine.<anonymous>' call
      tmp_1[tmp] = this.x4x(_this__u8e3s4);
      tmp = tmp + 1 | 0;
    }
    return new ColorLine(cycle, toList_1(tmp_1));
  }
  b4y(glyphID, s, c, pal, level) {
    var nodeFormat = s.c1r();
    var isVar = (nodeFormat % 2 | 0) === 1;
    var indent = repeat('  ', level);
    var debug = false;
    var debugShape = false;
    if (debug) {
      println(indent + 'interpretColrv1[glyphID=' + glyphID + ']: ' + nodeFormat + ' - ' + toString(getOrNull(Companion_getInstance_33().a4z_1, nodeFormat)));
    }
    switch (nodeFormat) {
      case 1:
        var numLayers = s.c1r();
        var firstLayerIndex = s.g1r();
        var inductionVariable = 0;
        if (inductionVariable < numLayers)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var paint = this.h4w_1.u52_1[firstLayerIndex + n | 0];
            this.b4y(glyphID, this.h4w_1.x52_1.x1q(paint), c, pal, level + 1 | 0);
          }
           while (inductionVariable < numLayers);
        break;
      case 2:
      case 3:
        var paletteIndex = s.e1r();
        var alpha = this.p4y(s);
        if (isVar) {
          var varIndexBase = this.p4x(s);
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.nd();
        }

        var color = RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(this.g4w_1.f1(pal).j4b_1, paletteIndex), alpha);
        if (debugShape) {
          println("ctx.fillStyle = '" + _RGBA___get_htmlStringSimple__impl__l4nu0u(color) + "';");
          println('ctx.fill();');
        }

        if (debug) {
          println(indent + RGBA__toString_impl_4lw6dp(color));
        }

        c.y4n(new RGBA(color));
        break;
      case 4:
      case 5:
        var colorLineOffset = this.t4x(s);
        var x0 = this.r4x(s);
        var y0 = this.r4x(s);
        var x1 = this.r4x(s);
        var y1 = this.r4x(s);
        var x2 = this.r4x(s);
        var y2 = this.r4x(s);
        var colorLine = this.a4y(s.x1q(colorLineOffset));
        if (isVar) {
          var varIndexBase_0 = this.p4x(s);
        }

        // Inline function 'korlibs.image.paint.LinearGradientPaint' call

        var y0_0 = -y0;
        var y1_0 = -y1;
        var cycle = colorLine.m51_1;
        var transform = Companion_getInstance_5().n29_1;
        // Inline function 'kotlin.also' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.paint.LinearGradientPaint.<anonymous>' call

        var paint_0 = new GradientPaint(GradientKind_LINEAR_getInstance(), numberToDouble(x0), numberToDouble(y0_0), 0.0, numberToDouble(x1), numberToDouble(y1_0), 0.0, VOID, VOID, cycle, transform);
        colorLine.o51(paint_0, this.g4w_1.f1(pal));
        if (debug) {
          println(indent + paint_0.toString());
        }

        c.y4n(paint_0);
        break;
      case 6:
      case 7:
        var colorLineOffset_0 = this.t4x(s);
        var x0_0 = this.r4x(s);
        var y0_1 = this.r4x(s);
        var radius0 = this.q4x(s);
        var x1_0 = this.r4x(s);
        var y1_1 = this.r4x(s);
        var radius1 = this.q4x(s);
        var colorLine_0 = this.a4y(s.x1q(colorLineOffset_0));
        if (isVar) {
          var varIndexBase_1 = this.p4x(s);
        }

        if (debugShape) {
          println('ctx.fillStyle = ctx.createRadialGradient(' + x0_0 + ', -' + y0_1 + ', ' + radius0 + ', ' + x1_0 + ', -' + y1_1 + ', ' + radius1 + ');');
          println('ctx.fill();');
        }

        // Inline function 'korlibs.image.paint.RadialGradientPaint' call

        var y0_2 = -y0_1;
        var y1_2 = -y1_1;
        var cycle_0 = colorLine_0.m51_1;
        var transform_0 = Companion_getInstance_5().n29_1;
        // Inline function 'kotlin.also' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.paint.RadialGradientPaint.<anonymous>' call

        var paint_1 = new GradientPaint(GradientKind_RADIAL_getInstance(), numberToDouble(x0_0), numberToDouble(y0_2), numberToDouble(radius0), numberToDouble(x1_0), numberToDouble(y1_2), numberToDouble(radius1), VOID, VOID, cycle_0, transform_0);
        colorLine_0.o51(paint_1, this.g4w_1.f1(pal));
        if (debug) {
          println(indent + paint_1.toString());
        }

        c.y4n(paint_1);
        break;
      case 8:
      case 9:
        var colorLine_1 = this.t4x(s);
        var centerX = this.r4x(s);
        var centerY = this.r4x(s);
        var startAngle = this.p4y(s);
        var endAngle = this.p4y(s);
        if (isVar) {
          var varIndexBase_2 = this.p4x(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.nd();
      case 10:
        var paint_2 = this.t4x(s);
        var glyphID_0 = s.e1r();
        var colr = this.f4w_1.f1(glyphID_0);
        var glyph = this.o4y(glyphID_0);
        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.f4o();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (!(glyph == null)) {
            if (debugShape) {
              println(joinToString(toContext2dCommands(glyph.m22().z53_1), '\n'));
            }
            c.s56(glyph.m22().z53_1);
            this.b4y(glyphID_0, s.x1q(paint_2), c, pal, level + 1 | 0);
          }
        }finally {
          c.n4o();
        }

        break;
      case 11:
        var glyphID_1 = s.e1r();
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.nd();
      case 12:
      case 13:
        var paint_3 = this.t4x(s);
        var transform_1 = this.t4x(s);
        var affine = this.v4x(s.x1q(transform_1), isVar);
        if (debug) {
          println(indent + 'affine=' + affine.toString());
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.f4o();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          c.z4p(affine);
          this.b4y(glyphID, s.x1q(paint_3), c, pal, level + 1 | 0);
        }finally {
          c.n4o();
        }

        break;
      case 14:
      case 15:
        var paint_4 = this.t4x(s);
        var dx = FWord__toDouble_impl_53j5qp(this.b4x(s));
        var dy = FWord__toDouble_impl_53j5qp(this.b4x(s));
        if (isVar) {
          var varIndexBase_3 = this.p4x(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.f4o();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (debug) {
            println('translate: ' + dx + ', ' + dy);
          }
          c.x4p(dx, -dy);
          this.b4y(glyphID, s.x1q(paint_4), c, pal, level + 1 | 0);
        }finally {
          c.n4o();
        }

        break;
      case 16:
      case 17:
      case 18:
      case 19:
        var paint_5 = this.t4x(s);
        var scaleX = this.p4y(s);
        var scaleY = this.p4y(s);
        var aroundCenter = nodeFormat >= 18;
        if (aroundCenter) {
          var centerX_0 = this.r4x(s);
          var centerY_0 = this.r4x(s);
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.nd();
        }

        if (isVar) {
          var varIndexBase_4 = this.p4x(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.f4o();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          // Inline function 'korlibs.image.vector.Context2d.scale' call
          c.t56(numberToDouble(scaleX), numberToDouble(scaleY));
          this.b4y(glyphID, s.x1q(paint_5), c, pal, level + 1 | 0);
        }finally {
          c.n4o();
        }

        break;
      case 20:
      case 21:
      case 22:
      case 23:
        var paint_6 = this.t4x(s);
        var scale = this.p4y(s);
        if (nodeFormat >= 22) {
          var centerX_1 = this.r4x(s);
          var centerY_1 = this.r4x(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_5 = this.p4x(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.nd();
      case 24:
      case 25:
      case 26:
      case 27:
        var paint_7 = this.t4x(s);
        var angle = this.p4y(s);
        if (nodeFormat >= 26) {
          var centerX_2 = this.r4x(s);
          var centerY_2 = this.r4x(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_6 = this.p4x(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.nd();
      case 28:
      case 29:
      case 30:
      case 31:
        var paint_8 = this.t4x(s);
        var xSkewAngle = this.p4y(s);
        var ySkewAngle = this.p4y(s);
        if (nodeFormat >= 30) {
          var centerX_3 = this.r4x(s);
          var centerY_3 = this.r4x(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_7 = this.p4x(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.nd();
      case 32:
        var sourcePaint = this.t4x(s);
        var compositeMode = s.c1r();
        var backdropPaint = this.t4x(s);
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.nd();
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Unknown colorv1 format=' + nodeFormat;
        throw NotImplementedError.nd('An operation is not implemented: ' + reason);
    }
  }
  c4y(_this__u8e3s4, hintedCount) {
    var coverageFormat = _this__u8e3s4.e1r();
    switch (coverageFormat) {
      case 1:
        var glyphCount = _this__u8e3s4.e1r();
        // Inline function 'korlibs.datastructure.mapInt' call

        var this_0 = _this__u8e3s4.k1r(glyphCount);
        // Inline function 'kotlin.also' call

        var this_1 = new Int32Array(this_0.length);
        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

        var inductionVariable = 0;
        var last = this_0.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
            // Inline function 'kotlin.code' call
            var this_2 = this_0[n];
            this_1[n] = Char__toInt_impl_vasixd(this_2);
          }
           while (inductionVariable < last);
        return this_1;
      case 2:
        var rangeCount = _this__u8e3s4.e1r();
        // Inline function 'kotlin.collections.map' call

        var this_3 = until(0, rangeCount);
        // Inline function 'kotlin.collections.mapTo' call

        var destination = ArrayList.w(collectionSizeOrDefault(this_3, 10));
        var inductionVariable_0 = this_3.y1_1;
        var last_0 = this_3.z1_1;
        if (inductionVariable_0 <= last_0)
          do {
            var item = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
            var tmp$ret$4 = new BaseTtfFont$readCoverage$RangeInfo(_this__u8e3s4.e1r(), _this__u8e3s4.e1r(), _this__u8e3s4.e1r());
            destination.h(tmp$ret$4);
          }
           while (!(item === last_0));
        var ranges = destination;
        // Inline function 'kotlin.collections.maxOf' call

        var iterator = ranges.a1();
        if (!iterator.b1())
          throw NoSuchElementException.g6();
        // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call

        var it = iterator.c1();
        var maxValue = it.l56_1 + it.m56_1 | 0;
        while (iterator.b1()) {
          // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
          var it_0 = iterator.c1();
          var v = it_0.l56_1 + it_0.m56_1 | 0;
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }

        var glyphCount_0 = maxValue;
        var glyphArray = new Int32Array(glyphCount_0);
        var _iterator__ex2g4s = ranges.a1();
        while (_iterator__ex2g4s.b1()) {
          var range = _iterator__ex2g4s.c1();
          var inductionVariable_1 = range.j56_1;
          var last_1 = range.k56_1;
          if (inductionVariable_1 <= last_1)
            do {
              var glyphID = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var offset = glyphID - range.j56_1 | 0;
              glyphArray[range.l56_1 + offset | 0] = glyphID;
            }
             while (!(glyphID === last_1));
        }

        return glyphArray;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'coverageFormat=' + coverageFormat;
        throw NotImplementedError.nd('An operation is not implemented: ' + reason);
    }
  }
  d4y(_this__u8e3s4, hintedCount, $super) {
    hintedCount = hintedCount === VOID ? -1 : hintedCount;
    return $super === VOID ? this.c4y(_this__u8e3s4, hintedCount) : $super.c4y.call(this, _this__u8e3s4, hintedCount);
  }
  e4y() {
    var tmp111_safe_receiver = this.d4x('GSUB');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>' call
      var totalLength = tmp111_safe_receiver.a();
      var majorVersion = tmp111_safe_receiver.e1r();
      var minorVersion = tmp111_safe_receiver.e1r();
      if (!(majorVersion === 1)) {
        // Inline function 'kotlin.error' call
        var message = 'Unknown GSUB majorVerrsion=' + majorVersion;
        throw IllegalStateException.s4(toString_0(message));
      }
      var scriptListOffset = this.s4x(tmp111_safe_receiver);
      var featureListOffset = this.s4x(tmp111_safe_receiver);
      var lookupListOffset = this.s4x(tmp111_safe_receiver);
      if (minorVersion >= 1) {
        var featureVariationsOffset = this.u4x(tmp111_safe_receiver);
      }
      // Inline function 'kotlin.apply' call
      var this_0 = tmp111_safe_receiver.x1q(scriptListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var scriptCount = this_0.e1r();
      var inductionVariable = 0;
      if (inductionVariable < scriptCount)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var scriptTag = this_0.p1r(4);
          var scriptOffset = this.s4x(this_0);
        }
         while (inductionVariable < scriptCount);
      // Inline function 'kotlin.apply' call
      var this_1 = tmp111_safe_receiver.x1q(featureListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var featureCount = this_1.e1r();
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < featureCount)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var featureTag = this_1.p1r(4);
          var featureOffset = this.s4x(this_1);
        }
         while (inductionVariable_0 < featureCount);
      // Inline function 'kotlin.apply' call
      var this_2 = tmp111_safe_receiver.x1q(lookupListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var lookupCount = this_2.e1r();
      // Inline function 'korlibs.datastructure.mapInt' call
      var this_3 = until(0, lookupCount);
      // Inline function 'kotlin.also' call
      var this_4 = IntArrayList.x2j((coerceAtLeast(this_3.b2() - this_3.c2() | 0, 0) / this_3.a2_1 | 0) + 1 | 0);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
      var nestedFirst = this_3.c2();
      var nestedLast = this_3.b2();
      var stepArg = this_3.a2_1;
      if (stepArg <= 0)
        THROW_IAE('Step must be positive, was: ' + stepArg + '.');
      var inductionVariable_1 = nestedFirst;
      var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
      if (inductionVariable_1 <= last)
        do {
          var v = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + stepArg | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$2 = this.s4x(this_2);
          this_4.d2k(tmp$ret$2);
        }
         while (!(v === last));
      var lookups = this_4;
      var _iterator__ex2g4s = lookups.a1();
      while (_iterator__ex2g4s.b1()) {
        var lookupOffset = _iterator__ex2g4s.c1();
        // Inline function 'kotlin.apply' call
        var this_5 = this_2.x1q(lookupOffset);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
        var lookupType = this_5.e1r();
        var lookupFlag = this_5.e1r();
        var subTableCount = this_5.e1r();
        // Inline function 'korlibs.datastructure.mapInt' call
        var this_6 = this_5.j1r(subTableCount);
        // Inline function 'kotlin.also' call
        var this_7 = new Int32Array(this_6.length);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
        var inductionVariable_2 = 0;
        var last_0 = this_6.length;
        if (inductionVariable_2 < last_0)
          do {
            var n_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            this_7[n_1] = this_6[n_1] & 65535;
          }
           while (inductionVariable_2 < last_0);
        var subtableOffsets = this_7;
        var markFilteringSet = this_5.e1r();
        var inductionVariable_3 = 0;
        var last_1 = subtableOffsets.length;
        while (inductionVariable_3 < last_1) {
          var offset = subtableOffsets[inductionVariable_3];
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          // Inline function 'kotlin.apply' call
          var this_8 = this_5.x1q(offset);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
          var subsTable = this_8;
          switch (lookupType) {
            case 1:
              var substFormat = this_8.e1r();
              var coverageOffset = this.s4x(this_8);
              switch (substFormat) {
                case 1:
                  var deltaGlyphID = this_8.d1r();
                  var coverageTable = this.d4y(this_8.x1q(coverageOffset));
                  var inductionVariable_4 = 0;
                  var last_2 = coverageTable.length;
                  while (inductionVariable_4 < last_2) {
                    var glyphID = coverageTable[inductionVariable_4];
                    inductionVariable_4 = inductionVariable_4 + 1 | 0;
                    this.j4w_1.w2o(glyphID, glyphID + deltaGlyphID | 0);
                  }

                  break;
                case 2:
                  var glyphCount = this_8.e1r();
                  var coverageTable_0 = this.d4y(this_8.x1q(coverageOffset));
                  // Inline function 'korlibs.datastructure.mapInt' call

                  var this_9 = this_8.k1r(glyphCount);
                  // Inline function 'kotlin.also' call

                  var this_10 = new Int32Array(this_9.length);
                  // Inline function 'kotlin.contracts.contract' call

                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

                  var inductionVariable_5 = 0;
                  var last_3 = this_9.length;
                  if (inductionVariable_5 < last_3)
                    do {
                      var n_2 = inductionVariable_5;
                      inductionVariable_5 = inductionVariable_5 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      // Inline function 'kotlin.code' call
                      var this_11 = this_9[n_2];
                      this_10[n_2] = Char__toInt_impl_vasixd(this_11);
                    }
                     while (inductionVariable_5 < last_3);
                  var substituteGlyphIDs = this_10;
                  // Inline function 'kotlin.repeat' call

                  // Inline function 'kotlin.contracts.contract' call

                  var inductionVariable_6 = 0;
                  if (inductionVariable_6 < glyphCount)
                    do {
                      var index = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      this.j4w_1.w2o(coverageTable_0[index], substituteGlyphIDs[index]);
                    }
                     while (inductionVariable_6 < glyphCount);
                  break;
                default:
                  // Inline function 'kotlin.error' call

                  var message_0 = 'Unsupported lookupType=1, substFormat=' + substFormat;
                  throw IllegalStateException.s4(toString_0(message_0));
              }

              break;
            case 4:
              var substFormat_0 = this_8.e1r();
              if (!(substFormat_0 === 1)) {
                // Inline function 'kotlin.error' call
                var message_1 = 'For lookType=4 only substFormat=1 is supported';
                throw IllegalStateException.s4(toString_0(message_1));
              }

              var coverageOffset_0 = this.s4x(this_8);
              var ligatureSetCount = this_8.e1r();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_12 = this_8.k1r(ligatureSetCount);
              // Inline function 'kotlin.also' call

              var this_13 = new Int32Array(this_12.length);
              // Inline function 'kotlin.contracts.contract' call

              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

              var inductionVariable_7 = 0;
              var last_4 = this_12.length;
              if (inductionVariable_7 < last_4)
                do {
                  var n_3 = inductionVariable_7;
                  inductionVariable_7 = inductionVariable_7 + 1 | 0;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  // Inline function 'kotlin.code' call
                  var this_14 = this_12[n_3];
                  this_13[n_3] = Char__toInt_impl_vasixd(this_14);
                }
                 while (inductionVariable_7 < last_4);
              var ligatureSetOffsets = this_13;
              var glyphArray = this.c4y(this_8.x1q(coverageOffset_0), ligatureSetCount);
              var inductionVariable_8 = 0;
              var last_5 = ligatureSetOffsets.length - 1 | 0;
              if (inductionVariable_8 <= last_5)
                do {
                  var n_4 = inductionVariable_8;
                  inductionVariable_8 = inductionVariable_8 + 1 | 0;
                  var glyphID_0 = glyphArray[n_4];
                  var asetoffset = ligatureSetOffsets[n_4];
                  var map = LinkedHashMap.ac();
                  var codePoint = this.i4y(glyphID_0);
                  // Inline function 'kotlin.intArrayOf' call
                  var codePointIntArray = new Int32Array([codePoint]);
                  var maxComponentCount = 1;
                  // Inline function 'kotlin.apply' call
                  var this_15 = subsTable.x1q(asetoffset);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ligatureCount = this_15.e1r();
                  // Inline function 'korlibs.datastructure.mapInt' call
                  var this_16 = this_15.k1r(ligatureCount);
                  // Inline function 'kotlin.also' call
                  var this_17 = new Int32Array(this_16.length);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                  var inductionVariable_9 = 0;
                  var last_6 = this_16.length;
                  if (inductionVariable_9 < last_6)
                    do {
                      var n_5 = inductionVariable_9;
                      inductionVariable_9 = inductionVariable_9 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      // Inline function 'kotlin.code' call
                      var this_18 = this_16[n_5];
                      this_17[n_5] = Char__toInt_impl_vasixd(this_18);
                    }
                     while (inductionVariable_9 < last_6);
                  var ligatureOffsets = this_17;
                  var inductionVariable_10 = 0;
                  var last_7 = ligatureOffsets.length;
                  while (inductionVariable_10 < last_7) {
                    var offset_0 = ligatureOffsets[inductionVariable_10];
                    inductionVariable_10 = inductionVariable_10 + 1 | 0;
                    // Inline function 'kotlin.apply' call
                    var this_19 = this_15.x1q(offset_0);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    var ligatureGlyph = this_19.e1r();
                    var componentCount = this_19.e1r();
                    // Inline function 'kotlin.math.max' call
                    var a = maxComponentCount;
                    var b = componentCount + 1 | 0;
                    maxComponentCount = Math.max(a, b);
                    // Inline function 'korlibs.datastructure.mapInt' call
                    var this_20 = this_19.k1r(componentCount - 1 | 0);
                    // Inline function 'kotlin.also' call
                    var this_21 = new Int32Array(this_20.length);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                    var inductionVariable_11 = 0;
                    var last_8 = this_20.length;
                    if (inductionVariable_11 < last_8)
                      do {
                        var n_6 = inductionVariable_11;
                        inductionVariable_11 = inductionVariable_11 + 1 | 0;
                        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        // Inline function 'kotlin.code' call
                        var this_22 = this_20[n_6];
                        var tmp$ret$22 = Char__toInt_impl_vasixd(this_22);
                        this_21[n_6] = this.i4y(tmp$ret$22);
                      }
                       while (inductionVariable_11 < last_8);
                    var componentCodePoints = this_21;
                    var tmp = Companion_getInstance_12();
                    // Inline function 'kotlin.collections.plus' call
                    var tmp$ret$26 = primitiveArrayConcat([codePointIntArray, componentCodePoints]);
                    var ligature = tmp.a1h(tmp$ret$26);
                    // Inline function 'kotlin.collections.set' call
                    // Inline function 'kotlin.intArrayOf' call
                    var value = new Int32Array([ligatureGlyph]);
                    map.f3(ligature, value);
                  }
                  this.k4w_1.z2n(codePoint, new SubstitutionInfo(maxComponentCount, map));
                }
                 while (inductionVariable_8 <= last_5);
              break;
            default:
              // Inline function 'korlibs.logger.Logger.info' call

              var this_23 = Companion_getInstance_31().e4u_1;
              var level = Level_INFO_getInstance();
              var tmp_0;
              if (this_23.k2t(level)) {
                // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                var tmp$ret$30 = 'TTF.GSUB: Unsupported lookupType=' + lookupType;
                this_23.l2t(level, tmp$ret$30);
                tmp_0 = Unit_instance;
              }

              break;
          }
        }
      }
    }
    return Unit_instance;
  }
  f4y() {
    var tmp111_safe_receiver = this.d4x('COLR');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>' call
      var version = tmp111_safe_receiver.e1r();
      switch (version) {
        case 0:
        case 1:
          var numBaseGlyphRecords = tmp111_safe_receiver.e1r();
          var baseGlyphRecordsOffset = tmp111_safe_receiver.g1r();
          var layerRecordsOffset = tmp111_safe_receiver.g1r();
          var numLayerRecords = tmp111_safe_receiver.e1r();
          // Inline function 'kotlin.apply' call

          var this_0 = tmp111_safe_receiver.x1q(layerRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call

          var tmp = this;
          var tmp_0 = 0;
          // Inline function 'kotlin.arrayOfNulls' call

          var tmp_1 = fillArrayVal(Array(numLayerRecords), null);
          while (tmp_0 < numLayerRecords) {
            tmp_1[tmp_0] = new ColrLayerInfo(this, this_0.e1r(), this_0.e1r());
            tmp_0 = tmp_0 + 1 | 0;
          }

          tmp.e4w_1 = tmp_1;
          // Inline function 'kotlin.apply' call

          var this_1 = tmp111_safe_receiver.x1q(baseGlyphRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call

          var inductionVariable = 0;
          if (inductionVariable < numBaseGlyphRecords)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var info = new ColrGlyphInfoV0(this, this_1.e1r(), this_1.e1r(), this_1.e1r());
              this.f4w_1.z2n(info.f54_1, info);
            }
             while (inductionVariable < numBaseGlyphRecords);
          if (version === 1) {
            var baseGlyphListOffset = this.u4x(tmp111_safe_receiver);
            var layerListOffset = this.u4x(tmp111_safe_receiver);
            var clipListOffset = this.u4x(tmp111_safe_receiver);
            var varIdxMapOffset = this.u4x(tmp111_safe_receiver);
            var varStoreOffset = this.u4x(tmp111_safe_receiver);
            this.h4w_1.z52_1.y2();
            var tmp_2 = this;
            var tmp126_s = tmp111_safe_receiver.x1q(0);
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_2 = tmp111_safe_receiver.x1q(layerListOffset);
            var tmp_3 = 0;
            var tmp_4 = this_2.g1r();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_5 = fillArrayVal(Array(tmp_4), null);
            while (tmp_3 < tmp_4) {
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp_5[tmp_3] = this.u4x(this_2);
              tmp_3 = tmp_3 + 1 | 0;
            }
            var tmp127_layerList = toIntArray(tmp_5);
            var tmp128_sBaseOffset = tmp111_safe_receiver.x1q(baseGlyphListOffset);
            var tmp129_sLayerOffset = tmp111_safe_receiver.x1q(layerListOffset);
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_6;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            if (!(clipListOffset === 0)) {
              tmp_6 = clipListOffset;
            } else {
              tmp_6 = null;
            }
            var tmp125_safe_receiver = tmp_6;
            var tmp_7;
            if (tmp125_safe_receiver == null) {
              tmp_7 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp_7 = tmp111_safe_receiver.x1q(tmp125_safe_receiver);
            }
            var tmp130_sClipOffset = tmp_7;
            tmp_2.h4w_1 = new COLRv1(tmp127_layerList, tmp126_s, tmp128_sBaseOffset, tmp129_sLayerOffset, tmp130_sClipOffset);
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_8;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            if (!(clipListOffset === 0)) {
              tmp_8 = clipListOffset;
            } else {
              tmp_8 = null;
            }
            if (tmp_8 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              var s = tmp111_safe_receiver.x1q(clipListOffset);
              var format = s.c1r();
              // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
              var tmp_9 = 0;
              var tmp_10 = s.g1r();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_11 = fillArrayVal(Array(tmp_10), null);
              while (tmp_9 < tmp_10) {
                var tmp_12 = tmp_9;
                var startGlyphID = s.e1r();
                var endGlyphID = s.e1r();
                var clipBoxOffset = this.t4x(s);
                var inductionVariable_0 = startGlyphID;
                if (inductionVariable_0 <= endGlyphID)
                  do {
                    var glyphID = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    this.h4w_1.z52_1.w2o(glyphID, clipBoxOffset);
                  }
                   while (!(glyphID === endGlyphID));
                tmp_11[tmp_12] = Unit_instance;
                tmp_9 = tmp_9 + 1 | 0;
              }
            }
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_3 = tmp111_safe_receiver.x1q(baseGlyphListOffset);
            var tmp_13 = 0;
            var tmp_14 = this_3.g1r();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_15 = fillArrayVal(Array(tmp_14), null);
            while (tmp_13 < tmp_14) {
              var tmp_16 = tmp_13;
              var glyphID_0 = this_3.e1r();
              var paint = this.u4x(this_3);
              this.f4w_1.z2n(glyphID_0, new ColrGlyphInfoV1(this, glyphID_0, paint));
              tmp_15[tmp_16] = Unit_instance;
              tmp_13 = tmp_13 + 1 | 0;
            }
          }

          break;
        default:
          println('TTF WARNING CCOLv' + version + ' not supported');
          break;
      }
    }
    return Unit_instance;
  }
  g4y() {
    var tmp111_safe_receiver = this.d4x('cmap');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>' call
      var version = tmp111_safe_receiver.e1r();
      var numTables = tmp111_safe_receiver.e1r();
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, numTables);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var inductionVariable = this_0.y1_1;
      var last = this_0.z1_1;
      if (inductionVariable <= last)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>' call
          var tmp$ret$0 = new BaseTtfFont$readCmap$EncodingRecord(tmp111_safe_receiver.e1r(), tmp111_safe_receiver.e1r(), tmp111_safe_receiver.g1r());
          destination.h(tmp$ret$0);
        }
         while (!(item === last));
      var tables = destination;
      var index = 0;
      var _iterator__ex2g4s = tables.a1();
      while (_iterator__ex2g4s.b1()) {
        var table = _iterator__ex2g4s.c1();
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        var $this$run = tmp111_safe_receiver.x1q(table.p56_1);
        var format = $this$run.e1r();
        try {
          switch (format) {
            case 0:
              var length = $this$run.e1r();
              var language = $this$run.e1r();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_1 = $this$run.a1r(256);
              // Inline function 'kotlin.also' call

              var this_2 = new Int32Array(this_1.length);
              // Inline function 'kotlin.contracts.contract' call

              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

              var inductionVariable_0 = 0;
              var last_0 = this_1.length;
              if (inductionVariable_0 < last_0)
                do {
                  var n = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>.<anonymous>' call
                  this_2[n] = this_1[n] & 255;
                }
                 while (inductionVariable_0 < last_0);
              var glyphIdArray = this_2;
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < 256)
                do {
                  var n_0 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  this.y4w(n_0, glyphIdArray[n_0]);
                }
                 while (inductionVariable_1 < 256);
              break;
            case 2:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 4:
              var length_0 = $this$run.e1r();
              var language_0 = $this$run.e1r();
              var segCount = $this$run.e1r() / 2 | 0;
              var searchRangeS = $this$run.e1r();
              var entrySelector = $this$run.e1r();
              var rangeShift = $this$run.e1r();
              var endCount = $this$run.k1r(segCount);
              $this$run.e1r();
              var startCount = $this$run.k1r(segCount);
              var idDelta = $this$run.j1r(segCount);
              var rangeOffsetPos = $this$run.t1q();
              var idRangeOffset = $this$run.k1r(segCount);
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < segCount)
                do {
                  var n_1 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  var ec = Char__toInt_impl_vasixd(endCount[n_1]);
                  var sc = Char__toInt_impl_vasixd(startCount[n_1]);
                  var delta = idDelta[n_1];
                  var iro = Char__toInt_impl_vasixd(idRangeOffset[n_1]);
                  var inductionVariable_3 = sc;
                  if (inductionVariable_3 <= ec)
                    do {
                      var c = inductionVariable_3;
                      inductionVariable_3 = inductionVariable_3 + 1 | 0;
                      if (!(iro === 0)) {
                        var glyphIndexOffset = rangeOffsetPos + imul(n_1, 2) | 0;
                        glyphIndexOffset = glyphIndexOffset + iro | 0;
                        glyphIndexOffset = glyphIndexOffset + imul(c - sc | 0, 2) | 0;
                        index = $this$run.x1q(glyphIndexOffset).e1r();
                        if (!(index === 0)) {
                          index = index + delta | 0;
                        }
                      } else {
                        index = c + delta | 0;
                      }
                      this.x4w(c, index & 65535);
                    }
                     while (!(c === ec));
                }
                 while (inductionVariable_2 < segCount);
              break;
            case 6:
              var length_1 = $this$run.e1r();
              var language_1 = $this$run.e1r();
              var firstCode = $this$run.e1r();
              var entryCount = $this$run.e1r();
              var inductionVariable_4 = 0;
              if (inductionVariable_4 < entryCount)
                do {
                  var n_2 = inductionVariable_4;
                  inductionVariable_4 = inductionVariable_4 + 1 | 0;
                  var codePoint = firstCode + n_2 | 0;
                  this.x4w(codePoint, $this$run.e1r());
                }
                 while (inductionVariable_4 < entryCount);
              break;
            case 8:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 10:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 12:
              $this$run.e1r();
              var length_2 = $this$run.g1r();
              var language_2 = $this$run.g1r();
              var numGroups = $this$run.g1r();
              var inductionVariable_5 = 0;
              if (inductionVariable_5 < numGroups)
                do {
                  var n_3 = inductionVariable_5;
                  inductionVariable_5 = inductionVariable_5 + 1 | 0;
                  var startCharCode = $this$run.g1r();
                  var endCharCode = $this$run.g1r();
                  var startGlyphId = $this$run.g1r();
                  var inductionVariable_6 = startCharCode;
                  if (inductionVariable_6 <= endCharCode)
                    do {
                      var c_0 = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      var m = c_0 - startCharCode | 0;
                      this.x4w(c_0, startGlyphId + m | 0);
                    }
                     while (!(c_0 === endCharCode));
                }
                 while (inductionVariable_5 < numGroups);
              break;
            case 13:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            default:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
          } else {
            throw $p;
          }
        }
      }
    }
    return Unit_instance;
  }
  h4y(charIndex, default_0) {
    // Inline function 'kotlin.collections.getOrElse' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0_elvis_lhs = this.b4w_1.d3(charIndex);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.font.BaseTtfFont.getCodePointFromCharIndexOrElse.<anonymous>' call
      tmp = default_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  i4y(charIndex, default_0, $super) {
    default_0 = default_0 === VOID ? -1 : default_0;
    return $super === VOID ? this.h4y(charIndex, default_0) : $super.h4y.call(this, charIndex, default_0);
  }
  j4y(reader, codePoint, cache) {
    var g = this.m4y(codePoint);
    var skipCount = 1;
    if (this.j4u_1 && !(g == null)) {
      var subs = this.k4w_1.f1(codePoint);
      if (!(reader == null) && !(subs == null)) {
        // Inline function 'kotlin.math.min' call
        var a = reader.m1g();
        var b = subs.m4z_1;
        var inductionVariable = Math.min(a, b);
        if (2 <= inductionVariable)
          $l$loop_0: do {
            var count = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var sub = reader.y1g(0, count);
            var replacement = subs.n4z_1.d3(sub);
            if (!(replacement == null)) {
              skipCount = sub.a();
              var tmp0_elvis_lhs = this.o4y(first_1(replacement));
              var tmp;
              if (tmp0_elvis_lhs == null) {
                break $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              g = tmp;
              break $l$loop_0;
            }
          }
           while (2 <= inductionVariable);
      }
    }
    if (reader == null)
      null;
    else {
      reader.x1g(skipCount);
    }
    return g;
  }
  k4y(reader, codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.j4y(reader, codePoint, cache) : $super.j4y.call(this, reader, codePoint, cache);
  }
  l4y(codePoint, cache) {
    var tmp134_safe_receiver = this.w4w(codePoint);
    var tmp;
    if (tmp134_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByCodePoint.<anonymous>' call
      tmp = this.n4y(tmp134_safe_receiver, cache, codePoint);
    }
    return tmp;
  }
  m4y(codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.l4y(codePoint, cache) : $super.l4y.call(this, codePoint, cache);
  }
  n4y(index, cache, codePoint) {
    var cff = this.o4w_1;
    if (!(cff == null)) {
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var this_0 = this.c4w_1;
      var res = this_0.f1(index);
      if (res == null) {
        // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
        var gvector = cff.x4s(index);
        var tmp$ret$0 = new CFFGlyph(this, index, 0, 0, 0, 0, numberToInt(gvector.b4s_1), new GlyphGraphicsPath(index, gvector.a4s_1));
        this_0.z2n(index, tmp$ret$0);
      }
      return ensureNotNull(this_0.f1(index));
    }
    var tmp0_elvis_lhs = getOrNull_0(this.n4v_1, index);
    var start = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = getOrNull_0(this.n4v_1, index + 1 | 0);
    var end = tmp1_elvis_lhs == null ? start : tmp1_elvis_lhs;
    var size = end - start | 0;
    var tmp;
    if (!(size === 0)) {
      var tmp2_elvis_lhs = this.c4w_1.f1(index);
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.image.font.BaseTtfFont.runTable' call
          var tmp0_elvis_lhs_0 = this.t4w('glyf');
          var tmp_1;
          if (tmp0_elvis_lhs_0 == null) {
            tmp$ret$2 = null;
            break $l$block;
          } else {
            tmp_1 = tmp0_elvis_lhs_0;
          }
          var table = tmp_1;
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
          var $this$runTable = table.o4z();
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>.<anonymous>' call
          tmp$ret$2 = this.s4y($this$runTable.x1q(start), index);
        }
        tmp_0 = tmp$ret$2;
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.intArrayOf' call
      var tmp_2 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_3 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_4 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$9 = new Int32Array([]);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
      tmp = new SimpleGlyph(this, index, 0, 0, 0, 0, tmp_2, tmp_3, tmp_4, tmp$ret$9, this.z4v_1.f1(index).p4z_1, true);
    }
    var glyph = tmp;
    if (cache && !this.i4w_1) {
      this.c4w_1.z2n(index, glyph);
    }
    return glyph;
  }
  o4y(index, cache, codePoint, $super) {
    cache = cache === VOID ? true : cache;
    codePoint = codePoint === VOID ? -1 : codePoint;
    return $super === VOID ? this.n4y(index, cache, codePoint) : $super.n4y.call(this, index, cache, codePoint);
  }
  p4y(_this__u8e3s4) {
    var v = _this__u8e3s4.d1r();
    var i = extractSigned(v, 14, 2);
    var f = extract(v, 0, 14);
    return i + f / 16384.0;
  }
  q4y(_this__u8e3s4) {
    var v = _this__u8e3s4.g1r();
    var i = extractSigned(v, 16, 16);
    var f = extract(v, 0, 16);
    return i + f / 65536.0;
  }
  r4y(_this__u8e3s4, signed, word) {
    var tmp;
    if (!word && signed) {
      tmp = _this__u8e3s4.b1r();
    } else if (!word && !signed) {
      tmp = _this__u8e3s4.c1r();
    } else if (word && signed) {
      tmp = _this__u8e3s4.d1r();
    } else if (word && !signed) {
      tmp = _this__u8e3s4.e1r();
    } else {
      get_invalidOp();
    }
    return tmp;
  }
  s4y(_this__u8e3s4, index) {
    var ncontours = _this__u8e3s4.d1r();
    var xMin = _this__u8e3s4.d1r();
    var yMin = _this__u8e3s4.d1r();
    var xMax = _this__u8e3s4.d1r();
    var yMax = _this__u8e3s4.d1r();
    var advanceWidth = this.z4v_1.f1(index).p4z_1;
    // Inline function 'kotlin.also' call
    var tmp;
    if (ncontours < 0) {
      var ARG_1_AND_2_ARE_WORDS = 1;
      var ARGS_ARE_XY_VALUES = 2;
      var ROUND_XY_TO_GRID = 4;
      var WE_HAVE_A_SCALE = 8;
      var MORE_COMPONENTS = 32;
      var WE_HAVE_AN_X_AND_Y_SCALE = 64;
      var WE_HAVE_A_TWO_BY_TWO = 128;
      var WE_HAVE_INSTRUCTIONS = 256;
      var USE_MY_METRICS = 512;
      var OVERLAP_COMPOUND = 1024;
      var SCALED_COMPONENT_OFFSET = 2048;
      var UNSCALED_COMPONENT_OFFSET = 4096;
      // Inline function 'kotlin.collections.arrayListOf' call
      var references = ArrayList.i1();
      do {
        var flags = _this__u8e3s4.e1r();
        var glyphIndex = _this__u8e3s4.e1r();
        var signed = !((flags & ARGS_ARE_XY_VALUES) === 0);
        var words = !((flags & ARG_1_AND_2_ARE_WORDS) === 0);
        var x = this.r4y(_this__u8e3s4, signed, words);
        var y = this.r4y(_this__u8e3s4, signed, words);
        var scaleX = 1.0;
        var scaleY = 1.0;
        var scale01 = 0.0;
        var scale10 = 0.0;
        if (!((flags & WE_HAVE_A_SCALE) === 0)) {
          scaleX = this.p4y(_this__u8e3s4);
          scaleY = scaleX;
        } else if (!((flags & WE_HAVE_AN_X_AND_Y_SCALE) === 0)) {
          scaleX = this.p4y(_this__u8e3s4);
          scaleY = this.p4y(_this__u8e3s4);
        } else if (!((flags & WE_HAVE_A_TWO_BY_TWO) === 0)) {
          scaleX = this.p4y(_this__u8e3s4);
          scale01 = this.p4y(_this__u8e3s4);
          scale10 = this.p4y(_this__u8e3s4);
          scaleY = this.p4y(_this__u8e3s4);
        }
        var ref = new GlyphReference(ensureNotNull(this.o4y(glyphIndex)), x, y, scaleX, scale01, scale10, scaleY);
        // Inline function 'kotlin.collections.plusAssign' call
        references.h(ref);
      }
       while (!((flags & MORE_COMPONENTS) === 0));
      tmp = new CompositeGlyph(this, index, xMin, yMin, xMax, yMax, references, advanceWidth);
    } else {
      var contoursIndices = new Int32Array(ncontours + 1 | 0);
      contoursIndices[0] = -1;
      var inductionVariable = 1;
      if (inductionVariable <= ncontours)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          contoursIndices[n] = _this__u8e3s4.e1r();
        }
         while (!(n === ncontours));
      var instructionLength = _this__u8e3s4.e1r();
      var instructions = _this__u8e3s4.a1r(instructionLength);
      var tmp139_safe_receiver = lastOrNull(contoursIndices);
      var tmp0_elvis_lhs = tmp139_safe_receiver == null ? null : tmp139_safe_receiver + 1 | 0;
      var numPoints = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      var flags_0 = IntArrayList.x2j();
      var npos = 0;
      while (npos < numPoints) {
        var cf = _this__u8e3s4.c1r();
        flags_0.d2k(cf);
        if (!((cf & 8) === 0)) {
          var count = _this__u8e3s4.c1r();
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < count)
            do {
              var n_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              flags_0.d2k(cf);
            }
             while (inductionVariable_0 < count);
          npos = npos + (count + 1 | 0) | 0;
        } else {
          npos = npos + 1 | 0;
        }
      }
      var xPos = new Int32Array(numPoints);
      var yPos = new Int32Array(numPoints);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= 1)
        do {
          var xy = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var pos = xy === 0 ? xPos : yPos;
          var p = 0;
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < numPoints)
            do {
              var n_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var flag = flags_0.s1i(n_1);
              var b1 = !(((flag >>> (1 + xy | 0) | 0) & 1) === 0);
              var b2 = !(((flag >>> (4 + xy | 0) | 0) & 1) === 0);
              if (b1) {
                var magnitude = _this__u8e3s4.c1r();
                if (b2)
                  p = p + magnitude | 0;
                else
                  p = p - magnitude | 0;
              } else if (!b2) {
                p = p + _this__u8e3s4.d1r() | 0;
              }
              pos[n_1] = p;
            }
             while (inductionVariable_2 < numPoints);
        }
         while (inductionVariable_1 <= 1);
      tmp = new SimpleGlyph(this, index, xMin, yMin, xMax, yMax, contoursIndices, flags_0.o2k(), xPos, yPos, advanceWidth);
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BaseTtfFont.readGlyph.<anonymous>' call
    return tmp;
  }
}
class TtfFont extends BaseTtfFont {
  static d4k(d, extName, onlyReadMetadata, enableLigatures) {
    Companion_getInstance_31();
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var $this = this.p4w(d, extName, onlyReadMetadata, enableLigatures);
    $this.c4k_1 = LinkedHashMap.ac();
    $this.q4w();
    return $this;
  }
  r4w() {
    this.c4k_1.h3(Companion_instance_26.s4w(this.g4u_1.y1q()));
  }
  t4w(name) {
    return this.c4k_1.d3(name);
  }
}
class Companion_15 {
  constructor() {
    this.z4y_1 = 26;
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_25 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.arrayOfNulls' call
    var this_0 = fillArrayVal(Array(1), null);
    var elements = values_3();
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a4z_1 = this_0.concat(elements);
  }
}
class NamesInfo {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.b4z_1 = fillArrayVal(Array(26), null);
    this.c4z_1 = new Int32Array(26);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(26);
    while (tmp_1 < 26) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.d4z_1 = tmp_2;
    var tmp_3 = this;
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = fillArrayVal(Array(26), null);
    while (tmp_4 < 26) {
      tmp_5[tmp_4] = get_UTF8();
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.e4z_1 = tmp_5;
    this.f4z_1 = null;
  }
  a4x() {
    var tmp0_elvis_lhs = this.g4z(NameId_NAME_getInstance());
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.g4z(NameId_COMPLETE_NAME_getInstance()) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? 'TtfFont' : tmp1_elvis_lhs;
  }
  h4z(nameId) {
    if (this.b4z_1[nameId] == null) {
      var nameLength = this.d4z_1[nameId];
      if (nameLength < 0)
        return null;
      var string = ensureNotNull(this.f4z_1).n1r(this.c4z_1[nameId], nameLength, this.e4z_1[nameId]);
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(string) === 0) {
        tmp = string;
      } else {
        if (charSequenceGet(string, 0) === _Char___init__impl__6a9atx(0)) {
          // Inline function 'kotlin.text.filter' call
          // Inline function 'kotlin.text.filterTo' call
          var destination = StringBuilder.f();
          var inductionVariable = 0;
          var last = charSequenceLength(string);
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var element = charSequenceGet(string, index);
              // Inline function 'korlibs.image.font.NamesInfo.getName.<anonymous>' call
              if (!(element === _Char___init__impl__6a9atx(0))) {
                destination.ob(element);
              }
            }
             while (inductionVariable < last);
          tmp = destination.toString();
        } else {
          tmp = string;
        }
      }
      this.b4z_1[nameId] = tmp;
    }
    return this.b4z_1[nameId];
  }
  g4z(nameId) {
    return this.h4z(nameId.k4z_1);
  }
  l4z() {
    // Inline function 'kotlin.collections.associateWith' call
    var this_0 = values_2();
    var result = LinkedHashMap.bc(coerceAtLeast(mapCapacity(this_0.length), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.NamesInfo.toMap.<anonymous>' call
      var tmp$ret$0 = this.g4z(element);
      result.f3(element, tmp$ret$0);
    }
    return result;
  }
  toString() {
    return 'NamesInfo(' + toString_0(this.l4z()) + ')';
  }
}
class SubstitutionInfo {
  constructor(maxSequence, map) {
    this.m4z_1 = maxSequence;
    this.n4z_1 = map;
  }
}
class Table {
  constructor(id, checksum, offset, length) {
    this.t4y_1 = id;
    this.u4y_1 = checksum;
    this.v4y_1 = offset;
    this.w4y_1 = length;
    this.x4y_1 = null;
    var tmp = this;
    tmp.y4y_1 = lazy(BaseTtfFont$Table$ss$delegate$lambda(this));
  }
  o4z() {
    return _get_ss__ndcawb(this).u1i();
  }
  toString() {
    return 'Table(id=' + this.t4y_1 + ', checksum=' + this.u4y_1 + ', offset=' + this.v4y_1 + ', length=' + this.w4y_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.t4y_1);
    result = imul(result, 31) + this.u4y_1 | 0;
    result = imul(result, 31) + this.v4y_1 | 0;
    result = imul(result, 31) + this.w4y_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Table))
      return false;
    var tmp0_other_with_cast = other instanceof Table ? other : THROW_CCE();
    if (!(this.t4y_1 === tmp0_other_with_cast.t4y_1))
      return false;
    if (!(this.u4y_1 === tmp0_other_with_cast.u4y_1))
      return false;
    if (!(this.v4y_1 === tmp0_other_with_cast.v4y_1))
      return false;
    if (!(this.w4y_1 === tmp0_other_with_cast.w4y_1))
      return false;
    return true;
  }
}
class HorMetric {
  constructor(advanceWidth, lsb) {
    this.p4z_1 = advanceWidth;
    this.q4z_1 = lsb;
  }
  toString() {
    return 'HorMetric(advanceWidth=' + this.p4z_1 + ', lsb=' + this.q4z_1 + ')';
  }
  hashCode() {
    var result = this.p4z_1;
    result = imul(result, 31) + this.q4z_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HorMetric))
      return false;
    var tmp0_other_with_cast = other instanceof HorMetric ? other : THROW_CCE();
    if (!(this.p4z_1 === tmp0_other_with_cast.p4z_1))
      return false;
    if (!(this.q4z_1 === tmp0_other_with_cast.q4z_1))
      return false;
    return true;
  }
}
class Companion_17 {
  r4z(s, info) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var format = s.e1r();
    var count = s.e1r();
    var stringOffset = s.e1r();
    var inductionVariable = 0;
    if (inductionVariable < count)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var platformId = s.e1r();
        var encodingId = s.e1r();
        var languageId = s.e1r();
        var nameId = s.e1r();
        var length = s.e1r();
        var offset = s.e1r();
        if (nameId < 0 || nameId >= 26)
          continue $l$loop;
        var charset;
        switch (encodingId) {
          case 0:
            charset = get_UTF8();
            break;
          case 1:
            charset = get_UTF16_BE();
            break;
          default:
            charset = get_UTF16_BE();
            break;
        }
        if (platformId === 0 && languageId === 0 || info.d4z_1[nameId] === -1) {
          info.c4z_1[nameId] = stringOffset + offset | 0;
          info.d4z_1[nameId] = length;
          info.e4z_1[nameId] = charset;
          info.f4z_1 = s;
        }
      }
       while (inductionVariable < count);
    return Unit_instance;
  }
  s4w(s) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    if (s.g1r() === 1953784678) {
      var majorVersion = s.e1r();
      var minorVersion = s.e1r();
      var numFonts = s.g1r();
      var tableDirectoryOffsets = s.m1r(numFonts);
      if (majorVersion >= 2) {
        var dsigTag = s.g1r();
        var dsigLength = s.g1r();
        var dsigOffset = s.g1r();
      }
      s.s1q(tableDirectoryOffsets[0]);
    } else {
      s.z1q(4);
    }
    // Inline function 'kotlin.apply' call
    var this_0 = s.e1r();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(this_0 === 1) && !(this_0 === 20308)) {
      invalidOp('Not a TTF/OTF file');
    }
    var majorVersion_0 = this_0;
    // Inline function 'kotlin.apply' call
    var this_1 = s.e1r();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(this_1 === 0) && !(this_1 === 21583)) {
      invalidOp('Not a TTF/OTF file');
    }
    var minorVersion_0 = this_1;
    var numTables = s.e1r();
    var searchRange = s.e1r();
    var entrySelector = s.e1r();
    var rangeShift = s.e1r();
    // Inline function 'kotlin.collections.map' call
    var this_2 = until(0, numTables);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var inductionVariable = this_2.y1_1;
    var last = this_2.z1_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
        var tmp$ret$2 = new Table(s.p1r(4), s.g1r(), s.g1r(), s.g1r());
        destination.h(tmp$ret$2);
      }
       while (!(item === last));
    var tables = destination;
    var tablesByName = LinkedHashMap.ac();
    var _iterator__ex2g4s = tables.a1();
    while (_iterator__ex2g4s.b1()) {
      var table = _iterator__ex2g4s.c1();
      var tmp = table;
      tmp.x4y_1 = BaseTtfFont$Companion$readHeaderTables$lambda(s, table);
      // Inline function 'kotlin.collections.set' call
      var key = table.t4y_1;
      tablesByName.f3(key, table);
    }
    return tablesByName;
  }
}
class NameId extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.k4z_1 = id;
  }
}
class ColorBitmapInfo {
  constructor(indexSubTableArrayOffset, indexTablesSize, numberofIndexSubTables, colorRef, hori, vert, startGlyphIndex, endGlyphIndex, ppemX, ppemY, bitDepth, flags) {
    indexSubTableArrayOffset = indexSubTableArrayOffset === VOID ? 0 : indexSubTableArrayOffset;
    indexTablesSize = indexTablesSize === VOID ? 0 : indexTablesSize;
    numberofIndexSubTables = numberofIndexSubTables === VOID ? 0 : numberofIndexSubTables;
    colorRef = colorRef === VOID ? 0 : colorRef;
    hori = hori === VOID ? new SbitLineMetrics() : hori;
    vert = vert === VOID ? new SbitLineMetrics() : vert;
    startGlyphIndex = startGlyphIndex === VOID ? 0 : startGlyphIndex;
    endGlyphIndex = endGlyphIndex === VOID ? 0 : endGlyphIndex;
    ppemX = ppemX === VOID ? 0 : ppemX;
    ppemY = ppemY === VOID ? 0 : ppemY;
    bitDepth = bitDepth === VOID ? 0 : bitDepth;
    flags = flags === VOID ? 0 : flags;
    this.s4z_1 = indexSubTableArrayOffset;
    this.t4z_1 = indexTablesSize;
    this.u4z_1 = numberofIndexSubTables;
    this.v4z_1 = colorRef;
    this.w4z_1 = hori;
    this.x4z_1 = vert;
    this.y4z_1 = startGlyphIndex;
    this.z4z_1 = endGlyphIndex;
    this.a50_1 = ppemX;
    this.b50_1 = ppemY;
    this.c50_1 = bitDepth;
    this.d50_1 = flags;
  }
  toString() {
    return 'ColorBitmapInfo(indexSubTableArrayOffset=' + this.s4z_1 + ', indexTablesSize=' + this.t4z_1 + ', numberofIndexSubTables=' + this.u4z_1 + ', colorRef=' + this.v4z_1 + ', hori=' + this.w4z_1.toString() + ', vert=' + this.x4z_1.toString() + ', startGlyphIndex=' + this.y4z_1 + ', endGlyphIndex=' + this.z4z_1 + ', ppemX=' + this.a50_1 + ', ppemY=' + this.b50_1 + ', bitDepth=' + this.c50_1 + ', flags=' + this.d50_1 + ')';
  }
  hashCode() {
    var result = this.s4z_1;
    result = imul(result, 31) + this.t4z_1 | 0;
    result = imul(result, 31) + this.u4z_1 | 0;
    result = imul(result, 31) + this.v4z_1 | 0;
    result = imul(result, 31) + this.w4z_1.hashCode() | 0;
    result = imul(result, 31) + this.x4z_1.hashCode() | 0;
    result = imul(result, 31) + this.y4z_1 | 0;
    result = imul(result, 31) + this.z4z_1 | 0;
    result = imul(result, 31) + this.a50_1 | 0;
    result = imul(result, 31) + this.b50_1 | 0;
    result = imul(result, 31) + this.c50_1 | 0;
    result = imul(result, 31) + this.d50_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorBitmapInfo))
      return false;
    var tmp0_other_with_cast = other instanceof ColorBitmapInfo ? other : THROW_CCE();
    if (!(this.s4z_1 === tmp0_other_with_cast.s4z_1))
      return false;
    if (!(this.t4z_1 === tmp0_other_with_cast.t4z_1))
      return false;
    if (!(this.u4z_1 === tmp0_other_with_cast.u4z_1))
      return false;
    if (!(this.v4z_1 === tmp0_other_with_cast.v4z_1))
      return false;
    if (!this.w4z_1.equals(tmp0_other_with_cast.w4z_1))
      return false;
    if (!this.x4z_1.equals(tmp0_other_with_cast.x4z_1))
      return false;
    if (!(this.y4z_1 === tmp0_other_with_cast.y4z_1))
      return false;
    if (!(this.z4z_1 === tmp0_other_with_cast.z4z_1))
      return false;
    if (!(this.a50_1 === tmp0_other_with_cast.a50_1))
      return false;
    if (!(this.b50_1 === tmp0_other_with_cast.b50_1))
      return false;
    if (!(this.c50_1 === tmp0_other_with_cast.c50_1))
      return false;
    if (!(this.d50_1 === tmp0_other_with_cast.d50_1))
      return false;
    return true;
  }
}
class SbitLineMetrics {
  constructor(ascender, descender, widthMax, caretSlopeNumerator, caretSlopeDenominator, caretOffset, minOriginSB, minAdvanceSB, maxBeforeBL, minAfterBL, pad1, pad2) {
    ascender = ascender === VOID ? 0 : ascender;
    descender = descender === VOID ? 0 : descender;
    widthMax = widthMax === VOID ? 0 : widthMax;
    caretSlopeNumerator = caretSlopeNumerator === VOID ? 0 : caretSlopeNumerator;
    caretSlopeDenominator = caretSlopeDenominator === VOID ? 0 : caretSlopeDenominator;
    caretOffset = caretOffset === VOID ? 0 : caretOffset;
    minOriginSB = minOriginSB === VOID ? 0 : minOriginSB;
    minAdvanceSB = minAdvanceSB === VOID ? 0 : minAdvanceSB;
    maxBeforeBL = maxBeforeBL === VOID ? 0 : maxBeforeBL;
    minAfterBL = minAfterBL === VOID ? 0 : minAfterBL;
    pad1 = pad1 === VOID ? 0 : pad1;
    pad2 = pad2 === VOID ? 0 : pad2;
    this.e50_1 = ascender;
    this.f50_1 = descender;
    this.g50_1 = widthMax;
    this.h50_1 = caretSlopeNumerator;
    this.i50_1 = caretSlopeDenominator;
    this.j50_1 = caretOffset;
    this.k50_1 = minOriginSB;
    this.l50_1 = minAdvanceSB;
    this.m50_1 = maxBeforeBL;
    this.n50_1 = minAfterBL;
    this.o50_1 = pad1;
    this.p50_1 = pad2;
  }
  toString() {
    return 'SbitLineMetrics(ascender=' + this.e50_1 + ', descender=' + this.f50_1 + ', widthMax=' + this.g50_1 + ', caretSlopeNumerator=' + this.h50_1 + ', caretSlopeDenominator=' + this.i50_1 + ', caretOffset=' + this.j50_1 + ', minOriginSB=' + this.k50_1 + ', minAdvanceSB=' + this.l50_1 + ', maxBeforeBL=' + this.m50_1 + ', minAfterBL=' + this.n50_1 + ', pad1=' + this.o50_1 + ', pad2=' + this.p50_1 + ')';
  }
  hashCode() {
    var result = this.e50_1;
    result = imul(result, 31) + this.f50_1 | 0;
    result = imul(result, 31) + this.g50_1 | 0;
    result = imul(result, 31) + this.h50_1 | 0;
    result = imul(result, 31) + this.i50_1 | 0;
    result = imul(result, 31) + this.j50_1 | 0;
    result = imul(result, 31) + this.k50_1 | 0;
    result = imul(result, 31) + this.l50_1 | 0;
    result = imul(result, 31) + this.m50_1 | 0;
    result = imul(result, 31) + this.n50_1 | 0;
    result = imul(result, 31) + this.o50_1 | 0;
    result = imul(result, 31) + this.p50_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SbitLineMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof SbitLineMetrics ? other : THROW_CCE();
    if (!(this.e50_1 === tmp0_other_with_cast.e50_1))
      return false;
    if (!(this.f50_1 === tmp0_other_with_cast.f50_1))
      return false;
    if (!(this.g50_1 === tmp0_other_with_cast.g50_1))
      return false;
    if (!(this.h50_1 === tmp0_other_with_cast.h50_1))
      return false;
    if (!(this.i50_1 === tmp0_other_with_cast.i50_1))
      return false;
    if (!(this.j50_1 === tmp0_other_with_cast.j50_1))
      return false;
    if (!(this.k50_1 === tmp0_other_with_cast.k50_1))
      return false;
    if (!(this.l50_1 === tmp0_other_with_cast.l50_1))
      return false;
    if (!(this.m50_1 === tmp0_other_with_cast.m50_1))
      return false;
    if (!(this.n50_1 === tmp0_other_with_cast.n50_1))
      return false;
    if (!(this.o50_1 === tmp0_other_with_cast.o50_1))
      return false;
    if (!(this.p50_1 === tmp0_other_with_cast.p50_1))
      return false;
    return true;
  }
}
class BitmapGlyphInfo {
  constructor(glyphID, imageFormat, offset, size, info, height, width, horiBearingX, horiBearingY, horiAdvance, vertBearingX, vertBearingY, vertAdvance) {
    imageFormat = imageFormat === VOID ? 0 : imageFormat;
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? 0 : size;
    height = height === VOID ? 0 : height;
    width = width === VOID ? 0 : width;
    horiBearingX = horiBearingX === VOID ? 0 : horiBearingX;
    horiBearingY = horiBearingY === VOID ? 0 : horiBearingY;
    horiAdvance = horiAdvance === VOID ? 0 : horiAdvance;
    vertBearingX = vertBearingX === VOID ? 0 : vertBearingX;
    vertBearingY = vertBearingY === VOID ? 0 : vertBearingY;
    vertAdvance = vertAdvance === VOID ? 0 : vertAdvance;
    this.q50_1 = glyphID;
    this.r50_1 = imageFormat;
    this.s50_1 = offset;
    this.t50_1 = size;
    this.u50_1 = info;
    this.v50_1 = height;
    this.w50_1 = width;
    this.x50_1 = horiBearingX;
    this.y50_1 = horiBearingY;
    this.z50_1 = horiAdvance;
    this.a51_1 = vertBearingX;
    this.b51_1 = vertBearingY;
    this.c51_1 = vertAdvance;
    this.d51_1 = null;
    this.e51_1 = null;
  }
  f51() {
    return this.u50_1.w4z_1.f50_1;
  }
  g51(cache) {
    var tmp0_elvis_lhs = this.e51_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0;
      try {
        tmp_0 = PNG_getInstance().k51(toSyncStream(ensureNotNull(this.d51_1)));
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          println('Error in TtfFont.BitmapGlyphInfo: ' + e.message);
          // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
          var tmp$ret$0 = get_Bitmaps_transparent();
          tmp_1 = get_bmp(tmp$ret$0);
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var bmp = tmp;
    if (cache)
      this.e51_1 = bmp;
    return bmp;
  }
  l51(cache, $super) {
    cache = cache === VOID ? false : cache;
    return $super === VOID ? this.g51(cache) : $super.g51.call(this, cache);
  }
  toString() {
    return 'BitmapGlyphInfo(glyphID=' + this.q50_1 + ', imageFormat=' + this.r50_1 + ', offset=' + this.s50_1 + ', size=' + this.t50_1 + ', info=' + this.u50_1.toString() + ', height=' + this.v50_1 + ', width=' + this.w50_1 + ', horiBearingX=' + this.x50_1 + ', horiBearingY=' + this.y50_1 + ', horiAdvance=' + this.z50_1 + ', vertBearingX=' + this.a51_1 + ', vertBearingY=' + this.b51_1 + ', vertAdvance=' + this.c51_1 + ')';
  }
  hashCode() {
    var result = this.q50_1;
    result = imul(result, 31) + this.r50_1 | 0;
    result = imul(result, 31) + this.s50_1 | 0;
    result = imul(result, 31) + this.t50_1 | 0;
    result = imul(result, 31) + this.u50_1.hashCode() | 0;
    result = imul(result, 31) + this.v50_1 | 0;
    result = imul(result, 31) + this.w50_1 | 0;
    result = imul(result, 31) + this.x50_1 | 0;
    result = imul(result, 31) + this.y50_1 | 0;
    result = imul(result, 31) + this.z50_1 | 0;
    result = imul(result, 31) + this.a51_1 | 0;
    result = imul(result, 31) + this.b51_1 | 0;
    result = imul(result, 31) + this.c51_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapGlyphInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapGlyphInfo ? other : THROW_CCE();
    if (!(this.q50_1 === tmp0_other_with_cast.q50_1))
      return false;
    if (!(this.r50_1 === tmp0_other_with_cast.r50_1))
      return false;
    if (!(this.s50_1 === tmp0_other_with_cast.s50_1))
      return false;
    if (!(this.t50_1 === tmp0_other_with_cast.t50_1))
      return false;
    if (!this.u50_1.equals(tmp0_other_with_cast.u50_1))
      return false;
    if (!(this.v50_1 === tmp0_other_with_cast.v50_1))
      return false;
    if (!(this.w50_1 === tmp0_other_with_cast.w50_1))
      return false;
    if (!(this.x50_1 === tmp0_other_with_cast.x50_1))
      return false;
    if (!(this.y50_1 === tmp0_other_with_cast.y50_1))
      return false;
    if (!(this.z50_1 === tmp0_other_with_cast.z50_1))
      return false;
    if (!(this.a51_1 === tmp0_other_with_cast.a51_1))
      return false;
    if (!(this.b51_1 === tmp0_other_with_cast.b51_1))
      return false;
    if (!(this.c51_1 === tmp0_other_with_cast.c51_1))
      return false;
    return true;
  }
}
class ColorLine {
  constructor(cycle, stops) {
    this.m51_1 = cycle;
    this.n51_1 = stops;
  }
  o51(paint, palette) {
    var _iterator__ex2g4s = this.n51_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var stop = _iterator__ex2g4s.c1();
      paint.q52(stop.p51_1, RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(palette.j4b_1, stop.q51_1), stop.r51_1));
    }
  }
  toString() {
    return 'ColorLine(cycle=' + this.m51_1.toString() + ', stops=' + toString_0(this.n51_1) + ')';
  }
  hashCode() {
    var result = this.m51_1.hashCode();
    result = imul(result, 31) + hashCode(this.n51_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorLine))
      return false;
    var tmp0_other_with_cast = other instanceof ColorLine ? other : THROW_CCE();
    if (!this.m51_1.equals(tmp0_other_with_cast.m51_1))
      return false;
    if (!equals(this.n51_1, tmp0_other_with_cast.n51_1))
      return false;
    return true;
  }
}
class ColorStop {
  constructor(stopOffset, paletteIndex, alpha) {
    this.p51_1 = stopOffset;
    this.q51_1 = paletteIndex;
    this.r51_1 = alpha;
  }
}
class Colrv1Paint extends Enum {
  constructor(name, ordinal) {
    super(name, ordinal);
    this.t52_1 = this.k3_1 + 1 | 0;
  }
}
class COLRv1 {
  constructor(layerList, s, sBaseOffset, sLayerOffset, sClipOffset) {
    var tmp;
    if (layerList === VOID) {
      // Inline function 'kotlin.intArrayOf' call
      tmp = new Int32Array([]);
    } else {
      tmp = layerList;
    }
    layerList = tmp;
    var tmp_0;
    if (s === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0 = new Int8Array([]);
      tmp_0 = new FastByteArrayInputStream(tmp$ret$0);
    } else {
      tmp_0 = s;
    }
    s = tmp_0;
    var tmp_1;
    if (sBaseOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_0 = new Int8Array([]);
      tmp_1 = new FastByteArrayInputStream(tmp$ret$0_0);
    } else {
      tmp_1 = sBaseOffset;
    }
    sBaseOffset = tmp_1;
    var tmp_2;
    if (sLayerOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_1 = new Int8Array([]);
      tmp_2 = new FastByteArrayInputStream(tmp$ret$0_1);
    } else {
      tmp_2 = sLayerOffset;
    }
    sLayerOffset = tmp_2;
    sClipOffset = sClipOffset === VOID ? null : sClipOffset;
    this.u52_1 = layerList;
    this.v52_1 = s;
    this.w52_1 = sBaseOffset;
    this.x52_1 = sLayerOffset;
    this.y52_1 = sClipOffset;
    this.z52_1 = IntIntMap.x2o();
  }
}
class Contour {
  constructor(x, y, onCurve) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    onCurve = onCurve === VOID ? false : onCurve;
    this.a53_1 = x;
    this.b53_1 = y;
    this.c53_1 = onCurve;
  }
  toString() {
    return 'Contour(x=' + this.a53_1 + ', y=' + this.b53_1 + ', onCurve=' + this.c53_1 + ')';
  }
  hashCode() {
    var result = this.a53_1;
    result = imul(result, 31) + this.b53_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.c53_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Contour))
      return false;
    var tmp0_other_with_cast = other instanceof Contour ? other : THROW_CCE();
    if (!(this.a53_1 === tmp0_other_with_cast.a53_1))
      return false;
    if (!(this.b53_1 === tmp0_other_with_cast.b53_1))
      return false;
    if (!(this.c53_1 === tmp0_other_with_cast.c53_1))
      return false;
    return true;
  }
}
class GlyphReference {
  constructor(glyph, x, y, scaleX, scale01, scale10, scaleY) {
    this.d53_1 = glyph;
    this.e53_1 = x;
    this.f53_1 = y;
    this.g53_1 = scaleX;
    this.h53_1 = scale01;
    this.i53_1 = scale10;
    this.j53_1 = scaleY;
  }
  toString() {
    return 'GlyphReference(glyph=' + toString_0(this.d53_1) + ', x=' + this.e53_1 + ', y=' + this.f53_1 + ', scaleX=' + this.g53_1 + ', scale01=' + this.h53_1 + ', scale10=' + this.i53_1 + ', scaleY=' + this.j53_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.d53_1);
    result = imul(result, 31) + this.e53_1 | 0;
    result = imul(result, 31) + this.f53_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.g53_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.h53_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i53_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j53_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphReference))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphReference ? other : THROW_CCE();
    if (!equals(this.d53_1, tmp0_other_with_cast.d53_1))
      return false;
    if (!(this.e53_1 === tmp0_other_with_cast.e53_1))
      return false;
    if (!(this.f53_1 === tmp0_other_with_cast.f53_1))
      return false;
    if (!equals(this.g53_1, tmp0_other_with_cast.g53_1))
      return false;
    if (!equals(this.h53_1, tmp0_other_with_cast.h53_1))
      return false;
    if (!equals(this.i53_1, tmp0_other_with_cast.i53_1))
      return false;
    if (!equals(this.j53_1, tmp0_other_with_cast.j53_1))
      return false;
    return true;
  }
}
class ColrLayerInfo {
  constructor($outer, glyphID, paletteIndex) {
    this.m53_1 = $outer;
    this.k53_1 = glyphID;
    this.l53_1 = paletteIndex;
  }
  n53(pal) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = new RgbaArray(getCyclic(this.m53_1.g4w_1, pal).j4b_1);
    var index = this.l53_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= index ? index < this_0.d1() : false) {
      tmp = this_0.f1(index);
    } else {
      // Inline function 'korlibs.image.font.ColrLayerInfo.color.<anonymous>' call
      tmp = new RGBA(Colors_getInstance().o3z_1);
    }
    return tmp.i4d_1;
  }
  o53() {
    return this.n53(0);
  }
  p53(pal) {
    var tmp135_safe_receiver = this.m53_1.o4y(this.k53_1);
    var tmp136_safe_receiver = tmp135_safe_receiver == null ? null : tmp135_safe_receiver.m22();
    var tmp;
    if (tmp136_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.ColrLayerInfo.getShape.<anonymous>' call
      tmp = new FillShape(tmp136_safe_receiver.z53_1, null, new RGBA(this.n53(pal)));
    }
    return tmp;
  }
  toString() {
    return 'ColrLayerInfo(' + this.k53_1 + ', ' + this.l53_1 + ', ' + RGBA__toString_impl_4lw6dp(this.o53()) + ')';
  }
}
class ColrGlyphInfo {}
function getColorShape$default(pal, $super) {
  pal = pal === VOID ? 0 : pal;
  return $super === VOID ? this.a54(pal) : $super.a54.call(this, pal);
}
class ColrGlyphInfoV1 {
  constructor($outer, glyphID, paint) {
    this.e54_1 = $outer;
    this.c54_1 = glyphID;
    this.d54_1 = paint;
  }
  a54(pal) {
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.apply' call
    var this_0 = new ShapeBuilder(null, null);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    var paintS = this.e54_1.h4w_1.w52_1.x1q(this.d54_1);
    try {
      this.e54_1.b4y(this.c54_1, paintS, this_0, pal, 0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    return this_0.u4k();
  }
  toString() {
    return 'ColrGlyphInfoV1[' + this.c54_1 + '][' + this.d54_1 + ']';
  }
}
class ColrGlyphInfoV0 {
  constructor($outer, glyphID, firstLayerIndex, numLayers) {
    this.i54_1 = $outer;
    this.f54_1 = glyphID;
    this.g54_1 = firstLayerIndex;
    this.h54_1 = numLayers;
  }
  f1(index) {
    return this.i54_1.e4w_1[this.g54_1 + index | 0];
  }
  b4t() {
    var tmp = 0;
    var tmp_0 = this.h54_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = this.f1(tmp_2);
      tmp = tmp + 1 | 0;
    }
    return toList_1(tmp_1);
  }
  a54(pal) {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = this.b4t();
    var destination = ArrayList.i1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.font.ColrGlyphInfoV0.getColorShape.<anonymous>' call
      var tmp0_safe_receiver = element.p53(pal);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(tmp0_safe_receiver);
      }
    }
    return new CompoundShape(destination);
  }
  toString() {
    return 'ColrGlyphInfoV0[' + this.f54_1 + '][' + this.h54_1 + '](' + toString_0(this.b4t()) + ')';
  }
}
class GlyphGraphicsPath {
  constructor(glpyhIndex, path) {
    this.y53_1 = glpyhIndex;
    this.z53_1 = path;
  }
  b3e(p) {
    this.z53_1.b3e(p);
  }
  d3e(p) {
    this.z53_1.d3e(p);
  }
  e3e(c, a) {
    this.z53_1.e3e(c, a);
  }
  g3e(c1, c2, a) {
    this.z53_1.g3e(c1, c2, a);
  }
  y5() {
    this.z53_1.y5();
  }
  n3n(p0, p1) {
    this.z53_1.n3n(p0, p1);
  }
  o3n(a, c, r) {
    this.z53_1.o3n(a, c, r);
  }
  g1() {
    return this.z53_1.g1();
  }
  p3n(rect) {
    this.z53_1.p3n(rect);
  }
  q3n(pos, size) {
    this.z53_1.q3n(pos, size);
  }
  r3n(x, y, width, height) {
    this.z53_1.r3n(x, y, width, height);
  }
  s3n(x, y, w, h, rtl, rtr, rbr, rbl) {
    this.z53_1.s3n(x, y, w, h, rtl, rtr, rbr, rbl);
  }
  t3n(center, r, start, end, counterclockwise) {
    this.z53_1.t3n(center, r, start, end, counterclockwise);
  }
  j38(center, radius) {
    this.z53_1.j38(center, radius);
  }
  v3n(x) {
    this.z53_1.v3n(x);
  }
  w3n(y) {
    this.z53_1.w3n(y);
  }
  x3n(x) {
    this.z53_1.x3n(x);
  }
  y3n(y) {
    this.z53_1.y3n(y);
  }
  z3n(delta) {
    this.z53_1.z3n(delta);
  }
  a3o(delta) {
    this.z53_1.a3o(delta);
  }
  n2f(m) {
    return this.z53_1.n2f(m);
  }
  m3n() {
    return this.z53_1.m3n();
  }
  c3e() {
    return this.z53_1.p3e_1;
  }
  toString() {
    return 'GlyphGraphicsPath(glpyhIndex=' + this.y53_1 + ', "' + toSvgPathString(this.z53_1) + '")';
  }
  hashCode() {
    var result = this.y53_1;
    result = imul(result, 31) + this.z53_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphGraphicsPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphGraphicsPath ? other : THROW_CCE();
    if (!(this.y53_1 === tmp0_other_with_cast.y53_1))
      return false;
    if (!this.z53_1.equals(tmp0_other_with_cast.z53_1))
      return false;
    return true;
  }
}
class Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box) {
    boxApply(this, $box);
    this.x53_1 = $outer;
    this.q53_1 = index;
    this.r53_1 = xMin;
    this.s53_1 = yMin;
    this.t53_1 = xMax;
    this.u53_1 = yMax;
    this.v53_1 = advanceWidth;
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Glyph.metrics1px.<anonymous>' call
    var xMin_0 = this.r53_1;
    var yMin_0 = this.s53_1;
    var xMax_0 = this.t53_1;
    var yMax_0 = this.u53_1;
    if (xMin_0 === 0 && yMin_0 === 0 && xMax_0 === 0 && yMax_0 === 0) {
      var sClipOffset = this.x53_1.h4w_1.y52_1;
      var glyphIDToClipOffset = this.x53_1.h4w_1.z52_1;
      var tmp_0;
      if (!(sClipOffset == null) && glyphIDToClipOffset.wo(this.q53_1)) {
        var clipOffset = glyphIDToClipOffset.f1(this.q53_1);
        tmp_0 = this.x53_1.z4x(sClipOffset.x1q(clipOffset));
      } else {
        var tmp137_safe_receiver = this.j54();
        var tmp138_safe_receiver = tmp137_safe_receiver == null ? null : tmp137_safe_receiver.b54();
        tmp_0 = tmp138_safe_receiver == null ? null : tmp138_safe_receiver.k54();
      }
      var bounds = tmp_0;
      if (!(bounds == null)) {
        xMin_0 = numberToInt(bounds.t26());
        xMax_0 = numberToInt(bounds.u26());
        yMin_0 = numberToInt(bounds.v26());
        yMax_0 = numberToInt(bounds.w26());
      }
    }
    var size = this.x53_1.p4v_1;
    var scale = this.x53_1.x4f(size);
    tmp.w53_1 = new GlyphMetrics(size, true, -1, Companion_getInstance_4().p2e(xMin_0 * scale, yMin_0 * scale, xMax_0 * scale, yMax_0 * scale), this.v53_1 * scale);
  }
  j54() {
    return this.x53_1.f4w_1.f1(this.q53_1);
  }
  l54() {
    return this.x53_1.d4w_1.d3(this.q53_1);
  }
}
class CompositeGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, refs, advanceWidth, $box) {
    if ($box === VOID)
      $box = {};
    $box.x54_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.u54_1 = refs;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.u54_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>' call
      var gpath = item.d53_1.m22().z53_1;
      // Inline function 'kotlin.also' call
      var this_1 = new GlyphGraphicsPath(item.d53_1.q53_1, new VectorPath(IntArrayList.x2j(gpath.j3e_1.d1()), DoubleArrayList.r2k(gpath.k3e_1.d1())));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>.<anonymous>' call
      var m = Companion_getInstance_5().q29().o2a(item.g53_1, item.j53_1).u2a(item.e53_1, -item.f53_1 | 0);
      this_1.z53_1.n3o(item.d53_1.m22().z53_1, m);
      destination.h(this_1);
    }
    tmp.v54_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>' call
    var commandsSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = this.v54_1;
    var n = 0;
    while (n < this_2.d1()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var gpath_0 = this_2.f1(_unary__edvuaz);
      commandsSize = commandsSize + gpath_0.z53_1.j3e_1.d1() | 0;
      dataSize = dataSize + gpath_0.z53_1.k3e_1.d1() | 0;
    }
    // Inline function 'kotlin.also' call
    var this_3 = new GlyphGraphicsPath(index, new VectorPath(IntArrayList.x2j(commandsSize), DoubleArrayList.r2k(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_4 = this.v54_1;
    var n_0 = 0;
    while (n_0 < this_4.d1()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var it = this_4.f1(_unary__edvuaz_0);
      this_3.z53_1.o3o(it.z53_1);
    }
    tmp_0.w54_1 = this_3;
  }
  toString() {
    return 'CompositeGlyph[' + this.v53_1 + '](' + toString_0(this.u54_1) + ')';
  }
  m22() {
    return this.w54_1;
  }
}
class CFFGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, advanceWidth, path, $box) {
    if ($box === VOID)
      $box = {};
    $box.i55_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.g55_1 = path;
    this.h55_1 = listOf_0(this.g55_1);
  }
  m22() {
    return this.g55_1;
  }
}
class SimpleGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, contoursIndices, flags, xPos, yPos, advanceWidth, dummy, $box) {
    if ($box === VOID)
      $box = {};
    dummy = dummy === VOID ? false : dummy;
    $box.y55_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.r55_1 = contoursIndices;
    this.s55_1 = flags;
    this.t55_1 = xPos;
    this.u55_1 = yPos;
    this.v55_1 = dummy;
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>' call
    var commandSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    this.y55_1;
    var inductionVariable = 0;
    var last = this.r55_1.length - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var cstart = this.r55_1[n] + 1 | 0;
        var cend = this.r55_1[n + 1 | 0];
        var csize = (cend - cstart | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
        commandSize = commandSize + (1 + imul(csize, 2) | 0) | 0;
        dataSize = dataSize + (2 + imul(csize, 8) | 0) | 0;
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = new GlyphGraphicsPath(index, new VectorPath(IntArrayList.x2j(commandSize), DoubleArrayList.r2k(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    var this_1 = this.y55_1;
    var inductionVariable_0 = 0;
    var last_0 = this.r55_1.length - 1 | 0;
    if (inductionVariable_0 < last_0)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var cstart_0 = this.r55_1[n_0] + 1 | 0;
        var cend_0 = this.r55_1[n_0 + 1 | 0];
        var csize_0 = (cend_0 - cstart_0 | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
        var curr = this.z55(cend_0, this_1.l4u_1[0]);
        var next = this.z55(cstart_0, this_1.l4u_1[1]);
        if (curr.c53_1) {
          this_0.b3e(Vector2D.y28(curr.a53_1, -curr.b53_1 | 0));
        } else if (next.c53_1) {
          this_0.b3e(Vector2D.y28(next.a53_1, -next.b53_1 | 0));
        } else {
          this_0.b3e(Vector2D.y28(imul(curr.a53_1 + next.a53_1 | 0, numberToInt(0.5)), -numberToInt((curr.b53_1 + next.b53_1 | 0) * 0.5) | 0));
        }
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < csize_0)
          do {
            var cpos = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var prev = curr;
            curr = next;
            next = this.z55(cstart_0 + ((cpos + 1 | 0) % csize_0 | 0) | 0, this_1.l4u_1[(cpos + 2 | 0) % 3 | 0]);
            if (curr.c53_1) {
              this_0.d3e(Vector2D.y28(curr.a53_1, -curr.b53_1 | 0));
            } else {
              var prev2X = prev.a53_1;
              var prev2Y = prev.b53_1;
              var next2X = next.a53_1;
              var next2Y = next.b53_1;
              if (!prev.c53_1) {
                prev2X = numberToInt((curr.a53_1 + prev.a53_1 | 0) * 0.5);
                prev2Y = numberToInt((curr.b53_1 + prev.b53_1 | 0) * 0.5);
                this_0.d3e(Vector2D.y28(prev2X, -prev2Y | 0));
              }
              if (!next.c53_1) {
                next2X = numberToInt((curr.a53_1 + next.a53_1 | 0) * 0.5);
                next2Y = numberToInt((curr.b53_1 + next.b53_1 | 0) * 0.5);
              }
              this_0.d3e(Vector2D.y28(prev2X, -prev2Y | 0));
              this_0.e3e(Vector2D.y28(curr.a53_1, -curr.b53_1 | 0), Vector2D.y28(next2X, -next2Y | 0));
            }
          }
           while (inductionVariable_1 < csize_0);
        this_0.y5();
      }
       while (inductionVariable_0 < last_0);
    tmp.w55_1 = this_0;
    this.x55_1 = listOf_0(this.w55_1);
  }
  toString() {
    return 'SimpleGlyph' + (this.v55_1 ? 'Dummy' : '') + '[' + this.q53_1 + '](advance=' + this.v53_1 + ') : ' + this.w55_1.toString();
  }
  a56(n) {
    return !((this.s55_1[n] & 1) === 0);
  }
  z55(n, out) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.contour.<anonymous>' call
    out.a53_1 = this.t55_1[n];
    out.b53_1 = this.u55_1[n];
    out.c53_1 = this.a56(n);
    return out;
  }
  m22() {
    return this.w55_1;
  }
}
class BaseTtfFont$readCblc$Subtable {
  constructor(firstGlyphIndex, lastGlyphIndex, additionalOffsetToIndexSubtable) {
    this.b56_1 = firstGlyphIndex;
    this.c56_1 = lastGlyphIndex;
    this.d56_1 = additionalOffsetToIndexSubtable;
  }
  e56() {
    return this.c56_1 - this.b56_1 | 0;
  }
  toString() {
    return 'Subtable(firstGlyphIndex=' + this.b56_1 + ', lastGlyphIndex=' + this.c56_1 + ', additionalOffsetToIndexSubtable=' + this.d56_1 + ')';
  }
  hashCode() {
    var result = this.b56_1;
    result = imul(result, 31) + this.c56_1 | 0;
    result = imul(result, 31) + this.d56_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCblc$Subtable))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCblc$Subtable ? other : THROW_CCE();
    if (!(this.b56_1 === tmp0_other_with_cast.b56_1))
      return false;
    if (!(this.c56_1 === tmp0_other_with_cast.c56_1))
      return false;
    if (!(this.d56_1 === tmp0_other_with_cast.d56_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readSbix$StrikeInfo {
  constructor(ppem, ppi, strikeOffset, offsets) {
    this.f56_1 = ppem;
    this.g56_1 = ppi;
    this.h56_1 = strikeOffset;
    this.i56_1 = offsets;
  }
  toString() {
    return 'StrikeInfo(ppem=' + this.f56_1 + ', ppi=' + this.g56_1 + ', strikeOffset=' + this.h56_1 + ', offsets=' + this.i56_1.toString() + ')';
  }
  hashCode() {
    var result = this.f56_1;
    result = imul(result, 31) + this.g56_1 | 0;
    result = imul(result, 31) + this.h56_1 | 0;
    result = imul(result, 31) + this.i56_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readSbix$StrikeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readSbix$StrikeInfo ? other : THROW_CCE();
    if (!(this.f56_1 === tmp0_other_with_cast.f56_1))
      return false;
    if (!(this.g56_1 === tmp0_other_with_cast.g56_1))
      return false;
    if (!(this.h56_1 === tmp0_other_with_cast.h56_1))
      return false;
    if (!this.i56_1.equals(tmp0_other_with_cast.i56_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readCoverage$RangeInfo {
  constructor(start, endInclusive, index) {
    this.j56_1 = start;
    this.k56_1 = endInclusive;
    this.l56_1 = index;
    this.m56_1 = (this.k56_1 - this.j56_1 | 0) + 1 | 0;
  }
  toString() {
    return 'RangeInfo(start=' + this.j56_1 + ', endInclusive=' + this.k56_1 + ', index=' + this.l56_1 + ')';
  }
  hashCode() {
    var result = this.j56_1;
    result = imul(result, 31) + this.k56_1 | 0;
    result = imul(result, 31) + this.l56_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCoverage$RangeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCoverage$RangeInfo ? other : THROW_CCE();
    if (!(this.j56_1 === tmp0_other_with_cast.j56_1))
      return false;
    if (!(this.k56_1 === tmp0_other_with_cast.k56_1))
      return false;
    if (!(this.l56_1 === tmp0_other_with_cast.l56_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readCmap$EncodingRecord {
  constructor(platformId, encodingId, offset) {
    this.n56_1 = platformId;
    this.o56_1 = encodingId;
    this.p56_1 = offset;
  }
  toString() {
    return 'EncodingRecord(platformId=' + this.n56_1 + ', encodingId=' + this.o56_1 + ', offset=' + this.p56_1 + ')';
  }
  hashCode() {
    var result = this.n56_1;
    result = imul(result, 31) + this.o56_1 | 0;
    result = imul(result, 31) + this.p56_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCmap$EncodingRecord))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCmap$EncodingRecord ? other : THROW_CCE();
    if (!(this.n56_1 === tmp0_other_with_cast.n56_1))
      return false;
    if (!(this.o56_1 === tmp0_other_with_cast.o56_1))
      return false;
    if (!(this.p56_1 === tmp0_other_with_cast.p56_1))
      return false;
    return true;
  }
}
class Companion_18 {
  r56(num, den) {
    return insert16(insert16(0, num, 0), den, 16);
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_28 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_4();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.bc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.w56_1;
      destination.f3(tmp$ret$0, element);
    }
    tmp.y56_1 = destination;
  }
  f1(index) {
    var tmp0_elvis_lhs = this.y56_1.d3(index);
    return tmp0_elvis_lhs == null ? DataFormat_UNKNOWN_getInstance() : tmp0_elvis_lhs;
  }
}
class DataFormat extends Enum {
  constructor(name, ordinal, id, indexBytes) {
    super(name, ordinal);
    this.w56_1 = id;
    this.x56_1 = indexBytes;
  }
}
class EXIF {
  constructor() {
    EXIF_instance = this;
    this.z56_1 = Companion_getInstance_15().c1h('EXIF');
  }
  a57(ss, info, debug, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readExifBase__4npesx.bind(VOID, this, ss, info, debug), $completion);
  }
  b57(ss, info, debug, $completion, $super) {
    info = info === VOID ? new ImageInfo() : info;
    debug = debug === VOID ? false : debug;
    return $super === VOID ? this.a57(ss, info, debug, $completion) : $super.a57.call(this, ss, info, debug, $completion);
  }
}
class Direction extends Enum {}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.c57_1 = function_0;
  }
  qi(a, b) {
    return this.c57_1(a, b);
  }
  compare(a, b) {
    return this.qi(a, b);
  }
  g4() {
    return this.c57_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.g4(), other.g4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.g4());
  }
}
class ImageAnimation {
  constructor(frames, direction, name, layers) {
    var tmp;
    if (layers === VOID) {
      // Inline function 'kotlin.collections.sortedBy' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList.i1();
      var tmp0_iterator = frames.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var list = element.j57_1;
        addAll(destination, list);
      }
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
      var tmp0_iterator_0 = destination.a1();
      while (tmp0_iterator_0.b1()) {
        var item = tmp0_iterator_0.c1();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var tmp$ret$3 = item.l57_1;
        destination_0.h(tmp$ret$3);
      }
      var this_0 = distinct(destination_0);
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_0 = ImageAnimation$_init_$lambda_bxp50i;
      var tmp$ret$6 = new sam$kotlin_Comparator$0(tmp_0);
      tmp = sortedWith(this_0, tmp$ret$6);
    } else {
      tmp = layers;
    }
    layers = tmp;
    this.v57_1 = frames;
    this.w57_1 = direction;
    this.x57_1 = name;
    this.y57_1 = layers;
    var tmp_1 = this;
    var tmp0_elvis_lhs = firstOrNull_0(this.v57_1);
    tmp_1.z57_1 = tmp0_elvis_lhs == null ? ImageFrame.a58(0) : tmp0_elvis_lhs;
  }
}
class Companion_20 {
  b58(bitmaps) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(bitmaps.length);
    var inductionVariable = 0;
    var last = bitmaps.length;
    while (inductionVariable < last) {
      var item = bitmaps[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.invoke.<anonymous>' call
      var tmp$ret$0 = Companion_instance_32.c58(item);
      destination.h(tmp$ret$0);
    }
    return new ImageData(destination);
  }
}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.d58_1 = function_0;
  }
  qi(a, b) {
    return this.d58_1(a, b);
  }
  compare(a, b) {
    return this.qi(a, b);
  }
  g4() {
    return this.d58_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.g4(), other.g4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.g4());
  }
}
class ImageData {
  constructor(frames, loopCount, width, height, layers, animations, name) {
    loopCount = loopCount === VOID ? 0 : loopCount;
    var tmp;
    if (width === VOID) {
      var tmp171_safe_receiver = firstOrNull_0(frames);
      var tmp0_elvis_lhs = tmp171_safe_receiver == null ? null : tmp171_safe_receiver.w2i();
      tmp = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    } else {
      tmp = width;
    }
    width = tmp;
    var tmp_0;
    if (height === VOID) {
      var tmp172_safe_receiver = firstOrNull_0(frames);
      var tmp1_elvis_lhs = tmp172_safe_receiver == null ? null : tmp172_safe_receiver.x2i();
      tmp_0 = tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs;
    } else {
      tmp_0 = height;
    }
    height = tmp_0;
    layers = layers === VOID ? fastArrayListOf([]) : layers;
    animations = animations === VOID ? fastArrayListOf([]) : animations;
    name = name === VOID ? null : name;
    this.g58_1 = new Mixin();
    this.h58_1 = frames;
    this.i58_1 = loopCount;
    this.j58_1 = width;
    this.k58_1 = height;
    this.l58_1 = layers;
    this.m58_1 = animations;
    this.n58_1 = name;
    this.o58_1 = new ImageAnimation(this.h58_1, Direction_FORWARD_getInstance(), 'default');
    var tmp_1 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.m58_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.bc(capacity);
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.format.ImageData.animationsByName.<anonymous>' call
      var tmp$ret$0 = element.x57_1;
      destination.f3(tmp$ret$0, element);
    }
    tmp_1.p58_1 = destination;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = this.h58_1;
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.bc(capacity_0);
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.image.format.ImageData.framesByName.<anonymous>' call
      var tmp$ret$3 = element_0.l3();
      destination_0.f3(tmp$ret$3, element_0);
    }
    tmp_2.q58_1 = destination_0;
    var tmp_3 = this;
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_2 = this.h58_1;
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_4 = ImageData$framesSortedByPriority$lambda;
    var tmp$ret$6 = new sam$kotlin_Comparator$0_0(tmp_4);
    tmp_3.r58_1 = sortedWith(this_2, tmp$ret$6);
  }
  y1i(_set____db54di) {
    this.g58_1.y1i(_set____db54di);
  }
  z1i() {
    return this.g58_1.z1i();
  }
  s58() {
    var tmp173_safe_receiver = firstOrNull_0(this.r58_1);
    var tmp0_elvis_lhs = tmp173_safe_receiver == null ? null : tmp173_safe_receiver.e58();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException.l('No bitmap found');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  toString() {
    return 'ImageData(' + toString_0(this.h58_1) + ')';
  }
}
class Companion_21 {
  t58(bitmaps) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(bitmaps, 10));
    var tmp0_iterator = bitmaps.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.format.Companion.invoke.<anonymous>' call
      var tmp$ret$0 = Companion_instance_29.b58([item]);
      destination.h(tmp$ret$0);
    }
    return new ImageDataContainer(destination);
  }
  b58(bitmaps) {
    return Companion_instance_30.t58(toList_1(bitmaps));
  }
}
class ImageDataContainer {
  constructor(imageDatas) {
    this.u58_1 = imageDatas;
    var tmp = this;
    tmp.v58_1 = lazy(ImageDataContainer$imageDatasByName$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.w58_1 = lazy(ImageDataContainer$default$delegate$lambda(this));
  }
  x58() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v58_1;
    imageDatasByName$factory();
    return this_0.o1();
  }
  y58() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w58_1;
    default$factory();
    return this_0.o1();
  }
}
class Companion_22 {
  constructor() {
    Companion_instance_31 = this;
    this.p4h_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.q4h_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.r4h_1 = new ImageDecodingProps(VOID, VOID, VOID, false);
  }
}
class ImageDecodingProps {
  constructor(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    Companion_getInstance_39();
    filename = filename === VOID ? 'unknown' : filename;
    width = width === VOID ? null : width;
    height = height === VOID ? null : height;
    premultiplied = premultiplied === VOID ? null : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? false : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? null : requestedMaxSize;
    debug = debug === VOID ? false : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? false : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? true : tryNativeDecode;
    format = format === VOID ? get_RegisteredImageFormats() : format;
    out = out === VOID ? null : out;
    extra = extra === VOID ? null : extra;
    this.z58_1 = filename;
    this.a59_1 = width;
    this.b59_1 = height;
    this.c59_1 = premultiplied;
    this.d59_1 = asumePremultiplied;
    this.e59_1 = requestedMaxSize;
    this.f59_1 = debug;
    this.g59_1 = preferKotlinDecoder;
    this.h59_1 = tryNativeDecode;
    this.i59_1 = format;
    this.j59_1 = out;
    this.k59_1 = extra;
  }
  y1i(_set____db54di) {
    this.k59_1 = _set____db54di;
  }
  z1i() {
    return this.k59_1;
  }
  l59() {
    return this;
  }
  m59() {
    var tmp0_elvis_lhs = this.c59_1;
    return tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs;
  }
  n59(filename) {
    return this.o59(filename);
  }
  p59(file) {
    return this.n59(get_baseName(file));
  }
  q59(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    return new ImageDecodingProps(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  o59(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra, $super) {
    filename = filename === VOID ? this.z58_1 : filename;
    width = width === VOID ? this.a59_1 : width;
    height = height === VOID ? this.b59_1 : height;
    premultiplied = premultiplied === VOID ? this.c59_1 : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? this.d59_1 : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? this.e59_1 : requestedMaxSize;
    debug = debug === VOID ? this.f59_1 : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? this.g59_1 : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? this.h59_1 : tryNativeDecode;
    format = format === VOID ? this.i59_1 : format;
    out = out === VOID ? this.j59_1 : out;
    extra = extra === VOID ? this.k59_1 : extra;
    return $super === VOID ? this.q59(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) : $super.q59.call(this, filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  toString() {
    return 'ImageDecodingProps(filename=' + this.z58_1 + ', width=' + this.a59_1 + ', height=' + this.b59_1 + ', premultiplied=' + this.c59_1 + ', asumePremultiplied=' + this.d59_1 + ', requestedMaxSize=' + this.e59_1 + ', debug=' + this.f59_1 + ', preferKotlinDecoder=' + this.g59_1 + ', tryNativeDecode=' + this.h59_1 + ', format=' + toString(this.i59_1) + ', out=' + toString(this.j59_1) + ', extra=' + toString(this.k59_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.z58_1);
    result = imul(result, 31) + (this.a59_1 == null ? 0 : this.a59_1) | 0;
    result = imul(result, 31) + (this.b59_1 == null ? 0 : this.b59_1) | 0;
    result = imul(result, 31) + (this.c59_1 == null ? 0 : getBooleanHashCode(this.c59_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d59_1) | 0;
    result = imul(result, 31) + (this.e59_1 == null ? 0 : this.e59_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f59_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g59_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h59_1) | 0;
    result = imul(result, 31) + (this.i59_1 == null ? 0 : hashCode(this.i59_1)) | 0;
    result = imul(result, 31) + (this.j59_1 == null ? 0 : hashCode(this.j59_1)) | 0;
    result = imul(result, 31) + (this.k59_1 == null ? 0 : hashCode(this.k59_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ImageDecodingProps))
      return false;
    var tmp0_other_with_cast = other instanceof ImageDecodingProps ? other : THROW_CCE();
    if (!(this.z58_1 === tmp0_other_with_cast.z58_1))
      return false;
    if (!(this.a59_1 == tmp0_other_with_cast.a59_1))
      return false;
    if (!(this.b59_1 == tmp0_other_with_cast.b59_1))
      return false;
    if (!(this.c59_1 == tmp0_other_with_cast.c59_1))
      return false;
    if (!(this.d59_1 === tmp0_other_with_cast.d59_1))
      return false;
    if (!(this.e59_1 == tmp0_other_with_cast.e59_1))
      return false;
    if (!(this.f59_1 === tmp0_other_with_cast.f59_1))
      return false;
    if (!(this.g59_1 === tmp0_other_with_cast.g59_1))
      return false;
    if (!(this.h59_1 === tmp0_other_with_cast.h59_1))
      return false;
    if (!equals(this.i59_1, tmp0_other_with_cast.i59_1))
      return false;
    if (!equals(this.j59_1, tmp0_other_with_cast.j59_1))
      return false;
    if (!equals(this.k59_1, tmp0_other_with_cast.k59_1))
      return false;
    return true;
  }
}
class ImageFormat {
  static s59(exts, mimeType) {
    mimeType = mimeType === VOID ? 'image/' + first_2(exts) : mimeType;
    var $this = createThis(this);
    $this.h51_1 = mimeType;
    var tmp = $this;
    tmp.i51_1 = lazy(ImageFormat$decodingProps$delegate$lambda($this));
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(exts.length);
    var inductionVariable = 0;
    var last = exts.length;
    while (inductionVariable < last) {
      var item = exts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.ImageFormat.extensions.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var this_0 = item.toLowerCase();
      var tmp$ret$3 = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      destination.h(tmp$ret$3);
    }
    tmp_0.j51_1 = toSet(destination);
    return $this;
  }
  l59() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.i51_1;
    decodingProps$factory();
    return this_0.o1();
  }
  u59(s, props) {
    return this.t59(s, props).y58();
  }
  v59(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>' call
      var bmp = this.r59(s, props);
      // Inline function 'kotlin.apply' call
      var this_0 = new ImageInfo();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>.<anonymous>' call
      this_0.x59_1 = bmp.f3w_1;
      this_0.y59_1 = bmp.g3w_1;
      this_0.z59_1 = bmp.h3w_1;
      tmp = this_0;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  r59(s, props) {
    return this.u59(s, props).s58();
  }
  a5a(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.check.<anonymous>' call
      tmp = !(this.v59(s, props) == null);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  b5a(s, props) {
    return this.r59(s, props);
  }
  k51(s, props, $super) {
    props = props === VOID ? Companion_getInstance_39().p4h_1 : props;
    return $super === VOID ? this.b5a(s, props) : $super.b5a.call(this, s, props);
  }
  c5a(data, props) {
    return this.r59(openSync(data), props);
  }
  d5a(data, props, $completion) {
    return this.c5a(data, props);
  }
  e5a(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq.bind(VOID, this, file, props), $completion);
  }
  toString() {
    return 'ImageFormat(' + toString_0(this.j51_1) + ')';
  }
}
class ImageDecoderNotFoundException extends Exception {}
class ImageFormats extends ImageFormat {
  static j5a(formats) {
    var $this = this.s59(['']);
    $this.i5a_1 = atomic$ref$1(minus(listFormats(formats), $this));
    return $this;
  }
  static k5a(formats) {
    return this.j5a(toList_1(formats));
  }
  l5a(_set____db54di) {
    var this_0 = this.i5a_1;
    _formats$factory();
    this_0.kotlinx$atomicfu$value = _set____db54di;
    return Unit_instance;
  }
  m5a() {
    // Inline function 'kotlinx.atomicfu.AtomicRef.getValue' call
    var this_0 = this.i5a_1;
    _formats$factory_0();
    return this_0.kotlinx$atomicfu$value;
  }
  n5a() {
    return this.m5a();
  }
  toString() {
    return 'ImageFormats(' + this.n5a().d1() + ')' + toString_0(this.n5a());
  }
  v59(s, props) {
    if (this.n5a().g1())
      return null;
    var _iterator__ex2g4s = this.n5a().a1();
    $l$loop_0: while (_iterator__ex2g4s.b1()) {
      var format = _iterator__ex2g4s.c1();
      var tmp;
      try {
        var tmp0_elvis_lhs = format.v59(sliceStart_0(s), props);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          if (e instanceof CancellationException)
            throw e;
          continue $l$loop_0;
        } else {
          throw $p;
        }
      }
      return tmp;
    }
    return null;
  }
  t59(s, props) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.image.format.ImageFormats.readImageTyped' call
      var _iterator__ex2g4s = this.n5a().a1();
      while (_iterator__ex2g4s.b1()) {
        var format = _iterator__ex2g4s.c1();
        if (format.a5a(sliceStart_0(s), props)) {
          // Inline function 'korlibs.image.format.ImageFormats.readImageContainer.<anonymous>' call
          var s_0 = sliceStart_0(s);
          tmp$ret$1 = format.t59(sliceStart_0(s_0), props);
          break $l$block;
        }
      }
      throw UnsupportedOperationException.x9('No suitable image format : MAGIC:' + readString_0(sliceStart_0(s), 4, ASCII_getInstance()) + '(' + get_hex_0(readBytes(sliceStart_0(s), 4)) + ') (' + toString_2(readBytes(sliceStart_0(s), 4), ASCII_getInstance()) + ')');
    }
    return tmp$ret$1;
  }
}
class ImageFormatsMutable extends ImageFormats {
  static t5a() {
    var $this = this.k5a([]);
    $this.s5a_1 = new NonRecursiveLock();
    return $this;
  }
  static u5a(formats) {
    var $this = this.t5a();
    $this.v5a(formats.slice());
    return $this;
  }
  v5a(formats) {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.s5a_1.y1v_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    this.l5a(minus(plus_0(this.m5a(), formats), this));
    return this;
  }
}
class Companion_23 {
  w5a(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) {
    return ImageFrame.x5a(index, time, fastArrayListOf([new ImageFrameLayer(new ImageLayer(0, null, Type_NORMAL_getInstance()), slice(bitmap, VOID, name), targetX, targetY, main, includeInAtlas)]));
  }
  c58(bitmap, time, targetX, targetY, main, includeInAtlas, name, index, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    name = name === VOID ? null : name;
    index = index === VOID ? 0 : index;
    return $super === VOID ? this.w5a(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) : $super.w5a.call(this, bitmap, new Duration(time), targetX, targetY, main, includeInAtlas, name, index);
  }
}
class ImageFrame {
  static a58(index, fastTime, layerData) {
    fastTime = fastTime === VOID ? get_fastSeconds(0) : fastTime;
    layerData = layerData === VOID ? emptyList() : layerData;
    var $this = createThis(this);
    $this.g57_1 = new Mixin();
    $this.h57_1 = index;
    $this.i57_1 = fastTime;
    $this.j57_1 = layerData;
    $this.k57_1 = firstOrNull_0($this.j57_1);
    return $this;
  }
  y1i(_set____db54di) {
    this.g57_1.y1i(_set____db54di);
  }
  z1i() {
    return this.g57_1.z1i();
  }
  y5a() {
    return toDuration_0(this.i57_1);
  }
  static x5a(index, time, layerData) {
    layerData = layerData === VOID ? emptyList() : layerData;
    return this.a58(index, get_fast(time), layerData);
  }
  z5a() {
    var tmp177_safe_receiver = this.k57_1;
    var tmp0_elvis_lhs = tmp177_safe_receiver == null ? null : tmp177_safe_receiver.u57_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  a5b() {
    var tmp178_safe_receiver = this.k57_1;
    var tmp0_elvis_lhs = tmp178_safe_receiver == null ? null : tmp178_safe_receiver.m57_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  b5b() {
    var tmp179_safe_receiver = this.k57_1;
    var tmp0_elvis_lhs = tmp179_safe_receiver == null ? null : tmp179_safe_receiver.n57_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  f58() {
    var tmp180_safe_receiver = this.k57_1;
    var tmp0_elvis_lhs = tmp180_safe_receiver == null ? null : tmp180_safe_receiver.o57_1;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  w2i() {
    return this.z5a().s3g_1;
  }
  x2i() {
    return this.z5a().t3g_1;
  }
  e58() {
    var tmp182_safe_receiver = this.k57_1;
    var tmp0_elvis_lhs = tmp182_safe_receiver == null ? null : tmp182_safe_receiver.e58();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      tmp = get_bmp(tmp$ret$0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  l3() {
    return this.z5a().n3g_1;
  }
  toString() {
    return 'ImageFrame(' + this.z5a().toString() + ', time=' + Duration__toString_impl_8d916b(this.y5a()) + ', targetX=' + this.a5b() + ', targetY=' + this.b5b() + ', main=' + this.f58() + ')';
  }
}
class ImageFrameLayer {
  constructor(layer, slice, targetX, targetY, main, includeInAtlas, tilemap, ninePatchSlice) {
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    tilemap = tilemap === VOID ? null : tilemap;
    ninePatchSlice = ninePatchSlice === VOID ? null : ninePatchSlice;
    this.l57_1 = layer;
    this.m57_1 = targetX;
    this.n57_1 = targetY;
    this.o57_1 = main;
    this.p57_1 = includeInAtlas;
    this.q57_1 = tilemap;
    this.r57_1 = ninePatchSlice;
    this.s57_1 = null;
    this.t57_1 = null;
    this.u57_1 = slice;
  }
  w2i() {
    return this.u57_1.s3g_1;
  }
  x2i() {
    return this.u57_1.t3g_1;
  }
  e58() {
    if (get_bmp(this.u57_1).f3w_1 === this.w2i() && get_bmp(this.u57_1).g3w_1 === this.x2i())
      return get_bmp(this.u57_1);
    if (this.s57_1 == null)
      this.s57_1 = extract_0(this.u57_1);
    return ensureNotNull(this.s57_1);
  }
}
class ImageInfo {
  constructor() {
    this.w59_1 = new Mixin();
    this.x59_1 = 0;
    this.y59_1 = 0;
    this.z59_1 = 8;
  }
  y1i(_set____db54di) {
    this.w59_1.y1i(_set____db54di);
  }
  z1i() {
    return this.w59_1.z1i();
  }
  toString() {
    var tmp = this.x59_1;
    var tmp_0 = this.y59_1;
    var tmp_1 = this.z59_1;
    var tmp183_safe_receiver = this.z1i();
    return 'ImageInfo(width=' + tmp + ', height=' + tmp_0 + ', bpp=' + tmp_1 + ', extra=' + toString(tmp183_safe_receiver == null ? null : toMap_0(tmp183_safe_receiver)) + ')';
  }
}
class Companion_24 {
  constructor() {
    Companion_instance_33 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c5b_1 = [Type_NORMAL_getInstance(), Type_GROUP_getInstance(), Type_TILEMAP_getInstance()];
  }
}
class Type extends Enum {}
class ImageLayer {
  constructor(index, name, type) {
    type = type === VOID ? Type_NORMAL_getInstance() : type;
    this.d57_1 = index;
    this.e57_1 = name;
    this.f57_1 = type;
  }
}
class NativeImageFormatProvider {
  f5b(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_0.bind(VOID, this, data, props), $completion);
  }
  z5b(_this__u8e3s4, props) {
    return this.b5c(_this__u8e3s4, props);
  }
  b5c(image, props) {
    return this.a5c(toBitmap_0(image.g3u()), props);
  }
  y5b(vfs, path, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_1.bind(VOID, this, vfs, path, props), $completion);
  }
  d5a(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeSuspend__fioeme.bind(VOID, this, data, props), $completion);
  }
  c5c(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq_0.bind(VOID, this, file, props), $completion);
  }
  e5a(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq_1.bind(VOID, this, file, props), $completion);
  }
  f4a(width, height, premultiplied) {
    return BitmapNativeImage.h5c(Bitmap32.y3v(width, height, VOID, premultiplied == null ? true : premultiplied));
  }
  e4a(bmp) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.f4a(bmp.f3w_1, bmp.g3w_1, bmp.l3w_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>' call
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_0.j3w_1;
    if (true) {
      this_0.s3w();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = this_0.b44(true);
      try {
        // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>.<anonymous>' call
        ctx.i5c(bmp, Companion_getInstance_6().e26_1);
      }finally {
        ctx.ov();
      }
    }finally {
      result = true ? this_0.u3w(rect) : 0;
    }
    return this_0;
  }
  d5c(bmp) {
    return BitmapNativeImage.x5b(bmp);
  }
  a5c(_this__u8e3s4, props) {
    var tmp;
    var tmp_0;
    if (_this__u8e3s4 instanceof NativeImage) {
      tmp_0 = !props.d59_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = props.c59_1 == null || props.c59_1 === _this__u8e3s4.l3w_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      return _this__u8e3s4;
    }
    var out = _this__u8e3s4.c44();
    if (props.d59_1) {
      asumePremultiplied(out);
    } else if (!_this__u8e3s4.l3w_1 && props.c59_1 === false) {
      out.k47();
    } else if (_this__u8e3s4.l3w_1 && props.c59_1 === true) {
      out.j47();
    }
    return this.d5c(out);
  }
  d5b(_this__u8e3s4, props) {
    return new NativeImageResult(this.a5c(_this__u8e3s4, props));
  }
}
class BaseNativeImageFormatProvider extends NativeImageFormatProvider {
  f5b(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt.bind(VOID, this, data, props), $completion);
  }
  g5b(bmp) {
    return BitmapNativeImage.x5b(bmp);
  }
  e5b(bmp, props) {
    var bmp32 = bmp.c44();
    return new NativeImageResult(this.g5b(props.d59_1 ? asumePremultiplied(bmp32) : props.m59() ? bmp32.g47() : bmp32.h47()));
  }
  f4a(width, height, premultiplied) {
    return this.g5b(Bitmap32.y3v(width, height, VOID, premultiplied == null ? true : premultiplied));
  }
  e4a(bmp) {
    return this.g5b(bmp);
  }
}
class NativeImageResult {
  constructor(image, originalWidth, originalHeight) {
    originalWidth = originalWidth === VOID ? image.f3w_1 : originalWidth;
    originalHeight = originalHeight === VOID ? image.g3w_1 : originalHeight;
    this.e5c_1 = image;
    this.f5c_1 = originalWidth;
    this.g5c_1 = originalHeight;
  }
  toString() {
    return 'NativeImageResult(image=' + this.e5c_1.toString() + ', originalWidth=' + this.f5c_1 + ', originalHeight=' + this.g5c_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.e5c_1);
    result = imul(result, 31) + this.f5c_1 | 0;
    result = imul(result, 31) + this.g5c_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NativeImageResult))
      return false;
    var tmp0_other_with_cast = other instanceof NativeImageResult ? other : THROW_CCE();
    if (!equals(this.e5c_1, tmp0_other_with_cast.e5c_1))
      return false;
    if (!(this.f5c_1 === tmp0_other_with_cast.f5c_1))
      return false;
    if (!(this.g5c_1 === tmp0_other_with_cast.g5c_1))
      return false;
    return true;
  }
}
class BitmapNativeImage extends NativeImage {
  static h5c(bitmap) {
    var $this = this.d4a(bitmap.f3w_1, bitmap.g3w_1, bitmap, bitmap.l3w_1);
    $this.v5b_1 = bitmap;
    $this.w5b_1 = $this.v5b_1.v3v_1;
    return $this;
  }
  l3() {
    return 'BitmapNativeImage';
  }
  static x5b(bitmap) {
    return this.h5c(bitmap.c44());
  }
  b44(antialiasing) {
    return this.v5b_1.b44(antialiasing);
  }
  r3w() {
    return this.v5b_1;
  }
  c3x(x, y, width, height, out, offset) {
    return this.v5b_1.c3x(x, y, width, height, out, offset);
  }
  e3x(x, y, width, height, out, offset) {
    return this.v5b_1.e3x(x, y, width, height, out, offset);
  }
  f3x(x, y, v) {
    return this.v5b_1.f3x(x, y, v);
  }
  d3x(x, y) {
    return this.v5b_1.d3x(x, y);
  }
}
class Companion_25 {
  constructor() {
    Companion_instance_34 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_5();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.bc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.l5c_1;
      destination.f3(tmp$ret$0, element);
    }
    tmp.n5c_1 = destination;
  }
}
class InterlacedPass {
  constructor(startingRow, startingCol, rowIncrement, colIncrement, blockHeight, blockWidth) {
    this.o5c_1 = startingRow;
    this.p5c_1 = startingCol;
    this.q5c_1 = rowIncrement;
    this.r5c_1 = colIncrement;
    this.s5c_1 = blockHeight;
    this.t5c_1 = blockWidth;
    var tmp = this;
    // Inline function 'kotlin.math.log2' call
    var x = this.r5c_1;
    var tmp$ret$0 = log2(x);
    tmp.u5c_1 = numberToInt(tmp$ret$0);
  }
  toString() {
    return 'InterlacedPass(startingRow=' + this.o5c_1 + ', startingCol=' + this.p5c_1 + ', rowIncrement=' + this.q5c_1 + ', colIncrement=' + this.r5c_1 + ', blockHeight=' + this.s5c_1 + ', blockWidth=' + this.t5c_1 + ')';
  }
  hashCode() {
    var result = this.o5c_1;
    result = imul(result, 31) + this.p5c_1 | 0;
    result = imul(result, 31) + this.q5c_1 | 0;
    result = imul(result, 31) + this.r5c_1 | 0;
    result = imul(result, 31) + this.s5c_1 | 0;
    result = imul(result, 31) + this.t5c_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InterlacedPass))
      return false;
    var tmp0_other_with_cast = other instanceof InterlacedPass ? other : THROW_CCE();
    if (!(this.o5c_1 === tmp0_other_with_cast.o5c_1))
      return false;
    if (!(this.p5c_1 === tmp0_other_with_cast.p5c_1))
      return false;
    if (!(this.q5c_1 === tmp0_other_with_cast.q5c_1))
      return false;
    if (!(this.r5c_1 === tmp0_other_with_cast.r5c_1))
      return false;
    if (!(this.s5c_1 === tmp0_other_with_cast.s5c_1))
      return false;
    if (!(this.t5c_1 === tmp0_other_with_cast.t5c_1))
      return false;
    return true;
  }
}
class Colorspace extends Enum {
  constructor(name, ordinal, id, nchannels) {
    super(name, ordinal);
    this.l5c_1 = id;
    this.m5c_1 = nchannels;
  }
}
class Header {
  constructor(width, height, bitsPerChannel, colorspace, compressionmethod, filtermethod, interlacemethod) {
    this.v5c_1 = width;
    this.w5c_1 = height;
    this.x5c_1 = bitsPerChannel;
    this.y5c_1 = colorspace;
    this.z5c_1 = compressionmethod;
    this.a5d_1 = filtermethod;
    this.b5d_1 = interlacemethod;
    var tmp = this;
    var tmp_0;
    switch (this.y5c_1.k3_1) {
      case 0:
        tmp_0 = 1;
        break;
      case 2:
        tmp_0 = 1;
        break;
      case 3:
        tmp_0 = 2;
        break;
      case 1:
        tmp_0 = 3;
        break;
      case 4:
        tmp_0 = 4;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.c5d_1 = tmp_0;
    this.d5d_1 = imul(imul(this.v5c_1, this.c5d_1), this.x5c_1) / 8 | 0;
  }
}
class DecodingContext {
  constructor(header) {
    this.e5d_1 = header;
    this.f5d_1 = _UByteArrayInt___init__impl__xif7bu_0(this.e5d_1.d5d_1);
    this.g5d_1 = _UByteArrayInt___init__impl__xif7bu_0(this.e5d_1.d5d_1);
    this.h5d_1 = Companion_instance_14.n47(this.e5d_1.v5c_1);
  }
  r5d() {
    var temp = this.g5d_1;
    this.g5d_1 = this.f5d_1;
    this.f5d_1 = temp;
  }
}
class PNG$readCommon$readChunk$slambda {
  constructor($data, $info) {
    this.s5d_1 = $data;
    this.t5d_1 = $info;
  }
  od($completion) {
    return EXIF_getInstance().b57(openAsync(readAll_0(this.s5d_1)), this.t5d_1, VOID, $completion);
  }
}
class PNG extends ImageFormat {
  static u5d() {
    PNG_instance = null;
    var $this = this.s59(['png']);
    PNG_instance = $this;
    $this.l5d_1 = -1991225785;
    $this.m5d_1 = 218765834;
    $this.n5d_1 = listOf([new InterlacedPass(0, 0, 8, 8, 8, 8), new InterlacedPass(0, 4, 8, 8, 8, 4), new InterlacedPass(4, 0, 8, 4, 4, 4), new InterlacedPass(0, 2, 4, 4, 4, 2), new InterlacedPass(2, 0, 4, 2, 2, 2), new InterlacedPass(0, 1, 2, 2, 2, 1), new InterlacedPass(1, 0, 2, 1, 1, 1)]);
    $this.o5d_1 = listOf_0(new InterlacedPass(0, 0, 1, 1, 1, 1));
    return $this;
  }
  v59(s, props) {
    var tmp;
    try {
      var info = new ImageInfo();
      var tmp_0 = readCommon(this, s, true, info);
      var header = tmp_0 instanceof Header ? tmp_0 : THROW_CCE();
      tmp = info;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var t = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  t59(s, props) {
    var tmp = Companion_instance_30;
    var tmp_0 = readCommon$default(this, s, false);
    return tmp.b58([tmp_0 instanceof Bitmap ? tmp_0 : THROW_CCE()]);
  }
  v5d(a, b, c) {
    var p = (a + b | 0) - c | 0;
    var pa = abs(p - a | 0);
    var pb = abs(p - b | 0);
    var pc = abs(p - c | 0);
    return pa <= pb && pa <= pc ? a : pb <= pc ? b : c;
  }
  p5d(filter, p, c, bpp, size) {
    switch (filter) {
      case 0:
        break;
      case 1:
        var inductionVariable = bpp;
        if (inductionVariable < size)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n, UByteArrayInt__get_impl_px6q8a(c, n) + UByteArrayInt__get_impl_px6q8a(c, n - bpp | 0) | 0);
          }
           while (inductionVariable < size);
        break;
      case 2:
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < size)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_0, UByteArrayInt__get_impl_px6q8a(c, n_0) + UByteArrayInt__get_impl_px6q8a(p, n_0) | 0);
          }
           while (inductionVariable_0 < size);
        break;
      case 3:
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < bpp)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_1, UByteArrayInt__get_impl_px6q8a(c, n_1) + (UByteArrayInt__get_impl_px6q8a(p, n_1) / 2 | 0) | 0);
          }
           while (inductionVariable_1 < bpp);
        var inductionVariable_2 = bpp;
        if (inductionVariable_2 < size)
          do {
            var n_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_2, UByteArrayInt__get_impl_px6q8a(c, n_2) + ((UByteArrayInt__get_impl_px6q8a(c, n_2 - bpp | 0) + UByteArrayInt__get_impl_px6q8a(p, n_2) | 0) / 2 | 0) | 0);
          }
           while (inductionVariable_2 < size);
        break;
      case 4:
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < bpp)
          do {
            var n_3 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_3, UByteArrayInt__get_impl_px6q8a(c, n_3) + UByteArrayInt__get_impl_px6q8a(p, n_3) | 0);
          }
           while (inductionVariable_3 < bpp);
        var inductionVariable_4 = bpp;
        if (inductionVariable_4 < size)
          do {
            var n_4 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_4, UByteArrayInt__get_impl_px6q8a(c, n_4) + this.v5d(UByteArrayInt__get_impl_px6q8a(c, n_4 - bpp | 0), UByteArrayInt__get_impl_px6q8a(p, n_4), UByteArrayInt__get_impl_px6q8a(p, n_4 - bpp | 0)) | 0);
          }
           while (inductionVariable_4 < size);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Filter: ' + filter;
        throw NotImplementedError.nd('An operation is not implemented: ' + reason);
    }
  }
  q5d(filter, p, c, bpp, size, $super) {
    size = size === VOID ? _UByteArrayInt___get_size__impl__bcjnte(c) : size;
    var tmp;
    if ($super === VOID) {
      this.p5d(filter, p, c, bpp, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.p5d.call(this, filter, new UByteArrayInt(p), new UByteArrayInt(c), bpp, size);
    }
    return tmp;
  }
}
class BaseFiller {
  z5d(data, offset, x0, x1, y) {
    var yFloat = y;
    var inductionVariable = x0;
    if (inductionVariable <= x1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaPremultipliedArray__set_impl_7fwbby(data, offset + n | 0, this.y5d(n, yFloat));
      }
       while (!(n === x1));
  }
  a5e(bmp, rect) {
    var cols = _RgbaPremultipliedArray___init__impl__lx83hy(bmp.v3v_1);
    var inductionVariable = rect.v26();
    var last = rect.w26();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var offset = imul(y, bmp.f3w_1);
        this.z5d(cols, offset, rect.t26(), rect.u26() - 1 | 0, y);
      }
       while (inductionVariable < last);
  }
  b5e(bmp, rect, $super) {
    rect = rect === VOID ? bmp.x3v_1 : rect;
    var tmp;
    if ($super === VOID) {
      this.a5e(bmp, rect);
      tmp = Unit_instance;
    } else {
      tmp = $super.a5e.call(this, bmp, rect);
    }
    return tmp;
  }
}
class ColorFiller extends BaseFiller {
  constructor() {
    super();
    this.w5d_1 = _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().o3x_1);
  }
  x5d(fill, state) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.ColorFiller.set.<anonymous>' call
    this.w5d_1 = _RGBA___get_premultiplied__impl__3bulqc(_RGBA___get_color__impl__8x3sb3(fill));
    return this;
  }
  y5d(x, y) {
    return this.w5d_1;
  }
  z5d(data, offset, x0, x1, y) {
    RgbaPremultipliedArray__fill_impl_sem38t(data, this.w5d_1, offset + x0 | 0, (offset + x1 | 0) + 1 | 0);
  }
}
class Companion_26 {
  constructor() {
    this.c5e_1 = 256;
  }
}
class GradientFiller extends BaseFiller {
  constructor() {
    super();
    this.d5e_1 = Companion_instance_17.d4e(256);
  }
  f5e(fill, state) {
    fill.g5e(this.d5e_1);
    this.e5e_1 = fill.h5e(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_5().n29_1.i2b(fill.c52_1).i2b(state.z4f_1));
    return this;
  }
  i5e(x, y) {
    return _get_fill__d6ivc8(this).j5e(Vector2D.y2a(x, y));
  }
  y5d(x, y) {
    return color(this, this.i5e(x, y));
  }
}
class BitmapFiller extends BaseFiller {
  constructor() {
    super();
    this.k5e_1 = _CycleMethodPair___init__impl__y6jlco_0(CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_getInstance());
    this.l5e_1 = 0.0;
    this.m5e_1 = 0.0;
    this.n5e_1 = 0.0;
    this.o5e_1 = 0.0;
    var tmp = this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    tmp.p5e_1 = get_bmp(tmp$ret$0);
    this.q5e_1 = Companion_getInstance_5().n29_1;
    this.r5e_1 = true;
    this.s5e_1 = Companion_getInstance_5().n29_1;
  }
  t5e(fill, state) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.BitmapFiller.set.<anonymous>' call
    this.k5e_1 = _CycleMethodPair___init__impl__y6jlco_0(fill.w5e_1, fill.x5e_1);
    _set_texture__qu271y(this, fill.a5f_1);
    this.q5e_1 = fill.v5e_1;
    this.r5e_1 = fill.y5e_1;
    this.s5e_1 = Companion_getInstance_5().n29_1.b2b(state.z4f_1).b2b(fill.v5e_1).c2b();
    return this;
  }
  b5f(x, y) {
    return this.p5e_1.l3x(x, y);
  }
  c5f(x, y) {
    return this.p5e_1.v45(numberToInt(x), numberToInt(y));
  }
  y5d(x, y) {
    var mat = this.s5e_1;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p = Vector2D.y2a(x, y);
      if (mat.r26()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.l28(mat.i2a(p.c26_1, p.d26_1), mat.l2a(p.c26_1, p.d26_1));
    }
    var this_0 = tmp$ret$0;
    var that = Vector2D.y2a(this.n5e_1, this.o5e_1);
    var p_0 = Vector2D.l28(this_0.c26_1 * that.c26_1, this_0.d26_1 * that.d26_1);
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_1 = CycleMethodPair__apply_impl_g3sekg(this.k5e_1, p_0);
    var that_0 = Vector2D.y2a(this.l5e_1, this.m5e_1);
    var t = Vector2D.l28(this_1.c26_1 * that_0.c26_1, this_1.d26_1 * that_0.d26_1);
    return this.r5e_1 ? _RGBA___get_premultiplied__impl__3bulqc(this.b5f(t.c26_1, t.d26_1)) : _RGBA___get_premultiplied__impl__3bulqc(this.c5f(t.c26_1, t.d26_1));
  }
}
class NoneFiller extends BaseFiller {
  constructor() {
    NoneFiller_instance = null;
    super();
    NoneFiller_instance = this;
  }
  y5d(x, y) {
    return _RGBAPremultiplied___init__impl__uos02x(0);
  }
  z5d(data, offset, x0, x1, y) {
    return Unit_instance;
  }
}
class Companion_27 {}
class TransformedPaint {}
class GradientPaint {
  constructor(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    stops = stops === VOID ? DoubleArrayList.r2k() : stops;
    colors = colors === VOID ? IntArrayList.x2j() : colors;
    cycle = cycle === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycle;
    transform = transform === VOID ? Companion_getInstance_5().n29_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? GradientInterpolationMethod_NORMAL_getInstance() : interpolationMethod;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    startAngle = startAngle === VOID ? Companion_getInstance_8().t25_1 : startAngle;
    this.s51_1 = kind;
    this.t51_1 = x0;
    this.u51_1 = y0;
    this.v51_1 = r0;
    this.w51_1 = x1;
    this.x51_1 = y1;
    this.y51_1 = r1;
    this.z51_1 = stops;
    this.a52_1 = colors;
    this.b52_1 = cycle;
    this.c52_1 = transform;
    this.d52_1 = interpolationMethod;
    this.e52_1 = units;
    this.f52_1 = startAngle;
    var tmp = this;
    var tmp_0 = Companion_getInstance_5().n29_1.v2a(-this.t51_1, -this.u51_1).q2a(1.0 / clamp_1(Companion_getInstance_6().q2f(this.t51_1, this.u51_1, this.w51_1, this.x51_1), 1.0, 16000.0));
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_8();
    var x0_0 = this.t51_1;
    var y0_0 = this.u51_1;
    var x1_0 = this.w51_1;
    var y1_0 = this.x51_1;
    var up = Companion_getInstance_6().i26_1;
    var tmp$ret$0 = Angle_between(x0_0, y0_0, x1_0, y1_0, up);
    tmp.g52_1 = tmp_0.a2a(Angle__unaryMinus_impl_7901fr(tmp$ret$0));
    this.h52_1 = this.c52_1.c2b();
    this.i52_1 = Companion_getInstance_5().n29_1.b2b(this.g52_1).b2b(this.h52_1);
    this.j52_1 = 2 * this.v51_1 * this.y51_1;
    this.k52_1 = this.d5f(this.v51_1);
    this.l52_1 = this.d5f(this.y51_1);
    this.m52_1 = this.u51_1 - this.x51_1;
    this.n52_1 = this.v51_1 - this.y51_1;
    this.o52_1 = this.t51_1 - this.w51_1;
    this.p52_1 = 1.0 / (this.d5f(this.v51_1 - this.y51_1) - this.d5f(this.t51_1 - this.w51_1) - this.d5f(this.u51_1 - this.x51_1));
  }
  y4p() {
    return this.c52_1;
  }
  e5f() {
    return this.e52_1;
  }
  g5e(out) {
    return _fillColors(Companion_instance_36, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(out), this.z51_1, this.a52_1, true);
  }
  f5f(stop, color) {
    return this.q52(Ratio__toDouble_impl_o7epze(stop), color);
  }
  q52(stop, color) {
    return this.g5f(stop, color);
  }
  g5f(stop, color) {
    this.z51_1.z2k(stop);
    this.a52_1.e2k(_RGBA___get_value__impl__hhco8v(color));
    return this;
  }
  j5e(p) {
    var tmp;
    switch (this.s51_1.k3_1) {
      case 2:
        var tmp$ret$0;
        $l$block: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var this_0 = this.h52_1;
          if (this_0.r26()) {
            tmp$ret$0 = p;
            break $l$block;
          }
          tmp$ret$0 = Vector2D.l28(this_0.i2a(p.c26_1, p.d26_1), this_0.l2a(p.c26_1, p.d26_1));
        }

        var p_0 = tmp$ret$0;
        tmp = Angle__div_impl_ut2btd(Companion_getInstance_6().g2h(Vector2D.l28(this.t51_1, this.u51_1), p_0), get_degrees(360));
        break;
      case 1:
        var tmp$ret$1;
        $l$block_0: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var this_1 = this.h52_1;
          if (this_1.r26()) {
            tmp$ret$1 = p;
            break $l$block_0;
          }
          tmp$ret$1 = Vector2D.l28(this_1.i2a(p.c26_1, p.d26_1), this_1.l2a(p.c26_1, p.d26_1));
        }

        var _destruct__k2r9zo = tmp$ret$1;
        var x = _destruct__k2r9zo.bl();
        var y = _destruct__k2r9zo.cl();
        var tmp_0 = -this.y51_1 * this.n52_1 + this.o52_1 * (this.w51_1 - x) + this.m52_1 * (this.x51_1 - y);
        // Inline function 'kotlin.math.sqrt' call

        var x_0 = this.l52_1 * (this.d5f(this.t51_1 - x) + this.d5f(this.u51_1 - y)) - this.j52_1 * ((this.t51_1 - x) * (this.w51_1 - x) + (this.u51_1 - y) * (this.x51_1 - y)) + this.k52_1 * (this.d5f(this.w51_1 - x) + this.d5f(this.x51_1 - y)) - this.d5f(this.w51_1 * this.u51_1 - x * this.u51_1 - this.t51_1 * this.x51_1 + x * this.x51_1 + this.t51_1 * y - this.w51_1 * y);
        tmp = 1.0 - (tmp_0 - Math.sqrt(x_0)) * this.p52_1;
        break;
      default:
        tmp = this.i52_1.h2a(p);
        break;
    }
    return this.b52_1.j5f(tmp);
  }
  d5f(_this__u8e3s4) {
    return _this__u8e3s4 * _this__u8e3s4;
  }
  k5f(m) {
    return this.h5e(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, m);
  }
  u1i() {
    return this.h5e(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.c52_1);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.GradientPaint.toString.<anonymous>' call
    var tmp;
    switch (this.s51_1.k3_1) {
      case 0:
        tmp = 'LinearGradient([' + this.t51_1 + ', ' + this.u51_1 + '], [' + this.w51_1 + ', ' + this.x51_1 + ']';
        break;
      case 1:
        tmp = 'RadialGradient([' + this.t51_1 + ', ' + this.u51_1 + ', ' + this.v51_1 + '], [' + this.w51_1 + ', ' + this.x51_1 + ', ' + this.y51_1 + ']';
        break;
      case 2:
        tmp = 'ConicGradient([' + this.t51_1 + ', ' + this.u51_1 + ']';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this_0.nb(tmp);
    this_0.nb(', stops=' + this.z51_1.toString() + ', colors=' + colorsToString_0(this, this.a52_1) + ', cycle=' + this.b52_1.toString() + ', transform=' + this.c52_1.toString() + ', interpolationMethod=' + this.d52_1.toString() + ', units=' + this.e52_1.toString() + ')');
    return this_0.toString();
  }
  l5f(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    return new GradientPaint(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle);
  }
  h5e(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle, $super) {
    kind = kind === VOID ? this.s51_1 : kind;
    x0 = x0 === VOID ? this.t51_1 : x0;
    y0 = y0 === VOID ? this.u51_1 : y0;
    r0 = r0 === VOID ? this.v51_1 : r0;
    x1 = x1 === VOID ? this.w51_1 : x1;
    y1 = y1 === VOID ? this.x51_1 : y1;
    r1 = r1 === VOID ? this.y51_1 : r1;
    stops = stops === VOID ? this.z51_1 : stops;
    colors = colors === VOID ? this.a52_1 : colors;
    cycle = cycle === VOID ? this.b52_1 : cycle;
    transform = transform === VOID ? this.c52_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? this.d52_1 : interpolationMethod;
    units = units === VOID ? this.e52_1 : units;
    startAngle = startAngle === VOID ? this.f52_1 : startAngle;
    return $super === VOID ? this.l5f(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) : $super.l5f.call(this, kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, new Angle(startAngle));
  }
  hashCode() {
    var result = this.s51_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.t51_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u51_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v51_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w51_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x51_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y51_1) | 0;
    result = imul(result, 31) + this.z51_1.hashCode() | 0;
    result = imul(result, 31) + this.a52_1.hashCode() | 0;
    result = imul(result, 31) + this.b52_1.hashCode() | 0;
    result = imul(result, 31) + this.c52_1.hashCode() | 0;
    result = imul(result, 31) + this.d52_1.hashCode() | 0;
    result = imul(result, 31) + this.e52_1.hashCode() | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.f52_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GradientPaint))
      return false;
    var tmp0_other_with_cast = other instanceof GradientPaint ? other : THROW_CCE();
    if (!this.s51_1.equals(tmp0_other_with_cast.s51_1))
      return false;
    if (!equals(this.t51_1, tmp0_other_with_cast.t51_1))
      return false;
    if (!equals(this.u51_1, tmp0_other_with_cast.u51_1))
      return false;
    if (!equals(this.v51_1, tmp0_other_with_cast.v51_1))
      return false;
    if (!equals(this.w51_1, tmp0_other_with_cast.w51_1))
      return false;
    if (!equals(this.x51_1, tmp0_other_with_cast.x51_1))
      return false;
    if (!equals(this.y51_1, tmp0_other_with_cast.y51_1))
      return false;
    if (!this.z51_1.equals(tmp0_other_with_cast.z51_1))
      return false;
    if (!this.a52_1.equals(tmp0_other_with_cast.a52_1))
      return false;
    if (!this.b52_1.equals(tmp0_other_with_cast.b52_1))
      return false;
    if (!this.c52_1.equals(tmp0_other_with_cast.c52_1))
      return false;
    if (!this.d52_1.equals(tmp0_other_with_cast.d52_1))
      return false;
    if (!this.e52_1.equals(tmp0_other_with_cast.e52_1))
      return false;
    if (!equals(this.f52_1, tmp0_other_with_cast.f52_1))
      return false;
    return true;
  }
}
class GradientKind extends Enum {}
class GradientInterpolationMethod extends Enum {}
class GradientUnits extends Enum {}
class NonePaint {
  u1i() {
    return this;
  }
}
class BitmapPaint {
  constructor(bitmap, transform, cycleX, cycleY, smooth, units) {
    transform = transform === VOID ? Companion_getInstance_5().n29_1 : transform;
    cycleX = cycleX === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleX;
    cycleY = cycleY === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleY;
    smooth = smooth === VOID ? true : smooth;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    this.u5e_1 = bitmap;
    this.v5e_1 = transform;
    this.w5e_1 = cycleX;
    this.x5e_1 = cycleY;
    this.y5e_1 = smooth;
    this.z5e_1 = units;
    this.a5f_1 = this.u5e_1.r3w();
  }
  y4p() {
    return this.v5e_1;
  }
  e5f() {
    return this.z5e_1;
  }
  m5f() {
    return this.w5e_1.n5f();
  }
  o5f() {
    return this.x5e_1.n5f();
  }
  u1i() {
    return this.p5f(VOID, this.v5e_1);
  }
  k5f(m) {
    return this.p5f(VOID, m);
  }
  toString() {
    return 'BitmapPaint(' + toString_0(this.u5e_1) + ', cycle=(' + this.w5e_1.toString() + ', ' + this.x5e_1.toString() + '), smooth=' + this.y5e_1 + ', transform=' + this.v5e_1.toString() + ')';
  }
  q5f(bitmap, transform, cycleX, cycleY, smooth, units) {
    return new BitmapPaint(bitmap, transform, cycleX, cycleY, smooth, units);
  }
  p5f(bitmap, transform, cycleX, cycleY, smooth, units, $super) {
    bitmap = bitmap === VOID ? this.u5e_1 : bitmap;
    transform = transform === VOID ? this.v5e_1 : transform;
    cycleX = cycleX === VOID ? this.w5e_1 : cycleX;
    cycleY = cycleY === VOID ? this.x5e_1 : cycleY;
    smooth = smooth === VOID ? this.y5e_1 : smooth;
    units = units === VOID ? this.z5e_1 : units;
    return $super === VOID ? this.q5f(bitmap, transform, cycleX, cycleY, smooth, units) : $super.q5f.call(this, bitmap, transform, cycleX, cycleY, smooth, units);
  }
  hashCode() {
    var result = hashCode(this.u5e_1);
    result = imul(result, 31) + this.v5e_1.hashCode() | 0;
    result = imul(result, 31) + this.w5e_1.hashCode() | 0;
    result = imul(result, 31) + this.x5e_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y5e_1) | 0;
    result = imul(result, 31) + this.z5e_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapPaint))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapPaint ? other : THROW_CCE();
    if (!equals(this.u5e_1, tmp0_other_with_cast.u5e_1))
      return false;
    if (!this.v5e_1.equals(tmp0_other_with_cast.v5e_1))
      return false;
    if (!this.w5e_1.equals(tmp0_other_with_cast.w5e_1))
      return false;
    if (!this.x5e_1.equals(tmp0_other_with_cast.x5e_1))
      return false;
    if (!(this.y5e_1 === tmp0_other_with_cast.y5e_1))
      return false;
    if (!this.z5e_1.equals(tmp0_other_with_cast.z5e_1))
      return false;
    return true;
  }
}
class Companion_28 {
  constructor() {
    Companion_instance_37 = this;
    this.s5f_1 = new KeyFrame(Companion_getInstance_9().m1i_1, new Declarations(emptyList()));
  }
}
class Companion_29 {
  t5f(selector) {
    var str = selector.b34();
    if (str === 'from')
      return Companion_getInstance_9().m1i_1;
    if (str === 'to')
      return Companion_getInstance_9().p1i_1;
    if (!endsWith(str, '%')) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid keyframe selector ' + toString_0(selector);
      throw IllegalStateException.s4(toString_0(message));
    }
    return Companion_instance_39.u5f(str);
  }
  v5f(rules) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList.i1();
    var tmp0_iterator = rules.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      if (element instanceof RuleSet) {
        destination.h(element);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator_0 = destination.a1();
    while (tmp0_iterator_0.b1()) {
      var item = tmp0_iterator_0.c1();
      // Inline function 'korlibs.image.style.Companion.ruleSetToKeyFrame.<anonymous>' call
      var tmp$ret$2 = new KeyFrame(Companion_instance_38.t5f(item.w5f_1), item.x5f_1);
      destination_0.h(tmp$ret$2);
    }
    return destination_0;
  }
}
class Token {
  constructor(str) {
    this.r5f_1 = str;
  }
  toString() {
    return 'Token(str=' + this.r5f_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.r5f_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Token))
      return false;
    var tmp0_other_with_cast = other instanceof Token ? other : THROW_CCE();
    if (!(this.r5f_1 === tmp0_other_with_cast.r5f_1))
      return false;
    return true;
  }
}
class sam$korlibs_math_interpolation_Easing$0 {
  constructor(function_0) {
    this.y5f_1 = function_0;
  }
  f1i(it) {
    return this.y5f_1(it);
  }
  g4() {
    return this.y5f_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Easing) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.g4(), other.g4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.g4());
  }
}
class IdSelector {
  constructor(token) {
    this.b5g_1 = token;
    this.c5g_1 = substr(this.b34(), 1);
  }
  b34() {
    return this.b5g_1.r5f_1;
  }
  toString() {
    return 'IdSelector(token=' + this.b5g_1.toString() + ')';
  }
  hashCode() {
    return this.b5g_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof IdSelector))
      return false;
    var tmp0_other_with_cast = other instanceof IdSelector ? other : THROW_CCE();
    if (!this.b5g_1.equals(tmp0_other_with_cast.b5g_1))
      return false;
    return true;
  }
}
class ClassSelector {
  constructor(token) {
    this.d5g_1 = token;
    this.e5g_1 = substr(this.b34(), 1);
  }
  b34() {
    return this.d5g_1.r5f_1;
  }
  toString() {
    return 'ClassSelector(token=' + this.d5g_1.toString() + ')';
  }
  hashCode() {
    return this.d5g_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ClassSelector))
      return false;
    var tmp0_other_with_cast = other instanceof ClassSelector ? other : THROW_CCE();
    if (!this.d5g_1.equals(tmp0_other_with_cast.d5g_1))
      return false;
    return true;
  }
}
class UnknownSelector {
  constructor(token) {
    this.f5g_1 = token;
  }
  b34() {
    return this.f5g_1.r5f_1;
  }
  toString() {
    return 'UnknownSelector(token=' + this.f5g_1.toString() + ')';
  }
  hashCode() {
    return this.f5g_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UnknownSelector))
      return false;
    var tmp0_other_with_cast = other instanceof UnknownSelector ? other : THROW_CCE();
    if (!this.f5g_1.equals(tmp0_other_with_cast.f5g_1))
      return false;
    return true;
  }
}
class Expression {
  constructor(expr) {
    this.g5g_1 = new Mixin();
    this.h5g_1 = expr;
    var tmp = this;
    tmp.i5g_1 = joinToString(this.h5g_1, ' ', VOID, VOID, VOID, VOID, CSS$Expression$exprStr$lambda);
  }
  y1i(_set____db54di) {
    this.g5g_1.y1i(_set____db54di);
  }
  z1i() {
    return this.g5g_1.z1i();
  }
  toString() {
    return 'Expression(expr=' + toString_0(this.h5g_1) + ')';
  }
  hashCode() {
    return hashCode(this.h5g_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Expression))
      return false;
    var tmp0_other_with_cast = other instanceof Expression ? other : THROW_CCE();
    if (!equals(this.h5g_1, tmp0_other_with_cast.h5g_1))
      return false;
    return true;
  }
}
class Declaration {
  constructor(property, expr) {
    this.j5g_1 = property;
    this.k5g_1 = expr;
  }
  toString() {
    return 'Declaration(property=' + this.j5g_1 + ', expr=' + toString(this.k5g_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.j5g_1);
    result = imul(result, 31) + (this.k5g_1 == null ? 0 : this.k5g_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Declaration))
      return false;
    var tmp0_other_with_cast = other instanceof Declaration ? other : THROW_CCE();
    if (!(this.j5g_1 === tmp0_other_with_cast.j5g_1))
      return false;
    if (!equals(this.k5g_1, tmp0_other_with_cast.k5g_1))
      return false;
    return true;
  }
}
class Declarations {
  constructor(declarations) {
    this.l5g_1 = new Mixin();
    this.m5g_1 = declarations;
    var tmp = this;
    // Inline function 'kotlin.collections.associate' call
    var this_0 = this.m5g_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap.bc(capacity);
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'korlibs.image.style.Declarations.declarationsMap.<anonymous>' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = element.j5g_1.toLowerCase();
      var pair = to(tmp$ret$1, element.k5g_1);
      destination.f3(pair.zk_1, pair.al_1);
    }
    tmp.n5g_1 = destination;
  }
  y1i(_set____db54di) {
    this.l5g_1.y1i(_set____db54di);
  }
  z1i() {
    return this.l5g_1.z1i();
  }
  xh(prop) {
    return this.n5g_1.d3(prop);
  }
  toString() {
    return 'Declarations(declarations=' + toString_0(this.m5g_1) + ')';
  }
  hashCode() {
    return hashCode(this.m5g_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Declarations))
      return false;
    var tmp0_other_with_cast = other instanceof Declarations ? other : THROW_CCE();
    if (!equals(this.m5g_1, tmp0_other_with_cast.m5g_1))
      return false;
    return true;
  }
}
class RuleSet {
  constructor(selector, declarations) {
    this.w5f_1 = selector;
    this.x5f_1 = declarations;
  }
  toString() {
    return 'RuleSet(selector=' + toString_0(this.w5f_1) + ', declarations=' + this.x5f_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.w5f_1);
    result = imul(result, 31) + this.x5f_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RuleSet))
      return false;
    var tmp0_other_with_cast = other instanceof RuleSet ? other : THROW_CCE();
    if (!equals(this.w5f_1, tmp0_other_with_cast.w5f_1))
      return false;
    if (!this.x5f_1.equals(tmp0_other_with_cast.x5f_1))
      return false;
    return true;
  }
}
class KeyFrame {
  constructor(ratio, declarations) {
    Companion_getInstance_45();
    this.o5g_1 = ratio;
    this.p5g_1 = declarations;
    var tmp = this;
    var tmp227_safe_receiver = this.xh('animation-timing-function');
    var tmp0_elvis_lhs = tmp227_safe_receiver == null ? null : get_easing(tmp227_safe_receiver);
    tmp.q5g_1 = tmp0_elvis_lhs == null ? Companion_getInstance_10().j1i_1 : tmp0_elvis_lhs;
  }
  xh(key) {
    return this.p5g_1.n5g_1.d3(key);
  }
  toString() {
    return 'KeyFrame(ratio=' + Ratio__toString_impl_mfgt3e(this.o5g_1) + ', declarations=' + this.p5g_1.toString() + ')';
  }
  hashCode() {
    var result = Ratio__hashCode_impl_quhc2v(this.o5g_1);
    result = imul(result, 31) + this.p5g_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyFrame))
      return false;
    var tmp0_other_with_cast = other instanceof KeyFrame ? other : THROW_CCE();
    if (!equals(this.o5g_1, tmp0_other_with_cast.o5g_1))
      return false;
    if (!this.p5g_1.equals(tmp0_other_with_cast.p5g_1))
      return false;
    return true;
  }
}
class InterpolationResult {
  constructor(ratio, k0, k1) {
    ratio = ratio === VOID ? 0.0 : ratio;
    k0 = k0 === VOID ? Companion_getInstance_45().s5f_1 : k0;
    k1 = k1 === VOID ? Companion_getInstance_45().s5f_1 : k1;
    this.r5g_1 = ratio;
    this.s5g_1 = k0;
    this.t5g_1 = k1;
  }
  u5g() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.s5g_1.p5g_1.m5g_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.style.InterpolationResult.<get-properties>.<anonymous>' call
      var tmp$ret$0 = item.j5g_1;
      destination.h(tmp$ret$0);
    }
    return destination;
  }
  toString() {
    return 'InterpolationResult(ratio=' + this.r5g_1 + ', k0=' + this.s5g_1.toString() + ', k1=' + this.t5g_1.toString() + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.r5g_1);
    result = imul(result, 31) + this.s5g_1.hashCode() | 0;
    result = imul(result, 31) + this.t5g_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InterpolationResult))
      return false;
    var tmp0_other_with_cast = other instanceof InterpolationResult ? other : THROW_CCE();
    if (!equals(this.r5g_1, tmp0_other_with_cast.r5g_1))
      return false;
    if (!this.s5g_1.equals(tmp0_other_with_cast.s5g_1))
      return false;
    if (!this.t5g_1.equals(tmp0_other_with_cast.t5g_1))
      return false;
    return true;
  }
}
class Animation {
  constructor(name, duration, delay, iterationCount, direction, easing) {
    var tmp;
    if (delay === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = delay;
    }
    delay = tmp;
    iterationCount = iterationCount === VOID ? -1 : iterationCount;
    direction = direction === VOID ? true : direction;
    easing = easing === VOID ? Companion_getInstance_10().j1i_1 : easing;
    this.v5g_1 = name;
    this.w5g_1 = duration;
    this.x5g_1 = delay;
    this.y5g_1 = iterationCount;
    this.z5g_1 = direction;
    this.a5h_1 = easing;
  }
  toString() {
    return 'Animation(name=' + this.v5g_1 + ', duration=' + Duration__toString_impl_8d916b(this.w5g_1) + ', delay=' + Duration__toString_impl_8d916b(this.x5g_1) + ', iterationCount=' + this.y5g_1 + ', direction=' + this.z5g_1 + ', easing=' + toString_0(this.a5h_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.v5g_1);
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.w5g_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.x5g_1) | 0;
    result = imul(result, 31) + this.y5g_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z5g_1) | 0;
    result = imul(result, 31) + hashCode(this.a5h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Animation))
      return false;
    var tmp0_other_with_cast = other instanceof Animation ? other : THROW_CCE();
    if (!(this.v5g_1 === tmp0_other_with_cast.v5g_1))
      return false;
    if (!equals(this.w5g_1, tmp0_other_with_cast.w5g_1))
      return false;
    if (!equals(this.x5g_1, tmp0_other_with_cast.x5g_1))
      return false;
    if (!(this.y5g_1 === tmp0_other_with_cast.y5g_1))
      return false;
    if (!(this.z5g_1 === tmp0_other_with_cast.z5g_1))
      return false;
    if (!equals(this.a5h_1, tmp0_other_with_cast.a5h_1))
      return false;
    return true;
  }
}
class KeyFrames {
  constructor(id, partialKeyFrames) {
    this.b5h_1 = id;
    this.c5h_1 = partialKeyFrames;
    var tmp = this;
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = this.c5h_1;
    var destination = ArrayList.i1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.style.KeyFrames.propertyNames.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_1 = element.p5g_1.m5g_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator_0 = this_1.a1();
      while (tmp0_iterator_0.b1()) {
        var item = tmp0_iterator_0.c1();
        // Inline function 'korlibs.image.style.KeyFrames.propertyNames.<anonymous>.<anonymous>' call
        var tmp$ret$0 = item.j5g_1;
        destination_0.h(tmp$ret$0);
      }
      var list = destination_0;
      addAll(destination, list);
    }
    tmp.d5h_1 = distinct(destination);
    this.e5h_1 = FastArrayList.r1j();
    // Inline function 'kotlin.collections.associateWith' call
    var this_2 = this.d5h_1;
    var result = LinkedHashMap.bc(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var tmp0_iterator_1 = this_2.a1();
    while (tmp0_iterator_1.b1()) {
      var element_0 = tmp0_iterator_1.c1();
      // Inline function 'korlibs.image.style.KeyFrames.<anonymous>' call
      var tmp$ret$6 = (null == null ? true : null instanceof Expression) ? null : THROW_CCE();
      result.f3(element_0, tmp$ret$6);
    }
    var currentMap = toMutableMap(result);
    var _iterator__ex2g4s = this.c5h_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var frame = _iterator__ex2g4s.c1();
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_0 = frame.p5g_1.n5g_1.m1().a1();
      while (_iterator__ex2g4s_0.b1()) {
        var _destruct__k2r9zo = _iterator__ex2g4s_0.c1();
        // Inline function 'kotlin.collections.component1' call
        var key = _destruct__k2r9zo.n1();
        // Inline function 'kotlin.collections.component2' call
        var value = _destruct__k2r9zo.o1();
        // Inline function 'kotlin.collections.set' call
        currentMap.f3(key, value);
      }
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList.w(currentMap.d1());
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_2 = currentMap.m1().a1();
      while (tmp0_iterator_2.b1()) {
        var item_0 = tmp0_iterator_2.c1();
        // Inline function 'korlibs.image.style.KeyFrames.<anonymous>' call
        var tmp$ret$13 = new Declaration(item_0.n1(), item_0.o1());
        destination_1.h(tmp$ret$13);
      }
      this.e5h_1.h(new KeyFrame(frame.o5g_1, new Declarations(destination_1)));
    }
  }
  f5h(ratio, out) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index = 0;
      var tmp0_iterator = this.e5h_1.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.image.style.KeyFrames.getAt.<anonymous>' call
        if (Ratio__compareTo_impl_z2ienc(item.o5g_1, ratio) >= 0) {
          tmp$ret$1 = index;
          break $l$block;
        }
        index = index + 1 | 0;
      }
      tmp$ret$1 = -1;
    }
    var firstFrameIndex = tmp$ret$1;
    if (firstFrameIndex >= 0) {
      var firstFrame = this.e5h_1.f1(firstFrameIndex);
      var tmp = out;
      var tmp228_subject = firstFrame.o5g_1;
      var tmp_0;
      if (equals(tmp228_subject, ratio)) {
        tmp_0 = firstFrame;
      } else {
        var tmp0_elvis_lhs = getOrNull_1(this.e5h_1, firstFrameIndex - 1 | 0);
        tmp_0 = tmp0_elvis_lhs == null ? firstFrame : tmp0_elvis_lhs;
      }
      tmp.s5g_1 = tmp_0;
      out.t5g_1 = firstFrame;
      var tmp_1 = out;
      var tmp_2;
      if (equals(out.s5g_1.o5g_1, out.t5g_1.o5g_1)) {
        tmp_2 = 0.0;
      } else {
        var easing = out.s5g_1.q5g_1;
        tmp_2 = easing.g1i(Ratio__toDouble_impl_o7epze(convertRange_0(ratio, out.s5g_1.o5g_1, out.t5g_1.o5g_1, Companion_getInstance_9().m1i_1, Companion_getInstance_9().p1i_1)));
      }
      tmp_1.r5g_1 = tmp_2;
    } else {
      out.s5g_1 = Companion_getInstance_45().s5f_1;
      out.t5g_1 = Companion_getInstance_45().s5f_1;
      out.r5g_1 = 0.0;
    }
    return out;
  }
  g5h(ratio, out, $super) {
    out = out === VOID ? new InterpolationResult() : out;
    return $super === VOID ? this.f5h(ratio, out) : $super.f5h.call(this, new Ratio(ratio), out);
  }
  toString() {
    return 'KeyFrames(id=' + this.b5h_1.toString() + ', partialKeyFrames=' + toString_0(this.c5h_1) + ')';
  }
  hashCode() {
    var result = this.b5h_1.hashCode();
    result = imul(result, 31) + hashCode(this.c5h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyFrames))
      return false;
    var tmp0_other_with_cast = other instanceof KeyFrames ? other : THROW_CCE();
    if (!this.b5h_1.equals(tmp0_other_with_cast.b5h_1))
      return false;
    if (!equals(this.c5h_1, tmp0_other_with_cast.c5h_1))
      return false;
    return true;
  }
}
class Companion_30 {
  h5h(str) {
    return (new CSSReader(reader(this.i5h(Companion_instance_6.a1i(str))))).k5h();
  }
  l5h(str) {
    return this.i5h(Companion_instance_6.a1i(str));
  }
  i5h(ss) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var out = ArrayList.i1();
    var buffer = StringBuilder.f();
    while (ss.s1g()) {
      var c = ss.s1h();
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(9) || (c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13))) {
        tokenize$flush(buffer, out);
      } else if (c === _Char___init__impl__6a9atx(47)) {
        if (ss.r1h() === _Char___init__impl__6a9atx(42)) {
          tokenize$flush(buffer, out);
          ss.x1h();
          var prev = {_v: new Char(_Char___init__impl__6a9atx(0))};
          skipWhile(ss, CSS$Companion$tokenize$lambda(prev));
          ss.w1h(1);
        } else {
          tokenize$flush(buffer, out);
          out.h(new Token(toString_1(c)));
        }
      } else if (c === _Char___init__impl__6a9atx(44) || c === _Char___init__impl__6a9atx(58) || (c === _Char___init__impl__6a9atx(59) || c === _Char___init__impl__6a9atx(40)) || (c === _Char___init__impl__6a9atx(91) || c === _Char___init__impl__6a9atx(41) || (c === _Char___init__impl__6a9atx(93) || (c === _Char___init__impl__6a9atx(123) || c === _Char___init__impl__6a9atx(125))))) {
        tokenize$flush(buffer, out);
        out.h(new Token(toString_1(c)));
      } else if (c === _Char___init__impl__6a9atx(45)) {
        var tmp;
        // Inline function 'kotlin.text.isNotEmpty' call
        if (charSequenceLength(buffer) > 0) {
          tmp = !(toDoubleOrNull(buffer.toString()) == null);
        } else {
          tmp = false;
        }
        if (tmp) {
          tokenize$flush(buffer, out);
          buffer.ob(c);
        } else {
          buffer.ob(c);
        }
      } else {
        buffer.ob(c);
      }
    }
    tokenize$flush(buffer, out);
    return out;
  }
  m5h(str) {
    // Inline function 'kotlin.text.trimEnd' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.trimEnd' call
      var this_0 = isCharSequence(str) ? str : THROW_CCE();
      var inductionVariable = charSequenceLength(this_0) - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          // Inline function 'korlibs.image.style.Companion.parseNumberDropSuffix.<anonymous>' call
          var it = charSequenceGet(this_0, index);
          if (!(!(it === _Char___init__impl__6a9atx(46)) && !(_Char___init__impl__6a9atx(48) <= it ? it <= _Char___init__impl__6a9atx(57) : false))) {
            tmp$ret$1 = charSequenceSubSequence(this_0, 0, index + 1 | 0);
            break $l$block;
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$1 = '';
    }
    var tmp$ret$2 = toString_0(tmp$ret$1);
    return toDoubleOrNull(tmp$ret$2);
  }
  n5h(str) {
    if (endsWith(str, 'ms')) {
      var tmp230_safe_receiver = toDoubleOrNull(removeSuffix(str, 'ms'));
      var tmp;
      if (tmp230_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'korlibs.time.milliseconds' call
        tmp = toDuration(tmp230_safe_receiver, DurationUnit_MILLISECONDS_getInstance());
      }
      return tmp;
    }
    if (endsWith(str, 's')) {
      var tmp231_safe_receiver = toDoubleOrNull(removeSuffix(str, 's'));
      var tmp_0;
      if (tmp231_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'korlibs.time.seconds' call
        tmp_0 = toDuration(tmp231_safe_receiver, DurationUnit_SECONDS_getInstance());
      }
      return tmp_0;
    }
    var tmp232_safe_receiver = this.m5h(str);
    var tmp_1;
    if (tmp232_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'korlibs.time.milliseconds' call
      tmp_1 = toDuration(tmp232_safe_receiver, DurationUnit_MILLISECONDS_getInstance());
    }
    return tmp_1;
  }
  o5h(str) {
    if (endsWith(str, 'deg')) {
      var tmp233_safe_receiver = toDoubleOrNull(removeSuffix(str, 'deg'));
      return tmp233_safe_receiver == null ? null : get_degrees_0(tmp233_safe_receiver);
    }
    if (endsWith(str, 'rad')) {
      var tmp234_safe_receiver = toDoubleOrNull(removeSuffix(str, 'rad'));
      return tmp234_safe_receiver == null ? null : get_radians(tmp234_safe_receiver);
    }
    var tmp235_safe_receiver = this.m5h(str);
    return tmp235_safe_receiver == null ? null : get_degrees_0(tmp235_safe_receiver);
  }
  a5g(str) {
    if (endsWith(str, '%')) {
      var tmp236_safe_receiver = toDoubleOrNull(removeSuffix(str, '%'));
      return tmp236_safe_receiver == null ? null : tmp236_safe_receiver / 100.0;
    }
    if (endsWith(str, 'px'))
      return toDoubleOrNull(removeSuffix(str, 'px'));
    if (endsWith(str, 'pt'))
      return toDoubleOrNull(removeSuffix(str, 'pt'));
    var tmp237_safe_receiver = this.m5h(str);
    return tmp237_safe_receiver == null ? null : tmp237_safe_receiver;
  }
  z5f(tr) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var args = ArrayList.i1();
    expect(tr, '(');
    $l$loop_0: while (true) {
      if (tr.e2p() === ')') {
        tr.a1v();
        break $l$loop_0;
      }
      if (tr.e2p() === ',') {
        tr.a1v();
        continue $l$loop_0;
      }
      // Inline function 'kotlin.collections.plusAssign' call
      var element = tr.a1v();
      args.h(element);
    }
    return args;
  }
  p5h(str) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.l5h(str);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.style.Companion.parseTransform.<anonymous>' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = item.r5f_1.toLowerCase();
      destination.h(tmp$ret$2);
    }
    var tokens = destination;
    var tr = new ListReader(tokens);
    var out = Companion_getInstance_5().q29();
    while (tr.s1g()) {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var id = tr.a1v().toLowerCase();
      // Inline function 'kotlin.collections.arrayListOf' call
      var args = ArrayList.i1();
      if (tr.e2p() === '(') {
        // Inline function 'kotlin.collections.plusAssign' call
        var elements = this.z5f(tr);
        addAll(args, elements);
      }
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(args, 10));
      var tmp0_iterator_0 = args.a1();
      while (tmp0_iterator_0.b1()) {
        var item_0 = tmp0_iterator_0.c1();
        // Inline function 'korlibs.image.style.Companion.parseTransform.<anonymous>' call
        var tmp0_elvis_lhs = Companion_instance_39.a5g(item_0);
        var tmp$ret$8 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
        destination_0.h(tmp$ret$8);
      }
      var doubleArgs = destination_0;
      switch (id) {
        case 'translate3d':
          println('Warning. CSS. translate3d not implemented');
          out = out.z2a(parseTransform$double(doubleArgs, 0), parseTransform$double(doubleArgs, 1));
          break;
        case 'translatey':
          out = out.z2a(0.0, parseTransform$double(doubleArgs, 0));
          break;
        case 'translatex':
          out = out.z2a(parseTransform$double(doubleArgs, 0), 0.0);
          break;
        case 'translatez':
          println('Warning. CSS. translatez not implemented');
          out = out.z2a(0.0, 0.0);
          break;
        case 'translate':
          out = out.z2a(parseTransform$double(doubleArgs, 0), parseTransform$double(doubleArgs, 1));
          break;
        case 'scale':
          out = out.r2a(parseTransform$double(doubleArgs, 0), doubleArgs.d1() >= 2 ? parseTransform$double(doubleArgs, 1) : parseTransform$double(doubleArgs, 0));
          break;
        case 'matrix':
          out = out.b2b(new Matrix(parseTransform$double(doubleArgs, 0), parseTransform$double(doubleArgs, 1), parseTransform$double(doubleArgs, 2), parseTransform$double(doubleArgs, 3), parseTransform$double(doubleArgs, 4), parseTransform$double(doubleArgs, 5)));
          break;
        case 'rotate':
          if (doubleArgs.d1() >= 3)
            out = out.z2a(parseTransform$double(doubleArgs, 1), parseTransform$double(doubleArgs, 2));
          var tmp0_elvis_lhs_0 = this.o5h(args.f1(0));
          var tmp;
          var tmp_0 = tmp0_elvis_lhs_0;
          if ((tmp_0 == null ? null : new Angle(tmp_0)) == null) {
            tmp = get_degrees(0);
          } else {
            tmp = tmp0_elvis_lhs_0;
          }

          var angle = tmp;
          out = out.a2b(angle);
          if (doubleArgs.d1() >= 3)
            out = out.z2a(-parseTransform$double(doubleArgs, 1), -parseTransform$double(doubleArgs, 2));
          break;
        default:
          invalidOp('Unsupported transform ' + id + ' : ' + args.toString() + ' : ' + toString_0(doubleArgs) + ' (' + str + ')');
          break;
      }
    }
    return out;
  }
  q5h(str, default_0) {
    if (endsWith(str, '%')) {
      var tmp0_elvis_lhs = this.m5h(str);
      return _Ratio___init__impl__9mwvn2_0((tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs) / 100.0);
    }
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp;
    switch (str.toLowerCase()) {
      case 'from':
        tmp = Companion_getInstance_9().m1i_1;
        break;
      case 'to':
        tmp = Companion_getInstance_9().p1i_1;
        break;
      default:
        var tmp1_elvis_lhs = this.m5h(str);
        tmp = _Ratio___init__impl__9mwvn2_0(tmp1_elvis_lhs == null ? Ratio__toDouble_impl_o7epze(default_0) : tmp1_elvis_lhs);
        break;
    }
    return tmp;
  }
  u5f(str, default_0, $super) {
    default_0 = default_0 === VOID ? Companion_getInstance_9().m1i_1 : default_0;
    return $super === VOID ? this.q5h(str, default_0) : $super.q5h.call(this, str, new Ratio(default_0)).l1i_1;
  }
  r5h(str) {
    return Colors_getInstance().f4d(str, Colors_getInstance().o3z_1);
  }
  s5h(str) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.l5h(str);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.style.Companion.parseEasing.<anonymous>' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = item.r5f_1.toLowerCase();
      destination.h(tmp$ret$2);
    }
    return parseEasing$parseEasing(reader(destination));
  }
  t5h(size) {
    // Inline function 'kotlin.text.filter' call
    // Inline function 'kotlin.text.filterTo' call
    var destination = StringBuilder.f();
    var inductionVariable = 0;
    var last = charSequenceLength(size);
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var element = charSequenceGet(size, index);
        // Inline function 'korlibs.image.style.Companion.parseSizeAsDouble.<anonymous>' call
        if (!(_Char___init__impl__6a9atx(97) <= element ? element <= _Char___init__impl__6a9atx(122) : false) && !(_Char___init__impl__6a9atx(65) <= element ? element <= _Char___init__impl__6a9atx(90) : false)) {
          destination.ob(element);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$2 = destination.toString();
    var tmp0_elvis_lhs = toDoubleOrNull(tmp$ret$2);
    return tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
  }
  u5h(str) {
    var tokens = reader(this.l5h(str));
    var id = tokens.a1v().r5f_1;
    var tmp0_elvis_lhs = this.n5h(tokens.a1v().r5f_1);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new Duration(tmp_0)) == null) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(1, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var duration = tmp;
    return new Animation(id, duration);
  }
}
class CSS {
  static a5i(allRules, unit) {
    unit = unit === VOID ? Unit_instance : unit;
    var $this = createThis(this);
    $this.v5h_1 = allRules;
    var tmp = $this;
    // Inline function 'kotlin.collections.associateBy' call
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var this_0 = $this.v5h_1;
    var destination = ArrayList.i1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      if (element instanceof KeyFrames) {
        destination.h(element);
      }
    }
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.bc(capacity);
    var tmp0_iterator_0 = destination.a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.image.style.CSS.animationsById.<anonymous>' call
      var tmp$ret$2 = element_0.b5h_1.r5f_1;
      destination_0.f3(tmp$ret$2, element_0);
    }
    tmp.w5h_1 = destination_0;
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var this_1 = $this.v5h_1;
    var destination_1 = ArrayList.i1();
    var tmp0_iterator_1 = this_1.a1();
    while (tmp0_iterator_1.b1()) {
      var element_1 = tmp0_iterator_1.c1();
      if (element_1 instanceof RuleSet) {
        destination_1.h(element_1);
      }
    }
    tmp_0.x5h_1 = destination_1;
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.associateBy' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_2 = $this.x5h_1;
    var destination_2 = ArrayList.i1();
    var tmp0_iterator_2 = this_2.a1();
    while (tmp0_iterator_2.b1()) {
      var element_2 = tmp0_iterator_2.c1();
      // Inline function 'korlibs.image.style.CSS.rulesForIds.<anonymous>' call
      var tmp_2 = element_2.w5f_1;
      if (tmp_2 instanceof IdSelector) {
        destination_2.h(element_2);
      }
    }
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination_2, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_3 = LinkedHashMap.bc(capacity_0);
    var tmp0_iterator_3 = destination_2.a1();
    while (tmp0_iterator_3.b1()) {
      var element_3 = tmp0_iterator_3.c1();
      // Inline function 'korlibs.image.style.CSS.rulesForIds.<anonymous>' call
      var tmp_3 = element_3.w5f_1;
      var tmp$ret$10 = (tmp_3 instanceof IdSelector ? tmp_3 : THROW_CCE()).c5g_1;
      destination_3.f3(tmp$ret$10, element_3);
    }
    tmp_1.y5h_1 = destination_3;
    var tmp_4 = $this;
    // Inline function 'kotlin.collections.associateBy' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_3 = $this.x5h_1;
    var destination_4 = ArrayList.i1();
    var tmp0_iterator_4 = this_3.a1();
    while (tmp0_iterator_4.b1()) {
      var element_4 = tmp0_iterator_4.c1();
      // Inline function 'korlibs.image.style.CSS.rulesForClassNames.<anonymous>' call
      var tmp_5 = element_4.w5f_1;
      if (tmp_5 instanceof ClassSelector) {
        destination_4.h(element_4);
      }
    }
    var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination_4, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_5 = LinkedHashMap.bc(capacity_1);
    var tmp0_iterator_5 = destination_4.a1();
    while (tmp0_iterator_5.b1()) {
      var element_5 = tmp0_iterator_5.c1();
      // Inline function 'korlibs.image.style.CSS.rulesForClassNames.<anonymous>' call
      var tmp_6 = element_5.w5f_1;
      var tmp$ret$16 = (tmp_6 instanceof ClassSelector ? tmp_6 : THROW_CCE()).e5g_1;
      destination_5.f3(tmp$ret$16, element_5);
    }
    tmp_4.z5h_1 = destination_5;
    return $this;
  }
  static b5i(cssList) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList.i1();
    var tmp0_iterator = cssList.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.style.CSS.<init>.<anonymous>' call
      var list = element.v5h_1;
      addAll(destination, list);
    }
    return this.a5i(destination);
  }
  toString() {
    return 'CSS(rules = ' + this.x5h_1.d1() + ', animations = ' + this.w5h_1.d1() + ')';
  }
}
class sam$kotlin_Comparator$0_1 {
  constructor(function_0) {
    this.c5i_1 = function_0;
  }
  qi(a, b) {
    return this.c5i_1(a, b);
  }
  compare(a, b) {
    return this.qi(a, b);
  }
  g4() {
    return this.c5i_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.g4(), other.g4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.g4());
  }
}
class CSSReader {
  constructor(tokens) {
    this.j5h_1 = tokens;
  }
  k5h() {
    return CSS.a5i(this.d5i());
  }
  d5i() {
    // Inline function 'kotlin.collections.arrayListOf' call
    var out = ArrayList.i1();
    while (this.j5h_1.s1g()) {
      // Inline function 'kotlin.collections.plusAssign' call
      var elements = this.e5i();
      addAll(out, elements);
    }
    return out;
  }
  f5i(token) {
    if (startsWith(token.r5f_1, '#'))
      return new IdSelector(token);
    if (startsWith(token.r5f_1, '.'))
      return new ClassSelector(token);
    return new UnknownSelector(token);
  }
  e5i() {
    var token = this.j5h_1.e2p();
    if (startsWith(token.r5f_1, '@')) {
      this.j5h_1.a1v();
      switch (token.r5f_1) {
        case '@keyframes':
        case '@-webkit-keyframes':
          var keyframesName = this.j5h_1.a1v();
          // Inline function 'kotlin.collections.arrayListOf' call

          var sets = ArrayList.i1();
          expect(this.j5h_1, new Token('{'));
          while (!this.j5h_1.e2p().equals(new Token('}'))) {
            var frame = Companion_instance_38.v5f(this.e5i());
            if (!(frame == null)) {
              // Inline function 'kotlin.collections.plusAssign' call
              addAll(sets, frame);
            }
          }

          expect(this.j5h_1, new Token('}'));
          // Inline function 'kotlin.collections.sortedBy' call

          // Inline function 'kotlin.comparisons.compareBy' call

          var tmp = CSSReader$parseRuleset$lambda;
          var tmp$ret$1 = new sam$kotlin_Comparator$0_1(tmp);
          var tmp$ret$2 = sortedWith(sets, tmp$ret$1);
          return listOf_0(new KeyFrames(keyframesName, tmp$ret$2));
        default:
          // Inline function 'kotlin.TODO' call

          var reason = "Unknown at rule: '" + token.toString() + "'";
          throw NotImplementedError.nd('An operation is not implemented: ' + reason);
      }
    } else {
      // Inline function 'kotlin.collections.arrayListOf' call
      var selectors = ArrayList.i1();
      $l$loop_0: while (this.j5h_1.s1g()) {
        var token_0 = this.j5h_1.a1v();
        // Inline function 'kotlin.collections.plusAssign' call
        var element = this.f5i(token_0);
        selectors.h(element);
        if (this.j5h_1.e2p().r5f_1 === ',') {
          this.j5h_1.f2p();
          continue $l$loop_0;
        }
        if (this.j5h_1.e2p().r5f_1 === '{') {
          break $l$loop_0;
        }
      }
      // Inline function 'kotlin.collections.arrayListOf' call
      var decls = ArrayList.i1();
      expect(this.j5h_1, new Token('{'));
      while (!this.j5h_1.e2p().equals(new Token('}'))) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element_0 = this.g5i();
        decls.h(element_0);
      }
      expect(this.j5h_1, new Token('}'));
      var declsd = new Declarations(decls);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(selectors, 10));
      var tmp0_iterator = selectors.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.image.style.CSSReader.parseRuleset.<anonymous>' call
        var tmp$ret$5 = new RuleSet(item, declsd);
        destination.h(tmp$ret$5);
      }
      return destination;
    }
  }
  g5i() {
    var property = removePrefix(this.j5h_1.a1v().r5f_1, '-webkit-');
    expect(this.j5h_1, new Token(':'));
    var expression = this.h5i();
    return new Declaration(property, expression);
  }
  h5i() {
    // Inline function 'kotlin.collections.arrayListOf' call
    var out = ArrayList.i1();
    $l$loop_0: while (true) {
      var token = this.j5h_1.a1v();
      if (token.r5f_1 === ';') {
        break $l$loop_0;
      }
      if (token.r5f_1 === '}') {
        this.j5h_1.w1h(-1);
        break $l$loop_0;
      }
      out.h(token);
    }
    return new Expression(out);
  }
}
class RatioMapping {
  constructor(name, property) {
    this.i5i_1 = name;
    this.j5i_1 = property;
  }
  k5i(element, prop, value) {
    this.j5i_1.set(element, Ratio__toDouble_impl_o7epze(Companion_instance_40.l5i(prop, value)));
  }
}
class MatrixMapping {
  constructor(name, property) {
    this.m5i_1 = name;
    this.n5i_1 = property;
  }
  k5i(element, prop, value) {
    this.n5i_1.set(element, Companion_instance_40.o5i(prop, value));
  }
}
class DomPropertyMapping {
  constructor() {
    this.z5i_1 = HashMap.f8();
  }
  a5j(name, property) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.style.DomPropertyMapping.add.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.z5i_1;
    var value = new RatioMapping(name, isInterface(property, KMutableProperty1) ? property : THROW_CCE());
    this_0.f3(name, value);
    return this;
  }
  b5j(name, property) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.style.DomPropertyMapping.add.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.z5i_1;
    var value = new MatrixMapping(name, isInterface(property, KMutableProperty1) ? property : THROW_CCE());
    this_0.f3(name, value);
    return this;
  }
}
class DomElement {
  constructor(dom, mappings, $box) {
    mappings = mappings === VOID ? null : mappings;
    boxApply(this, $box);
    this.v5i_1 = dom;
    this.w5i_1 = mappings;
    this.x5i_1 = null;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp.y5i_1 = LinkedHashSet.h1();
  }
  c5j(value) {
    if (!(this.x5i_1 == null)) {
      _get_listener__4cngyf(this).e5j(this, ensureNotNull(this.x5i_1));
    }
    this.x5i_1 = value;
    if (!(this.x5i_1 == null)) {
      _get_listener__4cngyf(this).f5j(this, ensureNotNull(this.x5i_1));
    }
  }
  g5j() {
    return this.y5i_1;
  }
  h5j(prop, value) {
    var tmp253_safe_receiver = this.w5i_1;
    var tmp254_safe_receiver = tmp253_safe_receiver == null ? null : tmp253_safe_receiver.z5i_1;
    var tmp255_safe_receiver = tmp254_safe_receiver == null ? null : tmp254_safe_receiver.d3(prop);
    if (tmp255_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      tmp255_safe_receiver.k5i(this, prop, value);
    }
  }
  i5j(result) {
    var properties = result.u5g();
    var _iterator__ex2g4s = properties.a1();
    while (_iterator__ex2g4s.b1()) {
      var prop = _iterator__ex2g4s.c1();
      this.h5j(prop, result);
    }
  }
}
class DomListener {}
function removedId(element, id) {
  return this.j5j(element);
}
function addedId(element, id) {
  return this.j5j(element);
}
function updatedElement(element) {
  return Unit_instance;
}
class ComposedDomListener {
  constructor(list) {
    this.d5j_1 = list;
  }
  e5j(element, id) {
    var this_0 = this.d5j_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.image.style.ComposedDomListener.removedId.<anonymous>' call
      this_0.f1((this_0.d1() - n | 0) - 1 | 0).e5j(element, id);
      n = n + 1 | 0;
    }
    return Unit_instance;
  }
  f5j(element, id) {
    var this_0 = this.d5j_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.image.style.ComposedDomListener.addedId.<anonymous>' call
      this_0.f1((this_0.d1() - n | 0) - 1 | 0).f5j(element, id);
      n = n + 1 | 0;
    }
    return Unit_instance;
  }
  j5j(element) {
    var this_0 = this.d5j_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.image.style.ComposedDomListener.updatedElement.<anonymous>' call
      this_0.f1((this_0.d1() - n | 0) - 1 | 0).j5j(element);
      n = n + 1 | 0;
    }
    return Unit_instance;
  }
}
class Companion_31 {
  o5i(prop, value) {
    var tmp;
    if (value instanceof Matrix) {
      tmp = value;
    } else {
      if (value instanceof InterpolationResult) {
        tmp = getMatrix(value, prop);
      } else {
        if (value instanceof Expression) {
          tmp = get_matrix(value);
        } else {
          tmp = Companion_getInstance_5().n29_1;
        }
      }
    }
    return tmp;
  }
  l5i(prop, value) {
    var tmp;
    if (!(value == null) ? typeof value === 'number' : false) {
      tmp = toRatio(value);
    } else {
      if (!(value == null) ? typeof value === 'number' : false) {
        tmp = toRatio_0(value);
      } else {
        if (value instanceof InterpolationResult) {
          tmp = getRatio(value, prop);
        } else {
          if (value instanceof Expression) {
            tmp = get_ratio(value);
          } else {
            tmp = Companion_getInstance_9().m1i_1;
          }
        }
      }
    }
    return tmp;
  }
}
class DOM$internalListener$1 {
  constructor(this$0) {
    this.k5j_1 = this$0;
  }
  e5j(element, id) {
    this.k5j_1.q5i_1.g3(id);
  }
  f5j(element, id) {
    // Inline function 'kotlin.collections.set' call
    this.k5j_1.q5i_1.f3(id, element);
  }
}
class DOM {
  constructor(css) {
    this.p5i_1 = css;
    this.q5i_1 = HashMap.f8();
    this.r5i_1 = HashMap.f8();
    var tmp = this;
    tmp.s5i_1 = new DOM$internalListener$1(this);
    this.t5i_1 = arrayListOf([this.s5i_1]);
    this.u5i_1 = new ComposedDomListener(this.t5i_1);
  }
}
class DOMAnimator$1 {
  constructor(this$0) {
    this.l5j_1 = this$0;
  }
  j5j(element) {
    this.l5j_1.o5j(element instanceof SvgElement ? element : THROW_CCE());
  }
}
class DOMAnimator {
  constructor(dom) {
    this.m5j_1 = dom;
    var tmp = this;
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    tmp.n5j_1 = toDuration(0, DurationUnit_SECONDS_getInstance());
    this.m5j_1.t5i_1.h(new DOMAnimator$1(this));
  }
  p5j() {
    return this.m5j_1.p5i_1;
  }
  o5j(element) {
    // Inline function 'kotlin.collections.get' call
    var this_0 = this.p5j().y5h_1;
    var key = element.x5i_1;
    var tmp$ret$0 = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).d3(key);
    var tmp = listOf_0(tmp$ret$0);
    // Inline function 'kotlin.collections.map' call
    var this_1 = element.g5j();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.style.DOMAnimator.updateElement.<anonymous>' call
      var tmp$ret$1 = this.p5j().z5h_1.d3(item);
      destination.h(tmp$ret$1);
    }
    var rules = filterNotNull(plus(tmp, destination));
    var _iterator__ex2g4s = rules.a1();
    while (_iterator__ex2g4s.b1()) {
      var rule = _iterator__ex2g4s.c1();
      var decls = rule.x5f_1;
      var tmp259_safe_receiver = get_animation(decls);
      if (tmp259_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        $l$block: {
          // Inline function 'korlibs.image.style.DOMAnimator.updateElement.<anonymous>' call
          var tmp0_elvis_lhs = this.p5j().w5h_1.d3(tmp259_safe_receiver.v5g_1);
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            break $l$block;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var animation = tmp_0;
          // Inline function 'korlibs.time.rem' call
          var this_2 = this.n5j_1;
          var other = tmp259_safe_receiver.w5g_1;
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          var this_3 = get_milliseconds(this_2) % get_milliseconds(other);
          var tmp$ret$6 = toDuration(this_3, DurationUnit_MILLISECONDS_getInstance());
          var ratio = Duration__div_impl_dknbf4(tmp$ret$6, tmp259_safe_receiver.w5g_1);
          var results = animation.g5h(toRatio_0(ratio));
          element.i5j(results);
        }
      }
      var _iterator__ex2g4s_0 = decls.m5g_1.a1();
      while (_iterator__ex2g4s_0.b1()) {
        var decl = _iterator__ex2g4s_0.c1();
        element.h5j(decl.j5g_1, decl.k5g_1);
      }
    }
  }
}
class Companion_32 {
  constructor() {
    Companion_instance_41 = this;
    this.q5j_1 = _VerticalAlign___init__impl__f42kfq(0.0);
    this.r5j_1 = _VerticalAlign___init__impl__f42kfq(0.5);
    this.s5j_1 = _VerticalAlign___init__impl__f42kfq(1.0);
    this.t5j_1 = _VerticalAlign___init__impl__f42kfq(Infinity);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u5j_1 = [new VerticalAlign(this.q5j_1), new VerticalAlign(this.r5j_1), new VerticalAlign(this.t5j_1), new VerticalAlign(this.s5j_1)];
    this.v5j_1 = toList_1(this.u5j_1);
  }
}
class VerticalAlign {
  constructor(ratio) {
    Companion_getInstance_49();
    this.w5j_1 = ratio;
  }
  toString() {
    return VerticalAlign__toString_impl_hcpnn2(this.w5j_1);
  }
  hashCode() {
    return VerticalAlign__hashCode_impl_vx8hj7(this.w5j_1);
  }
  equals(other) {
    return VerticalAlign__equals_impl_xp13z(this.w5j_1, other);
  }
}
class Companion_33 {
  constructor() {
    Companion_instance_42 = this;
    this.x5j_1 = _HorizontalAlign___init__impl__ad654o(-1.0 / 2048.0);
    this.y5j_1 = _HorizontalAlign___init__impl__ad654o(0.0);
    this.z5j_1 = _HorizontalAlign___init__impl__ad654o(0.5);
    this.a5k_1 = _HorizontalAlign___init__impl__ad654o(1.0);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b5k_1 = [new HorizontalAlign(this.y5j_1), new HorizontalAlign(this.z5j_1), new HorizontalAlign(this.a5k_1), new HorizontalAlign(this.x5j_1)];
    this.c5k_1 = toList_1(this.b5k_1);
  }
}
class HorizontalAlign {
  constructor(ratio) {
    Companion_getInstance_50();
    this.d5k_1 = ratio;
  }
  toString() {
    return HorizontalAlign__toString_impl_toflc0(this.d5k_1);
  }
  hashCode() {
    return HorizontalAlign__hashCode_impl_7x9oj5(this.d5k_1);
  }
  equals(other) {
    return HorizontalAlign__equals_impl_hkfbhv(this.d5k_1, other);
  }
}
class Companion_34 {
  constructor() {
    Companion_instance_43 = this;
    this.m4l_1 = listOf([new HorizontalAlign(Companion_getInstance_50().y5j_1), new HorizontalAlign(Companion_getInstance_50().z5j_1), new HorizontalAlign(Companion_getInstance_50().a5k_1), new HorizontalAlign(Companion_getInstance_50().x5j_1)]);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.m4l_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.text.Companion.TOP.<anonymous>' call
      var it = item.d5k_1;
      var tmp$ret$0 = new TextAlignment(it, Companion_getInstance_49().q5j_1);
      destination.h(tmp$ret$0);
    }
    tmp.n4l_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.m4l_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var item_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.image.text.Companion.BASELINE.<anonymous>' call
      var it_0 = item_0.d5k_1;
      var tmp$ret$3 = new TextAlignment(it_0, Companion_getInstance_49().t5j_1);
      destination_0.h(tmp$ret$3);
    }
    tmp_0.o4l_1 = destination_0;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = this.m4l_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator_1 = this_2.a1();
    while (tmp0_iterator_1.b1()) {
      var item_1 = tmp0_iterator_1.c1();
      // Inline function 'korlibs.image.text.Companion.MIDDLE.<anonymous>' call
      var it_1 = item_1.d5k_1;
      var tmp$ret$6 = new TextAlignment(it_1, Companion_getInstance_49().r5j_1);
      destination_1.h(tmp$ret$6);
    }
    tmp_1.p4l_1 = destination_1;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.map' call
    var this_3 = this.m4l_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList.w(collectionSizeOrDefault(this_3, 10));
    var tmp0_iterator_2 = this_3.a1();
    while (tmp0_iterator_2.b1()) {
      var item_2 = tmp0_iterator_2.c1();
      // Inline function 'korlibs.image.text.Companion.BOTTOM.<anonymous>' call
      var it_2 = item_2.d5k_1;
      var tmp$ret$9 = new TextAlignment(it_2, Companion_getInstance_49().s5j_1);
      destination_2.h(tmp$ret$9);
    }
    tmp_2.q4l_1 = destination_2;
    this.r4l_1 = plus(plus(plus(this.n4l_1, this.o4l_1), this.p4l_1), this.q4l_1);
    this.s4l_1 = this.n4l_1.f1(0);
    this.t4l_1 = this.n4l_1.f1(1);
    this.u4l_1 = this.n4l_1.f1(2);
    this.v4l_1 = this.n4l_1.f1(3);
    this.w4l_1 = this.o4l_1.f1(0);
    this.x4l_1 = this.o4l_1.f1(1);
    this.y4l_1 = this.o4l_1.f1(2);
    this.z4l_1 = this.o4l_1.f1(3);
    this.a4m_1 = this.n4l_1.f1(0);
    this.b4m_1 = this.n4l_1.f1(1);
    this.c4m_1 = this.n4l_1.f1(2);
    this.d4m_1 = this.n4l_1.f1(3);
    this.e4m_1 = this.p4l_1.f1(0);
    this.f4m_1 = this.p4l_1.f1(1);
    this.g4m_1 = this.p4l_1.f1(2);
    this.h4m_1 = this.p4l_1.f1(3);
    this.i4m_1 = this.q4l_1.f1(0);
    this.j4m_1 = this.q4l_1.f1(1);
    this.k4m_1 = this.q4l_1.f1(2);
    this.l4m_1 = this.q4l_1.f1(3);
  }
  e5k(horizontal, vertical) {
    var tmp;
    if (equals(horizontal, Companion_getInstance_50().y5j_1)) {
      tmp = 0;
    } else if (equals(horizontal, Companion_getInstance_50().z5j_1)) {
      tmp = 1;
    } else if (equals(horizontal, Companion_getInstance_50().a5k_1)) {
      tmp = 2;
    } else if (equals(horizontal, Companion_getInstance_50().x5j_1)) {
      tmp = 3;
    } else {
      return new TextAlignment(horizontal, vertical);
    }
    var horizontalIndex = tmp;
    return equals(vertical, Companion_getInstance_49().q5j_1) ? this.n4l_1.f1(horizontalIndex) : equals(vertical, Companion_getInstance_49().t5j_1) ? this.o4l_1.f1(horizontalIndex) : equals(vertical, Companion_getInstance_49().r5j_1) ? this.p4l_1.f1(horizontalIndex) : equals(vertical, Companion_getInstance_49().s5j_1) ? this.q4l_1.f1(horizontalIndex) : new TextAlignment(horizontal, vertical);
  }
}
class TextAlignment {
  constructor(horizontal, vertical) {
    Companion_getInstance_51();
    this.k4n_1 = horizontal;
    this.l4n_1 = vertical;
    this.m4n_1 = Anchor2D.q25(_HorizontalAlign___get_ratioFake__impl__h46z0d(this.k4n_1), _VerticalAlign___get_ratioFake__impl__1h2fwv(this.l4n_1));
  }
  toString() {
    return VerticalAlign__toString_impl_hcpnn2(this.l4n_1) + '_' + HorizontalAlign__toString_impl_toflc0(this.k4n_1);
  }
  hashCode() {
    var result = HorizontalAlign__hashCode_impl_7x9oj5(this.k4n_1);
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.l4n_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextAlignment))
      return false;
    var tmp0_other_with_cast = other instanceof TextAlignment ? other : THROW_CCE();
    if (!equals(this.k4n_1, tmp0_other_with_cast.k4n_1))
      return false;
    if (!equals(this.l4n_1, tmp0_other_with_cast.l4n_1))
      return false;
    return true;
  }
}
class TextRenderer {}
function get_version() {
  return 0;
}
class LineStats {
  constructor(maxLineHeight, maxX, bounds) {
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    maxX = maxX === VOID ? 0.0 : maxX;
    bounds = bounds === VOID ? Companion_getInstance_7().c27() : bounds;
    this.o4n_1 = maxLineHeight;
    this.p4n_1 = maxX;
    this.q4n_1 = bounds;
  }
  r4n(align) {
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, this.p4n_1) + BoundsBuilder__xminOr_impl_k3l1m2(this.q4n_1, 0.0);
  }
  g4q(dx) {
    this.p4n_1 = this.p4n_1 + dx;
  }
  h5k(fontMetrics) {
    var tmp = this;
    // Inline function 'kotlin.math.max' call
    var a = this.o4n_1;
    var b = fontMetrics.t4e();
    tmp.o4n_1 = Math.max(a, b);
  }
  i5k() {
  }
  d2q() {
    this.p4n_1 = 0.0;
    this.q4n_1 = Companion_getInstance_7().x26_1;
    this.o4n_1 = 0.0;
  }
  toString() {
    return 'LineStats(maxLineHeight=' + this.o4n_1 + ', maxX=' + this.p4n_1 + ', bounds=' + BoundsBuilder__toString_impl_fmvxh7(this.q4n_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.o4n_1);
    result = imul(result, 31) + getNumberHashCode(this.p4n_1) | 0;
    result = imul(result, 31) + BoundsBuilder__hashCode_impl_649zbo(this.q4n_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LineStats))
      return false;
    var tmp0_other_with_cast = other instanceof LineStats ? other : THROW_CCE();
    if (!equals(this.o4n_1, tmp0_other_with_cast.o4n_1))
      return false;
    if (!equals(this.p4n_1, tmp0_other_with_cast.p4n_1))
      return false;
    if (!equals(this.q4n_1, tmp0_other_with_cast.q4n_1))
      return false;
    return true;
  }
}
class BoundBuilderTextRendererActions extends TextRendererActions {
  constructor() {
    super();
    this.e4n_1 = Companion_getInstance_7().c27();
    this.f4n_1 = Companion_getInstance_7().c27();
    this.g4n_1 = 0;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.h4n_1 = ArrayList.i1();
    this.i4n_1 = new LineStats();
  }
  j4n() {
    return this.g4n_1;
  }
  j5k() {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = this.h4n_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      var tmp = sum;
      // Inline function 'korlibs.image.text.BoundBuilderTextRendererActions.<get-totalMaxLineHeight>.<anonymous>' call
      sum = tmp + element.o4n_1;
    }
    return sum;
  }
  w4p(align, line) {
    var tmp0_elvis_lhs = getOrNull_1(this.h4n_1, line);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return HorizontalAlign__getOffsetX_impl_urzzxf(align, 0.0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var line_0 = tmp;
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, line_0.p4n_1);
  }
  n4n(align, fontMetrics) {
    return VerticalAlign__getOffsetYRespectBaseline_impl_62po5b(align, fontMetrics, this.j5k());
  }
  d2q() {
    super.d2q();
    this.g4n_1 = 0;
    this.f4n_1 = Companion_getInstance_7().x26_1;
    this.e4n_1 = Companion_getInstance_7().x26_1;
    this.i4n_1.d2q();
    this.h4n_1.y2();
  }
  k4p(reader, codePoint) {
    var g = this.e4q(reader, codePoint);
    add_0(this, g.s4f_1);
    this.i4n_1.h5k(this.n4p_1);
    return g;
  }
  g4q(x) {
    super.g4q(x);
    this.i4n_1.g4q(x);
  }
  h4q(y, end) {
    super.h4q(y, end);
    this.g4n_1 = this.g4n_1 + 1 | 0;
    this.i4n_1.h5k(this.n4p_1);
    this.i4n_1.i5k();
    this.h4n_1.h(this.i4n_1);
    this.i4n_1 = new LineStats();
  }
}
class LineInfo {
  constructor(maxTop, minBottom, maxLineHeight) {
    maxTop = maxTop === VOID ? 0.0 : maxTop;
    minBottom = minBottom === VOID ? 0.0 : minBottom;
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    this.k5k_1 = maxTop;
    this.l5k_1 = minBottom;
    this.m5k_1 = maxLineHeight;
  }
  toString() {
    return 'LineInfo(maxTop=' + this.k5k_1 + ', minBottom=' + this.l5k_1 + ', maxLineHeight=' + this.m5k_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.k5k_1);
    result = imul(result, 31) + getNumberHashCode(this.l5k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.m5k_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LineInfo))
      return false;
    var tmp0_other_with_cast = other instanceof LineInfo ? other : THROW_CCE();
    if (!equals(this.k5k_1, tmp0_other_with_cast.k5k_1))
      return false;
    if (!equals(this.l5k_1, tmp0_other_with_cast.l5k_1))
      return false;
    if (!equals(this.m5k_1, tmp0_other_with_cast.m5k_1))
      return false;
    return true;
  }
}
class Entry_0 {
  constructor(tex, x, y, sx, sy, rot) {
    var tmp;
    if (tex === VOID) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tex;
    }
    tex = tmp;
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    sx = sx === VOID ? 1.0 : sx;
    sy = sy === VOID ? 1.0 : sy;
    rot = rot === VOID ? get_radians_0(0) : rot;
    this.n5k_1 = tex;
    this.o5k_1 = x;
    this.p5k_1 = y;
    this.q5k_1 = sx;
    this.r5k_1 = sy;
    this.s5k_1 = rot;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.Entry.toString.<anonymous>' call
    this_0.nb('Entry(');
    this_0.nb("'" + this.n5k_1.n3g_1 + "', " + numberToInt(this.o5k_1) + ', ' + numberToInt(this.p5k_1) + ', ' + this.n5k_1.s3g_1 + ', ' + this.n5k_1.t3g_1);
    if (!(this.q5k_1 === 1.0)) {
      this_0.nb(', sx=' + get_niceStr_0(this.q5k_1));
    }
    if (!(this.r5k_1 === 1.0)) {
      this_0.nb(', sy=' + get_niceStr_0(this.r5k_1));
    }
    if (!equals(this.s5k_1, get_radians_0(0))) {
      this_0.nb(', rot=' + get_niceStr_0(_Angle___get_degrees__impl__qg56vw(this.s5k_1)));
    }
    this_0.nb(')');
    return this_0.toString();
  }
  hashCode() {
    var result = this.n5k_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.o5k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p5k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q5k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r5k_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.s5k_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_0))
      return false;
    var tmp0_other_with_cast = other instanceof Entry_0 ? other : THROW_CCE();
    if (!this.n5k_1.equals(tmp0_other_with_cast.n5k_1))
      return false;
    if (!equals(this.o5k_1, tmp0_other_with_cast.o5k_1))
      return false;
    if (!equals(this.p5k_1, tmp0_other_with_cast.p5k_1))
      return false;
    if (!equals(this.q5k_1, tmp0_other_with_cast.q5k_1))
      return false;
    if (!equals(this.r5k_1, tmp0_other_with_cast.r5k_1))
      return false;
    if (!equals(this.s5k_1, tmp0_other_with_cast.s5k_1))
      return false;
    return true;
  }
}
class Text2TextRendererActions extends TextRendererActions {
  constructor() {
    super();
    this.d5l_1 = Companion_getInstance_51().s4l_1;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.e5l_1 = ArrayList.i1();
    this.f5l_1 = doubleArrayListOf(new Float64Array([]));
    this.g5l_1 = doubleArrayListOf(new Float64Array([]));
    this.h5l_1 = doubleArrayListOf(new Float64Array([]));
    this.i5l_1 = doubleArrayListOf(new Float64Array([]));
    this.j5l_1 = doubleArrayListOf(new Float64Array([]));
    this.k5l_1 = new DoubleVectorArrayList(4);
    this.l5l_1 = MatrixTransform.z2b();
  }
  m5l() {
    return this.d5l_1.l4n_1;
  }
  d1() {
    return this.f5l_1.d1();
  }
  n5l() {
    var out = arrayListOf([new LineInfo()]);
    // Inline function 'korlibs.math.geom.fastForEachGeneric' call
    var this_0 = this.k5l_1;
    var inductionVariable = 0;
    var last = this_0.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.text.Text2TextRendererActions.getLineInfos.<anonymous>' call
        var line = numberToInt(this_0.n28(n, 0));
        while (out.d1() <= line) {
          out.h(new LineInfo());
        }
        var lineInfo = out.f1(line);
        var top = this_0.n28(n, 1);
        var bottom = this_0.n28(n, 2);
        var lineHeight = this_0.n28(n, 3);
        var tmp = lineInfo;
        // Inline function 'kotlin.math.max' call
        var a = lineInfo.k5k_1;
        tmp.k5k_1 = Math.max(a, top);
        var tmp_0 = lineInfo;
        // Inline function 'kotlin.math.min' call
        var a_0 = lineInfo.l5k_1;
        tmp_0.l5k_1 = Math.min(a_0, bottom);
        var tmp_1 = lineInfo;
        // Inline function 'kotlin.math.max' call
        var a_1 = lineInfo.m5k_1;
        tmp_1.m5k_1 = Math.max(a_1, lineHeight);
      }
       while (inductionVariable < last);
    return out;
  }
  o5l(n) {
    return n >= this.d1() ? Companion_getInstance_4().y26_1 : Companion_getInstance_4().p2e(this.f5l_1.f1(n), this.g5l_1.f1(n), this.f5l_1.f1(n) + this.e5l_1.f1(n).s3g_1 * this.h5l_1.f1(n), this.g5l_1.f1(n) + this.e5l_1.f1(n).t3g_1 * this.i5l_1.f1(n));
  }
  s3a() {
    if (this.d1() === 0) {
      return Companion_getInstance_4().y26_1;
    }
    var bb = Companion_getInstance_7().c27();
    var inductionVariable = 0;
    var last = this.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, this.o5l(n));
      }
       while (inductionVariable < last);
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  p5l(n, out) {
    out.n5k_1 = this.e5l_1.f1(n);
    out.o5k_1 = this.f5l_1.f1(n);
    out.p5k_1 = this.g5l_1.f1(n);
    out.q5k_1 = this.h5l_1.f1(n);
    out.r5k_1 = this.i5l_1.f1(n);
    var tmp = out;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_8();
    var ratio = this.j5l_1.f1(n);
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_0 = toRatio_0(ratio);
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    tmp.s5k_1 = _Angle___init__impl__g23q1m(tmp$ret$0);
    return out;
  }
  q5l() {
    this.d4q(Companion_getInstance_6().e26_1);
    this.e5l_1.y2();
    this.f5l_1.y2();
    this.g5l_1.y2();
    this.h5l_1.y2();
    this.i5l_1.y2();
    this.j5l_1.y2();
    this.k5l_1.y2();
    this.b4q(0);
  }
  k4p(reader, codePoint) {
    var tmp = this.a4q();
    var bf = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.io.lang.keep' call
      var tmp0_elvis_lhs = reader == null ? null : reader.l1g_1;
      var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      try {
        // Inline function 'korlibs.image.text.Text2TextRendererActions.put.<anonymous>' call
        tmp$ret$1 = this.e4q(reader, codePoint);
        break $l$block;
      }finally {
        if (reader == null)
          null;
        else {
          reader.l1g_1 = old;
        }
      }
    }
    var m = tmp$ret$1;
    var g = bf.f1(codePoint);
    var x = g.j4e_1;
    var tmp_0 = g.k4e_1;
    var tmp295_subject = this.m5l();
    var y = tmp_0 - (equals(tmp295_subject, Companion_getInstance_49().t5j_1) ? bf.s3h() : bf.t4e() * _VerticalAlign___get_ratio__impl__b3ilr8(this.m5l()));
    var fontScale = this.q4p_1 / bf.s4e();
    this.l5l_1 = get_immutable(this.y4p()).d2b();
    this.e5l_1.h(g.i4e_1);
    this.f5l_1.t1k(this.t1h().c26_1 + this.y4p().i2a(x, y) * fontScale);
    this.g5l_1.t1k(this.t1h().d26_1 + this.y4p().l2a(x, y) * fontScale);
    this.h5l_1.t1k(this.l5l_1.r2b_1 * fontScale);
    this.i5l_1.t1k(this.l5l_1.s2b_1 * fontScale);
    this.j5l_1.t1k(Ratio__toDouble_impl_o7epze(_Angle___get_ratio__impl__ap3on4(this.l5l_1.v2b_1)));
    this.k5l_1.x2k(this.v4p(), this.n4p_1.d4f_1, this.n4p_1.h4f_1, this.n4p_1.t4e());
    return m;
  }
}
class CreateWStringTextRenderer$2 {
  constructor($getVersion, $handler) {
    this.r5l_1 = $getVersion;
    this.s5l_1 = $handler;
  }
  f5k() {
    return this.r5l_1();
  }
  t5l(_this__u8e3s4, text, size, defaultFont) {
    _this__u8e3s4.d2q();
    _this__u8e3s4.c4q(defaultFont, size);
    var reader = new WStringReader(text);
    while (reader.s1g()) {
      var c = _WChar___get_codePoint__impl__c8brwu(reader.v1g());
      var c1 = _WChar___get_codePoint__impl__c8brwu(reader.t1g(1));
      var startPos = reader.l1g_1;
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(10);
      if (c === Char__toInt_impl_vasixd(this_0)) {
        _this__u8e3s4.h4q(_this__u8e3s4.t4e(), false);
      } else {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.io.lang.keep' call
          var tmp0_elvis_lhs = reader == null ? null : reader.l1g_1;
          var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
          try {
            // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
            tmp$ret$2 = _this__u8e3s4.e4q(reader, c);
            break $l$block;
          }finally {
            if (reader == null)
              null;
            else {
              reader.l1g_1 = old;
            }
          }
        }
        var g = tmp$ret$2;
        _this__u8e3s4.f4q(Companion_getInstance_5().n29_1);
        this.s5l_1(_this__u8e3s4, reader, c, g, g.t4f_1 + _this__u8e3s4.w4f(c, c1));
      }
      if (reader.l1g_1 <= startPos) {
        reader.x1g(1);
      }
    }
    _this__u8e3s4.h4q(_this__u8e3s4.t4e(), true);
  }
  g5k(_this__u8e3s4, text, size, defaultFont) {
    return this.t5l(_this__u8e3s4, text instanceof WString ? text : THROW_CCE(), size, defaultFont);
  }
}
class CreateStringTextRenderer$2 {
  constructor($getVersion, $handler) {
    var tmp = this;
    tmp.u5l_1 = CreateWStringTextRenderer($getVersion, CreateStringTextRenderer$o$wstring$lambda($handler));
  }
  f5k() {
    return this.u5l_1.f5k();
  }
  v5l(_this__u8e3s4, text, size, defaultFont) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
    this.u5l_1.g5k(_this__u8e3s4, Companion_getInstance_12().c1h(text), size, defaultFont);
  }
  g5k(_this__u8e3s4, text, size, defaultFont) {
    return this.v5l(_this__u8e3s4, (!(text == null) ? typeof text === 'string' : false) ? text : THROW_CCE(), size, defaultFont);
  }
}
class SegmentHandler {
  constructor() {
    this.w5l_1 = intArrayListOf(new Int32Array([]));
    this.x5l_1 = intArrayListOf(new Int32Array([]));
    this.d2q();
  }
  d1() {
    return this.w5l_1.d1();
  }
  d2q() {
    this.w5l_1.y2();
    this.x5l_1.y2();
  }
  y3k(x0, x1) {
    var inductionVariable = 0;
    var last = this.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var xmin = this.w5l_1.s1i(n);
        var xmax = this.x5l_1.s1i(n);
        if (overlaps(this, xmin, xmax, x0, x1)) {
          // Inline function 'kotlin.math.min' call
          var tmp$ret$0 = Math.min(x0, xmin);
          this.w5l_1.i2k(n, tmp$ret$0);
          // Inline function 'kotlin.math.max' call
          var tmp$ret$1 = Math.max(x1, xmax);
          this.x5l_1.i2k(n, tmp$ret$1);
          return Unit_instance;
        }
      }
       while (inductionVariable < last);
    this.w5l_1.d2k(x0);
    this.x5l_1.d2k(x1);
  }
}
class ScanlineWriter {
  constructor($outer) {
    this.j5m_1 = $outer;
    this.y5l_1 = get_DEFAULT(Companion_getInstance_52());
    this.z5l_1 = NoneFiller_getInstance();
    this.a5m_1 = -1;
    this.b5m_1 = -1;
    this.c5m_1 = new Float32Array(this.d1());
    this.d5m_1 = new Int32Array(this.d1());
    this.e5m_1 = Companion_instance_17.d4e(this.d1());
    this.f5m_1 = Companion_instance_17.d4e(this.d1());
    this.g5m_1 = new SegmentHandler();
    this.h5m_1 = 0;
    this.i5m_1 = 1.0;
  }
  d1() {
    return this.j5m_1.m5m_1.f3w_1;
  }
  w5m() {
    return this.j5m_1.m5m_1.f3w_1 - 1 | 0;
  }
  d2q() {
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.g5m_1;
    var inductionVariable = 0;
    var last = this_0.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.reset.<anonymous>' call
        var xmin = this_0.w5l_1.s1i(n);
        var xmax = this_0.x5l_1.s1i(n);
        fill_0(this.c5m_1, 0.0, xmin, xmax + 1 | 0);
        fill(this.d5m_1, 0, xmin, xmax + 1 | 0);
      }
       while (inductionVariable < last);
    this.h5m_1 = 0;
    this.g5m_1.d2q();
  }
  x5m(x0, x1, y0) {
    if (this.w5m() < 1)
      return Unit_instance;
    var x0_0 = coerceIn(x0, 0, imul(this.w5m(), 20));
    var x1_0 = coerceIn(x1, 0, imul(this.w5m(), 20));
    var a = x0_0 / 20 | 0;
    var b = x1_0 / 20 | 0;
    var y = y0 / 20 | 0;
    var i0 = coerceIn(a, 0, this.w5m());
    var i1 = coerceIn(b, 0, this.w5m());
    var i0m = x0_0 % 20 | 0;
    var i1m = x1_0 % 20 | 0;
    if (!(this.b5m_1 === y)) {
      if (y >= 0) {
        this.kc();
      }
      this.b5m_1 = y;
      this.d2q();
    }
    if (!(this.a5m_1 === y0)) {
      this.a5m_1 = y0;
      this.h5m_1 = this.h5m_1 + 1 | 0;
    }
    if (i1 > i0) {
      this.g5m_1.y3k(i0, i1);
      this.y5m(i0, 1.0 - i0m / 20);
      var inductionVariable = i0 + 1 | 0;
      if (inductionVariable < i1)
        do {
          var x = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.y5m(x, 1.0);
        }
         while (inductionVariable < i1);
      if (!(i1m === 0)) {
        this.y5m(i1, i1m / 20);
      }
    }
  }
  y5m(x, ratio) {
    var mask = 1 << this.h5m_1;
    if ((this.d5m_1[x] & mask) === 0) {
      this.d5m_1[x] = this.d5m_1[x] | mask;
      var _array__4zh2yp = this.c5m_1;
      _array__4zh2yp[x] = _array__4zh2yp[x] + ratio;
    }
  }
  kc() {
    var containsUpper = this.j5m_1.m5m_1.g3w_1;
    var containsArg = this.b5m_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      return Unit_instance;
    var galpha = clamp01_0(this.i5m_1);
    var scale_0 = 1.0 / this.h5m_1 * galpha;
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.g5m_1;
    var inductionVariable = 0;
    var last = this_0.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.flush.<anonymous>' call
        var xmin = this_0.w5l_1.s1i(n);
        var xmax = this_0.x5l_1.s1i(n);
        var x = xmin;
        var count = (xmax - xmin | 0) + 1 | 0;
        this.z5l_1.z5d(this.f5m_1, 0, xmin, xmax, this.b5m_1);
        var inductionVariable_0 = xmin;
        if (inductionVariable_0 <= xmax)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _array__4zh2yp = this.c5m_1;
            var _index_0__fvwizt = n_0;
            _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] * scale_0;
          }
           while (!(n_0 === xmax));
        scale(this.f5m_1, xmin, this.c5m_1, xmin, count);
        var index = this.j5m_1.m5m_1.a3x(0, this.b5m_1) + x | 0;
        if (this.j5m_1.m5m_1.l3w_1) {
          arraycopy(this.j5m_1.m5m_1.v3v_1, index, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.e5m_1), x, count);
        } else {
          premultiply(_RgbaArray___init__impl__oib4y4(this.j5m_1.m5m_1.v3v_1), index, this.e5m_1, x, count);
        }
        this.y5l_1.z5m(this.e5m_1, x, this.f5m_1, x, count);
        if (this.j5m_1.m5m_1.l3w_1) {
          arraycopy(_RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.e5m_1), x, this.j5m_1.m5m_1.v3v_1, index, count);
        } else {
          depremultiply(this.e5m_1, x, _RgbaArray___init__impl__oib4y4(this.j5m_1.m5m_1.v3v_1), index, count);
        }
      }
       while (inductionVariable < last);
  }
}
class Renderer {
  constructor() {
    this.l5n_1 = false;
    this.m5n_1 = 0;
  }
  kc() {
    return Unit_instance;
  }
  o5n() {
    var _unary__edvuaz = this.m5n_1;
    this.m5n_1 = _unary__edvuaz + 1 | 0;
    return _unary__edvuaz;
  }
  p5n() {
    this.m5n_1 = this.m5n_1 - 1 | 0;
    if (this.m5n_1 === 0) {
      this.kc();
    }
  }
  q5n(state, fill, winding) {
    var rstate = state;
    if (fill && !this.s5n(state.j4g_1)) {
      rstate = state.u1i();
      rstate.j4g_1 = toBitmapPaint(rstate.j4g_1, state);
    }
    this.k5n(rstate, fill, winding);
  }
  r5n(state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.q5n(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.q5n.call(this, state, fill, winding);
    }
    return tmp;
  }
  k5n(state, fill, winding) {
    return Unit_instance;
  }
  s5n(_this__u8e3s4) {
    return true;
  }
  t5n(image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.renderer.Renderer.drawImage.<anonymous>' call
    if (transform.g2a().equals(MatrixType_IDENTITY_getInstance())) {
      this_0.q3n(pos, size);
    } else {
      this_0.i3o(transform, Renderer$drawImage$lambda(pos, size));
    }
    this.r5n(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, scaled(Companion_getInstance_5().n29_1, size.j2g(toFloat(image.d1()))).t2a(pos))), true);
  }
  ov() {
    this.kc();
  }
}
class Bitmap32Context2d extends Renderer {
  constructor(bmp, antialiasing) {
    super();
    this.m5m_1 = bmp;
    this.n5m_1 = antialiasing;
    this.o5m_1 = this.m5m_1.x3v_1.a2g();
    this.p5m_1 = new Rasterizer();
    this.q5m_1 = new ColorFiller();
    this.r5m_1 = new GradientFiller();
    this.s5m_1 = new BitmapFiller();
    this.t5m_1 = new ScanlineWriter(this);
    this.u5m_1 = new VectorPath(VOID, VOID, Winding_EVEN_ODD_getInstance());
    this.v5m_1 = new StrokeToFill();
  }
  w2i() {
    return this.m5m_1.f3w_1;
  }
  x2i() {
    return this.m5m_1.g3w_1;
  }
  k5n(state, fill, winding) {
    var style = fill ? state.j4g_1 : state.i4g_1;
    var tmp;
    if (style instanceof NonePaint) {
      tmp = NoneFiller_getInstance();
    } else {
      if (style instanceof RGBA) {
        tmp = this.q5m_1.x5d(style.i4d_1, state);
      } else {
        if (style instanceof GradientPaint) {
          tmp = this.r5m_1.f5e(style, state);
        } else {
          if (style instanceof BitmapPaint) {
            tmp = this.s5m_1.t5e(style, state);
          } else {
            throw NotImplementedError.nd();
          }
        }
      }
    }
    var filler = tmp;
    this.t5m_1.y5l_1 = state.q4g_1;
    this.p5m_1.d2q();
    this.p5m_1.a5n_1 = this.l5n_1;
    var doingStroke = !fill;
    var tmp_0;
    if (fill) {
      tmp_0 = state.b4g_1;
    } else {
      this.u5m_1.y2();
      var tmp306_$receiver = state.b4g_1;
      var tmp307_lineWidth = state.n5n();
      var tmp308_joins = state.g4g_1;
      var tmp309_startCap = state.e4g_1;
      var tmp310_endCap = state.f4g_1;
      var tmp311_miterLimit = state.h4g_1;
      var tmp312_temp = this.v5m_1;
      var tmp313_outFill = this.u5m_1;
      var tmp314_lineDash = state.r4g_1;
      var tmp315_lineDashOffset = state.s4g_1;
      tmp_0 = strokeToFill(tmp306_$receiver, tmp307_lineWidth, tmp308_joins, tmp309_startCap, tmp310_endCap, tmp311_miterLimit, tmp314_lineDash, tmp315_lineDashOffset, tmp312_temp, tmp313_outFill);
    }
    var fillPath = tmp_0;
    if (!(state.a4g_1 == null)) {
      this.p5m_1.e5n_1.d3k_1 = ensureNotNull(state.a4g_1).l3e_1;
      // Inline function 'korlibs.math.geom.shape.emitPoints2' call
      var this_0 = ensureNotNull(state.a4g_1);
      var i = Vector2D.w28();
      var l = Vector2D.w28();
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.p5m_1.e5n_1.y5();
      }
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
      var n = 0;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_1 = this_0.j3e_1;
      var n_0 = 0;
      while (n_0 < this_1.d1()) {
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
        var _unary__edvuaz = n_0;
        n_0 = _unary__edvuaz + 1 | 0;
        switch (this_1.s1i(_unary__edvuaz)) {
          case 0:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_0 = n;
            n = _unary__edvuaz_0 + 1 | 0;
            var tmp_1 = this_0.k3e_1.f1(_unary__edvuaz_0);
            var _unary__edvuaz_1 = n;
            n = _unary__edvuaz_1 + 1 | 0;
            var it = Vector2D.l28(tmp_1, this_0.k3e_1.f1(_unary__edvuaz_1));
            i = it;
            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var x = it.bl();
            var y = it.cl();
            this.p5m_1.e5n_1.g3l(x, y, true);
            l = it;
            break;
          case 1:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_2 = n;
            n = _unary__edvuaz_2 + 1 | 0;
            var tmp_2 = this_0.k3e_1.f1(_unary__edvuaz_2);
            var _unary__edvuaz_3 = n;
            n = _unary__edvuaz_3 + 1 | 0;
            var it_0 = Vector2D.l28(tmp_2, this_0.k3e_1.f1(_unary__edvuaz_3));
            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var x_0 = it_0.bl();
            var y_0 = it_0.cl();
            this.p5m_1.e5n_1.g3l(x_0, y_0, false);
            l = it_0;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 2:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_4 = n;
            n = _unary__edvuaz_4 + 1 | 0;
            var tmp_3 = this_0.k3e_1.f1(_unary__edvuaz_4);
            var _unary__edvuaz_5 = n;
            n = _unary__edvuaz_5 + 1 | 0;
            var c = Vector2D.l28(tmp_3, this_0.k3e_1.f1(_unary__edvuaz_5));
            var _unary__edvuaz_6 = n;
            n = _unary__edvuaz_6 + 1 | 0;
            var tmp_4 = this_0.k3e_1.f1(_unary__edvuaz_6);
            var _unary__edvuaz_7 = n;
            n = _unary__edvuaz_7 + 1 | 0;
            var a = Vector2D.l28(tmp_4, this_0.k3e_1.f1(_unary__edvuaz_7));
            var sum = Companion_getInstance_6().m2h(l, c) + Companion_getInstance_6().m2h(c, a);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call

            // Inline function 'kotlin.math.max' call

            var a_0 = numberToInt(sum);
            var rcurveSteps = Math.max(a_0, 20);
            var dt = 1.0 / rcurveSteps;
            var lastPos = {_v: Vector2D.w28()};
            var prevPos = {_v: Vector2D.w28()};
            var emittedCount = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

            var ratio = Companion_getInstance_9().m1i_1;
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

            lastPos._v = Companion_getInstance_1().b3c(l, c, a, ratio);
            var nStart = false ? 0 : 1;
            var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
            var inductionVariable = nStart;
            if (inductionVariable <= nEnd)
              do {
                var n_1 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var ratio_0 = _Ratio___init__impl__9mwvn2_1(n_1 * dt);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var it_1 = Companion_getInstance_1().b3c(l, c, a, ratio_0);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var x_1 = it_1.bl();
                var y_1 = it_1.cl();
                this.p5m_1.e5n_1.g3l(x_1, y_1, false);
                emittedCount._v = emittedCount._v + 1 | 0;
                lastPos._v = prevPos._v;
                prevPos._v = it_1;
              }
               while (!(n_1 === nEnd));
            l = a;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 3:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_8 = n;
            n = _unary__edvuaz_8 + 1 | 0;
            var tmp_5 = this_0.k3e_1.f1(_unary__edvuaz_8);
            var _unary__edvuaz_9 = n;
            n = _unary__edvuaz_9 + 1 | 0;
            var c0 = Vector2D.l28(tmp_5, this_0.k3e_1.f1(_unary__edvuaz_9));
            var _unary__edvuaz_10 = n;
            n = _unary__edvuaz_10 + 1 | 0;
            var tmp_6 = this_0.k3e_1.f1(_unary__edvuaz_10);
            var _unary__edvuaz_11 = n;
            n = _unary__edvuaz_11 + 1 | 0;
            var c1 = Vector2D.l28(tmp_6, this_0.k3e_1.f1(_unary__edvuaz_11));
            var _unary__edvuaz_12 = n;
            n = _unary__edvuaz_12 + 1 | 0;
            var tmp_7 = this_0.k3e_1.f1(_unary__edvuaz_12);
            var _unary__edvuaz_13 = n;
            n = _unary__edvuaz_13 + 1 | 0;
            var a_1 = Vector2D.l28(tmp_7, this_0.k3e_1.f1(_unary__edvuaz_13));
            var sum_0 = Companion_getInstance_6().m2h(l, c0) + Companion_getInstance_6().m2h(c0, c1) + Companion_getInstance_6().m2h(c1, a_1);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call

            // Inline function 'kotlin.math.max' call

            var a_2 = numberToInt(sum_0);
            var rcurveSteps_0 = Math.max(a_2, 20);
            var dt_0 = 1.0 / rcurveSteps_0;
            var lastPos_0 = {_v: Vector2D.w28()};
            var prevPos_0 = {_v: Vector2D.w28()};
            var emittedCount_0 = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

            var ratio_1 = Companion_getInstance_9().m1i_1;
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

            lastPos_0._v = Companion_getInstance_1().a3c(l, c0, c1, a_1, ratio_1);
            var nStart_0 = false ? 0 : 1;
            var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
            var inductionVariable_0 = nStart_0;
            if (inductionVariable_0 <= nEnd_0)
              do {
                var n_2 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var ratio_2 = _Ratio___init__impl__9mwvn2_1(n_2 * dt_0);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var it_2 = Companion_getInstance_1().a3c(l, c0, c1, a_1, ratio_2);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var x_2 = it_2.bl();
                var y_2 = it_2.cl();
                this.p5m_1.e5n_1.g3l(x_2, y_2, false);
                emittedCount_0._v = emittedCount_0._v + 1 | 0;
                lastPos_0._v = prevPos_0._v;
                prevPos_0._v = it_2;
              }
               while (!(n_2 === nEnd_0));
            l = a_1;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 4:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var destruct = i;
            var x_3 = destruct.bl();
            var y_3 = destruct.cl();
            this.p5m_1.e5n_1.g3l(x_3, y_3, false);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            if (true) {
              this.p5m_1.e5n_1.y5();
            }

            break;
        }
      }
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.p5m_1.e5n_1.y5();
      }
    }
    var tmp_8 = this.p5m_1.d5n_1;
    tmp_8.d3k_1 = winding == null ? ensureNotNull(state.b4g_1).l3e_1 : winding;
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i_0 = Vector2D.w28();
    var l_0 = Vector2D.w28();
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.p5m_1.d5n_1.y5();
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n_3 = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = fillPath.j3e_1;
    var n_4 = 0;
    while (n_4 < this_2.d1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz_14 = n_4;
      n_4 = _unary__edvuaz_14 + 1 | 0;
      switch (this_2.s1i(_unary__edvuaz_14)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_15 = n_3;
          n_3 = _unary__edvuaz_15 + 1 | 0;
          var tmp_9 = fillPath.k3e_1.f1(_unary__edvuaz_15);
          var _unary__edvuaz_16 = n_3;
          n_3 = _unary__edvuaz_16 + 1 | 0;
          var it_3 = Vector2D.l28(tmp_9, fillPath.k3e_1.f1(_unary__edvuaz_16));
          i_0 = it_3;
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var x_4 = it_3.bl();
          var y_4 = it_3.cl();
          if (doingStroke) {
            if (true) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.p5m_1.d5n_1.g3l(x_4, y_4, true);
          l_0 = it_3;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_17 = n_3;
          n_3 = _unary__edvuaz_17 + 1 | 0;
          var tmp_10 = fillPath.k3e_1.f1(_unary__edvuaz_17);
          var _unary__edvuaz_18 = n_3;
          n_3 = _unary__edvuaz_18 + 1 | 0;
          var it_4 = Vector2D.l28(tmp_10, fillPath.k3e_1.f1(_unary__edvuaz_18));
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var x_5 = it_4.bl();
          var y_5 = it_4.cl();
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.p5m_1.d5n_1.g3l(x_5, y_5, false);
          l_0 = it_4;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_19 = n_3;
          n_3 = _unary__edvuaz_19 + 1 | 0;
          var tmp_11 = fillPath.k3e_1.f1(_unary__edvuaz_19);
          var _unary__edvuaz_20 = n_3;
          n_3 = _unary__edvuaz_20 + 1 | 0;
          var c_0 = Vector2D.l28(tmp_11, fillPath.k3e_1.f1(_unary__edvuaz_20));
          var _unary__edvuaz_21 = n_3;
          n_3 = _unary__edvuaz_21 + 1 | 0;
          var tmp_12 = fillPath.k3e_1.f1(_unary__edvuaz_21);
          var _unary__edvuaz_22 = n_3;
          n_3 = _unary__edvuaz_22 + 1 | 0;
          var a_3 = Vector2D.l28(tmp_12, fillPath.k3e_1.f1(_unary__edvuaz_22));
          var sum_1 = Companion_getInstance_6().m2h(l_0, c_0) + Companion_getInstance_6().m2h(c_0, a_3);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_4 = numberToInt(sum_1);
          var rcurveSteps_1 = Math.max(a_4, 20);
          var dt_1 = 1.0 / rcurveSteps_1;
          var lastPos_1 = {_v: Vector2D.w28()};
          var prevPos_1 = {_v: Vector2D.w28()};
          var emittedCount_1 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_3 = Companion_getInstance_9().m1i_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_1._v = Companion_getInstance_1().b3c(l_0, c_0, a_3, ratio_3);
          var nStart_1 = false ? 0 : 1;
          var nEnd_1 = true ? rcurveSteps_1 : rcurveSteps_1 - 1 | 0;
          var inductionVariable_1 = nStart_1;
          if (inductionVariable_1 <= nEnd_1)
            do {
              var n_5 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var ratio_4 = _Ratio___init__impl__9mwvn2_1(n_5 * dt_1);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_5 = Companion_getInstance_1().b3c(l_0, c_0, a_3, ratio_4);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
              var x_6 = it_5.bl();
              var y_6 = it_5.cl();
              if (doingStroke) {
                if (false) {
                  renderFinal$flush(this, filler, state, winding, fillPath);
                }
              }
              this.p5m_1.d5n_1.g3l(x_6, y_6, false);
              emittedCount_1._v = emittedCount_1._v + 1 | 0;
              lastPos_1._v = prevPos_1._v;
              prevPos_1._v = it_5;
            }
             while (!(n_5 === nEnd_1));
          l_0 = a_3;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_23 = n_3;
          n_3 = _unary__edvuaz_23 + 1 | 0;
          var tmp_13 = fillPath.k3e_1.f1(_unary__edvuaz_23);
          var _unary__edvuaz_24 = n_3;
          n_3 = _unary__edvuaz_24 + 1 | 0;
          var c0_0 = Vector2D.l28(tmp_13, fillPath.k3e_1.f1(_unary__edvuaz_24));
          var _unary__edvuaz_25 = n_3;
          n_3 = _unary__edvuaz_25 + 1 | 0;
          var tmp_14 = fillPath.k3e_1.f1(_unary__edvuaz_25);
          var _unary__edvuaz_26 = n_3;
          n_3 = _unary__edvuaz_26 + 1 | 0;
          var c1_0 = Vector2D.l28(tmp_14, fillPath.k3e_1.f1(_unary__edvuaz_26));
          var _unary__edvuaz_27 = n_3;
          n_3 = _unary__edvuaz_27 + 1 | 0;
          var tmp_15 = fillPath.k3e_1.f1(_unary__edvuaz_27);
          var _unary__edvuaz_28 = n_3;
          n_3 = _unary__edvuaz_28 + 1 | 0;
          var a_5 = Vector2D.l28(tmp_15, fillPath.k3e_1.f1(_unary__edvuaz_28));
          var sum_2 = Companion_getInstance_6().m2h(l_0, c0_0) + Companion_getInstance_6().m2h(c0_0, c1_0) + Companion_getInstance_6().m2h(c1_0, a_5);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_6 = numberToInt(sum_2);
          var rcurveSteps_2 = Math.max(a_6, 20);
          var dt_2 = 1.0 / rcurveSteps_2;
          var lastPos_2 = {_v: Vector2D.w28()};
          var prevPos_2 = {_v: Vector2D.w28()};
          var emittedCount_2 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_5 = Companion_getInstance_9().m1i_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_2._v = Companion_getInstance_1().a3c(l_0, c0_0, c1_0, a_5, ratio_5);
          var nStart_2 = false ? 0 : 1;
          var nEnd_2 = true ? rcurveSteps_2 : rcurveSteps_2 - 1 | 0;
          var inductionVariable_2 = nStart_2;
          if (inductionVariable_2 <= nEnd_2)
            do {
              var n_6 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var ratio_6 = _Ratio___init__impl__9mwvn2_1(n_6 * dt_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_6 = Companion_getInstance_1().a3c(l_0, c0_0, c1_0, a_5, ratio_6);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
              var x_7 = it_6.bl();
              var y_7 = it_6.cl();
              if (doingStroke) {
                if (false) {
                  renderFinal$flush(this, filler, state, winding, fillPath);
                }
              }
              this.p5m_1.d5n_1.g3l(x_7, y_7, false);
              emittedCount_2._v = emittedCount_2._v + 1 | 0;
              lastPos_2._v = prevPos_2._v;
              prevPos_2._v = it_6;
            }
             while (!(n_6 === nEnd_2));
          l_0 = a_5;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var destruct_0 = i_0;
          var x_8 = destruct_0.bl();
          var y_8 = destruct_0.cl();
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.p5m_1.d5n_1.g3l(x_8, y_8, false);
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          if (true) {
            this.p5m_1.d5n_1.y5();
          }

          break;
      }
    }
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.p5m_1.d5n_1.y5();
    }
    renderFinal$flush(this, filler, state, winding, fillPath);
  }
}
class CompositeOperation$Companion$invoke$1 {
  constructor($func) {
    this.u5n_1 = $func;
  }
  z5m(dst, dstN, src, srcN, count) {
    return this.u5n_1(new RgbaPremultipliedArray(dst), dstN, new RgbaPremultipliedArray(src), srcN, count);
  }
}
class Companion_35 {
  constructor() {
    Companion_instance_44 = this;
    var tmp = this;
    var tmp_0 = Companion_getInstance_52();
    tmp.v5n_1 = tmp_0.w5n(CompositeOperation$Companion$UNIMPLEMENTED$lambda);
  }
  w5n(func) {
    return new CompositeOperation$Companion$invoke$1(func);
  }
}
class Companion_36 {
  j3o() {
    return CompositeMode_SOURCE_OVER_getInstance();
  }
}
class CompositeMode extends Enum {
  constructor(name, ordinal, op) {
    super(name, ordinal);
    this.z5n_1 = op;
  }
  z5m(dst, dstN, src, srcN, count) {
    this.z5n_1.z5m(dst, dstN, src, srcN, count);
  }
}
class BlendMode extends Enum {}
class State {
  constructor(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    transform = transform === VOID ? Companion_getInstance_5().n29_1 : transform;
    clip = clip === VOID ? null : clip;
    path = path === VOID ? new VectorPath() : path;
    lineScaleMode = lineScaleMode === VOID ? LineScaleMode_NORMAL_getInstance() : lineScaleMode;
    lineWidth = lineWidth === VOID ? 1.0 : lineWidth;
    startLineCap = startLineCap === VOID ? LineCap_BUTT_getInstance() : startLineCap;
    endLineCap = endLineCap === VOID ? LineCap_BUTT_getInstance() : endLineCap;
    lineJoin = lineJoin === VOID ? LineJoin_MITER_getInstance() : lineJoin;
    miterLimit = miterLimit === VOID ? 10.0 : miterLimit;
    strokeStyle = strokeStyle === VOID ? new RGBA(get_DefaultPaint()) : strokeStyle;
    fillStyle = fillStyle === VOID ? new RGBA(get_DefaultPaint()) : fillStyle;
    fontRegistry = fontRegistry === VOID ? null : fontRegistry;
    font = font === VOID ? null : font;
    fontSize = fontSize === VOID ? 24.0 : fontSize;
    verticalAlign = verticalAlign === VOID ? Companion_getInstance_49().t5j_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? Companion_getInstance_50().y5j_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? CompositeMode_SOURCE_OVER_getInstance() : globalCompositeOperation;
    lineDash = lineDash === VOID ? null : lineDash;
    lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
    this.z4f_1 = transform;
    this.a4g_1 = clip;
    this.b4g_1 = path;
    this.c4g_1 = lineScaleMode;
    this.d4g_1 = lineWidth;
    this.e4g_1 = startLineCap;
    this.f4g_1 = endLineCap;
    this.g4g_1 = lineJoin;
    this.h4g_1 = miterLimit;
    this.i4g_1 = strokeStyle;
    this.j4g_1 = fillStyle;
    this.k4g_1 = fontRegistry;
    this.l4g_1 = font;
    this.m4g_1 = fontSize;
    this.n4g_1 = verticalAlign;
    this.o4g_1 = horizontalAlign;
    this.p4g_1 = globalAlpha;
    this.q4g_1 = globalCompositeOperation;
    this.r4g_1 = lineDash;
    this.s4g_1 = lineDashOffset;
    var tmp = this;
    tmp.t4g_1 = lazy(Context2d$State$transformTransform$delegate$lambda(this));
  }
  a5o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t4g_1;
    transformTransform$factory();
    return this_0.o1();
  }
  n5n() {
    var tmp = this.d4g_1;
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = this.a5o().b2c();
    return tmp * Math.abs(this_0);
  }
  b5o() {
    return Companion_getInstance_51().e5k(this.o4g_1, this.n4g_1);
  }
  h4o(value) {
    this.e4g_1 = value;
    this.f4g_1 = value;
  }
  a4o() {
    return this.e4g_1;
  }
  u1i() {
    var tmp = this.z4f_1;
    var tmp319_safe_receiver = this.a4g_1;
    var tmp_0 = tmp319_safe_receiver == null ? null : tmp319_safe_receiver.u1i();
    var tmp_1 = this.b4g_1.u1i();
    var tmp320_safe_receiver = this.r4g_1;
    return this.c5o(tmp, tmp_0, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp320_safe_receiver == null ? null : tmp320_safe_receiver.u1i());
  }
  d5o(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    return new State(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  }
  c5o(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset, $super) {
    transform = transform === VOID ? this.z4f_1 : transform;
    clip = clip === VOID ? this.a4g_1 : clip;
    path = path === VOID ? this.b4g_1 : path;
    lineScaleMode = lineScaleMode === VOID ? this.c4g_1 : lineScaleMode;
    lineWidth = lineWidth === VOID ? this.d4g_1 : lineWidth;
    startLineCap = startLineCap === VOID ? this.e4g_1 : startLineCap;
    endLineCap = endLineCap === VOID ? this.f4g_1 : endLineCap;
    lineJoin = lineJoin === VOID ? this.g4g_1 : lineJoin;
    miterLimit = miterLimit === VOID ? this.h4g_1 : miterLimit;
    strokeStyle = strokeStyle === VOID ? this.i4g_1 : strokeStyle;
    fillStyle = fillStyle === VOID ? this.j4g_1 : fillStyle;
    fontRegistry = fontRegistry === VOID ? this.k4g_1 : fontRegistry;
    font = font === VOID ? this.l4g_1 : font;
    fontSize = fontSize === VOID ? this.m4g_1 : fontSize;
    verticalAlign = verticalAlign === VOID ? this.n4g_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? this.o4g_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? this.p4g_1 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? this.q4g_1 : globalCompositeOperation;
    lineDash = lineDash === VOID ? this.r4g_1 : lineDash;
    lineDashOffset = lineDashOffset === VOID ? this.s4g_1 : lineDashOffset;
    return $super === VOID ? this.d5o(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) : $super.d5o.call(this, transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, new VerticalAlign(verticalAlign), new HorizontalAlign(horizontalAlign), globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  }
  toString() {
    return 'State(transform=' + this.z4f_1.toString() + ', clip=' + toString(this.a4g_1) + ', path=' + this.b4g_1.toString() + ', lineScaleMode=' + this.c4g_1.toString() + ', lineWidth=' + this.d4g_1 + ', startLineCap=' + this.e4g_1.toString() + ', endLineCap=' + this.f4g_1.toString() + ', lineJoin=' + this.g4g_1.toString() + ', miterLimit=' + this.h4g_1 + ', strokeStyle=' + toString_0(this.i4g_1) + ', fillStyle=' + toString_0(this.j4g_1) + ', fontRegistry=' + toString(this.k4g_1) + ', font=' + toString(this.l4g_1) + ', fontSize=' + this.m4g_1 + ', verticalAlign=' + VerticalAlign__toString_impl_hcpnn2(this.n4g_1) + ', horizontalAlign=' + HorizontalAlign__toString_impl_toflc0(this.o4g_1) + ', globalAlpha=' + this.p4g_1 + ', globalCompositeOperation=' + toString_0(this.q4g_1) + ', lineDash=' + toString(this.r4g_1) + ', lineDashOffset=' + this.s4g_1 + ')';
  }
  hashCode() {
    var result = this.z4f_1.hashCode();
    result = imul(result, 31) + (this.a4g_1 == null ? 0 : this.a4g_1.hashCode()) | 0;
    result = imul(result, 31) + this.b4g_1.hashCode() | 0;
    result = imul(result, 31) + this.c4g_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.d4g_1) | 0;
    result = imul(result, 31) + this.e4g_1.hashCode() | 0;
    result = imul(result, 31) + this.f4g_1.hashCode() | 0;
    result = imul(result, 31) + this.g4g_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.h4g_1) | 0;
    result = imul(result, 31) + hashCode(this.i4g_1) | 0;
    result = imul(result, 31) + hashCode(this.j4g_1) | 0;
    result = imul(result, 31) + (this.k4g_1 == null ? 0 : hashCode(this.k4g_1)) | 0;
    result = imul(result, 31) + (this.l4g_1 == null ? 0 : hashCode(this.l4g_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.m4g_1) | 0;
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.n4g_1) | 0;
    result = imul(result, 31) + HorizontalAlign__hashCode_impl_7x9oj5(this.o4g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p4g_1) | 0;
    result = imul(result, 31) + hashCode(this.q4g_1) | 0;
    result = imul(result, 31) + (this.r4g_1 == null ? 0 : hashCode(this.r4g_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s4g_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof State))
      return false;
    var tmp0_other_with_cast = other instanceof State ? other : THROW_CCE();
    if (!this.z4f_1.equals(tmp0_other_with_cast.z4f_1))
      return false;
    if (!equals(this.a4g_1, tmp0_other_with_cast.a4g_1))
      return false;
    if (!this.b4g_1.equals(tmp0_other_with_cast.b4g_1))
      return false;
    if (!this.c4g_1.equals(tmp0_other_with_cast.c4g_1))
      return false;
    if (!equals(this.d4g_1, tmp0_other_with_cast.d4g_1))
      return false;
    if (!this.e4g_1.equals(tmp0_other_with_cast.e4g_1))
      return false;
    if (!this.f4g_1.equals(tmp0_other_with_cast.f4g_1))
      return false;
    if (!this.g4g_1.equals(tmp0_other_with_cast.g4g_1))
      return false;
    if (!equals(this.h4g_1, tmp0_other_with_cast.h4g_1))
      return false;
    if (!equals(this.i4g_1, tmp0_other_with_cast.i4g_1))
      return false;
    if (!equals(this.j4g_1, tmp0_other_with_cast.j4g_1))
      return false;
    if (!equals(this.k4g_1, tmp0_other_with_cast.k4g_1))
      return false;
    if (!equals(this.l4g_1, tmp0_other_with_cast.l4g_1))
      return false;
    if (!equals(this.m4g_1, tmp0_other_with_cast.m4g_1))
      return false;
    if (!equals(this.n4g_1, tmp0_other_with_cast.n4g_1))
      return false;
    if (!equals(this.o4g_1, tmp0_other_with_cast.o4g_1))
      return false;
    if (!equals(this.p4g_1, tmp0_other_with_cast.p4g_1))
      return false;
    if (!equals(this.q4g_1, tmp0_other_with_cast.q4g_1))
      return false;
    if (!equals(this.r4g_1, tmp0_other_with_cast.r4g_1))
      return false;
    if (!equals(this.s4g_1, tmp0_other_with_cast.s4g_1))
      return false;
    return true;
  }
}
class Context2d {
  constructor(renderer, defaultFontRegistry, defaultFont) {
    defaultFontRegistry = defaultFontRegistry === VOID ? null : defaultFontRegistry;
    defaultFont = defaultFont === VOID ? null : defaultFont;
    this.d44_1 = renderer;
    this.e44_1 = defaultFontRegistry;
    this.f44_1 = defaultFont;
    this.g44_1 = new State(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.e44_1, this.f44_1);
    this.h44_1 = _TGenStack___init__impl__yynjgt();
    this.i44_1 = Vector2D.w28();
    this.j44_1 = Vector2D.w28();
  }
  e5o() {
    return this.d44_1.w2i();
  }
  f5o() {
    return this.d44_1.x2i();
  }
  g5o(state, fill, winding) {
    return this.d44_1.q5n(state, fill, winding);
  }
  h5o(state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.g5o(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.g5o.call(this, state, fill, winding);
    }
    return tmp;
  }
  i5o(image, pos, size, transform) {
    return this.d44_1.t5n(image, pos, size, transform);
  }
  j5o() {
    return this.d44_1.ov();
  }
  k5o() {
    return this.d44_1.o5n();
  }
  l5o() {
    return this.d44_1.p5n();
  }
  m5o(state, font, fontSize, text, pos, fill) {
    if (font == null)
      null;
    else
      drawText(font, this, fontSize, text, fill ? state.j4g_1 : state.i4g_1, pos, fill);
  }
  n5o(text, pos) {
    return this.m5o(this.g44_1, this.a4q(), this.s4e(), text, pos, true);
  }
  o5o(text, pos) {
    return this.m5o(this.g44_1, this.a4q(), this.s4e(), text, pos, false);
  }
  w2i() {
    return this.e5o();
  }
  x2i() {
    return this.f5o();
  }
  ov() {
    this.j5o();
  }
  p5o() {
    return this.k5o();
  }
  q5o() {
    return this.l5o();
  }
  r5o(value) {
    this.g44_1.c4g_1 = value;
  }
  g4o(value) {
    this.g44_1.d4g_1 = value;
  }
  z4n() {
    return this.g44_1.d4g_1;
  }
  h4o(value) {
    this.g44_1.h4o(value);
  }
  a4o() {
    return this.g44_1.a4o();
  }
  j4o(value) {
    this.g44_1.h4g_1 = value;
  }
  c4o() {
    return this.g44_1.h4g_1;
  }
  s5o(value) {
    this.g44_1.e4g_1 = value;
  }
  t5o(value) {
    this.g44_1.f4g_1 = value;
  }
  i4o(value) {
    this.g44_1.g4g_1 = value;
  }
  b4o() {
    return this.g44_1.g4g_1;
  }
  u5o(value) {
    this.g44_1.i4g_1 = value;
  }
  v5o() {
    return this.g44_1.i4g_1;
  }
  w4g(value) {
    this.g44_1.j4g_1 = value;
  }
  v4g() {
    return this.g44_1.j4g_1;
  }
  w5o() {
    return this.g44_1.k4g_1;
  }
  x5o(value) {
    this.g44_1.l4g_1 = value;
  }
  a4q() {
    return this.g44_1.l4g_1;
  }
  y5o(value) {
    this.g44_1.m4g_1 = value;
  }
  s4e() {
    return this.g44_1.m4g_1;
  }
  z5o(value) {
    this.g44_1.n4g_1 = value;
  }
  m5l() {
    return this.g44_1.n4g_1;
  }
  a5p(value) {
    this.g44_1.o4g_1 = value;
  }
  b5p() {
    return this.g44_1.o4g_1;
  }
  c5p(value) {
    this.a5p(value.k4n_1);
    this.z5o(value.l4n_1);
  }
  b5o() {
    return Companion_getInstance_51().e5k(this.b5p(), this.m5l());
  }
  d5p(value) {
    this.g44_1.p4g_1 = value;
  }
  e5p() {
    return this.g44_1.p4g_1;
  }
  k4o(value) {
    this.g44_1.r4g_1 = value;
  }
  d4o() {
    return this.g44_1.r4g_1;
  }
  l4o(value) {
    this.g44_1.s4g_1 = value;
  }
  e4o() {
    return this.g44_1.s4g_1;
  }
  f4o() {
    TGenStack__push_impl_9yh33t(this.h44_1, this.g44_1.u1i());
  }
  n4o() {
    this.g44_1 = TGenStack__pop_impl_qisxa0(this.h44_1);
  }
  t56(sx, sy) {
    this.g44_1.z4f_1 = this.g44_1.z4f_1.r2a(sx, sy);
  }
  u4g(sx, sy, $super) {
    sy = sy === VOID ? sx : sy;
    var tmp;
    if ($super === VOID) {
      this.t56(sx, sy);
      tmp = Unit_instance;
    } else {
      tmp = $super.t56.call(this, sx, sy);
    }
    return tmp;
  }
  x4p(tx, ty) {
    this.g44_1.z4f_1 = this.g44_1.z4f_1.z2a(tx, ty);
  }
  z4p(m) {
    this.g44_1.z4f_1 = this.g44_1.z4f_1.b2b(m);
  }
  f5p(_set____db54di) {
    this.i44_1 = _set____db54di;
  }
  g5p() {
    return this.i44_1;
  }
  h5p(_set____db54di) {
    this.j44_1 = _set____db54di;
  }
  c3e() {
    return this.j44_1;
  }
  m3n() {
    return this.g44_1.b4g_1.m3n();
  }
  y5() {
    this.g44_1.b4g_1.y5();
    this.h5p(this.g5p());
  }
  b3e(p) {
    this.g44_1.b4g_1.b3e(trans(this, p));
    this.h5p(p);
    this.f5p(p);
  }
  d3e(p) {
    this.g44_1.b4g_1.d3e(trans(this, p));
    this.h5p(p);
  }
  e3e(c, a) {
    this.g44_1.b4g_1.e3e(trans(this, c), trans(this, a));
    this.h5p(a);
  }
  g3e(c1, c2, a) {
    this.g44_1.b4g_1.g3e(trans(this, c1), trans(this, c2), trans(this, a));
    this.h5p(a);
  }
  s56(path) {
    if (this.g1())
      this.g44_1.b4g_1.l3e_1 = path.l3e_1;
    write_0(this, path);
  }
  r4q(d) {
    d.q4q(this);
  }
  x4g(x, y, width, height) {
    this.m4m();
    this.r3n(x, y, width, height);
    this.v4n();
  }
  m4m() {
    this.g44_1.b4g_1 = new VectorPath();
  }
  u4n() {
    if (!equals(this.g44_1.i4g_1, NonePaint_instance)) {
      this.h5o(this.g44_1, false);
    }
  }
  i5p(winding) {
    if (!equals(this.g44_1.j4g_1, NonePaint_instance)) {
      this.g5o(this.g44_1, true, winding);
    }
  }
  v4n(winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.i5p(winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.i5p.call(this, winding);
    }
    return tmp;
  }
  j5p(paint, winding) {
    if (paint == null)
      return Unit_instance;
    // Inline function 'korlibs.image.vector.Context2d.fillStyle' call
    var oldStyle = this.v4g();
    this.w4g(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.fill.<anonymous>' call
      this.i5p(winding);
    }finally {
      this.w4g(oldStyle);
    }
  }
  y4n(paint, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.j5p(paint, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.j5p.call(this, paint, winding);
    }
    return tmp;
  }
  m4o(paint) {
    // Inline function 'korlibs.image.vector.Context2d.strokeStyle' call
    var oldStyle = this.v5o();
    this.u5o(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
      this.u4n();
    }finally {
      this.u5o(oldStyle);
    }
  }
  k5p() {
    this.v4n();
    this.u4n();
  }
  l5p(path, winding) {
    if (!(path == null)) {
      if (this.g44_1.a4g_1 == null) {
        this.g44_1.a4g_1 = new VectorPath();
      }
      ensureNotNull(this.g44_1.a4g_1).y2();
      ensureNotNull(this.g44_1.a4g_1).l3e_1 = winding;
      ensureNotNull(this.g44_1.a4g_1).o3o(path);
      if (path === this.g44_1.b4g_1) {
        path.y2();
      }
    } else {
      this.g44_1.a4g_1 = null;
    }
  }
  m5p(path, winding, $super) {
    path = path === VOID ? this.g44_1.b4g_1 : path;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.l5p(path, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.l5p.call(this, path, winding);
    }
    return tmp;
  }
  n5p(color) {
    return color;
  }
  o5p(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) {
    var paint_0 = paint == null ? fill ? this.v4g() : this.v5o() : paint;
    return font == null ? null : drawText(font, this, size, text, paint_0, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  }
  p5p(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, $super) {
    pos = pos === VOID ? Companion_getInstance_6().e26_1 : pos;
    fill = fill === VOID ? true : fill;
    paint = paint === VOID ? null : paint;
    font = font === VOID ? this.a4q() : font;
    size = size === VOID ? this.s4e() : size;
    var tmp;
    if (renderer === VOID) {
      var tmp_0 = get_DefaultStringTextRenderer();
      tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
    } else {
      tmp = renderer;
    }
    renderer = tmp;
    align = align === VOID ? this.b5o() : align;
    outMetrics = outMetrics === VOID ? null : outMetrics;
    fillStyle = fillStyle === VOID ? null : fillStyle;
    stroke = stroke === VOID ? null : stroke;
    textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
    textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
    return $super === VOID ? this.o5p(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) : $super.o5p.call(this, text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  }
  y4g(image, pos, size) {
    return this.i5o(image, pos, size, this.g44_1.z4f_1);
  }
  i5c(image, pos, size, $super) {
    size = size === VOID ? toFloat(image.d1()) : size;
    var tmp;
    if ($super === VOID) {
      this.y4g(image, pos, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.y4g.call(this, image, pos, size);
    }
    return tmp;
  }
}
class scaled$1 {
  constructor($this_scaled, $sx, $sy) {
    this.t5p_1 = $this_scaled;
    this.u5p_1 = $sx;
    this.v5p_1 = $sy;
    this.q5p_1 = $this_scaled;
    var tmp = this;
    // Inline function 'kotlin.math.abs' call
    var x = $this_scaled.w2i() * numberToDouble($sx);
    var tmp$ret$0 = Math.abs(x);
    tmp.r5p_1 = numberToInt(tmp$ret$0);
    var tmp_0 = this;
    // Inline function 'kotlin.math.abs' call
    var x_0 = $this_scaled.x2i() * numberToDouble($sy);
    var tmp$ret$1 = Math.abs(x_0);
    tmp_0.s5p_1 = numberToInt(tmp$ret$1);
  }
  w2i() {
    return this.r5p_1;
  }
  x2i() {
    return this.s5p_1;
  }
  q4q(c) {
    c.t56(numberToDouble(this.u5p_1), numberToDouble(this.v5p_1));
    this.t5p_1.q4q(c);
  }
}
class Companion_37 {
  constructor() {
    Companion_instance_46 = this;
    this.w5p_1 = values_6();
  }
}
class CycleMethod extends Enum {
  n5f() {
    return !this.equals(CycleMethod_NO_CYCLE_getInstance()) && !this.equals(CycleMethod_NO_CYCLE_CLAMP_getInstance());
  }
  j5f(ratio) {
    var tmp;
    switch (this.k3_1) {
      case 0:
        tmp = ratio;
        break;
      case 1:
        tmp = clamp01_0(ratio);
        break;
      case 2:
        // Inline function 'korlibs.math.fract' call

        tmp = ratio - toIntFloor(ratio);
        break;
      case 3:
        var part = umod(ratio, 2.0);
        tmp = part > 1.0 ? 2.0 - part : part;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  x5p(ratio) {
    return this.j5f(ratio);
  }
}
class BoundsDrawable {}
function get_width() {
  return numberToInt(this.k54().o26_1);
}
function get_height() {
  return numberToInt(this.k54().p26_1);
}
class ColorizedBeziers {
  constructor(beziers) {
    this.y5p_1 = beziers;
    var tmp = this;
    tmp.z5p_1 = lazy(ColorizedBeziers$red$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.a5q_1 = lazy(ColorizedBeziers$green$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.b5q_1 = lazy(ColorizedBeziers$blue$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.c5q_1 = lazy(ColorizedBeziers$allProjected$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.d5q_1 = lazy(ColorizedBeziers$redProjected$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.e5q_1 = lazy(ColorizedBeziers$greenProjected$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.f5q_1 = lazy(ColorizedBeziers$blueProjected$delegate$lambda(this));
  }
  q5q() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z5p_1;
    red$factory();
    return this_0.o1();
  }
  r5q() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.a5q_1;
    green$factory();
    return this_0.o1();
  }
  s5q() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b5q_1;
    blue$factory();
    return this_0.o1();
  }
  g5q() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c5q_1;
    allProjected$factory();
    return this_0.o1();
  }
  l5q() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d5q_1;
    redProjected$factory();
    return this_0.o1();
  }
  m5q() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.e5q_1;
    greenProjected$factory();
    return this_0.o1();
  }
  n5q() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f5q_1;
    blueProjected$factory();
    return this_0.o1();
  }
}
class ColoredBezier {
  constructor(bezier, color) {
    this.o5q_1 = bezier;
    this.p5q_1 = color;
  }
  toString() {
    return 'ColoredBezier(bezier=' + this.o5q_1.toString() + ', color=' + RGBA__toString_impl_4lw6dp(this.p5q_1) + ')';
  }
  hashCode() {
    var result = this.o5q_1.hashCode();
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.p5q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColoredBezier))
      return false;
    var tmp0_other_with_cast = other instanceof ColoredBezier ? other : THROW_CCE();
    if (!this.o5q_1.equals(tmp0_other_with_cast.o5q_1))
      return false;
    if (!(this.p5q_1 === tmp0_other_with_cast.p5q_1))
      return false;
    return true;
  }
}
class ProjectCurvesLookup {
  constructor(beziers) {
    this.h5q_1 = beziers;
    this.i5q_1 = new ProjectedPoint();
    this.j5q_1 = Companion_getInstance_2().q29();
  }
  k5q(point) {
    return Companion_getInstance_6().m2h(point, this.h3d(point));
  }
  h3d(point) {
    if (this.h5q_1.g1())
      return Vector2D.y28(0, 0);
    var minDistSq = Infinity;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.h5q_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var dist = this_0.f1(_unary__edvuaz).s3c().w27(point);
      if (dist < minDistSq) {
        minDistSq = dist;
      }
    }
    var bminDistSq = Infinity;
    var out = Vector2D.w28();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.h5q_1;
    var n_0 = 0;
    while (n_0 < this_1.d1()) {
      $l$block: {
        // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        var it = this_1.f1(_unary__edvuaz_0);
        if (it.s3c().v27(point) > minDistSq) {
          break $l$block;
        }
        it.f3d(point, this.i5q_1);
        if (this.i5q_1.v3b_1 < bminDistSq) {
          bminDistSq = this.i5q_1.v3b_1;
          out = this.i5q_1.t3b_1;
        }
      }
    }
    return out;
  }
}
class Shape {}
function getPath(path) {
  return path;
}
function getPath$default(path, $super) {
  path = path === VOID ? new VectorPath() : path;
  return $super === VOID ? this.t5q(path) : getPath(path);
}
function get_bounds() {
  return this.u5q(true);
}
class StyledShape {}
function get_path() {
  return null;
}
function getBounds(includeStrokes) {
  var tmp345_safe_receiver = this.m22();
  var tmp;
  if (tmp345_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.StyledShape.getBounds.<anonymous>' call
    tmp = _BoundsBuilder___get_bounds__impl__s1l1gx(plus_1(Companion_getInstance_7().c27(), tmp345_safe_receiver));
  }
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? Companion_getInstance_4().b27() : tmp0_elvis_lhs;
}
function getPath_0(path) {
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.StyledShape.getPath.<anonymous>' call
  var tmp347_safe_receiver = this.m22();
  if (tmp347_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    path.o3o(tmp347_safe_receiver);
  }
  return path;
}
function draw(c) {
  // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
  var t = c.g44_1.z4f_1;
  try {
    // Inline function 'korlibs.image.vector.StyledShape.draw.<anonymous>' call
    c.m4m();
    var tmp348_safe_receiver = this.m22();
    if (tmp348_safe_receiver == null)
      null;
    else {
      draw_0(tmp348_safe_receiver, c);
    }
    if (!(this.c5r() == null)) {
      draw_0(ensureNotNull(this.c5r()), c);
      c.m5p();
    }
    c.z4p(get_immutable(this.y4p()));
    this.g5r(c);
  }finally {
    c.g44_1.z4f_1 = t;
  }
}
function drawInternal(c) {
}
class FillShape {
  constructor(path, clip, paint, transform, globalAlpha) {
    transform = transform === VOID ? Companion_getInstance_5().n29_1 : transform;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.v5q_1 = path;
    this.w5q_1 = clip;
    this.x5q_1 = paint;
    this.y5q_1 = transform;
    this.z5q_1 = globalAlpha;
    var tmp = this;
    tmp.a5r_1 = lazy(FillShape$pathCurvesList$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.b5r_1 = lazy(FillShape$clipCurvesList$delegate$lambda(this));
  }
  m22() {
    return this.v5q_1;
  }
  c5r() {
    return this.w5q_1;
  }
  y4p() {
    return this.y5q_1;
  }
  d5r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.a5r_1;
    pathCurvesList$factory();
    return this_0.o1();
  }
  e5r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b5r_1;
    clipCurvesList$factory();
    return this_0.o1();
  }
  f5r() {
    return this.d5r().d1() === 1 && get_isConvex(first_0(this.d5r())) && this.e5r() == null;
  }
  g5r(c) {
    c.j5p(this.x5q_1, this.v5q_1.l3e_1);
  }
  toString() {
    return 'FillShape(path=' + this.v5q_1.toString() + ', clip=' + toString(this.w5q_1) + ', paint=' + toString_0(this.x5q_1) + ', transform=' + this.y5q_1.toString() + ', globalAlpha=' + this.z5q_1 + ')';
  }
  hashCode() {
    var result = this.v5q_1.hashCode();
    result = imul(result, 31) + (this.w5q_1 == null ? 0 : this.w5q_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.x5q_1) | 0;
    result = imul(result, 31) + this.y5q_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.z5q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FillShape))
      return false;
    var tmp0_other_with_cast = other instanceof FillShape ? other : THROW_CCE();
    if (!this.v5q_1.equals(tmp0_other_with_cast.v5q_1))
      return false;
    if (!equals(this.w5q_1, tmp0_other_with_cast.w5q_1))
      return false;
    if (!equals(this.x5q_1, tmp0_other_with_cast.x5q_1))
      return false;
    if (!this.y5q_1.equals(tmp0_other_with_cast.y5q_1))
      return false;
    if (!equals(this.z5q_1, tmp0_other_with_cast.z5q_1))
      return false;
    return true;
  }
}
class CompoundShape {
  constructor(components) {
    this.h5r_1 = components;
  }
  u5q(includeStrokes) {
    var bb = Companion_getInstance_7().c27();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.h5r_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getBounds.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.f1(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, it.u5q(includeStrokes));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  q4q(c) {
    $l$block: {
      // Inline function 'korlibs.image.vector.Context2d.buffering' call
      c.p5o();
      try {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var this_0 = this.h5r_1;
        var n = 0;
        while (n < this_0.d1()) {
          // Inline function 'korlibs.image.vector.CompoundShape.draw.<anonymous>.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          this_0.f1(_unary__edvuaz).q4q(c);
        }
        break $l$block;
      }finally {
        c.q5o();
      }
    }
    return Unit_instance;
  }
  t5q(path) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.h5r_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.f1(_unary__edvuaz).t5q(path);
    }
    return path;
  }
  toString() {
    return 'CompoundShape(\n  ' + joinToString(this.h5r_1, ',\n  ') + '\n)';
  }
}
class PolylineShape {
  constructor(path, clip, paint, transform, strokeInfo, globalAlpha) {
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.j5r_1 = path;
    this.k5r_1 = clip;
    this.l5r_1 = paint;
    this.m5r_1 = transform;
    this.n5r_1 = strokeInfo;
    this.o5r_1 = globalAlpha;
    this.p5r_1 = thickness$factory(this.n5r_1);
    this.q5r_1 = scaleMode$factory(this.n5r_1);
    this.r5r_1 = startCap$factory(this.n5r_1);
    this.s5r_1 = endCap$factory(this.n5r_1);
    this.t5r_1 = join$factory(this.n5r_1);
    this.u5r_1 = miterLimit$factory(this.n5r_1);
    this.v5r_1 = dash$factory(this.n5r_1);
    this.w5r_1 = dashOffset$factory(this.n5r_1);
    var tmp = this;
    tmp.x5r_1 = lazy(PolylineShape$fillShape$delegate$lambda(this));
  }
  m22() {
    return this.j5r_1;
  }
  c5r() {
    return this.k5r_1;
  }
  y4p() {
    return this.m5r_1;
  }
  u5q(includeStrokes) {
    var tmp352_safe_receiver = BoundsBuilder__boundsOrNull_impl_se9lyg(plus_1(Companion_getInstance_7().c27(), this.j5r_1));
    var bounds = tmp352_safe_receiver == null ? null : get_mutable(tmp352_safe_receiver);
    if (includeStrokes) {
      // Inline function 'kotlin.math.max' call
      var a = this.n5r_1.k38_1 / 2.0;
      var halfThickness = Math.max(a, 0.0);
      if (bounds == null)
        null;
      else
        bounds.j3q(halfThickness, halfThickness);
    }
    var tmp0_elvis_lhs = bounds == null ? null : bounds.r3p();
    return tmp0_elvis_lhs == null ? Companion_getInstance_4().y26_1 : tmp0_elvis_lhs;
  }
  y5r(c) {
    c.r5o(this.n5r_1.m38_1);
    c.g4o(this.n5r_1.k38_1);
    c.s5o(this.n5r_1.n38_1);
    c.t5o(this.n5r_1.o38_1);
    c.i4o(this.n5r_1.p38_1);
    c.j4o(this.n5r_1.q38_1);
    c.k4o(this.n5r_1.r38_1);
    c.l4o(this.n5r_1.s38_1);
  }
  g5r(c) {
    this.y5r(c);
    c.m4o(this.l5r_1);
  }
  toString() {
    return 'PolylineShape(path=' + this.j5r_1.toString() + ', clip=' + toString(this.k5r_1) + ', paint=' + toString_0(this.l5r_1) + ', transform=' + this.m5r_1.toString() + ', strokeInfo=' + this.n5r_1.toString() + ', globalAlpha=' + this.o5r_1 + ')';
  }
  hashCode() {
    var result = this.j5r_1.hashCode();
    result = imul(result, 31) + (this.k5r_1 == null ? 0 : this.k5r_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.l5r_1) | 0;
    result = imul(result, 31) + this.m5r_1.hashCode() | 0;
    result = imul(result, 31) + this.n5r_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.o5r_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PolylineShape))
      return false;
    var tmp0_other_with_cast = other instanceof PolylineShape ? other : THROW_CCE();
    if (!this.j5r_1.equals(tmp0_other_with_cast.j5r_1))
      return false;
    if (!equals(this.k5r_1, tmp0_other_with_cast.k5r_1))
      return false;
    if (!equals(this.l5r_1, tmp0_other_with_cast.l5r_1))
      return false;
    if (!this.m5r_1.equals(tmp0_other_with_cast.m5r_1))
      return false;
    if (!this.n5r_1.equals(tmp0_other_with_cast.n5r_1))
      return false;
    if (!equals(this.o5r_1, tmp0_other_with_cast.o5r_1))
      return false;
    return true;
  }
}
class TextShape {
  constructor(text, pos, font, fontSize, clip, fill, stroke, align, transform, globalAlpha) {
    align = align === VOID ? Companion_getInstance_51().s4l_1 : align;
    transform = transform === VOID ? Companion_getInstance_5().n29_1 : transform;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.z5r_1 = text;
    this.a5s_1 = pos;
    this.b5s_1 = font;
    this.c5s_1 = fontSize;
    this.d5s_1 = clip;
    this.e5s_1 = fill;
    this.f5s_1 = stroke;
    this.g5s_1 = align;
    this.h5s_1 = transform;
    this.i5s_1 = globalAlpha;
    var tmp = this;
    tmp.j5s_1 = lazy(TextShape$primitiveShapes$delegate$lambda(this));
  }
  c5r() {
    return this.d5s_1;
  }
  y4p() {
    return this.h5s_1;
  }
  u5q(includeStrokes) {
    return Companion_getInstance_4().g27(this.a5s_1, Vector2D.l28(this.a5s_1.c26_1 + this.c5s_1 * this.z5r_1.length, this.a5s_1.d26_1 + this.c5s_1));
  }
  g5r(c) {
    // Inline function 'korlibs.image.vector.Context2d.font' call
    var font = this.b5s_1;
    var align = this.g5s_1;
    var size = c.s4e();
    var oldFont = c.a4q();
    var oldFontSize = c.s4e();
    var oldAlign = c.b5o();
    try {
      c.x5o(font);
      c.y5o(size);
      c.c5p(align);
      // Inline function 'korlibs.image.vector.TextShape.drawInternal.<anonymous>' call
      if (!(this.e5s_1 == null)) {
        c.n5o(this.z5r_1, this.a5s_1);
      }
      if (!(this.f5s_1 == null)) {
        c.o5o(this.z5r_1, this.a5s_1);
      }
    }finally {
      c.x5o(oldFont);
      c.y5o(oldFontSize);
      c.c5p(oldAlign);
    }
  }
  k5s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.j5s_1;
    primitiveShapes$factory();
    return this_0.o1();
  }
}
class EmptyShape {
  u5q(includeStrokes) {
    return Companion_getInstance_4().b27();
  }
  q4q(c) {
    return Unit_instance;
  }
}
class ShapeBuilder extends Context2d {
  constructor(width, height) {
    super(Companion_getInstance_57());
    var tmp = this;
    tmp.r4k_1 = width == null ? 256 : width;
    var tmp_0 = this;
    tmp_0.s4k_1 = height == null ? 256 : height;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_1.t4k_1 = ArrayList.i1();
  }
  e5o() {
    return this.r4k_1;
  }
  f5o() {
    return this.s4k_1;
  }
  g5o(state, fill, winding) {
    if (state.b4g_1.g1())
      return Unit_instance;
    // Inline function 'kotlin.also' call
    var this_0 = state.b4g_1.u1i();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
    var tmp = this_0;
    tmp.l3e_1 = winding == null ? this_0.l3e_1 : winding;
    var path = this_0;
    var tmp367_safe_receiver = state.a4g_1;
    var tmp368_safe_receiver = tmp367_safe_receiver == null ? null : tmp367_safe_receiver.u1i();
    var tmp_0;
    if (tmp368_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
      var tmp_1 = tmp368_safe_receiver;
      tmp_1.l3e_1 = winding == null ? tmp368_safe_receiver.l3e_1 : winding;
      tmp_0 = tmp368_safe_receiver;
    }
    var clip = tmp_0;
    var transform = state.z4f_1;
    if (fill) {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = this.t4k_1;
      var element = new FillShape(path, clip, state.j4g_1.u1i(), transform, state.p4g_1);
      this_1.h(element);
    } else {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_2 = this.t4k_1;
      var tmp_2 = state.i4g_1.u1i();
      var tmp369_thickness = state.d4g_1;
      var tmp370_scaleMode = state.c4g_1;
      var tmp371_startCap = state.e4g_1;
      var tmp372_endCap = state.f4g_1;
      var tmp373_join = state.g4g_1;
      var tmp374_dash = state.r4g_1;
      var tmp375_dashOffset = state.s4g_1;
      var tmp376_miterLimit = state.h4g_1;
      var element_0 = new PolylineShape(path, clip, tmp_2, transform, new StrokeInfo(tmp369_thickness, true, tmp370_scaleMode, tmp371_startCap, tmp372_endCap, tmp373_join, tmp376_miterLimit, tmp374_dash, tmp375_dashOffset), state.p4g_1);
      this_2.h(element_0);
    }
  }
  m5o(state, font, fontSize, text, pos, fill) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.t4k_1;
    var tmp377_safe_receiver = state.a4g_1;
    var element = new TextShape(text, pos, font, fontSize, tmp377_safe_receiver == null ? null : tmp377_safe_receiver.u1i(), fill ? state.j4g_1 : null, fill ? null : state.i4g_1, state.b5o(), state.z4f_1);
    this_0.h(element);
  }
  i5o(image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererDrawImage.<anonymous>' call
    this_0.q3n(pos, size);
    this.h5o(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, scaled(Companion_getInstance_5().n29_1, size.j2g(toFloat(image.d1()))).t2a(pos))), true);
  }
  j5o() {
  }
  k5o() {
    return 0;
  }
  l5o() {
  }
  u4k() {
    return this.t4k_1.d1() === 1 ? first_0(this.t4k_1) : new CompoundShape(toList(this.t4k_1));
  }
  q4q(c) {
    c.r4q(this.u4k());
  }
}
class Companion_38 {
  z5s(str) {
    return (new CSSDeclarations()).f1k(str).a5t_1;
  }
}
class SvgDef {
  constructor(def) {
    this.r5t_1 = def;
    var tmp = this;
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s5t_1 = this.r5t_1.b1n('id').toLowerCase();
    this.t5t_1 = this.r5t_1.t1l_1;
    this.u5t_1 = this.b5u(this.r5t_1);
    var tmp_0 = this;
    var tmp0_elvis_lhs = this.r5t_1.k10('gradientUnits');
    tmp_0.v5t_1 = (tmp0_elvis_lhs == null ? 'objectBoundingBox' : tmp0_elvis_lhs) === 'userSpaceOnUse' ? GradientUnits_USER_SPACE_ON_USE_getInstance() : GradientUnits_OBJECT_BOUNDING_BOX_getInstance();
    var tmp_1 = this;
    var tmp380_safe_receiver = this.r5t_1.k10('gradientTransform');
    var tmp_2;
    if (tmp380_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.vector.format.SvgDef.gradientTransform.<anonymous>' call
      tmp_2 = Companion_instance_39.p5h(tmp380_safe_receiver);
    }
    var tmp0_elvis_lhs_0 = tmp_2;
    tmp_1.w5t_1 = tmp0_elvis_lhs_0 == null ? Companion_getInstance_5().n29_1 : tmp0_elvis_lhs_0;
    var tmp_3 = this;
    // Inline function 'kotlin.text.lowercase' call
    var tmp0_elvis_lhs_1 = this.r5t_1.k10('spreadMethod');
    // Inline function 'kotlin.js.asDynamic' call
    switch ((tmp0_elvis_lhs_1 == null ? 'pad' : tmp0_elvis_lhs_1).toLowerCase()) {
      case 'pad':
        tmp_3.x5t_1 = CycleMethod_NO_CYCLE_getInstance();
        break;
      case 'repeat':
        tmp_3.x5t_1 = CycleMethod_REPEAT_getInstance();
        break;
      case 'reflect':
        tmp_3.x5t_1 = CycleMethod_REFLECT_getInstance();
        break;
      default:
        tmp_3.x5t_1 = CycleMethod_NO_CYCLE_getInstance();
        break;
    }
    var tmp_4 = this;
    var tmp_5;
    if (this.t5t_1 === 'lineargradient') {
      var x0 = this.r5t_1.u1m('x1', 0.0);
      var y0 = this.r5t_1.u1m('y1', 0.0);
      var x1 = this.r5t_1.u1m('x2', 1.0);
      var y1 = this.r5t_1.u1m('y2', 1.0);
      tmp_5 = new GradientPaint(GradientKind_LINEAR_getInstance(), x0, y0, 0.0, x1, y1, 0.0, VOID, VOID, this.x5t_1, this.w5t_1, VOID, this.v5t_1);
    } else {
      var cx = this.r5t_1.u1m('cx', 0.0);
      var cy = this.r5t_1.u1m('cy', 0.0);
      var r = this.r5t_1.u1m('r', 16.0);
      var fx = this.r5t_1.u1m('fx', cx);
      var fy = this.r5t_1.u1m('fy', cy);
      tmp_5 = new GradientPaint(GradientKind_RADIAL_getInstance(), cx, cy, 0.0, fx, fy, r, VOID, VOID, this.x5t_1, this.w5t_1, VOID, this.v5t_1);
    }
    tmp_4.y5t_1 = tmp_5;
    this.z5t_1 = this.r5t_1.d1n('xlink:href');
    var _iterator__ex2g4s = this.u5t_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.c1();
      var offset = _destruct__k2r9zo.bl().l1i_1;
      var color = _destruct__k2r9zo.cl().i4d_1;
      this.y5t_1.f5f(offset, color);
    }
    this.a5u_1 = this.y5t_1;
  }
  b5u(xml) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var out = ArrayList.i1();
    var _iterator__ex2g4s = xml.t1m('stop').a1();
    while (_iterator__ex2g4s.b1()) {
      var stop = _iterator__ex2g4s.c1();
      var info = Companion_getInstance_56().e5u(stop);
      var offset = Companion_getInstance_9().m1i_1;
      var colorStop = Companion_getInstance_56().d5u_1.d4d_1;
      var alphaStop = 1.0;
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_0 = info.m1().a1();
      while (_iterator__ex2g4s_0.b1()) {
        var _destruct__k2r9zo = _iterator__ex2g4s_0.c1();
        // Inline function 'kotlin.collections.component1' call
        var key = _destruct__k2r9zo.n1();
        // Inline function 'kotlin.collections.component2' call
        var value = _destruct__k2r9zo.o1();
        switch (key) {
          case 'offset':
            offset = Companion_instance_39.u5f(value);
            break;
          case 'stop-color':
            colorStop = Companion_getInstance_56().d5u_1.e4d(value);
            break;
          case 'stop-opacity':
            // Inline function 'kotlin.text.toFloatOrNull' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp0_elvis_lhs = toDoubleOrNull(value);
            alphaStop = tmp0_elvis_lhs == null ? 1.0 : tmp0_elvis_lhs;
            break;
        }
      }
      // Inline function 'kotlin.collections.plusAssign' call
      var element = new Pair(new Ratio(offset), new RGBA(Companion_getInstance_23().s4d(_RGBA___get_rgb__impl__tijaqt(colorStop), numberToInt(_RGBA___get_ad__impl__pt5rdj(colorStop) * alphaStop * 255))));
      out.h(element);
    }
    return out;
  }
}
class Mappings {
  constructor() {
    Mappings_instance = this;
    this.f5u_1 = (new DomPropertyMapping()).b5j('transform', transform$factory()).a5j('opacity', opacity$factory());
  }
}
class SvgElement extends DomElement {
  constructor($outer, xml, $box) {
    if ($box === VOID)
      $box = {};
    $box.p5u_1 = $outer;
    super(_get__dom__d2l6i0($outer), Mappings_getInstance().f5u_1, $box);
    this.k5u_1 = xml;
    this.c5j(this.k5u_1.k10('id'));
    this.l5u_1 = Companion_getInstance_56().e5u(this.k5u_1);
    var tmp = this;
    var tmp386_safe_receiver = this.l5u_1.d3('transform');
    var tmp_0;
    if (tmp386_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.vector.format.SvgElement.transform.<anonymous>' call
      tmp_0 = Companion_instance_39.p5h(tmp386_safe_receiver);
    }
    var tmp0_elvis_lhs = tmp_0;
    tmp.m5u_1 = tmp0_elvis_lhs == null ? Companion_getInstance_5().n29_1 : tmp0_elvis_lhs;
    var tmp_1 = this;
    var tmp387_safe_receiver = this.l5u_1.d3('opacity');
    var tmp0_elvis_lhs_0 = tmp387_safe_receiver == null ? null : toDoubleOrNull(tmp387_safe_receiver);
    tmp_1.n5u_1 = tmp0_elvis_lhs_0 == null ? 1.0 : tmp0_elvis_lhs_0;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = this.k5u_1.r1m();
    var destination = ArrayList.i1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.vector.format.SvgElement.children.<anonymous>' call
      var tmp0_safe_receiver = this.p5u_1.q5u(element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(tmp0_safe_receiver);
      }
    }
    tmp_2.o5u_1 = destination;
  }
  toString() {
    return 'SvgElement(' + this.x5i_1 + ', ' + this.k5u_1.t1l_1 + ', children=' + this.o5u_1.d1() + ')';
  }
  q4q(c) {
    // Inline function 'korlibs.image.vector.Context2d.keepApply' call
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.Context2d.keepApply.<anonymous>' call
    // Inline function 'korlibs.image.vector.Context2d.keep' call
    c.f4o();
    try {
      // Inline function 'korlibs.image.vector.Context2d.keepApply.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.image.vector.format.SvgElement.draw.<anonymous>' call
      var tmp388_safe_receiver = this.m5u_1;
      if (tmp388_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        c.g44_1.z4f_1 = c.g44_1.z4f_1.b2b(get_immutable(tmp388_safe_receiver));
      }
      this.r5u(c);
      this.s5u(c);
      this.g5r(c);
      this.t5u(c);
    }finally {
      c.n4o();
    }
  }
  s5u(c) {
    var _iterator__ex2g4s = this.o5u_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var child = _iterator__ex2g4s.c1();
      child.q4q(c);
    }
  }
  g5r(c) {
  }
  t5u(c) {
    if (c.g44_1.b4g_1.m28()) {
      // Inline function 'korlibs.image.vector.Context2d.keep' call
      c.f4o();
      try {
        // Inline function 'korlibs.image.vector.format.SvgElement.fillStrokeInternal.<anonymous>' call
        c.w4g(getPaintWithUnits(c.v4g(), c.g44_1.z4f_1, c.g44_1.b4g_1));
        c.u5o(getPaintWithUnits(c.v5o(), c.g44_1.z4f_1, c.g44_1.b4g_1));
        c.k5p();
      }finally {
        c.n4o();
      }
    }
  }
  u5u(_this__u8e3s4, default_0) {
    // Inline function 'kotlin.text.trim' call
    var str = toString_0(trim(isCharSequence(_this__u8e3s4) ? _this__u8e3s4 : THROW_CCE()));
    var scale = endsWith(str, 'px') ? 1.0 : endsWith(str, 'pt') ? 1.0 : endsWith(str, 'em') ? 10.0 : endsWith(str, '%') ? 0.01 : 1.0;
    // Inline function 'kotlin.text.toFloatOrNull' call
    var this_0 = removeSuffix(removeSuffix(removeSuffix(removeSuffix(str, 'px'), 'pt'), 'em'), '%');
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp389_safe_receiver = toDoubleOrNull(this_0);
    var tmp0_elvis_lhs = tmp389_safe_receiver == null ? null : tmp389_safe_receiver * scale;
    return tmp0_elvis_lhs == null ? default_0 : tmp0_elvis_lhs;
  }
  r5u(c) {
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.l5u_1.m1().a1();
    while (_iterator__ex2g4s.b1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.c1();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.n1();
      // Inline function 'kotlin.collections.component2' call
      var it = _destruct__k2r9zo.o1();
      switch (key) {
        case 'stroke-width':
          c.g4o(this.u5u(it, 1.0));
          break;
        case 'stroke-linejoin':
          c.i4o(Companion_instance_1.v3o(it));
          break;
        case 'stroke-linecap':
          c.h4o(Companion_instance_2.v3o(it));
          break;
        case 'stroke':
          c.u5o(this.v5u(c, it));
          break;
        case 'opacity':
          c.d5p(c.e5p() * this.n5u_1);
          break;
        case 'fill-opacity':
          c.d5p(c.e5p() * this.u5u(it, 1.0));
          break;
        case 'stroke-opacity':
          c.d5p(c.e5p() * this.u5u(it, 1.0));
          break;
        case 'fill':
          c.w4g(this.v5u(c, it));
          break;
        case 'font-size':
          c.y5o(Companion_instance_39.t5h(it));
          break;
        case 'font-family':
          var tmp391_safe_receiver = c.w5o();
          c.x5o(tmp391_safe_receiver == null ? null : tmp391_safe_receiver.v3o(it));
          break;
        case 'text-anchor':
          // Inline function 'kotlin.text.trim' call

          // Inline function 'kotlin.text.lowercase' call

          // Inline function 'kotlin.js.asDynamic' call

          var this_0 = it.toLowerCase();
          var tmp392_subject = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
          c.a5p(tmp392_subject === 'left' ? Companion_getInstance_50().y5j_1 : tmp392_subject === 'center' || tmp392_subject === 'middle' ? Companion_getInstance_50().z5j_1 : tmp392_subject === 'right' || tmp392_subject === 'end' ? Companion_getInstance_50().a5k_1 : c.b5p());
          break;
        case 'alignment-baseline':
          // Inline function 'kotlin.text.trim' call

          // Inline function 'kotlin.text.lowercase' call

          // Inline function 'kotlin.js.asDynamic' call

          var this_1 = it.toLowerCase();
          var tmp393_subject = toString_0(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
          c.z5o(tmp393_subject === 'hanging' ? Companion_getInstance_49().q5j_1 : tmp393_subject === 'center' || tmp393_subject === 'middle' ? Companion_getInstance_49().r5j_1 : tmp393_subject === 'baseline' ? Companion_getInstance_49().t5j_1 : tmp393_subject === 'bottom' ? Companion_getInstance_49().s5j_1 : c.m5l());
          break;
        case 'fill-rule':
          break;
      }
    }
  }
  v5u(c, str2) {
    // Inline function 'kotlin.text.trim' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var this_0 = str2.toLowerCase();
    var str = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    var tmp;
    if (startsWith(str, 'url(')) {
      var urlPattern = substringBefore(substr_0(str, 4, -1), _Char___init__impl__6a9atx(41));
      var extra = substringAfter(str, _Char___init__impl__6a9atx(41));
      var tmp_0;
      if (startsWith(urlPattern, '#')) {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var idName = urlPattern.substring(1).toLowerCase();
        var def = this.p5u_1.w5u().d3(idName);
        if (def == null) {
          // Inline function 'korlibs.logger.Logger.info' call
          var this_1 = Companion_getInstance_56().c5u_1;
          var level = Level_INFO_getInstance();
          var tmp_1;
          if (this_1.k2t(level)) {
            // Inline function 'korlibs.image.vector.format.SvgElement.parseFillStroke.<anonymous>' call
            var tmp$ret$7 = this.p5u_1.w5u();
            this_1.l2t(level, tmp$ret$7);
            tmp_1 = Unit_instance;
          }
          // Inline function 'korlibs.logger.Logger.info' call
          var this_2 = Companion_getInstance_56().c5u_1;
          var level_0 = Level_INFO_getInstance();
          var tmp_2;
          if (this_2.k2t(level_0)) {
            // Inline function 'korlibs.image.vector.format.SvgElement.parseFillStroke.<anonymous>' call
            var tmp$ret$9 = "Can't find svg definition '" + idName + "'";
            this_2.l2t(level_0, tmp$ret$9);
            tmp_2 = Unit_instance;
          }
        }
        var tmp0_elvis_lhs = def == null ? null : def.a5u_1;
        tmp_0 = tmp0_elvis_lhs == null ? NonePaint_instance : tmp0_elvis_lhs;
      } else {
        // Inline function 'korlibs.logger.Logger.info' call
        var this_3 = Companion_getInstance_56().c5u_1;
        var level_1 = Level_INFO_getInstance();
        var tmp_3;
        if (this_3.k2t(level_1)) {
          // Inline function 'korlibs.image.vector.format.SvgElement.parseFillStroke.<anonymous>' call
          var tmp$ret$11 = 'Unsupported ' + str;
          this_3.l2t(level_1, tmp$ret$11);
          tmp_3 = Unit_instance;
        }
        tmp_0 = NonePaint_instance;
      }
      tmp = tmp_0;
    } else if (startsWith(str, 'rgba(')) {
      // Inline function 'kotlin.collections.map' call
      var this_4 = split(removeSuffix(removePrefix(str, 'rgba('), ')'), [',']);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_4, 10));
      var tmp0_iterator = this_4.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.image.vector.format.SvgElement.parseFillStroke.<anonymous>' call
        // Inline function 'kotlin.text.trim' call
        var tmp$ret$13 = toString_0(trim(isCharSequence(item) ? item : THROW_CCE()));
        var tmp0_elvis_lhs_0 = toDoubleOrNull(tmp$ret$13);
        var tmp$ret$14 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
        destination.h(tmp$ret$14);
      }
      var components = destination;
      tmp = new RGBA(Companion_getInstance_23().t4d(Companion_getInstance_23().w4b(numberToInt(components.f1(0)), numberToInt(components.f1(1)), numberToInt(components.f1(2)), numberToInt(components.f1(3) * 255))));
    } else if (startsWith(str, 'rgb(')) {
      // Inline function 'kotlin.collections.map' call
      var this_5 = split(removeSuffix(removePrefix(str, 'rgb('), ')'), [',']);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_5, 10));
      var tmp0_iterator_0 = this_5.a1();
      while (tmp0_iterator_0.b1()) {
        var item_0 = tmp0_iterator_0.c1();
        // Inline function 'korlibs.image.vector.format.SvgElement.parseFillStroke.<anonymous>' call
        // Inline function 'kotlin.text.trim' call
        var tmp$ret$17 = toString_0(trim(isCharSequence(item_0) ? item_0 : THROW_CCE()));
        var tmp0_elvis_lhs_1 = toDoubleOrNull(tmp$ret$17);
        var tmp$ret$18 = tmp0_elvis_lhs_1 == null ? 0.0 : tmp0_elvis_lhs_1;
        destination_0.h(tmp$ret$18);
      }
      var components_0 = destination_0;
      tmp = new RGBA(Companion_getInstance_23().t4d(Companion_getInstance_23().w4b(numberToInt(components_0.f1(0)), numberToInt(components_0.f1(1)), numberToInt(components_0.f1(2)), 255)));
    } else {
      tmp = str === 'none' ? NonePaint_instance : new RGBA(c.n5p(Companion_getInstance_56().d5u_1.e4d(str)));
    }
    var res = tmp;
    return res;
  }
}
class RectSvgElement extends SvgElement {
  constructor($outer, xml, $box) {
    if ($box === VOID)
      $box = {};
    $box.n5v_1 = $outer;
    super($outer, xml, $box);
    this.h5v_1 = xml.v1m('x');
    this.i5v_1 = xml.v1m('y');
    this.j5v_1 = xml.v1m('width');
    this.k5v_1 = xml.v1m('height');
    this.l5v_1 = xml.u1m('ry', xml.v1m('rx'));
    this.m5v_1 = xml.u1m('rx', xml.v1m('ry'));
  }
  g5r(c) {
    c.c3o(this.h5v_1, this.i5v_1, this.j5v_1, this.k5v_1, this.m5v_1, this.l5v_1);
  }
}
class CircleSvgElement extends SvgElement {
  constructor($outer, xml, $box) {
    if ($box === VOID)
      $box = {};
    $box.b5w_1 = $outer;
    super($outer, xml, $box);
    this.y5v_1 = xml.v1m('cx');
    this.z5v_1 = xml.v1m('cy');
    this.a5w_1 = xml.v1m('r');
  }
  g5r(c) {
    c.j38(Vector2D.l28(this.y5v_1, this.z5v_1), this.a5w_1);
  }
}
class EllipseSvgElement extends SvgElement {
  constructor($outer, xml, $box) {
    if ($box === VOID)
      $box = {};
    $box.q5w_1 = $outer;
    super($outer, xml, $box);
    this.m5w_1 = xml.v1m('cx');
    this.n5w_1 = xml.v1m('cy');
    this.o5w_1 = xml.v1m('rx');
    this.p5w_1 = xml.v1m('ry');
  }
  g5r(c) {
    c.d3o(Vector2D.l28(this.m5w_1 - this.o5w_1, this.n5w_1 - this.p5w_1), Size2D.s2e(this.o5w_1 * 2, this.p5w_1 * 2));
  }
}
class PolySvgElement extends SvgElement {
  constructor($outer, xml, $box) {
    if ($box === VOID)
      $box = {};
    $box.e5x_1 = $outer;
    super($outer, xml, $box);
    this.b5x_1 = Companion_instance_6.a1i(xml.b1n('points'));
    var tmp = this;
    // Inline function 'korlibs.datastructure.mapWhile' call
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.collections.arrayListOf' call
    var this_0 = ArrayList.i1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapWhile.<anonymous>' call
    $l$loop: while (true) {
      // Inline function 'korlibs.image.vector.format.PolySvgElement.pps.<anonymous>' call
      this_0.d1();
      if (!this.b5x_1.s1g()) {
        break $l$loop;
      }
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'korlibs.image.vector.format.PolySvgElement.pps.<anonymous>' call
      this_0.d1();
      skipWhile(this.b5x_1, SVG$PolySvgElement$pps$lambda);
      // Inline function 'korlibs.util.readWhileBuilder' call
      var this_1 = this.b5x_1;
      // Inline function 'korlibs.util.readUntilBuilder' call
      var out = StringBuilder.f();
      $l$loop_0: while (this_1.s1g()) {
        var c = this_1.r1h();
        // Inline function 'korlibs.util.readWhileBuilder.<anonymous>' call
        // Inline function 'korlibs.image.vector.format.PolySvgElement.pps.<anonymous>.<anonymous>' call
        if (!get_isNumeric(c)) {
          if (false) {
            this_1.s1h();
            out.ob(c);
          }
          break $l$loop_0;
        }
        this_1.s1h();
        out.ob(c);
      }
      var out_0 = toDouble(out.toString());
      skipWhile(this.b5x_1, SVG$PolySvgElement$pps$lambda_0);
      this_0.h(out_0);
    }
    tmp.c5x_1 = new ListReader(toList(this_0));
    var tmp_0 = this;
    // Inline function 'kotlin.also' call
    var this_2 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.format.PolySvgElement.path.<anonymous>' call
    var edges = 0;
    this_2.b3e(Vector2D.l28(this.c5x_1.a1v(), this.c5x_1.a1v()));
    while (this.c5x_1.s1g()) {
      var x = this.c5x_1.a1v();
      var y = this.c5x_1.a1v();
      this_2.d3e(Vector2D.l28(x, y));
      edges = edges + 1 | 0;
    }
    if (xml.t1l_1 === 'polygon') {
      this_2.y5();
    }
    tmp_0.d5x_1 = this_2;
  }
  g5r(c) {
    c.m4m();
    c.s56(this.d5x_1);
  }
}
class LineSvgElement extends SvgElement {
  constructor($outer, xml, $box) {
    if ($box === VOID)
      $box = {};
    $box.t5x_1 = $outer;
    super($outer, xml, $box);
    this.p5x_1 = xml.v1m('x1');
    this.q5x_1 = xml.v1m('y1');
    this.r5x_1 = xml.v1m('x2');
    this.s5x_1 = xml.v1m('y2');
  }
  g5r(c) {
    c.m4m();
    c.b3e(Vector2D.l28(this.p5x_1, this.q5x_1));
    c.d3e(Vector2D.l28(this.r5x_1, this.s5x_1));
  }
}
class TextSvgElement extends SvgElement {
  constructor($outer, xml, $box) {
    if ($box === VOID)
      $box = {};
    $box.j5y_1 = $outer;
    super($outer, xml, $box);
    var tmp = this;
    // Inline function 'kotlin.text.trim' call
    var this_0 = xml.p1m();
    tmp.e5y_1 = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    this.f5y_1 = xml.x1m('x');
    this.g5y_1 = xml.x1m('dx');
    this.h5y_1 = xml.x1m('y');
    this.i5y_1 = xml.x1m('dy');
  }
  g5r(c) {
  }
  t5u(c) {
    c.n5o(this.e5y_1, Vector2D.y2a(this.f5y_1 + this.g5y_1, this.h5y_1 + this.i5y_1));
  }
}
class PathSvgElement extends SvgElement {
  constructor($outer, xml, $box) {
    if ($box === VOID)
      $box = {};
    $box.x5s_1 = $outer;
    super($outer, xml, $box);
    this.v5s_1 = xml.b1n('d');
    var tmp = this;
    tmp.w5s_1 = lazy(SVG$PathSvgElement$path$delegate$lambda(this));
    var tmp396_safe_receiver = this.x5s_1.c5t_1;
    if (tmp396_safe_receiver == null)
      null;
    else
      tmp396_safe_receiver("Parsed SVG Path: '" + toSvgPathString_0(this.m22()) + "'");
    var tmp397_safe_receiver = this.x5s_1.c5t_1;
    if (tmp397_safe_receiver == null)
      null;
    else
      tmp397_safe_receiver("Original SVG Path: '" + this.v5s_1 + "'");
    var tmp398_safe_receiver = this.x5s_1.c5t_1;
    if (tmp398_safe_receiver == null)
      null;
    else
      tmp398_safe_receiver('Points: ' + toString_0(get_cachedPoints(this.m22())));
  }
  m22() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w5s_1;
    path$factory();
    return this_0.o1();
  }
  g5r(c) {
    c.m4m();
    write(c, this.m22());
  }
}
class CSSDeclarations {
  constructor() {
    this.a5t_1 = LinkedHashMap.ac();
  }
  f1k(str) {
    return this.k5y(Companion_instance_6.a1i(str));
  }
  k5y(_this__u8e3s4) {
    while (!get_eof(_this__u8e3s4)) {
      this.l5y(_this__u8e3s4);
    }
    return this;
  }
  l5y(_this__u8e3s4) {
    skipSpaces(_this__u8e3s4);
    var id = this.m5y(_this__u8e3s4);
    skipSpaces(_this__u8e3s4);
    skipExpect(_this__u8e3s4, _Char___init__impl__6a9atx(58));
    skipSpaces(_this__u8e3s4);
    // Inline function 'kotlin.text.trim' call
    // Inline function 'korlibs.util.readUntilBuilder' call
    var out = StringBuilder.f();
    $l$loop: while (_this__u8e3s4.s1g()) {
      var c = _this__u8e3s4.r1h();
      // Inline function 'korlibs.image.vector.format.CSSDeclarations.parseCssDecl.<anonymous>' call
      if (c === _Char___init__impl__6a9atx(59)) {
        if (false) {
          _this__u8e3s4.s1h();
          out.ob(c);
        }
        break $l$loop;
      }
      _this__u8e3s4.s1h();
      out.ob(c);
    }
    var this_0 = out.toString();
    var value = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    // Inline function 'kotlin.collections.set' call
    this.a5t_1.f3(id, value);
    if (!get_eof(_this__u8e3s4)) {
      skipExpect(_this__u8e3s4, _Char___init__impl__6a9atx(59));
    }
  }
  m5y(_this__u8e3s4) {
    // Inline function 'korlibs.util.readWhileBuilder' call
    // Inline function 'korlibs.util.readUntilBuilder' call
    var out = StringBuilder.f();
    $l$loop: while (_this__u8e3s4.s1g()) {
      var c = _this__u8e3s4.r1h();
      // Inline function 'korlibs.util.readWhileBuilder.<anonymous>' call
      // Inline function 'korlibs.image.vector.format.CSSDeclarations.readCssId.<anonymous>' call
      if (!(isLetterOrDigit(c) || c === _Char___init__impl__6a9atx(45))) {
        if (false) {
          _this__u8e3s4.s1h();
          out.ob(c);
        }
        break $l$loop;
      }
      _this__u8e3s4.s1h();
      out.ob(c);
    }
    return out.toString();
  }
}
class Companion_39 {
  constructor() {
    Companion_instance_48 = this;
    this.c5u_1 = Companion_getInstance_15().c1h('SVG');
    this.d5u_1 = new WithDefault(Colors_getInstance().n3x_1);
  }
  e5u(node) {
    var out = toMutableMap(node.p1l_1);
    var tmp399_safe_receiver = node.k10('style');
    if (tmp399_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      out.h3(Companion_instance_47.z5s(tmp399_safe_receiver));
    }
    return out;
  }
}
class PathTokenNumber {
  constructor(value) {
    this.n5y_1 = value;
  }
  toString() {
    return 'PathTokenNumber(value=' + this.n5y_1 + ')';
  }
  hashCode() {
    return getNumberHashCode(this.n5y_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PathTokenNumber))
      return false;
    var tmp0_other_with_cast = other instanceof PathTokenNumber ? other : THROW_CCE();
    if (!equals(this.n5y_1, tmp0_other_with_cast.n5y_1))
      return false;
    return true;
  }
}
class PathTokenCmd {
  constructor(id) {
    this.o5y_1 = id;
  }
  toString() {
    return 'PathTokenCmd(id=' + toString_1(this.o5y_1) + ')';
  }
  hashCode() {
    return Char__hashCode_impl_otmys(this.o5y_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PathTokenCmd))
      return false;
    var tmp0_other_with_cast = other instanceof PathTokenCmd ? other : THROW_CCE();
    if (!(this.o5y_1 === tmp0_other_with_cast.o5y_1))
      return false;
    return true;
  }
}
class SVG {
  static t5y(root, warningProcessor) {
    Companion_getInstance_56();
    warningProcessor = warningProcessor === VOID ? null : warningProcessor;
    var $this = createThis(this);
    $this.b5t_1 = root;
    $this.c5t_1 = warningProcessor;
    $this.d5t_1 = $this.b5t_1.y1m('x', 0);
    $this.e5t_1 = $this.b5t_1.y1m('y', 0);
    $this.f5t_1 = $this.b5t_1.u1m('width', 128.0);
    $this.g5t_1 = $this.b5t_1.u1m('height', 128.0);
    var tmp = $this;
    var tmp0_elvis_lhs = $this.b5t_1.k10('viewBox');
    tmp.h5t_1 = tmp0_elvis_lhs == null ? '0 0 ' + $this.f5t_1 + ' ' + $this.g5t_1 : tmp0_elvis_lhs;
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = split_0($this.h5t_1, charArrayOf([_Char___init__impl__6a9atx(32)]));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.format.SVG.viewBoxNumbers.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      var tmp$ret$0 = toString_0(trim(isCharSequence(item) ? item : THROW_CCE()));
      var tmp0_elvis_lhs_0 = toDoubleOrNull(tmp$ret$0);
      var tmp$ret$1 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
      destination.h(tmp$ret$1);
    }
    tmp_0.i5t_1 = destination;
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.getOrElse' call
    var this_1 = $this.i5t_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp_2;
    if (0 <= 0 ? 0 < this_1.d1() : false) {
      tmp_2 = this_1.f1(0);
    } else {
      // Inline function 'korlibs.image.vector.format.SVG.viewBoxRectangle.<anonymous>' call
      tmp_2 = 0.0;
    }
    var tmp_3 = tmp_2;
    // Inline function 'kotlin.collections.getOrElse' call
    var this_2 = $this.i5t_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp_4;
    if (0 <= 1 ? 1 < this_2.d1() : false) {
      tmp_4 = this_2.f1(1);
    } else {
      // Inline function 'korlibs.image.vector.format.SVG.viewBoxRectangle.<anonymous>' call
      tmp_4 = 0.0;
    }
    var tmp_5 = tmp_4;
    // Inline function 'kotlin.collections.getOrElse' call
    var this_3 = $this.i5t_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp_6;
    if (0 <= 2 ? 2 < this_3.d1() : false) {
      tmp_6 = this_3.f1(2);
    } else {
      // Inline function 'korlibs.image.vector.format.SVG.viewBoxRectangle.<anonymous>' call
      tmp_6 = $this.f5t_1;
    }
    var tmp_7 = tmp_6;
    // Inline function 'kotlin.collections.getOrElse' call
    var this_4 = $this.i5t_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp_8;
    if (0 <= 3 ? 3 < this_4.d1() : false) {
      tmp_8 = this_4.f1(3);
    } else {
      // Inline function 'korlibs.image.vector.format.SVG.viewBoxRectangle.<anonymous>' call
      tmp_8 = $this.g5t_1;
    }
    var tmp$ret$11 = tmp_8;
    tmp_1.j5t_1 = new Rectangle(tmp_3, tmp_5, tmp_7, tmp$ret$11);
    var tmp_9 = $this;
    tmp_9.k5t_1 = lazy(SVG$defs$delegate$lambda($this));
    var tmp_10 = $this;
    tmp_10.l5t_1 = lazy(SVG$cssList$delegate$lambda($this));
    var tmp_11 = $this;
    tmp_11.m5t_1 = lazy(SVG$cssCombined$delegate$lambda($this));
    var tmp_12 = $this;
    tmp_12.n5t_1 = lazy(SVG$_dom$delegate$lambda($this));
    var tmp_13 = $this;
    tmp_13.o5t_1 = lazy(SVG$dom$delegate$lambda($this));
    var tmp_14 = $this;
    tmp_14.p5t_1 = lazy(SVG$renderElement$delegate$lambda($this));
    var tmp_15 = $this;
    tmp_15.q5t_1 = lazy(SVG$animator$delegate$lambda($this));
    return $this;
  }
  static u5y(str) {
    Companion_getInstance_56();
    return this.t5y(Xml(str));
  }
  toString() {
    return 'SVG(' + this.w2i() + ', ' + this.x2i() + ')';
  }
  w2i() {
    return numberToInt(this.j5t_1.o26_1);
  }
  x2i() {
    return numberToInt(this.j5t_1.p26_1);
  }
  w5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.k5t_1;
    defs$factory();
    return this_0.o1();
  }
  p5y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.l5t_1;
    cssList$factory();
    return this_0.o1();
  }
  q5y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m5t_1;
    cssCombined$factory();
    return this_0.o1();
  }
  s5y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o5t_1;
    dom$factory();
    return this_0.o1();
  }
  r5y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p5t_1;
    renderElement$factory();
    return this_0.o1();
  }
  q5u(xml) {
    var nodeName = xml.t1l_1;
    var tmp;
    switch (nodeName) {
      case 'g':
      case 'a':
      case 'svg':
        tmp = new SvgElement(this, xml);
        break;
      case 'defs':
        tmp = null;
        break;
      case '_text_':
        tmp = null;
        break;
      case '_comment_':
        tmp = null;
        break;
      case 'title':
        tmp = null;
        break;
      case 'rect':
        tmp = new RectSvgElement(this, xml);
        break;
      case 'circle':
        tmp = new CircleSvgElement(this, xml);
        break;
      case 'ellipse':
        tmp = new EllipseSvgElement(this, xml);
        break;
      case 'polyline':
      case 'polygon':
        tmp = new PolySvgElement(this, xml);
        break;
      case 'line':
        tmp = new LineSvgElement(this, xml);
        break;
      case 'text':
        tmp = new TextSvgElement(this, xml);
        break;
      case 'path':
        tmp = new PathSvgElement(this, xml);
        break;
      default:
        var tmp385_safe_receiver = this.c5t_1;
        if (tmp385_safe_receiver == null)
          null;
        else
          tmp385_safe_receiver("Unhandled SVG node '" + nodeName + "'");
        tmp = null;
        break;
    }
    return tmp;
  }
  q4q(c) {
    // Inline function 'korlibs.image.vector.Context2d.keep' call
    c.f4o();
    try {
      // Inline function 'korlibs.image.vector.format.SVG.draw.<anonymous>' call
      c.u5o(NonePaint_instance);
      c.w4g(new RGBA(Colors_getInstance().n3x_1));
      this.r5y().q4q(c);
    }finally {
      c.n4o();
    }
  }
}
class SvgPath {
  v5y(d, warningProcessor) {
    var t = new Float64Array(6);
    var out = new VectorPath();
    var tokens = this.w5y(d);
    var tl = new ListReader(tokens);
    out.b3e(Vector2D.l28(0.0, 0.0));
    var lastCX = 0.0;
    var lastCY = 0.0;
    var lastCmd = _Char___init__impl__6a9atx(45);
    $l$loop_0: while (tl.s1g()) {
      var tmp0_elvis_lhs = parse$readNextTokenCmd(tl, warningProcessor, tokens);
      var tmp;
      var tmp_0 = tmp0_elvis_lhs;
      if ((tmp_0 == null ? null : new Char(tmp_0)) == null) {
        break $l$loop_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var cmd = tmp;
      if (cmd === _Char___init__impl__6a9atx(0) || isWhitespaceFast(cmd))
        continue $l$loop_0;
      var relative = _Char___init__impl__6a9atx(97) <= cmd ? cmd <= _Char___init__impl__6a9atx(122) : false;
      var tmp403_subject = lastCmd;
      var lastCurve = tmp403_subject === _Char___init__impl__6a9atx(83) || tmp403_subject === _Char___init__impl__6a9atx(67) || (tmp403_subject === _Char___init__impl__6a9atx(84) || tmp403_subject === _Char___init__impl__6a9atx(81)) || (tmp403_subject === _Char___init__impl__6a9atx(115) || tmp403_subject === _Char___init__impl__6a9atx(99) || (tmp403_subject === _Char___init__impl__6a9atx(116) || tmp403_subject === _Char___init__impl__6a9atx(113))) ? true : false;
      if (cmd === _Char___init__impl__6a9atx(77) || cmd === _Char___init__impl__6a9atx(109)) {
        out.f3o(Vector2D.l28(parse$n(tl, warningProcessor, tokens), parse$n(tl, warningProcessor, tokens)), relative);
        while (parse$isNextNumber(tl))
          out.e3o(Vector2D.l28(parse$n(tl, warningProcessor, tokens), parse$n(tl, warningProcessor, tokens)), relative);
      } else if (cmd === _Char___init__impl__6a9atx(76) || cmd === _Char___init__impl__6a9atx(108))
        while (parse$isNextNumber(tl))
          out.e3o(Vector2D.l28(parse$n(tl, warningProcessor, tokens), parse$n(tl, warningProcessor, tokens)), relative);
      else if (cmd === _Char___init__impl__6a9atx(72) || cmd === _Char___init__impl__6a9atx(104))
        while (parse$isNextNumber(tl))
          out.g3o(parse$n(tl, warningProcessor, tokens), relative);
      else if (cmd === _Char___init__impl__6a9atx(86) || cmd === _Char___init__impl__6a9atx(118))
        while (parse$isNextNumber(tl))
          out.h3o(parse$n(tl, warningProcessor, tokens), relative);
      else if (cmd === _Char___init__impl__6a9atx(81) || cmd === _Char___init__impl__6a9atx(113))
        while (parse$isNextNumber(tl)) {
          var cx = parse$nX(out, tl, warningProcessor, tokens, relative);
          var cy = parse$nY(out, tl, warningProcessor, tokens, relative);
          var x2 = parse$nX(out, tl, warningProcessor, tokens, relative);
          var y2 = parse$nY(out, tl, warningProcessor, tokens, relative);
          lastCX = cx;
          lastCY = cy;
          out.e3e(Vector2D.l28(cx, cy), Vector2D.l28(x2, y2));
        }
       else if (cmd === _Char___init__impl__6a9atx(67) || cmd === _Char___init__impl__6a9atx(99))
        while (parse$isNextNumber(tl)) {
          var x1 = parse$nX(out, tl, warningProcessor, tokens, relative);
          var y1 = parse$nY(out, tl, warningProcessor, tokens, relative);
          var x2_0 = parse$nX(out, tl, warningProcessor, tokens, relative);
          var y2_0 = parse$nY(out, tl, warningProcessor, tokens, relative);
          var x = parse$nX(out, tl, warningProcessor, tokens, relative);
          var y = parse$nY(out, tl, warningProcessor, tokens, relative);
          lastCX = x2_0;
          lastCY = y2_0;
          out.g3e(Vector2D.l28(x1, y1), Vector2D.l28(x2_0, y2_0), Vector2D.l28(x, y));
        }
       else if (cmd === _Char___init__impl__6a9atx(83) || cmd === _Char___init__impl__6a9atx(115)) {
        while (parse$isNextNumber(tl)) {
          var x2_1 = parse$nX(out, tl, warningProcessor, tokens, relative);
          var y2_1 = parse$nY(out, tl, warningProcessor, tokens, relative);
          var x_0 = parse$nX(out, tl, warningProcessor, tokens, relative);
          var y_0 = parse$nY(out, tl, warningProcessor, tokens, relative);
          var x1_0 = lastCurve ? out.p3e_1.c26_1 * 2 - lastCX : out.p3e_1.c26_1;
          var y1_0 = lastCurve ? out.p3e_1.d26_1 * 2 - lastCY : out.p3e_1.d26_1;
          lastCX = x2_1;
          lastCY = y2_1;
          out.g3e(Vector2D.l28(x1_0, y1_0), Vector2D.l28(x2_1, y2_1), Vector2D.l28(x_0, y_0));
          lastCurve = true;
        }
      } else if (cmd === _Char___init__impl__6a9atx(84) || cmd === _Char___init__impl__6a9atx(116)) {
        var n = 0;
        while (parse$isNextNumber(tl)) {
          var x2_2 = parse$nX(out, tl, warningProcessor, tokens, relative);
          var y2_2 = parse$nY(out, tl, warningProcessor, tokens, relative);
          var cx_0 = lastCurve ? out.p3e_1.c26_1 * 2 - lastCX : out.p3e_1.c26_1;
          var cy_0 = lastCurve ? out.p3e_1.d26_1 * 2 - lastCY : out.p3e_1.d26_1;
          lastCX = cx_0;
          lastCY = cy_0;
          out.e3e(Vector2D.l28(cx_0, cy_0), Vector2D.l28(x2_2, y2_2));
          n = n + 1 | 0;
          lastCurve = true;
        }
      } else if (cmd === _Char___init__impl__6a9atx(65) || cmd === _Char___init__impl__6a9atx(97)) {
        var EPSILON = 1.0E-6;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = parse$readNumber(tl, warningProcessor, tokens);
        var rx = Math.abs(this_0);
        // Inline function 'kotlin.math.absoluteValue' call
        var this_1 = parse$readNumber(tl, warningProcessor, tokens);
        var ry = Math.abs(this_1);
        var rotx = parse$readNumber(tl, warningProcessor, tokens) / 180.0 * 3.141592653589793;
        var tmp_1;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_2 = parse$readNumber(tl, warningProcessor, tokens);
        if (Math.abs(this_2) > EPSILON) {
          tmp_1 = 1;
        } else {
          tmp_1 = 0;
        }
        var fa = tmp_1;
        var tmp_2;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_3 = parse$readNumber(tl, warningProcessor, tokens);
        if (Math.abs(this_3) > EPSILON) {
          tmp_2 = 1;
        } else {
          tmp_2 = 0;
        }
        var fs = tmp_2;
        var x1_1 = out.p3e_1.c26_1;
        var y1_1 = out.p3e_1.d26_1;
        var x2_3 = parse$nX(out, tl, warningProcessor, tokens, relative);
        var y2_3 = parse$nY(out, tl, warningProcessor, tokens, relative);
        var dx = x1_1 - x2_3;
        var dy = y1_1 - y2_3;
        // Inline function 'kotlin.math.hypot' call
        var x_1 = dx;
        var y_1 = dy;
        var d_0 = hypot(x_1, y_1);
        if (d_0 < EPSILON || rx < EPSILON || ry < EPSILON) {
          out.d3e(Vector2D.l28(x2_3, y2_3));
        } else {
          // Inline function 'kotlin.math.sin' call
          var sinrx = Math.sin(rotx);
          // Inline function 'kotlin.math.cos' call
          var cosrx = Math.cos(rotx);
          var x1p = cosrx * dx / 2.0 + sinrx * dy / 2.0;
          var y1p = -sinrx * dx / 2.0 + cosrx * dy / 2.0;
          var d_1 = sqr(this, x1p) / sqr(this, rx) + sqr(this, y1p) / sqr(this, ry);
          if (d_1 > 1) {
            d_1 = sqr(this, d_1);
            rx = rx * d_1;
            ry = ry * d_1;
          }
          var s = 0.0;
          var sa = sqr(this, rx) * sqr(this, ry) - sqr(this, rx) * sqr(this, y1p) - sqr(this, ry) * sqr(this, x1p);
          var sb = sqr(this, rx) * sqr(this, y1p) + sqr(this, ry) * sqr(this, x1p);
          if (sa < 0.0)
            sa = 0.0;
          if (sb > 0.0) {
            // Inline function 'kotlin.math.sqrt' call
            var x_2 = sa / sb;
            s = Math.sqrt(x_2);
          }
          if (fa === fs)
            s = -s;
          var cxp = s * rx * y1p / ry;
          var cyp = s * -ry * x1p / rx;
          var cx_1 = (x1_1 + x2_3) / 2.0 + cosrx * cxp - sinrx * cyp;
          var cy_1 = (y1_1 + y2_3) / 2.0 + sinrx * cxp + cosrx * cyp;
          var ux = (x1p - cxp) / rx;
          var uy = (y1p - cyp) / ry;
          var vx = (-x1p - cxp) / rx;
          var vy = (-y1p - cyp) / ry;
          var a1 = vecang(this, 1.0, 0.0, ux, uy);
          var da = vecang(this, ux, uy, vx, vy);
          if (fs === 0 && da > 0)
            da = da - 2 * 3.141592653589793;
          else if (fs === 1 && da < 0)
            da = da + 2 * 3.141592653589793;
          t[0] = cosrx;
          t[1] = sinrx;
          t[2] = -sinrx;
          t[3] = cosrx;
          t[4] = cx_1;
          t[5] = cy_1;
          // Inline function 'kotlin.math.abs' call
          var x_3 = da;
          var tmp$ret$8 = Math.abs(x_3);
          var ndivs = numberToInt(tmp$ret$8 / (3.141592653589793 * 0.5) + 1.0);
          var hda = da / ndivs / 2.0;
          // Inline function 'kotlin.math.abs' call
          var tmp_3 = 4.0 / 3.0;
          // Inline function 'kotlin.math.cos' call
          var tmp_4 = tmp_3 * (1.0 - Math.cos(hda));
          // Inline function 'kotlin.math.sin' call
          var x_4 = tmp_4 / Math.sin(hda);
          var kappa = Math.abs(x_4);
          if (da < 0.0)
            kappa = -kappa;
          var ptanx = 0.0;
          var ptany = 0.0;
          var px = 0.0;
          var py = 0.0;
          var inductionVariable = 0;
          if (inductionVariable <= ndivs)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var a = a1 + da * (i / ndivs);
              // Inline function 'kotlin.math.cos' call
              dx = Math.cos(a);
              // Inline function 'kotlin.math.sin' call
              dy = Math.sin(a);
              var x_5 = xformPointX(this, dx * rx, dy * ry, t);
              var y_2 = xformPointY(this, dx * rx, dy * ry, t);
              var tanx = xformVecX(this, -dy * rx * kappa, dx * ry * kappa, t);
              var tany = xformVecY(this, -dy * rx * kappa, dx * ry * kappa, t);
              if (i > 0) {
                out.g3e(Vector2D.l28(px + ptanx, py + ptany), Vector2D.l28(x_5 - tanx, y_2 - tany), Vector2D.l28(x_5, y_2));
              }
              px = x_5;
              py = y_2;
              ptanx = tanx;
              ptany = tany;
            }
             while (!(i === ndivs));
          out.p3e_1 = Vector2D.l28(x2_3, y2_3);
        }
      } else if (cmd === _Char___init__impl__6a9atx(90) || cmd === _Char___init__impl__6a9atx(122)) {
        out.y5();
      } else {
        // Inline function 'kotlin.TODO' call
        var reason = "Unsupported command '" + toString_1(cmd) + "' (" + Char__toInt_impl_vasixd(cmd) + ") : Parsed: '" + toSvgPathString_0(out) + "', Original: '" + d + "'";
        throw NotImplementedError.nd('An operation is not implemented: ' + reason);
      }
      lastCmd = cmd;
    }
    return out;
  }
  y5s(d, warningProcessor, $super) {
    warningProcessor = warningProcessor === VOID ? null : warningProcessor;
    return $super === VOID ? this.v5y(d, warningProcessor) : $super.v5y.call(this, d, warningProcessor);
  }
  w5y(str) {
    var sr = Companion_instance_6.a1i(str);
    // Inline function 'kotlin.collections.arrayListOf' call
    var out = ArrayList.i1();
    while (sr.s1g()) {
      tokenizePath$skipSeparators(sr);
      var c = sr.r1h();
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp;
      if ((_Char___init__impl__6a9atx(48) <= c ? c <= _Char___init__impl__6a9atx(57) : false) || c === _Char___init__impl__6a9atx(45) || c === _Char___init__impl__6a9atx(43) || c === _Char___init__impl__6a9atx(46)) {
        tmp = new PathTokenNumber(tokenizePath$readNumber(sr));
      } else {
        tmp = new PathTokenCmd(sr.s1h());
      }
      var element = tmp;
      out.h(element);
    }
    return out;
  }
  i5r(path, separator, decimalPlaces) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var parts = ArrayList.i1();
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.j3e_1;
    var n_0 = 0;
    while (n_0 < this_0.d1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.s1i(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.k3e_1.f1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.l28(tmp, path.k3e_1.f1(_unary__edvuaz_1));
          var x = destruct.bl();
          var y = destruct.cl();
          // Inline function 'kotlin.collections.plusAssign' call

          var element = 'M' + toSvgPathString$fixX(x, decimalPlaces) + ' ' + toSvgPathString$fixY(y, decimalPlaces);
          parts.h(element);
          break;
        case 1:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.k3e_1.f1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.l28(tmp_0, path.k3e_1.f1(_unary__edvuaz_3));
          var x_0 = destruct_0.bl();
          var y_0 = destruct_0.cl();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_0 = 'L' + toSvgPathString$fixX(x_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y_0, decimalPlaces);
          parts.h(element_0);
          break;
        case 2:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.k3e_1.f1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.l28(tmp_1, path.k3e_1.f1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.k3e_1.f1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.l28(tmp_2, path.k3e_1.f1(_unary__edvuaz_7));
          var x1 = destruct_1.bl();
          var y1 = destruct_1.cl();
          var x2 = destruct_2.bl();
          var y2 = destruct_2.cl();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_1 = 'Q' + toSvgPathString$fixX(x1, decimalPlaces) + ' ' + toSvgPathString$fixY(y1, decimalPlaces) + ', ' + toSvgPathString$fixX(x2, decimalPlaces) + ' ' + toSvgPathString$fixY(y2, decimalPlaces);
          parts.h(element_1);
          break;
        case 3:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.k3e_1.f1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.l28(tmp_3, path.k3e_1.f1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.k3e_1.f1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.l28(tmp_4, path.k3e_1.f1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.k3e_1.f1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.l28(tmp_5, path.k3e_1.f1(_unary__edvuaz_13));
          var x1_0 = destruct_3.bl();
          var y1_0 = destruct_3.cl();
          var x2_0 = destruct_4.bl();
          var y2_0 = destruct_4.cl();
          var x3 = destruct_5.bl();
          var y3 = destruct_5.cl();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_2 = 'C' + toSvgPathString$fixX(x1_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y1_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x2_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y2_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x3, decimalPlaces) + ' ' + toSvgPathString$fixY(y3, decimalPlaces);
          parts.h(element_2);
          break;
        case 4:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          // Inline function 'kotlin.collections.plusAssign' call

          parts.h('Z');
          break;
      }
    }
    return joinToString(parts, '');
  }
}
class Rasterizer extends RastScale {
  constructor() {
    super();
    this.a5n_1 = false;
    this.b5n_1 = 2;
    this.c5n_1 = 1;
    this.d5n_1 = new PolygonScanline();
    this.e5n_1 = new PolygonScanline();
    this.f5n_1 = new IntSegmentSet();
    this.g5n_1 = new IntSegmentSet();
    this.h5n_1 = new IntSegmentSet();
    this.i5n_1 = IntArrayList.x2j(1024);
  }
  d2q() {
    this.d5n_1.d2q();
    this.e5n_1.d2q();
  }
  x5y(bounds, quality, stats, winding, callback) {
    if (stats == null)
      null;
    else {
      stats.d2q();
    }
    var xmin = this.u3k(bounds.t26());
    var xmax = this.u3k(bounds.u26());
    var tempRect = this.d5n_1.s3a();
    // Inline function 'kotlin.math.max' call
    var a = bounds.v26();
    var b = tempRect.v26();
    var tmp$ret$0 = Math.max(a, b);
    var startY = this.u3k(tmp$ret$0);
    // Inline function 'kotlin.math.min' call
    var a_0 = bounds.w26();
    var b_0 = tempRect.w26();
    var tmp$ret$1 = Math.min(a_0, b_0);
    var endY = this.u3k(tmp$ret$1);
    var func = Rasterizer$rasterizeFill$lambda(xmax, xmin, this, callback);
    this.i5n_1.y2();
    var q = quality;
    var yCount = imul(((endY - startY | 0) / this.m3l() | 0) + 1 | 0, q);
    var inductionVariable = 0;
    var last = (yCount + q | 0) - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = startY + ((imul(n, this.m3l()) / this.c5n_1 | 0) / q | 0) | 0;
        this.i5n_1.d2k(y);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>' call
    var edgesEmitted = 0;
    var edgesChecked = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.i5n_1;
    var n_0 = 0;
    while (n_0 < this_0.d1()) {
      // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      var y_0 = this_0.s1i(_unary__edvuaz);
      this.d5n_1.h3l(y_0, winding, this.f5n_1);
      edgesChecked = edgesChecked + this.d5n_1.s3k_1 | 0;
      if (this.e5n_1.m28()) {
        this.e5n_1.h3l(y_0, this.e5n_1.d3k_1, this.g5n_1);
        edgesChecked = edgesChecked + this.e5n_1.s3k_1 | 0;
        this.h5n_1.i38(this.f5n_1, this.g5n_1);
      }
      // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
      var this_1 = this.e5n_1.m28() ? this.h5n_1 : this.f5n_1;
      var inductionVariable_0 = 0;
      var last_0 = this_1.d1();
      if (inductionVariable_0 < last_0)
        do {
          var n_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>.<anonymous>' call
          func(this_1.a38_1.s1i(n_1), this_1.b38_1.s1i(n_1), y_0);
          edgesEmitted = edgesEmitted + 1 | 0;
        }
         while (inductionVariable_0 < last_0);
    }
    var tmp;
    if (stats == null) {
      tmp = null;
    } else {
      stats.b5z(edgesChecked, edgesEmitted, yCount);
      tmp = Unit_instance;
    }
  }
  j5n(bounds, quality, stats, winding, callback, $super) {
    quality = quality === VOID ? this.b5n_1 : quality;
    stats = stats === VOID ? null : stats;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.x5y(bounds, quality, stats, winding, callback);
      tmp = Unit_instance;
    } else {
      tmp = $super.x5y.call(this, bounds, quality, stats, winding, callback);
    }
    return tmp;
  }
}
class DummyRenderer extends Renderer {
  constructor(width, height) {
    Companion_getInstance_57();
    super();
    this.e5z_1 = width;
    this.f5z_1 = height;
  }
  w2i() {
    return this.e5z_1;
  }
  x2i() {
    return this.f5z_1;
  }
}
class Companion_40 extends DummyRenderer {
  constructor() {
    Companion_instance_49 = null;
    super(128, 128);
    Companion_instance_49 = this;
  }
}
class HtmlCanvas {
  n3u(width, height) {
    if (Companion_getInstance_11().f1f()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on Node.JS';
      throw IllegalStateException.s4(toString_0(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var out = document.createElement('canvas');
    out.width = width;
    out.height = height;
    return toLike(out);
  }
}
class HtmlImage {
  b60(width, height) {
    return HtmlCanvas_instance.n3u(width, height);
  }
  c60(bmpData, bmpWidth, bmpHeight, canvas) {
    var pixelCount = _RgbaArray___get_size__impl__imxef8(bmpData);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    var idata = ctx.createImageData(bmpWidth, bmpHeight);
    var idataData = idata.data;
    var m = 0;
    var inductionVariable = 0;
    if (inductionVariable < pixelCount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = RgbaArray__get_impl_nzyo1o(bmpData, n);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz = m;
        m = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz] = _RGBA___get_r__impl__duz7mo(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_0 = m;
        m = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_0] = _RGBA___get_g__impl__o8pukr(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_1 = m;
        m = _unary__edvuaz_1 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_1] = _RGBA___get_b__impl__m6tl80(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_2 = m;
        m = _unary__edvuaz_2 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_2] = _RGBA___get_a__impl__6msvu7(c);
      }
       while (inductionVariable < pixelCount);
    ctx.putImageData(idata, 0.0, 0.0);
    return canvas;
  }
  d60(bmp, canvas) {
    return this.c60(_RgbaArray___init__impl__oib4y4(bmp.h47().v3v_1), bmp.f3w_1, bmp.g3w_1, canvas);
  }
  g5z(bmp) {
    return this.d60(bmp, this.b60(bmp.f3w_1, bmp.g3w_1));
  }
}
class NonBrowserNativeImageFormatProvider extends BaseNativeImageFormatProvider {
  constructor() {
    NonBrowserNativeImageFormatProvider_instance = null;
    super();
    NonBrowserNativeImageFormatProvider_instance = this;
  }
}
class HtmlNativeImageFormatProvider extends NativeImageFormatProvider {
  constructor() {
    HtmlNativeImageFormatProvider_instance = null;
    super();
    HtmlNativeImageFormatProvider_instance = this;
  }
  f5b(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_2.bind(VOID, this, data, props), $completion);
  }
  y5b(vfs, path, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_3.bind(VOID, this, vfs, path, props), $completion);
  }
  f4a(width, height, premultiplied) {
    return HtmlNativeImage.a60(HtmlCanvas_instance.n3u(width, height));
  }
  e4a(bmp) {
    return HtmlNativeImage.a60(HtmlImage_instance.g5z(bmp.r3w()));
  }
}
class HtmlNativeImage extends NativeImage {
  static j60(texSourceBase, width, height) {
    var $this = this.d4a(width, height, texSourceBase, true);
    $this.v5z_1 = texSourceBase;
    $this.w5z_1 = $this.v5z_1;
    var tmp = $this;
    tmp.x5z_1 = lazy(HtmlNativeImage$lazyCanvasElement$delegate$lambda($this, width, height));
    var tmp_0 = $this;
    tmp_0.y5z_1 = lazy(HtmlNativeImage$ctx$delegate$lambda($this));
    $this.z5z_1 = Monotonic_instance.aj();
    return $this;
  }
  l3() {
    return 'HtmlNativeImage';
  }
  static g60(img) {
    return this.j60(img, img.width, img.height);
  }
  static a60(canvas) {
    return this.j60(canvas, canvas.width, canvas.height);
  }
  i60() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x5z_1;
    lazyCanvasElement$factory();
    return this_0.o1();
  }
  k60() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y5z_1;
    ctx$factory();
    return this_0.o1();
  }
  c3x(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var tmp = this.v5z_1;
    if (tmp instanceof HTMLVideoElement) {
      var now = Monotonic_instance.aj();
      var elapsedTime = ValueTimeMark__minus_impl_f87sko(now, this.z5z_1);
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$1 = toDuration(16, DurationUnit_MILLISECONDS_getInstance());
      if (Duration__compareTo_impl_pchp0f(elapsedTime, tmp$ret$1) >= 0) {
        this.z5z_1 = now;
        this.k60().clearRect(0.0, 0.0, width, height);
        this.k60().drawImage(this.v5z_1, 0.0, 0.0);
      }
    }
    var idata = this.k60().getImageData(x, y, width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(data, 0, out, offset, size);
    if (get_isBigEndian()) {
      bswap32(out, offset, size);
    }
    if (!this.m3w_1) {
      premultiply(_RgbaArray___init__impl__oib4y4(out), offset, _RgbaPremultipliedArray___init__impl__lx83hy(out), offset, imul(width, height));
    }
  }
  e3x(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var idata = this.k60().createImageData(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(out, offset, data, 0, size);
    if (!this.m3w_1) {
      depremultiply(_RgbaPremultipliedArray___init__impl__lx83hy(data), 0, _RgbaArray___init__impl__oib4y4(data), 0, imul(width, height));
    }
    if (get_isBigEndian()) {
      bswap32(data, 0, size);
    }
    this.k60().putImageData(idata, x, y);
  }
  b44(antialiasing) {
    return new Context2d(new CanvasContext2dRenderer(this.i60()));
  }
  l60(type, quality) {
    return this.i60().toDataURL(type, quality);
  }
  m60(type, quality, $super) {
    type = type === VOID ? 'image/png' : type;
    quality = quality === VOID ? null : quality;
    return $super === VOID ? this.l60(type, quality) : $super.l60.call(this, type, quality);
  }
}
class BrowserImage {
  e60(bytes, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeToCanvas__71sobd.bind(VOID, this, bytes, props), $completion);
  }
  o60(img) {
    return this.h60(img, img.width, img.height);
  }
  h60(img, width, height) {
    var canvas = HtmlCanvas_instance.n3u(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    ctx.drawImage(img, 0.0, 0.0);
    return canvas;
  }
  f60(jsUrl, props, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.uw();
    // Inline function 'korlibs.image.format.BrowserImage.loadImage.<anonymous>' call
    if (Companion_getInstance_11().f1f()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on NodeJS';
      throw IllegalStateException.s4(toString_0(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var img = document.createElement('img');
    img.onload = BrowserImage$loadImage$lambda(cancellable, img);
    img.onerror = BrowserImage$loadImage$lambda_0(cancellable, jsUrl);
    img.src = jsUrl;
    return cancellable.gu();
  }
  n60(jsUrl, props, $completion, $super) {
    props = props === VOID ? Companion_getInstance_39().p4h_1 : props;
    return $super === VOID ? this.f60(jsUrl, props, $completion) : $super.f60.call(this, jsUrl, props, $completion);
  }
  j3u(jsUrl, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loadCanvas__xw76hi.bind(VOID, this, jsUrl), $completion);
  }
}
class CanvasContext2dRenderer extends Renderer {
  constructor(canvas) {
    super();
    this.r60_1 = canvas;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s60_1 = this.r60_1.getContext('2d');
    this.t60_1 = NaN;
    this.u60_1 = null;
  }
  w2i() {
    return this.r60_1.width;
  }
  x2i() {
    return this.r60_1.height;
  }
  y60(_this__u8e3s4, paint) {
    var grad = _this__u8e3s4;
    var inductionVariable = 0;
    var last = paint.z51_1.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var stop = paint.z51_1.s1i(n);
        var color = paint.a52_1.s1i(n);
        grad.addColorStop(stop, _RGBA___get_htmlStringSimple__impl__l4nu0u(_RGBA___init__impl__lqpay5(color)));
      }
       while (inductionVariable < last);
    return _this__u8e3s4;
  }
  w60(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof NonePaint) {
      tmp = 'none';
    } else {
      if (_this__u8e3s4 instanceof RGBA) {
        tmp = _RGBA___get_htmlColor__impl__bzw5k6(_RGBA___get_color__impl__8x3sb3(_this__u8e3s4.i4d_1));
      } else {
        if (_this__u8e3s4 instanceof GradientPaint) {
          var tmp_0;
          switch (_this__u8e3s4.s51_1.k3_1) {
            case 0:
              tmp_0 = this.y60(this.s60_1.createLinearGradient(_this__u8e3s4.t51_1, _this__u8e3s4.u51_1, _this__u8e3s4.w51_1, _this__u8e3s4.x51_1), _this__u8e3s4);
              break;
            case 1:
              tmp_0 = this.y60(this.s60_1.createRadialGradient(_this__u8e3s4.t51_1, _this__u8e3s4.u51_1, _this__u8e3s4.v51_1, _this__u8e3s4.w51_1, _this__u8e3s4.x51_1, _this__u8e3s4.y51_1), _this__u8e3s4);
              break;
            case 2:
              var tmp_1;
              if (!equals(this.s60_1.createConicGradient, undefined)) {
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$1 = this.s60_1.createConicGradient(_Angle___get_radians__impl__n00yt5(_this__u8e3s4.f52_1), _this__u8e3s4.t51_1, _this__u8e3s4.u51_1);
                tmp_1 = this.y60(tmp$ret$1, _this__u8e3s4);
              } else {
                tmp_1 = 'fuchsia';
              }

              tmp_0 = tmp_1;
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          tmp = tmp_0;
        } else {
          if (_this__u8e3s4 instanceof BitmapPaint) {
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$3 = toHtmlNative(_this__u8e3s4.u5e_1).w5z_1;
            tmp = this.s60_1.createPattern(tmp$ret$3, _this__u8e3s4.m5f() && _this__u8e3s4.o5f() ? 'repeat' : _this__u8e3s4.m5f() ? 'repeat-x' : _this__u8e3s4.o5f() ? 'repeat-y' : 'no-repeat');
          } else {
            tmp = 'black';
          }
        }
      }
    }
    return tmp;
  }
  z60(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.k3_1) {
      case 0:
        tmp = 'clear';
        break;
      case 1:
        tmp = 'copy';
        break;
      case 2:
        tmp = 'source-over';
        break;
      case 3:
        tmp = 'destination-over';
        break;
      case 4:
        tmp = 'source-in';
        break;
      case 5:
        tmp = 'destination-in';
        break;
      case 6:
        tmp = 'source-out';
        break;
      case 7:
        tmp = 'destination-out';
        break;
      case 8:
        tmp = 'source-atop';
        break;
      case 9:
        tmp = 'destination-atop';
        break;
      case 10:
        tmp = 'xor';
        break;
      case 11:
        tmp = 'lighter';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  a61(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.k3_1) {
      case 0:
        tmp = 'normal';
        break;
      case 1:
        tmp = 'multiply';
        break;
      case 2:
        tmp = 'screen';
        break;
      case 3:
        tmp = 'overlay';
        break;
      case 4:
        tmp = 'darken';
        break;
      case 5:
        tmp = 'lighten';
        break;
      case 6:
        tmp = 'color-dodge';
        break;
      case 7:
        tmp = 'color-burn';
        break;
      case 8:
        tmp = 'hard-light';
        break;
      case 9:
        tmp = 'soft-light';
        break;
      case 10:
        tmp = 'difference';
        break;
      case 11:
        tmp = 'exclusion';
        break;
      case 12:
        tmp = 'hue';
        break;
      case 13:
        tmp = 'saturation';
        break;
      case 14:
        tmp = 'color';
        break;
      case 15:
        tmp = 'luminosity';
        break;
      default:
        // Inline function 'kotlin.text.lowercase' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = _this__u8e3s4.j3_1.toLowerCase();
        break;
    }
    return tmp;
  }
  v60(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof CompositeMode) {
      tmp = this.z60(_this__u8e3s4);
    } else {
      if (_this__u8e3s4 instanceof BlendMode) {
        tmp = this.a61(_this__u8e3s4);
      } else {
        tmp = 'source-over';
      }
    }
    return tmp;
  }
  x60(_this__u8e3s4, m) {
    _this__u8e3s4.transform(m.s29_1, m.t29_1, m.u29_1, m.v29_1, m.w29_1, m.x29_1);
  }
  t5n(image, pos, size, transform) {
    this.s60_1.save();
    try {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      this.s60_1.setTransform(transform.s29_1, transform.t29_1, transform.u29_1, transform.v29_1, transform.w29_1, transform.x29_1);
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp = ensureNative(image);
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = (tmp instanceof HtmlNativeImage ? tmp : THROW_CCE()).w5z_1;
      this.s60_1.drawImage(tmp$ret$2, pos.c26_1, pos.d26_1, size.h27_1, size.i27_1);
    }finally {
      this.s60_1.restore();
    }
  }
  b61(path) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.j3e_1;
    var n_0 = 0;
    while (n_0 < this_0.d1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.s1i(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.k3e_1.f1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.l28(tmp, path.k3e_1.f1(_unary__edvuaz_1));
          var x = destruct.bl();
          var y = destruct.cl();
          this.s60_1.moveTo(x, y);
          break;
        case 1:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.k3e_1.f1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.l28(tmp_0, path.k3e_1.f1(_unary__edvuaz_3));
          var x_0 = destruct_0.bl();
          var y_0 = destruct_0.cl();
          this.s60_1.lineTo(x_0, y_0);
          break;
        case 2:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.k3e_1.f1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.l28(tmp_1, path.k3e_1.f1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.k3e_1.f1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.l28(tmp_2, path.k3e_1.f1(_unary__edvuaz_7));
          var cx = destruct_1.bl();
          var cy = destruct_1.cl();
          var ax = destruct_2.bl();
          var ay = destruct_2.cl();
          this.s60_1.quadraticCurveTo(cx, cy, ax, ay);
          break;
        case 3:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.k3e_1.f1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.l28(tmp_3, path.k3e_1.f1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.k3e_1.f1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.l28(tmp_4, path.k3e_1.f1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.k3e_1.f1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.l28(tmp_5, path.k3e_1.f1(_unary__edvuaz_13));
          var cx1 = destruct_3.bl();
          var cy1 = destruct_3.cl();
          var cx2 = destruct_4.bl();
          var cy2 = destruct_4.cl();
          var ax_0 = destruct_5.bl();
          var ay_0 = destruct_5.cl();
          this.s60_1.bezierCurveTo(cx1, cy1, cx2, cy2, ax_0, ay_0);
          break;
        case 4:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          this.s60_1.closePath();
          break;
      }
    }
  }
  k5n(state, fill, winding) {
    if (state.b4g_1.g1())
      return Unit_instance;
    $l$block: {
      // Inline function 'korlibs.image.format.CanvasContext2dRenderer.keep' call
      this.s60_1.save();
      try {
        setState(this, state, fill, false);
        var clip = state.a4g_1;
        if (!(clip == null)) {
          this.s60_1.beginPath();
          this.b61(clip);
          this.s60_1.clip(this.c61(winding == null ? clip.l3e_1 : winding));
        }
        this.s60_1.beginPath();
        this.b61(state.b4g_1);
        this.x60(this.s60_1, state.z4f_1);
        if (fill) {
          transformPaint(this, state.j4g_1);
          this.s60_1.fill(this.c61(winding == null ? state.b4g_1.l3e_1 : winding));
        } else {
          transformPaint(this, state.i4g_1);
          var lineDash = state.r4g_1;
          if (!(lineDash == null)) {
            this.s60_1.lineDashOffset = state.s4g_1;
            // Inline function 'kotlin.collections.toTypedArray' call
            // Inline function 'korlibs.datastructure.mapDouble' call
            // Inline function 'kotlin.also' call
            var this_0 = DoubleArrayList.r2k();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.datastructure.mapDouble.<anonymous>' call
            var _iterator__ex2g4s = lineDash.a1();
            while (_iterator__ex2g4s.b1()) {
              var v = _iterator__ex2g4s.c1();
              // Inline function 'korlibs.image.format.CanvasContext2dRenderer.renderFinal.<anonymous>.<anonymous>' call
              this_0.t1k(v);
            }
            var tmp$ret$3 = copyToArray(this_0);
            this.s60_1.setLineDash(tmp$ret$3);
          }
          this.s60_1.stroke();
        }
        break $l$block;
      }finally {
        this.s60_1.restore();
      }
    }
  }
  c61(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.k3_1) {
      case 1:
        // Inline function 'org.w3c.dom.NONZERO' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'nonzero';
        break;
      case 0:
        // Inline function 'org.w3c.dom.EVENODD' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'evenodd';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
}
//endregion
function get_isLow(_this__u8e3s4) {
  return _this__u8e3s4.i2t() <= 0.25;
}
var GrowMethod_GROW_IMAGE_instance;
var GrowMethod_NEW_IMAGES_instance;
var GrowMethod_entriesInitialized;
function GrowMethod_initEntries() {
  if (GrowMethod_entriesInitialized)
    return Unit_instance;
  GrowMethod_entriesInitialized = true;
  GrowMethod_GROW_IMAGE_instance = new GrowMethod('GROW_IMAGE', 0);
  GrowMethod_NEW_IMAGES_instance = new GrowMethod('NEW_IMAGES', 1);
}
function reconstructWithSize($this, width, height) {
  var slices = toList($this.f3v_1);
  $this.x3u_1 = Companion_instance_0.w3e(width, height);
  $this.d3v_1 = Bitmap32.y3v(width, height, VOID, $this.z3u_1);
  $this.e3v_1.y2();
  $this.e3v_1.h($this.d3v_1);
  $this.g3v_1.y2();
  $this.f3v_1.y2();
  var _iterator__ex2g4s = slices.a1();
  while (_iterator__ex2g4s.b1()) {
    var entry = _iterator__ex2g4s.c1();
    $this.z3v(entry.v3u_1, entry.w3u_1, entry.v3u_1.n3g_1);
  }
}
function growAtlas($this, bmp) {
  switch ($this.b3v_1.k3_1) {
    case 0:
      reconstructWithSize($this, imul($this.w2i(), 2), imul($this.x2i(), 2));
      break;
    case 1:
      if (bmp.s3g_1 > $this.w2i() || bmp.t3g_1 > $this.x2i()) {
        // Inline function 'kotlin.error' call
        var message = 'Atlas is too small (' + $this.w2i() + 'x' + $this.x2i() + ') to hold a slice of (' + bmp.s3g_1 + 'x' + bmp.t3g_1 + ')';
        throw IllegalStateException.s4(toString_0(message));
      }

      $this.x3u_1 = Companion_instance_0.w3e($this.w2i(), $this.x2i());
      $this.d3v_1 = Bitmap32.y3v($this.w2i(), $this.x2i(), VOID, $this.z3u_1);
      $this.e3v_1.h($this.d3v_1);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
}
function GrowMethod_NEW_IMAGES_getInstance() {
  GrowMethod_initEntries();
  return GrowMethod_NEW_IMAGES_instance;
}
function set_baseMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var this_0 = baseMipmapLevel$delegate;
  var property = baseMipmapLevel$factory();
  var tmp0_elvis_lhs = this_0.a1j_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_baseMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = baseMipmapLevel$delegate;
    var property = baseMipmapLevel$factory_0();
    var tmp = _this__u8e3s4.z1i();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a1j_1;
      tmp_0 = tmp0_safe_receiver.d3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b1j_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a1j_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a1j_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var baseMipmapLevel$delegate;
function set_maxMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var this_0 = maxMipmapLevel$delegate;
  var property = maxMipmapLevel$factory();
  var tmp0_elvis_lhs = this_0.a1j_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_maxMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = maxMipmapLevel$delegate;
    var property = maxMipmapLevel$factory_0();
    var tmp = _this__u8e3s4.z1i();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a1j_1;
      tmp_0 = tmp0_safe_receiver.d3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b1j_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a1j_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a1j_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var maxMipmapLevel$delegate;
function Bitmap$tempInts$delegate$lambda(this$0) {
  return function () {
    return new Int32Array(imul(this$0.f3w_1, 2));
  };
}
function readPixelsUnsafe(_this__u8e3s4, x, y, width, height) {
  _init_properties_Bitmap_kt__y1ku1b();
  var out = new Int32Array(imul(width, height));
  _this__u8e3s4.c3x(x, y, width, height, out, 0);
  return out;
}
function mipmaps(_this__u8e3s4, enable) {
  enable = enable === VOID ? true : enable;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.mipmaps.<anonymous>' call
  _this__u8e3s4.q3w_1 = enable;
  return _this__u8e3s4;
}
function NativeImageContext2d(width, height, antialiased, block) {
  antialiased = antialiased === VOID ? true : antialiased;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'korlibs.image.bitmap.context2d' call
  var this_0 = NativeImage_0(width, height, true);
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = this_0.j3w_1;
  if (false) {
    this_0.s3w();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = this_0.b44(antialiased);
    try {
      // Inline function 'korlibs.image.bitmap.NativeImageContext2d.<anonymous>' call
      block(ctx);
    }finally {
      ctx.ov();
    }
  }finally {
    result = false ? this_0.u3w(rect) : 0;
  }
  return this_0;
}
function asumePremultiplied(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  _this__u8e3s4.l3w_1 = true;
  _this__u8e3s4.m3w_1 = true;
  return _this__u8e3s4;
}
function baseMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function maxMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function baseMipmapLevel$factory() {
  return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_baseMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_baseMipmapLevel(receiver, value);
  });
}
function baseMipmapLevel$factory_0() {
  return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_baseMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_baseMipmapLevel(receiver, value);
  });
}
function maxMipmapLevel$factory() {
  return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_maxMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_maxMipmapLevel(receiver, value);
  });
}
function maxMipmapLevel$factory_0() {
  return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_maxMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_maxMipmapLevel(receiver, value);
  });
}
function tempInts$factory() {
  return getPropertyCallableRef('tempInts', 1, KProperty1, function (receiver) {
    return receiver.x3w();
  }, null);
}
var properties_initialized_Bitmap_kt_sxrn69;
function _init_properties_Bitmap_kt__y1ku1b() {
  if (!properties_initialized_Bitmap_kt_sxrn69) {
    properties_initialized_Bitmap_kt_sxrn69 = true;
    baseMipmapLevel$delegate = new Property(VOID, baseMipmapLevel$delegate$lambda);
    maxMipmapLevel$delegate = new Property(VOID, maxMipmapLevel$delegate$lambda);
  }
}
function *_generator_invoke__zhh2q8($this, $this$iterator, $completion) {
  var inductionVariable = 0;
  var last = $this.k44_1.y2f();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = $this$iterator.hl(new RGBA($this.k44_1.l44(n)), $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
     while (inductionVariable < last);
  return Unit_instance;
}
var Companion_instance_8;
function Companion_getInstance_16() {
  if (Companion_instance_8 === VOID)
    new Companion();
  return Companion_instance_8;
}
function Bitmap32$iterator$slambda_0(this$0) {
  var i = new Bitmap32$iterator$slambda(this$0);
  var l = function ($this$iterator, $completion) {
    return i.t45($this$iterator, $completion);
  };
  l.$arity = 1;
  return l;
}
function isFullyTransparent(_this__u8e3s4) {
  var bmp = get_bmp(_this__u8e3s4);
  var data = _RgbaArray___init__impl__oib4y4(get_bmp(_this__u8e3s4).v3v_1);
  var width = _this__u8e3s4.u26() - _this__u8e3s4.t26() | 0;
  var inductionVariable = _this__u8e3s4.v26();
  var last = _this__u8e3s4.w26();
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var index = bmp.a3x(_this__u8e3s4.t26(), y);
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(index >= 0 && index <= (_RgbaArray___get_size__impl__imxef8(data) - width | 0))) {
        // Inline function 'korlibs.image.bitmap.isFullyTransparent.<anonymous>' call
        var message = 'left=' + _this__u8e3s4.t26() + ', top=' + _this__u8e3s4.v26() + ', right=' + _this__u8e3s4.u26() + ', bottom=' + _this__u8e3s4.w26();
        throw IllegalStateException.s4(toString_0(message));
      }
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < width)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!(_RGBA___get_a__impl__6msvu7(RgbaArray__get_impl_nzyo1o(data, index + n | 0)) === 0))
            return false;
        }
         while (inductionVariable_0 < width);
    }
     while (inductionVariable < last);
  return true;
}
function expandBorder(_this__u8e3s4, area, border) {
  return expandBorder_0(_this__u8e3s4, area.v26(), area.t26(), area.w26(), area.u26(), border);
}
function expandBorder_0(_this__u8e3s4, areaTop, areaLeft, areaBottom, areaRight, border) {
  var data = _this__u8e3s4.v3v_1;
  var x0Index = _this__u8e3s4.a3x(areaLeft, areaTop);
  var x1Index = _this__u8e3s4.a3x(areaRight - 1 | 0, areaTop);
  var areaWidth = areaRight - areaLeft | 0;
  var areaHeight = areaBottom - areaTop | 0;
  var inductionVariable = 0;
  if (inductionVariable < areaHeight)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var x0Color = data[x0Index];
      var x1Color = data[x1Index];
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < border)
        do {
          var m = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          data[(x0Index - m | 0) - 1 | 0] = x0Color;
          data[(x1Index + m | 0) + 1 | 0] = x1Color;
        }
         while (inductionVariable_0 < border);
      x0Index = x0Index + _this__u8e3s4.f3w_1 | 0;
      x1Index = x1Index + _this__u8e3s4.f3w_1 | 0;
    }
     while (inductionVariable < areaHeight);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 < border)
    do {
      var m_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var x = areaLeft - border | 0;
      var npixels = areaWidth + imul(border, 2) | 0;
      arraycopy(data, _this__u8e3s4.a3x(x, areaTop), data, _this__u8e3s4.a3x(x, (areaTop - m_0 | 0) - 1 | 0), npixels);
      arraycopy(data, _this__u8e3s4.a3x(x, areaBottom - 1 | 0), data, _this__u8e3s4.a3x(x, areaBottom + m_0 | 0), npixels);
    }
     while (inductionVariable_1 < border);
}
var Companion_instance_9;
function Companion_getInstance_17() {
  return Companion_instance_9;
}
var BitmapChannel_RED_instance;
var BitmapChannel_GREEN_instance;
var BitmapChannel_BLUE_instance;
var BitmapChannel_ALPHA_instance;
var Companion_instance_10;
function Companion_getInstance_18() {
  BitmapChannel_initEntries();
  if (Companion_instance_10 === VOID)
    new Companion_1();
  return Companion_instance_10;
}
function values() {
  return [BitmapChannel_RED_getInstance(), BitmapChannel_GREEN_getInstance(), BitmapChannel_BLUE_getInstance(), BitmapChannel_ALPHA_getInstance()];
}
var BitmapChannel_entriesInitialized;
function BitmapChannel_initEntries() {
  if (BitmapChannel_entriesInitialized)
    return Unit_instance;
  BitmapChannel_entriesInitialized = true;
  BitmapChannel_RED_instance = new BitmapChannel('RED', 0, 0);
  BitmapChannel_GREEN_instance = new BitmapChannel('GREEN', 1, 1);
  BitmapChannel_BLUE_instance = new BitmapChannel('BLUE', 2, 2);
  BitmapChannel_ALPHA_instance = new BitmapChannel('ALPHA', 3, 3);
  Companion_getInstance_18();
}
function BitmapChannel_RED_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_RED_instance;
}
function BitmapChannel_GREEN_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_GREEN_instance;
}
function BitmapChannel_BLUE_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_BLUE_instance;
}
function BitmapChannel_ALPHA_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_ALPHA_instance;
}
function get_bounds_0(_this__u8e3s4) {
  return _this__u8e3s4.k3g_1;
}
function get_bmp(_this__u8e3s4) {
  return get_container(_this__u8e3s4);
}
function get_container(_this__u8e3s4) {
  return _this__u8e3s4.s3h();
}
function slice(_this__u8e3s4, bounds, name, orientation, padding) {
  bounds = bounds === VOID ? RectangleInt.k2f(0, 0, _this__u8e3s4.f3w_1, _this__u8e3s4.g3w_1) : bounds;
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_0().z3f_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_3().d29_1 : padding;
  var left = clamp(bounds.t26(), 0, _this__u8e3s4.f3w_1);
  var top = clamp(bounds.v26(), 0, _this__u8e3s4.g3w_1);
  return new RectSlice(_this__u8e3s4, Companion_instance_3.q2e(left, top, clamp(bounds.u26(), left, _this__u8e3s4.f3w_1), clamp(bounds.w26(), top, _this__u8e3s4.g3w_1)), orientation, padding, name);
}
function extract_0(_this__u8e3s4) {
  var w = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.l3g_1) ? _this__u8e3s4.k3g_1.i2f_1 : _this__u8e3s4.k3g_1.j2f_1;
  var h = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.l3g_1) ? _this__u8e3s4.k3g_1.j2f_1 : _this__u8e3s4.k3g_1.i2f_1;
  var tmp = get_container(_this__u8e3s4).a44(w + _this__u8e3s4.m3g_1.l29() | 0, h + _this__u8e3s4.m3g_1.m29() | 0);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  var raw = extractUntransformed(_this__u8e3s4).z43(_this__u8e3s4.l3g_1);
  raw.n43(0, 0, out, _this__u8e3s4.m3g_1.h29_1, _this__u8e3s4.m3g_1.e29_1, raw.f3w_1, raw.g3w_1);
  return out;
}
function sliceWithSize(_this__u8e3s4, x, y, width, height, name, orientation, padding) {
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_0().z3f_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_3().d29_1 : padding;
  return slice(_this__u8e3s4, RectangleInt.k2f(x, y, width, height), name, orientation, padding);
}
function extractUntransformed(_this__u8e3s4) {
  var tmp = get_container(_this__u8e3s4).a44(_this__u8e3s4.k3g_1.i2f_1, _this__u8e3s4.k3g_1.j2f_1);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  get_container(_this__u8e3s4).k43(_this__u8e3s4.k3g_1.g2f_1, _this__u8e3s4.k3g_1.h2f_1, out, 0, 0, _this__u8e3s4.k3g_1.i2f_1, _this__u8e3s4.k3g_1.j2f_1);
  return out;
}
function get_Bitmaps_transparent() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_transparent;
}
var Bitmaps_transparent;
function get_Bitmaps_white() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_white;
}
var Bitmaps_white;
var Bitmaps_instance;
function Bitmaps_getInstance() {
  return Bitmaps_instance;
}
var properties_initialized_Bitmaps_kt_qcuk18;
function _init_properties_Bitmaps_kt__92w93i() {
  if (!properties_initialized_Bitmaps_kt_qcuk18) {
    properties_initialized_Bitmaps_kt_qcuk18 = true;
    Bitmaps_transparent = slice(Companion_getInstance_16().n44(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().r3x_1)), VOID, 'transparent');
    Bitmaps_white = slice(Companion_getInstance_16().n44(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().m3x_1)), VOID, 'white');
  }
}
var Companion_instance_11;
function Companion_getInstance_19() {
  return Companion_instance_11;
}
function setFromBitmap$getAlpha(_this__u8e3s4, x, y, min) {
  return _this__u8e3s4.q43(x, y) ? _RGBA___get_a__impl__6msvu7(_this__u8e3s4.d3x(x, y)) >= min : false;
}
function setFromBitmap$pass(this$0, x, y, dx, dy, d) {
  if (this$0.i48(x + dx | 0, y + dy | 0) + d < this$0.i48(x, y)) {
    this$0.e48(x, y, x + dx | 0, y + dy | 0);
    // Inline function 'kotlin.math.hypot' call
    var x_0 = x - this$0.f48(x, y) | 0;
    var y_0 = y - this$0.g48(x, y) | 0;
    var tmp$ret$0 = hypot(x_0, y_0);
    this$0.h48(x, y, tmp$ret$0);
  }
}
function distanceMap(_this__u8e3s4, out, thresold) {
  out = out === VOID ? new DistanceBitmap(_this__u8e3s4.f3w_1, _this__u8e3s4.g3w_1) : out;
  thresold = thresold === VOID ? 0.5 : thresold;
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.distanceMap.<anonymous>' call
  out.k48(_this__u8e3s4, thresold);
  return out;
}
function index4($this, x, y) {
  return imul($this.a3x(x, y), 4);
}
function NativeImageOrBitmap32(width, height, native, premultiplied) {
  native = native === VOID ? true : native;
  premultiplied = premultiplied === VOID ? null : premultiplied;
  var tmp;
  if (native) {
    tmp = NativeImage_0(width, height, premultiplied);
  } else {
    tmp = Bitmap32.y3v(width, height, VOID, premultiplied == null ? true : premultiplied);
  }
  return tmp;
}
function ensureNative(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof NativeImage) {
    tmp = _this__u8e3s4;
  } else {
    tmp = get_nativeImageFormatProvider().e4a(_this__u8e3s4);
  }
  return tmp;
}
function NativeImage_0(width, height, premultiplied) {
  premultiplied = premultiplied === VOID ? null : premultiplied;
  return get_nativeImageFormatProvider().f4a(width, height, premultiplied);
}
var Companion_instance_12;
function Companion_getInstance_20() {
  if (Companion_instance_12 === VOID)
    Companion_3.u4a();
  return Companion_instance_12;
}
function applyEffect(_this__u8e3s4, effect) {
  var safeBorder = get_safeBorder(effect);
  var out = Companion_getInstance_16().o44(_this__u8e3s4.f3w_1 + imul(safeBorder, 2) | 0, _this__u8e3s4.g3w_1 + imul(safeBorder, 2) | 0, _this__u8e3s4.l3w_1);
  out.f46(_this__u8e3s4, safeBorder, safeBorder);
  applyEffectInline(out, effect);
  return out;
}
function get_safeBorder(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 == null ? null : _this__u8e3s4.u4b();
  return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
}
function applyEffectInline(_this__u8e3s4, effect) {
  if (effect == null)
    return Unit_instance;
  if (!(effect.n4b_1 === 0)) {
    blurInplace(_this__u8e3s4, effect.n4b_1);
  }
  if (!(effect.q4b_1 === 0) || !(effect.o4b_1 === 0) || !(effect.p4b_1 === 0)) {
    dropShadowInplace(_this__u8e3s4, effect.o4b_1, effect.p4b_1, effect.q4b_1, effect.r4b_1);
  }
  if (!(effect.s4b_1 === 0)) {
    borderInline(_this__u8e3s4, effect.s4b_1, effect.t4b_1);
  }
}
function blurInplace(_this__u8e3s4, r) {
  var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.f3w_1 / 2 | 0) - 1 | 0), (_this__u8e3s4.g3w_1 / 2 | 0) - 1 | 0);
  var t1 = Bitmap8.f47(_this__u8e3s4.f3w_1, _this__u8e3s4.g3w_1);
  var t2 = Bitmap8.f47(_this__u8e3s4.f3w_1, _this__u8e3s4.g3w_1);
  var inductionVariable = 0;
  if (inductionVariable < 4)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var channel = Companion_getInstance_18().f1(n);
      _this__u8e3s4.j46(channel, t1);
      arraycopy_0(t1.r45(), 0, t2.r45(), 0, t2.y2f());
      gaussBlur(t1.r45(), t2.r45(), _this__u8e3s4.f3w_1, _this__u8e3s4.g3w_1, r_0);
      _this__u8e3s4.i46(channel, t2);
    }
     while (inductionVariable < 4);
}
function gaussBlur(scl, tcl, w, h, r) {
  var a = 0;
  var b = 0;
  var c = 0;
  // Inline function 'korlibs.image.bitmap.effect.boxesForGaussN3' call
  var n = 3;
  // Inline function 'kotlin.math.sqrt' call
  var x = 12.0 * r * r / n + 1;
  var wIdeal = Math.sqrt(x);
  var wl = toIntFloor_0(wIdeal);
  if ((wl % 2 | 0) === 0) {
    wl = wl - 1 | 0;
  }
  var wu = wl + 2 | 0;
  var mIdeal = (12.0 * r * r - imul(imul(n, wl), wl) - imul(imul(4, n), wl) - imul(3, n)) / (imul(-4, wl) - 4 | 0);
  var m = round(mIdeal);
  // Inline function 'korlibs.image.bitmap.effect.gaussBlur.<anonymous>' call
  a = 0 < m ? wl : wu;
  b = 1 < m ? wl : wu;
  c = 2 < m ? wl : wu;
  boxBlur(scl, tcl, w, h, (a - 1 | 0) / 2 | 0);
  boxBlur(tcl, scl, w, h, (b - 1 | 0) / 2 | 0);
  boxBlur(scl, tcl, w, h, (c - 1 | 0) / 2 | 0);
}
function boxBlur(scl, tcl, w, h, r) {
  arraycopy_0(scl, 0, tcl, 0, scl.length);
  boxBlurH(tcl, scl, w, h, r);
  boxBlurT(scl, tcl, w, h, r);
}
function boxBlurH(scl, tcl, w, h, r) {
  var arr = (r + r | 0) + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < h)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ti = imul(i, w);
      var li = ti;
      var ri = ti + r | 0;
      var fv = getU8(scl, ti);
      var lv = getU8(scl, (ti + w | 0) - 1 | 0);
      var v = imul(r + 1 | 0, fv);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < r)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          v = v + getU8(scl, ti + j | 0) | 0;
        }
         while (inductionVariable_0 < r);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= r)
        do {
          var j_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var tmp = v;
          var _unary__edvuaz = ri;
          ri = _unary__edvuaz + 1 | 0;
          v = tmp + (getU8(scl, _unary__edvuaz) - fv | 0) | 0;
          var _unary__edvuaz_0 = ti;
          ti = _unary__edvuaz_0 + 1 | 0;
          tcl[_unary__edvuaz_0] = toByte(v / arr | 0);
        }
         while (!(j_0 === r));
      var inductionVariable_2 = r + 1 | 0;
      var last = w - r | 0;
      if (inductionVariable_2 < last)
        do {
          var j_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var tmp_0 = v;
          var _unary__edvuaz_1 = ri;
          ri = _unary__edvuaz_1 + 1 | 0;
          var tmp_1 = getU8(scl, _unary__edvuaz_1);
          var _unary__edvuaz_2 = li;
          li = _unary__edvuaz_2 + 1 | 0;
          v = tmp_0 + (tmp_1 - getU8(scl, _unary__edvuaz_2) | 0) | 0;
          var _unary__edvuaz_3 = ti;
          ti = _unary__edvuaz_3 + 1 | 0;
          tcl[_unary__edvuaz_3] = toByte(v / arr | 0);
        }
         while (inductionVariable_2 < last);
      var inductionVariable_3 = w - r | 0;
      if (inductionVariable_3 < w)
        do {
          var j_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          var tmp_2 = v;
          var _unary__edvuaz_4 = li;
          li = _unary__edvuaz_4 + 1 | 0;
          v = tmp_2 + (lv - getU8(scl, _unary__edvuaz_4) | 0) | 0;
          var _unary__edvuaz_5 = ti;
          ti = _unary__edvuaz_5 + 1 | 0;
          tcl[_unary__edvuaz_5] = toByte(v / arr | 0);
        }
         while (inductionVariable_3 < w);
    }
     while (inductionVariable < h);
}
function boxBlurT(scl, tcl, w, h, r) {
  var arr = (r + r | 0) + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < w)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ti = i;
      var li = ti;
      var ri = ti + imul(r, w) | 0;
      var fv = getU8(scl, ti);
      var lv = getU8(scl, ti + imul(w, h - 1 | 0) | 0);
      var v = imul(r + 1 | 0, fv);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < r)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          v = v + getU8(scl, ti + imul(j, w) | 0) | 0;
        }
         while (inductionVariable_0 < r);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= r)
        do {
          var j_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          v = v + (getU8(scl, ri) - fv | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          ri = ri + w | 0;
          ti = ti + w | 0;
        }
         while (!(j_0 === r));
      var inductionVariable_2 = r + 1 | 0;
      var last = h - r | 0;
      if (inductionVariable_2 < last)
        do {
          var j_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          v = v + (getU8(scl, ri) - getU8(scl, li) | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          li = li + w | 0;
          ri = ri + w | 0;
          ti = ti + w | 0;
        }
         while (inductionVariable_2 < last);
      var inductionVariable_3 = h - r | 0;
      if (inductionVariable_3 < h)
        do {
          var j_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          v = v + (lv - getU8(scl, li) | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          li = li + w | 0;
          ti = ti + w | 0;
        }
         while (inductionVariable_3 < h);
    }
     while (inductionVariable < w);
}
function blur(_this__u8e3s4, r) {
  var out = Bitmap8.f47(_this__u8e3s4.f3w_1 + imul(r, 2) | 0, _this__u8e3s4.g3w_1 + imul(r, 2) | 0);
  Companion_instance_9.m47(_this__u8e3s4, 0, 0, out, r, r, _this__u8e3s4.f3w_1, _this__u8e3s4.g3w_1);
  blurInplace_0(out, r);
  return out;
}
function blurInplace_0(_this__u8e3s4, r) {
  var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.f3w_1 / 2 | 0) - 1 | 0), (_this__u8e3s4.g3w_1 / 2 | 0) - 1 | 0);
  var t2 = Bitmap8.f47(_this__u8e3s4.f3w_1, _this__u8e3s4.g3w_1);
  arraycopy_0(_this__u8e3s4.r45(), 0, t2.r45(), 0, _this__u8e3s4.y2f());
  gaussBlur(t2.r45(), _this__u8e3s4.r45(), _this__u8e3s4.f3w_1, _this__u8e3s4.g3w_1, r_0);
}
function borderInline(_this__u8e3s4, r, color) {
  color = color === VOID ? Colors_getInstance().n3x_1 : color;
  var out = _this__u8e3s4;
  var distance = distanceMap(out);
  var inductionVariable = 0;
  var last = out.g3w_1;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = out.f3w_1;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var dist = distance.i48(x, y);
          if (dist < (r + 1 | 0)) {
            var alpha = dist >= r ? 1.0 - dist % 1.0 : 1.0;
            var rcolor = alpha === 1.0 ? color : RGBA__withAf_impl_dpdu32(color, _RGBA___get_af__impl__vu36qv(color) * alpha);
            out.u45(x, y, Companion_getInstance_23().v4b(rcolor, out.v45(x, y)));
          }
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
}
function dropShadowInplace(_this__u8e3s4, x, y, r, color) {
  color = color === VOID ? Colors_getInstance().n3x_1 : color;
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>' call
  var copy = _this__u8e3s4.u1i();
  var pcolor = _RGBA___get_premultiplied__impl__3bulqc(color);
  // Inline function 'kotlin.also' call
  var this_0 = blur(_this__u8e3s4.k46(BitmapChannel_ALPHA_getInstance()), r);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>.<anonymous>' call
  this_0.l3w_1 = true;
  var inductionVariable = 0;
  if (inductionVariable < 256)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      RgbaArray__set_impl_epw2wg(this_0.l45_1, n, Companion_getInstance_23().w4b(imul(_RGBAPremultiplied___get_r__impl__m8nz5i(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_g__impl__fv131x(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_b__impl__dt4tp6(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_a__impl__f0hnd1(pcolor), n) / 255 | 0));
    }
     while (inductionVariable < 256);
  var shadow = this_0.r3w();
  _this__u8e3s4.d46(Colors_getInstance().r3x_1);
  _this__u8e3s4.g46(shadow, x - r | 0, y - r | 0);
  _this__u8e3s4.g46(copy, 0, 0);
  return _this__u8e3s4;
}
var NewSDF_instance;
function NewSDF_getInstance() {
  return NewSDF_instance;
}
function decode(_this__u8e3s4, data, dataOffset, out, outOffset, size, littleEndian) {
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var tmp;
  switch (_this__u8e3s4.g4c()) {
    case 16:
      var tmp_0;
      if (littleEndian) {
        tmp_0 = getU16LE$ref();
      } else {
        tmp_0 = getU16BE$ref();
      }

      tmp = tmp_0;
      break;
    case 24:
      var tmp_1;
      if (littleEndian) {
        tmp_1 = getU24LE$ref();
      } else {
        tmp_1 = getU24BE$ref();
      }

      tmp = tmp_1;
      break;
    case 32:
      var tmp_2;
      if (littleEndian) {
        tmp_2 = getS32LE$ref();
      } else {
        tmp_2 = getS32BE$ref();
      }

      tmp = tmp_2;
      break;
    default:
      throw IllegalArgumentException.l('Unsupported bpp ' + _this__u8e3s4.g4c());
  }
  var readFunc = tmp;
  // Inline function 'korlibs.image.color.decodeInternal' call
  var io = dataOffset;
  var oo = outOffset;
  var bytesPerPixel = get_bytesPerPixel(_this__u8e3s4);
  var outdata = out;
  var Bpp = numberToInt(bytesPerPixel);
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c = readFunc(data, io);
      io = io + Bpp | 0;
      var _unary__edvuaz = oo;
      oo = _unary__edvuaz + 1 | 0;
      RgbaArray__set_impl_epw2wg(outdata, _unary__edvuaz, Companion_getInstance_23().w4b(_this__u8e3s4.h4c(c), _this__u8e3s4.i4c(c), _this__u8e3s4.j4c(c), _this__u8e3s4.k4c(c)));
    }
     while (inductionVariable < size);
}
function get_bytesPerPixel(_this__u8e3s4) {
  return _this__u8e3s4.g4c() / 8;
}
function getU16LE$ref() {
  var l = function (p0, p1) {
    return getU16LE(p0, p1);
  };
  l.callableName = 'getU16LE';
  return l;
}
function getU16BE$ref() {
  var l = function (p0, p1) {
    return getU16BE(p0, p1);
  };
  l.callableName = 'getU16BE';
  return l;
}
function getU24LE$ref() {
  var l = function (p0, p1) {
    return getU24LE(p0, p1);
  };
  l.callableName = 'getU24LE';
  return l;
}
function getU24BE$ref() {
  var l = function (p0, p1) {
    return getU24BE(p0, p1);
  };
  l.callableName = 'getU24BE';
  return l;
}
function getS32LE$ref() {
  var l = function (p0, p1) {
    return getS32LE(p0, p1);
  };
  l.callableName = 'getS32LE';
  return l;
}
function getS32BE$ref() {
  var l = function (p0, p1) {
    return getS32BE(p0, p1);
  };
  l.callableName = 'getS32BE';
  return l;
}
var Colors_instance;
function Colors_getInstance() {
  if (Colors_instance === VOID)
    new Colors();
  return Colors_instance;
}
var Companion_instance_13;
function Companion_getInstance_21() {
  if (Companion_instance_13 === VOID)
    new Companion_4();
  return Companion_instance_13;
}
function _RgbaArray___init__impl__oib4y4(ints) {
  return ints;
}
function _RgbaArray___get_ints__impl__u2kps1($this) {
  return $this;
}
var Companion_instance_14;
function Companion_getInstance_22() {
  return Companion_instance_14;
}
function RgbaArray__subList_impl_rbyi98($this, fromIndex, toIndex) {
  return new GenericSubList(new RgbaArray($this), fromIndex, toIndex);
}
function RgbaArray__contains_impl_ofn00n($this, element) {
  return contains(_RgbaArray___get_ints__impl__u2kps1($this), _RGBA___get_value__impl__hhco8v(element));
}
function RgbaArray__contains_impl_ofn00n_0($this, element) {
  if (!(element instanceof RGBA))
    return false;
  return RgbaArray__contains_impl_ofn00n($this.n4d_1, element instanceof RGBA ? element.i4d_1 : THROW_CCE());
}
function RgbaArray__containsAll_impl_l6gz5c($this, elements) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(elements, Collection)) {
      tmp = elements.g1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var tmp0_iterator = elements.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.color.RgbaArray.containsAll.<anonymous>' call
      var it = element.i4d_1;
      if (!RgbaArray__contains_impl_ofn00n($this, it)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function RgbaArray__containsAll_impl_l6gz5c_0($this, elements) {
  return RgbaArray__containsAll_impl_l6gz5c($this.n4d_1, elements);
}
function RgbaArray__isEmpty_impl_nch3ip($this) {
  // Inline function 'kotlin.collections.isEmpty' call
  return _RgbaArray___get_ints__impl__u2kps1($this).length === 0;
}
function RgbaArray__iterator_impl_5wfwsm($this) {
  return RgbaArray__listIterator_impl_m4kjt0_0($this, 0);
}
function RgbaArray__listIterator_impl_m4kjt0($this) {
  return RgbaArray__listIterator_impl_m4kjt0_0($this, 0);
}
function RgbaArray__listIterator_impl_m4kjt0_0($this, index) {
  return new GenericListIterator(new RgbaArray($this), index);
}
function _RgbaArray___get_size__impl__imxef8($this) {
  return _RgbaArray___get_ints__impl__u2kps1($this).length;
}
function RgbaArray__get_impl_nzyo1o($this, index) {
  return _RGBA___init__impl__lqpay5(_RgbaArray___get_ints__impl__u2kps1($this)[index]);
}
function RgbaArray__get_impl_nzyo1o_0($this, index) {
  return new RGBA(RgbaArray__get_impl_nzyo1o($this.n4d_1, index));
}
function RgbaArray__set_impl_epw2wg($this, index, color) {
  _RgbaArray___get_ints__impl__u2kps1($this)[index] = _RGBA___get_value__impl__hhco8v(color);
}
function RgbaArray__toString_impl_vgvk04($this) {
  return 'RgbaArray(' + _RgbaArray___get_size__impl__imxef8($this) + ')';
}
function RgbaArray__hashCode_impl_ht2l65($this) {
  return hashCode($this);
}
function RgbaArray__equals_impl_6qvuf($this, other) {
  if (!(other instanceof RgbaArray))
    return false;
  var tmp0_other_with_cast = other instanceof RgbaArray ? other.n4d_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function blendComponent($this, c1, c2, factor) {
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = c1 * (1.0 - Ratio__toFloat_impl_1ftup5(factor)) + c2 * Ratio__toFloat_impl_1ftup5(factor);
  return roundToInt(this_0) & 255;
}
function _RGBA___init__impl__lqpay5(value) {
  return value;
}
function _RGBA___get_value__impl__hhco8v($this) {
  return $this;
}
function RGBA__clone_impl_w007z0($this) {
  return new RGBA($this);
}
function _RGBA___get_color__impl__8x3sb3($this) {
  return $this;
}
function _RGBA___get_r__impl__duz7mo($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 0 | 0) & 255;
}
function _RGBA___get_g__impl__o8pukr($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 8 | 0) & 255;
}
function _RGBA___get_b__impl__m6tl80($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 16 | 0) & 255;
}
function _RGBA___get_a__impl__6msvu7($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 24 | 0) & 255;
}
function _RGBA___get_rf__impl__kvz75k($this) {
  return _RGBA___get_r__impl__duz7mo($this) / 255.0;
}
function _RGBA___get_gf__impl__5gcu1f($this) {
  return _RGBA___get_g__impl__o8pukr($this) / 255.0;
}
function _RGBA___get_bf__impl__1xz5yg($this) {
  return _RGBA___get_b__impl__m6tl80($this) / 255.0;
}
function _RGBA___get_af__impl__vu36qv($this) {
  return _RGBA___get_a__impl__6msvu7($this) / 255.0;
}
function _RGBA___get_ad__impl__pt5rdj($this) {
  return _RGBA___get_a__impl__6msvu7($this) / 255.0;
}
function _RGBA___get_rgb__impl__tijaqt($this) {
  return _RGBA___get_value__impl__hhco8v($this) & 16777215;
}
function RGBA__withA_impl_vogscm($this, v) {
  return _RGBA___init__impl__lqpay5(_RGBA___get_value__impl__hhco8v($this) & 16777215 | clampUByte(v) << 24);
}
function RGBA__withAd_impl_cralao($this, v) {
  return RGBA__withA_impl_vogscm($this, d2i(v));
}
function RGBA__withAf_impl_dpdu32($this, v) {
  return RGBA__withA_impl_vogscm($this, f2i(v));
}
function RGBA__concatAd_impl_gwhfm($this, v) {
  return RGBA__withA_impl_vogscm($this, roundToInt(_RGBA___get_a__impl__6msvu7($this) * v));
}
function _RGBA___get_hexString__impl__kocngm($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.sb(9);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.color.RGBA.<get-hexString>.<anonymous>' call
  this_0.ob(_Char___init__impl__6a9atx(35));
  appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
  appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
  appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
  appendHexByte(this_0, _RGBA___get_a__impl__6msvu7($this));
  return this_0.toString();
}
function _RGBA___get_hexStringNoAlpha__impl__j315et($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.sb(7);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.color.RGBA.<get-hexStringNoAlpha>.<anonymous>' call
  this_0.ob(_Char___init__impl__6a9atx(35));
  appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
  appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
  appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
  return this_0.toString();
}
function _RGBA___get_htmlColor__impl__bzw5k6($this) {
  return 'rgba(' + _RGBA___get_r__impl__duz7mo($this) + ', ' + _RGBA___get_g__impl__o8pukr($this) + ', ' + _RGBA___get_b__impl__m6tl80($this) + ', ' + get_niceStr(_RGBA___get_af__impl__vu36qv($this)) + ')';
}
function _RGBA___get_htmlStringSimple__impl__l4nu0u($this) {
  return _RGBA___get_hexStringNoAlpha__impl__j315et($this);
}
function RGBA__toString_impl_4lw6dp($this) {
  return _RGBA___get_hexString__impl__kocngm($this);
}
function RGBA__compareTo_impl_lrfjc1($this, other) {
  return compareTo(_RGBA___get_value__impl__hhco8v($this), _RGBA___get_value__impl__hhco8v(other));
}
function RGBA__compareTo_impl_lrfjc1_0($this, other) {
  return RGBA__compareTo_impl_lrfjc1($this.i4d_1, other instanceof RGBA ? other.i4d_1 : THROW_CCE());
}
function RGBA__premultipliedValue_impl_oja55q($this, premultiplied) {
  return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc($this)) : _RGBA___get_value__impl__hhco8v($this);
}
function _RGBA___get_premultiplied__impl__3bulqc($this) {
  return _RGBA___get_premultipliedFast__impl__qiau4g($this);
}
function _RGBA___get_premultipliedFast__impl__qiau4g($this) {
  var A = _RGBA___get_a__impl__6msvu7($this) + 1 | 0;
  if (A >= 255)
    return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this));
  if (A <= 1)
    return _RGBAPremultiplied___init__impl__uos02x(0);
  var RB = (imul(_RGBA___get_value__impl__hhco8v($this) & 16711935, A) >>> 8 | 0) & 16711935;
  var G = (imul(_RGBA___get_value__impl__hhco8v($this) & 65280, A) >>> 8 | 0) & 65280;
  return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this) & -16777216 | RB | G);
}
var Companion_instance_15;
function Companion_getInstance_23() {
  if (Companion_instance_15 === VOID)
    new Companion_6();
  return Companion_instance_15;
}
function RGBA__hashCode_impl_h59qf6($this) {
  return $this;
}
function RGBA__equals_impl_4vjmca($this, other) {
  if (!(other instanceof RGBA))
    return false;
  if (!($this === (other instanceof RGBA ? other.i4d_1 : THROW_CCE())))
    return false;
  return true;
}
function asNonPremultiplied(_this__u8e3s4) {
  return _RGBA___init__impl__lqpay5(_RGBAPremultiplied___get_value__impl__bqfhud(_this__u8e3s4));
}
function _RGBAPremultiplied___init__impl__uos02x(value) {
  return value;
}
function _RGBAPremultiplied___get_value__impl__bqfhud($this) {
  return $this;
}
function _RGBAPremultiplied___init__impl__uos02x_0(r, g, b, a) {
  return _RGBAPremultiplied___init__impl__uos02x(packIntClamped(r, g, b, a));
}
function _RGBAPremultiplied___get_r__impl__m8nz5i($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 0 | 0) & 255;
}
function _RGBAPremultiplied___get_g__impl__fv131x($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 8 | 0) & 255;
}
function _RGBAPremultiplied___get_b__impl__dt4tp6($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 16 | 0) & 255;
}
function _RGBAPremultiplied___get_a__impl__f0hnd1($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0) & 255;
}
function _RGBAPremultiplied___get_rf__impl__pt0c4y($this) {
  return _RGBAPremultiplied___get_r__impl__m8nz5i($this) / 255.0;
}
function _RGBAPremultiplied___get_gf__impl__ivron7($this) {
  return _RGBAPremultiplied___get_g__impl__fv131x($this) / 255.0;
}
function _RGBAPremultiplied___get_bf__impl__qa3on2($this) {
  return _RGBAPremultiplied___get_b__impl__dt4tp6($this) / 255.0;
}
function _RGBAPremultiplied___get_af__impl__euwcjn($this) {
  return _RGBAPremultiplied___get_a__impl__f0hnd1($this) / 255.0;
}
function _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv($this) {
  var alpha = _RGBAPremultiplied___get_a__impl__f0hnd1($this);
  var tmp;
  if (alpha === 0) {
    tmp = Colors_getInstance().r3x_1;
  } else {
    var ialpha = 255.0 / alpha;
    var tmp_0 = Companion_getInstance_23();
    // Inline function 'kotlin.math.roundToInt' call
    var this_0 = _RGBAPremultiplied___get_r__impl__m8nz5i($this) * ialpha;
    var tmp_1 = roundToInt(this_0);
    // Inline function 'kotlin.math.roundToInt' call
    var this_1 = _RGBAPremultiplied___get_g__impl__fv131x($this) * ialpha;
    var tmp_2 = roundToInt(this_1);
    // Inline function 'kotlin.math.roundToInt' call
    var this_2 = _RGBAPremultiplied___get_b__impl__dt4tp6($this) * ialpha;
    var tmp$ret$2 = roundToInt(this_2);
    tmp = tmp_0.w4b(tmp_1, tmp_2, tmp$ret$2, alpha);
  }
  return tmp;
}
function RGBAPremultiplied__scaled256_impl_hjm9ii($this, s) {
  var rb = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 16711935, s) >>> 8 | 0) & 16711935;
  var g = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 65280, s) >>> 8 | 0) & 65280;
  var a = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0, s) >>> 8 | 0) << 24;
  return _RGBAPremultiplied___init__impl__uos02x(rb | g | a);
}
function RGBAPremultiplied__scaled_impl_qz7lg1($this, alpha) {
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = clamp01_0(alpha) * 256;
  var tmp$ret$0 = roundToInt(this_0);
  return RGBAPremultiplied__scaled256_impl_hjm9ii($this, tmp$ret$0);
}
var Companion_instance_16;
function Companion_getInstance_24() {
  return Companion_instance_16;
}
function asPremultiplied(_this__u8e3s4) {
  return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v(_this__u8e3s4));
}
function mix(_this__u8e3s4, src) {
  var dst = _this__u8e3s4;
  var srcAf = _RGBAPremultiplied___get_af__impl__euwcjn(src);
  var oneMSrcAf = 1.0 - srcAf;
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = _RGBAPremultiplied___get_a__impl__f0hnd1(src) + _RGBAPremultiplied___get_a__impl__f0hnd1(dst) * oneMSrcAf;
  var outA = roundToInt(this_0);
  // Inline function 'kotlin.math.roundToInt' call
  var this_1 = _RGBAPremultiplied___get_r__impl__m8nz5i(src) + _RGBAPremultiplied___get_r__impl__m8nz5i(dst) * oneMSrcAf;
  var outR = roundToInt(this_1);
  // Inline function 'kotlin.math.roundToInt' call
  var this_2 = _RGBAPremultiplied___get_g__impl__fv131x(src) + _RGBAPremultiplied___get_g__impl__fv131x(dst) * oneMSrcAf;
  var outG = roundToInt(this_2);
  // Inline function 'kotlin.math.roundToInt' call
  var this_3 = _RGBAPremultiplied___get_b__impl__dt4tp6(src) + _RGBAPremultiplied___get_b__impl__dt4tp6(dst) * oneMSrcAf;
  var outB = roundToInt(this_3);
  return _RGBAPremultiplied___init__impl__uos02x_0(outR, outG, outB, outA);
}
function _RgbaPremultipliedArray___init__impl__lx83hy(ints) {
  return ints;
}
function _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this) {
  return $this;
}
var Companion_instance_17;
function Companion_getInstance_25() {
  return Companion_instance_17;
}
function _RgbaPremultipliedArray___get_size__impl__6lte0e($this) {
  return _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this).length;
}
function RgbaPremultipliedArray__get_impl_1u69ta($this, index) {
  return _RGBAPremultiplied___init__impl__uos02x(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index]);
}
function RgbaPremultipliedArray__set_impl_7fwbby($this, index, color) {
  _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index] = _RGBAPremultiplied___get_value__impl__bqfhud(color);
}
function RgbaPremultipliedArray__fill_impl_sem38t($this, value, start, end) {
  return fill(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this), _RGBAPremultiplied___get_value__impl__bqfhud(value), start, end);
}
function RgbaPremultipliedArray__toString_impl_seal6e($this) {
  return 'RgbaPremultipliedArray(' + _RgbaPremultipliedArray___get_size__impl__6lte0e($this) + ')';
}
function RgbaPremultipliedArray__hashCode_impl_kvnjzv($this) {
  return hashCode($this);
}
function RgbaPremultipliedArray__equals_impl_vav5d5($this, other) {
  if (!(other instanceof RgbaPremultipliedArray))
    return false;
  var tmp0_other_with_cast = other instanceof RgbaPremultipliedArray ? other.e4e_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function scale(color, colorOffset, alpha, alphaOffset, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var a = clamp01_0(alpha[alphaOffset + n | 0]);
      if (a === 1.0)
        continue $l$loop;
      RgbaPremultipliedArray__set_impl_7fwbby(color, colorOffset + n | 0, RGBAPremultiplied__scaled_impl_qz7lg1(RgbaPremultipliedArray__get_impl_1u69ta(color, colorOffset + n | 0), a));
    }
     while (inductionVariable < count);
}
function premultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      RgbaPremultipliedArray__set_impl_7fwbby(dst, dstN + n | 0, _RGBA___get_premultiplied__impl__3bulqc(RgbaArray__get_impl_nzyo1o(src, srcN + n | 0)));
    }
     while (inductionVariable < count);
}
function depremultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = dstN + n | 0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = RgbaPremultipliedArray__get_impl_1u69ta(src, srcN + n | 0);
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
      RgbaArray__set_impl_epw2wg(dst, tmp, tmp$ret$0);
    }
     while (inductionVariable < count);
}
function mix_0(dst, dstX, src, srcX, count) {
  return mix_1(dst, dstX, dst, dstX, src, srcX, count);
}
function mix_1(tgt, tgtX, dst, dstX, src, srcX, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var srcC = RgbaPremultipliedArray__get_impl_1u69ta(src, srcX + n | 0);
      RgbaPremultipliedArray__set_impl_7fwbby(tgt, tgtX + n | 0, _RGBAPremultiplied___get_a__impl__f0hnd1(srcC) === 255 ? srcC : Companion_instance_16.c4e(RgbaPremultipliedArray__get_impl_1u69ta(dst, dstX + n | 0), srcC));
    }
     while (inductionVariable < count);
}
function _RGBAf___init__impl__idjpgn(data) {
  return data;
}
function _RGBAf___get_data__impl__yt2t4($this) {
  return $this;
}
function _RGBAf___init__impl__idjpgn_0(r, g, b, a) {
  r = r === VOID ? 1.0 : r;
  g = g === VOID ? 1.0 : g;
  b = b === VOID ? 1.0 : b;
  a = a === VOID ? 1.0 : a;
  // Inline function 'kotlin.floatArrayOf' call
  var tmp$ret$0 = new Float32Array([r, g, b, a]);
  return _RGBAf___init__impl__idjpgn(tmp$ret$0);
}
function _RGBAf___set_r__impl__pz5j5e($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[0] = v;
}
function _RGBAf___get_r__impl__jfq8gq($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[0];
}
function _RGBAf___set_g__impl__c4jj21($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[1] = v;
}
function _RGBAf___get_g__impl__dhoraz($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[1];
}
function _RGBAf___set_b__impl__a2n9pa($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[2] = v;
}
function _RGBAf___get_b__impl__fjl0nq($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[2];
}
function _RGBAf___set_a__impl__iqz7cx($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[3] = v;
}
function _RGBAf___get_a__impl__qnwk97($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[3];
}
var Companion_instance_18;
function Companion_getInstance_26() {
  return Companion_instance_18;
}
function BitmapFont$Glyph$bmp$delegate$lambda(this$0) {
  return function () {
    return extract_0(this$0.i4e_1).r3w();
  };
}
var Companion_instance_19;
function Companion_getInstance_27() {
  return Companion_instance_19;
}
function BitmapFontImpl$naturalFontMetrics$delegate$lambda(this$0) {
  return function () {
    var ascent = this$0.e4h_1;
    var baseline = 0.0;
    var tmp = -this$0.j4h_1;
    var tmp_0 = -this$0.j4h_1;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BitmapFontImpl.naturalFontMetrics$delegate.<anonymous>.<anonymous>' call
    var width = 0.0;
    var _iterator__ex2g4s = this$0.f4h_1.i3().a1();
    while (_iterator__ex2g4s.b1()) {
      var glyph = _iterator__ex2g4s.c1();
      if (!(glyph == null)) {
        // Inline function 'kotlin.math.max' call
        var a = width;
        var b = glyph.i4e_1.s3g_1;
        width = Math.max(a, b);
      }
    }
    var tmp$ret$2 = width;
    return new FontMetrics(this$0.c4h_1, ascent, ascent, baseline, tmp, tmp_0, 0.0, tmp$ret$2);
  };
}
function BitmapFontImpl$anyGlyph$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.f4h_1.f1(this$0.f4h_1.e3().a1().c1());
    return tmp0_elvis_lhs == null ? this$0.o4h() : tmp0_elvis_lhs;
  };
}
function BitmapFontImpl$invalidGlyph$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Glyph(this$0.c4h_1, -1, tmp$ret$0, 0, 0, 0);
  };
}
function *_generator_readBitmapFont__n2ejpo(_this__u8e3s4, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().p4h_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  var fntFile = _this__u8e3s4;
  // Inline function 'kotlin.text.trim' call
  var tmp = fntFile.s24(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var this_0 = tmp;
  var content = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  // Inline function 'kotlin.collections.hashMapOf' call
  var textures = HashMap.f8();
  var tmp_0;
  if (startsWith_0(content, _Char___init__impl__6a9atx(60))) {
    var tmp_1 = readBitmapFontXml(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } else if (startsWith_0(content, _Char___init__impl__6a9atx(123))) {
    var tmp_2 = readBitmapFontJson(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    tmp_0 = tmp_2;
  } else if (startsWith(content, 'info')) {
    var tmp_3 = readBitmapFontTxt(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_0 = tmp_3;
  } else {
    var reason = 'Unsupported font type starting with ' + substr_0(content, 0, 16);
    throw NotImplementedError.nd('An operation is not implemented: ' + reason);
  }
  return tmp_0;
}
function readBitmapFont(_this__u8e3s4, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().p4h_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFont__n2ejpo.bind(VOID, _this__u8e3s4, props, mipmaps, atlas), $completion);
}
function *_generator_readBitmapFontXml__tgdamn(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().p4h_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  var xml = Xml(content);
  var tmp60_safe_receiver = firstOrNull(xml.xh('info'));
  var tmp0_elvis_lhs = tmp60_safe_receiver == null ? null : tmp60_safe_receiver.c1n('size');
  var fontSize = tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
  var tmp61_safe_receiver = firstOrNull(xml.xh('common'));
  var tmp1_elvis_lhs = tmp61_safe_receiver == null ? null : tmp61_safe_receiver.c1n('lineHeight');
  var lineHeight = tmp1_elvis_lhs == null ? 16.0 : tmp1_elvis_lhs;
  var tmp62_safe_receiver = firstOrNull(xml.xh('common'));
  var tmp2_elvis_lhs = tmp62_safe_receiver == null ? null : tmp62_safe_receiver.c1n('base');
  var base = tmp2_elvis_lhs == null ? 16.0 : tmp2_elvis_lhs;
  var tmp63_safe_receiver = firstOrNull(xml.xh('distanceField'));
  var distanceField = tmp63_safe_receiver == null ? null : tmp63_safe_receiver.d1n('fieldType');
  var _iterator__ex2g4s = get(xml.xh('pages'), 'page').a1();
  while (_iterator__ex2g4s.b1()) {
    var page = _iterator__ex2g4s.c1();
    var id = page.z1m('id');
    var file = page.b1n('file');
    var texFile = fntFile.n24().xh(file);
    var tmp = readBitmap(texFile, props, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tex = slice(mipmaps(tmp, mipmaps_0));
    // Inline function 'kotlin.collections.set' call
    textures.f3(id, tex);
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get(xml.xh('chars'), 'char');
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var page_0 = item.z1m('page');
    var tmp0_elvis_lhs_0 = textures.d3(page_0);
    var texture = tmp0_elvis_lhs_0 == null ? first(textures.i3()) : tmp0_elvis_lhs_0;
    var tmp_0 = item.z1m('id');
    var tmp_1;
    if (atlas == null) {
      tmp_1 = null;
    } else {
      var tmp_2 = texture.a3i(item.z1m('x'), item.z1m('y'), item.z1m('width'), item.z1m('height'));
      tmp_1 = atlas.v3w(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
    }
    var tmp65_safe_receiver = tmp_1;
    var tmp1_elvis_lhs_0 = tmp65_safe_receiver == null ? null : tmp65_safe_receiver.v3u_1;
    var tmp$ret$0 = new Glyph(fontSize, tmp_0, tmp1_elvis_lhs_0 == null ? texture.a3i(item.z1m('x'), item.z1m('y'), item.z1m('width'), item.z1m('height')) : tmp1_elvis_lhs_0, item.z1m('xoffset'), item.z1m('yoffset'), item.z1m('xadvance'));
    destination.h(tmp$ret$0);
  }
  var glyphs = destination;
  // Inline function 'kotlin.collections.map' call
  var this_1 = get(xml.xh('kernings'), 'kerning');
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
  var tmp0_iterator_0 = this_1.a1();
  while (tmp0_iterator_0.b1()) {
    var item_0 = tmp0_iterator_0.c1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$3 = new Kerning(item_0.z1m('first'), item_0.z1m('second'), item_0.z1m('amount'));
    destination_0.h(tmp$ret$3);
  }
  var kernings = destination_0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.w(collectionSizeOrDefault(glyphs, 10));
  var tmp0_iterator_1 = glyphs.a1();
  while (tmp0_iterator_1.b1()) {
    var item_1 = tmp0_iterator_1.c1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$6 = to(item_1.h4e_1, item_1);
    destination_1.h(tmp$ret$6);
  }
  var glyphs_0 = toIntMap(toMap(destination_1));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.w(collectionSizeOrDefault(kernings, 10));
  var tmp0_iterator_2 = kernings.a1();
  while (tmp0_iterator_2.b1()) {
    var item_2 = tmp0_iterator_2.c1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$9 = to(Companion_instance_18.f4e(item_2.o4e_1, item_2.p4e_1), item_2);
    destination_2.h(tmp$ret$9);
  }
  var kernings_0 = toIntMap(toMap(destination_2));
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs_0, kernings_0, name, distanceField);
}
function readBitmapFontXml(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().p4h_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontXml__tgdamn.bind(VOID, content, fntFile, textures, props, mipmaps, atlas), $completion);
}
function *_generator_readBitmapFontJson__a3fd7w(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().p4h_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  var json = get_dyn(Companion_getInstance_13().f1k(content));
  var fontSize = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'info'), 'size'), 16.0);
  var lineHeight = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'common'), 'lineHeight'), 16.0);
  var base = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'common'), 'base'), 16.0);
  var distanceField = Dyn__toStringOrNull_impl_7e6cgy(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'distanceField'), 'fieldType'));
  // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
  var this_0 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'pages'));
  var n = 0;
  while (n < this_0.d1()) {
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var id = n;
    var page = this_0.f1(n).a2x_1;
    var file = Dyn__toString_impl_9l0v3s(page);
    var texFile = fntFile.n24().xh(file);
    var tmp = readBitmap(texFile, props, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tex = slice(mipmaps(tmp, mipmaps_0));
    // Inline function 'kotlin.collections.set' call
    textures.f3(id, tex);
    n = n + 1 | 0;
  }
  // Inline function 'kotlin.collections.map' call
  var this_1 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'chars'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
  var tmp0_iterator = this_1.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var it = item.a2x_1;
    var page_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'page'));
    var tmp0_elvis_lhs = textures.d3(page_0);
    var texture = tmp0_elvis_lhs == null ? first(textures.i3()) : tmp0_elvis_lhs;
    var tmp_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'id'));
    var tmp_1;
    if (atlas == null) {
      tmp_1 = null;
    } else {
      var tmp_2 = texture.a3i(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'height')));
      tmp_1 = atlas.v3w(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
    }
    var tmp43_safe_receiver = tmp_1;
    var tmp1_elvis_lhs = tmp43_safe_receiver == null ? null : tmp43_safe_receiver.v3u_1;
    var tmp$ret$0 = new Glyph(fontSize, tmp_0, tmp1_elvis_lhs == null ? texture.a3i(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'height'))) : tmp1_elvis_lhs, _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'xoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'yoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'xadvance')));
    destination.h(tmp$ret$0);
  }
  var glyphs = destination;
  // Inline function 'kotlin.collections.map' call
  var this_2 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'kernings'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
  var tmp0_iterator_0 = this_2.a1();
  while (tmp0_iterator_0.b1()) {
    var item_0 = tmp0_iterator_0.c1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var it_0 = item_0.a2x_1;
    var tmp$ret$3 = new Kerning(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'first')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'second')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'amount')));
    destination_0.h(tmp$ret$3);
  }
  var kernings = destination_0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.w(collectionSizeOrDefault(glyphs, 10));
  var tmp0_iterator_1 = glyphs.a1();
  while (tmp0_iterator_1.b1()) {
    var item_1 = tmp0_iterator_1.c1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var tmp$ret$6 = to(item_1.h4e_1, item_1);
    destination_1.h(tmp$ret$6);
  }
  var glyphs_0 = toIntMap(toMap(destination_1));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.w(collectionSizeOrDefault(kernings, 10));
  var tmp0_iterator_2 = kernings.a1();
  while (tmp0_iterator_2.b1()) {
    var item_2 = tmp0_iterator_2.c1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var tmp$ret$9 = to(Companion_instance_18.f4e(item_2.o4e_1, item_2.p4e_1), item_2);
    destination_2.h(tmp$ret$9);
  }
  var kernings_0 = toIntMap(toMap(destination_2));
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs_0, kernings_0, name, distanceField);
}
function readBitmapFontJson(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().p4h_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontJson__a3fd7w.bind(VOID, content, fntFile, textures, props, mipmaps, atlas), $completion);
}
function *_generator_readBitmapFontTxt__tgfm88(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().p4h_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  // Inline function 'kotlin.collections.arrayListOf' call
  var kernings = ArrayList.i1();
  // Inline function 'kotlin.collections.arrayListOf' call
  var glyphs = ArrayList.i1();
  var lineHeight = 16.0;
  var fontSize = 16.0;
  var base = null;
  var _iterator__ex2g4s = lines(content).a1();
  while (_iterator__ex2g4s.b1()) {
    var rline = _iterator__ex2g4s.c1();
    // Inline function 'kotlin.text.trim' call
    var line = toString_0(trim(isCharSequence(rline) ? rline : THROW_CCE()));
    var map = LinkedHashMap.ac();
    var _iterator__ex2g4s_0 = split_0(line, charArrayOf([_Char___init__impl__6a9atx(32)])).a1();
    while (_iterator__ex2g4s_0.b1()) {
      var part = _iterator__ex2g4s_0.c1();
      var _destruct__k2r9zo = plus(split_0(part, charArrayOf([_Char___init__impl__6a9atx(61)])), listOf(['', '']));
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.f1(0);
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.f1(1);
      // Inline function 'kotlin.collections.set' call
      map.f3(key, value);
    }
    if (startsWith(line, 'info')) {
      // Inline function 'kotlin.math.absoluteValue' call
      var tmp44_safe_receiver = map.d3('size');
      var tmp0_elvis_lhs = tmp44_safe_receiver == null ? null : toDouble(tmp44_safe_receiver);
      var this_0 = tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
      fontSize = Math.abs(this_0);
    } else if (startsWith(line, 'page')) {
      var tmp45_safe_receiver = map.d3('id');
      var tmp1_elvis_lhs = tmp45_safe_receiver == null ? null : toInt_0(tmp45_safe_receiver);
      var id = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      var tmp46_safe_receiver = map.d3('file');
      var tmp2_elvis_lhs = tmp46_safe_receiver == null ? null : unquote(tmp46_safe_receiver);
      var tmp;
      if (tmp2_elvis_lhs == null) {
        var message = 'page without file';
        throw IllegalStateException.s4(toString_0(message));
      } else {
        tmp = tmp2_elvis_lhs;
      }
      var file = tmp;
      // Inline function 'kotlin.collections.set' call
      var tmp_0 = readBitmap(fntFile.n24().xh(file), props, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      var value_0 = slice(mipmaps(tmp_0, mipmaps_0));
      textures.f3(id, value_0);
    } else if (startsWith(line, 'common ')) {
      var tmp47_safe_receiver = map.d3('lineHeight');
      var tmp3_elvis_lhs = tmp47_safe_receiver == null ? null : toDoubleOrNull(tmp47_safe_receiver);
      lineHeight = tmp3_elvis_lhs == null ? 16.0 : tmp3_elvis_lhs;
      var tmp48_safe_receiver = map.d3('base');
      base = tmp48_safe_receiver == null ? null : toDoubleOrNull(tmp48_safe_receiver);
    } else if (startsWith(line, 'char ')) {
      var tmp49_safe_receiver = map.d3('page');
      var tmp4_elvis_lhs = tmp49_safe_receiver == null ? null : toIntOrNull(tmp49_safe_receiver);
      var page = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
      var tmp5_elvis_lhs = textures.d3(page);
      var texture = tmp5_elvis_lhs == null ? first(textures.i3()) : tmp5_elvis_lhs;
      var dmap = get_dyn(map);
      var id_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'id'));
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp52_fontSize = fontSize;
      var tmp53_xoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xoffset'));
      var tmp54_yoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'yoffset'));
      var tmp55_xadvance = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xadvance'));
      var tmp_1;
      if (atlas == null) {
        tmp_1 = null;
      } else {
        var tmp_2 = texture.a3i(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + toString_1(numberToChar(id_0)));
        tmp_1 = atlas.v3w(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
      }
      var tmp51_safe_receiver = tmp_1;
      var tmp6_elvis_lhs = tmp51_safe_receiver == null ? null : tmp51_safe_receiver.v3u_1;
      var tmp56_texture = tmp6_elvis_lhs == null ? texture.a3i(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + toString_1(numberToChar(id_0))) : tmp6_elvis_lhs;
      var element = new Glyph(tmp52_fontSize, id_0, tmp56_texture, tmp53_xoffset, tmp54_yoffset, tmp55_xadvance);
      glyphs.h(element);
    } else if (startsWith(line, 'kerning ')) {
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp57_safe_receiver = map.d3('first');
      var tmp7_elvis_lhs = tmp57_safe_receiver == null ? null : toIntOrNull(tmp57_safe_receiver);
      var tmp_3 = tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs;
      var tmp58_safe_receiver = map.d3('second');
      var tmp8_elvis_lhs = tmp58_safe_receiver == null ? null : toIntOrNull(tmp58_safe_receiver);
      var tmp_4 = tmp8_elvis_lhs == null ? 0 : tmp8_elvis_lhs;
      var tmp59_safe_receiver = map.d3('amount');
      var tmp9_elvis_lhs = tmp59_safe_receiver == null ? null : toIntOrNull(tmp59_safe_receiver);
      var element_0 = new Kerning(tmp_3, tmp_4, tmp9_elvis_lhs == null ? 0 : tmp9_elvis_lhs);
      kernings.h(element_0);
    }
  }
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var fontSize_0 = fontSize;
  var lineHeight_0 = lineHeight;
  var tmp10_elvis_lhs = base;
  var base_0 = tmp10_elvis_lhs == null ? lineHeight : tmp10_elvis_lhs;
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(glyphs, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.bc(capacity);
  var tmp0_iterator = glyphs.a1();
  while (tmp0_iterator.b1()) {
    var element_1 = tmp0_iterator.c1();
    // Inline function 'korlibs.image.font.readBitmapFontTxt.<anonymous>' call
    var tmp$ret$6 = element_1.h4e_1;
    destination.f3(tmp$ret$6, element_1);
  }
  var glyphs_0 = toIntMap(destination);
  var kernings_0 = associateByInt(kernings, readBitmapFontTxt$lambda);
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize_0), numberToDouble(lineHeight_0), numberToDouble(base_0), glyphs_0, kernings_0, name, null);
}
function readBitmapFontTxt(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().p4h_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontTxt__tgfm88.bind(VOID, content, fntFile, textures, props, mipmaps, atlas), $completion);
}
function readBitmapFontTxt$lambda(_unused_var__etf5q3, it) {
  return Companion_instance_18.f4e(it.o4e_1, it.p4e_1);
}
function bmp$factory() {
  return getPropertyCallableRef('bmp', 1, KProperty1, function (receiver) {
    return receiver.r4e();
  }, null);
}
function naturalFontMetrics$factory() {
  return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
    return receiver.z4e();
  }, null);
}
function anyGlyph$factory() {
  return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
    return receiver.y4e();
  }, null);
}
function invalidGlyph$factory() {
  return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
    return receiver.o4h();
  }, null);
}
var DefaultTtfFontOrNull;
function get_DefaultTtfFont() {
  if (DefaultTtfFontOrNull == null) {
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.aj();
    // Inline function 'korlibs.image.font.<get-DefaultTtfFont>.<anonymous>' call
    var result = TtfFont.d4k(DefaultTtfFontBytes(), 'Default Font');
    var res = new TimedValue(result, ValueTimeMark__elapsedNow_impl_eonqvs(mark));
    DefaultTtfFontOrNull = res.ar_1;
  }
  return ensureNotNull(DefaultTtfFontOrNull);
}
function DefaultTtfFontBytes() {
  return uncompress(fromBase64('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'), Companion_getInstance_14());
}
function get_DefaultTtfFontAsBitmap() {
  return get_lazyBitmapSDF(get_DefaultTtfFont());
}
function renderGlyphToBitmap(_this__u8e3s4, size, codePoint, paint, fill, effect, border, nativeRendering, reader) {
  paint = paint === VOID ? new RGBA(get_DefaultPaint()) : paint;
  fill = fill === VOID ? true : fill;
  effect = effect === VOID ? null : effect;
  border = border === VOID ? 1 : border;
  nativeRendering = nativeRendering === VOID ? true : nativeRendering;
  reader = reader === VOID ? null : reader;
  var font = _this__u8e3s4;
  var fmetrics = _this__u8e3s4.m4f(size);
  var gmetrics = _this__u8e3s4.v4f(size, codePoint, VOID, reader);
  var gx = -gmetrics.t26();
  var gy = gmetrics.x2i() + gmetrics.v26();
  var border2 = imul(border, 2);
  var iwidth = toIntCeil_0(gmetrics.w2i()) + border2 | 0;
  var iheight = toIntCeil_0(gmetrics.x2i()) + border2 | 0;
  var image = nativeRendering ? NativeImage_0(iwidth, iheight) : Bitmap32.y3v(iwidth, iheight, VOID, true);
  // Inline function 'korlibs.image.bitmap.context2d' call
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = image.j3w_1;
  if (true) {
    image.s3w();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = image.b44(true);
    try {
      // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
      renderGlyphToBitmap$renderGlyph(ctx, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
    }finally {
      ctx.ov();
    }
  }finally {
    result = true ? image.u3w(rect) : 0;
  }
  var imageOut = applyEffect(image.c44(), effect);
  var glyph = new PlacedGlyphMetrics(codePoint, Vector2D.l28(gx + border, gy + border), gmetrics, fmetrics, Companion_getInstance_5().n29_1, 0, 0);
  var tmp = new TextMetrics();
  var tmp_0 = listOf_0(glyph);
  var tmp_1 = listOf_0(listOf_0(glyph));
  // Inline function 'korlibs.image.vector.buildShape' call
  // Inline function 'kotlin.apply' call
  var this_0 = new ShapeBuilder(iwidth, iheight);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
  renderGlyphToBitmap$renderGlyph(this_0, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
  var tmp$ret$3 = this_0.u4k();
  return new TextToBitmapResult(imageOut, fmetrics, tmp, tmp_0, tmp_1, tmp$ret$3);
}
function PlacedGlyphMetrics$boundsPath$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.shape.buildVectorPath' call
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.PlacedGlyphMetrics.boundsPath$delegate.<anonymous>.<anonymous>' call
    this_0.m3e_1 = false;
    this_0.r3n(this$0.x4k_1.t26(), -this$0.y4k_1.e4f_1, this$0.x4k_1.t4f_1, this$0.y4k_1.t4e());
    return applyTransform(this_0, Companion_getInstance_5().q29().t2a(this$0.w4k_1).b2b(this$0.z4k_1));
  };
}
function PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this$0) {
  return function () {
    var curves = getCurves(this$0.g4l());
    var tmp;
    if (!(curves.v39_1.d1() === 4)) {
      println('curves=' + curves.v39_1.d1());
      tmp = Unit_instance;
    }
    return curves;
  };
}
function PlacedGlyphMetrics$caretStart$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.Line2D.flipped' call
    var this_0 = this$0.h4l().v39_1.f1(3).r3d();
    var tmp$ret$0 = Line2D.u28(this_0.t28_1, this_0.s28_1);
    return toBezier(tmp$ret$0);
  };
}
function PlacedGlyphMetrics$caretEnd$delegate$lambda(this$0) {
  return function () {
    return this$0.h4l().v39_1.f1(1);
  };
}
function drawText(_this__u8e3s4, ctx, size, text, paint, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, placed) {
  pos = pos === VOID ? Companion_getInstance_6().e26_1 : pos;
  fill = fill === VOID ? true : fill;
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_51().w4l_1 : align;
  outMetrics = outMetrics === VOID ? null : outMetrics;
  fillStyle = fillStyle === VOID ? null : fillStyle;
  stroke = stroke === VOID ? null : stroke;
  textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
  textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
  placed = placed === VOID ? null : placed;
  var glyphs = !(outMetrics == null) ? new MultiplePlacedGlyphMetrics() : null;
  var fnt = _this__u8e3s4;
  var doRender = drawText$lambda(fillStyle, stroke, ctx, fill);
  var actions = new drawText$actions$1(renderer, text, size, fnt, align, pos, ctx, paint, textRangeStart, textRangeEnd, doRender, glyphs, placed);
  if (ctx == null)
    null;
  else {
    ctx.m4m();
  }
  invoke_1(renderer, actions, text, size, _this__u8e3s4);
  doRender();
  if (!(outMetrics == null)) {
    ensureNotNull(glyphs);
    outMetrics.k4l_1 = glyphs.n4m_1;
    outMetrics.l4l_1 = glyphs.o4m_1;
    var fmetrics = _this__u8e3s4.m4f(size);
    outMetrics.i4l_1 = fmetrics;
    var metrics = outMetrics.j4l_1;
    metrics.r4m_1.t4m(fmetrics);
    metrics.s4m_1 = glyphs.o4m_1.d1();
    var tmp_1 = metrics;
    // Inline function 'kotlin.collections.map' call
    var this_0 = glyphs.o4m_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.font.drawText.<anonymous>' call
      var bb = Companion_getInstance_7().c27();
      var _iterator__ex2g4s = item.a1();
      while (_iterator__ex2g4s.b1()) {
        var g = _iterator__ex2g4s.c1();
        bb = plus_1(bb, g.g4l());
      }
      var tmp$ret$0 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
      destination.h(tmp$ret$0);
    }
    tmp_1.q4m_1 = destination;
    metrics.p4m_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(BoundsBuilder__plus_impl_cz7f7x(Companion_getInstance_7().c27(), metrics.q4m_1));
  }
  return outMetrics;
}
function getTextBounds(_this__u8e3s4, size, text, out, renderer, align) {
  out = out === VOID ? new TextMetrics() : out;
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_51().s4l_1 : align;
  var actions = new BoundBuilderTextRendererActions();
  invoke_1(renderer, actions, text, size, _this__u8e3s4);
  _this__u8e3s4.b4f(size, out.r4m_1);
  out.s4m_1 = actions.j4n();
  var bb = Companion_getInstance_7().c27();
  var dy = 0.0;
  var lineBounds = FastArrayList.r1j();
  var offsetY = actions.n4n(align.l4n_1, out.r4m_1);
  var _iterator__ex2g4s = actions.h4n_1.a1();
  while (_iterator__ex2g4s.b1()) {
    var line = _iterator__ex2g4s.c1();
    var offsetX = line.r4n(align.k4n_1);
    var rect = new Rectangle(-offsetX, +offsetY + dy - out.s4n(), line.p4n_1, line.o4n_1);
    bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, rect);
    lineBounds.h(rect);
    dy = dy + line.o4n_1;
  }
  out.q4m_1 = lineBounds;
  out.p4m_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  return out;
}
function renderGlyphToBitmap$renderGlyph(_this__u8e3s4, $paint, font, $size, $codePoint, gx, $border, gy, gmetrics, $fill) {
  _this__u8e3s4.w4g($paint);
  font.z4g(_this__u8e3s4, $size, $codePoint, Vector2D.l28(gx + $border, gy + $border), true, gmetrics);
  if ($fill) {
    _this__u8e3s4.v4n();
  } else {
    _this__u8e3s4.u4n();
  }
}
function drawText$lambda($fillStyle, $stroke, $ctx, $fill) {
  return function () {
    if (!($fillStyle == null) || !($stroke == null)) {
      var tmp67_safe_receiver = $ctx;
      if (tmp67_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var fill = $fillStyle;
        var stroke = $stroke;
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var stroke_0 = stroke == null ? null : stroke.w4n_1;
        var strokeInfo = stroke == null ? null : stroke.x4n_1;
        // Inline function 'korlibs.image.vector.Context2d.fillStroke.<anonymous>' call
        if (!(fill == null)) {
          tmp67_safe_receiver.y4n(fill);
        }
        if (!(stroke_0 == null)) {
          if (!(strokeInfo == null)) {
            $l$block: {
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              if (stroke_0 == null || strokeInfo == null) {
                break $l$block;
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              var lineWidth = strokeInfo.k38_1;
              var lineCap = strokeInfo.n38_1;
              var lineJoin = strokeInfo.p38_1;
              var miterLimit = strokeInfo.q38_1;
              var lineDash = strokeInfo.r38_1;
              var lineDashOffset = strokeInfo.s38_1;
              if (false) {
                tmp67_safe_receiver.m4m();
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              // Inline function 'korlibs.image.vector.Context2d.keep' call
              tmp67_safe_receiver.f4o();
              try {
                // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
                tmp67_safe_receiver.g4o(numberToDouble(lineWidth));
                tmp67_safe_receiver.h4o(lineCap);
                tmp67_safe_receiver.i4o(lineJoin);
                tmp67_safe_receiver.j4o(numberToDouble(miterLimit));
                tmp67_safe_receiver.k4o(lineDash);
                tmp67_safe_receiver.l4o(numberToDouble(lineDashOffset));
                tmp67_safe_receiver.m4o(stroke_0);
              }finally {
                tmp67_safe_receiver.n4o();
              }
            }
          } else {
            // Inline function 'korlibs.image.vector.Context2d.stroke' call
            var lineWidth_0 = tmp67_safe_receiver.z4n();
            var lineCap_0 = tmp67_safe_receiver.a4o();
            var lineJoin_0 = tmp67_safe_receiver.b4o();
            var miterLimit_0 = tmp67_safe_receiver.c4o();
            var lineDash_0 = tmp67_safe_receiver.d4o();
            var lineDashOffset_0 = tmp67_safe_receiver.e4o();
            if (false) {
              tmp67_safe_receiver.m4m();
            }
            // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
            // Inline function 'korlibs.image.vector.Context2d.keep' call
            tmp67_safe_receiver.f4o();
            try {
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              tmp67_safe_receiver.g4o(numberToDouble(lineWidth_0));
              tmp67_safe_receiver.h4o(lineCap_0);
              tmp67_safe_receiver.i4o(lineJoin_0);
              tmp67_safe_receiver.j4o(numberToDouble(miterLimit_0));
              tmp67_safe_receiver.k4o(lineDash_0);
              tmp67_safe_receiver.l4o(numberToDouble(lineDashOffset_0));
              tmp67_safe_receiver.m4o(stroke_0);
            }finally {
              tmp67_safe_receiver.n4o();
            }
          }
        }
      }
    } else {
      if ($fill) {
        var tmp68_safe_receiver = $ctx;
        if (tmp68_safe_receiver == null)
          null;
        else {
          tmp68_safe_receiver.v4n();
        }
      } else {
        var tmp69_safe_receiver = $ctx;
        if (tmp69_safe_receiver == null)
          null;
        else {
          tmp69_safe_receiver.u4n();
        }
      }
    }
    var tmp70_safe_receiver = $ctx;
    if (tmp70_safe_receiver == null)
      null;
    else {
      tmp70_safe_receiver.m4m();
    }
    return Unit_instance;
  };
}
function boundsPath$factory() {
  return getPropertyCallableRef('boundsPath', 1, KProperty1, function (receiver) {
    return receiver.g4l();
  }, null);
}
function boundsPathCurves$factory() {
  return getPropertyCallableRef('boundsPathCurves', 1, KProperty1, function (receiver) {
    return receiver.h4l();
  }, null);
}
function *_generator_readFont__gkiy77(_this__u8e3s4, preload, props, mipmaps, $completion) {
  preload = preload === VOID ? false : preload;
  props = props === VOID ? Companion_getInstance_39().p4h_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  var tmp = _this__u8e3s4.o24(until(0, 16), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var header = tmp;
  var tmp_0;
  switch (getS32BE(header, 0)) {
    case 1953784678:
    case 1330926671:
    case 65536:
      var tmp_1 = readTtfFont(_this__u8e3s4, VOID, VOID, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp_0 = tmp_1;
      break;
    default:
      var tmp_2 = readBitmapFont(_this__u8e3s4, props, mipmaps, VOID, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_0 = tmp_2;
      break;
  }
  return tmp_0;
}
function readFont(_this__u8e3s4, preload, props, mipmaps, $completion) {
  preload = preload === VOID ? false : preload;
  props = props === VOID ? Companion_getInstance_39().p4h_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readFont__gkiy77.bind(VOID, _this__u8e3s4, preload, props, mipmaps), $completion);
}
var SystemFontRegistryOrNull;
var lazyBitmap$delegate;
function get_lazyBitmapSDF(_this__u8e3s4) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = lazyBitmapSDF$delegate;
    var property = lazyBitmapSDF$factory();
    var tmp0_elvis_lhs = this_0.c1j_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d1j_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c1j_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var lazyBitmapSDF$delegate;
var Companion_instance_20;
function Companion_getInstance_28() {
  if (Companion_instance_20 === VOID)
    new Companion_11();
  return Companion_instance_20;
}
function LazyBitmapFont$anyGlyph$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.b4r_1.f1(this$0.b4r_1.e3().a1().c1());
    return tmp0_elvis_lhs == null ? this$0.o4h() : tmp0_elvis_lhs;
  };
}
function LazyBitmapFont$invalidGlyph$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Glyph(this$0.v4q_1, -1, tmp$ret$0, 0, 0, 0);
  };
}
function LazyBitmapFont$naturalFontMetrics$delegate$lambda(this$0) {
  return function () {
    var descent = this$0.y4q_1.g4f_1 - this$0.y4q_1.i4f_1;
    var tmp78_size = this$0.y4q_1.c4f_1;
    var tmp79_top = this$0.y4q_1.d4f_1;
    var tmp80_ascent = this$0.y4q_1.e4f_1;
    var tmp81_baseline = this$0.y4q_1.f4f_1;
    var tmp82_maxWidth = this$0.y4q_1.j4f_1;
    return new FontMetrics(tmp78_size, tmp79_top, tmp80_ascent, tmp81_baseline, descent, descent, 0.0, tmp82_maxWidth, 0.0);
  };
}
function toLazyBitmapFont(_this__u8e3s4, fontSize, distanceField) {
  distanceField = distanceField === VOID ? null : distanceField;
  _init_properties_LazyBitmapFont_kt__76ptri();
  return new LazyBitmapFont(_this__u8e3s4, fontSize, distanceField);
}
function lazyBitmap$delegate$lambda($this$PropertyThis) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  return toLazyBitmapFont($this$PropertyThis, 32.0, null);
}
function lazyBitmapSDF$delegate$lambda($this$PropertyThis) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  return toLazyBitmapFont($this$PropertyThis, 32.0, 'sdf');
}
function lazyBitmapSDF$factory() {
  return getPropertyCallableRef('lazyBitmapSDF', 1, KProperty1, function (receiver) {
    return get_lazyBitmapSDF(receiver);
  }, null);
}
function anyGlyph$factory_0() {
  return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
    return receiver.y4e();
  }, null);
}
function invalidGlyph$factory_0() {
  return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
    return receiver.o4h();
  }, null);
}
function naturalFontMetrics$factory_0() {
  return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
    return receiver.z4e();
  }, null);
}
var properties_initialized_LazyBitmapFont_kt_c74u44;
function _init_properties_LazyBitmapFont_kt__76ptri() {
  if (!properties_initialized_LazyBitmapFont_kt_c74u44) {
    properties_initialized_LazyBitmapFont_kt_c74u44 = true;
    lazyBitmap$delegate = new PropertyThis(VOID, lazyBitmap$delegate$lambda);
    lazyBitmapSDF$delegate = new PropertyThis(VOID, lazyBitmapSDF$delegate$lambda);
  }
}
var Op_version_instance;
var Op_Copyright_instance;
var Op_Notice_instance;
var Op_isFixedPitch_instance;
var Op_FullName_instance;
var Op_ItalicAngle_instance;
var Op_FamilyName_instance;
var Op_UnderlinePosition_instance;
var Op_Weight_instance;
var Op_UnderlineThickness_instance;
var Op_FontBBox_instance;
var Op_PaintType_instance;
var Op_BlueValues_instance;
var Op_CharstringType_instance;
var Op_OtherBlues_instance;
var Op_FontMatrix_instance;
var Op_FamilyBlues_instance;
var Op_StrokeWidth_instance;
var Op_FamilyOtherBlues_instance;
var Op_BlueScale_instance;
var Op_StdHW_instance;
var Op_BlueShift_instance;
var Op_StdVW_instance;
var Op_BlueFuzz_instance;
var Op_StemSnapH_instance;
var Op_UniqueID_instance;
var Op_StemSnapV_instance;
var Op_XUID_instance;
var Op_ForceBold_instance;
var Op_charset_instance;
var Op_Encoding_instance;
var Op_CharStrings_instance;
var Op_LanguageGroup_instance;
var Op_Private_instance;
var Op_ExpansionFactor_instance;
var Op_Subrs_instance;
var Op_initialRandomSeed_instance;
var Op_defaultWidthX_instance;
var Op_SyntheicBase_instance;
var Op_nominalWidthX_instance;
var Op_PostScript_instance;
var Op_vsindex_instance;
var Op_BaseFontName_instance;
var Op_blend_instance;
var Op_BaseFontBlend_instance;
var Op_vstore_instance;
var Op_maxstack_instance;
var Op_ROS_instance;
var Op_CIDFontVersion_instance;
var Op_CIDFontRevision_instance;
var Op_CIDFontType_instance;
var Op_CIDCount_instance;
var Op_UIDBase_instance;
var Op_FDArray_instance;
var Op_FDSelect_instance;
var Op_FontName_instance;
var Companion_instance_21;
function Companion_getInstance_29() {
  Op_initEntries();
  if (Companion_instance_21 === VOID)
    new Companion_12();
  return Companion_instance_21;
}
function values_0() {
  return [Op_version_getInstance(), Op_Copyright_getInstance(), Op_Notice_getInstance(), Op_isFixedPitch_getInstance(), Op_FullName_getInstance(), Op_ItalicAngle_getInstance(), Op_FamilyName_getInstance(), Op_UnderlinePosition_getInstance(), Op_Weight_getInstance(), Op_UnderlineThickness_getInstance(), Op_FontBBox_getInstance(), Op_PaintType_getInstance(), Op_BlueValues_getInstance(), Op_CharstringType_getInstance(), Op_OtherBlues_getInstance(), Op_FontMatrix_getInstance(), Op_FamilyBlues_getInstance(), Op_StrokeWidth_getInstance(), Op_FamilyOtherBlues_getInstance(), Op_BlueScale_getInstance(), Op_StdHW_getInstance(), Op_BlueShift_getInstance(), Op_StdVW_getInstance(), Op_BlueFuzz_getInstance(), Op_StemSnapH_getInstance(), Op_UniqueID_getInstance(), Op_StemSnapV_getInstance(), Op_XUID_getInstance(), Op_ForceBold_getInstance(), Op_charset_getInstance(), Op_Encoding_getInstance(), Op_CharStrings_getInstance(), Op_LanguageGroup_getInstance(), Op_Private_getInstance(), Op_ExpansionFactor_getInstance(), Op_Subrs_getInstance(), Op_initialRandomSeed_getInstance(), Op_defaultWidthX_getInstance(), Op_SyntheicBase_getInstance(), Op_nominalWidthX_getInstance(), Op_PostScript_getInstance(), Op_vsindex_getInstance(), Op_BaseFontName_getInstance(), Op_blend_getInstance(), Op_BaseFontBlend_getInstance(), Op_vstore_getInstance(), Op_maxstack_getInstance(), Op_ROS_getInstance(), Op_CIDFontVersion_getInstance(), Op_CIDFontRevision_getInstance(), Op_CIDFontType_getInstance(), Op_CIDCount_getInstance(), Op_UIDBase_getInstance(), Op_FDArray_getInstance(), Op_FDSelect_getInstance(), Op_FontName_getInstance()];
}
var Op_entriesInitialized;
function Op_initEntries() {
  if (Op_entriesInitialized)
    return Unit_instance;
  Op_entriesInitialized = true;
  Op_version_instance = new Op('version', 0, 0);
  Op_Copyright_instance = new Op('Copyright', 1, 3072);
  Op_Notice_instance = new Op('Notice', 2, 1);
  Op_isFixedPitch_instance = new Op('isFixedPitch', 3, 3073);
  Op_FullName_instance = new Op('FullName', 4, 2);
  Op_ItalicAngle_instance = new Op('ItalicAngle', 5, 3074);
  Op_FamilyName_instance = new Op('FamilyName', 6, 3);
  Op_UnderlinePosition_instance = new Op('UnderlinePosition', 7, 3075);
  Op_Weight_instance = new Op('Weight', 8, 4);
  Op_UnderlineThickness_instance = new Op('UnderlineThickness', 9, 3076);
  Op_FontBBox_instance = new Op('FontBBox', 10, 5);
  Op_PaintType_instance = new Op('PaintType', 11, 3077);
  Op_BlueValues_instance = new Op('BlueValues', 12, 6);
  Op_CharstringType_instance = new Op('CharstringType', 13, 3078);
  Op_OtherBlues_instance = new Op('OtherBlues', 14, 7);
  Op_FontMatrix_instance = new Op('FontMatrix', 15, 3079);
  Op_FamilyBlues_instance = new Op('FamilyBlues', 16, 8);
  Op_StrokeWidth_instance = new Op('StrokeWidth', 17, 3080);
  Op_FamilyOtherBlues_instance = new Op('FamilyOtherBlues', 18, 9);
  Op_BlueScale_instance = new Op('BlueScale', 19, 3081);
  Op_StdHW_instance = new Op('StdHW', 20, 10);
  Op_BlueShift_instance = new Op('BlueShift', 21, 3082);
  Op_StdVW_instance = new Op('StdVW', 22, 11);
  Op_BlueFuzz_instance = new Op('BlueFuzz', 23, 3083);
  Op_StemSnapH_instance = new Op('StemSnapH', 24, 3084);
  Op_UniqueID_instance = new Op('UniqueID', 25, 13);
  Op_StemSnapV_instance = new Op('StemSnapV', 26, 3085);
  Op_XUID_instance = new Op('XUID', 27, 14);
  Op_ForceBold_instance = new Op('ForceBold', 28, 3086);
  Op_charset_instance = new Op('charset', 29, 15);
  Op_Encoding_instance = new Op('Encoding', 30, 16);
  Op_CharStrings_instance = new Op('CharStrings', 31, 17);
  Op_LanguageGroup_instance = new Op('LanguageGroup', 32, 3089);
  Op_Private_instance = new Op('Private', 33, 18);
  Op_ExpansionFactor_instance = new Op('ExpansionFactor', 34, 3090);
  Op_Subrs_instance = new Op('Subrs', 35, 19);
  Op_initialRandomSeed_instance = new Op('initialRandomSeed', 36, 3091);
  Op_defaultWidthX_instance = new Op('defaultWidthX', 37, 20);
  Op_SyntheicBase_instance = new Op('SyntheicBase', 38, 3092);
  Op_nominalWidthX_instance = new Op('nominalWidthX', 39, 21);
  Op_PostScript_instance = new Op('PostScript', 40, 3093);
  Op_vsindex_instance = new Op('vsindex', 41, 22);
  Op_BaseFontName_instance = new Op('BaseFontName', 42, 3094);
  Op_blend_instance = new Op('blend', 43, 23);
  Op_BaseFontBlend_instance = new Op('BaseFontBlend', 44, 3095);
  Op_vstore_instance = new Op('vstore', 45, 24);
  Op_maxstack_instance = new Op('maxstack', 46, 25);
  Op_ROS_instance = new Op('ROS', 47, 3102);
  Op_CIDFontVersion_instance = new Op('CIDFontVersion', 48, 3103);
  Op_CIDFontRevision_instance = new Op('CIDFontRevision', 49, 3104);
  Op_CIDFontType_instance = new Op('CIDFontType', 50, 3105);
  Op_CIDCount_instance = new Op('CIDCount', 51, 3106);
  Op_UIDBase_instance = new Op('UIDBase', 52, 3107);
  Op_FDArray_instance = new Op('FDArray', 53, 3108);
  Op_FDSelect_instance = new Op('FDSelect', 54, 3109);
  Op_FontName_instance = new Op('FontName', 55, 3110);
  Companion_getInstance_29();
}
function Op_version_getInstance() {
  Op_initEntries();
  return Op_version_instance;
}
function Op_Copyright_getInstance() {
  Op_initEntries();
  return Op_Copyright_instance;
}
function Op_Notice_getInstance() {
  Op_initEntries();
  return Op_Notice_instance;
}
function Op_isFixedPitch_getInstance() {
  Op_initEntries();
  return Op_isFixedPitch_instance;
}
function Op_FullName_getInstance() {
  Op_initEntries();
  return Op_FullName_instance;
}
function Op_ItalicAngle_getInstance() {
  Op_initEntries();
  return Op_ItalicAngle_instance;
}
function Op_FamilyName_getInstance() {
  Op_initEntries();
  return Op_FamilyName_instance;
}
function Op_UnderlinePosition_getInstance() {
  Op_initEntries();
  return Op_UnderlinePosition_instance;
}
function Op_Weight_getInstance() {
  Op_initEntries();
  return Op_Weight_instance;
}
function Op_UnderlineThickness_getInstance() {
  Op_initEntries();
  return Op_UnderlineThickness_instance;
}
function Op_FontBBox_getInstance() {
  Op_initEntries();
  return Op_FontBBox_instance;
}
function Op_PaintType_getInstance() {
  Op_initEntries();
  return Op_PaintType_instance;
}
function Op_BlueValues_getInstance() {
  Op_initEntries();
  return Op_BlueValues_instance;
}
function Op_CharstringType_getInstance() {
  Op_initEntries();
  return Op_CharstringType_instance;
}
function Op_OtherBlues_getInstance() {
  Op_initEntries();
  return Op_OtherBlues_instance;
}
function Op_FontMatrix_getInstance() {
  Op_initEntries();
  return Op_FontMatrix_instance;
}
function Op_FamilyBlues_getInstance() {
  Op_initEntries();
  return Op_FamilyBlues_instance;
}
function Op_StrokeWidth_getInstance() {
  Op_initEntries();
  return Op_StrokeWidth_instance;
}
function Op_FamilyOtherBlues_getInstance() {
  Op_initEntries();
  return Op_FamilyOtherBlues_instance;
}
function Op_BlueScale_getInstance() {
  Op_initEntries();
  return Op_BlueScale_instance;
}
function Op_StdHW_getInstance() {
  Op_initEntries();
  return Op_StdHW_instance;
}
function Op_BlueShift_getInstance() {
  Op_initEntries();
  return Op_BlueShift_instance;
}
function Op_StdVW_getInstance() {
  Op_initEntries();
  return Op_StdVW_instance;
}
function Op_BlueFuzz_getInstance() {
  Op_initEntries();
  return Op_BlueFuzz_instance;
}
function Op_StemSnapH_getInstance() {
  Op_initEntries();
  return Op_StemSnapH_instance;
}
function Op_UniqueID_getInstance() {
  Op_initEntries();
  return Op_UniqueID_instance;
}
function Op_StemSnapV_getInstance() {
  Op_initEntries();
  return Op_StemSnapV_instance;
}
function Op_XUID_getInstance() {
  Op_initEntries();
  return Op_XUID_instance;
}
function Op_ForceBold_getInstance() {
  Op_initEntries();
  return Op_ForceBold_instance;
}
function Op_charset_getInstance() {
  Op_initEntries();
  return Op_charset_instance;
}
function Op_Encoding_getInstance() {
  Op_initEntries();
  return Op_Encoding_instance;
}
function Op_CharStrings_getInstance() {
  Op_initEntries();
  return Op_CharStrings_instance;
}
function Op_LanguageGroup_getInstance() {
  Op_initEntries();
  return Op_LanguageGroup_instance;
}
function Op_Private_getInstance() {
  Op_initEntries();
  return Op_Private_instance;
}
function Op_ExpansionFactor_getInstance() {
  Op_initEntries();
  return Op_ExpansionFactor_instance;
}
function Op_Subrs_getInstance() {
  Op_initEntries();
  return Op_Subrs_instance;
}
function Op_initialRandomSeed_getInstance() {
  Op_initEntries();
  return Op_initialRandomSeed_instance;
}
function Op_defaultWidthX_getInstance() {
  Op_initEntries();
  return Op_defaultWidthX_instance;
}
function Op_SyntheicBase_getInstance() {
  Op_initEntries();
  return Op_SyntheicBase_instance;
}
function Op_nominalWidthX_getInstance() {
  Op_initEntries();
  return Op_nominalWidthX_instance;
}
function Op_PostScript_getInstance() {
  Op_initEntries();
  return Op_PostScript_instance;
}
function Op_vsindex_getInstance() {
  Op_initEntries();
  return Op_vsindex_instance;
}
function Op_BaseFontName_getInstance() {
  Op_initEntries();
  return Op_BaseFontName_instance;
}
function Op_blend_getInstance() {
  Op_initEntries();
  return Op_blend_instance;
}
function Op_BaseFontBlend_getInstance() {
  Op_initEntries();
  return Op_BaseFontBlend_instance;
}
function Op_vstore_getInstance() {
  Op_initEntries();
  return Op_vstore_instance;
}
function Op_maxstack_getInstance() {
  Op_initEntries();
  return Op_maxstack_instance;
}
function Op_ROS_getInstance() {
  Op_initEntries();
  return Op_ROS_instance;
}
function Op_CIDFontVersion_getInstance() {
  Op_initEntries();
  return Op_CIDFontVersion_instance;
}
function Op_CIDFontRevision_getInstance() {
  Op_initEntries();
  return Op_CIDFontRevision_instance;
}
function Op_CIDFontType_getInstance() {
  Op_initEntries();
  return Op_CIDFontType_instance;
}
function Op_CIDCount_getInstance() {
  Op_initEntries();
  return Op_CIDCount_instance;
}
function Op_UIDBase_getInstance() {
  Op_initEntries();
  return Op_UIDBase_instance;
}
function Op_FDArray_getInstance() {
  Op_initEntries();
  return Op_FDArray_instance;
}
function Op_FDSelect_getInstance() {
  Op_initEntries();
  return Op_FDSelect_instance;
}
function Op_FontName_getInstance() {
  Op_initEntries();
  return Op_FontName_instance;
}
var Op_hstem_instance;
var Op_vstem_instance;
var Op_and_instance;
var Op_vmoveto_instance;
var Op_or_instance;
var Op_rlineto_instance;
var Op_not_instance;
var Op_hlineto_instance;
var Op_vlineto_instance;
var Op_rrcurveto_instance;
var Op_abs_instance;
var Op_callsubr_instance;
var Op_add_instance;
var Op_return_instance;
var Op_sub_instance;
var Op_div_instance;
var Op_endchar_instance;
var Op_neg_instance;
var Op_cff2vsidx_instance;
var Op_eq_instance;
var Op_cff2blend_instance;
var Op_hstemhm_instance;
var Op_drop_instance;
var Op_hintmask_instance;
var Op_cntrmask_instance;
var Op_put_instance;
var Op_rmoveto_instance;
var Op_get_instance;
var Op_hmoveto_instance;
var Op_ifelse_instance;
var Op_vstemhm_instance;
var Op_random_instance;
var Op_rcurveline_instance;
var Op_mul_instance;
var Op_rlinecurve_instance;
var Op_vvcurveto_instance;
var Op_sqrt_instance;
var Op_hhcurveto_instance;
var Op_dup_instance;
var Op_exch_instance;
var Op_callgsubr_instance;
var Op_index_instance;
var Op_vhcurveto_instance;
var Op_roll_instance;
var Op_hvcurveto_instance;
var Op_hflex_instance;
var Op_flex_instance;
var Op_hflex1_instance;
var Op_flex1_instance;
var Companion_instance_22;
function Companion_getInstance_30() {
  Op_initEntries_0();
  if (Companion_instance_22 === VOID)
    new Companion_13();
  return Companion_instance_22;
}
function values_1() {
  return [Op_hstem_getInstance(), Op_vstem_getInstance(), Op_and_getInstance(), Op_vmoveto_getInstance(), Op_or_getInstance(), Op_rlineto_getInstance(), Op_not_getInstance(), Op_hlineto_getInstance(), Op_vlineto_getInstance(), Op_rrcurveto_getInstance(), Op_abs_getInstance(), Op_callsubr_getInstance(), Op_add_getInstance(), Op_return_getInstance(), Op_sub_getInstance(), Op_div_getInstance(), Op_endchar_getInstance(), Op_neg_getInstance(), Op_cff2vsidx_getInstance(), Op_eq_getInstance(), Op_cff2blend_getInstance(), Op_hstemhm_getInstance(), Op_drop_getInstance(), Op_hintmask_getInstance(), Op_cntrmask_getInstance(), Op_put_getInstance(), Op_rmoveto_getInstance(), Op_get_getInstance(), Op_hmoveto_getInstance(), Op_ifelse_getInstance(), Op_vstemhm_getInstance(), Op_random_getInstance(), Op_rcurveline_getInstance(), Op_mul_getInstance(), Op_rlinecurve_getInstance(), Op_vvcurveto_getInstance(), Op_sqrt_getInstance(), Op_hhcurveto_getInstance(), Op_dup_getInstance(), Op_exch_getInstance(), Op_callgsubr_getInstance(), Op_index_getInstance(), Op_vhcurveto_getInstance(), Op_roll_getInstance(), Op_hvcurveto_getInstance(), Op_hflex_getInstance(), Op_flex_getInstance(), Op_hflex1_getInstance(), Op_flex1_getInstance()];
}
var Op_entriesInitialized_0;
function Op_initEntries_0() {
  if (Op_entriesInitialized_0)
    return Unit_instance;
  Op_entriesInitialized_0 = true;
  Op_hstem_instance = new Op_0('hstem', 0, 1);
  Op_vstem_instance = new Op_0('vstem', 1, 3);
  Op_and_instance = new Op_0('and', 2, 3075);
  Op_vmoveto_instance = new Op_0('vmoveto', 3, 4);
  Op_or_instance = new Op_0('or', 4, 3076);
  Op_rlineto_instance = new Op_0('rlineto', 5, 5);
  Op_not_instance = new Op_0('not', 6, 3077);
  Op_hlineto_instance = new Op_0('hlineto', 7, 6);
  Op_vlineto_instance = new Op_0('vlineto', 8, 7);
  Op_rrcurveto_instance = new Op_0('rrcurveto', 9, 8);
  Op_abs_instance = new Op_0('abs', 10, 3081);
  Op_callsubr_instance = new Op_0('callsubr', 11, 10);
  Op_add_instance = new Op_0('add', 12, 3082);
  Op_return_instance = new Op_0('return', 13, 11);
  Op_sub_instance = new Op_0('sub', 14, 3083);
  Op_div_instance = new Op_0('div', 15, 3084);
  Op_endchar_instance = new Op_0('endchar', 16, 14);
  Op_neg_instance = new Op_0('neg', 17, 3086);
  Op_cff2vsidx_instance = new Op_0('cff2vsidx', 18, 15);
  Op_eq_instance = new Op_0('eq', 19, 3087);
  Op_cff2blend_instance = new Op_0('cff2blend', 20, 16);
  Op_hstemhm_instance = new Op_0('hstemhm', 21, 18);
  Op_drop_instance = new Op_0('drop', 22, 3090);
  Op_hintmask_instance = new Op_0('hintmask', 23, 19);
  Op_cntrmask_instance = new Op_0('cntrmask', 24, 20);
  Op_put_instance = new Op_0('put', 25, 3092);
  Op_rmoveto_instance = new Op_0('rmoveto', 26, 21);
  Op_get_instance = new Op_0('get', 27, 3093);
  Op_hmoveto_instance = new Op_0('hmoveto', 28, 22);
  Op_ifelse_instance = new Op_0('ifelse', 29, 3094);
  Op_vstemhm_instance = new Op_0('vstemhm', 30, 23);
  Op_random_instance = new Op_0('random', 31, 3095);
  Op_rcurveline_instance = new Op_0('rcurveline', 32, 24);
  Op_mul_instance = new Op_0('mul', 33, 3096);
  Op_rlinecurve_instance = new Op_0('rlinecurve', 34, 25);
  Op_vvcurveto_instance = new Op_0('vvcurveto', 35, 26);
  Op_sqrt_instance = new Op_0('sqrt', 36, 3098);
  Op_hhcurveto_instance = new Op_0('hhcurveto', 37, 27);
  Op_dup_instance = new Op_0('dup', 38, 3099);
  Op_exch_instance = new Op_0('exch', 39, 3100);
  Op_callgsubr_instance = new Op_0('callgsubr', 40, 29);
  Op_index_instance = new Op_0('index', 41, 3101);
  Op_vhcurveto_instance = new Op_0('vhcurveto', 42, 30);
  Op_roll_instance = new Op_0('roll', 43, 3102);
  Op_hvcurveto_instance = new Op_0('hvcurveto', 44, 31);
  Op_hflex_instance = new Op_0('hflex', 45, 3106);
  Op_flex_instance = new Op_0('flex', 46, 3107);
  Op_hflex1_instance = new Op_0('hflex1', 47, 3108);
  Op_flex1_instance = new Op_0('flex1', 48, 3109);
  Companion_getInstance_30();
}
function computeSubrBias($this, count) {
  return count < 1240 ? 107 : count < 33900 ? 1131 : 32768;
}
function Op_hstem_getInstance() {
  Op_initEntries_0();
  return Op_hstem_instance;
}
function Op_vstem_getInstance() {
  Op_initEntries_0();
  return Op_vstem_instance;
}
function Op_and_getInstance() {
  Op_initEntries_0();
  return Op_and_instance;
}
function Op_vmoveto_getInstance() {
  Op_initEntries_0();
  return Op_vmoveto_instance;
}
function Op_or_getInstance() {
  Op_initEntries_0();
  return Op_or_instance;
}
function Op_rlineto_getInstance() {
  Op_initEntries_0();
  return Op_rlineto_instance;
}
function Op_not_getInstance() {
  Op_initEntries_0();
  return Op_not_instance;
}
function Op_hlineto_getInstance() {
  Op_initEntries_0();
  return Op_hlineto_instance;
}
function Op_vlineto_getInstance() {
  Op_initEntries_0();
  return Op_vlineto_instance;
}
function Op_rrcurveto_getInstance() {
  Op_initEntries_0();
  return Op_rrcurveto_instance;
}
function Op_abs_getInstance() {
  Op_initEntries_0();
  return Op_abs_instance;
}
function Op_callsubr_getInstance() {
  Op_initEntries_0();
  return Op_callsubr_instance;
}
function Op_add_getInstance() {
  Op_initEntries_0();
  return Op_add_instance;
}
function Op_return_getInstance() {
  Op_initEntries_0();
  return Op_return_instance;
}
function Op_sub_getInstance() {
  Op_initEntries_0();
  return Op_sub_instance;
}
function Op_div_getInstance() {
  Op_initEntries_0();
  return Op_div_instance;
}
function Op_endchar_getInstance() {
  Op_initEntries_0();
  return Op_endchar_instance;
}
function Op_neg_getInstance() {
  Op_initEntries_0();
  return Op_neg_instance;
}
function Op_cff2vsidx_getInstance() {
  Op_initEntries_0();
  return Op_cff2vsidx_instance;
}
function Op_eq_getInstance() {
  Op_initEntries_0();
  return Op_eq_instance;
}
function Op_cff2blend_getInstance() {
  Op_initEntries_0();
  return Op_cff2blend_instance;
}
function Op_hstemhm_getInstance() {
  Op_initEntries_0();
  return Op_hstemhm_instance;
}
function Op_drop_getInstance() {
  Op_initEntries_0();
  return Op_drop_instance;
}
function Op_hintmask_getInstance() {
  Op_initEntries_0();
  return Op_hintmask_instance;
}
function Op_cntrmask_getInstance() {
  Op_initEntries_0();
  return Op_cntrmask_instance;
}
function Op_put_getInstance() {
  Op_initEntries_0();
  return Op_put_instance;
}
function Op_rmoveto_getInstance() {
  Op_initEntries_0();
  return Op_rmoveto_instance;
}
function Op_get_getInstance() {
  Op_initEntries_0();
  return Op_get_instance;
}
function Op_hmoveto_getInstance() {
  Op_initEntries_0();
  return Op_hmoveto_instance;
}
function Op_ifelse_getInstance() {
  Op_initEntries_0();
  return Op_ifelse_instance;
}
function Op_vstemhm_getInstance() {
  Op_initEntries_0();
  return Op_vstemhm_instance;
}
function Op_random_getInstance() {
  Op_initEntries_0();
  return Op_random_instance;
}
function Op_rcurveline_getInstance() {
  Op_initEntries_0();
  return Op_rcurveline_instance;
}
function Op_mul_getInstance() {
  Op_initEntries_0();
  return Op_mul_instance;
}
function Op_rlinecurve_getInstance() {
  Op_initEntries_0();
  return Op_rlinecurve_instance;
}
function Op_vvcurveto_getInstance() {
  Op_initEntries_0();
  return Op_vvcurveto_instance;
}
function Op_sqrt_getInstance() {
  Op_initEntries_0();
  return Op_sqrt_instance;
}
function Op_hhcurveto_getInstance() {
  Op_initEntries_0();
  return Op_hhcurveto_instance;
}
function Op_dup_getInstance() {
  Op_initEntries_0();
  return Op_dup_instance;
}
function Op_exch_getInstance() {
  Op_initEntries_0();
  return Op_exch_instance;
}
function Op_callgsubr_getInstance() {
  Op_initEntries_0();
  return Op_callgsubr_instance;
}
function Op_index_getInstance() {
  Op_initEntries_0();
  return Op_index_instance;
}
function Op_vhcurveto_getInstance() {
  Op_initEntries_0();
  return Op_vhcurveto_instance;
}
function Op_roll_getInstance() {
  Op_initEntries_0();
  return Op_roll_instance;
}
function Op_hvcurveto_getInstance() {
  Op_initEntries_0();
  return Op_hvcurveto_instance;
}
function Op_hflex_getInstance() {
  Op_initEntries_0();
  return Op_hflex_instance;
}
function Op_flex_getInstance() {
  Op_initEntries_0();
  return Op_flex_instance;
}
function Op_hflex1_getInstance() {
  Op_initEntries_0();
  return Op_hflex1_instance;
}
function Op_flex1_getInstance() {
  Op_initEntries_0();
  return Op_flex1_instance;
}
var CFF_instance;
function CFF_getInstance() {
  return CFF_instance;
}
var CharStringType2_instance;
function CharStringType2_getInstance() {
  return CharStringType2_instance;
}
var TtfCIDFont_instance;
function TtfCIDFont_getInstance() {
  if (TtfCIDFont_instance === VOID)
    new TtfCIDFont();
  return TtfCIDFont_instance;
}
var Companion_instance_23;
function Companion_getInstance_31() {
  if (Companion_instance_23 === VOID)
    new Companion_14();
  return Companion_instance_23;
}
function _get_ss__ndcawb($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.y4y_1;
  ss$factory();
  return this_0.o1();
}
function BaseTtfFont$Table$ss$delegate$lambda(this$0) {
  return function () {
    return ensureNotNull(this$0.x4y_1)();
  };
}
function BaseTtfFont$Companion$readHeaderTables$lambda($$this$run, $table) {
  return function () {
    return $$this$run.w1q($table.v4y_1, $table.w4y_1);
  };
}
var NameId_COPYRIGHT_instance;
var NameId_NAME_instance;
var NameId_STYLE_instance;
var NameId_UNAME_instance;
var NameId_COMPLETE_NAME_instance;
var NameId_RELEASE_VERSION_instance;
var NameId_POSTSCRIPT_NAME_instance;
var NameId_TRADEMARK_instance;
var NameId_MANUFACTURER_instance;
var NameId_DESIGNER_instance;
var NameId_DESCRIPTION_instance;
var NameId_URL_VENDOR_instance;
var NameId_URL_DESIGNER_instance;
var NameId_LICENSE_DESCRIPTION_instance;
var NameId_LICENSE_URL_instance;
var NameId_RESERVED_15_instance;
var NameId_PREFERRED_FAMILY_instance;
var NameId_PREFERRED_SUBFAMILY_instance;
var NameId_COMPATIBLE_FULL_instance;
var NameId_SAMPLE_TEXT_instance;
var NameId_POSTSCRIPT_CID_instance;
var NameId_WWS_FAMILY_NAME_instance;
var NameId_WWS_SUBFAMILY_NAME_instance;
var NameId_LIGHT_BACKGROUND_instance;
var NameId_DARK_BACKGROUND_instance;
var NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
var Companion_instance_24;
function Companion_getInstance_32() {
  return Companion_instance_24;
}
function values_2() {
  return [NameId_COPYRIGHT_getInstance(), NameId_NAME_getInstance(), NameId_STYLE_getInstance(), NameId_UNAME_getInstance(), NameId_COMPLETE_NAME_getInstance(), NameId_RELEASE_VERSION_getInstance(), NameId_POSTSCRIPT_NAME_getInstance(), NameId_TRADEMARK_getInstance(), NameId_MANUFACTURER_getInstance(), NameId_DESIGNER_getInstance(), NameId_DESCRIPTION_getInstance(), NameId_URL_VENDOR_getInstance(), NameId_URL_DESIGNER_getInstance(), NameId_LICENSE_DESCRIPTION_getInstance(), NameId_LICENSE_URL_getInstance(), NameId_RESERVED_15_getInstance(), NameId_PREFERRED_FAMILY_getInstance(), NameId_PREFERRED_SUBFAMILY_getInstance(), NameId_COMPATIBLE_FULL_getInstance(), NameId_SAMPLE_TEXT_getInstance(), NameId_POSTSCRIPT_CID_getInstance(), NameId_WWS_FAMILY_NAME_getInstance(), NameId_WWS_SUBFAMILY_NAME_getInstance(), NameId_LIGHT_BACKGROUND_getInstance(), NameId_DARK_BACKGROUND_getInstance(), NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance()];
}
var NameId_entriesInitialized;
function NameId_initEntries() {
  if (NameId_entriesInitialized)
    return Unit_instance;
  NameId_entriesInitialized = true;
  NameId_COPYRIGHT_instance = new NameId('COPYRIGHT', 0, 0);
  NameId_NAME_instance = new NameId('NAME', 1, 1);
  NameId_STYLE_instance = new NameId('STYLE', 2, 2);
  NameId_UNAME_instance = new NameId('UNAME', 3, 3);
  NameId_COMPLETE_NAME_instance = new NameId('COMPLETE_NAME', 4, 4);
  NameId_RELEASE_VERSION_instance = new NameId('RELEASE_VERSION', 5, 5);
  NameId_POSTSCRIPT_NAME_instance = new NameId('POSTSCRIPT_NAME', 6, 6);
  NameId_TRADEMARK_instance = new NameId('TRADEMARK', 7, 7);
  NameId_MANUFACTURER_instance = new NameId('MANUFACTURER', 8, 8);
  NameId_DESIGNER_instance = new NameId('DESIGNER', 9, 9);
  NameId_DESCRIPTION_instance = new NameId('DESCRIPTION', 10, 10);
  NameId_URL_VENDOR_instance = new NameId('URL_VENDOR', 11, 11);
  NameId_URL_DESIGNER_instance = new NameId('URL_DESIGNER', 12, 12);
  NameId_LICENSE_DESCRIPTION_instance = new NameId('LICENSE_DESCRIPTION', 13, 13);
  NameId_LICENSE_URL_instance = new NameId('LICENSE_URL', 14, 14);
  NameId_RESERVED_15_instance = new NameId('RESERVED_15', 15, 15);
  NameId_PREFERRED_FAMILY_instance = new NameId('PREFERRED_FAMILY', 16, 16);
  NameId_PREFERRED_SUBFAMILY_instance = new NameId('PREFERRED_SUBFAMILY', 17, 17);
  NameId_COMPATIBLE_FULL_instance = new NameId('COMPATIBLE_FULL', 18, 18);
  NameId_SAMPLE_TEXT_instance = new NameId('SAMPLE_TEXT', 19, 19);
  NameId_POSTSCRIPT_CID_instance = new NameId('POSTSCRIPT_CID', 20, 20);
  NameId_WWS_FAMILY_NAME_instance = new NameId('WWS_FAMILY_NAME', 21, 21);
  NameId_WWS_SUBFAMILY_NAME_instance = new NameId('WWS_SUBFAMILY_NAME', 22, 22);
  NameId_LIGHT_BACKGROUND_instance = new NameId('LIGHT_BACKGROUND', 23, 23);
  NameId_DARK_BACKGROUND_instance = new NameId('DARK_BACKGROUND', 24, 23);
  NameId_VARIATION_POSTSCRIPT_PREFIX_instance = new NameId('VARIATION_POSTSCRIPT_PREFIX', 25, 25);
}
var Colrv1Paint_PaintColrLayers_instance;
var Colrv1Paint_PaintSolid_instance;
var Colrv1Paint_PaintVarSolid_instance;
var Colrv1Paint_PaintLinearGradient_instance;
var Colrv1Paint_PaintVarLinearGradient_instance;
var Colrv1Paint_PaintRadialGradient_instance;
var Colrv1Paint_PaintVarRadialGradient_instance;
var Colrv1Paint_PaintSweepGradient_instance;
var Colrv1Paint_PaintVarSweepGradient_instance;
var Colrv1Paint_PaintGlyph_instance;
var Colrv1Paint_PaintColrGlyph_instance;
var Colrv1Paint_PaintTransform_instance;
var Colrv1Paint_PaintVarTransform_instance;
var Colrv1Paint_PaintTranslate_instance;
var Colrv1Paint_PaintVarTranslate_instance;
var Colrv1Paint_PaintScale_instance;
var Colrv1Paint_PaintVarScale_instance;
var Colrv1Paint_PaintScaleAroundCenter_instance;
var Colrv1Paint_PaintVarScaleAroundCenter_instance;
var Colrv1Paint_PaintScaleUniform_instance;
var Colrv1Paint_PaintVarScaleUniform_instance;
var Colrv1Paint_PaintScaleUniformAroundCenter_instance;
var Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
var Colrv1Paint_PaintRotate_instance;
var Colrv1Paint_PaintVarRotate_instance;
var Colrv1Paint_PaintRotateAroundCenter_instance;
var Colrv1Paint_PaintVarRotateAroundCenter_instance;
var Colrv1Paint_PaintSkew_instance;
var Colrv1Paint_PaintVarSkew_instance;
var Colrv1Paint_PaintSkewAroundCenter_instance;
var Colrv1Paint_PaintVarSkewAroundCenter_instance;
var Colrv1Paint_PaintComposite_instance;
var Companion_instance_25;
function Companion_getInstance_33() {
  Colrv1Paint_initEntries();
  if (Companion_instance_25 === VOID)
    new Companion_16();
  return Companion_instance_25;
}
function values_3() {
  return [Colrv1Paint_PaintColrLayers_getInstance(), Colrv1Paint_PaintSolid_getInstance(), Colrv1Paint_PaintVarSolid_getInstance(), Colrv1Paint_PaintLinearGradient_getInstance(), Colrv1Paint_PaintVarLinearGradient_getInstance(), Colrv1Paint_PaintRadialGradient_getInstance(), Colrv1Paint_PaintVarRadialGradient_getInstance(), Colrv1Paint_PaintSweepGradient_getInstance(), Colrv1Paint_PaintVarSweepGradient_getInstance(), Colrv1Paint_PaintGlyph_getInstance(), Colrv1Paint_PaintColrGlyph_getInstance(), Colrv1Paint_PaintTransform_getInstance(), Colrv1Paint_PaintVarTransform_getInstance(), Colrv1Paint_PaintTranslate_getInstance(), Colrv1Paint_PaintVarTranslate_getInstance(), Colrv1Paint_PaintScale_getInstance(), Colrv1Paint_PaintVarScale_getInstance(), Colrv1Paint_PaintScaleAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleAroundCenter_getInstance(), Colrv1Paint_PaintScaleUniform_getInstance(), Colrv1Paint_PaintVarScaleUniform_getInstance(), Colrv1Paint_PaintScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintRotate_getInstance(), Colrv1Paint_PaintVarRotate_getInstance(), Colrv1Paint_PaintRotateAroundCenter_getInstance(), Colrv1Paint_PaintVarRotateAroundCenter_getInstance(), Colrv1Paint_PaintSkew_getInstance(), Colrv1Paint_PaintVarSkew_getInstance(), Colrv1Paint_PaintSkewAroundCenter_getInstance(), Colrv1Paint_PaintVarSkewAroundCenter_getInstance(), Colrv1Paint_PaintComposite_getInstance()];
}
var Colrv1Paint_entriesInitialized;
function Colrv1Paint_initEntries() {
  if (Colrv1Paint_entriesInitialized)
    return Unit_instance;
  Colrv1Paint_entriesInitialized = true;
  Colrv1Paint_PaintColrLayers_instance = new Colrv1Paint('PaintColrLayers', 0);
  Colrv1Paint_PaintSolid_instance = new Colrv1Paint('PaintSolid', 1);
  Colrv1Paint_PaintVarSolid_instance = new Colrv1Paint('PaintVarSolid', 2);
  Colrv1Paint_PaintLinearGradient_instance = new Colrv1Paint('PaintLinearGradient', 3);
  Colrv1Paint_PaintVarLinearGradient_instance = new Colrv1Paint('PaintVarLinearGradient', 4);
  Colrv1Paint_PaintRadialGradient_instance = new Colrv1Paint('PaintRadialGradient', 5);
  Colrv1Paint_PaintVarRadialGradient_instance = new Colrv1Paint('PaintVarRadialGradient', 6);
  Colrv1Paint_PaintSweepGradient_instance = new Colrv1Paint('PaintSweepGradient', 7);
  Colrv1Paint_PaintVarSweepGradient_instance = new Colrv1Paint('PaintVarSweepGradient', 8);
  Colrv1Paint_PaintGlyph_instance = new Colrv1Paint('PaintGlyph', 9);
  Colrv1Paint_PaintColrGlyph_instance = new Colrv1Paint('PaintColrGlyph', 10);
  Colrv1Paint_PaintTransform_instance = new Colrv1Paint('PaintTransform', 11);
  Colrv1Paint_PaintVarTransform_instance = new Colrv1Paint('PaintVarTransform', 12);
  Colrv1Paint_PaintTranslate_instance = new Colrv1Paint('PaintTranslate', 13);
  Colrv1Paint_PaintVarTranslate_instance = new Colrv1Paint('PaintVarTranslate', 14);
  Colrv1Paint_PaintScale_instance = new Colrv1Paint('PaintScale', 15);
  Colrv1Paint_PaintVarScale_instance = new Colrv1Paint('PaintVarScale', 16);
  Colrv1Paint_PaintScaleAroundCenter_instance = new Colrv1Paint('PaintScaleAroundCenter', 17);
  Colrv1Paint_PaintVarScaleAroundCenter_instance = new Colrv1Paint('PaintVarScaleAroundCenter', 18);
  Colrv1Paint_PaintScaleUniform_instance = new Colrv1Paint('PaintScaleUniform', 19);
  Colrv1Paint_PaintVarScaleUniform_instance = new Colrv1Paint('PaintVarScaleUniform', 20);
  Colrv1Paint_PaintScaleUniformAroundCenter_instance = new Colrv1Paint('PaintScaleUniformAroundCenter', 21);
  Colrv1Paint_PaintVarScaleUniformAroundCenter_instance = new Colrv1Paint('PaintVarScaleUniformAroundCenter', 22);
  Colrv1Paint_PaintRotate_instance = new Colrv1Paint('PaintRotate', 23);
  Colrv1Paint_PaintVarRotate_instance = new Colrv1Paint('PaintVarRotate', 24);
  Colrv1Paint_PaintRotateAroundCenter_instance = new Colrv1Paint('PaintRotateAroundCenter', 25);
  Colrv1Paint_PaintVarRotateAroundCenter_instance = new Colrv1Paint('PaintVarRotateAroundCenter', 26);
  Colrv1Paint_PaintSkew_instance = new Colrv1Paint('PaintSkew', 27);
  Colrv1Paint_PaintVarSkew_instance = new Colrv1Paint('PaintVarSkew', 28);
  Colrv1Paint_PaintSkewAroundCenter_instance = new Colrv1Paint('PaintSkewAroundCenter', 29);
  Colrv1Paint_PaintVarSkewAroundCenter_instance = new Colrv1Paint('PaintVarSkewAroundCenter', 30);
  Colrv1Paint_PaintComposite_instance = new Colrv1Paint('PaintComposite', 31);
  Companion_getInstance_33();
}
var Companion_instance_26;
function Companion_getInstance_34() {
  return Companion_instance_26;
}
function NameId_COPYRIGHT_getInstance() {
  NameId_initEntries();
  return NameId_COPYRIGHT_instance;
}
function NameId_NAME_getInstance() {
  NameId_initEntries();
  return NameId_NAME_instance;
}
function NameId_STYLE_getInstance() {
  NameId_initEntries();
  return NameId_STYLE_instance;
}
function NameId_UNAME_getInstance() {
  NameId_initEntries();
  return NameId_UNAME_instance;
}
function NameId_COMPLETE_NAME_getInstance() {
  NameId_initEntries();
  return NameId_COMPLETE_NAME_instance;
}
function NameId_RELEASE_VERSION_getInstance() {
  NameId_initEntries();
  return NameId_RELEASE_VERSION_instance;
}
function NameId_POSTSCRIPT_NAME_getInstance() {
  NameId_initEntries();
  return NameId_POSTSCRIPT_NAME_instance;
}
function NameId_TRADEMARK_getInstance() {
  NameId_initEntries();
  return NameId_TRADEMARK_instance;
}
function NameId_MANUFACTURER_getInstance() {
  NameId_initEntries();
  return NameId_MANUFACTURER_instance;
}
function NameId_DESIGNER_getInstance() {
  NameId_initEntries();
  return NameId_DESIGNER_instance;
}
function NameId_DESCRIPTION_getInstance() {
  NameId_initEntries();
  return NameId_DESCRIPTION_instance;
}
function NameId_URL_VENDOR_getInstance() {
  NameId_initEntries();
  return NameId_URL_VENDOR_instance;
}
function NameId_URL_DESIGNER_getInstance() {
  NameId_initEntries();
  return NameId_URL_DESIGNER_instance;
}
function NameId_LICENSE_DESCRIPTION_getInstance() {
  NameId_initEntries();
  return NameId_LICENSE_DESCRIPTION_instance;
}
function NameId_LICENSE_URL_getInstance() {
  NameId_initEntries();
  return NameId_LICENSE_URL_instance;
}
function NameId_RESERVED_15_getInstance() {
  NameId_initEntries();
  return NameId_RESERVED_15_instance;
}
function NameId_PREFERRED_FAMILY_getInstance() {
  NameId_initEntries();
  return NameId_PREFERRED_FAMILY_instance;
}
function NameId_PREFERRED_SUBFAMILY_getInstance() {
  NameId_initEntries();
  return NameId_PREFERRED_SUBFAMILY_instance;
}
function NameId_COMPATIBLE_FULL_getInstance() {
  NameId_initEntries();
  return NameId_COMPATIBLE_FULL_instance;
}
function NameId_SAMPLE_TEXT_getInstance() {
  NameId_initEntries();
  return NameId_SAMPLE_TEXT_instance;
}
function NameId_POSTSCRIPT_CID_getInstance() {
  NameId_initEntries();
  return NameId_POSTSCRIPT_CID_instance;
}
function NameId_WWS_FAMILY_NAME_getInstance() {
  NameId_initEntries();
  return NameId_WWS_FAMILY_NAME_instance;
}
function NameId_WWS_SUBFAMILY_NAME_getInstance() {
  NameId_initEntries();
  return NameId_WWS_SUBFAMILY_NAME_instance;
}
function NameId_LIGHT_BACKGROUND_getInstance() {
  NameId_initEntries();
  return NameId_LIGHT_BACKGROUND_instance;
}
function NameId_DARK_BACKGROUND_getInstance() {
  NameId_initEntries();
  return NameId_DARK_BACKGROUND_instance;
}
function NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance() {
  NameId_initEntries();
  return NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
}
function Colrv1Paint_PaintColrLayers_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintColrLayers_instance;
}
function Colrv1Paint_PaintSolid_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSolid_instance;
}
function Colrv1Paint_PaintVarSolid_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSolid_instance;
}
function Colrv1Paint_PaintLinearGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintLinearGradient_instance;
}
function Colrv1Paint_PaintVarLinearGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarLinearGradient_instance;
}
function Colrv1Paint_PaintRadialGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRadialGradient_instance;
}
function Colrv1Paint_PaintVarRadialGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRadialGradient_instance;
}
function Colrv1Paint_PaintSweepGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSweepGradient_instance;
}
function Colrv1Paint_PaintVarSweepGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSweepGradient_instance;
}
function Colrv1Paint_PaintGlyph_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintGlyph_instance;
}
function Colrv1Paint_PaintColrGlyph_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintColrGlyph_instance;
}
function Colrv1Paint_PaintTransform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintTransform_instance;
}
function Colrv1Paint_PaintVarTransform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarTransform_instance;
}
function Colrv1Paint_PaintTranslate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintTranslate_instance;
}
function Colrv1Paint_PaintVarTranslate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarTranslate_instance;
}
function Colrv1Paint_PaintScale_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScale_instance;
}
function Colrv1Paint_PaintVarScale_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScale_instance;
}
function Colrv1Paint_PaintScaleAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleAroundCenter_instance;
}
function Colrv1Paint_PaintVarScaleAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleAroundCenter_instance;
}
function Colrv1Paint_PaintScaleUniform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleUniform_instance;
}
function Colrv1Paint_PaintVarScaleUniform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleUniform_instance;
}
function Colrv1Paint_PaintScaleUniformAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleUniformAroundCenter_instance;
}
function Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
}
function Colrv1Paint_PaintRotate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRotate_instance;
}
function Colrv1Paint_PaintVarRotate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRotate_instance;
}
function Colrv1Paint_PaintRotateAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRotateAroundCenter_instance;
}
function Colrv1Paint_PaintVarRotateAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRotateAroundCenter_instance;
}
function Colrv1Paint_PaintSkew_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSkew_instance;
}
function Colrv1Paint_PaintVarSkew_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSkew_instance;
}
function Colrv1Paint_PaintSkewAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSkewAroundCenter_instance;
}
function Colrv1Paint_PaintVarSkewAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSkewAroundCenter_instance;
}
function Colrv1Paint_PaintComposite_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintComposite_instance;
}
var Companion_instance_27;
function Companion_getInstance_35() {
  return Companion_instance_27;
}
function _FWord___init__impl__2rjyqf(data) {
  return data;
}
function _FWord___get_data__impl__9ys4ze($this) {
  return $this;
}
function FWord__toDouble_impl_53j5qp($this) {
  return _FWord___get_data__impl__9ys4ze($this);
}
function *_generator_readTtfFont__nm5tmd(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion) {
  onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
  enableLigatures = enableLigatures === VOID ? true : enableLigatures;
  var tmp = _this__u8e3s4.p24($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return TtfFont.d4k(tmp, get_baseName(_this__u8e3s4), onlyReadMetadata, enableLigatures);
}
function readTtfFont(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion) {
  onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
  enableLigatures = enableLigatures === VOID ? true : enableLigatures;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readTtfFont__nm5tmd.bind(VOID, _this__u8e3s4, onlyReadMetadata, enableLigatures), $completion);
}
function ss$factory() {
  return getPropertyCallableRef('ss', 1, KProperty1, function (receiver) {
    return _get_ss__ndcawb(receiver);
  }, null);
}
var DataFormat_UBYTE_instance;
var DataFormat_STRING_instance;
var DataFormat_USHORT_instance;
var DataFormat_ULONG_instance;
var DataFormat_URATIO_instance;
var DataFormat_SBYTE_instance;
var DataFormat_UNDEFINED_instance;
var DataFormat_SSHORT_instance;
var DataFormat_SLONG_instance;
var DataFormat_SRATIO_instance;
var DataFormat_SFLOAT_instance;
var DataFormat_DFLOAT_instance;
var DataFormat_UNKNOWN_instance;
var Companion_instance_28;
function Companion_getInstance_36() {
  DataFormat_initEntries();
  if (Companion_instance_28 === VOID)
    new Companion_19();
  return Companion_instance_28;
}
function values_4() {
  return [DataFormat_UBYTE_getInstance(), DataFormat_STRING_getInstance(), DataFormat_USHORT_getInstance(), DataFormat_ULONG_getInstance(), DataFormat_URATIO_getInstance(), DataFormat_SBYTE_getInstance(), DataFormat_UNDEFINED_getInstance(), DataFormat_SSHORT_getInstance(), DataFormat_SLONG_getInstance(), DataFormat_SRATIO_getInstance(), DataFormat_SFLOAT_getInstance(), DataFormat_DFLOAT_getInstance(), DataFormat_UNKNOWN_getInstance()];
}
function EXIF$DataFormat$lambda(it) {
  return it;
}
function EXIF$DataFormat$lambda_0(it) {
  return 4;
}
function EXIF$DataFormat$lambda_1(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_2(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_3(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_4(it) {
  return it;
}
function EXIF$DataFormat$lambda_5(it) {
  return it;
}
function EXIF$DataFormat$lambda_6(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_7(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_8(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_9(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_10(it) {
  return imul(it, 8);
}
function EXIF$DataFormat$lambda_11(it) {
  return 0;
}
var DataFormat_entriesInitialized;
function DataFormat_initEntries() {
  if (DataFormat_entriesInitialized)
    return Unit_instance;
  DataFormat_entriesInitialized = true;
  DataFormat_UBYTE_instance = new DataFormat('UBYTE', 0, 1, EXIF$DataFormat$lambda);
  DataFormat_STRING_instance = new DataFormat('STRING', 1, 2, EXIF$DataFormat$lambda_0);
  DataFormat_USHORT_instance = new DataFormat('USHORT', 2, 3, EXIF$DataFormat$lambda_1);
  DataFormat_ULONG_instance = new DataFormat('ULONG', 3, 4, EXIF$DataFormat$lambda_2);
  DataFormat_URATIO_instance = new DataFormat('URATIO', 4, 5, EXIF$DataFormat$lambda_3);
  DataFormat_SBYTE_instance = new DataFormat('SBYTE', 5, 6, EXIF$DataFormat$lambda_4);
  DataFormat_UNDEFINED_instance = new DataFormat('UNDEFINED', 6, 7, EXIF$DataFormat$lambda_5);
  DataFormat_SSHORT_instance = new DataFormat('SSHORT', 7, 8, EXIF$DataFormat$lambda_6);
  DataFormat_SLONG_instance = new DataFormat('SLONG', 8, 9, EXIF$DataFormat$lambda_7);
  DataFormat_SRATIO_instance = new DataFormat('SRATIO', 9, 10, EXIF$DataFormat$lambda_8);
  DataFormat_SFLOAT_instance = new DataFormat('SFLOAT', 10, 11, EXIF$DataFormat$lambda_9);
  DataFormat_DFLOAT_instance = new DataFormat('DFLOAT', 11, 12, EXIF$DataFormat$lambda_10);
  DataFormat_UNKNOWN_instance = new DataFormat('UNKNOWN', 12, -1, EXIF$DataFormat$lambda_11);
  Companion_getInstance_36();
}
function *_generator_readExifBase__4npesx($this, ss, info, debug, $completion) {
  var tmp = sliceHere(ss, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var s = tmp;
  var tmp_0 = readString(s, 2, Charsets_instance.j1g(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var start = tmp_0;
  var tmp_1;
  switch (start) {
    case 'MM':
      tmp_1 = Endian_BIG_ENDIAN_getInstance();
      break;
    case 'II':
      tmp_1 = Endian_LITTLE_ENDIAN_getInstance();
      break;
    default:
      var message = "Not Exif data (not starting with MM or II but '" + start + "')";
      throw IllegalStateException.s4(toString_0(message));
  }
  var endian = tmp_1;
  var tmp_2 = readU16(s, endian, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tagMark = tmp_2;
  var tmp_3 = readS32(s, endian, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var offsetFirstIFD = tmp_3;
  var tmp_4 = readU16(s, endian, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var nDirEntry = tmp_4;
  if (debug) {
    // Inline function 'korlibs.logger.Logger.error' call
    var this_0 = $this.z56_1;
    var level = Level_ERROR_getInstance();
    var tmp_5;
    if (this_0.k2t(level)) {
      // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
      var tmp$ret$0 = 'nDirEntry=' + nDirEntry + ', tagMark=' + tagMark + ', offsetFirstFID=' + offsetFirstIFD;
      this_0.l2t(level, tmp$ret$0);
      tmp_5 = Unit_instance;
    }
  }
  var inductionVariable = 0;
  if (inductionVariable < nDirEntry)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tagPos = s.l1s_1.f2();
      var tmp_6 = readU16(s, endian, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      var tagNumber = tmp_6;
      var tmp_7 = Companion_getInstance_36();
      var tmp_8 = readU16(s, endian, $completion);
      if (tmp_8 === get_COROUTINE_SUSPENDED())
        tmp_8 = yield tmp_8;
      var dataFormat = tmp_7.f1(tmp_8);
      var tmp_9 = readS32(s, endian, $completion);
      if (tmp_9 === get_COROUTINE_SUSPENDED())
        tmp_9 = yield tmp_9;
      var nComponent = tmp_9;
      if (debug) {
        // Inline function 'korlibs.logger.Logger.error' call
        var this_1 = $this.z56_1;
        var level_0 = Level_ERROR_getInstance();
        var tmp_10;
        if (this_1.k2t(level_0)) {
          // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
          var tmp$ret$2 = 'tagPos=' + get_hex(tagPos) + ', tagNumber=' + get_hex(tagNumber) + ', dataFormat=' + dataFormat.toString() + ', nComponent=' + nComponent + ', size=' + dataFormat.x56_1(nComponent);
          this_1.l2t(level_0, tmp$ret$2);
          tmp_10 = Unit_instance;
        }
      }
      var tmp_11 = readBytesExact(s, dataFormat.x56_1(nComponent), $completion);
      if (tmp_11 === get_COROUTINE_SUSPENDED())
        tmp_11 = yield tmp_11;
      var data = tmp_11;
      if (debug) {
        if (dataFormat.equals(DataFormat_STRING_getInstance())) {
          // Inline function 'korlibs.logger.Logger.error' call
          var this_2 = $this.z56_1;
          var level_1 = Level_ERROR_getInstance();
          var tmp_12;
          if (this_2.k2t(level_1)) {
            // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
            var tmp_13 = sliceStart(s, toLong(readExifBase$readInt(data, endian, 0)), VOID, $completion);
            if (tmp_13 === get_COROUTINE_SUSPENDED())
              tmp_13 = yield tmp_13;
            var tmp_14 = readStringz(tmp_13, nComponent, VOID, $completion);
            if (tmp_14 === get_COROUTINE_SUSPENDED())
              tmp_14 = yield tmp_14;
            var tmp$ret$4 = "  - '" + tmp_14 + "'";
            this_2.l2t(level_1, tmp$ret$4);
            tmp_12 = Unit_instance;
          }
        }
      }
      if (tagNumber === 274) {
        var tmp_15;
        switch (readExifBase$readUShort(data, endian, 0)) {
          case 1:
            // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

            tmp_15 = Companion_getInstance_0().z3f_1;
            break;
          case 2:
            // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_HORIZONTAL' call

            tmp_15 = Companion_getInstance_0().d3g_1;
            break;
          case 3:
            tmp_15 = Companion_getInstance_0().b3g_1;
            break;
          case 4:
            // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_VERTICAL' call

            tmp_15 = Companion_getInstance_0().f3g_1;
            break;
          case 5:
            tmp_15 = Companion_getInstance_0().g3g_1;
            break;
          case 6:
            tmp_15 = Companion_getInstance_0().a3g_1;
            break;
          case 7:
            tmp_15 = Companion_getInstance_0().e3g_1;
            break;
          case 8:
            tmp_15 = Companion_getInstance_0().c3g_1;
            break;
          default:
            // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

            tmp_15 = Companion_getInstance_0().z3f_1;
            break;
        }
        set_orientation(info, tmp_15);
      }
      skipToAlign(s, 4, 2);
    }
     while (inductionVariable < nDirEntry);
  return info;
}
function readExifBase$readUShort(data, endian, index) {
  return getU16(data, imul(index, 2), endian.s1e());
}
function readExifBase$readInt(data, endian, index) {
  return getS32(data, imul(index, 4), endian.s1e());
}
function DataFormat_UBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UBYTE_instance;
}
function DataFormat_STRING_getInstance() {
  DataFormat_initEntries();
  return DataFormat_STRING_instance;
}
function DataFormat_USHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_USHORT_instance;
}
function DataFormat_ULONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_ULONG_instance;
}
function DataFormat_URATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_URATIO_instance;
}
function DataFormat_SBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SBYTE_instance;
}
function DataFormat_UNDEFINED_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNDEFINED_instance;
}
function DataFormat_SSHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SSHORT_instance;
}
function DataFormat_SLONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SLONG_instance;
}
function DataFormat_SRATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SRATIO_instance;
}
function DataFormat_SFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SFLOAT_instance;
}
function DataFormat_DFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_DFLOAT_instance;
}
function DataFormat_UNKNOWN_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNKNOWN_instance;
}
var EXIF_instance;
function EXIF_getInstance() {
  if (EXIF_instance === VOID)
    new EXIF();
  return EXIF_instance;
}
var Direction_ONCE_FORWARD_instance;
var Direction_ONCE_REVERSE_instance;
var Direction_FORWARD_instance;
var Direction_REVERSE_instance;
var Direction_PING_PONG_instance;
var Direction_entriesInitialized;
function Direction_initEntries() {
  if (Direction_entriesInitialized)
    return Unit_instance;
  Direction_entriesInitialized = true;
  Direction_ONCE_FORWARD_instance = new Direction('ONCE_FORWARD', 0);
  Direction_ONCE_REVERSE_instance = new Direction('ONCE_REVERSE', 1);
  Direction_FORWARD_instance = new Direction('FORWARD', 2);
  Direction_REVERSE_instance = new Direction('REVERSE', 3);
  Direction_PING_PONG_instance = new Direction('PING_PONG', 4);
}
function ImageAnimation$_init_$lambda_bxp50i(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
  var tmp = a.d57_1;
  // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
  var tmp$ret$1 = b.d57_1;
  return compareValues(tmp, tmp$ret$1);
}
function Direction_FORWARD_getInstance() {
  Direction_initEntries();
  return Direction_FORWARD_instance;
}
var Companion_instance_29;
function Companion_getInstance_37() {
  return Companion_instance_29;
}
function ImageData$framesSortedByPriority$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
  var tmp;
  if (b.f58()) {
    tmp = 2147483647;
  } else {
    tmp = imul(imul(b.e58().f3w_1, b.e58().g3w_1), imul(b.e58().h3w_1, b.e58().h3w_1));
  }
  var tmp_0 = tmp;
  // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
  var tmp_1;
  if (a.f58()) {
    tmp_1 = 2147483647;
  } else {
    tmp_1 = imul(imul(a.e58().f3w_1, a.e58().g3w_1), imul(a.e58().h3w_1, a.e58().h3w_1));
  }
  var tmp$ret$1 = tmp_1;
  return compareValues(tmp_0, tmp$ret$1);
}
var Companion_instance_30;
function Companion_getInstance_38() {
  return Companion_instance_30;
}
function ImageDataContainer$imageDatasByName$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this$0.u58_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.bc(capacity);
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.format.ImageDataContainer.imageDatasByName$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = element.n58_1;
      destination.f3(tmp$ret$0, element);
    }
    return destination;
  };
}
function ImageDataContainer$default$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.x58().d3(null);
    return tmp0_elvis_lhs == null ? first_0(this$0.u58_1) : tmp0_elvis_lhs;
  };
}
function imageDatasByName$factory() {
  return getPropertyCallableRef('imageDatasByName', 1, KProperty1, function (receiver) {
    return receiver.x58();
  }, null);
}
function default$factory() {
  return getPropertyCallableRef('default', 1, KProperty1, function (receiver) {
    return receiver.y58();
  }, null);
}
var tilesetBorder$delegate;
var Companion_instance_31;
function Companion_getInstance_39() {
  if (Companion_instance_31 === VOID)
    new Companion_22();
  return Companion_instance_31;
}
function *_generator_decode__skqvkq($this, file, props, $completion) {
  var tmp = readAsSyncStream(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.r59(tmp, props.p59(file));
}
function ImageFormat$decodingProps$delegate$lambda(this$0) {
  return function () {
    return toProps(this$0);
  };
}
function toProps(_this__u8e3s4, props) {
  props = props === VOID ? Companion_getInstance_39().p4h_1 : props;
  _init_properties_ImageFormat_kt__44biio();
  return props.o59(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, _this__u8e3s4);
}
function tilesetBorder$delegate$lambda() {
  _init_properties_ImageFormat_kt__44biio();
  return 1;
}
function decodingProps$factory() {
  return getPropertyCallableRef('decodingProps', 1, KProperty1, function (receiver) {
    return receiver.l59();
  }, null);
}
var properties_initialized_ImageFormat_kt_anr6ua;
function _init_properties_ImageFormat_kt__44biio() {
  if (!properties_initialized_ImageFormat_kt_anr6ua) {
    properties_initialized_ImageFormat_kt_anr6ua = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = tilesetBorder$delegate$lambda;
    tilesetBorder$delegate = new Property(null, default_0);
  }
}
function listFormats(_this__u8e3s4) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList.i1();
  var tmp0_iterator = _this__u8e3s4.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'korlibs.image.format.listFormats.<anonymous>' call
    var list = listFormats_0(element);
    addAll(destination, list);
  }
  return toMutableSet(destination);
}
function listFormats_0(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ImageFormats) {
    tmp = _this__u8e3s4.n5a();
  } else {
    tmp = setOf_0(_this__u8e3s4);
  }
  return tmp;
}
function _formats$factory() {
  return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
    return receiver.m5a();
  }, function (receiver, value) {
    return receiver.l5a(value);
  });
}
function _formats$factory_0() {
  return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
    return receiver.m5a();
  }, function (receiver, value) {
    return receiver.l5a(value);
  });
}
var Companion_instance_32;
function Companion_getInstance_40() {
  return Companion_instance_32;
}
var Type_NORMAL_instance;
var Type_GROUP_instance;
var Type_TILEMAP_instance;
var Companion_instance_33;
function Companion_getInstance_41() {
  Type_initEntries();
  if (Companion_instance_33 === VOID)
    new Companion_24();
  return Companion_instance_33;
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_NORMAL_instance = new Type('NORMAL', 0);
  Type_GROUP_instance = new Type('GROUP', 1);
  Type_TILEMAP_instance = new Type('TILEMAP', 2);
  Companion_getInstance_41();
}
function Type_NORMAL_getInstance() {
  Type_initEntries();
  return Type_NORMAL_instance;
}
function Type_GROUP_getInstance() {
  Type_initEntries();
  return Type_GROUP_instance;
}
function Type_TILEMAP_getInstance() {
  Type_initEntries();
  return Type_TILEMAP_instance;
}
function set_orientation(_this__u8e3s4, _set____db54di) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var this_0 = orientation$delegate;
  var property = orientation$factory();
  var tmp = _set____db54di;
  var value = tmp == null ? null : new SliceOrientation(tmp);
  var tmp0_elvis_lhs = this_0.a1j_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_orientation(_this__u8e3s4) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = orientation$delegate;
    var property = orientation$factory_0();
    var tmp = _this__u8e3s4.z1i();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a1j_1;
      tmp_0 = tmp0_safe_receiver.d3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b1j_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a1j_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a1j_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      var tmp_2 = r;
      tmp$ret$0 = tmp_2 == null ? null : tmp_2.i3g_1;
      break $l$block;
    }
    var tmp_3 = res;
    tmp$ret$0 = tmp_3 == null ? null : tmp_3.i3g_1;
  }
  return tmp$ret$0;
}
var orientation$delegate;
function orientation$delegate$lambda() {
  _init_properties_ImageOrientation_kt__rodtsl();
  return null;
}
function orientation$factory() {
  return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
    var tmp = get_orientation(receiver);
    return tmp == null ? null : new SliceOrientation(tmp);
  }, function (receiver, value) {
    var tmp = value;
    return set_orientation(receiver, tmp == null ? null : tmp.i3g_1);
  });
}
function orientation$factory_0() {
  return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
    var tmp = get_orientation(receiver);
    return tmp == null ? null : new SliceOrientation(tmp);
  }, function (receiver, value) {
    var tmp = value;
    return set_orientation(receiver, tmp == null ? null : tmp.i3g_1);
  });
}
var properties_initialized_ImageOrientation_kt_37wzbr;
function _init_properties_ImageOrientation_kt__rodtsl() {
  if (!properties_initialized_ImageOrientation_kt_37wzbr) {
    properties_initialized_ImageOrientation_kt_37wzbr = true;
    orientation$delegate = new Property(VOID, orientation$delegate$lambda);
  }
}
function get_imageLoadingLogger() {
  _init_properties_KorioExt_kt__tiega5();
  return imageLoadingLogger;
}
var imageLoadingLogger;
function readBitmapSlice(_this__u8e3s4, name, atlas, props, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  props = props === VOID ? Companion_getInstance_39().p4h_1 : props;
  return readBitmapSlice_0(_this__u8e3s4, props, name, atlas, $completion);
}
function readBitmap(_this__u8e3s4, props, $completion) {
  props = props === VOID ? Companion_getInstance_39().p4h_1 : props;
  return _readBitmap(_this__u8e3s4, VOID, props.l59(), $completion);
}
function *_generator_readBitmapSlice__1cfrfr(_this__u8e3s4, bprops, name, atlas, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  var tmp = readBitmap(_this__u8e3s4, bprops, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var result = tmp;
  return !(atlas == null) ? atlas.c3w(result.c44(), Unit_instance, name).v3u_1 : slice(result, VOID, name);
}
function readBitmapSlice_0(_this__u8e3s4, bprops, name, atlas, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapSlice__1cfrfr.bind(VOID, _this__u8e3s4, bprops, name, atlas), $completion);
}
function *_generator__readBitmap__syf68g(file, bytes, props, $completion) {
  file = file === VOID ? null : file;
  bytes = bytes === VOID ? null : bytes;
  props = props === VOID ? Companion_getInstance_39().p4h_1 : props;
  var prop = !(file == null) ? props.p59(file) : props;
  var rformats = !prop.h59_1 ? listOf_0(prop.i59_1) : prop.i59_1 == null ? listOf_0(null) : prop.g59_1 ? listOf([prop.i59_1, null]) : listOf([null, prop.i59_1]);
  var lastError = null;
  var _iterator__ex2g4s = rformats.a1();
  while (_iterator__ex2g4s.b1()) {
    var format = _iterator__ex2g4s.c1();
    try {
      var rformat = format == null ? get_nativeImageFormatProvider() : format;
      var tmp;
      if (!(bytes == null)) {
        var tmp_0 = rformat.d5a(bytes, prop, $completion);
        if (tmp_0 === get_COROUTINE_SUSPENDED())
          tmp_0 = yield tmp_0;
        tmp = tmp_0;
      } else if (!(file == null)) {
        var tmp_1 = rformat.e5a(file, prop, $completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
        tmp = tmp_1;
      } else {
        throw NotImplementedError.nd();
      }
      var bmp = tmp;
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format._readBitmap.<anonymous>' call
      if (prop.d59_1) {
        asumePremultiplied(bmp);
      }
      return bmp;
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        lastError = e;
        if (e instanceof CancellationException)
          throw e;
        else {
          var tmp_2;
          if (e instanceof FileNotFoundException) {
            tmp_2 = true;
          } else {
            tmp_2 = e instanceof ImageDecoderNotFoundException;
          }
          if (!tmp_2) {
            // Inline function 'korlibs.logger.Logger.info' call
            var this_0 = get_imageLoadingLogger();
            var level = Level_INFO_getInstance();
            var tmp_3;
            if (this_0.k2t(level)) {
              // Inline function 'korlibs.image.format._readBitmap.<anonymous>' call
              this_0.l2t(level, e);
              tmp_3 = Unit_instance;
            }
          }
        }
      } else {
        throw $p;
      }
    }
  }
  throw ensureNotNull(lastError);
}
function _readBitmap(file, bytes, props, $completion) {
  file = file === VOID ? null : file;
  bytes = bytes === VOID ? null : bytes;
  props = props === VOID ? Companion_getInstance_39().p4h_1 : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator__readBitmap__syf68g.bind(VOID, file, bytes, props), $completion);
}
function *_generator_readBitmap__ml2xmr(_this__u8e3s4, props, $completion) {
  props = props === VOID ? new ImageDecodingProps('file.bin') : props;
  var tmp = readAll(_this__u8e3s4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = _readBitmap(VOID, tmp, props.l59(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function readBitmap_0(_this__u8e3s4, props, $completion) {
  props = props === VOID ? new ImageDecodingProps('file.bin') : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmap__ml2xmr.bind(VOID, _this__u8e3s4, props), $completion);
}
var properties_initialized_KorioExt_kt_kjvlu9;
function _init_properties_KorioExt_kt__tiega5() {
  if (!properties_initialized_KorioExt_kt_kjvlu9) {
    properties_initialized_KorioExt_kt_kjvlu9 = true;
    imageLoadingLogger = Companion_getInstance_15().c1h('ImageLoading');
  }
}
function *_generator_decodeInternal__jnwsgt($this, data, props, $completion) {
  if (props.d59_1 || props.c59_1 === false) {
    return $this.d5b(get_RegisteredImageFormats().c5a(data, props), props);
  }
  var tmp = decodeBytes(Companion_instance_7, data, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.e5b(toBitmap(tmp), props);
}
function *_generator_decodeInternal__jnwsgt_0($this, data, props, $completion) {
  if (props.d59_1 || props.c59_1 === false) {
    return $this.d5b(get_RegisteredImageFormats().c5a(data, props), props);
  }
  var tmp = decodeBytes(Companion_instance_7, data, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var image = tmp;
  return $this.d5b($this.z5b(image, props), props);
}
function *_generator_decodeInternal__jnwsgt_1($this, vfs, path, props, $completion) {
  var tmp = vfs.c24(path).q24($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.f5b(tmp, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function *_generator_decodeSuspend__fioeme($this, data, props, $completion) {
  var tmp = $this.f5b(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.e5c_1;
}
function *_generator_decode__skqvkq_0($this, file, props, $completion) {
  var tmp = $this.y5b(file.g22(), file.m22(), props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.e5c_1;
}
function *_generator_decode__skqvkq_1($this, file, props, $completion) {
  var tmp = getUnderlyingUnscapedFile(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.c5c(tmp, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function toBitmap(_this__u8e3s4) {
  return toBitmap_0(_this__u8e3s4.g3u());
}
function toBitmap_0(_this__u8e3s4) {
  return Bitmap32.y3v(_this__u8e3s4.b3u_1, _this__u8e3s4.c3u_1, _this__u8e3s4.d3u_1, _this__u8e3s4.e3u_1);
}
var Colorspace_GRAYSCALE_instance;
var Colorspace_RGB_instance;
var Colorspace_INDEXED_instance;
var Colorspace_GRAYSCALE_ALPHA_instance;
var Colorspace_RGBA_instance;
var Companion_instance_34;
function Companion_getInstance_42() {
  Colorspace_initEntries();
  if (Companion_instance_34 === VOID)
    new Companion_25();
  return Companion_instance_34;
}
function values_5() {
  return [Colorspace_GRAYSCALE_getInstance(), Colorspace_RGB_getInstance(), Colorspace_INDEXED_getInstance(), Colorspace_GRAYSCALE_ALPHA_getInstance(), Colorspace_RGBA_getInstance()];
}
var Colorspace_entriesInitialized;
function Colorspace_initEntries() {
  if (Colorspace_entriesInitialized)
    return Unit_instance;
  Colorspace_entriesInitialized = true;
  Colorspace_GRAYSCALE_instance = new Colorspace('GRAYSCALE', 0, 0, 1);
  Colorspace_RGB_instance = new Colorspace('RGB', 1, 2, 3);
  Colorspace_INDEXED_instance = new Colorspace('INDEXED', 2, 3, 1);
  Colorspace_GRAYSCALE_ALPHA_instance = new Colorspace('GRAYSCALE_ALPHA', 3, 4, 2);
  Colorspace_RGBA_instance = new Colorspace('RGBA', 4, 6, 4);
  Companion_getInstance_42();
}
function readCommon($this, s, readHeader, info) {
  var magic = readS32BE(s);
  if (!(magic === -1991225785))
    throw IllegalArgumentException.l('Invalid PNG file magic: ' + get_hex(magic) + '!=' + get_hex(-1991225785));
  readS32BE(s);
  var pheader = {_v: null};
  var pngdata = ByteArrayBuilder.y1d();
  var rgbPalette = _UByteArrayInt___init__impl__xif7bu_0(768);
  var tmp = 0;
  var tmp_0 = new Int8Array(256);
  while (tmp < 256) {
    tmp_0[tmp] = -1;
    tmp = tmp + 1 | 0;
  }
  var aPalette = _UByteArrayInt___init__impl__xif7bu(tmp_0);
  var paletteCount = {_v: 0};
  while (!get_eof_0(s) && readCommon$readChunk(s, pheader, info, paletteCount, rgbPalette, aPalette, readHeader, pngdata)) {
  }
  if (readHeader)
    return pheader._v;
  var tmp0_elvis_lhs = pheader._v;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException.l('PNG without header!');
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var header = tmp_1;
  var width = header.v5c_1;
  var height = header.w5c_1;
  var outputSizeHint = imul(imul(1 + width | 0, height), header.c5d_1);
  var databb = uncompress(pngdata.d1e(), Companion_getInstance_14());
  var databbp = 0;
  var context = new DecodingContext(header);
  var bpp = context.e5d_1.c5d_1;
  var row32 = context.h5d_1;
  var tmp_2;
  if (header.c5d_1 === 1) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, paletteCount._v);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.y1_1;
    var last = this_0.z1_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.format.PNG.readCommon.<anonymous>' call
        var it = item;
        var tmp$ret$1 = _RGBA___get_value__impl__hhco8v(Companion_getInstance_23().w4b(UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 0 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 1 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 2 | 0), UByteArrayInt__get_impl_px6q8a(aPalette, it)));
        destination.h(tmp$ret$1);
      }
       while (!(item === last));
    tmp_2 = Bitmap8.f47(width, height, VOID, _RgbaArray___init__impl__oib4y4(toIntArray_0(destination)));
  } else {
    tmp_2 = Bitmap32.y3v(width, height, VOID, false);
  }
  var bmp = tmp_2;
  var bmp8 = bmp instanceof Bitmap8 ? bmp : null;
  var bmp32 = bmp instanceof Bitmap32 ? bmp : null;
  var passes = header.b5d_1 === 1 ? $this.n5d_1 : $this.o5d_1;
  var _iterator__ex2g4s = passes.a1();
  while (_iterator__ex2g4s.b1()) {
    var pass = _iterator__ex2g4s.c1();
    var progression = step(until(pass.o5c_1, height), pass.q5c_1);
    var inductionVariable_0 = progression.y1_1;
    var last_0 = progression.z1_1;
    var step_0 = progression.a2_1;
    if (step_0 > 0 && inductionVariable_0 <= last_0 || (step_0 < 0 && last_0 <= inductionVariable_0))
      do {
        var row = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + step_0 | 0;
        var col = pass.p5c_1;
        var colIncrement = pass.r5c_1;
        var pixelsInThisRow = width >>> pass.u5c_1 | 0;
        var bytesInThisRow = imul(imul(pixelsInThisRow, header.c5d_1), header.x5c_1) / 8 | 0;
        var _unary__edvuaz = databbp;
        databbp = _unary__edvuaz + 1 | 0;
        var filter = databb[_unary__edvuaz] & 255;
        var currentRow = context.g5d_1;
        var lastRow = context.f5d_1;
        arraycopy_0(databb, databbp, asByteArray(currentRow), 0, bytesInThisRow);
        databbp = databbp + bytesInThisRow | 0;
        if (!(bmp8 == null)) {
          $this.q5d(filter, lastRow, currentRow, header.c5d_1);
          switch (header.x5c_1) {
            case 1:
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < width)
                do {
                  var n = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x = col + n | 0;
                  var y = row;
                  var color = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n / 8 | 0, 0), 7 - imul(n % 8 | 0, 1) | 0, 1);
                  bmp.j3x(x, y, color);
                }
                 while (inductionVariable_1 < width);
              break;
            case 2:
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < width)
                do {
                  var n_0 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x_0 = col + n_0 | 0;
                  var y_0 = row;
                  var color_0 = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n_0 / 4 | 0, 0), 6 - imul(n_0 % 4 | 0, 2) | 0, 2);
                  bmp.j3x(x_0, y_0, color_0);
                }
                 while (inductionVariable_2 < width);
              break;
            case 4:
              var inductionVariable_3 = 0;
              if (inductionVariable_3 < width)
                do {
                  var n_1 = inductionVariable_3;
                  inductionVariable_3 = inductionVariable_3 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x_1 = col + n_1 | 0;
                  var y_1 = row;
                  var color_1 = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n_1 / 2 | 0, 0), 4 - imul(n_1 % 2 | 0, 4) | 0, 4);
                  bmp.j3x(x_1, y_1, color_1);
                }
                 while (inductionVariable_3 < width);
              break;
            case 8:
              bmp8.u47(col, row, asByteArray(currentRow), width, colIncrement);
              break;
            default:
              // Inline function 'kotlin.error' call

              var message = 'Unsupported header.bitsPerChannel=' + header.x5c_1;
              throw IllegalStateException.s4(toString_0(message));
          }
        } else if (!(bmp32 == null)) {
          if (header.x5c_1 === 8) {
            $this.p5d(filter, lastRow, currentRow, bpp, bytesInThisRow);
            switch (bpp) {
              case 3:
                decode(Companion_getInstance_21(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              case 4:
                decode(Companion_getInstance_23(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              default:
                // Inline function 'kotlin.TODO' call

                var reason = 'Bytes: ' + bpp;
                throw NotImplementedError.nd('An operation is not implemented: ' + reason);
            }
            bmp32.l47(col, row, row32, width, colIncrement);
          } else {
            // Inline function 'kotlin.error' call
            var message_0 = 'Unsupported header.bitsPerChannel=' + header.x5c_1;
            throw IllegalStateException.s4(toString_0(message_0));
          }
        }
        context.r5d();
      }
       while (!(row === last_0));
  }
  return bmp;
}
function readCommon$default($this, s, readHeader, info, $super) {
  info = info === VOID ? new ImageInfo() : info;
  return readCommon($this, s, readHeader, info);
}
function readCommon$readChunk(_this__u8e3s4, pheader, $info, paletteCount, rgbPalette, aPalette, $readHeader, pngdata) {
  if (get_eof_0(_this__u8e3s4))
    return false;
  var length = readS32BE(_this__u8e3s4);
  var type = readStringz_0(_this__u8e3s4, 4);
  var data = readStream(_this__u8e3s4, toLong(length));
  var crc = readS32BE(_this__u8e3s4);
  switch (type) {
    case 'IHDR':
      // Inline function 'kotlin.run' call

      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>' call

      // Inline function 'kotlin.also' call

      var tmp = readS32BE(data);
      var tmp_0 = readS32BE(data);
      var tmp_1 = readU8(data);
      var tmp0_elvis_lhs = Companion_getInstance_42().n5c_1.d3(readU8(data));
      var this_0 = new Header(tmp, tmp_0, tmp_1, tmp0_elvis_lhs == null ? Colorspace_RGBA_getInstance() : tmp0_elvis_lhs, readU8(data), readU8(data), readU8(data));
      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>.<anonymous>' call

      $info.x59_1 = this_0.v5c_1;
      $info.y59_1 = this_0.w5c_1;
      $info.z59_1 = imul(this_0.x5c_1, this_0.y5c_1.m5c_1);
      pheader._v = this_0;
      break;
    case 'PLTE':
      // Inline function 'kotlin.math.max' call

      var a = paletteCount._v;
      var b = data.a().f2() / 3 | 0;
      paletteCount._v = Math.max(a, b);
      data.d1p(asByteArray(rgbPalette), 0, data.a().f2());
      break;
    case 'tRNS':
      // Inline function 'kotlin.math.max' call

      var a_0 = paletteCount._v;
      var b_0 = data.a().f2();
      paletteCount._v = Math.max(a_0, b_0);
      data.d1p(asByteArray(aPalette), 0, data.a().f2());
      break;
    case 'IDAT':
      if ($readHeader) {
        return false;
      }

      pngdata.b1e(readAll_0(data));
      break;
    case 'eXIf':
      runBlockingNoSuspensions(PNG$readCommon$readChunk$slambda_0(data, $info));
      break;
    case 'IEND':
      return false;
  }
  return true;
}
function PNG$readCommon$readChunk$slambda_0($data, $info) {
  var i = new PNG$readCommon$readChunk$slambda($data, $info);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function Colorspace_GRAYSCALE_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_instance;
}
function Colorspace_RGB_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGB_instance;
}
function Colorspace_INDEXED_getInstance() {
  Colorspace_initEntries();
  return Colorspace_INDEXED_instance;
}
function Colorspace_GRAYSCALE_ALPHA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_ALPHA_instance;
}
function Colorspace_RGBA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGBA_instance;
}
var PNG_instance;
function PNG_getInstance() {
  if (PNG_instance === VOID)
    PNG.u5d();
  return PNG_instance;
}
function get_RegisteredImageFormats() {
  _init_properties_RegisteredImageFormats_kt__dq34zn();
  return RegisteredImageFormats;
}
var RegisteredImageFormats;
var properties_initialized_RegisteredImageFormats_kt_ribwxx;
function _init_properties_RegisteredImageFormats_kt__dq34zn() {
  if (!properties_initialized_RegisteredImageFormats_kt_ribwxx) {
    properties_initialized_RegisteredImageFormats_kt_ribwxx = true;
    RegisteredImageFormats = ImageFormatsMutable.u5a([PNG_getInstance()]);
  }
}
var WEBP_WASM_BASE64_ZLIB;
function sumPacked4MulR(a, b, mul) {
  var dstRB = imul(b & 16711935, mul) >>> 8 | 0;
  var dstGA = imul((b >>> 8 | 0) & 16711935, mul) >>> 8 | 0;
  var r = ((a >>> 0 | 0) & 255) + ((dstRB >>> 0 | 0) & 255) | 0;
  var g = ((a >>> 8 | 0) & 255) + ((dstGA >>> 0 | 0) & 255) | 0;
  var b_0 = ((a >>> 16 | 0) & 255) + ((dstRB >>> 16 | 0) & 255) | 0;
  var a_0 = ((a >>> 24 | 0) & 255) + ((dstGA >>> 16 | 0) & 255) | 0;
  return packIntClamped(r, g, b_0, a_0);
}
function d2i(v) {
  return toIntRound(clamp01(v) * 255);
}
function f2i(v) {
  return toIntRound_0(clamp01_0(v) * 255);
}
function packIntUnchecked(r, g, b, a) {
  return (r & 255) << 0 | (g & 255) << 8 | (b & 255) << 16 | (a & 255) << 24;
}
function packIntClamped(r, g, b, a) {
  return clampUByte(r) | clampUByte(g) << 8 | clampUByte(b) << 16 | clampUByte(a) << 24;
}
var Companion_instance_35;
function Companion_getInstance_43() {
  return Companion_instance_35;
}
function _get_fill__d6ivc8($this) {
  var tmp = $this.e5e_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('fill');
  }
}
function color($this, ratio) {
  return RgbaPremultipliedArray__get_impl_1u69ta($this.d5e_1, numberToInt(clamp01_0(ratio) * 255));
}
function _set_texture__qu271y($this, value) {
  $this.p5e_1 = value;
  $this.l5e_1 = $this.p5e_1.f3w_1;
  $this.m5e_1 = $this.p5e_1.g3w_1;
  $this.n5e_1 = 1.0 / $this.l5e_1;
  $this.o5e_1 = 1.0 / $this.m5e_1;
}
var NoneFiller_instance;
function NoneFiller_getInstance() {
  if (NoneFiller_instance === VOID)
    new NoneFiller();
  return NoneFiller_instance;
}
function toFiller(_this__u8e3s4, state) {
  var tmp;
  if (_this__u8e3s4 instanceof NonePaint) {
    tmp = NoneFiller_getInstance();
  } else {
    if (_this__u8e3s4 instanceof RGBA) {
      // Inline function 'kotlin.also' call
      var this_0 = new ColorFiller();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
      this_0.x5d(_this__u8e3s4.i4d_1, state);
      tmp = this_0;
    } else {
      if (_this__u8e3s4 instanceof GradientPaint) {
        // Inline function 'kotlin.also' call
        var this_1 = new GradientFiller();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
        this_1.f5e(_this__u8e3s4, state);
        tmp = this_1;
      } else {
        if (_this__u8e3s4 instanceof BitmapPaint) {
          // Inline function 'kotlin.also' call
          var this_2 = new BitmapFiller();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
          this_2.t5e(_this__u8e3s4, state);
          tmp = this_2;
        } else {
          throw NotImplementedError.nd();
        }
      }
    }
  }
  return tmp;
}
function colorInt(_this__u8e3s4, $this, premultiplied) {
  return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_this__u8e3s4)) : _RGBA___get_value__impl__hhco8v(_this__u8e3s4);
}
function _fillColors($this, out, stops, colors, premultiplied) {
  var numberOfStops = stops.d1();
  var NCOLORS = out.length;
  switch (numberOfStops) {
    case 0:
    case 1:
      var color = numberOfStops === 0 ? Colors_getInstance().o3z_1 : _RGBA___init__impl__lqpay5(colors.gk());
      var pcolor = colorInt(color, $this, premultiplied);
      var inductionVariable = 0;
      if (inductionVariable < NCOLORS)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          out[n] = pcolor;
        }
         while (inductionVariable < NCOLORS);
      break;
    default:
      var inductionVariable_0 = 0;
      var last = _fillColors$stopN(stops, NCOLORS, 0);
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          out[n_0] = colorInt(_RGBA___init__impl__lqpay5(colors.gk()), $this, premultiplied);
        }
         while (inductionVariable_0 < last);
      var inductionVariable_1 = 0;
      var last_0 = numberOfStops - 1 | 0;
      if (inductionVariable_1 < last_0)
        do {
          var n_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var stop0 = _fillColors$stopN(stops, NCOLORS, n_1 + 0 | 0);
          var stop1 = _fillColors$stopN(stops, NCOLORS, n_1 + 1 | 0);
          var color0 = _RGBA___init__impl__lqpay5(colors.s1i(n_1 + 0 | 0));
          var color1 = _RGBA___init__impl__lqpay5(colors.s1i(n_1 + 1 | 0));
          var inductionVariable_2 = stop0;
          if (inductionVariable_2 < stop1)
            do {
              var s = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var ratio = _Ratio___init__impl__9mwvn2(s - stop0 | 0, stop1 - stop0 | 0);
              out[s] = colorInt(Companion_getInstance_23().y4d(color0, color1, ratio), $this, premultiplied);
            }
             while (inductionVariable_2 < stop1);
        }
         while (inductionVariable_1 < last_0);
      var inductionVariable_3 = _fillColors$stopN(stops, NCOLORS, numberOfStops - 1 | 0);
      if (inductionVariable_3 < NCOLORS)
        do {
          var n_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          out[n_2] = colorInt(_RGBA___init__impl__lqpay5(colors.k2k()), $this, premultiplied);
        }
         while (inductionVariable_3 < NCOLORS);
      break;
  }
}
function _fillColors$stopN($stops, NCOLORS, n) {
  return numberToInt($stops.f1(n) * NCOLORS);
}
var Companion_instance_36;
function Companion_getInstance_44() {
  return Companion_instance_36;
}
function colorsToString($this, colors) {
  return '[' + joinToString(new RgbaArray(colors), ', ', VOID, VOID, VOID, VOID, GradientPaint$colorsToString$lambda) + ']';
}
function colorsToString_0($this, colors) {
  return colorsToString($this, _RgbaArray___init__impl__oib4y4(colors.o2k()));
}
function GradientPaint$colorsToString$lambda(it) {
  return _RGBA___get_hexString__impl__kocngm(it.i4d_1);
}
var GradientKind_LINEAR_instance;
var GradientKind_RADIAL_instance;
var GradientKind_SWEEP_instance;
var GradientKind_entriesInitialized;
function GradientKind_initEntries() {
  if (GradientKind_entriesInitialized)
    return Unit_instance;
  GradientKind_entriesInitialized = true;
  GradientKind_LINEAR_instance = new GradientKind('LINEAR', 0);
  GradientKind_RADIAL_instance = new GradientKind('RADIAL', 1);
  GradientKind_SWEEP_instance = new GradientKind('SWEEP', 2);
}
var GradientInterpolationMethod_LINEAR_instance;
var GradientInterpolationMethod_NORMAL_instance;
var GradientInterpolationMethod_entriesInitialized;
function GradientInterpolationMethod_initEntries() {
  if (GradientInterpolationMethod_entriesInitialized)
    return Unit_instance;
  GradientInterpolationMethod_entriesInitialized = true;
  GradientInterpolationMethod_LINEAR_instance = new GradientInterpolationMethod('LINEAR', 0);
  GradientInterpolationMethod_NORMAL_instance = new GradientInterpolationMethod('NORMAL', 1);
}
var GradientUnits_USER_SPACE_ON_USE_instance;
var GradientUnits_OBJECT_BOUNDING_BOX_instance;
var GradientUnits_entriesInitialized;
function GradientUnits_initEntries() {
  if (GradientUnits_entriesInitialized)
    return Unit_instance;
  GradientUnits_entriesInitialized = true;
  GradientUnits_USER_SPACE_ON_USE_instance = new GradientUnits('USER_SPACE_ON_USE', 0);
  GradientUnits_OBJECT_BOUNDING_BOX_instance = new GradientUnits('OBJECT_BOUNDING_BOX', 1);
}
var NonePaint_instance;
function NonePaint_getInstance() {
  return NonePaint_instance;
}
function get_DefaultPaint() {
  return Colors_getInstance().n3x_1;
}
function getPaintWithUnits(_this__u8e3s4, transform, path) {
  var paint = _this__u8e3s4;
  if (!isInterface(paint, TransformedPaint))
    return _this__u8e3s4;
  if (paint.e5f().equals(GradientUnits_USER_SPACE_ON_USE_getInstance()))
    return _this__u8e3s4;
  var bounds = path.s3a();
  var m = Companion_getInstance_5().n29_1.z2a(bounds.m26_1, bounds.n26_1).r2a(bounds.o26_1, bounds.p26_1);
  return paint.k5f(paint.y4p().e2a(m).e2a(transform.c2b()));
}
function GradientKind_LINEAR_getInstance() {
  GradientKind_initEntries();
  return GradientKind_LINEAR_instance;
}
function GradientKind_RADIAL_getInstance() {
  GradientKind_initEntries();
  return GradientKind_RADIAL_instance;
}
function GradientInterpolationMethod_NORMAL_getInstance() {
  GradientInterpolationMethod_initEntries();
  return GradientInterpolationMethod_NORMAL_instance;
}
function GradientUnits_USER_SPACE_ON_USE_getInstance() {
  GradientUnits_initEntries();
  return GradientUnits_USER_SPACE_ON_USE_instance;
}
function GradientUnits_OBJECT_BOUNDING_BOX_getInstance() {
  GradientUnits_initEntries();
  return GradientUnits_OBJECT_BOUNDING_BOX_instance;
}
var color$delegate;
function get_ratio(_this__u8e3s4) {
  _init_properties_CSS_kt__uqsclt();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = ratio$delegate;
    var property = ratio$factory();
    var tmp0_elvis_lhs = this_0.c1j_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d1j_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c1j_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r.l1i_1;
      break $l$block;
    }
    tmp$ret$0 = res.l1i_1;
  }
  return tmp$ret$0;
}
var ratio$delegate;
function get_matrix(_this__u8e3s4) {
  _init_properties_CSS_kt__uqsclt();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = matrix$delegate;
    var property = matrix$factory();
    var tmp0_elvis_lhs = this_0.c1j_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d1j_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c1j_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var matrix$delegate;
var transform$delegate;
function get_easing(_this__u8e3s4) {
  _init_properties_CSS_kt__uqsclt();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = easing$delegate;
    var property = easing$factory();
    var tmp0_elvis_lhs = this_0.c1j_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d1j_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c1j_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var easing$delegate;
function get_animation(_this__u8e3s4) {
  _init_properties_CSS_kt__uqsclt();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = animation$delegate;
    var property = animation$factory();
    var tmp0_elvis_lhs = this_0.c1j_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d1j_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c1j_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var animation$delegate;
function CSS$Expression$exprStr$lambda(it) {
  return it.r5f_1;
}
var Companion_instance_37;
function Companion_getInstance_45() {
  if (Companion_instance_37 === VOID)
    new Companion_28();
  return Companion_instance_37;
}
var Companion_instance_38;
function Companion_getInstance_46() {
  return Companion_instance_38;
}
function tokenize$flush(buffer, out) {
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(buffer) === 0)
    return Unit_instance;
  out.h(new Token(buffer.toString()));
  buffer.xg();
}
function parseTransform$double(doubleArgs, index) {
  // Inline function 'kotlin.collections.getOrElse' call
  // Inline function 'kotlin.contracts.contract' call
  var tmp;
  if (0 <= index ? index < doubleArgs.d1() : false) {
    tmp = doubleArgs.f1(index);
  } else {
    // Inline function 'korlibs.image.style.Companion.parseTransform.double.<anonymous>' call
    tmp = 0.0;
  }
  return tmp;
}
function parseEasing$parseEasing(tr) {
  var tmp;
  switch (tr.a1v()) {
    case 'ease':
      tmp = cubic(Companion_getInstance_10(), 0.25, 0.1, 0.25, 1.0);
      break;
    case 'linear':
      tmp = cubic(Companion_getInstance_10(), 0.0, 0.0, 1.0, 1.0);
      break;
    case 'ease-in':
      tmp = cubic(Companion_getInstance_10(), 0.42, 0.0, 1.0, 1.0);
      break;
    case 'ease-out':
      tmp = cubic(Companion_getInstance_10(), 0.0, 0.0, 0.58, 1.0);
      break;
    case 'ease-in-out':
      tmp = cubic(Companion_getInstance_10(), 0.42, 0.0, 0.58, 1.0);
      break;
    case 'cubic-bezier':
      // Inline function 'kotlin.collections.map' call

      var this_0 = Companion_instance_39.z5f(tr);
      // Inline function 'kotlin.collections.mapTo' call

      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.image.style.Companion.parseEasing.parseEasing.<anonymous>' call
        var tmp0_elvis_lhs = Companion_instance_39.a5g(item);
        var tmp$ret$0 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
        destination.h(tmp$ret$0);
      }

      var doubleArgs = destination;
      tmp = cubic(Companion_getInstance_10(), doubleArgs.f1(0), doubleArgs.f1(1), doubleArgs.f1(2), doubleArgs.f1(3));
      break;
    case 'jump-start':
    case 'start':
      tmp = get_EASE_CLAMP_START(Companion_getInstance_10());
      break;
    case 'jump-end':
    case 'end':
      tmp = get_EASE_CLAMP_END(Companion_getInstance_10());
      break;
    case 'step-start':
      var tmp_0 = CSS$Companion$parseEasing$parseEasing$lambda;
      tmp = new sam$korlibs_math_interpolation_Easing$0(tmp_0);
      break;
    case 'step-end':
      var tmp_1 = CSS$Companion$parseEasing$parseEasing$lambda_0;
      tmp = new sam$korlibs_math_interpolation_Easing$0(tmp_1);
      break;
    default:
      var reason = tr.s1p(-1);
      throw NotImplementedError.nd('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function CSS$Companion$tokenize$lambda($prev) {
  return function (c) {
    // Inline function 'kotlin.also' call
    var this_0 = $prev._v.equals(new Char(_Char___init__impl__6a9atx(42))) && equals(c, new Char(_Char___init__impl__6a9atx(47)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.style.Companion.tokenize.<anonymous>.<anonymous>' call
    $prev._v = c;
    return !this_0;
  };
}
function CSS$Companion$parseEasing$parseEasing$lambda(it) {
  return 1.0;
}
function CSS$Companion$parseEasing$parseEasing$lambda_0(it) {
  return 0.0;
}
var Companion_instance_39;
function Companion_getInstance_47() {
  return Companion_instance_39;
}
function CSSReader$parseRuleset$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.style.CSSReader.parseRuleset.<anonymous>' call
  var tmp = new Ratio(a.o5g_1);
  // Inline function 'korlibs.image.style.CSSReader.parseRuleset.<anonymous>' call
  var tmp$ret$1 = new Ratio(b.o5g_1);
  return compareValues(tmp, tmp$ret$1);
}
function getMatrix(_this__u8e3s4, key, default_0) {
  default_0 = default_0 === VOID ? Companion_getInstance_5().q29() : default_0;
  _init_properties_CSS_kt__uqsclt();
  var tmp = toRatio_0(_this__u8e3s4.r5g_1);
  var tmp247_safe_receiver = _this__u8e3s4.s5g_1.xh(key);
  var tmp248_safe_receiver = tmp247_safe_receiver == null ? null : get_matrix(tmp247_safe_receiver);
  var tmp_0;
  if (tmp248_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_1;
    // Inline function 'korlibs.image.style.getMatrix.<anonymous>' call
    if (tmp248_safe_receiver.s26()) {
      tmp_1 = tmp248_safe_receiver;
    } else {
      tmp_1 = null;
    }
    tmp_0 = tmp_1;
  }
  var tmp0_elvis_lhs = tmp_0;
  var tmp_2 = tmp0_elvis_lhs == null ? default_0 : tmp0_elvis_lhs;
  var tmp249_safe_receiver = _this__u8e3s4.t5g_1.xh(key);
  var tmp1_elvis_lhs = tmp249_safe_receiver == null ? null : get_matrix(tmp249_safe_receiver);
  return interpolate(tmp, tmp_2, tmp1_elvis_lhs == null ? default_0 : tmp1_elvis_lhs);
}
function getRatio(_this__u8e3s4, key, default_0) {
  default_0 = default_0 === VOID ? Companion_getInstance_9().m1i_1 : default_0;
  _init_properties_CSS_kt__uqsclt();
  var tmp = toRatio_0(_this__u8e3s4.r5g_1);
  var tmp245_safe_receiver = _this__u8e3s4.s5g_1.xh(key);
  var tmp0_elvis_lhs = tmp245_safe_receiver == null ? null : get_ratio(tmp245_safe_receiver);
  var tmp_0;
  var tmp_1 = tmp0_elvis_lhs;
  if ((tmp_1 == null ? null : new Ratio(tmp_1)) == null) {
    tmp_0 = default_0;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var tmp_2 = tmp_0;
  var tmp246_safe_receiver = _this__u8e3s4.t5g_1.xh(key);
  var tmp1_elvis_lhs = tmp246_safe_receiver == null ? null : get_ratio(tmp246_safe_receiver);
  var tmp_3;
  var tmp_4 = tmp1_elvis_lhs;
  if ((tmp_4 == null ? null : new Ratio(tmp_4)) == null) {
    tmp_3 = default_0;
  } else {
    tmp_3 = tmp1_elvis_lhs;
  }
  return interpolate_1(tmp, tmp_2, tmp_3);
}
function color$delegate$lambda($this$extraPropertyThis) {
  _init_properties_CSS_kt__uqsclt();
  return new RGBA(Companion_instance_39.r5h($this$extraPropertyThis.i5g_1));
}
function color$delegate$lambda_0(_this__u8e3s4, it) {
  _init_properties_CSS_kt__uqsclt();
  return it;
}
function ratio$delegate$lambda($this$extraPropertyThis) {
  _init_properties_CSS_kt__uqsclt();
  return new Ratio(Companion_instance_39.u5f($this$extraPropertyThis.i5g_1));
}
function ratio$delegate$lambda_0(_this__u8e3s4, it) {
  _init_properties_CSS_kt__uqsclt();
  return it;
}
function matrix$delegate$lambda($this$extraPropertyThis) {
  _init_properties_CSS_kt__uqsclt();
  return Companion_instance_39.p5h($this$extraPropertyThis.i5g_1);
}
function matrix$delegate$lambda_0(_this__u8e3s4, it) {
  _init_properties_CSS_kt__uqsclt();
  return it;
}
function transform$delegate$lambda($this$extraPropertyThis) {
  _init_properties_CSS_kt__uqsclt();
  return get_immutable(get_matrix($this$extraPropertyThis)).e2b();
}
function transform$delegate$lambda_0(_this__u8e3s4, it) {
  _init_properties_CSS_kt__uqsclt();
  return it;
}
function easing$delegate$lambda($this$extraPropertyThis) {
  _init_properties_CSS_kt__uqsclt();
  return Companion_instance_39.s5h($this$extraPropertyThis.i5g_1);
}
function easing$delegate$lambda_0(_this__u8e3s4, it) {
  _init_properties_CSS_kt__uqsclt();
  return it;
}
function animation$delegate$lambda($this$extraPropertyThis) {
  _init_properties_CSS_kt__uqsclt();
  var tmp242_safe_receiver = $this$extraPropertyThis.xh('animation');
  var tmp;
  if (tmp242_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.style.animation$delegate.<anonymous>.<anonymous>' call
    tmp = Companion_instance_39.u5h(tmp242_safe_receiver.i5g_1);
  }
  return tmp;
}
function animation$delegate$lambda_0(_this__u8e3s4, it) {
  _init_properties_CSS_kt__uqsclt();
  return it;
}
function ratio$factory() {
  return getPropertyCallableRef('ratio', 1, KProperty1, function (receiver) {
    return new Ratio(get_ratio(receiver));
  }, null);
}
function matrix$factory() {
  return getPropertyCallableRef('matrix', 1, KProperty1, function (receiver) {
    return get_matrix(receiver);
  }, null);
}
function easing$factory() {
  return getPropertyCallableRef('easing', 1, KProperty1, function (receiver) {
    return get_easing(receiver);
  }, null);
}
function animation$factory() {
  return getPropertyCallableRef('animation', 1, KProperty1, function (receiver) {
    return get_animation(receiver);
  }, null);
}
var properties_initialized_CSS_kt_ks83l9;
function _init_properties_CSS_kt__uqsclt() {
  if (!properties_initialized_CSS_kt_ks83l9) {
    properties_initialized_CSS_kt_ks83l9 = true;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var default_0 = color$delegate$lambda;
    var transform = color$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_0 = new PropertyThis(null, default_0);
    this_0.e1j_1 = transform;
    color$delegate = this_0;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var default_1 = ratio$delegate$lambda;
    var transform_0 = ratio$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_1 = new PropertyThis(null, default_1);
    this_1.e1j_1 = transform_0;
    ratio$delegate = this_1;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var default_2 = matrix$delegate$lambda;
    var transform_1 = matrix$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_2 = new PropertyThis(null, default_2);
    this_2.e1j_1 = transform_1;
    matrix$delegate = this_2;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var default_3 = transform$delegate$lambda;
    var transform_2 = transform$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_3 = new PropertyThis(null, default_3);
    this_3.e1j_1 = transform_2;
    transform$delegate = this_3;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var default_4 = easing$delegate$lambda;
    var transform_3 = easing$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_4 = new PropertyThis(null, default_4);
    this_4.e1j_1 = transform_3;
    easing$delegate = this_4;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var default_5 = animation$delegate$lambda;
    var transform_4 = animation$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_5 = new PropertyThis(null, default_5);
    this_5.e1j_1 = transform_4;
    animation$delegate = this_5;
  }
}
function _get_listener__4cngyf($this) {
  return $this.v5i_1.u5i_1;
}
var Companion_instance_40;
function Companion_getInstance_48() {
  return Companion_instance_40;
}
function _VerticalAlign___init__impl__f42kfq(ratio) {
  return ratio;
}
function _VerticalAlign___get_ratio__impl__b3ilr8($this) {
  return $this;
}
function _VerticalAlign___get_ratioFake__impl__1h2fwv($this) {
  return equals($this, Companion_getInstance_49().t5j_1) ? 1.0 : _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
var Companion_instance_41;
function Companion_getInstance_49() {
  if (Companion_instance_41 === VOID)
    new Companion_32();
  return Companion_instance_41;
}
function VerticalAlign__getOffsetY_impl_iso0y6($this, height, baseline) {
  return equals($this, Companion_getInstance_49().t5j_1) ? baseline : -height * _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
function VerticalAlign__getOffsetYRespectBaseline_impl_62po5b($this, font, totalHeight) {
  return equals($this, Companion_getInstance_49().t5j_1) ? 0.0 : interpolate_2(toRatio_0(_VerticalAlign___get_ratio__impl__b3ilr8($this)), font.d4f_1, font.d4f_1 - totalHeight);
}
function VerticalAlign__toString_impl_hcpnn2($this) {
  return equals($this, Companion_getInstance_49().q5j_1) ? 'TOP' : equals($this, Companion_getInstance_49().r5j_1) ? 'MIDDLE' : equals($this, Companion_getInstance_49().s5j_1) ? 'BOTTOM' : equals($this, Companion_getInstance_49().t5j_1) ? 'BASELINE' : 'VerticalAlign(' + _VerticalAlign___get_ratio__impl__b3ilr8($this) + ')';
}
function VerticalAlign__hashCode_impl_vx8hj7($this) {
  return getNumberHashCode($this);
}
function VerticalAlign__equals_impl_xp13z($this, other) {
  if (!(other instanceof VerticalAlign))
    return false;
  var tmp0_other_with_cast = other instanceof VerticalAlign ? other.w5j_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function _HorizontalAlign___init__impl__ad654o(ratio) {
  return ratio;
}
function _HorizontalAlign___get_ratio__impl__x9wlea($this) {
  return $this;
}
function _HorizontalAlign___get_ratioFake__impl__h46z0d($this) {
  return equals($this, Companion_getInstance_50().x5j_1) ? 0.0 : _HorizontalAlign___get_ratio__impl__x9wlea($this);
}
var Companion_instance_42;
function Companion_getInstance_50() {
  if (Companion_instance_42 === VOID)
    new Companion_33();
  return Companion_instance_42;
}
function HorizontalAlign__getOffsetX_impl_urzzxf($this, width) {
  return equals($this, Companion_getInstance_50().x5j_1) ? 0.0 : width * _HorizontalAlign___get_ratio__impl__x9wlea($this);
}
function HorizontalAlign__toString_impl_toflc0($this) {
  return equals($this, Companion_getInstance_50().y5j_1) ? 'LEFT' : equals($this, Companion_getInstance_50().z5j_1) ? 'CENTER' : equals($this, Companion_getInstance_50().a5k_1) ? 'RIGHT' : equals($this, Companion_getInstance_50().x5j_1) ? 'JUSTIFY' : 'HorizontalAlign(' + _HorizontalAlign___get_ratio__impl__x9wlea($this) + ')';
}
function HorizontalAlign__hashCode_impl_7x9oj5($this) {
  return getNumberHashCode($this);
}
function HorizontalAlign__equals_impl_hkfbhv($this, other) {
  if (!(other instanceof HorizontalAlign))
    return false;
  var tmp0_other_with_cast = other instanceof HorizontalAlign ? other.d5k_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var Companion_instance_43;
function Companion_getInstance_51() {
  if (Companion_instance_43 === VOID)
    new Companion_34();
  return Companion_instance_43;
}
var DefaultWStringTextRenderer;
function get_DefaultStringTextRenderer() {
  _init_properties_TextRenderer_kt__4uayeo();
  return DefaultStringTextRenderer;
}
var DefaultStringTextRenderer;
function CreateWStringTextRenderer(getVersion, handler) {
  var tmp;
  if (getVersion === VOID) {
    tmp = CreateWStringTextRenderer$lambda;
  } else {
    tmp = getVersion;
  }
  getVersion = tmp;
  _init_properties_TextRenderer_kt__4uayeo();
  return new CreateWStringTextRenderer$2(getVersion, handler);
}
function CreateStringTextRenderer(getVersion, handler) {
  var tmp;
  if (getVersion === VOID) {
    tmp = CreateStringTextRenderer$lambda;
  } else {
    tmp = getVersion;
  }
  getVersion = tmp;
  _init_properties_TextRenderer_kt__4uayeo();
  return new CreateStringTextRenderer$2(getVersion, handler);
}
function add($this, x, y) {
  var rx = $this.t1h().c26_1 + $this.y4p().i2a(x, y);
  var ry = $this.t1h().d26_1 + $this.y4p().l2a(x, y);
  $this.f4n_1 = BoundsBuilder__plus_impl_cz7f7x_1($this.f4n_1, Vector2D.l28(rx, ry));
  if ($this.g4n_1 === 0) {
    $this.e4n_1 = BoundsBuilder__plus_impl_cz7f7x_1($this.e4n_1, Vector2D.l28(rx, ry));
  }
  var _receiver__tnumb7 = $this.i4n_1;
  _receiver__tnumb7.q4n_1 = BoundsBuilder__plus_impl_cz7f7x_1(_receiver__tnumb7.q4n_1, Vector2D.l28(rx, ry));
}
function add_0($this, rect) {
  var fx = rect.t26();
  var fy = rect.v26();
  var w = rect.o26_1;
  var h = rect.p26_1;
  add($this, fx, fy);
  add($this, fx + w, fy);
  add($this, fx + w, fy + h);
  add($this, fx, fy + h);
}
function measure(_this__u8e3s4, text, size, defaultFont) {
  _init_properties_TextRenderer_kt__4uayeo();
  var actions = new BoundBuilderTextRendererActions();
  invoke_1(_this__u8e3s4, actions, text, size, defaultFont);
  return actions;
}
function invoke_1(_this__u8e3s4, actions, text, size, defaultFont) {
  _init_properties_TextRenderer_kt__4uayeo();
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.text.invoke.<anonymous>' call
  _this__u8e3s4.g5k(actions, text, size, defaultFont);
}
function DefaultWStringTextRenderer$lambda($this$CreateWStringTextRenderer, text, c, g, advance) {
  _init_properties_TextRenderer_kt__4uayeo();
  $this$CreateWStringTextRenderer.k4p(text, c);
  $this$CreateWStringTextRenderer.g4q(advance);
  return Unit_instance;
}
function DefaultStringTextRenderer$lambda($this$CreateStringTextRenderer, text, c, g, advance) {
  _init_properties_TextRenderer_kt__4uayeo();
  $this$CreateStringTextRenderer.k4p(text, c);
  $this$CreateStringTextRenderer.g4q(advance);
  return Unit_instance;
}
function CreateWStringTextRenderer$lambda() {
  _init_properties_TextRenderer_kt__4uayeo();
  return 0;
}
function CreateStringTextRenderer$lambda() {
  _init_properties_TextRenderer_kt__4uayeo();
  return 0;
}
function CreateStringTextRenderer$o$wstring$lambda($handler) {
  return function ($this$CreateWStringTextRenderer, text, c, g, advance) {
    $handler($this$CreateWStringTextRenderer, text, c, g, advance);
    return Unit_instance;
  };
}
var properties_initialized_TextRenderer_kt_lfmsb6;
function _init_properties_TextRenderer_kt__4uayeo() {
  if (!properties_initialized_TextRenderer_kt_lfmsb6) {
    properties_initialized_TextRenderer_kt_lfmsb6 = true;
    DefaultWStringTextRenderer = CreateWStringTextRenderer(VOID, DefaultWStringTextRenderer$lambda);
    DefaultStringTextRenderer = CreateStringTextRenderer(VOID, DefaultStringTextRenderer$lambda);
  }
}
function overlaps($this, a0, a1, b0, b1) {
  // Inline function 'kotlin.math.min' call
  var min = Math.min(a0, a0);
  // Inline function 'kotlin.math.max' call
  var max = Math.max(a1, a1);
  // Inline function 'kotlin.math.max' call
  var maxMinor = Math.max(a0, b0);
  // Inline function 'kotlin.math.min' call
  var minMajor = Math.min(a1, b1);
  return (min <= maxMinor ? maxMinor <= max : false) || (min <= minMajor ? minMajor <= max : false);
}
function renderFinal$flush(this$0, filler, $state, $winding, fillPath) {
  if (this$0.p5m_1.d5n_1.m28()) {
    this$0.p5m_1.b5n_1 = this$0.n5m_1 ? 4 : 1;
    this$0.t5m_1.z5l_1 = filler;
    this$0.t5m_1.i5m_1 = $state.p4g_1;
    this$0.t5m_1.d2q();
    var tmp = $winding == null ? fillPath.l3e_1 : $winding;
    this$0.p5m_1.j5n(this$0.o5m_1, VOID, VOID, tmp, Bitmap32Context2d$renderFinal$flush$lambda(this$0));
    this$0.t5m_1.kc();
    this$0.p5m_1.d5n_1.d2q();
  }
}
function Bitmap32Context2d$renderFinal$flush$lambda(this$0) {
  return function (x0, x1, y) {
    this$0.t5m_1.x5m(x0, x1, y);
    return Unit_instance;
  };
}
function CompositeOperation$Companion$UNIMPLEMENTED$lambda(dst, dstN, src, srcN, count) {
  mix_0(dst.e4e_1, dstN, src.e4e_1, srcN, count);
  return Unit_instance;
}
var Companion_instance_44;
function Companion_getInstance_52() {
  if (Companion_instance_44 === VOID)
    new Companion_35();
  return Companion_instance_44;
}
var CompositeMode_CLEAR_instance;
var CompositeMode_COPY_instance;
var CompositeMode_SOURCE_OVER_instance;
var CompositeMode_DESTINATION_OVER_instance;
var CompositeMode_SOURCE_IN_instance;
var CompositeMode_DESTINATION_IN_instance;
var CompositeMode_SOURCE_OUT_instance;
var CompositeMode_DESTINATION_OUT_instance;
var CompositeMode_SOURCE_ATOP_instance;
var CompositeMode_DESTINATION_ATOP_instance;
var CompositeMode_XOR_instance;
var CompositeMode_LIGHTER_instance;
var Companion_instance_45;
function Companion_getInstance_53() {
  return Companion_instance_45;
}
function CompositeMode$lambda(dst, dstN, src, srcN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var d = RgbaPremultipliedArray__get_impl_1u69ta(dst.e4e_1, dstN + n | 0);
      var s = RgbaPremultipliedArray__get_impl_1u69ta(src.e4e_1, srcN + n | 0);
      var tmp = dstN + n | 0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(d);
      RgbaPremultipliedArray__set_impl_7fwbby(dst.e4e_1, tmp, _RGBA___get_premultiplied__impl__3bulqc(RGBA__withA_impl_vogscm(tmp$ret$0, clampUByte(_RGBAPremultiplied___get_a__impl__f0hnd1(d) - _RGBAPremultiplied___get_a__impl__f0hnd1(s) | 0))));
    }
     while (inductionVariable < count);
  return Unit_instance;
}
function CompositeMode$lambda_0(dst, dstN, src, srcN, count) {
  mix_1(dst.e4e_1, dstN, dst.e4e_1, dstN, src.e4e_1, srcN, count);
  return Unit_instance;
}
function CompositeMode$lambda_1(dst, dstN, src, srcN, count) {
  mix_1(dst.e4e_1, dstN, src.e4e_1, srcN, dst.e4e_1, dstN, count);
  return Unit_instance;
}
var CompositeMode_entriesInitialized;
function CompositeMode_initEntries() {
  if (CompositeMode_entriesInitialized)
    return Unit_instance;
  CompositeMode_entriesInitialized = true;
  var tmp = Companion_getInstance_52();
  CompositeMode_CLEAR_instance = new CompositeMode('CLEAR', 0, tmp.w5n(CompositeMode$lambda));
  CompositeMode_COPY_instance = new CompositeMode('COPY', 1, Companion_getInstance_52().v5n_1);
  var tmp_0 = Companion_getInstance_52();
  CompositeMode_SOURCE_OVER_instance = new CompositeMode('SOURCE_OVER', 2, tmp_0.w5n(CompositeMode$lambda_0));
  var tmp_1 = Companion_getInstance_52();
  CompositeMode_DESTINATION_OVER_instance = new CompositeMode('DESTINATION_OVER', 3, tmp_1.w5n(CompositeMode$lambda_1));
  CompositeMode_SOURCE_IN_instance = new CompositeMode('SOURCE_IN', 4, Companion_getInstance_52().v5n_1);
  CompositeMode_DESTINATION_IN_instance = new CompositeMode('DESTINATION_IN', 5, Companion_getInstance_52().v5n_1);
  CompositeMode_SOURCE_OUT_instance = new CompositeMode('SOURCE_OUT', 6, Companion_getInstance_52().v5n_1);
  CompositeMode_DESTINATION_OUT_instance = new CompositeMode('DESTINATION_OUT', 7, Companion_getInstance_52().v5n_1);
  CompositeMode_SOURCE_ATOP_instance = new CompositeMode('SOURCE_ATOP', 8, Companion_getInstance_52().v5n_1);
  CompositeMode_DESTINATION_ATOP_instance = new CompositeMode('DESTINATION_ATOP', 9, Companion_getInstance_52().v5n_1);
  CompositeMode_XOR_instance = new CompositeMode('XOR', 10, Companion_getInstance_52().v5n_1);
  CompositeMode_LIGHTER_instance = new CompositeMode('LIGHTER', 11, Companion_getInstance_52().v5n_1);
}
function get_DEFAULT(_this__u8e3s4) {
  return Companion_instance_45.j3o();
}
function CompositeMode_SOURCE_OVER_getInstance() {
  CompositeMode_initEntries();
  return CompositeMode_SOURCE_OVER_instance;
}
function Context2d$State$transformTransform$delegate$lambda(this$0) {
  return function () {
    return this$0.z4f_1.d2b();
  };
}
function trans($this, p) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = $this.g44_1.z4f_1;
    if (this_0.r26()) {
      tmp$ret$0 = p;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.l28(this_0.i2a(p.c26_1, p.d26_1), this_0.l2a(p.c26_1, p.d26_1));
  }
  return tmp$ret$0;
}
function write_0(_this__u8e3s4, path) {
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = path.j3e_1;
  var n_0 = 0;
  while (n_0 < this_0.d1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.s1i(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = path.k3e_1.f1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.l28(tmp, path.k3e_1.f1(_unary__edvuaz_1));
        _this__u8e3s4.b3e(it);
        break;
      case 1:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = path.k3e_1.f1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.l28(tmp_0, path.k3e_1.f1(_unary__edvuaz_3));
        _this__u8e3s4.d3e(it_0);
        break;
      case 2:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = path.k3e_1.f1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var c = Vector2D.l28(tmp_1, path.k3e_1.f1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = path.k3e_1.f1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var a = Vector2D.l28(tmp_2, path.k3e_1.f1(_unary__edvuaz_7));
        _this__u8e3s4.e3e(c, a);
        break;
      case 3:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = path.k3e_1.f1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var c1 = Vector2D.l28(tmp_3, path.k3e_1.f1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = path.k3e_1.f1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var c2 = Vector2D.l28(tmp_4, path.k3e_1.f1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = path.k3e_1.f1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var a_0 = Vector2D.l28(tmp_5, path.k3e_1.f1(_unary__edvuaz_13));
        _this__u8e3s4.g3e(c1, c2, a_0);
        break;
      case 4:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        _this__u8e3s4.y5();
        break;
    }
  }
}
function toBitmapPaint(_this__u8e3s4, state) {
  var filler = toFiller(_this__u8e3s4, state);
  var bb = Companion_getInstance_7().c27();
  bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, state.b4g_1.s3a());
  var tmp = bb;
  var tmp333_safe_receiver = state.a4g_1;
  bb = BoundsBuilder__plus_impl_cz7f7x_0(tmp, tmp333_safe_receiver == null ? null : tmp333_safe_receiver.s3a());
  var bounds = _BoundsBuilder___get_bounds__impl__s1l1gx(bb).n2f(state.z4f_1);
  // Inline function 'kotlin.also' call
  var this_0 = Bitmap32.y3v(toIntCeil_0(bounds.o26_1), toIntCeil_0(bounds.p26_1), VOID, true);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.toBitmapPaint.<anonymous>' call
  filler.b5e(this_0);
  var bmp = this_0;
  return new BitmapPaint(bmp, Companion_getInstance_5().q29().v2a(-bounds.t26(), -bounds.v26()));
}
function render(_this__u8e3s4) {
  var tmp = render_0(_this__u8e3s4, true);
  return tmp instanceof NativeImage ? tmp : THROW_CCE();
}
function scaled_0(_this__u8e3s4, sx, sy) {
  sx = sx === VOID ? 1.0 : sx;
  sy = sy === VOID ? sx : sy;
  return new scaled$1(_this__u8e3s4, sx, sy);
}
function render_0(_this__u8e3s4, native) {
  // Inline function 'korlibs.image.bitmap.context2d' call
  var this_0 = NativeImageOrBitmap32(_this__u8e3s4.w2i(), _this__u8e3s4.x2i(), native);
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = this_0.j3w_1;
  if (true) {
    this_0.s3w();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = this_0.b44(true);
    try {
      // Inline function 'korlibs.image.vector.render.<anonymous>' call
      _this__u8e3s4.q4q(ctx);
    }finally {
      ctx.ov();
    }
  }finally {
    result = true ? this_0.u3w(rect) : 0;
  }
  return this_0;
}
function transformTransform$factory() {
  return getPropertyCallableRef('transformTransform', 1, KProperty1, function (receiver) {
    return receiver.a5o();
  }, null);
}
var CycleMethod_NO_CYCLE_instance;
var CycleMethod_NO_CYCLE_CLAMP_instance;
var CycleMethod_REPEAT_instance;
var CycleMethod_REFLECT_instance;
var Companion_instance_46;
function Companion_getInstance_54() {
  CycleMethod_initEntries();
  if (Companion_instance_46 === VOID)
    new Companion_37();
  return Companion_instance_46;
}
function values_6() {
  return [CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_CLAMP_getInstance(), CycleMethod_REPEAT_getInstance(), CycleMethod_REFLECT_getInstance()];
}
var CycleMethod_entriesInitialized;
function CycleMethod_initEntries() {
  if (CycleMethod_entriesInitialized)
    return Unit_instance;
  CycleMethod_entriesInitialized = true;
  CycleMethod_NO_CYCLE_instance = new CycleMethod('NO_CYCLE', 0);
  CycleMethod_NO_CYCLE_CLAMP_instance = new CycleMethod('NO_CYCLE_CLAMP', 1);
  CycleMethod_REPEAT_instance = new CycleMethod('REPEAT', 2);
  CycleMethod_REFLECT_instance = new CycleMethod('REFLECT', 3);
  Companion_getInstance_54();
}
function _CycleMethodPair___init__impl__y6jlco(data) {
  return data;
}
function _CycleMethodPair___get_data__impl__r5ik0n($this) {
  return $this;
}
function _CycleMethodPair___init__impl__y6jlco_0(x, y) {
  return _CycleMethodPair___init__impl__y6jlco(insert8(insert8(0, x.k3_1, 0), y.k3_1, 8));
}
function _CycleMethodPair___get_x__impl__dgz5uj($this) {
  var tmp = Companion_getInstance_54().w5p_1;
  // Inline function 'korlibs.memory.extract8' call
  return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 0 | 0) & 255];
}
function _CycleMethodPair___get_y__impl__fcnb7o($this) {
  var tmp = Companion_getInstance_54().w5p_1;
  // Inline function 'korlibs.memory.extract8' call
  return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 8 | 0) & 255];
}
function CycleMethodPair__apply_impl_g3sekg($this, ratio) {
  return Vector2D.l28(_CycleMethodPair___get_x__impl__dgz5uj($this).x5p(ratio.c26_1), _CycleMethodPair___get_y__impl__fcnb7o($this).x5p(ratio.d26_1));
}
function CycleMethod_NO_CYCLE_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_NO_CYCLE_instance;
}
function CycleMethod_NO_CYCLE_CLAMP_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_NO_CYCLE_CLAMP_instance;
}
function CycleMethod_REPEAT_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_REPEAT_instance;
}
function CycleMethod_REFLECT_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_REFLECT_instance;
}
function draw_0(_this__u8e3s4, c) {
  c.s56(_this__u8e3s4);
}
function draw_1(_this__u8e3s4, path) {
  _this__u8e3s4.s56(path);
}
function msdfBmp(_this__u8e3s4, width, height) {
  var msdf_0 = msdf(_this__u8e3s4, width, height);
  // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
  // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
  var width_0 = msdf_0.f3w_1 - 0 | 0;
  var inductionVariable = 0;
  var last = 0 + (msdf_0.g3w_1 - 0 | 0) | 0;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var n = msdf_0.a3x(0, 0 + y | 0);
      var inductionVariable_0 = 0;
      var last_0 = 0 + width_0 | 0;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
          n = n + 1 | 0;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value = msdf_0.b49(x, y);
          var tmp = 0 === 3 ? -100.0 : value;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_0 = msdf_0.c49(x, y);
          var tmp_0 = 1 === 3 ? -100.0 : value_0;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_1 = msdf_0.d49(x, y);
          var tmp_1 = 2 === 3 ? -100.0 : value_1;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_2 = msdf_0.e49(x, y);
          var tmp$ret$3 = 3 === 3 ? -100.0 : value_2;
          msdf_0.f49(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  msdf_0.m49(-1.0);
  msdf_0.o49(-1.0, +1.0);
  msdf_0.l49();
  var msdfBitmap = msdf_0.r3w();
  return msdfBitmap;
}
function sdfBmp(_this__u8e3s4, width, height) {
  var tmp = NewSDF_instance;
  var newImage = tmp.e4c(NativeImageContext2d(width, height, VOID, sdfBmp$lambda(_this__u8e3s4)).r3w(), VOID, 0);
  return newImage.x4b_1.c44();
}
function msdf(_this__u8e3s4, width, height) {
  return msdf_0(_this__u8e3s4, FloatBitmap32.z48(width, height));
}
function msdf_0(_this__u8e3s4, data) {
  var path = _this__u8e3s4;
  var curvesList = toCurvesList(path);
  var p = Vector2D.w28();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(curvesList, 10));
  var tmp0_iterator = curvesList.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
    var tmp$ret$0 = colorize(item.v39_1, item.w39_1);
    destination.h(tmp$ret$0);
  }
  var colorizedCurves = destination;
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList.i1();
  var tmp0_iterator_0 = colorizedCurves.a1();
  while (tmp0_iterator_0.b1()) {
    var element = tmp0_iterator_0.c1();
    // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
    var list = element.y5p_1;
    addAll(destination_0, list);
  }
  var allColorizedCurves = new ColorizedBeziers(destination_0);
  var inductionVariable = 0;
  var last = data.g3w_1;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = data.f3w_1;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          p = Vector2D.l28(x + 0.5, y + 0.5);
          var inside = path.m3o(p);
          var allDist = allColorizedCurves.g5q().k5q(p);
          var redDist = allColorizedCurves.l5q().k5q(p);
          var greenDist = allColorizedCurves.m5q().k5q(p);
          var blueDist = allColorizedCurves.n5q().k5q(p);
          var minR = redDist;
          var minG = greenDist;
          var minB = blueDist;
          var minA = allDist;
          if (inside) {
            minR = -minR;
            minG = -minG;
            minB = -minB;
            minA = -minA;
          }
          data.f49(x, y, minR, minG, minB, minA);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return data;
}
function ColorizedBeziers$red$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.y5p_1;
    var destination = ArrayList.i1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.red$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_r__impl__duz7mo(element.p5q_1) === 0)) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$green$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.y5p_1;
    var destination = ArrayList.i1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.green$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_g__impl__o8pukr(element.p5q_1) === 0)) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$blue$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.y5p_1;
    var destination = ArrayList.i1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.blue$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_b__impl__m6tl80(element.p5q_1) === 0)) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$allProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.y5p_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.allProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.o5q_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$redProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.q5q();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.redProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.o5q_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$greenProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.r5q();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.greenProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.o5q_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$blueProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.s5q();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.blueProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.o5q_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function colorize(_this__u8e3s4, closed) {
  closed = closed === VOID ? true : closed;
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(_this__u8e3s4, 10));
  var index = 0;
  var tmp0_iterator = _this__u8e3s4.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.vector.colorize.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var index_0 = checkIndexOverflow(tmp1);
    var color = msdfColor(index_0, _this__u8e3s4.d1(), closed);
    var tmp$ret$0 = new ColoredBezier(item, color);
    destination.h(tmp$ret$0);
  }
  return new ColorizedBeziers(destination);
}
function msdfColor(index, size, closed) {
  if (size === 1)
    return Colors_getInstance().m3x_1;
  if (index === 0)
    return Colors_getInstance().o3z_1;
  return ((index - 1 | 0) % 2 | 0) === 0 ? Colors_getInstance().c43_1 : Colors_getInstance().m3y_1;
}
function sdfBmp$lambda($this_sdfBmp) {
  return function ($this$NativeImageContext2d) {
    var paint = new RGBA(Colors_getInstance().m3x_1);
    if (true) {
      $this$NativeImageContext2d.m4m();
    }
    // Inline function 'korlibs.image.vector.sdfBmp.<anonymous>.<anonymous>' call
    write($this$NativeImageContext2d, $this_sdfBmp);
    $this$NativeImageContext2d.j5p(paint, null);
    return Unit_instance;
  };
}
function red$factory() {
  return getPropertyCallableRef('red', 1, KProperty1, function (receiver) {
    return receiver.q5q();
  }, null);
}
function green$factory() {
  return getPropertyCallableRef('green', 1, KProperty1, function (receiver) {
    return receiver.r5q();
  }, null);
}
function blue$factory() {
  return getPropertyCallableRef('blue', 1, KProperty1, function (receiver) {
    return receiver.s5q();
  }, null);
}
function allProjected$factory() {
  return getPropertyCallableRef('allProjected', 1, KProperty1, function (receiver) {
    return receiver.g5q();
  }, null);
}
function redProjected$factory() {
  return getPropertyCallableRef('redProjected', 1, KProperty1, function (receiver) {
    return receiver.l5q();
  }, null);
}
function greenProjected$factory() {
  return getPropertyCallableRef('greenProjected', 1, KProperty1, function (receiver) {
    return receiver.m5q();
  }, null);
}
function blueProjected$factory() {
  return getPropertyCallableRef('blueProjected', 1, KProperty1, function (receiver) {
    return receiver.n5q();
  }, null);
}
function toContext2dCommands(_this__u8e3s4, prefix, suffix, decimalPlaces) {
  prefix = prefix === VOID ? 'ctx.' : prefix;
  suffix = suffix === VOID ? ';' : suffix;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList.i1();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_1 = _this__u8e3s4.j3e_1;
  var n_0 = 0;
  while (n_0 < this_1.d1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_1.s1i(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var destruct = Vector2D.l28(tmp, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_1));
        var x = destruct.bl();
        var y = destruct.cl();
        this_0.h('moveTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(x, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(y, decimalPlaces) + ')');
        break;
      case 1:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var destruct_0 = Vector2D.l28(tmp_0, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_3));
        var x_0 = destruct_0.bl();
        var y_0 = destruct_0.cl();
        this_0.h('lineTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(x_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(y_0, decimalPlaces) + ')');
        break;
      case 2:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var destruct_1 = Vector2D.l28(tmp_1, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var destruct_2 = Vector2D.l28(tmp_2, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_7));
        var cx = destruct_1.bl();
        var cy = destruct_1.cl();
        var ax = destruct_2.bl();
        var ay = destruct_2.cl();
        this_0.h('quadTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ax, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ay, decimalPlaces) + ')');
        break;
      case 3:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var destruct_3 = Vector2D.l28(tmp_3, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var destruct_4 = Vector2D.l28(tmp_4, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var destruct_5 = Vector2D.l28(tmp_5, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_13));
        var cx1 = destruct_3.bl();
        var cy1 = destruct_3.cl();
        var cx2 = destruct_4.bl();
        var cy2 = destruct_4.cl();
        var ax_0 = destruct_5.bl();
        var ay_0 = destruct_5.cl();
        this_0.h('cubicTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ax_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ay_0, decimalPlaces) + ')');
        break;
      case 4:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        this_0.h('close()');
        break;
    }
  }
  var this_2 = this_0.s7();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_2, 10));
  var tmp0_iterator = this_2.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
    var tmp$ret$3 = prefix + item + suffix;
    destination.h(tmp$ret$3);
  }
  return destination;
}
function FillShape$pathCurvesList$delegate$lambda(this$0) {
  return function () {
    return toCurvesList(this$0.v5q_1);
  };
}
function FillShape$clipCurvesList$delegate$lambda(this$0) {
  return function () {
    var tmp351_safe_receiver = this$0.w5q_1;
    return tmp351_safe_receiver == null ? null : toCurvesList(tmp351_safe_receiver);
  };
}
function toSvgPathString(_this__u8e3s4, separator, decimalPlaces) {
  separator = separator === VOID ? ' ' : separator;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  return SvgPath_instance.i5r(_this__u8e3s4, separator, decimalPlaces);
}
function PolylineShape$fillShape$delegate$lambda(this$0) {
  return function () {
    return new FillShape(strokeToFill_0(this$0.j5r_1, this$0.n5r_1), this$0.k5r_1, this$0.l5r_1, this$0.m5r_1, this$0.o5r_1);
  };
}
function TextShape$primitiveShapes$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.apply' call
    var this_0 = new ShapeBuilder(null, null);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.TextShape.primitiveShapes$delegate.<anonymous>.<anonymous>' call
    this_0.z4p(get_immutable(this$0.h5s_1));
    this_0.m5p(this$0.d5s_1);
    if (!(this$0.e5s_1 == null)) {
      var tmp355_safe_receiver = this$0.b5s_1;
      if (tmp355_safe_receiver == null)
        null;
      else
        drawText(tmp355_safe_receiver, this_0, this$0.c5s_1, this$0.z5r_1, this$0.e5s_1, this$0.a5s_1, true);
    }
    if (!(this$0.f5s_1 == null)) {
      var tmp356_safe_receiver = this$0.b5s_1;
      if (tmp356_safe_receiver == null)
        null;
      else
        drawText(tmp356_safe_receiver, this_0, this$0.c5s_1, this$0.z5r_1, this$0.f5s_1, this$0.a5s_1, false);
    }
    return this_0.u4k();
  };
}
var EmptyShape_instance;
function EmptyShape_getInstance() {
  return EmptyShape_instance;
}
function toContext2dCommands$_anonymous_$round$0_5f3kr1(_this__u8e3s4, $decimalPlaces) {
  return niceStr(_this__u8e3s4, $decimalPlaces);
}
function pathCurvesList$factory() {
  return getPropertyCallableRef('pathCurvesList', 1, KProperty1, function (receiver) {
    return receiver.d5r();
  }, null);
}
function clipCurvesList$factory() {
  return getPropertyCallableRef('clipCurvesList', 1, KProperty1, function (receiver) {
    return receiver.e5r();
  }, null);
}
function thickness$factory($b0) {
  return getPropertyCallableRef('thickness', 0, KProperty0, function () {
    return $b0.k38_1;
  }, null);
}
function scaleMode$factory($b0) {
  return getPropertyCallableRef('scaleMode', 0, KProperty0, function () {
    return $b0.m38_1;
  }, null);
}
function startCap$factory($b0) {
  return getPropertyCallableRef('startCap', 0, KProperty0, function () {
    return $b0.n38_1;
  }, null);
}
function endCap$factory($b0) {
  return getPropertyCallableRef('endCap', 0, KProperty0, function () {
    return $b0.o38_1;
  }, null);
}
function join$factory($b0) {
  return getPropertyCallableRef('join', 0, KProperty0, function () {
    return $b0.p38_1;
  }, null);
}
function miterLimit$factory($b0) {
  return getPropertyCallableRef('miterLimit', 0, KProperty0, function () {
    return $b0.q38_1;
  }, null);
}
function dash$factory($b0) {
  return getPropertyCallableRef('dash', 0, KProperty0, function () {
    return $b0.r38_1;
  }, null);
}
function dashOffset$factory($b0) {
  return getPropertyCallableRef('dashOffset', 0, KProperty0, function () {
    return $b0.s38_1;
  }, null);
}
function primitiveShapes$factory() {
  return getPropertyCallableRef('primitiveShapes', 1, KProperty1, function (receiver) {
    return receiver.k5s();
  }, null);
}
function SVG$PolySvgElement$pps$lambda(it) {
  return !get_isNumeric(it.h2_1);
}
function SVG$PolySvgElement$pps$lambda_0(it) {
  return !get_isNumeric(it.h2_1);
}
function SVG$PathSvgElement$path$delegate$lambda(this$0) {
  return function () {
    return SvgPath_instance.y5s(this$0.v5s_1);
  };
}
var Companion_instance_47;
function Companion_getInstance_55() {
  return Companion_instance_47;
}
function _get__dom__d2l6i0($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.n5t_1;
  _dom$factory();
  return this_0.o1();
}
var Mappings_instance;
function Mappings_getInstance() {
  if (Mappings_instance === VOID)
    new Mappings();
  return Mappings_instance;
}
var Companion_instance_48;
function Companion_getInstance_56() {
  if (Companion_instance_48 === VOID)
    new Companion_39();
  return Companion_instance_48;
}
function SVG$defs$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.hashMapOf' call
    var this_0 = HashMap.f8();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.format.SVG.defs$delegate.<anonymous>.<anonymous>' call
    var _iterator__ex2g4s = this$0.b5t_1.t1m('defs').a1();
    while (_iterator__ex2g4s.b1()) {
      var defs = _iterator__ex2g4s.c1();
      var _iterator__ex2g4s_0 = defs.r1m().a1();
      while (_iterator__ex2g4s_0.b1()) {
        var def = _iterator__ex2g4s_0.c1();
        var svgDef = new SvgDef(def);
        // Inline function 'kotlin.collections.set' call
        var key = svgDef.s5t_1;
        this_0.f3(key, svgDef);
      }
    }
    return this_0;
  };
}
function SVG$cssList$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.arrayListOf' call
    var this_0 = ArrayList.i1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.format.SVG.cssList$delegate.<anonymous>.<anonymous>' call
    var _iterator__ex2g4s = this$0.b5t_1.t1m('style').a1();
    while (_iterator__ex2g4s.b1()) {
      var style = _iterator__ex2g4s.c1();
      // Inline function 'kotlin.collections.plusAssign' call
      var element = Companion_instance_39.h5h(style.p1m());
      this_0.h(element);
    }
    return this_0;
  };
}
function SVG$cssCombined$delegate$lambda(this$0) {
  return function () {
    return CSS.b5i(this$0.p5y());
  };
}
function SVG$_dom$delegate$lambda(this$0) {
  return function () {
    return new DOM(this$0.q5y());
  };
}
function SVG$dom$delegate$lambda(this$0) {
  return function () {
    this$0.r5y();
    return _get__dom__d2l6i0(this$0);
  };
}
function SVG$renderElement$delegate$lambda(this$0) {
  return function () {
    return new SvgElement(this$0, this$0.b5t_1);
  };
}
function SVG$animator$delegate$lambda(this$0) {
  return function () {
    return new DOMAnimator(this$0.s5y());
  };
}
function *_generator_readSVG__9pep6u(_this__u8e3s4, $completion) {
  var tmp = _this__u8e3s4.s24(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return SVG.u5y(tmp);
}
function readSVG(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readSVG__9pep6u.bind(VOID, _this__u8e3s4), $completion);
}
function defs$factory() {
  return getPropertyCallableRef('defs', 1, KProperty1, function (receiver) {
    return receiver.w5u();
  }, null);
}
function cssList$factory() {
  return getPropertyCallableRef('cssList', 1, KProperty1, function (receiver) {
    return receiver.p5y();
  }, null);
}
function cssCombined$factory() {
  return getPropertyCallableRef('cssCombined', 1, KProperty1, function (receiver) {
    return receiver.q5y();
  }, null);
}
function _dom$factory() {
  return getPropertyCallableRef('_dom', 1, KProperty1, function (receiver) {
    return _get__dom__d2l6i0(receiver);
  }, null);
}
function dom$factory() {
  return getPropertyCallableRef('dom', 1, KProperty1, function (receiver) {
    return receiver.s5y();
  }, null);
}
function renderElement$factory() {
  return getPropertyCallableRef('renderElement', 1, KProperty1, function (receiver) {
    return receiver.r5y();
  }, null);
}
function transform$factory() {
  return getPropertyCallableRef('transform', 1, KMutableProperty1, function (receiver) {
    return receiver.m5u_1;
  }, function (receiver, value) {
    receiver.m5u_1 = value;
    return Unit_instance;
  });
}
function opacity$factory() {
  return getPropertyCallableRef('opacity', 1, KMutableProperty1, function (receiver) {
    return receiver.n5u_1;
  }, function (receiver, value) {
    receiver.n5u_1 = value;
    return Unit_instance;
  });
}
function path$factory() {
  return getPropertyCallableRef('path', 1, KProperty1, function (receiver) {
    return receiver.m22();
  }, null);
}
function sqr($this, v) {
  return v * v;
}
function vmag($this, x, y) {
  // Inline function 'kotlin.math.sqrt' call
  var x_0 = x * x + y * y;
  return Math.sqrt(x_0);
}
function vecrat($this, ux, uy, vx, vy) {
  return (ux * vx + uy * vy) / (vmag($this, ux, uy) * vmag($this, vx, vy));
}
function vecang($this, ux, uy, vx, vy) {
  var r = vecrat($this, ux, uy, vx, vy);
  if (r < -1.0)
    r = -1.0;
  if (r > 1.0)
    r = 1.0;
  var tmp = ux * vy < uy * vx ? -1.0 : 1.0;
  // Inline function 'kotlin.math.acos' call
  var x = r;
  return tmp * Math.acos(x);
}
function xformPointX($this, x, y, t) {
  return x * t[0] + y * t[2] + t[4];
}
function xformPointY($this, x, y, t) {
  return x * t[1] + y * t[3] + t[5];
}
function xformVecX($this, x, y, t) {
  return x * t[0] + y * t[2];
}
function xformVecY($this, x, y, t) {
  return x * t[1] + y * t[3];
}
function parse$dumpTokens(tokens, $warningProcessor) {
  var iterator = tokens.a1();
  var index = 0;
  while (iterator.b1()) {
    var n = index;
    index = index + 1 | 0;
    var token = iterator.c1();
    if ($warningProcessor == null)
      null;
    else
      $warningProcessor('- ' + n + ': ' + toString_0(token));
  }
}
function parse$isNextNumber(tl) {
  var tmp;
  if (tl.s1g()) {
    var tmp_0 = tl.e2p();
    tmp = tmp_0 instanceof PathTokenNumber;
  } else {
    tmp = false;
  }
  return tmp;
}
function parse$readNumber(tl, $warningProcessor, tokens) {
  while (tl.s1g()) {
    var token = tl.a1v();
    if (token instanceof PathTokenNumber)
      return token.n5y_1;
    if ($warningProcessor == null)
      null;
    else
      $warningProcessor('Invalid path (expected number but found ' + toString_0(token) + ') at ' + (tl.d2p_1 - 1 | 0));
    parse$dumpTokens(tokens, $warningProcessor);
  }
  return 0.0;
}
function parse$n(tl, $warningProcessor, tokens) {
  return parse$readNumber(tl, $warningProcessor, tokens);
}
function parse$nX(out, tl, $warningProcessor, tokens, relative) {
  return relative ? out.p3e_1.c26_1 + parse$readNumber(tl, $warningProcessor, tokens) : parse$readNumber(tl, $warningProcessor, tokens);
}
function parse$nY(out, tl, $warningProcessor, tokens, relative) {
  return relative ? out.p3e_1.d26_1 + parse$readNumber(tl, $warningProcessor, tokens) : parse$readNumber(tl, $warningProcessor, tokens);
}
function parse$readNextTokenCmd(tl, $warningProcessor, tokens) {
  while (tl.s1g()) {
    var token = tl.a1v();
    if (token instanceof PathTokenCmd)
      return token.o5y_1;
    if ($warningProcessor == null)
      null;
    else
      $warningProcessor('Invalid path (expected command but found ' + toString_0(token) + ') at ' + (tl.d2p_1 - 1 | 0));
    parse$dumpTokens(tokens, $warningProcessor);
  }
  return null;
}
function tokenizePath$skipSeparators(_this__u8e3s4) {
  skipWhile(_this__u8e3s4, SvgPath$tokenizePath$skipSeparators$lambda);
}
function tokenizePath$readNumber(_this__u8e3s4) {
  tokenizePath$skipSeparators(_this__u8e3s4);
  var first = true;
  var pointCount = 0;
  // Inline function 'korlibs.util.readWhileBuilder' call
  // Inline function 'korlibs.util.readUntilBuilder' call
  var out = StringBuilder.f();
  $l$loop: while (_this__u8e3s4.s1g()) {
    var c = _this__u8e3s4.r1h();
    // Inline function 'korlibs.util.readWhileBuilder.<anonymous>' call
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.image.vector.format.SvgPath.tokenizePath.readNumber.<anonymous>' call
      if (c === _Char___init__impl__6a9atx(46)) {
        if (pointCount > 0) {
          tmp$ret$0 = false;
          break $l$block;
        }
        pointCount = pointCount + 1 | 0;
      }
      var tmp;
      if (first) {
        first = false;
        tmp = isDigit(c) || c === _Char___init__impl__6a9atx(45) || c === _Char___init__impl__6a9atx(43) || c === _Char___init__impl__6a9atx(46);
      } else if (c === _Char___init__impl__6a9atx(101) || c === _Char___init__impl__6a9atx(69)) {
        first = true;
        tmp = true;
      } else {
        tmp = isDigit(c) || c === _Char___init__impl__6a9atx(46);
      }
      tmp$ret$0 = tmp;
    }
    if (!tmp$ret$0) {
      if (false) {
        _this__u8e3s4.s1h();
        out.ob(c);
      }
      break $l$loop;
    }
    _this__u8e3s4.s1h();
    out.ob(c);
  }
  var str = out.toString();
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(str) === 0) {
    tmp_0 = 0.0;
  } else {
    var tmp_1;
    try {
      tmp_1 = toDouble(str);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        tmp_2 = 0.0;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    tmp_0 = tmp_1;
  }
  return tmp_0;
}
function toSvgPathString$fixX(_this__u8e3s4, $decimalPlaces) {
  return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
}
function toSvgPathString$fixY(_this__u8e3s4, $decimalPlaces) {
  return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
}
function SvgPath$tokenizePath$skipSeparators$lambda(it) {
  return equals(it, new Char(_Char___init__impl__6a9atx(44))) || equals(it, new Char(_Char___init__impl__6a9atx(32))) || equals(it, new Char(_Char___init__impl__6a9atx(9))) || equals(it, new Char(_Char___init__impl__6a9atx(10))) || equals(it, new Char(_Char___init__impl__6a9atx(13)));
}
var SvgPath_instance;
function SvgPath_getInstance() {
  return SvgPath_instance;
}
function toSvgPathString_0(_this__u8e3s4, separator, decimalPlaces) {
  separator = separator === VOID ? ' ' : separator;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  return SvgPath_instance.i5r(_this__u8e3s4, separator, decimalPlaces);
}
function Rasterizer$rasterizeFill$lambda($xmax, $xmin, this$0, $callback) {
  return function (a, b, y) {
    var tmp;
    if (a <= $xmax && b >= $xmin) {
      var a0 = coerceIn(a, $xmin, $xmax);
      var b0 = coerceIn(b, $xmin, $xmax);
      if (this$0.a5n_1) {
        println('RASTER(' + a0 + ', ' + b0 + ', ' + y + ')');
      }
      tmp = $callback(a0, b0, y);
    } else {
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function Renderer$drawImage$lambda($pos, $size) {
  return function ($this$transformed) {
    $this$transformed.q3n($pos, $size);
    return Unit_instance;
  };
}
var Companion_instance_49;
function Companion_getInstance_57() {
  if (Companion_instance_49 === VOID)
    new Companion_40();
  return Companion_instance_49;
}
var HtmlCanvas_instance;
function HtmlCanvas_getInstance() {
  return HtmlCanvas_instance;
}
function toLike(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4;
}
function toHtmlNative(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof HtmlNativeImage) {
    tmp = _this__u8e3s4;
  } else {
    tmp = HtmlNativeImage.a60(HtmlImage_instance.g5z(_this__u8e3s4.r3w()));
  }
  return tmp;
}
var HtmlImage_instance;
function HtmlImage_getInstance() {
  return HtmlImage_instance;
}
function get_nativeImageFormatProvider() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return nativeImageFormatProvider;
}
var nativeImageFormatProvider;
function get_isLittleEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return isLittleEndian;
}
var isLittleEndian;
var NonBrowserNativeImageFormatProvider_instance;
function NonBrowserNativeImageFormatProvider_getInstance() {
  if (NonBrowserNativeImageFormatProvider_instance === VOID)
    new NonBrowserNativeImageFormatProvider();
  return NonBrowserNativeImageFormatProvider_instance;
}
function *_generator_decodeInternal__jnwsgt_2($this, data, props, $completion) {
  var tmp = BrowserImage_instance.e60(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return new NativeImageResult(HtmlNativeImage.a60(tmp));
}
function *_generator_decodeInternal__jnwsgt_3($this, vfs, path, props, $completion) {
  var tmp;
  if (vfs instanceof LocalVfs) {
    var tmp_0 = BrowserImage_instance.f60(path, props, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = HtmlNativeImage.g60(tmp_0);
  } else {
    if (vfs instanceof UrlVfs) {
      var jsUrl = vfs.c25(path);
      var tmp_1 = BrowserImage_instance.f60(jsUrl, props, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp = HtmlNativeImage.g60(tmp_1);
    } else {
      var tmp_2 = BrowserImage_instance;
      var tmp_3 = vfs.xh(path).p24($completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      var tmp_4 = tmp_2.e60(tmp_3, props, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      tmp = HtmlNativeImage.a60(tmp_4);
    }
  }
  return new NativeImageResult(tmp);
}
var HtmlNativeImageFormatProvider_instance;
function HtmlNativeImageFormatProvider_getInstance() {
  if (HtmlNativeImageFormatProvider_instance === VOID)
    new HtmlNativeImageFormatProvider();
  return HtmlNativeImageFormatProvider_instance;
}
function HtmlNativeImage$lazyCanvasElement$delegate$lambda(this$0, $width, $height) {
  return function () {
    // Inline function 'kotlin.also' call
    var tmp;
    // Inline function 'kotlin.js.asDynamic' call
    if (this$0.w5z_1.src !== undefined) {
      var tmp_0 = BrowserImage_instance;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = this$0.w5z_1;
      tmp = tmp_0.h60(tmp$ret$2, $width, $height);
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this$0.w5z_1;
    }
    var this_0 = tmp;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.HtmlNativeImage.lazyCanvasElement$delegate.<anonymous>.<anonymous>' call
    this$0.w5z_1 = this_0;
    return this_0;
  };
}
function HtmlNativeImage$ctx$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this$0.i60().getContext('2d');
  };
}
function *_generator_decodeToCanvas__71sobd($this, bytes, props, $completion) {
  if (Companion_getInstance_11().f1f()) {
    // Inline function 'kotlin.error' call
    var message = 'Canvas not available on NodeJS';
    throw IllegalStateException.s4(toString_0(message));
  }
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = [bytes];
  // Inline function 'org.w3c.files.BlobPropertyBag' call
  var type = 'image/png';
  var o = {};
  o['type'] = type;
  var blob = new Blob(tmp, o);
  var blobURL = URL.createObjectURL(blob);
  try {
    var tmp_0 = $this.j3u(blobURL, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    return tmp_0;
  }finally {
    URL.revokeObjectURL(blobURL);
  }
}
function *_generator_loadCanvas__xw76hi($this, jsUrl, $completion) {
  var tmp = $this.n60(jsUrl, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.o60(tmp);
}
function BrowserImage$loadImage$lambda($c, $img) {
  return function (it) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $c;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.Companion.success' call
    var value = $img;
    var tmp$ret$2 = _Result___init__impl__xyqfz8(value);
    this_0.nc(tmp$ret$2);
    return Unit_instance;
  };
}
function BrowserImage$loadImage$lambda_0($c, $jsUrl) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1, _unused_var__etf5q3_2, _unused_var__etf5q3_3) {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    var this_0 = $c;
    // Inline function 'kotlin.Companion.failure' call
    var exception = RuntimeException.ia('error loading image ' + $jsUrl);
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    this_0.nc(tmp$ret$0);
    return Unit_instance;
  };
}
var BrowserImage_instance;
function BrowserImage_getInstance() {
  return BrowserImage_instance;
}
function get_isBigEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return !get_isLittleEndian();
}
function bswap32(v, offset, size) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  var inductionVariable = offset;
  var last = offset + size | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      v[n] = bswap32_0(v[n]);
    }
     while (inductionVariable < last);
}
function setFont($this, font, fontSize) {
  var tmp;
  if ((font == null ? null : font.l3()) == $this.u60_1) {
    tmp = fontSize === $this.t60_1;
  } else {
    tmp = false;
  }
  if (tmp)
    return Unit_instance;
  var tmp_0 = $this;
  tmp_0.u60_1 = font == null ? null : font.l3();
  $this.t60_1 = fontSize;
  var tmp0_elvis_lhs = font == null ? null : font.l3();
  $this.s60_1.font = '' + fontSize + "px '" + (tmp0_elvis_lhs == null ? 'default' : tmp0_elvis_lhs) + "'";
}
function setState($this, state, fill, doSetFont) {
  $this.s60_1.globalAlpha = state.p4g_1;
  $this.s60_1.globalCompositeOperation = $this.v60(state.q4g_1);
  if (doSetFont) {
    setFont($this, state.l4g_1, state.m4g_1);
  }
  if (fill) {
    $this.s60_1.fillStyle = $this.w60(state.j4g_1);
  } else {
    $this.s60_1.lineWidth = state.d4g_1;
    var tmp;
    switch (state.g4g_1.k3_1) {
      case 0:
        // Inline function 'org.w3c.dom.BEVEL' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'bevel';
        break;
      case 2:
        // Inline function 'org.w3c.dom.MITER' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'miter';
        break;
      case 1:
        // Inline function 'org.w3c.dom.ROUND' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'round';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $this.s60_1.lineJoin = tmp;
    var tmp_0;
    switch (state.a4o().k3_1) {
      case 0:
        // Inline function 'org.w3c.dom.BUTT' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'butt';
        break;
      case 2:
        // Inline function 'org.w3c.dom.ROUND' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'round';
        break;
      case 1:
        // Inline function 'org.w3c.dom.SQUARE' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'square';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $this.s60_1.lineCap = tmp_0;
    $this.s60_1.strokeStyle = $this.w60(state.i4g_1);
  }
}
function transformPaint($this, paint) {
  if (isInterface(paint, TransformedPaint)) {
    $this.x60($this.s60_1, paint.y4p());
  }
}
function bswap32_0(v) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return (v >>> 24 | 0 | v << 24 | (v & 65280) << 8 | (v >>> 8 | 0)) & 65280;
}
function lazyCanvasElement$factory() {
  return getPropertyCallableRef('lazyCanvasElement', 1, KProperty1, function (receiver) {
    return receiver.i60();
  }, null);
}
function ctx$factory() {
  return getPropertyCallableRef('ctx', 1, KProperty1, function (receiver) {
    return receiver.k60();
  }, null);
}
var properties_initialized_NativeImageFormatProviderJs_kt_7b9n17;
function _init_properties_NativeImageFormatProviderJs_kt__3qg4wz() {
  if (!properties_initialized_NativeImageFormatProviderJs_kt_7b9n17) {
    properties_initialized_NativeImageFormatProviderJs_kt_7b9n17 = true;
    nativeImageFormatProvider = Companion_getInstance_11().g1f() ? NonBrowserNativeImageFormatProvider_getInstance() : Companion_getInstance_11().f1f() ? NonBrowserNativeImageFormatProvider_getInstance() : HtmlNativeImageFormatProvider_getInstance();
    // Inline function 'org.khronos.webgl.get' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [1];
    // Inline function 'kotlin.js.asDynamic' call
    isLittleEndian = (new Uint8Array((new Int32Array(tmp$ret$2)).buffer))[0] === 1;
  }
}
//region block: post-declaration
initMetadataForClass(GrowMethod, 'GrowMethod');
initMetadataForClass(Entry, 'Entry');
initMetadataForClass(MutableAtlas, 'MutableAtlas', MutableAtlas.b3w);
initMetadataForClass(Bitmap, 'Bitmap');
initMetadataForCompanion(Companion, VOID, VOID, [2, 3]);
initMetadataForLambda(Bitmap32$iterator$slambda, VOID, VOID, [1]);
initMetadataForClass(Bitmap32, 'Bitmap32', VOID, VOID, [Bitmap, Iterable]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(BitmapIndexed, 'BitmapIndexed');
initMetadataForClass(Bitmap8, 'Bitmap8');
initMetadataForCompanion(Companion_1);
initMetadataForClass(BitmapChannel, 'BitmapChannel');
initMetadataForObject(Bitmaps, 'Bitmaps');
initMetadataForCompanion(Companion_2);
initMetadataForClass(DistanceBitmap, 'DistanceBitmap');
initMetadataForClass(FloatBitmap32, 'FloatBitmap32');
initMetadataForClass(MultiBitmap, 'MultiBitmap');
initMetadataForClass(NativeImage, 'NativeImage', VOID, VOID, [Bitmap, NativeImageRef]);
initMetadataForInterface(ForcedTexId, 'ForcedTexId');
initMetadataForClass(NullBitmap, 'NullBitmap');
initMetadataForCompanion(Companion_3);
initMetadataForClass(Palette, 'Palette');
initMetadataForClass(Result, 'Result');
initMetadataForObject(NewSDF, 'NewSDF');
initMetadataForClass(ColorFormat32, 'ColorFormat32');
initMetadataForClass(ColorFormat24, 'ColorFormat24');
initMetadataForClass(ColorTransformMul, 'ColorTransformMul', ColorTransformMul);
initMetadataForClass(WithDefault, 'WithDefault');
initMetadataForObject(Colors, 'Colors');
initMetadataForClass(RGB, 'RGB');
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(RgbaArray, 'RgbaArray', VOID, VOID, [KtList]);
initMetadataForCompanion(Companion_6);
initMetadataForClass(RGBA, 'RGBA', VOID, VOID, [Comparable]);
initMetadataForCompanion(Companion_7);
initMetadataForCompanion(Companion_8);
initMetadataForClass(RgbaPremultipliedArray, 'RgbaPremultipliedArray');
initMetadataForCompanion(Companion_9);
initMetadataForCompanion(Companion_10);
initMetadataForClass(Kerning, 'Kerning');
initMetadataForClass(Glyph, 'Glyph');
initMetadataForInterface(Font, 'Font', VOID, VOID, VOID, [0]);
initMetadataForInterface(BitmapFont, 'BitmapFont', VOID, VOID, [Font], [0]);
protoOf(BitmapFontImpl).x4e = get_baseBmp;
protoOf(BitmapFontImpl).b4f = getFontMetrics;
protoOf(BitmapFontImpl).m4f = getFontMetrics$default;
protoOf(BitmapFontImpl).n4f = getGlyphMetrics;
protoOf(BitmapFontImpl).v4f = getGlyphMetrics$default;
protoOf(BitmapFontImpl).a4h = getKerning;
protoOf(BitmapFontImpl).x4f = getTextScale;
protoOf(BitmapFontImpl).f1 = get_0;
protoOf(BitmapFontImpl).y4f = renderGlyph;
protoOf(BitmapFontImpl).z4g = renderGlyph$default;
initMetadataForClass(BitmapFontImpl, 'BitmapFontImpl', VOID, VOID, [BitmapFont], [0]);
initMetadataForClass(TextToBitmapResult, 'TextToBitmapResult');
initMetadataForClass(PlacedGlyphMetrics, 'PlacedGlyphMetrics');
initMetadataForClass(TextMetricsResult, 'TextMetricsResult', TextMetricsResult);
initMetadataForClass(MultiplePlacedGlyphMetrics, 'MultiplePlacedGlyphMetrics', MultiplePlacedGlyphMetrics);
initMetadataForInterface(ITextRendererActions, 'ITextRendererActions');
protoOf(TextRendererActions).d2q = reset;
protoOf(TextRendererActions).g4q = advance;
protoOf(TextRendererActions).h4q = newLine;
initMetadataForClass(TextRendererActions, 'TextRendererActions', VOID, VOID, [ITextRendererActions]);
initMetadataForClass(drawText$actions$1);
initMetadataForClass(GlyphPath, 'GlyphPath', GlyphPath);
initMetadataForCompanion(Companion_11);
protoOf(LazyBitmapFont).x4e = get_baseBmp;
protoOf(LazyBitmapFont).b4f = getFontMetrics;
protoOf(LazyBitmapFont).m4f = getFontMetrics$default;
protoOf(LazyBitmapFont).n4f = getGlyphMetrics;
protoOf(LazyBitmapFont).v4f = getGlyphMetrics$default;
protoOf(LazyBitmapFont).a4h = getKerning;
protoOf(LazyBitmapFont).x4f = getTextScale;
protoOf(LazyBitmapFont).c1k = getOrNull_2;
protoOf(LazyBitmapFont).f1 = get_0;
protoOf(LazyBitmapFont).y4f = renderGlyph;
protoOf(LazyBitmapFont).z4g = renderGlyph$default;
initMetadataForClass(LazyBitmapFont, 'LazyBitmapFont', VOID, VOID, [BitmapFont], [0]);
initMetadataForClass(FontMetrics, 'FontMetrics', FontMetrics);
initMetadataForClass(GlyphMetrics, 'GlyphMetrics', GlyphMetrics);
initMetadataForClass(TextMetrics, 'TextMetrics', TextMetrics);
initMetadataForCompanion(Companion_12);
initMetadataForClass(GlyphPath_0, 'GlyphPath');
initMetadataForClass(CFFResult, 'CFFResult');
initMetadataForClass(DataIndex, 'DataIndex', DataIndex.z4s, VOID, [Iterable]);
initMetadataForClass(Op, 'Op');
initMetadataForCompanion(Companion_13);
initMetadataForClass(EvalContext, 'EvalContext', EvalContext);
initMetadataForClass(Op_0, 'Op');
initMetadataForObject(CFF, 'CFF');
initMetadataForObject(CharStringType2, 'CharStringType2');
initMetadataForObject(TtfCIDFont, 'TtfCIDFont');
initMetadataForCompanion(Companion_14, VOID, VOID, [1]);
initMetadataForInterface(VectorFont, 'VectorFont', VOID, VOID, [Font], [0]);
protoOf(BaseTtfFont).m4f = getFontMetrics$default;
protoOf(BaseTtfFont).v4f = getGlyphMetrics$default;
protoOf(BaseTtfFont).v4w = getGlyphPath$default;
protoOf(BaseTtfFont).y4f = renderGlyph_0;
protoOf(BaseTtfFont).z4g = renderGlyph$default;
protoOf(BaseTtfFont).c1k = getOrNull_2;
initMetadataForClass(BaseTtfFont, 'BaseTtfFont', VOID, VOID, [VectorFont], [0]);
initMetadataForClass(TtfFont, 'TtfFont', VOID, VOID, VOID, [0]);
initMetadataForCompanion(Companion_15);
initMetadataForCompanion(Companion_16);
initMetadataForClass(NamesInfo, 'NamesInfo', NamesInfo);
initMetadataForClass(SubstitutionInfo, 'SubstitutionInfo');
initMetadataForClass(Table, 'Table');
initMetadataForClass(HorMetric, 'HorMetric');
initMetadataForCompanion(Companion_17);
initMetadataForClass(NameId, 'NameId');
initMetadataForClass(ColorBitmapInfo, 'ColorBitmapInfo', ColorBitmapInfo);
initMetadataForClass(SbitLineMetrics, 'SbitLineMetrics', SbitLineMetrics);
initMetadataForClass(BitmapGlyphInfo, 'BitmapGlyphInfo');
initMetadataForClass(ColorLine, 'ColorLine');
initMetadataForClass(ColorStop, 'ColorStop');
initMetadataForClass(Colrv1Paint, 'Colrv1Paint');
initMetadataForClass(COLRv1, 'COLRv1', COLRv1);
initMetadataForClass(Contour, 'Contour', Contour);
initMetadataForClass(GlyphReference, 'GlyphReference');
initMetadataForClass(ColrLayerInfo, 'ColrLayerInfo');
initMetadataForInterface(ColrGlyphInfo, 'ColrGlyphInfo');
protoOf(ColrGlyphInfoV1).b54 = getColorShape$default;
initMetadataForClass(ColrGlyphInfoV1, 'ColrGlyphInfoV1', VOID, VOID, [ColrGlyphInfo]);
protoOf(ColrGlyphInfoV0).b54 = getColorShape$default;
initMetadataForClass(ColrGlyphInfoV0, 'ColrGlyphInfoV0', VOID, VOID, [ColrGlyphInfo]);
protoOf(GlyphGraphicsPath).u3n = arc$default;
initMetadataForClass(GlyphGraphicsPath, 'GlyphGraphicsPath', VOID, VOID, [VectorBuilder]);
initMetadataForClass(Glyph_0, 'Glyph');
initMetadataForClass(CompositeGlyph, 'CompositeGlyph');
initMetadataForClass(CFFGlyph, 'CFFGlyph');
initMetadataForClass(SimpleGlyph, 'SimpleGlyph');
initMetadataForClass(BaseTtfFont$readCblc$Subtable, 'Subtable');
initMetadataForClass(BaseTtfFont$readSbix$StrikeInfo, 'StrikeInfo');
initMetadataForClass(BaseTtfFont$readCoverage$RangeInfo, 'RangeInfo');
initMetadataForClass(BaseTtfFont$readCmap$EncodingRecord, 'EncodingRecord');
initMetadataForCompanion(Companion_18);
initMetadataForCompanion(Companion_19);
initMetadataForClass(DataFormat, 'DataFormat');
initMetadataForObject(EXIF, 'EXIF', VOID, VOID, VOID, [3]);
initMetadataForClass(Direction, 'Direction');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(ImageAnimation, 'ImageAnimation');
initMetadataForCompanion(Companion_20);
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(ImageData, 'ImageData');
initMetadataForCompanion(Companion_21);
initMetadataForClass(ImageDataContainer, 'ImageDataContainer');
initMetadataForCompanion(Companion_22);
initMetadataForClass(ImageDecodingProps, 'ImageDecodingProps', ImageDecodingProps);
initMetadataForClass(ImageFormat, 'ImageFormat', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(ImageDecoderNotFoundException, 'ImageDecoderNotFoundException');
initMetadataForClass(ImageFormats, 'ImageFormats', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(ImageFormatsMutable, 'ImageFormatsMutable', ImageFormatsMutable.t5a, VOID, VOID, [2, 1]);
initMetadataForCompanion(Companion_23);
initMetadataForClass(ImageFrame, 'ImageFrame');
initMetadataForClass(ImageFrameLayer, 'ImageFrameLayer');
initMetadataForClass(ImageInfo, 'ImageInfo', ImageInfo);
initMetadataForCompanion(Companion_24);
initMetadataForClass(Type, 'Type');
initMetadataForClass(ImageLayer, 'ImageLayer');
initMetadataForClass(NativeImageFormatProvider, 'NativeImageFormatProvider', NativeImageFormatProvider, VOID, VOID, [1, 2, 3]);
initMetadataForClass(BaseNativeImageFormatProvider, 'BaseNativeImageFormatProvider', BaseNativeImageFormatProvider, VOID, VOID, [1, 2, 3]);
initMetadataForClass(NativeImageResult, 'NativeImageResult');
initMetadataForClass(BitmapNativeImage, 'BitmapNativeImage');
initMetadataForCompanion(Companion_25);
initMetadataForClass(InterlacedPass, 'InterlacedPass');
initMetadataForClass(Colorspace, 'Colorspace');
initMetadataForClass(Header, 'Header');
initMetadataForClass(DecodingContext, 'DecodingContext');
initMetadataForLambda(PNG$readCommon$readChunk$slambda, VOID, VOID, [0]);
initMetadataForObject(PNG, 'PNG', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(BaseFiller, 'BaseFiller');
initMetadataForClass(ColorFiller, 'ColorFiller', ColorFiller);
initMetadataForCompanion(Companion_26);
initMetadataForClass(GradientFiller, 'GradientFiller', GradientFiller);
initMetadataForClass(BitmapFiller, 'BitmapFiller', BitmapFiller);
initMetadataForObject(NoneFiller, 'NoneFiller');
initMetadataForCompanion(Companion_27);
initMetadataForInterface(TransformedPaint, 'TransformedPaint');
initMetadataForClass(GradientPaint, 'GradientPaint', VOID, VOID, [TransformedPaint]);
initMetadataForClass(GradientKind, 'GradientKind');
initMetadataForClass(GradientInterpolationMethod, 'GradientInterpolationMethod');
initMetadataForClass(GradientUnits, 'GradientUnits');
initMetadataForObject(NonePaint, 'NonePaint');
initMetadataForClass(BitmapPaint, 'BitmapPaint', VOID, VOID, [TransformedPaint]);
initMetadataForCompanion(Companion_28);
initMetadataForCompanion(Companion_29);
initMetadataForClass(Token, 'Token');
protoOf(sam$korlibs_math_interpolation_Easing$0).g1i = invoke;
protoOf(sam$korlibs_math_interpolation_Easing$0).h1i = invoke_0;
initMetadataForClass(sam$korlibs_math_interpolation_Easing$0, 'sam$korlibs_math_interpolation_Easing$0', VOID, VOID, [Easing, FunctionAdapter]);
initMetadataForClass(IdSelector, 'IdSelector');
initMetadataForClass(ClassSelector, 'ClassSelector');
initMetadataForClass(UnknownSelector, 'UnknownSelector');
initMetadataForClass(Expression, 'Expression');
initMetadataForClass(Declaration, 'Declaration');
initMetadataForClass(Declarations, 'Declarations');
initMetadataForClass(RuleSet, 'RuleSet');
initMetadataForClass(KeyFrame, 'KeyFrame');
initMetadataForClass(InterpolationResult, 'InterpolationResult', InterpolationResult);
initMetadataForClass(Animation, 'Animation');
initMetadataForClass(KeyFrames, 'KeyFrames');
initMetadataForCompanion(Companion_30);
initMetadataForClass(CSS, 'CSS');
initMetadataForClass(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(CSSReader, 'CSSReader');
initMetadataForClass(RatioMapping, 'RatioMapping');
initMetadataForClass(MatrixMapping, 'MatrixMapping');
initMetadataForClass(DomPropertyMapping, 'DomPropertyMapping', DomPropertyMapping);
initMetadataForClass(DomElement, 'DomElement');
initMetadataForInterface(DomListener, 'DomListener');
initMetadataForClass(ComposedDomListener, 'ComposedDomListener', VOID, VOID, [DomListener]);
initMetadataForCompanion(Companion_31);
protoOf(DOM$internalListener$1).j5j = updatedElement;
initMetadataForClass(DOM$internalListener$1, VOID, VOID, VOID, [DomListener]);
initMetadataForClass(DOM, 'DOM');
protoOf(DOMAnimator$1).e5j = removedId;
protoOf(DOMAnimator$1).f5j = addedId;
initMetadataForClass(DOMAnimator$1, VOID, VOID, VOID, [DomListener]);
initMetadataForClass(DOMAnimator, 'DOMAnimator');
initMetadataForCompanion(Companion_32);
initMetadataForClass(VerticalAlign, 'VerticalAlign');
initMetadataForCompanion(Companion_33);
initMetadataForClass(HorizontalAlign, 'HorizontalAlign');
initMetadataForCompanion(Companion_34);
initMetadataForClass(TextAlignment, 'TextAlignment');
initMetadataForInterface(TextRenderer, 'TextRenderer');
initMetadataForClass(LineStats, 'LineStats', LineStats);
initMetadataForClass(BoundBuilderTextRendererActions, 'BoundBuilderTextRendererActions', BoundBuilderTextRendererActions);
initMetadataForClass(LineInfo, 'LineInfo', LineInfo);
initMetadataForClass(Entry_0, 'Entry', Entry_0);
initMetadataForClass(Text2TextRendererActions, 'Text2TextRendererActions', Text2TextRendererActions);
initMetadataForClass(CreateWStringTextRenderer$2, VOID, VOID, VOID, [TextRenderer]);
initMetadataForClass(CreateStringTextRenderer$2, VOID, VOID, VOID, [TextRenderer]);
initMetadataForClass(SegmentHandler, 'SegmentHandler', SegmentHandler);
initMetadataForClass(ScanlineWriter, 'ScanlineWriter');
initMetadataForClass(Renderer, 'Renderer');
initMetadataForClass(Bitmap32Context2d, 'Bitmap32Context2d');
initMetadataForClass(CompositeOperation$Companion$invoke$1);
initMetadataForCompanion(Companion_35);
initMetadataForCompanion(Companion_36);
initMetadataForClass(CompositeMode, 'CompositeMode');
initMetadataForClass(BlendMode, 'BlendMode');
initMetadataForClass(State, 'State', State);
protoOf(Context2d).n3n = line;
protoOf(Context2d).o3n = arcTo;
protoOf(Context2d).g1 = isEmpty;
protoOf(Context2d).p3n = rect;
protoOf(Context2d).q3n = rect_0;
protoOf(Context2d).r3n = rect_1;
protoOf(Context2d).s3n = roundRect;
protoOf(Context2d).c3o = roundRect_0;
protoOf(Context2d).t3n = arc;
protoOf(Context2d).u3n = arc$default;
protoOf(Context2d).j38 = circle;
protoOf(Context2d).d3o = ellipse;
protoOf(Context2d).v3n = lineToH;
protoOf(Context2d).w3n = lineToV;
protoOf(Context2d).x3n = rLineToH;
protoOf(Context2d).y3n = rLineToV;
protoOf(Context2d).z3n = rMoveTo;
protoOf(Context2d).a3o = rLineTo;
protoOf(Context2d).n2f = transformed;
initMetadataForClass(Context2d, 'Context2d', VOID, VOID, [VectorBuilder]);
initMetadataForClass(scaled$1);
initMetadataForCompanion(Companion_37);
initMetadataForClass(CycleMethod, 'CycleMethod');
initMetadataForInterface(BoundsDrawable, 'BoundsDrawable');
initMetadataForClass(ColorizedBeziers, 'ColorizedBeziers');
initMetadataForClass(ColoredBezier, 'ColoredBezier');
initMetadataForClass(ProjectCurvesLookup, 'ProjectCurvesLookup');
initMetadataForInterface(Shape, 'Shape', VOID, VOID, [BoundsDrawable]);
initMetadataForInterface(StyledShape, 'StyledShape', VOID, VOID, [Shape]);
protoOf(FillShape).u5q = getBounds;
protoOf(FillShape).t5q = getPath_0;
protoOf(FillShape).j4r = getPath$default;
protoOf(FillShape).q4q = draw;
protoOf(FillShape).k54 = get_bounds;
protoOf(FillShape).w2i = get_width;
protoOf(FillShape).x2i = get_height;
initMetadataForClass(FillShape, 'FillShape', VOID, VOID, [StyledShape]);
protoOf(CompoundShape).j4r = getPath$default;
protoOf(CompoundShape).k54 = get_bounds;
protoOf(CompoundShape).w2i = get_width;
protoOf(CompoundShape).x2i = get_height;
initMetadataForClass(CompoundShape, 'CompoundShape', VOID, VOID, [Shape]);
protoOf(PolylineShape).t5q = getPath_0;
protoOf(PolylineShape).j4r = getPath$default;
protoOf(PolylineShape).q4q = draw;
protoOf(PolylineShape).k54 = get_bounds;
protoOf(PolylineShape).w2i = get_width;
protoOf(PolylineShape).x2i = get_height;
initMetadataForClass(PolylineShape, 'PolylineShape', VOID, VOID, [StyledShape]);
protoOf(TextShape).m22 = get_path;
protoOf(TextShape).t5q = getPath_0;
protoOf(TextShape).j4r = getPath$default;
protoOf(TextShape).q4q = draw;
protoOf(TextShape).k54 = get_bounds;
protoOf(TextShape).w2i = get_width;
protoOf(TextShape).x2i = get_height;
initMetadataForClass(TextShape, 'TextShape', VOID, VOID, [StyledShape]);
protoOf(EmptyShape).t5q = getPath;
protoOf(EmptyShape).j4r = getPath$default;
protoOf(EmptyShape).k54 = get_bounds;
protoOf(EmptyShape).w2i = get_width;
protoOf(EmptyShape).x2i = get_height;
initMetadataForObject(EmptyShape, 'EmptyShape', VOID, VOID, [Shape]);
initMetadataForClass(ShapeBuilder, 'ShapeBuilder');
initMetadataForCompanion(Companion_38);
initMetadataForClass(SvgDef, 'SvgDef');
initMetadataForObject(Mappings, 'Mappings');
initMetadataForClass(SvgElement, 'SvgElement');
initMetadataForClass(RectSvgElement, 'RectSvgElement');
initMetadataForClass(CircleSvgElement, 'CircleSvgElement');
initMetadataForClass(EllipseSvgElement, 'EllipseSvgElement');
initMetadataForClass(PolySvgElement, 'PolySvgElement');
initMetadataForClass(LineSvgElement, 'LineSvgElement');
initMetadataForClass(TextSvgElement, 'TextSvgElement');
initMetadataForClass(PathSvgElement, 'PathSvgElement');
initMetadataForClass(CSSDeclarations, 'CSSDeclarations', CSSDeclarations);
initMetadataForCompanion(Companion_39);
initMetadataForClass(PathTokenNumber, 'PathTokenNumber');
initMetadataForClass(PathTokenCmd, 'PathTokenCmd');
initMetadataForClass(SVG, 'SVG');
initMetadataForObject(SvgPath, 'SvgPath');
initMetadataForClass(Rasterizer, 'Rasterizer', Rasterizer);
initMetadataForClass(DummyRenderer, 'DummyRenderer');
initMetadataForCompanion(Companion_40);
initMetadataForObject(HtmlCanvas, 'HtmlCanvas');
initMetadataForObject(HtmlImage, 'HtmlImage');
initMetadataForObject(NonBrowserNativeImageFormatProvider, 'NonBrowserNativeImageFormatProvider', VOID, VOID, VOID, [1, 2, 3]);
initMetadataForObject(HtmlNativeImageFormatProvider, 'HtmlNativeImageFormatProvider', VOID, VOID, VOID, [2, 3, 1]);
initMetadataForClass(HtmlNativeImage, 'HtmlNativeImage');
initMetadataForObject(BrowserImage, 'BrowserImage', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(CanvasContext2dRenderer, 'CanvasContext2dRenderer');
//endregion
//region block: init
Companion_instance_9 = new Companion_0();
Bitmaps_instance = new Bitmaps();
Companion_instance_11 = new Companion_2();
NewSDF_instance = new NewSDF();
Companion_instance_14 = new Companion_5();
Companion_instance_16 = new Companion_7();
Companion_instance_17 = new Companion_8();
Companion_instance_18 = new Companion_9();
Companion_instance_19 = new Companion_10();
DefaultTtfFontOrNull = null;
SystemFontRegistryOrNull = null;
CFF_instance = new CFF();
CharStringType2_instance = new CharStringType2();
Companion_instance_24 = new Companion_15();
Companion_instance_26 = new Companion_17();
Companion_instance_27 = new Companion_18();
Companion_instance_29 = new Companion_20();
Companion_instance_30 = new Companion_21();
Companion_instance_32 = new Companion_23();
WEBP_WASM_BASE64_ZLIB = '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';
Companion_instance_35 = new Companion_26();
Companion_instance_36 = new Companion_27();
NonePaint_instance = new NonePaint();
Companion_instance_38 = new Companion_29();
Companion_instance_39 = new Companion_30();
Companion_instance_40 = new Companion_31();
Companion_instance_45 = new Companion_36();
EmptyShape_instance = new EmptyShape();
Companion_instance_47 = new Companion_38();
SvgPath_instance = new SvgPath();
HtmlCanvas_instance = new HtmlCanvas();
HtmlImage_instance = new HtmlImage();
BrowserImage_instance = new BrowserImage();
//endregion
//region block: exports
export {
  readFont as readFont34z4s2654u5hd,
  readBitmapSlice as readBitmapSlice2r7knpwifec2u,
  readBitmap_0 as readBitmap1yhww5yoq3a9l,
  readBitmap as readBitmapdk80pcjw6p8f,
  readSVG as readSVG1bsgckm5esgfg,
  _RGBA___get_af__impl__vu36qv as _RGBA___get_af__impl__vu36qv3fdqajvftucv7,
  _RGBA___get_bf__impl__1xz5yg as _RGBA___get_bf__impl__1xz5yg37iolmxbb8ro0,
  _RGBA___get_gf__impl__5gcu1f as _RGBA___get_gf__impl__5gcu1f1tcfjj6a92jd8,
  RGBA__hashCode_impl_h59qf6 as RGBA__hashCode_impl_h59qf629uhw1oxrapg6,
  _RGBA___get_hexString__impl__kocngm as _RGBA___get_hexString__impl__kocngmis57bfwjkwav,
  _RGBA___get_premultiplied__impl__3bulqc as _RGBA___get_premultiplied__impl__3bulqc3rk78ta2124j5,
  _RGBA___get_rf__impl__kvz75k as _RGBA___get_rf__impl__kvz75k2enjmg3zrtnq3,
  _RGBA___get_rgb__impl__tijaqt as _RGBA___get_rgb__impl__tijaqtysv8goadjy9q,
  RGBA__toString_impl_4lw6dp as RGBA__toString_impl_4lw6dp2tumn1mea41fm,
  _RGBA___get_value__impl__hhco8v as _RGBA___get_value__impl__hhco8vehpblbe3f2y8,
  RGBA__withAd_impl_cralao as RGBA__withAd_impl_cralao1ojb8pkalp2nb,
  _RGBAPremultiplied___get_af__impl__euwcjn as _RGBAPremultiplied___get_af__impl__euwcjn2miyh1t3zubgx,
  _RGBAPremultiplied___get_bf__impl__qa3on2 as _RGBAPremultiplied___get_bf__impl__qa3on231tqs9tgl21ni,
  _RGBAPremultiplied___get_gf__impl__ivron7 as _RGBAPremultiplied___get_gf__impl__ivron7124n55fu7nftq,
  _RGBAPremultiplied___get_rf__impl__pt0c4y as _RGBAPremultiplied___get_rf__impl__pt0c4yud4u7tot9j6v,
  _RgbaPremultipliedArray___init__impl__lx83hy as _RgbaPremultipliedArray___init__impl__lx83hy2e5m664sv80uc,
  HorizontalAlign__getOffsetX_impl_urzzxf as HorizontalAlign__getOffsetX_impl_urzzxfa8fekmmr9non,
  _HorizontalAlign___get_ratio__impl__x9wlea as _HorizontalAlign___get_ratio__impl__x9wlea2fkrj6kbsj2fk,
  VerticalAlign__getOffsetY_impl_iso0y6 as VerticalAlign__getOffsetY_impl_iso0y6m9d6k6n5h47j,
  _VerticalAlign___get_ratioFake__impl__1h2fwv as _VerticalAlign___get_ratioFake__impl__1h2fwv1dj21d0zq5uhq,
  Bitmaps_instance as Bitmaps_instance27726euemn90u,
  Colors_getInstance as Colors_getInstance2cnv7p5d6jz4u,
  Companion_getInstance_23 as Companion_getInstance2ou2xyvohty1g,
  Companion_instance_19 as Companion_instance1zw3l6m7tnvps,
  Companion_instance_18 as Companion_instance1sgltfeqg9bxt,
  Companion_getInstance_51 as Companion_getInstancezw1wxvwtmh0g,
  Companion_getInstance_49 as Companion_getInstance2w9pdpq8h2ue0,
  EmptyShape_instance as EmptyShape_instance1905h5dvjxi3r,
  Bitmap32 as Bitmap321klycakvwgb5w,
  Bitmap8 as Bitmap82ekc5d8xpcfp2,
  get_Bitmaps_transparent as get_Bitmaps_transparent3nm2857y3u3hn,
  get_Bitmaps_white as get_Bitmaps_white37u58wbn8ngk2,
  FloatBitmap32 as FloatBitmap321fufbxi3ys0iu,
  ForcedTexId as ForcedTexId3ivekmtdm8t3u,
  MultiBitmap as MultiBitmapk0zsv2zy1mpk,
  NativeImageOrBitmap32 as NativeImageOrBitmap3211fg7set8uiki,
  NativeImage as NativeImagebqxh3nwkmck,
  NullBitmap as NullBitmap15b22oyta4usb,
  get_baseMipmapLevel as get_baseMipmapLevel1ty2cgb5p9xw4,
  get_bmp as get_bmpevghw2zw2fa7,
  get_maxMipmapLevel as get_maxMipmapLevel13juf70j6ney9,
  slice as slice2pfxfvku0ybgy,
  ColorTransformMul as ColorTransformMul2rawiv5hyxh9p,
  RGBA as RGBA34obx2i62wcl3,
  Glyph as Glyphdz1l7rusab9h,
  BitmapFontImpl as BitmapFontImpljoxrxbqjo5ee,
  BitmapFont as BitmapFont35unsvaxq1brd,
  get_DefaultTtfFontAsBitmap as get_DefaultTtfFontAsBitmap1hzwi8e4truhb,
  FontMetrics as FontMetrics1b1o1zbrk6cew,
  Font as Font2bg7nte760csr,
  TextMetricsResult as TextMetricsResult1qr6b0fc6i56z,
  TextMetrics as TextMetrics1vfyzci74zdhy,
  getTextBounds as getTextBoundsio1pfpt2q8ze,
  HtmlNativeImage as HtmlNativeImagenz79853f60h,
  ImageDecodingProps as ImageDecodingProps12g4gdsvb3zm5,
  get_RegisteredImageFormats as get_RegisteredImageFormats243xf60qkmjxj,
  toHtmlNative as toHtmlNative1zcg9na83p2te,
  BitmapPaint as BitmapPaintgyia0tdij0bl,
  GradientPaint as GradientPaint1uc4xuo0s2w8w,
  NonePaint as NonePaint2h93brzruznft,
  get_DefaultStringTextRenderer as get_DefaultStringTextRendererdyzggul2pyry,
  Entry_0 as Entry3jfmfe0iy8gwc,
  LineInfo as LineInfo27uw564y6w2d2,
  Text2TextRendererActions as Text2TextRendererActions1307nbc4pqqhs,
  invoke_1 as invoke2ot88cm6qcfmr,
  CompoundShape as CompoundShape2jsp34o6wp7wp,
  FillShape as FillShape13c5zk3dmjgcf,
  PolylineShape as PolylineShape2w5p5crr94b97,
  ShapeBuilder as ShapeBuilderk05da5wk16e9,
  TextShape as TextShape3u9vrw15swk1x,
  render as render2gbt8tlw6dobg,
  scaled_0 as scaled3gdp9stc6gl4n,
  get_isLow as get_isLow1k7uocm2ojjr8,
};
//endregion
